
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("f1UXy", function(module, exports) {
$parcel$export(module.exports, "PanelInfoIcon", () => (parcelRequire("jA0E3")).PanelInfoIcon);
$parcel$export(module.exports, "PanelWarningIcon", () => (parcelRequire("6MmtN")).PanelWarningIcon);
$parcel$export(module.exports, "PanelErrorIcon", () => (parcelRequire("dDpOM")).PanelErrorIcon);
$parcel$export(module.exports, "PanelSuccessIcon", () => (parcelRequire("30pGv")).PanelSuccessIcon);
$parcel$export(module.exports, "PanelNoteIcon", () => (parcelRequire("564fr")).PanelNoteIcon);
$parcel$export(module.exports, "DynamicStrokeIconDecoration", () => (parcelRequire("btkFO")).DynamicStrokeIconDecoration);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4wH3g = parcelRequire("4wH3g");


var $jA0E3 = parcelRequire("jA0E3");


var $6MmtN = parcelRequire("6MmtN");


var $dDpOM = parcelRequire("dDpOM");


var $30pGv = parcelRequire("30pGv");


var $564fr = parcelRequire("564fr");




var $btkFO = parcelRequire("btkFO");


const $8e1c154bd4210a31$export$84f497075f5b07be = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "7Wa7q",
    name: "IconTable",
    loader: ()=>(parcelRequire("kHwDs")).then((module)=>module.default),
    loading: ()=>null
});
module.exports["IconTable"] = $8e1c154bd4210a31$export$84f497075f5b07be;

});

parcelRegister("kHwDs", function(module, exports) {

let $f121237d44544502$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f121237d44544502$var$load("7BHAC"),
    $f121237d44544502$var$load("N3TvS"),
    $f121237d44544502$var$load("cvDS7")
]).then(()=>parcelRequire('alH50'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("45O09", function(module, exports) {

var $jVdlG = parcelRequire("jVdlG");


var $lqPdm = parcelRequire("lqPdm");

const $dca98429b91f0137$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $dca98429b91f0137$var$prefix = 'ak-editor-panel';
const $dca98429b91f0137$export$6dd740b6c888e050 = {
    prefix: $dca98429b91f0137$var$prefix,
    content: `${$dca98429b91f0137$var$prefix}__content`,
    icon: `${$dca98429b91f0137$var$prefix}__icon`,
    noIcon: `${$dca98429b91f0137$var$prefix}__no-icon`
};
const $dca98429b91f0137$export$b0ee08fae091706a = {
    infoPanel: `.${$dca98429b91f0137$var$prefix}[data-panel-type=${(0, $jVdlG.PanelType).INFO}]`,
    notePanel: `.${$dca98429b91f0137$var$prefix}[data-panel-type=${(0, $jVdlG.PanelType).NOTE}]`,
    warningPanel: `.${$dca98429b91f0137$var$prefix}[data-panel-type=${(0, $jVdlG.PanelType).WARNING}]`,
    errorPanel: `.${$dca98429b91f0137$var$prefix}[data-panel-type=${(0, $jVdlG.PanelType).ERROR}]`,
    successPanel: `.${$dca98429b91f0137$var$prefix}[data-panel-type=${(0, $jVdlG.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[data-testid="popup-wrapper"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $dca98429b91f0137$export$8099afddf1b1be78 = (panelType)=>$dca98429b91f0137$var$lightPanelColors[panelType] || 'none';
const $dca98429b91f0137$export$dd3f0fd482ae7ccc = (panelType)=>(0, $lqPdm.hexToEditorBackgroundPaletteColor)($dca98429b91f0137$var$lightPanelColors[panelType]) || 'none';
module.exports["PanelSharedCssClassName"] = $dca98429b91f0137$export$6dd740b6c888e050;
module.exports["getPanelTypeBackgroundNoTokens"] = $dca98429b91f0137$export$8099afddf1b1be78;

});

parcelRegister("k3XQC", function(module, exports) {

var $4EZEs = parcelRequire("4EZEs");

const $0a38197c1471e9db$export$1974047c293dd52e = (datasourceId, defaultValue = true)=>{
    const datasourceType = (0, $4EZEs.getDatasourceType)(datasourceId);
    switch(datasourceType){
        case 'jira':
        case 'assets':
            return true;
        default:
            return defaultValue;
    }
};
module.exports["canRenderDatasource"] = $0a38197c1471e9db$export$1974047c293dd52e;

});

parcelRegister("4EZEs", function(module, exports) {

var $ao034 = parcelRequire("ao034");


var $2WEO5 = parcelRequire("2WEO5");


var $b1qV0 = parcelRequire("b1qV0");

const $bf1c02a4bd6e6fe6$export$19af9860957ca153 = (datasourceId)=>{
    switch(datasourceId){
        case 0, $b1qV0.JIRA_LIST_OF_LINKS_DATASOURCE_ID:
            return 'jira';
        case 0, $ao034.ASSETS_LIST_OF_LINKS_DATASOURCE_ID:
            return 'assets';
        case 0, $2WEO5.CONFLUENCE_SEARCH_DATASOURCE_ID:
            return 'confluence-search';
        default:
            return undefined;
    }
};
module.exports["getDatasourceType"] = $bf1c02a4bd6e6fe6$export$19af9860957ca153;

});

parcelRegister("ao034", function(module, exports) {

var $joG9X = parcelRequire("joG9X");

const $c0028d282bccd42c$export$34a6fbdd67f09ff6 = '361d618a-3c04-40ad-9b27-3c8ea6927020';
var $c0028d282bccd42c$export$2e2bcd8739ae039 = (0, $joG9X.AssetsConfigModalWithWrappers);
module.exports["ASSETS_LIST_OF_LINKS_DATASOURCE_ID"] = $c0028d282bccd42c$export$34a6fbdd67f09ff6;

});

parcelRegister("joG9X", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


const $1a2e374578fb66aa$var$LazyAssetsConfigModal = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("19zVq")).then((module)=>({
            default: module.AssetsConfigModal
        })));
const $1a2e374578fb66aa$export$22622bb648794f66 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "assets-aql-datasource-table-suspense"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: t0,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($1a2e374578fb66aa$var$LazyAssetsConfigModal, {
                ...props
            })
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": 'assets-aql-datasource-table-suspense'
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($1a2e374578fb66aa$var$LazyAssetsConfigModal, {
            ...props
        })
    });
};
module.exports["AssetsConfigModalWithWrappers"] = $1a2e374578fb66aa$export$22622bb648794f66;

});

parcelRegister("19zVq", function(module, exports) {

let $0d727fba0f309be5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0d727fba0f309be5$var$load("35mvB"),
    $0d727fba0f309be5$var$load("7A87G"),
    $0d727fba0f309be5$var$load("6wr18"),
    $0d727fba0f309be5$var$load("L98h8"),
    $0d727fba0f309be5$var$load("dfVn7"),
    $0d727fba0f309be5$var$load("aEiTV"),
    $0d727fba0f309be5$var$load("iQvHF"),
    $0d727fba0f309be5$var$load("jmTCk"),
    $0d727fba0f309be5$var$load("dJVzt"),
    $0d727fba0f309be5$var$load("aCJpU"),
    $0d727fba0f309be5$var$load("aLwQm"),
    $0d727fba0f309be5$var$load("Xi5vc"),
    $0d727fba0f309be5$var$load("ekdqM"),
    $0d727fba0f309be5$var$load("dhXIT"),
    $0d727fba0f309be5$var$load("iWnyc"),
    $0d727fba0f309be5$var$load("hhss7"),
    $0d727fba0f309be5$var$load("fuOfV"),
    $0d727fba0f309be5$var$load("jL1Ke"),
    $0d727fba0f309be5$var$load("5MQ0D"),
    $0d727fba0f309be5$var$load("ffEVr"),
    $0d727fba0f309be5$var$load("f0CsL"),
    $0d727fba0f309be5$var$load("56OxX"),
    $0d727fba0f309be5$var$load("Wowvf"),
    $0d727fba0f309be5$var$load("4g6rd"),
    $0d727fba0f309be5$var$load("7EorR"),
    $0d727fba0f309be5$var$load("4YY0q")
]).then(()=>parcelRequire('l99oY'));

});

parcelRegister("2WEO5", function(module, exports) {

var $kkIPZ = parcelRequire("kkIPZ");

const $1b4d8917faf0f40b$export$d9788d6cf1867282 = '768fc736-3af4-4a8f-b27e-203602bff8ca';
var $1b4d8917faf0f40b$export$2e2bcd8739ae039 = (0, $kkIPZ.ConfluenceSearchConfigModalWithWrappers);
module.exports["CONFLUENCE_SEARCH_DATASOURCE_ID"] = $1b4d8917faf0f40b$export$d9788d6cf1867282;

});

parcelRegister("kkIPZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


const $a8302a5b0a8ca21c$var$LazyConfluenceSearchConfigModal = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("6Zddt")).then((module)=>({
            default: module.ConfluenceSearchConfigModal
        })));
const $a8302a5b0a8ca21c$export$354a4025961c00ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "confluence-search-datasource-table-suspense"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: t0,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($a8302a5b0a8ca21c$var$LazyConfluenceSearchConfigModal, {
                ...props
            })
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": 'confluence-search-datasource-table-suspense'
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($a8302a5b0a8ca21c$var$LazyConfluenceSearchConfigModal, {
            ...props
        })
    });
};
module.exports["ConfluenceSearchConfigModalWithWrappers"] = $a8302a5b0a8ca21c$export$354a4025961c00ab;

});

parcelRegister("6Zddt", function(module, exports) {

let $5162b10cfbef615b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5162b10cfbef615b$var$load("35mvB"),
    $5162b10cfbef615b$var$load("7A87G"),
    $5162b10cfbef615b$var$load("6wr18"),
    $5162b10cfbef615b$var$load("6dLts"),
    $5162b10cfbef615b$var$load("jdPbE"),
    $5162b10cfbef615b$var$load("eUsnQ"),
    $5162b10cfbef615b$var$load("6C7Vr"),
    $5162b10cfbef615b$var$load("8l7sn"),
    $5162b10cfbef615b$var$load("L98h8"),
    $5162b10cfbef615b$var$load("dfVn7"),
    $5162b10cfbef615b$var$load("aEiTV"),
    $5162b10cfbef615b$var$load("iQvHF"),
    $5162b10cfbef615b$var$load("jmTCk"),
    $5162b10cfbef615b$var$load("dJVzt"),
    $5162b10cfbef615b$var$load("aCJpU"),
    $5162b10cfbef615b$var$load("aLwQm"),
    $5162b10cfbef615b$var$load("Xi5vc"),
    $5162b10cfbef615b$var$load("ekdqM"),
    $5162b10cfbef615b$var$load("dhXIT"),
    $5162b10cfbef615b$var$load("iWnyc"),
    $5162b10cfbef615b$var$load("hhss7"),
    $5162b10cfbef615b$var$load("fuOfV"),
    $5162b10cfbef615b$var$load("jL1Ke"),
    $5162b10cfbef615b$var$load("5MQ0D"),
    $5162b10cfbef615b$var$load("ffEVr"),
    $5162b10cfbef615b$var$load("f0CsL"),
    $5162b10cfbef615b$var$load("56OxX"),
    $5162b10cfbef615b$var$load("Wowvf"),
    $5162b10cfbef615b$var$load("4g6rd"),
    $5162b10cfbef615b$var$load("7EorR"),
    $5162b10cfbef615b$var$load("crXoG")
]).then(()=>parcelRequire('avxxY'));

});

parcelRegister("b1qV0", function(module, exports) {

var $lMCnP = parcelRequire("lMCnP");

const $4a21bbd750c2f727$export$8ce19958117ece5c = 'd8b75300-dfda-4519-b6cd-e49abbd50401';
var $4a21bbd750c2f727$export$2e2bcd8739ae039 = (0, $lMCnP.JiraIssuesConfigModalWithWrappers);
module.exports["JIRA_LIST_OF_LINKS_DATASOURCE_ID"] = $4a21bbd750c2f727$export$8ce19958117ece5c;

});

parcelRegister("lMCnP", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


const $91cb687e8d659ade$var$LazyJiraIssuesConfigModal = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("j5N7u")).then((module)=>({
            default: module.JiraIssuesConfigModal
        })));
const $91cb687e8d659ade$export$1cd9f81ef4050ddb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "jira-datasource-table-suspense"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: t0,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($91cb687e8d659ade$var$LazyJiraIssuesConfigModal, {
                ...props
            })
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": 'jira-datasource-table-suspense'
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($91cb687e8d659ade$var$LazyJiraIssuesConfigModal, {
            ...props
        })
    });
};
module.exports["JiraIssuesConfigModalWithWrappers"] = $91cb687e8d659ade$export$1cd9f81ef4050ddb;

});

parcelRegister("j5N7u", function(module, exports) {

let $de649625083579dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $de649625083579dd$var$load("6dLts"),
    $de649625083579dd$var$load("jdPbE"),
    $de649625083579dd$var$load("35mvB"),
    $de649625083579dd$var$load("b8BFA"),
    $de649625083579dd$var$load("7BHAC"),
    $de649625083579dd$var$load("N3TvS"),
    $de649625083579dd$var$load("1vUE6"),
    $de649625083579dd$var$load("7A87G"),
    $de649625083579dd$var$load("6wr18"),
    $de649625083579dd$var$load("9RiRQ"),
    $de649625083579dd$var$load("jt9eA"),
    $de649625083579dd$var$load("5pK3l"),
    $de649625083579dd$var$load("9UGFj"),
    $de649625083579dd$var$load("4bzNN"),
    $de649625083579dd$var$load("ariuh"),
    $de649625083579dd$var$load("hH9dm"),
    $de649625083579dd$var$load("6vUJB"),
    $de649625083579dd$var$load("eqAkJ"),
    $de649625083579dd$var$load("j5aD5"),
    $de649625083579dd$var$load("3zwpG"),
    $de649625083579dd$var$load("8l7sn"),
    $de649625083579dd$var$load("L98h8"),
    $de649625083579dd$var$load("dfVn7"),
    $de649625083579dd$var$load("aEiTV"),
    $de649625083579dd$var$load("iQvHF"),
    $de649625083579dd$var$load("jmTCk"),
    $de649625083579dd$var$load("dJVzt"),
    $de649625083579dd$var$load("aCJpU"),
    $de649625083579dd$var$load("aLwQm"),
    $de649625083579dd$var$load("Xi5vc"),
    $de649625083579dd$var$load("ekdqM"),
    $de649625083579dd$var$load("dhXIT"),
    $de649625083579dd$var$load("iWnyc"),
    $de649625083579dd$var$load("hhss7"),
    $de649625083579dd$var$load("fuOfV"),
    $de649625083579dd$var$load("jL1Ke"),
    $de649625083579dd$var$load("5MQ0D"),
    $de649625083579dd$var$load("ffEVr"),
    $de649625083579dd$var$load("f0CsL"),
    $de649625083579dd$var$load("56OxX"),
    $de649625083579dd$var$load("Wowvf"),
    $de649625083579dd$var$load("4g6rd"),
    $de649625083579dd$var$load("7EorR"),
    $de649625083579dd$var$load("ammxV")
]).then(()=>parcelRequire('5FeeG'));

});

parcelRegister("ePK6j", function(module, exports) {

var $bPgnM = parcelRequire("bPgnM");


var $gV6hJ = parcelRequire("gV6hJ");

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */ function $acc996c64b493b49$var$clamp(number, lower, upper) {
    if (upper === undefined) {
        upper = lower;
        lower = undefined;
    }
    if (upper !== undefined) {
        upper = $gV6hJ(upper);
        upper = upper === upper ? upper : 0;
    }
    if (lower !== undefined) {
        lower = $gV6hJ(lower);
        lower = lower === lower ? lower : 0;
    }
    return $bPgnM($gV6hJ(number), lower, upper);
}
module.exports = $acc996c64b493b49$var$clamp;

});

parcelRegister("8nvEM", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");

const $6199071156ddad70$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $6199071156ddad70$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $6199071156ddad70$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $6199071156ddad70$var$textRange = function(node, from, to) {
    let range = $6199071156ddad70$var$reusedRange || ($6199071156ddad70$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $6199071156ddad70$var$clearReusedRange = function() {
    $6199071156ddad70$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $6199071156ddad70$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($6199071156ddad70$var$scanFor(node, off, targetNode, targetOff, -1) || $6199071156ddad70$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $6199071156ddad70$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $6199071156ddad70$var$scanFor(node, off, targetNode, targetOff, dir) {
    var _a;
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $6199071156ddad70$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $6199071156ddad70$var$hasBlockDesc(node) || $6199071156ddad70$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $6199071156ddad70$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            let child = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (child.nodeType == 1 && child.contentEditable == "false") {
                if ((_a = child.pmViewDesc) === null || _a === void 0 ? void 0 : _a.ignoreForSelection) off += dir;
                else return false;
            } else {
                node = child;
                off = dir < 0 ? $6199071156ddad70$var$nodeSize(node) : 0;
            }
        } else return false;
    }
}
function $6199071156ddad70$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $6199071156ddad70$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $6199071156ddad70$var$nodeSize(node);
        } else if (node.parentNode && !$6199071156ddad70$var$hasBlockDesc(node)) {
            offset = $6199071156ddad70$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $6199071156ddad70$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$6199071156ddad70$var$hasBlockDesc(node)) {
            offset = $6199071156ddad70$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $6199071156ddad70$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $6199071156ddad70$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $6199071156ddad70$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $6199071156ddad70$var$nodeSize(node);
    }
}
function $6199071156ddad70$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $6199071156ddad70$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $6199071156ddad70$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $6199071156ddad70$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $6199071156ddad70$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $6199071156ddad70$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($6199071156ddad70$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($6199071156ddad70$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $6199071156ddad70$var$nav = typeof navigator != "undefined" ? navigator : null;
const $6199071156ddad70$var$doc = typeof document != "undefined" ? document : null;
const $6199071156ddad70$var$agent = $6199071156ddad70$var$nav && $6199071156ddad70$var$nav.userAgent || "";
const $6199071156ddad70$var$ie_edge = /Edge\/(\d+)/.exec($6199071156ddad70$var$agent);
const $6199071156ddad70$var$ie_upto10 = /MSIE \d/.exec($6199071156ddad70$var$agent);
const $6199071156ddad70$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($6199071156ddad70$var$agent);
const $6199071156ddad70$var$ie = !!($6199071156ddad70$var$ie_upto10 || $6199071156ddad70$var$ie_11up || $6199071156ddad70$var$ie_edge);
const $6199071156ddad70$var$ie_version = $6199071156ddad70$var$ie_upto10 ? document.documentMode : $6199071156ddad70$var$ie_11up ? +$6199071156ddad70$var$ie_11up[1] : $6199071156ddad70$var$ie_edge ? +$6199071156ddad70$var$ie_edge[1] : 0;
const $6199071156ddad70$var$gecko = !$6199071156ddad70$var$ie && /gecko\/(\d+)/i.test($6199071156ddad70$var$agent);
$6199071156ddad70$var$gecko && (/Firefox\/(\d+)/.exec($6199071156ddad70$var$agent) || [
    0,
    0
])[1];
const $6199071156ddad70$var$_chrome = !$6199071156ddad70$var$ie && /Chrome\/(\d+)/.exec($6199071156ddad70$var$agent);
const $6199071156ddad70$var$chrome = !!$6199071156ddad70$var$_chrome;
const $6199071156ddad70$var$chrome_version = $6199071156ddad70$var$_chrome ? +$6199071156ddad70$var$_chrome[1] : 0;
const $6199071156ddad70$var$safari = !$6199071156ddad70$var$ie && !!$6199071156ddad70$var$nav && /Apple Computer/.test($6199071156ddad70$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $6199071156ddad70$var$ios = $6199071156ddad70$var$safari && (/Mobile\/\w+/.test($6199071156ddad70$var$agent) || !!$6199071156ddad70$var$nav && $6199071156ddad70$var$nav.maxTouchPoints > 2);
const $6199071156ddad70$var$mac = $6199071156ddad70$var$ios || ($6199071156ddad70$var$nav ? /Mac/.test($6199071156ddad70$var$nav.platform) : false);
const $6199071156ddad70$var$windows = $6199071156ddad70$var$nav ? /Win/.test($6199071156ddad70$var$nav.platform) : false;
const $6199071156ddad70$var$android = /Android \d/.test($6199071156ddad70$var$agent);
const $6199071156ddad70$var$webkit = !!$6199071156ddad70$var$doc && "webkitFontSmoothing" in $6199071156ddad70$var$doc.documentElement.style;
const $6199071156ddad70$var$webkit_version = $6199071156ddad70$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $6199071156ddad70$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $6199071156ddad70$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $6199071156ddad70$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $6199071156ddad70$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;;){
        if (!parent) break;
        if (parent.nodeType != 1) {
            parent = $6199071156ddad70$var$parentNode(parent);
            continue;
        }
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $6199071156ddad70$var$windowRect(doc) : $6199071156ddad70$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $6199071156ddad70$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $6199071156ddad70$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $6199071156ddad70$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $6199071156ddad70$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $6199071156ddad70$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $6199071156ddad70$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $6199071156ddad70$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $6199071156ddad70$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $6199071156ddad70$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        let pos = atTop ? "fixed" : getComputedStyle(parent).position;
        if (/^(fixed|sticky)$/.test(pos)) break;
        parent = pos == "absolute" ? parent.offsetParent : $6199071156ddad70$var$parentNode(parent);
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $6199071156ddad70$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $6199071156ddad70$var$scrollStack(view.dom)
    };
}
function $6199071156ddad70$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $6199071156ddad70$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $6199071156ddad70$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $6199071156ddad70$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $6199071156ddad70$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $6199071156ddad70$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $6199071156ddad70$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($6199071156ddad70$var$preventScrollSupported) return dom.focus($6199071156ddad70$var$preventScrollSupported);
    let stored = $6199071156ddad70$var$scrollStack(dom);
    dom.focus($6199071156ddad70$var$preventScrollSupported == null ? {
        get preventScroll () {
            $6199071156ddad70$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$6199071156ddad70$var$preventScrollSupported) {
        $6199071156ddad70$var$preventScrollSupported = false;
        $6199071156ddad70$var$restoreScrollStack(stored, 0);
    }
}
function $6199071156ddad70$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $6199071156ddad70$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $6199071156ddad70$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $6199071156ddad70$var$findOffsetInNode(closest, coordsClosest);
}
function $6199071156ddad70$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange(), result;
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $6199071156ddad70$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($6199071156ddad70$var$inRect(coords, rect)) {
            result = {
                node: node,
                offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
            };
            break;
        }
    }
    range.detach();
    return result || {
        node: node,
        offset: 0
    };
}
function $6199071156ddad70$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $6199071156ddad70$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $6199071156ddad70$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $6199071156ddad70$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $6199071156ddad70$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
        ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(desc.dom.nodeName)) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $6199071156ddad70$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($6199071156ddad70$var$inRect(coords, rect)) return $6199071156ddad70$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $6199071156ddad70$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $6199071156ddad70$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$6199071156ddad70$var$inRect(coords, box)) return null;
        elt = $6199071156ddad70$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($6199071156ddad70$var$safari) {
        for(let p = elt; node && p; p = $6199071156ddad70$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $6199071156ddad70$var$targetKludge(elt, coords);
    if (node) {
        if ($6199071156ddad70$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($6199071156ddad70$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $6199071156ddad70$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $6199071156ddad70$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $6199071156ddad70$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $6199071156ddad70$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($6199071156ddad70$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $6199071156ddad70$var$nonZero) || target.getBoundingClientRect();
}
const $6199071156ddad70$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $6199071156ddad70$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $6199071156ddad70$var$webkit || $6199071156ddad70$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($6199071156ddad70$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $6199071156ddad70$var$singleRect($6199071156ddad70$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($6199071156ddad70$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $6199071156ddad70$var$singleRect($6199071156ddad70$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $6199071156ddad70$var$singleRect($6199071156ddad70$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $6199071156ddad70$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $6199071156ddad70$var$flattenV($6199071156ddad70$var$singleRect($6199071156ddad70$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $6199071156ddad70$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $6199071156ddad70$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $6199071156ddad70$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $6199071156ddad70$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $6199071156ddad70$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $6199071156ddad70$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $6199071156ddad70$var$textRange(before, $6199071156ddad70$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $6199071156ddad70$var$flattenV($6199071156ddad70$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $6199071156ddad70$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $6199071156ddad70$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $6199071156ddad70$var$flattenV($6199071156ddad70$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $6199071156ddad70$var$flattenV($6199071156ddad70$var$singleRect(node.nodeType == 3 ? $6199071156ddad70$var$textRange(node) : node, -side), side >= 0);
}
function $6199071156ddad70$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $6199071156ddad70$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $6199071156ddad70$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $6199071156ddad70$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $6199071156ddad70$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $6199071156ddad70$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $6199071156ddad70$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $6199071156ddad70$var$maybeRTL = /[\u0590-\u08ac]/;
function $6199071156ddad70$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$6199071156ddad70$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $6199071156ddad70$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $6199071156ddad70$var$cachedState = null;
let $6199071156ddad70$var$cachedDir = null;
let $6199071156ddad70$var$cachedResult = false;
function $6199071156ddad70$var$endOfTextblock(view, state, dir) {
    if ($6199071156ddad70$var$cachedState == state && $6199071156ddad70$var$cachedDir == dir) return $6199071156ddad70$var$cachedResult;
    $6199071156ddad70$var$cachedState = state;
    $6199071156ddad70$var$cachedDir = dir;
    return $6199071156ddad70$var$cachedResult = dir == "up" || dir == "down" ? $6199071156ddad70$var$endOfTextblockVertical(view, state, dir) : $6199071156ddad70$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $6199071156ddad70$var$NOT_DIRTY = 0, $6199071156ddad70$var$CHILD_DIRTY = 1, $6199071156ddad70$var$CONTENT_DIRTY = 2, $6199071156ddad70$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $6199071156ddad70$var$ViewDesc {
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $6199071156ddad70$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)for(let i = 0; i < child.children.length; i++){
                    let inner = child.children[i];
                    if (inner.size) {
                        child = inner;
                        break;
                    }
                }
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $6199071156ddad70$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $6199071156ddad70$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $6199071156ddad70$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $6199071156ddad70$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $6199071156ddad70$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $6199071156ddad70$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($6199071156ddad70$var$gecko || $6199071156ddad70$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $6199071156ddad70$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($6199071156ddad70$var$gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $6199071156ddad70$var$safari) && $6199071156ddad70$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && $6199071156ddad70$var$isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !(brKludge && $6199071156ddad70$var$gecko)) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $6199071156ddad70$var$CONTENT_DIRTY : $6199071156ddad70$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $6199071156ddad70$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $6199071156ddad70$var$CONTENT_DIRTY : $6199071156ddad70$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $6199071156ddad70$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $6199071156ddad70$var$CONTENT_DIRTY : $6199071156ddad70$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    get ignoreForSelection() {
        return false;
    }
    isText(text) {
        return false;
    }
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $6199071156ddad70$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $6199071156ddad70$var$WidgetViewDesc extends $6199071156ddad70$var$ViewDesc {
    matchesWidget(widget) {
        return this.dirty == $6199071156ddad70$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get ignoreForSelection() {
        return !!this.widget.type.spec.relaxedSide;
    }
    get side() {
        return this.widget.type.side;
    }
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
}
class $6199071156ddad70$var$CompositionViewDesc extends $6199071156ddad70$var$ViewDesc {
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $6199071156ddad70$var$MarkViewDesc extends $6199071156ddad70$var$ViewDesc {
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $aPdNQ.DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $6199071156ddad70$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if (this.dirty & $6199071156ddad70$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $6199071156ddad70$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $6199071156ddad70$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $6199071156ddad70$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $6199071156ddad70$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $6199071156ddad70$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $6199071156ddad70$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    constructor(parent, mark, dom, contentDOM, spec){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $6199071156ddad70$var$NodeViewDesc extends $6199071156ddad70$var$ViewDesc {
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $aPdNQ.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $6199071156ddad70$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $6199071156ddad70$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $6199071156ddad70$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $6199071156ddad70$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $aPdNQ.Fragment).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $6199071156ddad70$var$NOT_DIRTY && node.eq(this.node) && $6199071156ddad70$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $6199071156ddad70$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $6199071156ddad70$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view, i);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $aPdNQ.Mark).none : this.node.child(i).marks, inline, view, i);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view, i);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view, 0);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $6199071156ddad70$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $6199071156ddad70$var$renderDescs(this.contentDOM, this.children, view);
            if ($6199071156ddad70$var$ios) $6199071156ddad70$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $kCECX.TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $6199071156ddad70$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $6199071156ddad70$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $6199071156ddad70$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $6199071156ddad70$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $6199071156ddad70$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($6199071156ddad70$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $6199071156ddad70$var$patchOuterDeco(this.dom, this.nodeDOM, $6199071156ddad70$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $6199071156ddad70$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.add("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.nodeDOM.draggable = true;
        }
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.nodeDOM.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $6199071156ddad70$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $6199071156ddad70$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $6199071156ddad70$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $6199071156ddad70$var$TextViewDesc extends $6199071156ddad70$var$NodeViewDesc {
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $6199071156ddad70$var$NODE_DIRTY || this.dirty != $6199071156ddad70$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $6199071156ddad70$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $6199071156ddad70$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $6199071156ddad70$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $6199071156ddad70$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $6199071156ddad70$var$TrailingHackViewDesc extends $6199071156ddad70$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $6199071156ddad70$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $6199071156ddad70$var$CustomNodeViewDesc extends $6199071156ddad70$var$NodeViewDesc {
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $6199071156ddad70$var$NODE_DIRTY) return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $6199071156ddad70$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $6199071156ddad70$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $6199071156ddad70$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $6199071156ddad70$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $6199071156ddad70$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $6199071156ddad70$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$6199071156ddad70$var$OuterDecoLevel.prototype = Object.create(null);
const $6199071156ddad70$var$noDeco = [
    new $6199071156ddad70$var$OuterDecoLevel
];
function $6199071156ddad70$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $6199071156ddad70$var$noDeco;
    let top = needsWrap ? $6199071156ddad70$var$noDeco[0] : new $6199071156ddad70$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $6199071156ddad70$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $6199071156ddad70$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $6199071156ddad70$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $6199071156ddad70$var$noDeco && curComputed == $6199071156ddad70$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $6199071156ddad70$var$noDeco[0];
                curDOM = parent;
            }
        }
        $6199071156ddad70$var$patchAttributes(curDOM, prev || $6199071156ddad70$var$noDeco[0], deco);
    }
    return curDOM;
}
function $6199071156ddad70$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $6199071156ddad70$var$applyOuterDeco(dom, deco, node) {
    return $6199071156ddad70$var$patchOuterDeco(dom, dom, $6199071156ddad70$var$noDeco, $6199071156ddad70$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $6199071156ddad70$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $6199071156ddad70$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $6199071156ddad70$var$ViewTreeUpdater {
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view, parentIndex) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $6199071156ddad70$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1, scanTo = this.top.children.length;
            if (parentIndex < this.preMatch.index) scanTo = Math.min(this.index + 3, scanTo);
            for(let i = this.index; i < scanTo; i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $6199071156ddad70$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $6199071156ddad70$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $6199071156ddad70$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $6199071156ddad70$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $6199071156ddad70$var$NODE_DIRTY && $6199071156ddad70$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $6199071156ddad70$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $6199071156ddad70$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !$6199071156ddad70$var$sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
        let wrapper = $6199071156ddad70$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $6199071156ddad70$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $6199071156ddad70$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $6199071156ddad70$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $6199071156ddad70$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($6199071156ddad70$var$safari || $6199071156ddad70$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $6199071156ddad70$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $6199071156ddad70$var$preMatch(top.node.content, top);
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes.
function $6199071156ddad70$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $6199071156ddad70$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $6199071156ddad70$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $6199071156ddad70$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($6199071156ddad70$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $6199071156ddad70$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $6199071156ddad70$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $6199071156ddad70$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $6199071156ddad70$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), anchor, selection;
    if ($6199071156ddad70$var$selectionCollapsed(domSel)) {
        anchor = head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $kCECX.NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $6199071156ddad70$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $kCECX.NodeSelection)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for(let i = 0; i < domSel.rangeCount; i++){
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0) return null;
            [anchor, head] = max == view.state.selection.anchor ? [
                max,
                min
            ] : [
                min,
                max
            ];
            $head = doc.resolve(head);
        } else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $6199071156ddad70$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $6199071156ddad70$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $6199071156ddad70$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $6199071156ddad70$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $6199071156ddad70$var$syncNodeSelection(view, sel);
    if (!$6199071156ddad70$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $6199071156ddad70$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $6199071156ddad70$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $6199071156ddad70$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($6199071156ddad70$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $kCECX.TextSelection))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $6199071156ddad70$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $6199071156ddad70$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if ($6199071156ddad70$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $6199071156ddad70$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $6199071156ddad70$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $6199071156ddad70$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $6199071156ddad70$var$brokenSelectBetweenUneditable = $6199071156ddad70$var$safari || $6199071156ddad70$var$chrome && $6199071156ddad70$var$chrome_version < 63;
function $6199071156ddad70$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($6199071156ddad70$var$safari && after && after.contentEditable == "false") return $6199071156ddad70$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $6199071156ddad70$var$setEditable(after);
        else if (before) return $6199071156ddad70$var$setEditable(before);
    }
}
function $6199071156ddad70$var$setEditable(element) {
    element.contentEditable = "true";
    if ($6199071156ddad70$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $6199071156ddad70$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $6199071156ddad70$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$6199071156ddad70$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $6199071156ddad70$var$selectCursorWrapper(view) {
    let domSel = view.domSelection();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) domSel.collapse(node.parentNode, $6199071156ddad70$var$domIndex(node) + 1);
    else domSel.collapse(node, 0);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $6199071156ddad70$var$ie && $6199071156ddad70$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $6199071156ddad70$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $kCECX.NodeSelection)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $6199071156ddad70$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $6199071156ddad70$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $6199071156ddad70$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $6199071156ddad70$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $kCECX.TextSelection).between($anchor, $head, bias);
}
function $6199071156ddad70$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $6199071156ddad70$var$hasSelection(view);
}
function $6199071156ddad70$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $6199071156ddad70$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $6199071156ddad70$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $6199071156ddad70$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $kCECX.Selection).findFrom($start, dir);
}
function $6199071156ddad70$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $6199071156ddad70$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $kCECX.TextSelection)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $6199071156ddad70$var$apply(view, new (0, $kCECX.TextSelection)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $6199071156ddad70$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $kCECX.NodeSelection)) return $6199071156ddad70$var$apply(view, next);
            return false;
        } else if (!($6199071156ddad70$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $kCECX.NodeSelection).isSelectable(node)) return $6199071156ddad70$var$apply(view, new (0, $kCECX.NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($6199071156ddad70$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $6199071156ddad70$var$apply(view, new (0, $kCECX.TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $kCECX.NodeSelection) && sel.node.isInline) return $6199071156ddad70$var$apply(view, new (0, $kCECX.TextSelection)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $6199071156ddad70$var$moveSelectionBlock(view.state, dir);
        if (next) return $6199071156ddad70$var$apply(view, next);
        return false;
    }
}
function $6199071156ddad70$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $6199071156ddad70$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $6199071156ddad70$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $6199071156ddad70$var$skipIgnoredNodesBefore(view) : $6199071156ddad70$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $6199071156ddad70$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($6199071156ddad70$var$gecko && node.nodeType == 1 && offset < $6199071156ddad70$var$nodeLen(node) && $6199071156ddad70$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($6199071156ddad70$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($6199071156ddad70$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $6199071156ddad70$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $6199071156ddad70$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $6199071156ddad70$var$nodeLen(node);
            }
        }
    }
    if (force) $6199071156ddad70$var$setSelFocus(view, node, offset);
    else if (moveNode) $6199071156ddad70$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $6199071156ddad70$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $6199071156ddad70$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($6199071156ddad70$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($6199071156ddad70$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $6199071156ddad70$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $6199071156ddad70$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $6199071156ddad70$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $6199071156ddad70$var$setSelFocus(view, moveNode, moveOffset);
}
function $6199071156ddad70$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $6199071156ddad70$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$6199071156ddad70$var$hasBlockDesc(node)){
        offset = $6199071156ddad70$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $6199071156ddad70$var$textNodeBefore(node, offset) {
    while(node && !offset && !$6199071156ddad70$var$hasBlockDesc(node)){
        offset = $6199071156ddad70$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $6199071156ddad70$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $6199071156ddad70$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $6199071156ddad70$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($6199071156ddad70$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $6199071156ddad70$var$selectionToDOM(view);
    }, 50);
}
function $6199071156ddad70$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($6199071156ddad70$var$chrome || $6199071156ddad70$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $6199071156ddad70$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $kCECX.TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($6199071156ddad70$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $6199071156ddad70$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $kCECX.NodeSelection)) return $6199071156ddad70$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $kCECX.AllSelection) ? (0, $kCECX.Selection).near(side, dir) : (0, $kCECX.Selection).findFrom(side, dir);
        return beyond ? $6199071156ddad70$var$apply(view, beyond) : false;
    }
    return false;
}
function $6199071156ddad70$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $kCECX.TextSelection))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $6199071156ddad70$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $6199071156ddad70$var$safariDownArrowBug(view) {
    if (!$6199071156ddad70$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $6199071156ddad70$var$switchEditable(view, child, "true");
        setTimeout(()=>$6199071156ddad70$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $6199071156ddad70$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $6199071156ddad70$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $6199071156ddad70$var$getMods(event);
    if (code == 8 || $6199071156ddad70$var$mac && code == 72 && mods == "c") return $6199071156ddad70$var$stopNativeHorizontalDelete(view, -1) || $6199071156ddad70$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $6199071156ddad70$var$mac && code == 68 && mods == "c") return $6199071156ddad70$var$stopNativeHorizontalDelete(view, 1) || $6199071156ddad70$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $6199071156ddad70$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $6199071156ddad70$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $6199071156ddad70$var$selectHorizontally(view, dir, mods) || $6199071156ddad70$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $6199071156ddad70$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $6199071156ddad70$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $6199071156ddad70$var$selectHorizontally(view, dir, mods) || $6199071156ddad70$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $6199071156ddad70$var$mac && code == 80 && mods == "c") return $6199071156ddad70$var$selectVertically(view, -1, mods) || $6199071156ddad70$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $6199071156ddad70$var$mac && code == 78 && mods == "c") return $6199071156ddad70$var$safariDownArrowBug(view) || $6199071156ddad70$var$selectVertically(view, 1, mods) || $6199071156ddad70$var$skipIgnoredNodes(view, 1);
    else if (mods == ($6199071156ddad70$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $6199071156ddad70$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $aPdNQ.DOMSerializer).fromSchema(view.state.schema);
    let doc = $6199071156ddad70$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $6199071156ddad70$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $6199071156ddad70$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = !!text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) {
            slice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0);
            view.someProp("transformPasted", (f)=>{
                slice = f(slice, view, true);
            });
            return slice;
        }
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $aPdNQ.DOMSerializer).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $6199071156ddad70$var$readHTML(html);
        if ($6199071156ddad70$var$webkit) $6199071156ddad70$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $aPdNQ.DOMParser).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$6199071156ddad70$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $6199071156ddad70$var$addContext($6199071156ddad70$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $aPdNQ.Slice).maxOpen($6199071156ddad70$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $6199071156ddad70$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view, asText);
    });
    return slice;
}
const $6199071156ddad70$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $6199071156ddad70$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $6199071156ddad70$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $6199071156ddad70$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $6199071156ddad70$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $aPdNQ.Fragment).from(result);
    }
    return fragment;
}
function $6199071156ddad70$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $aPdNQ.Fragment).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $6199071156ddad70$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $6199071156ddad70$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $aPdNQ.Fragment).from($6199071156ddad70$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $6199071156ddad70$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $6199071156ddad70$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $aPdNQ.Fragment).empty, true);
    return node.copy(fragment.append(fill));
}
function $6199071156ddad70$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $6199071156ddad70$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $aPdNQ.Fragment).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $6199071156ddad70$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $aPdNQ.Slice)($6199071156ddad70$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $aPdNQ.Slice)($6199071156ddad70$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $6199071156ddad70$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $6199071156ddad70$var$_detachedDoc = null;
function $6199071156ddad70$var$detachedDoc() {
    return $6199071156ddad70$var$_detachedDoc || ($6199071156ddad70$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let $6199071156ddad70$var$_policy = null;
function $6199071156ddad70$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!$6199071156ddad70$var$_policy) $6199071156ddad70$var$_policy = trustedTypes.defaultPolicy || trustedTypes.createPolicy("ProseMirrorClipboard", {
        createHTML: (s)=>s
    });
    return $6199071156ddad70$var$_policy.createHTML(html);
}
function $6199071156ddad70$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $6199071156ddad70$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $6199071156ddad70$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $6199071156ddad70$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $6199071156ddad70$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($6199071156ddad70$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $6199071156ddad70$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $aPdNQ.Fragment).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $aPdNQ.Slice)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $6199071156ddad70$var$handlers = {};
const $6199071156ddad70$var$editHandlers = {};
const $6199071156ddad70$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $6199071156ddad70$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: "",
            button: 0
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        this.badSafariComposition = false;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $6199071156ddad70$var$initInput(view) {
    for(let event in $6199071156ddad70$var$handlers){
        let handler = $6199071156ddad70$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($6199071156ddad70$var$eventBelongsToView(view, event) && !$6199071156ddad70$var$runCustomHandler(view, event) && (view.editable || !(event.type in $6199071156ddad70$var$editHandlers))) handler(view, event);
        }, $6199071156ddad70$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($6199071156ddad70$var$safari) view.dom.addEventListener("input", ()=>null);
    $6199071156ddad70$var$ensureListeners(view);
}
function $6199071156ddad70$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $6199071156ddad70$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $6199071156ddad70$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$6199071156ddad70$var$runCustomHandler(view, event));
    });
}
function $6199071156ddad70$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $6199071156ddad70$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $6199071156ddad70$var$dispatchEvent(view, event) {
    if (!$6199071156ddad70$var$runCustomHandler(view, event) && $6199071156ddad70$var$handlers[event.type] && (view.editable || !(event.type in $6199071156ddad70$var$editHandlers))) $6199071156ddad70$var$handlers[event.type](view, event);
}
$6199071156ddad70$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($6199071156ddad70$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($6199071156ddad70$var$android && $6199071156ddad70$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($6199071156ddad70$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $6199071156ddad70$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $6199071156ddad70$var$captureKeyDown(view, event)) event.preventDefault();
    else $6199071156ddad70$var$setSelectionOrigin(view, "key");
};
$6199071156ddad70$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$6199071156ddad70$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($6199071156ddad70$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $6199071156ddad70$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $kCECX.TextSelection)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        let deflt = ()=>view.state.tr.insertText(text).scrollIntoView();
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text, deflt))) view.dispatch(deflt());
        event.preventDefault();
    }
};
function $6199071156ddad70$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $6199071156ddad70$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $6199071156ddad70$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $6199071156ddad70$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $6199071156ddad70$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $kCECX.NodeSelection).isSelectable(node)) {
        $6199071156ddad70$var$updateSelection(view, new (0, $kCECX.NodeSelection)($pos), "pointer");
        return true;
    }
    return false;
}
function $6199071156ddad70$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $kCECX.NodeSelection)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $kCECX.NodeSelection).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $6199071156ddad70$var$updateSelection(view, (0, $kCECX.NodeSelection).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $6199071156ddad70$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $6199071156ddad70$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $6199071156ddad70$var$selectClickedNode(view, inside) : $6199071156ddad70$var$selectClickedLeaf(view, inside));
}
function $6199071156ddad70$var$handleDoubleClick(view, pos, inside, event) {
    return $6199071156ddad70$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $6199071156ddad70$var$handleTripleClick(view, pos, inside, event) {
    return $6199071156ddad70$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $6199071156ddad70$var$defaultTripleClick(view, inside, event);
}
function $6199071156ddad70$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $6199071156ddad70$var$updateSelection(view, (0, $kCECX.TextSelection).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $6199071156ddad70$var$updateSelection(view, (0, $kCECX.TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $kCECX.NodeSelection).isSelectable(node)) $6199071156ddad70$var$updateSelection(view, (0, $kCECX.NodeSelection).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $6199071156ddad70$var$forceDOMFlush(view) {
    return $6199071156ddad70$var$endComposition(view);
}
const $6199071156ddad70$var$selectNodeModifier = $6199071156ddad70$var$mac ? "metaKey" : "ctrlKey";
$6199071156ddad70$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $6199071156ddad70$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $6199071156ddad70$var$isNear(event, view.input.lastClick) && !event[$6199071156ddad70$var$selectNodeModifier] && view.input.lastClick.button == event.button) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type,
        button: event.button
    };
    let pos = view.posAtCoords($6199071156ddad70$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $6199071156ddad70$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $6199071156ddad70$var$handleDoubleClick : $6199071156ddad70$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $6199071156ddad70$var$setSelectionOrigin(view, "pointer");
};
class $6199071156ddad70$var$MouseDown {
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$6199071156ddad70$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($6199071156ddad70$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $6199071156ddad70$var$setSelectionOrigin(this.view, "pointer");
        else if ($6199071156ddad70$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $6199071156ddad70$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $6199071156ddad70$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $6199071156ddad70$var$updateSelection(this.view, (0, $kCECX.Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $6199071156ddad70$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $6199071156ddad70$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$6199071156ddad70$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.nodeDOM.nodeType == 1 ? targetDesc.nodeDOM : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $kCECX.NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $6199071156ddad70$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $6199071156ddad70$var$setSelectionOrigin(view, "pointer");
    }
}
$6199071156ddad70$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $6199071156ddad70$var$forceDOMFlush(view);
    $6199071156ddad70$var$setSelectionOrigin(view, "pointer");
};
$6199071156ddad70$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $6199071156ddad70$var$setSelectionOrigin(view, "pointer");
};
$6199071156ddad70$var$handlers.contextmenu = (view)=>$6199071156ddad70$var$forceDOMFlush(view);
function $6199071156ddad70$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($6199071156ddad70$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $6199071156ddad70$var$timeoutComposition = $6199071156ddad70$var$android ? 5000 : -1;
$6199071156ddad70$var$editHandlers.compositionstart = $6199071156ddad70$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $kCECX.TextSelection) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false) || $6199071156ddad70$var$chrome && $6199071156ddad70$var$windows && $6199071156ddad70$var$selectionBeforeUneditable(view))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $6199071156ddad70$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $6199071156ddad70$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($6199071156ddad70$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $6199071156ddad70$var$scheduleComposeEnd(view, $6199071156ddad70$var$timeoutComposition);
};
function $6199071156ddad70$var$selectionBeforeUneditable(view) {
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (!focusNode || focusNode.nodeType != 1 || focusOffset >= focusNode.childNodes.length) return false;
    let next = focusNode.childNodes[focusOffset];
    return next.nodeType == 1 && next.contentEditable == "false";
}
$6199071156ddad70$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.badSafariComposition) view.domObserver.forceFlush();
        else if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $6199071156ddad70$var$scheduleComposeEnd(view, 20);
    }
};
function $6199071156ddad70$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$6199071156ddad70$var$endComposition(view), delay);
}
function $6199071156ddad70$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $6199071156ddad70$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $6199071156ddad70$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $6199071156ddad70$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $6199071156ddad70$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $6199071156ddad70$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $6199071156ddad70$var$endComposition(view, restarting = false) {
    if ($6199071156ddad70$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $6199071156ddad70$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $6199071156ddad70$var$selectionFromDOM(view), cur = view.state.selection;
        if (sel && !sel.eq(cur)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !cur.$from.node(cur.$from.sharedDepth(cur.to)).inlineContent) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $6199071156ddad70$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $6199071156ddad70$var$brokenClipboardAPI = $6199071156ddad70$var$ie && $6199071156ddad70$var$ie_version < 15 || $6199071156ddad70$var$ios && $6199071156ddad70$var$webkit_version < 604;
$6199071156ddad70$var$handlers.copy = $6199071156ddad70$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $6199071156ddad70$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $6199071156ddad70$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $6199071156ddad70$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $6199071156ddad70$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $6199071156ddad70$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $6199071156ddad70$var$doPaste(view, target.value, null, plain, event);
        else $6199071156ddad70$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $6199071156ddad70$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $6199071156ddad70$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $aPdNQ.Slice).empty))) return true;
    if (!slice) return false;
    let singleNode = $6199071156ddad70$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $6199071156ddad70$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$6199071156ddad70$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$6199071156ddad70$var$android) return;
    let data = $6199071156ddad70$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $6199071156ddad70$var$doPaste(view, $6199071156ddad70$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $6199071156ddad70$var$capturePaste(view, event);
};
class $6199071156ddad70$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $6199071156ddad70$var$dragCopyModifier = $6199071156ddad70$var$mac ? "altKey" : "ctrlKey";
function $6199071156ddad70$var$dragMoves(view, event) {
    let moves = view.someProp("dragCopies", (test)=>!test(event));
    return moves != null ? moves : !event[$6199071156ddad70$var$dragCopyModifier];
}
$6199071156ddad70$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($6199071156ddad70$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $kCECX.NodeSelection) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $kCECX.NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $kCECX.NodeSelection).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $6199071156ddad70$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$6199071156ddad70$var$chrome || $6199071156ddad70$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($6199071156ddad70$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$6199071156ddad70$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $6199071156ddad70$var$Dragging(slice, $6199071156ddad70$var$dragMoves(view, event), node);
};
$6199071156ddad70$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$6199071156ddad70$var$editHandlers.dragover = $6199071156ddad70$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$6199071156ddad70$var$editHandlers.drop = (view, event)=>{
    try {
        $6199071156ddad70$var$handleDrop(view, event, view.dragging);
    } finally{
        view.dragging = null;
    }
};
function $6199071156ddad70$var$handleDrop(view, event, dragging) {
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($6199071156ddad70$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view, false);
    });
    else slice = $6199071156ddad70$var$parseFromClipboard(view, $6199071156ddad70$var$getText(event.dataTransfer), $6199071156ddad70$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && $6199071156ddad70$var$dragMoves(view, event));
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $aPdNQ.Slice).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $eOaGc.dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $kCECX.NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $kCECX.NodeSelection)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($6199071156ddad70$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
}
$6199071156ddad70$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $6199071156ddad70$var$selectionToDOM(view);
        }, 20);
    }
};
$6199071156ddad70$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$6199071156ddad70$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($6199071156ddad70$var$chrome && $6199071156ddad70$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $6199071156ddad70$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $6199071156ddad70$var$editHandlers)$6199071156ddad70$var$handlers[prop] = $6199071156ddad70$var$editHandlers[prop];
function $6199071156ddad70$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $6199071156ddad70$var$WidgetType {
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $6199071156ddad70$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $6199071156ddad70$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $6199071156ddad70$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $6199071156ddad70$var$noSpec;
        this.side = this.spec.side || 0;
    }
}
class $6199071156ddad70$var$InlineType {
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $6199071156ddad70$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $6199071156ddad70$var$InlineType && $6199071156ddad70$var$compareObjs(this.attrs, other.attrs) && $6199071156ddad70$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $6199071156ddad70$var$InlineType;
    }
    destroy() {}
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $6199071156ddad70$var$noSpec;
    }
}
class $6199071156ddad70$var$NodeType {
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $6199071156ddad70$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $6199071156ddad70$var$NodeType && $6199071156ddad70$var$compareObjs(this.attrs, other.attrs) && $6199071156ddad70$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $6199071156ddad70$var$noSpec;
    }
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $6199071156ddad70$export$10e30b733df217ea {
    /**
    @internal
    */ copy(from, to) {
        return new $6199071156ddad70$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $6199071156ddad70$export$10e30b733df217ea(pos, pos, new $6199071156ddad70$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $6199071156ddad70$export$10e30b733df217ea(from, to, new $6199071156ddad70$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $6199071156ddad70$export$10e30b733df217ea(from, to, new $6199071156ddad70$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $6199071156ddad70$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $6199071156ddad70$var$WidgetType;
    }
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
}
const $6199071156ddad70$var$none = [], $6199071156ddad70$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $6199071156ddad70$export$93bf62eb445cec98 {
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $6199071156ddad70$var$buildTree(decorations, doc, 0, $6199071156ddad70$var$noSpec) : $6199071156ddad70$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $6199071156ddad70$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $6199071156ddad70$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $6199071156ddad70$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $6199071156ddad70$export$93bf62eb445cec98(newLocal.sort($6199071156ddad70$var$byPos), $6199071156ddad70$var$none) : $6199071156ddad70$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $6199071156ddad70$var$empty) return $6199071156ddad70$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $6199071156ddad70$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $6199071156ddad70$var$buildTree(found, childNode, baseOffset + 1, $6199071156ddad70$var$noSpec));
            childIndex += 3;
        });
        let local = $6199071156ddad70$var$moveSpans(childIndex ? $6199071156ddad70$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $6199071156ddad70$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($6199071156ddad70$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $6199071156ddad70$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $6199071156ddad70$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $6199071156ddad70$export$93bf62eb445cec98(local, children) : $6199071156ddad70$var$empty;
    }
    forChild(offset, node) {
        if (this == $6199071156ddad70$var$empty) return this;
        if (node.isLeaf) return $6199071156ddad70$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $6199071156ddad70$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $6199071156ddad70$export$93bf62eb445cec98(local.sort($6199071156ddad70$var$byPos), $6199071156ddad70$var$none);
            return child ? new $6199071156ddad70$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $6199071156ddad70$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $6199071156ddad70$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $6199071156ddad70$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $6199071156ddad70$var$empty) return $6199071156ddad70$var$none;
        if (node.inlineContent || !this.local.some($6199071156ddad70$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $6199071156ddad70$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $6199071156ddad70$var$none;
        this.children = children.length ? children : $6199071156ddad70$var$none;
    }
}
/**
The empty set of decorations.
*/ $6199071156ddad70$export$93bf62eb445cec98.empty = new $6199071156ddad70$export$93bf62eb445cec98([], []);
/**
@internal
*/ $6199071156ddad70$export$93bf62eb445cec98.removeOverlap = $6199071156ddad70$var$removeOverlap;
const $6199071156ddad70$var$empty = $6199071156ddad70$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $6199071156ddad70$var$DecorationGroup {
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $6199071156ddad70$var$noSpec));
        return $6199071156ddad70$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $6199071156ddad70$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $6199071156ddad70$var$empty) continue;
            if (result instanceof $6199071156ddad70$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $6199071156ddad70$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $6199071156ddad70$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $6199071156ddad70$var$removeOverlap(sorted ? result : result.sort($6199071156ddad70$var$byPos)) : $6199071156ddad70$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $6199071156ddad70$var$empty;
            case 1:
                return members[0];
            default:
                return new $6199071156ddad70$var$DecorationGroup(members.every((m)=>m instanceof $6199071156ddad70$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $6199071156ddad70$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
    constructor(members){
        this.members = members;
    }
}
function $6199071156ddad70$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $6199071156ddad70$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $6199071156ddad70$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $6199071156ddad70$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $6199071156ddad70$export$93bf62eb445cec98(newLocal.sort($6199071156ddad70$var$byPos), children);
}
function $6199071156ddad70$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $6199071156ddad70$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $6199071156ddad70$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $6199071156ddad70$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $6199071156ddad70$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $6199071156ddad70$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $6199071156ddad70$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $6199071156ddad70$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $6199071156ddad70$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $6199071156ddad70$var$moveSpans(hasNulls ? $6199071156ddad70$var$withoutNulls(spans) : spans, -offset).sort($6199071156ddad70$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $6199071156ddad70$export$93bf62eb445cec98(locals, children) : $6199071156ddad70$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $6199071156ddad70$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $6199071156ddad70$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $6199071156ddad70$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $6199071156ddad70$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $6199071156ddad70$var$insertAhead(array, i, deco) {
    while(i < array.length && $6199071156ddad70$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $6199071156ddad70$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $6199071156ddad70$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($6199071156ddad70$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $6199071156ddad70$var$DecorationGroup.from(found);
}
const $6199071156ddad70$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $6199071156ddad70$var$useCharData = $6199071156ddad70$var$ie && $6199071156ddad70$var$ie_version <= 11;
class $6199071156ddad70$var$SelectionState {
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
}
class $6199071156ddad70$var$DOMObserver {
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $6199071156ddad70$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$6199071156ddad70$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $6199071156ddad70$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($6199071156ddad70$var$ie && $6199071156ddad70$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $6199071156ddad70$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $6199071156ddad70$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $6199071156ddad70$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $6199071156ddad70$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($6199071156ddad70$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $6199071156ddad70$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        } else if (($6199071156ddad70$var$chrome || $6199071156ddad70$var$safari) && added.some((n)=>n.nodeName == "BR") && (view.input.lastKeyCode == 8 || view.input.lastKeyCode == 46)) {
            // Chrome/Safari sometimes insert a bogus break node if you
            // backspace out the last bit of text before an inline-flex node (#1552)
            for (let node of added)if (node.nodeName == "BR" && node.parentNode) {
                let after = node.nextSibling;
                if (after && after.nodeType == 1 && after.contentEditable == "false") node.parentNode.removeChild(node);
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $6199071156ddad70$var$selectionCollapsed(sel) && (readSel = $6199071156ddad70$var$selectionFromDOM(view)) && readSel.eq((0, $kCECX.Selection).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $6199071156ddad70$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $6199071156ddad70$var$checkCSS(view);
            }
            if (view.input.badSafariComposition) {
                view.input.badSafariComposition = false;
                $6199071156ddad70$var$fixUpBadSafariComposition(view, added);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $6199071156ddad70$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($6199071156ddad70$var$ie && $6199071156ddad70$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $6199071156ddad70$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $6199071156ddad70$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $6199071156ddad70$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            if ($6199071156ddad70$var$ie && $6199071156ddad70$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            this.flushSoon();
            else if ($6199071156ddad70$var$safari && view.composing && mutations.some((m)=>m.type == "childList" && m.target.nodeName == "TR")) {
                // Safari does weird stuff when finishing a composition in a
                // table cell, which tends to involve inserting inappropriate
                // nodes in the table row.
                view.input.badSafariComposition = true;
                this.flushSoon();
            } else this.flush();
        });
        if ($6199071156ddad70$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
}
let $6199071156ddad70$var$cssChecked = new WeakMap();
let $6199071156ddad70$var$cssCheckWarned = false;
function $6199071156ddad70$var$checkCSS(view) {
    if ($6199071156ddad70$var$cssChecked.has(view)) return;
    $6199071156ddad70$var$cssChecked.set(view, null);
    if ([
        'normal',
        'nowrap',
        'pre-line'
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $6199071156ddad70$var$gecko;
        if ($6199071156ddad70$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $6199071156ddad70$var$cssCheckWarned = true;
    }
}
function $6199071156ddad70$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($6199071156ddad70$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $6199071156ddad70$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $6199071156ddad70$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $6199071156ddad70$var$rangeToSelectionRange(view, found) : null;
}
function $6199071156ddad70$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Kludge for a Safari bug where, on ending a composition in an
// otherwise empty table cell, it randomly moves the composed text
// into the table row around that cell, greatly confusing everything
// (#188).
function $6199071156ddad70$var$fixUpBadSafariComposition(view, addedNodes) {
    var _a;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    for (let node of addedNodes)if (((_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.nodeName) == "TR") {
        let nextCell = node.nextSibling;
        while(nextCell && nextCell.nodeName != "TD" && nextCell.nodeName != "TH")nextCell = nextCell.nextSibling;
        if (nextCell) {
            let parent = nextCell;
            for(;;){
                let first = parent.firstChild;
                if (!first || first.nodeType != 1 || first.contentEditable == "false" || /^(BR|IMG)$/.test(first.nodeName)) break;
                parent = first;
            }
            parent.insertBefore(node, parent.firstChild);
            if (focusNode == node) view.domSelection().collapse(node, focusOffset);
        } else node.parentNode.removeChild(node);
    }
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $6199071156ddad70$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$6199071156ddad70$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($6199071156ddad70$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $aPdNQ.DOMParser).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $6199071156ddad70$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $6199071156ddad70$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($6199071156ddad70$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $6199071156ddad70$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $6199071156ddad70$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $6199071156ddad70$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $6199071156ddad70$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($6199071156ddad70$var$chrome && $6199071156ddad70$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $6199071156ddad70$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $6199071156ddad70$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $6199071156ddad70$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($6199071156ddad70$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $6199071156ddad70$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$6199071156ddad70$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $6199071156ddad70$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $kCECX.TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $6199071156ddad70$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $kCECX.TextSelection)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($6199071156ddad70$var$ie && $6199071156ddad70$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($6199071156ddad70$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && (!$from.sameParent($to) || !$from.parent.inlineContent) && $from.pos < $to.pos && !/\S/.test(parse.doc.textBetween($from.pos, $to.pos, "", ""))) && view.someProp("handleKeyDown", (f)=>f(view, $6199071156ddad70$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $6199071156ddad70$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $6199071156ddad70$var$keyEvent(8, "Backspace")))) {
        if ($6199071156ddad70$var$android && $6199071156ddad70$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($6199071156ddad70$var$chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($6199071156ddad70$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $6199071156ddad70$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let mkTr = (base)=>{
        let tr = base || view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
        if (parse.sel) {
            let sel = $6199071156ddad70$var$resolveSelection(view, tr.doc, parse.sel);
            // Chrome will sometimes, during composition, report the
            // selection in the wrong place. If it looks like that is
            // happening, don't update the selection.
            // Edge just doesn't move the cursor forward when you start typing
            // in an empty block or between br nodes.
            if (sel && !($6199071156ddad70$var$chrome && view.composing && sel.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $6199071156ddad70$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
        }
        if (compositionID) tr.setMeta("composition", compositionID);
        return tr.scrollIntoView();
    };
    let markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($6199071156ddad70$var$ie && $6199071156ddad70$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$6199071156ddad70$var$selectionToDOM(view), 20);
            }
            let tr = mkTr(view.state.tr.delete(chFrom, chTo));
            let marks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
            if (marks) tr.ensureMarks(marks);
            view.dispatch(tr);
        } else if (change.endA == change.endB && (markChange = $6199071156ddad70$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            let tr = mkTr(view.state.tr);
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
            view.dispatch(tr);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            let deflt = ()=>mkTr(view.state.tr.insertText(text, chFrom, chTo));
            if (!view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text, deflt))) view.dispatch(deflt());
        } else view.dispatch(mkTr());
    } else view.dispatch(mkTr());
}
function $6199071156ddad70$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $6199071156ddad70$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $6199071156ddad70$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $aPdNQ.Fragment).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $6199071156ddad70$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $6199071156ddad70$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($6199071156ddad70$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $6199071156ddad70$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $6199071156ddad70$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $6199071156ddad70$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $6199071156ddad70$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $6199071156ddad70$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $6199071156ddad70$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $6199071156ddad70$export$5d42ca91c11c9e4d = $6199071156ddad70$var$parseFromClipboard;
/**
@internal
*/ const $6199071156ddad70$export$76b14d3c719c32fc = $6199071156ddad70$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $6199071156ddad70$export$eece2fccabbb77c5 {
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $6199071156ddad70$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($6199071156ddad70$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $6199071156ddad70$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $6199071156ddad70$var$buildNodeViews(this);
            if ($6199071156ddad70$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $6199071156ddad70$var$ensureListeners(this);
        this.editable = $6199071156ddad70$var$getEditable(this);
        $6199071156ddad70$var$updateCursorWrapper(this);
        let innerDeco = $6199071156ddad70$var$viewDecorations(this), outerDeco = $6199071156ddad70$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $6199071156ddad70$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($6199071156ddad70$var$ie || $6199071156ddad70$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $6199071156ddad70$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $6199071156ddad70$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $6199071156ddad70$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $6199071156ddad70$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && (!this.trackWrites || !this.dom.contains(this.trackWrites))) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $6199071156ddad70$var$anchorInRightPlace(this))) $6199071156ddad70$var$selectionToDOM(this, forceSelUpdate);
            else {
                $6199071156ddad70$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $6199071156ddad70$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (!startDOM || !this.dom.contains(startDOM.nodeType == 1 ? startDOM : startDOM.parentNode)) ;
        else if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $kCECX.NodeSelection)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $6199071156ddad70$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $6199071156ddad70$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $6199071156ddad70$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $kCECX.NodeSelection).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($6199071156ddad70$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == 'false') return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $6199071156ddad70$var$focusPreventScroll(this.dom);
        $6199071156ddad70$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $6199071156ddad70$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $6199071156ddad70$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $6199071156ddad70$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $6199071156ddad70$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $6199071156ddad70$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Serialize the given slice as it would be if it was copied from
    this editor. Returns a DOM element that contains a
    representation of the slice as its children, a textual
    representation, and the transformed slice (which can be
    different from the given input due to hooks like
    [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
    */ serializeForClipboard(slice) {
        return $6199071156ddad70$var$serializeForClipboard(this, slice);
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $6199071156ddad70$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $6199071156ddad70$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $6199071156ddad70$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $6199071156ddad70$var$dispatchEvent(this, event);
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $6199071156ddad70$var$safari && this.root.nodeType === 11 && $6199071156ddad70$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $6199071156ddad70$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $6199071156ddad70$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($6199071156ddad70$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $6199071156ddad70$var$getEditable(this);
        $6199071156ddad70$var$updateCursorWrapper(this);
        this.nodeViews = $6199071156ddad70$var$buildNodeViews(this);
        this.docView = $6199071156ddad70$var$docViewDesc(this.state.doc, $6199071156ddad70$var$computeDocDeco(this), $6199071156ddad70$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $6199071156ddad70$var$DOMObserver(this, (from, to, typeOver, added)=>$6199071156ddad70$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $6199071156ddad70$var$initInput(this);
        this.updatePluginViews();
    }
}
$6199071156ddad70$export$eece2fccabbb77c5.prototype.dispatch = function(tr) {
    let dispatchTransaction = this._props.dispatchTransaction;
    if (dispatchTransaction) dispatchTransaction.call(this, tr);
    else this.updateState(this.state.apply(tr));
};
function $6199071156ddad70$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $6199071156ddad70$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $6199071156ddad70$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $6199071156ddad70$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $6199071156ddad70$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $6199071156ddad70$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $6199071156ddad70$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $6199071156ddad70$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $6199071156ddad70$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}
module.exports["Decoration"] = $6199071156ddad70$export$10e30b733df217ea;
module.exports["DecorationSet"] = $6199071156ddad70$export$93bf62eb445cec98;
module.exports["__parseFromClipboard"] = $6199071156ddad70$export$5d42ca91c11c9e4d;
module.exports["EditorView"] = $6199071156ddad70$export$eece2fccabbb77c5;

});

parcelRegister("iUNgd", function(module, exports) {

var $eOaGc = parcelRequire("eOaGc");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");

/**
Delete the selection, if there is one.
*/ const $dc53ab10941bea06$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $dc53ab10941bea06$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $dc53ab10941bea06$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $dc53ab10941bea06$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $dc53ab10941bea06$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $eOaGc.liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($dc53ab10941bea06$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($dc53ab10941bea06$var$textblockAt(before, "end") || (0, $kCECX.NodeSelection).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $eOaGc.replaceStep)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $aPdNQ.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($dc53ab10941bea06$var$textblockAt(before, "end") ? (0, $kCECX.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $kCECX.NodeSelection).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $dc53ab10941bea06$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $dc53ab10941bea06$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $dc53ab10941bea06$var$findCutBefore($cursor);
    return $cut ? $dc53ab10941bea06$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $dc53ab10941bea06$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $dc53ab10941bea06$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $dc53ab10941bea06$var$findCutAfter($cursor);
    return $cut ? $dc53ab10941bea06$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $dc53ab10941bea06$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $eOaGc.replaceStep)(state.doc, beforePos, afterPos, (0, $aPdNQ.Slice).empty);
    if (!step || step.from != beforePos || step instanceof (0, $eOaGc.ReplaceStep) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $dc53ab10941bea06$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $dc53ab10941bea06$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $dc53ab10941bea06$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $kCECX.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $kCECX.NodeSelection).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $dc53ab10941bea06$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $dc53ab10941bea06$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $dc53ab10941bea06$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $dc53ab10941bea06$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $dc53ab10941bea06$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($dc53ab10941bea06$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($dc53ab10941bea06$var$textblockAt(after, "start") || (0, $kCECX.NodeSelection).isSelectable(after))) {
        let delStep = (0, $eOaGc.replaceStep)(state.doc, $cursor.before(), $cursor.after(), (0, $aPdNQ.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($dc53ab10941bea06$var$textblockAt(after, "start") ? (0, $kCECX.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $kCECX.NodeSelection).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $dc53ab10941bea06$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $dc53ab10941bea06$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $kCECX.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $kCECX.NodeSelection).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $dc53ab10941bea06$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $dc53ab10941bea06$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $kCECX.NodeSelection), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $eOaGc.canJoin)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $eOaGc.joinPoint)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $dc53ab10941bea06$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $kCECX.NodeSelection)) {
        if (sel.node.isTextblock || !(0, $eOaGc.canJoin)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $eOaGc.joinPoint)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $dc53ab10941bea06$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $eOaGc.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $dc53ab10941bea06$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $dc53ab10941bea06$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $dc53ab10941bea06$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $dc53ab10941bea06$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $dc53ab10941bea06$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $kCECX.AllSelection) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $dc53ab10941bea06$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $dc53ab10941bea06$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $eOaGc.canSplit)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $eOaGc.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $dc53ab10941bea06$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $eOaGc.canSplit)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth) return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for(let d = $from.depth;; d--){
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = $dc53ab10941bea06$var$defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? {
                    type: deflt
                } : null));
                splitDepth = d;
                break;
            } else {
                if (d == 1) return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof (0, $kCECX.TextSelection) || state.selection instanceof (0, $kCECX.AllSelection)) tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = (0, $eOaGc.canSplit)(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? {
                type: deflt
            } : null;
            can = (0, $eOaGc.canSplit)(tr.doc, splitPos, types.length, types);
        }
        if (!can) return false;
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $dc53ab10941bea06$export$e99155638ff4dff0 = $dc53ab10941bea06$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $dc53ab10941bea06$export$eeb429476568b72b = (state, dispatch)=>{
    return $dc53ab10941bea06$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $dc53ab10941bea06$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $kCECX.NodeSelection).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $dc53ab10941bea06$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $kCECX.AllSelection)(state.doc)));
    return true;
};
function $dc53ab10941bea06$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $eOaGc.canJoin)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function $dc53ab10941bea06$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $dc53ab10941bea06$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $aPdNQ.Fragment).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $aPdNQ.Fragment).from(conn[i].create(null, wrap));
            wrap = (0, $aPdNQ.Fragment).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $eOaGc.ReplaceAroundStep)($cut.pos - 1, end, $cut.pos, end, new (0, $aPdNQ.Slice)(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && (0, $eOaGc.canJoin)(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $kCECX.Selection).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $eOaGc.liftTarget)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $dc53ab10941bea06$var$textblockAt(after, "start", true) && $dc53ab10941bea06$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $aPdNQ.Fragment).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $aPdNQ.Fragment).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $eOaGc.ReplaceAroundStep)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $aPdNQ.Slice)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $dc53ab10941bea06$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $kCECX.TextSelection).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $dc53ab10941bea06$export$c3a64f3c9604a1b1 = $dc53ab10941bea06$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $dc53ab10941bea06$export$a66c1876556415e5 = $dc53ab10941bea06$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $dc53ab10941bea06$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $eOaGc.findWrapping)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $dc53ab10941bea06$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $dc53ab10941bea06$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $dc53ab10941bea06$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $kCECX.SelectionRange)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $kCECX.SelectionRange)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $dc53ab10941bea06$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    let dropSpace = !(options && options.includeWhitespace);
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$dc53ab10941bea06$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $dc53ab10941bea06$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = dropSpace && start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = dropSpace && end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $dc53ab10941bea06$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $eOaGc.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $dc53ab10941bea06$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $dc53ab10941bea06$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $dc53ab10941bea06$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $dc53ab10941bea06$var$backspace = $dc53ab10941bea06$export$146a774cdef7663a($dc53ab10941bea06$export$e9a518a637d1e641, $dc53ab10941bea06$export$979097b097459299, $dc53ab10941bea06$export$52b8a4af68d19794);
let $dc53ab10941bea06$var$del = $dc53ab10941bea06$export$146a774cdef7663a($dc53ab10941bea06$export$e9a518a637d1e641, $dc53ab10941bea06$export$bf432e340007f9ef, $dc53ab10941bea06$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $dc53ab10941bea06$export$eb36e8971b04df36 = {
    "Enter": $dc53ab10941bea06$export$146a774cdef7663a($dc53ab10941bea06$export$a5d02b4b65e94f91, $dc53ab10941bea06$export$d0f80ac1b4510888, $dc53ab10941bea06$export$a3574cc681852c08, $dc53ab10941bea06$export$e99155638ff4dff0),
    "Mod-Enter": $dc53ab10941bea06$export$634b78845598ff5b,
    "Backspace": $dc53ab10941bea06$var$backspace,
    "Mod-Backspace": $dc53ab10941bea06$var$backspace,
    "Shift-Backspace": $dc53ab10941bea06$var$backspace,
    "Delete": $dc53ab10941bea06$var$del,
    "Mod-Delete": $dc53ab10941bea06$var$del,
    "Mod-a": $dc53ab10941bea06$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $dc53ab10941bea06$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $dc53ab10941bea06$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $dc53ab10941bea06$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $dc53ab10941bea06$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $dc53ab10941bea06$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $dc53ab10941bea06$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $dc53ab10941bea06$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $dc53ab10941bea06$export$c3a64f3c9604a1b1,
    "Ctrl-e": $dc53ab10941bea06$export$a66c1876556415e5
};
for(let key in $dc53ab10941bea06$export$eb36e8971b04df36)$dc53ab10941bea06$export$f292ad8dbd5063c8[key] = $dc53ab10941bea06$export$eb36e8971b04df36[key];
const $dc53ab10941bea06$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $dc53ab10941bea06$export$4a0c2b85b1f0a889 = $dc53ab10941bea06$var$mac ? $dc53ab10941bea06$export$f292ad8dbd5063c8 : $dc53ab10941bea06$export$eb36e8971b04df36;
module.exports["deleteSelection"] = $dc53ab10941bea06$export$e9a518a637d1e641;
module.exports["selectNodeBackward"] = $dc53ab10941bea06$export$52b8a4af68d19794;
module.exports["exitCode"] = $dc53ab10941bea06$export$634b78845598ff5b;
module.exports["createParagraphNear"] = $dc53ab10941bea06$export$d0f80ac1b4510888;
module.exports["splitBlockAs"] = $dc53ab10941bea06$export$8bf8350f33b1e5ab;
module.exports["splitBlock"] = $dc53ab10941bea06$export$e99155638ff4dff0;
module.exports["selectAll"] = $dc53ab10941bea06$export$90aca4adda6ff0f5;
module.exports["toggleMark"] = $dc53ab10941bea06$export$797ad2667b8015a8;
module.exports["autoJoin"] = $dc53ab10941bea06$export$29903073afddcd8b;
module.exports["chainCommands"] = $dc53ab10941bea06$export$146a774cdef7663a;
module.exports["baseKeymap"] = $dc53ab10941bea06$export$4a0c2b85b1f0a889;

});

parcelRegister("44cyU", function(module, exports) {

var $iqS60 = parcelRequire("iqS60");


var $kCECX = parcelRequire("kCECX");

const $2f6147b7d75920ed$var$mac = typeof navigator != "undefined" && /Mac|iP(hone|[oa]d)/.test(navigator.platform);
const $2f6147b7d75920ed$var$windows = typeof navigator != "undefined" && /Win/.test(navigator.platform);
function $2f6147b7d75920ed$var$normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; i++){
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($2f6147b7d75920ed$var$mac) meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $2f6147b7d75920ed$var$normalize(map) {
    let copy = Object.create(null);
    for(let prop in map)copy[$2f6147b7d75920ed$var$normalizeKeyName(prop)] = map[prop];
    return copy;
}
function $2f6147b7d75920ed$var$modifiers(name, event, shift = true) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift && event.shiftKey) name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/ function $2f6147b7d75920ed$export$5043418e2ef368d5(bindings) {
    return new (0, $kCECX.Plugin)({
        props: {
            handleKeyDown: $2f6147b7d75920ed$export$53f558754f8b9fd1(bindings)
        }
    });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/ function $2f6147b7d75920ed$export$53f558754f8b9fd1(bindings) {
    let map = $2f6147b7d75920ed$var$normalize(bindings);
    return function(view, event) {
        let name = (0, $iqS60.keyName)(event), baseName, direct = map[$2f6147b7d75920ed$var$modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view)) return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[$2f6147b7d75920ed$var$modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view)) return true;
            }
            if ((event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
            !($2f6147b7d75920ed$var$windows && event.ctrlKey && event.altKey) && (baseName = (0, $iqS60.base)[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060, #1529.
                let fromCode = map[$2f6147b7d75920ed$var$modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
            }
        }
        return false;
    };
}
module.exports["keymap"] = $2f6147b7d75920ed$export$5043418e2ef368d5;
module.exports["keydownHandler"] = $2f6147b7d75920ed$export$53f558754f8b9fd1;

});

parcelRegister("hV96P", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

var $bab964f0db6aa999$var$GOOD_LEAF_SIZE = 200;
// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var $bab964f0db6aa999$var$RopeSequence = function RopeSequence() {};
$bab964f0db6aa999$var$RopeSequence.prototype.append = function append(other) {
    if (!other.length) return this;
    other = $bab964f0db6aa999$var$RopeSequence.from(other);
    return !this.length && other || other.length < $bab964f0db6aa999$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $bab964f0db6aa999$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
$bab964f0db6aa999$var$RopeSequence.prototype.prepend = function prepend(other) {
    if (!other.length) return this;
    return $bab964f0db6aa999$var$RopeSequence.from(other).append(this);
};
$bab964f0db6aa999$var$RopeSequence.prototype.appendInner = function appendInner(other) {
    return new $bab964f0db6aa999$var$Append(this, other);
};
// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
$bab964f0db6aa999$var$RopeSequence.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from >= to) return $bab964f0db6aa999$var$RopeSequence.empty;
    return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
// :: (number) → T
// Retrieve the element at the given position from this rope.
$bab964f0db6aa999$var$RopeSequence.prototype.get = function get(i) {
    if (i < 0 || i >= this.length) return undefined;
    return this.getInner(i);
};
// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
$bab964f0db6aa999$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from <= to) this.forEachInner(f, from, to, 0);
    else this.forEachInvertedInner(f, from, to, 0);
};
// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
$bab964f0db6aa999$var$RopeSequence.prototype.map = function map(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    var result = [];
    this.forEach(function(elt, i) {
        return result.push(f(elt, i));
    }, from, to);
    return result;
};
// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
$bab964f0db6aa999$var$RopeSequence.from = function from(values) {
    if (values instanceof $bab964f0db6aa999$var$RopeSequence) return values;
    return values && values.length ? new $bab964f0db6aa999$var$Leaf(values) : $bab964f0db6aa999$var$RopeSequence.empty;
};
var $bab964f0db6aa999$var$Leaf = /*@__PURE__*/ function(RopeSequence) {
    function Leaf(values) {
        RopeSequence.call(this);
        this.values = values;
    }
    if (RopeSequence) Leaf.__proto__ = RopeSequence;
    Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Leaf.prototype.constructor = Leaf;
    var prototypeAccessors = {
        length: {
            configurable: true
        },
        depth: {
            configurable: true
        }
    };
    Leaf.prototype.flatten = function flatten() {
        return this.values;
    };
    Leaf.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        return new Leaf(this.values.slice(from, to));
    };
    Leaf.prototype.getInner = function getInner(i) {
        return this.values[i];
    };
    Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
        for(var i = from; i < to; i++){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        for(var i = from - 1; i >= to; i--){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.leafAppend = function leafAppend(other) {
        if (this.length + other.length <= $bab964f0db6aa999$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
    };
    Leaf.prototype.leafPrepend = function leafPrepend(other) {
        if (this.length + other.length <= $bab964f0db6aa999$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
    };
    prototypeAccessors.length.get = function() {
        return this.values.length;
    };
    prototypeAccessors.depth.get = function() {
        return 0;
    };
    Object.defineProperties(Leaf.prototype, prototypeAccessors);
    return Leaf;
}($bab964f0db6aa999$var$RopeSequence);
// :: RopeSequence
// The empty rope sequence.
$bab964f0db6aa999$var$RopeSequence.empty = new $bab964f0db6aa999$var$Leaf([]);
var $bab964f0db6aa999$var$Append = /*@__PURE__*/ function(RopeSequence) {
    function Append(left, right) {
        RopeSequence.call(this);
        this.left = left;
        this.right = right;
        this.length = left.length + right.length;
        this.depth = Math.max(left.depth, right.depth) + 1;
    }
    if (RopeSequence) Append.__proto__ = RopeSequence;
    Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Append.prototype.constructor = Append;
    Append.prototype.flatten = function flatten() {
        return this.left.flatten().concat(this.right.flatten());
    };
    Append.prototype.getInner = function getInner(i) {
        return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
    };
    Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
        if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
    };
    Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
        if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
    };
    Append.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        var leftLen = this.left.length;
        if (to <= leftLen) return this.left.slice(from, to);
        if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
        return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
    };
    Append.prototype.leafAppend = function leafAppend(other) {
        var inner = this.right.leafAppend(other);
        if (inner) return new Append(this.left, inner);
    };
    Append.prototype.leafPrepend = function leafPrepend(other) {
        var inner = this.left.leafPrepend(other);
        if (inner) return new Append(inner, this.right);
    };
    Append.prototype.appendInner = function appendInner(other) {
        if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
        return new Append(this, other);
    };
    return Append;
}($bab964f0db6aa999$var$RopeSequence);
var $bab964f0db6aa999$export$2e2bcd8739ae039 = $bab964f0db6aa999$var$RopeSequence;



var $eOaGc = parcelRequire("eOaGc");

var $c0b0e53fdcf32530$var$_Branch;
// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const $c0b0e53fdcf32530$var$max_empty_items = 500;
const $c0b0e53fdcf32530$var$DEPTH_OVERFLOW = 20;
class $c0b0e53fdcf32530$export$aecb2ddcb55c95be {
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (this.eventCount == 0) return null;
        let end = this.items.length;
        for(;; end--){
            const next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        const transform = state.tr;
        let selection, remaining;
        const addAfter = [], addBefore = [];
        this.items.forEach((item, i)=>{
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                // To match existing behaviour of prosemirror-history
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new $c0b0e53fdcf32530$var$Item(item.map));
                const step = item.step.map(remap.slice(mapFrom));
                let map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new $c0b0e53fdcf32530$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                // To match existing behaviour of prosemirror-history
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
            } else transform.maybeStep(item.step);
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new $c0b0e53fdcf32530$export$aecb2ddcb55c95be(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return {
            remaining: remaining,
            transform: transform,
            selection: selection
        };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        const newItems = [];
        let eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for(let i = 0; i < transform.steps.length; i++){
            const step = transform.steps[i].invert(transform.docs[i]);
            let item = new $c0b0e53fdcf32530$var$Item(transform.mapping.maps[i], step, selection), merged;
            // To match existing behaviour of prosemirror-history
            // eslint-disable-next-line no-cond-assign
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i) newItems.pop();
                else oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems) lastItem = item;
        }
        const overflow = eventCount - histOptions.depth;
        if (overflow > $c0b0e53fdcf32530$var$DEPTH_OVERFLOW) {
            oldItems = $c0b0e53fdcf32530$var$cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new $c0b0e53fdcf32530$export$aecb2ddcb55c95be(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        const maps = new (0, $eOaGc.Mapping)();
        this.items.forEach((item, i)=>{
            const mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (this.eventCount == 0) return this;
        return new $c0b0e53fdcf32530$export$aecb2ddcb55c95be(this.items.append(array.map((map)=>new $c0b0e53fdcf32530$var$Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount) return this;
        const rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        const mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach((item)=>{
            if (item.selection) eventCount--;
        }, start);
        let iRebased = rebasedCount;
        this.items.forEach((item)=>{
            const pos = mapping.getMirror(--iRebased);
            // To match existing behaviour of prosemirror-history
            // eslint-disable-next-line eqeqeq
            if (pos == null) return;
            newUntil = Math.min(newUntil, pos);
            const map = mapping.maps[pos];
            if (item.step) {
                const step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                const selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection) eventCount++;
                rebasedItems.push(new $c0b0e53fdcf32530$var$Item(map, step, selection));
            } else rebasedItems.push(new $c0b0e53fdcf32530$var$Item(map));
        }, start);
        const newMaps = [];
        for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $c0b0e53fdcf32530$var$Item(mapping.maps[i]));
        const items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new $c0b0e53fdcf32530$export$aecb2ddcb55c95be(items, eventCount);
        if (branch.emptyItemCount() > $c0b0e53fdcf32530$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach((item)=>{
            if (!item.step) count++;
        });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        const remap = this.remapping(0, upto);
        let mapFrom = remap.maps.length;
        const items = [];
        let events = 0;
        this.items.forEach((item, i)=>{
            if (i >= upto) {
                items.push(item);
                if (item.selection) events++;
            } else if (item.step) {
                const step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
                if (step) {
                    const selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection) events++;
                    // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const newItem = new $c0b0e53fdcf32530$var$Item(map.invert(), step, selection);
                    let merged;
                    const last = items.length - 1;
                    // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line no-cond-assign
                    if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                    else items.push(newItem);
                }
            } else if (item.map) mapFrom--;
        }, this.items.length, 0);
        return new $c0b0e53fdcf32530$export$aecb2ddcb55c95be((0, $bab964f0db6aa999$export$2e2bcd8739ae039).from(items.reverse()), events);
    }
    constructor(items, eventCount){
        this.items = items;
        this.eventCount = eventCount;
    }
}
$c0b0e53fdcf32530$var$_Branch = $c0b0e53fdcf32530$export$aecb2ddcb55c95be;
$c0b0e53fdcf32530$export$aecb2ddcb55c95be.empty = new $c0b0e53fdcf32530$var$_Branch((0, $bab964f0db6aa999$export$2e2bcd8739ae039).empty, 0);
function $c0b0e53fdcf32530$var$cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i)=>{
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (item.selection && n-- == 0) {
            cutPoint = i;
            return false;
        }
    });
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return items.slice(cutPoint);
}
class $c0b0e53fdcf32530$var$Item {
    merge(other) {
        if (this.step && other.step && !other.selection) {
            const step = other.step.merge(this.step);
            if (step) return new $c0b0e53fdcf32530$var$Item(step.getMap().invert(), step, this.selection);
        }
    }
    constructor(// The (forward) step map for this item.
    map, // The inverted step
    step, // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset){
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
}



var $7PWH7 = parcelRequire("7PWH7");


var $iIsKs = parcelRequire("iIsKs");


var $7hXFI = parcelRequire("7hXFI");


var $8mvho = parcelRequire("8mvho");


var $1Iyfh = parcelRequire("1Iyfh");




function $ae51887f9b644273$export$6137dcc98f08e76(steps, finalDoc) {
    for (const step of steps.slice().reverse())try {
        const result = step.inverted.apply(finalDoc);
        if (result.failed === null && result.doc) finalDoc = result.doc;
    } catch (e) {
    //TODO: EDITOR-2471 - Log the error
    }
    let tr = new (0, $eOaGc.Transform)(finalDoc);
    for (const step of steps)try {
        tr = tr.step(step.step);
    } catch (e) {
    //TODO: EDITOR-2471 - Log the error
    }
    return tr;
}



var $aH8vj = parcelRequire("aH8vj");


var $ab7NC = parcelRequire("ab7NC");


var $l8S1J = parcelRequire("l8S1J");

function $c94e46aa0e536d96$export$55abd4691b317664(config = {}) {
    config = {
        depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500
    };
    return new (0, $kCECX.Plugin)({
        key: (0, $iIsKs.historyKey),
        state: {
            init () {
                return new (0, $7hXFI.HistoryState)((0, $c0b0e53fdcf32530$export$aecb2ddcb55c95be).empty, (0, $c0b0e53fdcf32530$export$aecb2ddcb55c95be).empty, null, 0, -1);
            },
            apply (tr, hist, state) {
                return $c94e46aa0e536d96$var$applyTransaction(hist, state, tr, config);
            }
        },
        config: config,
        props: {
            handleDOMEvents: {
                beforeinput (view, e) {
                    const inputType = e.inputType;
                    const command = // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line eqeqeq
                    inputType == 'historyUndo' ? (0, $1Iyfh.undo) : inputType == 'historyRedo' ? (0, $8mvho.redo) : null;
                    if (!command || !view.editable) return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
// Record a transformation in undo history.
function $c94e46aa0e536d96$var$applyTransaction(history, state, tr, options) {
    const historyTr = tr.getMeta((0, $iIsKs.historyKey));
    let rebased;
    if (historyTr) return historyTr.historyState;
    /**
	 * ===
	 * FORK ADDITION START
	 * If history slicing is active, we want to continue the current slice
	 */ if ((tr.getMeta('startHistorySlice') === true || history?.historySliceActive) && tr.getMeta('endHistorySlice') !== true) {
        const shouldIgnoreChange = tr.getMeta('isRemote');
        if (shouldIgnoreChange) {
            // For addToHistory=false transactions during a slice, we need to:
            // 1. Update the mapping for done/undone branches
            // 2. Map the existing steps
            // 3. Update the document to rebaseline
            const mappedRanges = history.prevRanges ? $c94e46aa0e536d96$var$mapRanges(history.prevRanges, tr.mapping) : null;
            return new (0, $7hXFI.HistoryState)(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), mappedRanges, history.prevTime, history.prevComposition, true, (0, $ab7NC.mapInvertableSteps)(history.trackedSteps, tr), history.selectionBookmark);
        }
        const startHistorySlice = tr.getMeta('startHistorySlice') === true;
        const newTrackedSteps = [
            ...history.trackedSteps || [],
            ...tr.steps.map((s, idx)=>new (0, $aH8vj.InvertableStep)(s, s.invert(tr.docs[idx])))
        ];
        const mappedRanges = history.prevRanges ? $c94e46aa0e536d96$var$mapRanges(history.prevRanges, tr.mapping) : null;
        return new (0, $7hXFI.HistoryState)(history.done, startHistorySlice ? (0, $c0b0e53fdcf32530$export$aecb2ddcb55c95be).empty : history.undone, mappedRanges, history.prevTime, history.prevComposition, true, newTrackedSteps, startHistorySlice ? state.selection.getBookmark() : history.selectionBookmark);
    } else if (tr.getMeta('endHistorySlice') === true && history.historySliceActive) {
        const trackedSteps = history.historySliceActive ? history.trackedSteps || [] : [];
        // Create transform that represents the changes made during the slice
        // Use the original slice document as the base
        const transform = (0, $ae51887f9b644273$export$6137dcc98f08e76)(trackedSteps, tr.doc);
        const mappedRanges = history.prevRanges ? $c94e46aa0e536d96$var$mapRanges(history.prevRanges, tr.mapping) : null;
        return new (0, $7hXFI.HistoryState)(history.done.addMaps(tr.mapping.maps).addTransform(transform, history.selectionBookmark, options, (0, $l8S1J.mustPreserveItems)(state)), history.undone.addMaps(tr.mapping.maps), mappedRanges, history.prevTime, history.prevComposition);
    }
    /**
	 * FORK ADDITION END
	 * ===
	 */ if (tr.getMeta((0, $7PWH7.closeHistoryKey))) history = new (0, $7hXFI.HistoryState)(history.done, history.undone, null, 0, -1);
    const appended = tr.getMeta('appendedTransaction');
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    if (tr.steps.length == 0) return history;
    else if (appended && appended.getMeta((0, $iIsKs.historyKey))) {
        if (appended.getMeta((0, $iIsKs.historyKey)).redo) return new (0, $7hXFI.HistoryState)(history.done.addTransform(tr, undefined, options, (0, $l8S1J.mustPreserveItems)(state)), history.undone, $c94e46aa0e536d96$var$rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else return new (0, $7hXFI.HistoryState)(history.done, history.undone.addTransform(tr, undefined, options, (0, $l8S1J.mustPreserveItems)(state)), null, history.prevTime, history.prevComposition);
    } else if (tr.getMeta('addToHistory') !== false && !(appended && appended.getMeta('addToHistory') === false)) {
        // Group transforms that occur in quick succession into one event.
        const composition = tr.getMeta('composition');
        const newGroup = // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        history.prevTime == 0 || !appended && // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        !$c94e46aa0e536d96$var$isAdjacentTo(tr, history.prevRanges));
        const prevRanges = appended ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $c94e46aa0e536d96$var$mapRanges(history.prevRanges, tr.mapping) : $c94e46aa0e536d96$var$rangesFor(tr.mapping.maps);
        return new (0, $7hXFI.HistoryState)(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, (0, $l8S1J.mustPreserveItems)(state)), (0, $c0b0e53fdcf32530$export$aecb2ddcb55c95be).empty, prevRanges, tr.time, // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        composition == null ? history.prevComposition : composition);
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line no-cond-assign
    } else if (rebased = tr.getMeta('rebased')) // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new (0, $7hXFI.HistoryState)(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $c94e46aa0e536d96$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    else return new (0, $7hXFI.HistoryState)(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $c94e46aa0e536d96$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
}
function $c94e46aa0e536d96$var$isAdjacentTo(transform, prevRanges) {
    if (!prevRanges) return false;
    if (!transform.docChanged) return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end)=>{
        for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
    });
    return adjacent;
}
function $c94e46aa0e536d96$var$rangesFor(maps) {
    const result = [];
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    for(let i = maps.length - 1; i >= 0 && result.length == 0; i--)maps[i].forEach((_from, _to, from, to)=>result.push(from, to));
    return result;
}
function $c94e46aa0e536d96$var$mapRanges(ranges, mapping) {
    if (!ranges) return null;
    const result = [];
    for(let i = 0; i < ranges.length; i += 2){
        const from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to) result.push(from, to);
    }
    return result;
}
module.exports["history"] = $c94e46aa0e536d96$export$55abd4691b317664;

});

parcelRegister("7PWH7", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $a5fae3af47cd1add$export$88d5c5940bb51262 = new (0, $kCECX.PluginKey)('closeHistory');
module.exports["closeHistoryKey"] = $a5fae3af47cd1add$export$88d5c5940bb51262;

});

parcelRegister("iIsKs", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $8ed2f84c279a6ca6$export$7f87c7786a9ef8f7 = new (0, $kCECX.PluginKey)('history');
module.exports["historyKey"] = $8ed2f84c279a6ca6$export$7f87c7786a9ef8f7;

});

parcelRegister("7hXFI", function(module, exports) {
class $e2998ffb77c2518d$export$95c891a1f5736881 {
    constructor(done, undone, prevRanges, prevTime, prevComposition, /**
   * ===
   * FORK ADDITION START
   * Allow for "history slicing" which groups together changes regardless of time / position adjacency
   */ historySliceActive, trackedSteps, selectionBookmark){
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
        this.historySliceActive = historySliceActive;
        this.trackedSteps = trackedSteps;
        this.selectionBookmark = selectionBookmark;
    }
}
module.exports["HistoryState"] = $e2998ffb77c2518d$export$95c891a1f5736881;

});

parcelRegister("8mvho", function(module, exports) {

var $8p30m = parcelRequire("8p30m");

const $c3b464cf7bf478f3$export$1688e416fee0a49e = (0, $8p30m.buildCommand)(true, true);
module.exports["redo"] = $c3b464cf7bf478f3$export$1688e416fee0a49e;

});

parcelRegister("1Iyfh", function(module, exports) {

var $8p30m = parcelRequire("8p30m");

const $8e34405ad4ddacab$export$21f930c44940fd98 = (0, $8p30m.buildCommand)(false, true);
module.exports["undo"] = $8e34405ad4ddacab$export$21f930c44940fd98;

});

parcelRegister("eaCAt", function(module, exports) {

var $krYZG = parcelRequire("krYZG");

const $bb50a7354614697d$export$7f3c24765adf61f0 = (type)=>{
    return {
        action: (0, $krYZG.ACTION).CLICKED,
        actionSubject: type === (0, $krYZG.ACTION_SUBJECT_ID).HYPERLINK ? (0, $krYZG.ACTION_SUBJECT).HYPERLINK : (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDIT_LINK,
        attributes: type !== (0, $krYZG.ACTION_SUBJECT_ID).HYPERLINK ? {
            // @ts-ignore
            display: type
        } : {},
        eventType: (0, $krYZG.EVENT_TYPE).UI
    };
};
const $bb50a7354614697d$var$mapLinkTypeToCardAppearance = (type)=>{
    switch(type){
        case (0, $krYZG.ACTION_SUBJECT_ID).CARD_INLINE:
            return 'inline';
        case (0, $krYZG.ACTION_SUBJECT_ID).CARD_BLOCK:
            return 'block';
        case (0, $krYZG.ACTION_SUBJECT_ID).EMBEDS:
            return 'embed';
        default:
            return 'url';
    }
};
const $bb50a7354614697d$export$e81ec2390acfc152 = (type)=>{
    return type === (0, $krYZG.ACTION_SUBJECT_ID).HYPERLINK ? $bb50a7354614697d$var$buildVisitedHyperLinkPayload() : $bb50a7354614697d$export$4c5e2a0406e7eae8(type, (0, $krYZG.INPUT_METHOD).TOOLBAR);
};
const $bb50a7354614697d$var$buildVisitedHyperLinkPayload = ()=>{
    return {
        action: (0, $krYZG.ACTION).VISITED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).HYPERLINK,
        actionSubjectId: undefined,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    };
};
const $bb50a7354614697d$export$4c5e2a0406e7eae8 = (type, inputMethod, resolvedAttributes)=>{
    return {
        action: (0, $krYZG.ACTION).VISITED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type,
        attributes: {
            inputMethod: inputMethod,
            ...resolvedAttributes && {
                displayCategory: resolvedAttributes.displayCategory,
                extensionKey: resolvedAttributes.extensionKey,
                status: resolvedAttributes.status,
                statusDetails: resolvedAttributes.statusDetails
            }
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    };
};
const $bb50a7354614697d$export$96aa8ae974c8591a = (type)=>{
    return {
        action: (0, $krYZG.ACTION).CLICKED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).GOTO_SMART_LINK_SETTINGS,
        attributes: {
            // @ts-ignore
            inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR,
            display: $bb50a7354614697d$var$mapLinkTypeToCardAppearance(type)
        },
        eventType: (0, $krYZG.EVENT_TYPE).UI
    };
};
const $bb50a7354614697d$export$aab75a08bdd88be4 = (type)=>{
    return {
        action: (0, $krYZG.ACTION).UNLINK,
        actionSubject: type === (0, $krYZG.ACTION_SUBJECT_ID).HYPERLINK ? (0, $krYZG.ACTION_SUBJECT).HYPERLINK : (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type === (0, $krYZG.ACTION_SUBJECT_ID).HYPERLINK ? undefined : type,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    };
};
module.exports["buildEditLinkPayload"] = $bb50a7354614697d$export$7f3c24765adf61f0;
module.exports["buildVisitedLinkPayload"] = $bb50a7354614697d$export$e81ec2390acfc152;
module.exports["buildVisitedNonHyperLinkPayload"] = $bb50a7354614697d$export$4c5e2a0406e7eae8;
module.exports["buildOpenedSettingsPayload"] = $bb50a7354614697d$export$96aa8ae974c8591a;
module.exports["unlinkPayload"] = $bb50a7354614697d$export$aab75a08bdd88be4;

});

parcelRegister("bI2nS", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $5a5160a39ce76bb6$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    url: {
        id: "fabric.editor.url",
        defaultMessage: "Display URL"
    },
    block: {
        id: "fabric.editor.displayBlock",
        defaultMessage: "Display card"
    },
    inline: {
        id: "fabric.editor.displayInline",
        defaultMessage: "Display inline"
    },
    embed: {
        id: "fabric.editor.displayEmbed",
        defaultMessage: "Display embed"
    },
    link: {
        id: "fabric.editor.displayLink",
        defaultMessage: "Display as text"
    },
    card: {
        id: "fabric.editor.cardFloatingControls",
        defaultMessage: "Card options"
    },
    blockCardUnavailable: {
        id: "fabric.editor.blockCardUnavailable",
        defaultMessage: "The inline link is inside {node} and cannot have its view changed"
    },
    displayOptionUnavailableInParentNode: {
        id: "fabric.editor.displayOptionUnavailableInParentNode",
        defaultMessage: "This display option isn't available inside {node}"
    },
    urlTitle: {
        id: "fabric.editor.urlTitle",
        defaultMessage: "URL"
    },
    blockTitle: {
        id: "fabric.editor.blockTitle",
        defaultMessage: "Card"
    },
    inlineTitle: {
        id: "fabric.editor.inlineTitle",
        defaultMessage: "Inline"
    },
    openButtonTitle: {
        id: "fabric.editor.openButtonTitle",
        defaultMessage: "Open"
    },
    panelButtonTitle: {
        id: "fabric.editor.panelButtonTitle",
        defaultMessage: "Panel"
    },
    previewButtonTitle: {
        id: "fabric.editor.previewButtonTitle",
        defaultMessage: "Preview"
    },
    embedTitle: {
        id: "fabric.editor.embedTitle",
        defaultMessage: "Embed"
    },
    urlDescription: {
        id: "fabric.editor.urlDescription",
        defaultMessage: "Display link as URL"
    },
    blockDescription: {
        id: "fabric.editor.blockDescription",
        defaultMessage: "Display more information about a link, including a summary and actions"
    },
    inlineDescription: {
        id: "fabric.editor.inlineDescription",
        defaultMessage: "Display link as inline text"
    },
    embedDescription: {
        id: "fabric.editor.ecombedDescription",
        defaultMessage: "Display an interactive preview of a link"
    },
    embedToBlockCardWarning: {
        id: "fabric.editor.embedToBlockCardWarning",
        defaultMessage: "Displays as a card on small screens"
    },
    editDropdownExpandIconLabel: {
        id: "fabric.editor.editDropdownExpandIconLabel",
        defaultMessage: "Expand dropdown menu"
    },
    editDropdownTriggerTitle: {
        id: "fabric.editor.editDropdownTriggerTitle",
        defaultMessage: "Edit"
    },
    editDropdownEditLinkTitle: {
        id: "fabric.editor.editDropdownEditLinkTitle",
        defaultMessage: "Edit link"
    },
    editDropdownEditDatasourceTitle: {
        id: "fabric.editor.editDropdownEditDatasourceTitle",
        defaultMessage: "Edit search query"
    },
    datasourceTitle: {
        id: "fabric.editor.datasourceTitle",
        defaultMessage: "Edit search query"
    },
    datasourceAppearanceTitle: {
        id: "fabric.editor.datasourceAppearanceTitle",
        defaultMessage: "List"
    },
    datasourceJiraIssue: {
        id: "fabric.editor.datasource.jiraIssue",
        defaultMessage: "Jira Issues"
    },
    datasourceJiraIssueDescription: {
        id: "fabric.editor.datasource.jiraIssue.description",
        defaultMessage: "Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration."
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: "fabric.editor.datasource.assetsObjectsGeneralAvailability",
        defaultMessage: "Assets"
    },
    datasourceAssetsObjectsDescription: {
        id: "fabric.editor.datasource.assetsObjects.description",
        defaultMessage: "Insert objects from Assets in Jira Service Management with search and filtering"
    },
    inlineOverlay: {
        id: "fabric.editor.inlineOverlay",
        defaultMessage: "Configure"
    },
    inlineConfigureLink: {
        id: "fabric.editor.inlineConfigureLink",
        defaultMessage: "Configure link"
    },
    inlineGoToLink: {
        id: "fabric.editor.inlineGoToLink",
        defaultMessage: "Go to link"
    },
    datasourceConfluenceSearch: {
        id: "fabric.editor.datasource.confluenceSearch",
        defaultMessage: "Insert Confluence list"
    },
    datasourceConfluenceSearchDescription: {
        id: "fabric.editor.datasource.confluenceSearch.description",
        defaultMessage: "Insert list of search results from Confluence with enhanced search, filtering, and configuration."
    },
    datasourceJiraIssueIssueTermRefresh: {
        id: "fabric.editor.datasource.jiraIssue.issue-term-refresh",
        defaultMessage: "Jira Work Items"
    },
    datasourceJiraIssueDescriptionIssueTermRefresh: {
        id: "fabric.editor.datasource.jiraIssue.description.issue-term-refresh",
        defaultMessage: "Insert Jira work items from Jira Cloud with enhanced search, filtering, and configuration."
    }
});
module.exports["messages"] = $5a5160a39ce76bb6$export$defe85febe8b728c;

});

parcelRegister("gckmL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $c8e7a7c78a311192$export$9b0f795b2e33f057 = (Wrapped)=>{
    class WithImageLoader extends (0, $cozmU.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $8aG6j.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                imageStatus: 'loading'
            };
            this.img = void 0;
            this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            };
            this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    }
    return WithImageLoader;
};
module.exports["withImageLoader"] = $c8e7a7c78a311192$export$9b0f795b2e33f057;

});

parcelRegister("cRgxl", function(module, exports) {
const $df1780c2a2b419f3$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
module.exports["isResolvingMentionProvider"] = $df1780c2a2b419f3$export$ae1fce5f69858ef3;

});

parcelRegister("bZDJe", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $h78iU = parcelRequire("h78iU");


var $l1ngX = parcelRequire("l1ngX");


var $4OhxS = parcelRequire("4OhxS");


var $bwJyA = parcelRequire("bwJyA");

function $f5daf5c59cbcb330$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f5daf5c59cbcb330$export$5455406531e3792c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    handleArrowLeft: ()=>{},
    handleArrowRight: ()=>{},
    handleTab: ()=>{}
});
const $f5daf5c59cbcb330$var$centeredToolbarContainer = {
    name: "1iikq5b",
    styles: "display:flex;width:100%;align-items:center"
};
const $f5daf5c59cbcb330$export$9837e395eba6f527 = ({ children: children, editorView: editorView, childComponentSelector: childComponentSelector, handleEscape: handleEscape, disableArrowKeyNavigation: disableArrowKeyNavigation, isShortcutToFocusToolbar: isShortcutToFocusToolbar, editorAppearance: editorAppearance, useStickyToolbar: useStickyToolbar, intl: intl })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    const selectedItemIndex = (0, $cozmU.useRef)(0);
    const incrementIndex = (0, $cozmU.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (index + 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const decrementIndex = (0, $cozmU.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (list.length + index - 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const handleArrowRightMemoized = (0, $cozmU.useCallback)(()=>{
        const filteredFocusableElements = $f5daf5c59cbcb330$var$getFilteredFocusableElements(wrapperRef?.current);
        incrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, [
        incrementIndex
    ]);
    const handleArrowLeftMemoized = (0, $cozmU.useCallback)(()=>{
        const filteredFocusableElements = $f5daf5c59cbcb330$var$getFilteredFocusableElements(wrapperRef?.current);
        decrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, [
        decrementIndex
    ]);
    const handleTabMemoized = (0, $cozmU.useCallback)(()=>{
        const filteredFocusableElements = $f5daf5c59cbcb330$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, []);
    const handleTabLocal = ()=>{
        const filteredFocusableElements = $f5daf5c59cbcb330$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements.forEach((element)=>{
            element.setAttribute('tabindex', '-1');
        });
        filteredFocusableElements[selectedItemIndex.current].setAttribute('tabindex', '0');
    };
    const focusAndScrollToElement = (element, scrollToElement = true)=>{
        if (scrollToElement) element?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        element.focus();
    };
    const submenuKeydownHandleContext = (0, $cozmU.useMemo)(()=>({
            handleArrowLeft: handleArrowLeftMemoized,
            handleArrowRight: handleArrowRightMemoized,
            handleTab: handleTabMemoized
        }), [
        handleArrowLeftMemoized,
        handleArrowRightMemoized,
        handleTabMemoized
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!wrapperRef.current || disableArrowKeyNavigation) return;
        const { current: element } = wrapperRef;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            // To trap the focus inside the horizontal toolbar for left and right arrow keys
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if (targetElement instanceof HTMLElement && document.querySelector('[data-role="droplistContent"], [data-test-id="color-picker-menu"], [data-emoji-picker-container="true"]')?.contains(targetElement) || targetElement instanceof HTMLElement && document.querySelector('[data-test-id="color-picker-menu"]')?.contains(targetElement) || targetElement instanceof HTMLElement && targetElement.closest('[data-keyboard-navigation-independent]') || event.key === 'ArrowUp' || event.key === 'ArrowDown' || disableArrowKeyNavigation) return;
            const menuWrapper = document.querySelector('.menu-key-handler-wrapper');
            if (menuWrapper) // if menu wrapper exists, then a menu is open and arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const elementBrowser = wrapperRef?.current?.querySelector(`#${(0, $h78iU.ELEMENT_BROWSER_ID)}`);
            if (elementBrowser) // if element browser is open, then arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const filteredFocusableElements = $f5daf5c59cbcb330$var$getFilteredFocusableElements(wrapperRef?.current);
            if (!filteredFocusableElements || filteredFocusableElements?.length === 0) return;
            // If the target element is the media picker then navigation is handled by the media picker
            if (targetElement instanceof HTMLElement && targetElement.closest(`[aria-label="${intl.formatMessage((0, $4OhxS.mediaInsertMessages).mediaPickerPopupAriaLabel)}"]`)) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) selectedItemIndex.current = -1;
            else selectedItemIndex.current = targetElement instanceof HTMLElement && filteredFocusableElements.indexOf(targetElement) > -1 ? filteredFocusableElements.indexOf(targetElement) : selectedItemIndex.current;
            // do not scroll to focused element for sticky toolbar when navigating with arrows to avoid unnesessary scroll jump
            const allowScrollToElement = !(editorAppearance === 'comment' && !!useStickyToolbar);
            switch(event.key){
                case 'ArrowRight':
                    incrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'Tab':
                    handleTabLocal();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleEscape(event);
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            // To focus the first element in the toolbar
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (isShortcutToFocusToolbar(event)) {
                const filteredFocusableElements = $f5daf5c59cbcb330$var$getFilteredFocusableElements(wrapperRef?.current);
                filteredFocusableElements[0]?.focus();
                // Button component from DS removes focus ring when :focus:not(:focus-visible) is true
                // Since here we programmatically focus the first button in the toolbar (as suppose to keyboard navigation), browser does not always force focus-visible to true
                // which is why the first button in the toolbar is not shown with focus ring
                // The workaround is add a new classname so we add back focus ring when the button is focused
                if (filteredFocusableElements[0]?.tagName === 'BUTTON') filteredFocusableElements[0].classList.add('first-floating-toolbar-button');
                filteredFocusableElements[0]?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        const editorViewDom = editorView?.dom;
        if (isShortcutToFocusToolbar) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            if (isShortcutToFocusToolbar) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        selectedItemIndex,
        wrapperRef,
        editorView,
        disableArrowKeyNavigation,
        handleEscape,
        childComponentSelector,
        incrementIndex,
        decrementIndex,
        isShortcutToFocusToolbar,
        editorAppearance,
        useStickyToolbar,
        intl
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: editorAppearance === 'comment' && $f5daf5c59cbcb330$var$centeredToolbarContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": intl.formatMessage((0, $l1ngX.messages).toolbarLabel),
        "aria-controls": (0, $bwJyA.EDIT_AREA_ID)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($f5daf5c59cbcb330$export$5455406531e3792c.Provider, {
        value: submenuKeydownHandleContext
    }, children));
};
function $f5daf5c59cbcb330$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"], div[tabindex="0"]') || [];
    return Array.from(focusableModalElements);
}
function $f5daf5c59cbcb330$var$isElementOrAncestorHiddenOrDisabled(element, rootNode) {
    let currentElement = element;
    while(currentElement && currentElement !== rootNode && currentElement !== document.body){
        const style = window.getComputedStyle(currentElement);
        // Check if current element is hidden
        if (style.visibility === 'hidden' || style.display === 'none') return true;
        // Check if current element is disabled
        if (currentElement.hasAttribute('disabled') || currentElement.getAttribute('aria-disabled') === 'true' || currentElement.disabled === true) return true;
        // Move to parent element
        currentElement = currentElement.parentElement;
    }
    return false;
}
function $f5daf5c59cbcb330$var$getFilteredFocusableElements(rootNode) {
    // Independent containers and child popups own their key handling and tab stops.
    return $f5daf5c59cbcb330$var$getFocusableElements(rootNode).filter((elm)=>{
        // Check if element or any ancestor is hidden or disabled
        const isHiddenOrDisabled = $f5daf5c59cbcb330$var$isElementOrAncestorHiddenOrDisabled(elm, rootNode);
        return !elm.closest('[data-role="droplistContent"]') && !elm.closest('[data-emoji-picker-container="true"]') && !elm.closest('[data-test-id="color-picker-menu"]') && !elm.closest('[data-keyboard-navigation-independent]') && !elm.closest('.scroll-buttons') && !isHiddenOrDisabled;
    });
}
module.exports["KeyDownHandlerContext"] = $f5daf5c59cbcb330$export$5455406531e3792c;
module.exports["ToolbarArrowKeyNavigationProvider"] = $f5daf5c59cbcb330$export$9837e395eba6f527;

});

parcelRegister("h78iU", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $9906ee11b4f23c9a$export$bc90872e265d166e = 8;
const $9906ee11b4f23c9a$export$1f1798e92fa75806 = {
    small: $9906ee11b4f23c9a$export$bc90872e265d166e * 40,
    medium: $9906ee11b4f23c9a$export$bc90872e265d166e * 75,
    large: $9906ee11b4f23c9a$export$bc90872e265d166e * 128
};
const $9906ee11b4f23c9a$export$69bde1b03e8b5224 = {
    small: $9906ee11b4f23c9a$export$bc90872e265d166e * 50,
    medium: $9906ee11b4f23c9a$export$1f1798e92fa75806.medium,
    large: $9906ee11b4f23c9a$export$1f1798e92fa75806.large
};
const $9906ee11b4f23c9a$export$780035d9fe48eb32 = `${$9906ee11b4f23c9a$export$bc90872e265d166e * 25}px`;
const $9906ee11b4f23c9a$export$95b62a1773aa5ebe = `${$9906ee11b4f23c9a$export$bc90872e265d166e * 6}px`;
const $9906ee11b4f23c9a$export$387950d54d372827 = '12px';
const $9906ee11b4f23c9a$export$51a2d6b2c009fbfd = '54px';
const $9906ee11b4f23c9a$export$df8bcac60101d466 = '20px';
const $9906ee11b4f23c9a$export$9a6bb2acef5e644a = 15;
const $9906ee11b4f23c9a$export$3b8e93b2c0f295b0 = 2;
const $9906ee11b4f23c9a$export$6d221f35db1b75aa = 60;
const $9906ee11b4f23c9a$export$ab53450bc5fd5b7d = 10;
const $9906ee11b4f23c9a$export$6ee360fa4b93ee8e = 'editor-element-browser';
const $9906ee11b4f23c9a$export$f5c254b5428bf7c6 = 'editor-element-browser-list';
module.exports["GRID_SIZE"] = $9906ee11b4f23c9a$export$bc90872e265d166e;
module.exports["DEVICE_BREAKPOINT_NUMBERS"] = $9906ee11b4f23c9a$export$1f1798e92fa75806;
module.exports["FLEX_ITEMS_CONTAINER_BREAKPOINT_NUMBERS"] = $9906ee11b4f23c9a$export$69bde1b03e8b5224;
module.exports["SIDEBAR_WIDTH"] = $9906ee11b4f23c9a$export$780035d9fe48eb32;
module.exports["SIDEBAR_HEADING_WRAPPER_HEIGHT"] = $9906ee11b4f23c9a$export$95b62a1773aa5ebe;
module.exports["INLINE_SIDEBAR_HEIGHT"] = $9906ee11b4f23c9a$export$51a2d6b2c009fbfd;
module.exports["SEARCH_ITEM_HEIGHT_WIDTH"] = $9906ee11b4f23c9a$export$df8bcac60101d466;
module.exports["SCROLLBAR_WIDTH"] = $9906ee11b4f23c9a$export$9a6bb2acef5e644a;
module.exports["ELEMENT_LIST_PADDING"] = $9906ee11b4f23c9a$export$3b8e93b2c0f295b0;
module.exports["ELEMENT_ITEM_HEIGHT"] = $9906ee11b4f23c9a$export$6d221f35db1b75aa;
module.exports["ELEMENT_ITEM_PADDING"] = $9906ee11b4f23c9a$export$ab53450bc5fd5b7d;
module.exports["ELEMENT_BROWSER_ID"] = $9906ee11b4f23c9a$export$6ee360fa4b93ee8e;
module.exports["ELEMENT_BROWSER_LIST_ID"] = $9906ee11b4f23c9a$export$f5c254b5428bf7c6;

});

parcelRegister("l1ngX", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f4a8ace593f1c6ff$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    toolbarLabel: {
        id: "fabric.editor.toolbarLabel",
        defaultMessage: "Editor"
    },
    pageActionsLabel: {
        id: "fabric.editor.pageActionsLabel",
        defaultMessage: "Page actions"
    },
    editableContentLabel: {
        id: "fabric.editor.editableContentLabel",
        defaultMessage: "Editable content"
    }
});
module.exports["messages"] = $f4a8ace593f1c6ff$export$defe85febe8b728c;

});

parcelRegister("4OhxS", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4b9acf304760535e$export$7eb9dc59242bbc45 = (0, $kSwu1.defineMessages)({
    loadPreview: {
        id: "fabric.editor.media.insert.loadPreview",
        defaultMessage: "Load preview"
    },
    insert: {
        id: "fabric.editor.media.insert.insert",
        defaultMessage: "Insert"
    },
    pasteLinkToUpload: {
        id: "fabric.editor.media.insert.pasteLinkToUpload",
        defaultMessage: "Paste link to upload"
    },
    cancel: {
        id: "fabric.editor.media.insert.cancel",
        defaultMessage: "Cancel"
    },
    fromUrlErrorMessage: {
        id: "fabric.editor.media.insert.fromUrlErrorMessage",
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page."
    },
    fromUrlWarning: {
        id: "fabric.editor.media.insert.fromUrlWarning",
        defaultMessage: "This image might not be visible to others due to source restrictions. Consider uploading the file instead."
    },
    localFileNetworkErrorMessage: {
        id: "fabric.editor.media.insert.localFileNetworkErrorMessage",
        defaultMessage: "File upload error. Check file path or network."
    },
    localFileErrorMessage: {
        id: "fabric.editor.media.insert.localFileErrorMessage",
        defaultMessage: "This file couldn\u2019t be uploaded."
    },
    mediaAlt: {
        id: "fabric.editor.media.insert.mediaAlt",
        defaultMessage: "Preview for uploaded image or video file"
    },
    upload: {
        id: "fabric.editor.media.insert.upload",
        defaultMessage: "Upload"
    },
    linkTabTitle: {
        id: "fabric.editor.media.insert.linkTabTitle",
        defaultMessage: "Link"
    },
    fileTabTitle: {
        id: "fabric.editor.media.insert.fileTabTitle",
        defaultMessage: "File"
    },
    generateTabTitle: {
        id: "fabric.editor.media.insert.generateTabTitle",
        defaultMessage: "Create"
    },
    mediaPickerPopupAriaLabel: {
        id: "fabric.editor.media.insert.mediaPickerPopupAriaLabel",
        defaultMessage: "Media picker"
    },
    invalidUrlErrorMessage: {
        id: "fabric.editor.media.insert.invalidUrlErrorMessage",
        defaultMessage: "Invalid link"
    },
    uploadTabTitle: {
        id: "fabric.editor.media.insert.uploadTabTitle",
        defaultMessage: "Upload"
    },
    chooseFile: {
        id: "fabric.editor.media.insert.chooseFile",
        defaultMessage: "Choose a file"
    }
});
module.exports["mediaInsertMessages"] = $4b9acf304760535e$export$7eb9dc59242bbc45;

});

parcelRegister("bwJyA", function(module, exports) {
const $9a66f99f68ba50c1$export$b16ce0826b76e795 = 'ak-editor-textarea';
module.exports["EDIT_AREA_ID"] = $9a66f99f68ba50c1$export$b16ce0826b76e795;

});

parcelRegister("2iHw5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4ed97f218324b909$var$ReactEditorViewContext = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({});
var $4ed97f218324b909$export$2e2bcd8739ae039 = $4ed97f218324b909$var$ReactEditorViewContext;
module.exports["default"] = $4ed97f218324b909$export$2e2bcd8739ae039;

});

parcelRegister("ldqjS", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ /**
                                                                    * @jsxRuntime classic
                                                                    * @jsx jsx
                                                                    */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $iqS60 = parcelRequire("iqS60");


var $aC6bW = parcelRequire("aC6bW");


var $8dxef = parcelRequire("8dxef");



var $eBSR7 = parcelRequire("eBSR7");

// eslint-disable-next-line require-unicode-regexp
const $5c26c0ab55efcf4e$var$MOD_REGEX = /Mod/i; // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $5c26c0ab55efcf4e$var$CMD_REGEX = /Cmd/i; // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $5c26c0ab55efcf4e$var$SHIFT_REGEX = /Shift/i; // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $5c26c0ab55efcf4e$var$CTRL_REGEX = /Ctrl/i; // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $5c26c0ab55efcf4e$var$ALT_REGEX = /Alt/i; // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $5c26c0ab55efcf4e$var$BACKSPACE_REGEX = /Backspace/i; // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $5c26c0ab55efcf4e$var$ENTER_REGEX = /Enter/i; // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $5c26c0ab55efcf4e$var$UPPERCASE_START_REGEX = /^[A-Z]/;
const $5c26c0ab55efcf4e$export$82527b23b485fa7f = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Add Alt Text', 'Mod-Alt-y');
const $5c26c0ab55efcf4e$export$c515872d50566e7b = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Toggle markdown view', 'Mod-e');
const $5c26c0ab55efcf4e$export$22d712d636967812 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('View changes', 'Mod-Alt-z');
const $5c26c0ab55efcf4e$export$9288bbefb6b7498b = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Navigate to editor toolbar', 'Alt-F9');
const $5c26c0ab55efcf4e$export$7be006a99a30f86b = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Navigate to floating toolbar', 'Alt-F10');
const $5c26c0ab55efcf4e$export$ae37214e128d9cc3 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Ask AI', "Mod-'");
const $5c26c0ab55efcf4e$export$183fe6d20e9e58ba = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Bold', 'Mod-b');
const $5c26c0ab55efcf4e$export$b03177f345903916 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Italic', 'Mod-i');
const $5c26c0ab55efcf4e$export$6bcc93697958b66d = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Underline', 'Mod-u');
const $5c26c0ab55efcf4e$export$6d564ba4eaf138d9 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Strikethrough', 'Mod-Shift-s');
const $5c26c0ab55efcf4e$export$d26ab98fee0c804 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Subscript', 'Mod-Shift-,');
const $5c26c0ab55efcf4e$export$4af6b58e12324fd = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Superscript', 'Mod-Shift-.');
const $5c26c0ab55efcf4e$export$70686c6e7e15ed46 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Code', 'Mod-Shift-m');
const $5c26c0ab55efcf4e$export$ab06dc742bb20e03 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Paste Plain Text', 'Mod-Shift-v');
const $5c26c0ab55efcf4e$export$195de5d8e201efd7 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Clear formatting', 'Mod-\\');
const $5c26c0ab55efcf4e$export$63c4f0859cc75dc6 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Normal text', 'Mod-Alt-0');
const $5c26c0ab55efcf4e$export$953ab0e6a5d310a9 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Heading 1', 'Mod-Alt-1');
const $5c26c0ab55efcf4e$export$192a351cfd6ca247 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Heading 2', 'Mod-Alt-2');
const $5c26c0ab55efcf4e$export$fe382f3f4c871c62 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Heading 3', 'Mod-Alt-3');
const $5c26c0ab55efcf4e$export$4073e08db19e0e31 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Heading 4', 'Mod-Alt-4');
const $5c26c0ab55efcf4e$export$b84e85b2035ddb39 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Heading 5', 'Mod-Alt-5');
const $5c26c0ab55efcf4e$export$86b1ac99fd15509b = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Heading 6', 'Mod-Alt-6');
const $5c26c0ab55efcf4e$export$16f43eb2b2380de5 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Small text', 'Mod-Alt-7');
const $5c26c0ab55efcf4e$export$dca848a1b50b6a31 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Numbered list', 'Mod-Shift-7');
const $5c26c0ab55efcf4e$export$17f69a767ce93bb3 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Cmd + Backspace', 'Mod-Backspace');
const $5c26c0ab55efcf4e$export$c0e115f47553645e = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Bullet list', 'Mod-Shift-8');
const $5c26c0ab55efcf4e$export$34ed0cbd4f7ff88 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Quote', 'Mod-Shift-9');
const $5c26c0ab55efcf4e$export$c2d9390f63354627 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Insert new line', 'Shift-Enter');
const $5c26c0ab55efcf4e$export$dfd73a1c108b1570 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Shift Backspace', 'Shift-Backspace');
const $5c26c0ab55efcf4e$export$9e5a9569a07601f2 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Split code block', 'Enter');
const $5c26c0ab55efcf4e$export$e920ee2eb756d384 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Split list item', 'Enter');
const $5c26c0ab55efcf4e$export$5f13bbad564673d4 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Insert horizontal rule', 'Mod-Shift--');
const $5c26c0ab55efcf4e$export$21f930c44940fd98 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Undo', 'Mod-z');
const $5c26c0ab55efcf4e$export$44935f8a884b57b9 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move up', 'ArrowUp');
const $5c26c0ab55efcf4e$export$8eba228b343b3599 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move down', 'ArrowDown');
const $5c26c0ab55efcf4e$export$108f27160c89e515 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move left', 'ArrowLeft');
const $5c26c0ab55efcf4e$export$e2c874fbfec7201 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move right', 'ArrowRight');
const $5c26c0ab55efcf4e$export$8066a906978eedb2 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Indent List', 'Tab');
const $5c26c0ab55efcf4e$export$959569198ddbbe17 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Outdent List', 'Shift-Tab');
const $5c26c0ab55efcf4e$export$c0e41ad67d77f6bb = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Redo', 'Mod-y');
const $5c26c0ab55efcf4e$export$1688e416fee0a49e = $5c26c0ab55efcf4e$export$d8a7f422d8d42038('Redo', 'Ctrl-y', 'Mod-Shift-z');
const $5c26c0ab55efcf4e$export$1e2fd7795238a2d3 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Open Help', 'Mod-/');
const $5c26c0ab55efcf4e$export$56b88caa6d8a3bff = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Link', 'Mod-k');
const $5c26c0ab55efcf4e$export$fd78ad47ea0892f4 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Annotate', 'Mod-Alt-c');
const $5c26c0ab55efcf4e$export$278533b7b7607665 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Copy link to selection', 'Mod-Alt-a');
const $5c26c0ab55efcf4e$export$853c27de4ce0f746 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Submit Content', 'Mod-Enter');
const $5c26c0ab55efcf4e$export$e668df1bcd81e4d2 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Enter', 'Enter');
const $5c26c0ab55efcf4e$export$9f99fe2ed5bb7a29 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Shift Enter', 'Shift-Enter');
const $5c26c0ab55efcf4e$export$62d58b1c91e8e902 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Tab', 'Tab');
const $5c26c0ab55efcf4e$export$79ebfa808dffa5c6 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Indent', 'Tab');
const $5c26c0ab55efcf4e$export$25755c0352544598 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Outdent', 'Shift-Tab');
const $5c26c0ab55efcf4e$export$1ea584ca7009bcc1 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Backspace', 'Backspace');
const $5c26c0ab55efcf4e$export$9603e93cdf38d7 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Delete', 'Delete');
const $5c26c0ab55efcf4e$export$9e41eded5cb7e706 = $5c26c0ab55efcf4e$export$d8a7f422d8d42038('Forward Delete', '', 'Ctrl-d');
const $5c26c0ab55efcf4e$export$a941ed4b947d12f8 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Space', 'Space');
const $5c26c0ab55efcf4e$export$4e7f196112fea3c5 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Escape', 'Escape');
const $5c26c0ab55efcf4e$export$172699367bb25225 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Next cell', 'Tab');
const $5c26c0ab55efcf4e$export$69838570e03d7193 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Previous cell', 'Shift-Tab');
const $5c26c0ab55efcf4e$export$776c0cd47234205a = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Shift ArrowUp', 'Shift-ArrowUp');
const $5c26c0ab55efcf4e$export$9ad63694f5781e16 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Shift Tab', 'Shift-Tab');
const $5c26c0ab55efcf4e$export$33b9473b3f67763f = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Table', 'Shift-Alt-t');
const $5c26c0ab55efcf4e$export$a57fbe0d9c764ae0 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Focus Table Resizer', 'Mod-Alt-Shift-r');
const $5c26c0ab55efcf4e$export$2e3087448cf87857 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Add Row Above', 'Ctrl-Alt-ArrowUp');
const $5c26c0ab55efcf4e$export$fbcf51cabbe4a007 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Add Row Below', 'Ctrl-Alt-ArrowDown');
const $5c26c0ab55efcf4e$export$bf95f7b7d259c19f = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Add Column After', 'Ctrl-Alt-ArrowRight');
const $5c26c0ab55efcf4e$export$717d5ccb817cdecc = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Add Column Before', 'Ctrl-Alt-ArrowLeft'); // The following few shortcuts that end in VO are added specifically for Voice Over users, as shortcuts that perform the same role when using Voice Over don't work because they conflict with default shortcuts in Voice Over
const $5c26c0ab55efcf4e$export$5851c701392d3bfd = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Add Row Above', 'Mod-Alt-[');
const $5c26c0ab55efcf4e$export$73fa63faf0fd6077 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Add Row Below', 'Mod-Alt-]');
const $5c26c0ab55efcf4e$export$875b853996fced8d = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Add Column After', 'Mod-Alt-=');
const $5c26c0ab55efcf4e$export$414418ca306c22bd = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Add Column Before', 'Mod-Alt--'); // When cleaning up editor-a11y-fy26-keyboard-move-row-column experiment
const $5c26c0ab55efcf4e$export$a055d05df46abae5 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move Column Left', 'Ctrl-Alt-Shift-ArrowLeft');
const $5c26c0ab55efcf4e$export$f092689a35ce978d = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move Column Left', 'Mod-Alt-Shift--');
const $5c26c0ab55efcf4e$export$7ff94d9a4edfc7f = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move Column Right', 'Ctrl-Alt-Shift-ArrowRight');
const $5c26c0ab55efcf4e$export$863ee96d9e15383b = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move Column Right', 'Mod-Alt-Shift-=');
const $5c26c0ab55efcf4e$export$180b7d3240961d01 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move Row Down', 'Ctrl-Alt-Shift-ArrowDown');
const $5c26c0ab55efcf4e$export$13c2dd2d968ada2a = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move Row Down', 'Mod-Alt-Shift-]');
const $5c26c0ab55efcf4e$export$88de3148cc9ddd81 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move Row Up', 'Ctrl-Alt-Shift-ArrowUp');
const $5c26c0ab55efcf4e$export$e6749a6fc243b921 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move Row Up', 'Mod-Alt-Shift-[');
const $5c26c0ab55efcf4e$export$f4f2d7d33085c714 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Delete Column', 'Ctrl-Backspace');
const $5c26c0ab55efcf4e$export$2ef39e5ffdaff9ed = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Delete Row', 'Ctrl-Backspace');
const $5c26c0ab55efcf4e$export$8f58457f1327dd26 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Activate Column Resize', 'Mod-Alt-Shift-c');
const $5c26c0ab55efcf4e$export$af2a99f971a346e6 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Cut', 'Mod-x');
const $5c26c0ab55efcf4e$export$784d13d8ee351f07 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Copy', 'Mod-c');
const $5c26c0ab55efcf4e$export$9b6706c8686cfc8e = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Paste', 'Mod-v');
const $5c26c0ab55efcf4e$export$3c1455b21d3e7aab = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Paste', 'Mod-Shift-v');
const $5c26c0ab55efcf4e$export$71aa6c912b956294 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Find', 'Mod-f');
const $5c26c0ab55efcf4e$export$ca42dd9a1a0eb501 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Align Left', 'Mod-Shift-l');
const $5c26c0ab55efcf4e$export$f4a51ff076cc9a09 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Align Center', 'Mod-Alt-e');
const $5c26c0ab55efcf4e$export$faf8793e4a37a5a2 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Align Right', 'Mod-Alt-t');
const $5c26c0ab55efcf4e$export$6f041e7a1d88fa51 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Toggles task item', 'Mod-Alt-Enter');
const $5c26c0ab55efcf4e$export$2e48e3ea1c210731 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Toggle task list', 'Mod-Shift-6');
const $5c26c0ab55efcf4e$export$e247ed8cec4832f4 = $5c26c0ab55efcf4e$export$5882c1dfa05eb556('Select row', [
    'Mod-Alt-Shift-ArrowLeft',
    'Mod-Alt-Shift-ArrowRight'
]);
const $5c26c0ab55efcf4e$export$c2e8772deb1607ea = $5c26c0ab55efcf4e$export$5882c1dfa05eb556('Select column', [
    'Mod-Alt-Shift-ArrowDown',
    'Mod-Alt-Shift-ArrowUp'
]);
const $5c26c0ab55efcf4e$export$625c5b9bf13f01a8 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Select table', 'Mod-a');
const $5c26c0ab55efcf4e$export$fdeca4160ac263c5 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-]');
const $5c26c0ab55efcf4e$export$5ec5f857fec297eb = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-[');
const $5c26c0ab55efcf4e$export$36141559a83247ee = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Activate controls panel on video', 'Shift-F10');
const $5c26c0ab55efcf4e$export$ec123199f2fe4770 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Toggle Highlight Palette', 'Mod-Alt-b');
const $5c26c0ab55efcf4e$export$62f87f0ca411e518 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Apply Yellow Highlight', 'Mod-Alt-y');
const $5c26c0ab55efcf4e$export$6b05735f625d1c82 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Focus table context menu trigger', 'Shift-F10');
const $5c26c0ab55efcf4e$export$a1bdda43619f945f = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move node up in the document', 'Ctrl-Shift-ArrowUp');
const $5c26c0ab55efcf4e$export$9bf312985dc8137e = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move node down in the document', 'Ctrl-Shift-ArrowDown');
const $5c26c0ab55efcf4e$export$c4f661b85fc92fd1 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move node to the left column in the document', 'Ctrl-Shift-Alt-ArrowLeft');
const $5c26c0ab55efcf4e$export$61c867f4a21787f6 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Move node to the right column in the document', 'Ctrl-Shift-Alt-ArrowRight');
const $5c26c0ab55efcf4e$export$ba34d2a4e6aa10e4 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Show drag handle for editor element', 'Ctrl-Shift-h');
const $5c26c0ab55efcf4e$export$e9c6aab026be9523 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Toggle Code Block', '```');
const $5c26c0ab55efcf4e$export$8d5c072327044b6f = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Insert Emoji', ':');
const $5c26c0ab55efcf4e$export$8c4314a90d4c5fc1 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Insert Mention', '@');
const $5c26c0ab55efcf4e$export$cf3c284f81e5d477 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Insert Action Item', '[]');
const $5c26c0ab55efcf4e$export$edd9d3cec5b0a9b6 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Insert Elements', '/');
const $5c26c0ab55efcf4e$export$54f122e0d55178a9 = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1('Continue in Rovo chat', 'Alt-Enter');
const $5c26c0ab55efcf4e$var$arrowKeysMap = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
const $5c26c0ab55efcf4e$var$tooltipShortcutStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    borderRadius: "var(--ds-radius-xsmall, 2px)",
    backgroundColor: "var(--ds-background-inverse-subtle, #00000029)",
    padding: `0 ${"var(--ds-space-025, 2px)"}`,
    // NOTE: This might not actually do anything: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E
    label: 'tooltip-shortcut'
});
function $5c26c0ab55efcf4e$export$384a290f8c265cc5(keymap) {
    let shortcut;
    const browser = (0, $8dxef.getBrowserInfo)();
    if (browser.mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace($5c26c0ab55efcf4e$var$CMD_REGEX, '\u2318').replace($5c26c0ab55efcf4e$var$SHIFT_REGEX, '\u21E7').replace($5c26c0ab55efcf4e$var$CTRL_REGEX, '\u2303').replace($5c26c0ab55efcf4e$var$ALT_REGEX, '\u2325').replace($5c26c0ab55efcf4e$var$BACKSPACE_REGEX, '\u232B').replace($5c26c0ab55efcf4e$var$ENTER_REGEX, '\u23CE');
    else shortcut = keymap.windows.replace($5c26c0ab55efcf4e$var$BACKSPACE_REGEX, '\u232B');
     // If there are two - keys side by side preserve it's place so we can add it back
    const keys = shortcut.split('-');
    let storedEnDash = false;
    if (keys[keys.length - 1] === '' && keys[keys.length - 2] === '') storedEnDash = true;
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $5c26c0ab55efcf4e$var$arrowKeysMap[lastKey.toUpperCase()] || lastKey;
    if (storedEnDash) keys[keys.length - 1] = '-';
    return keys.join(browser.mac ? '' : '+');
}
function $5c26c0ab55efcf4e$export$4e6f96734dfe12f4(keymap, description) {
    if (keymap) {
        const shortcut = $5c26c0ab55efcf4e$export$384a290f8c265cc5(keymap);
        return description ? `${description} ${shortcut}` : shortcut;
    }
    return;
}
const $5c26c0ab55efcf4e$export$4096cb8ab9668358 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && $5c26c0ab55efcf4e$export$384a290f8c265cc5(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, description, shortcut && description && '\u00A0', shortcut && /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $5c26c0ab55efcf4e$var$tooltipShortcutStyle
    }, shortcut)) : null;
});
const $5c26c0ab55efcf4e$export$9f7e5fe6d45c5f7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ helpDescriptors: helpDescriptors })=>{
    const keymapCount = helpDescriptors.length;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, helpDescriptors.map((descriptor, index)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, $lOiVq.jsx)($5c26c0ab55efcf4e$export$4096cb8ab9668358, descriptor), ' ', index < keymapCount - 1 && /*#__PURE__*/ (0, $lOiVq.jsx)("br", null))));
});
function $5c26c0ab55efcf4e$export$c4e6735ce96cc7b3(description) {
    const matches = $5c26c0ab55efcf4e$var$ALL.filter((keymap)=>keymap.description.toUpperCase() === description.toUpperCase());
    return matches[0];
}
function $5c26c0ab55efcf4e$export$ca66063a345ce3ab(description) {
    const keymap = $5c26c0ab55efcf4e$export$c4e6735ce96cc7b3(description);
    if (keymap) return $5c26c0ab55efcf4e$export$d69faf3b7bc3451(keymap);
    return;
}
function $5c26c0ab55efcf4e$export$d69faf3b7bc3451(keymap) {
    const browser = (0, $8dxef.getBrowserInfo)();
    if (browser.mac) return keymap.mac;
    return keymap.windows;
}
function $5c26c0ab55efcf4e$export$6db28e5c399297b0(keymap) {
    let keyShortcuts;
    const browser = (0, $8dxef.getBrowserInfo)();
    if (typeof keymap === 'string') keyShortcuts = keymap;
    else if (typeof keymap === 'object') keyShortcuts = keymap[browser.mac ? 'mac' : 'windows'];
    if (keyShortcuts) return keyShortcuts.toLowerCase().split('-').filter(Boolean).map((modifier)=>{
        switch(modifier){
            case 'cmd':
                return 'Meta';
            case 'ctrl':
                return 'Control';
            case 'alt':
                return 'Alt';
            case 'shift':
                return 'Shift';
            case 'enter':
                return 'Enter';
            case 'esc':
                return 'Esc';
            case 'tab':
                return 'Tab';
            case 'space':
                return 'Space';
            case 'backspace':
                return 'Backspace';
            case 'arrowup':
                return 'Arrow Up';
            case 'arrowdown':
                return 'Arrow Down';
            default:
                // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                return modifier.split('').join(' ');
        }
    }).join('+');
    else return undefined;
}
const $5c26c0ab55efcf4e$var$ALL = [
    $5c26c0ab55efcf4e$export$dca848a1b50b6a31,
    $5c26c0ab55efcf4e$export$c0e115f47553645e,
    $5c26c0ab55efcf4e$export$183fe6d20e9e58ba,
    $5c26c0ab55efcf4e$export$b03177f345903916,
    $5c26c0ab55efcf4e$export$6bcc93697958b66d,
    $5c26c0ab55efcf4e$export$6d564ba4eaf138d9,
    $5c26c0ab55efcf4e$export$d26ab98fee0c804,
    $5c26c0ab55efcf4e$export$4af6b58e12324fd,
    $5c26c0ab55efcf4e$export$70686c6e7e15ed46,
    $5c26c0ab55efcf4e$export$63c4f0859cc75dc6,
    $5c26c0ab55efcf4e$export$953ab0e6a5d310a9,
    $5c26c0ab55efcf4e$export$192a351cfd6ca247,
    $5c26c0ab55efcf4e$export$fe382f3f4c871c62,
    $5c26c0ab55efcf4e$export$4073e08db19e0e31,
    $5c26c0ab55efcf4e$export$b84e85b2035ddb39,
    $5c26c0ab55efcf4e$export$86b1ac99fd15509b,
    $5c26c0ab55efcf4e$export$16f43eb2b2380de5,
    $5c26c0ab55efcf4e$export$34ed0cbd4f7ff88,
    $5c26c0ab55efcf4e$export$c2d9390f63354627,
    $5c26c0ab55efcf4e$export$5f13bbad564673d4,
    $5c26c0ab55efcf4e$export$9e5a9569a07601f2,
    $5c26c0ab55efcf4e$export$e920ee2eb756d384,
    $5c26c0ab55efcf4e$export$1688e416fee0a49e,
    $5c26c0ab55efcf4e$export$21f930c44940fd98,
    $5c26c0ab55efcf4e$export$71aa6c912b956294,
    $5c26c0ab55efcf4e$export$4e7f196112fea3c5,
    $5c26c0ab55efcf4e$export$e668df1bcd81e4d2,
    $5c26c0ab55efcf4e$export$9f99fe2ed5bb7a29
];
function $5c26c0ab55efcf4e$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace($5c26c0ab55efcf4e$var$MOD_REGEX, 'Ctrl'),
        mac: mac.replace($5c26c0ab55efcf4e$var$MOD_REGEX, 'Cmd'),
        common: common
    };
}
function $5c26c0ab55efcf4e$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace($5c26c0ab55efcf4e$var$MOD_REGEX, 'Ctrl');
    const mac = common.replace($5c26c0ab55efcf4e$var$MOD_REGEX, 'Cmd');
    return $5c26c0ab55efcf4e$export$d8a7f422d8d42038(description, windows, mac, common);
}
function $5c26c0ab55efcf4e$export$5882c1dfa05eb556(description, shortcuts) {
    const keymapArray = [];
    shortcuts.forEach((shortcut)=>{
        keymapArray.push($5c26c0ab55efcf4e$export$7e6b588cc98b34f1(description, shortcut));
    });
    return keymapArray;
}
function $5c26c0ab55efcf4e$var$combineWithOldCommand(cmd, oldCmd) {
    return (state, dispatch, editorView)=>{
        return oldCmd(state, dispatch) || cmd(state, dispatch, editorView);
    };
}
function $5c26c0ab55efcf4e$export$4bced0ac29aaf950(shortcut, cmd, keymap) {
    const oldCmd = keymap[shortcut];
    keymap[shortcut] = oldCmd ? $5c26c0ab55efcf4e$var$combineWithOldCommand(cmd, oldCmd) : cmd;
} // If there is a need to use the same command with several shortcuts
function $5c26c0ab55efcf4e$export$e40cfdbcfa26f180(shortcutsArray, cmd, keymap) {
    shortcutsArray.forEach((shortcut)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $5c26c0ab55efcf4e$export$4bced0ac29aaf950(shortcut.common, cmd, keymap);
    });
}
function $5c26c0ab55efcf4e$export$b87d3e1cb85f0ba1(shortcut, cmd, keymap) {
    $5c26c0ab55efcf4e$export$4bced0ac29aaf950(shortcut, (0, $aC6bW.editorCommandToPMCommand)(cmd), keymap);
}
function $5c26c0ab55efcf4e$export$b2dbe47650bcfa54(keyMap) {
    if (keyMap) {
        const browser = (0, $8dxef.getBrowserInfo)();
        if (browser.mac) return keyMap.mac;
        return keyMap.windows;
    }
    return;
} /**
   * ED-20175: on windows OS if the capsLock is ON then it registers the key with capital case
   * which creates a command (Ctrl-B) and all the keymap bindings are in lower case (Ctrl-b).
   *
   */ 
function $5c26c0ab55efcf4e$export$f2da701c7659a26c(event) {
    let keyboardEvent = event;
    const name = (0, $iqS60.keyName)(event);
    if (event.ctrlKey && event.getModifierState('CapsLock') && !event.getModifierState('Shift') && name.length === 1 && $5c26c0ab55efcf4e$var$UPPERCASE_START_REGEX.test(name)) keyboardEvent = new KeyboardEvent('keydown', {
        key: (0, $iqS60.base)[event.keyCode].toLowerCase(),
        code: event.code,
        ctrlKey: true
    });
    return keyboardEvent;
}
module.exports["addAltText"] = $5c26c0ab55efcf4e$export$82527b23b485fa7f;
module.exports["makeKeyMapWithCommon"] = $5c26c0ab55efcf4e$export$7e6b588cc98b34f1;
module.exports["toggleMarkdownView"] = $5c26c0ab55efcf4e$export$c515872d50566e7b;
module.exports["toggleViewChanges"] = $5c26c0ab55efcf4e$export$22d712d636967812;
module.exports["navToEditorToolbar"] = $5c26c0ab55efcf4e$export$9288bbefb6b7498b;
module.exports["navToFloatingToolbar"] = $5c26c0ab55efcf4e$export$7be006a99a30f86b;
module.exports["askAIQuickInsert"] = $5c26c0ab55efcf4e$export$ae37214e128d9cc3;
module.exports["toggleBold"] = $5c26c0ab55efcf4e$export$183fe6d20e9e58ba;
module.exports["toggleItalic"] = $5c26c0ab55efcf4e$export$b03177f345903916;
module.exports["toggleUnderline"] = $5c26c0ab55efcf4e$export$6bcc93697958b66d;
module.exports["toggleStrikethrough"] = $5c26c0ab55efcf4e$export$6d564ba4eaf138d9;
module.exports["toggleSubscript"] = $5c26c0ab55efcf4e$export$d26ab98fee0c804;
module.exports["toggleSuperscript"] = $5c26c0ab55efcf4e$export$4af6b58e12324fd;
module.exports["toggleCode"] = $5c26c0ab55efcf4e$export$70686c6e7e15ed46;
module.exports["pastePlainText"] = $5c26c0ab55efcf4e$export$ab06dc742bb20e03;
module.exports["clearFormatting"] = $5c26c0ab55efcf4e$export$195de5d8e201efd7;
module.exports["setNormalText"] = $5c26c0ab55efcf4e$export$63c4f0859cc75dc6;
module.exports["toggleHeading1"] = $5c26c0ab55efcf4e$export$953ab0e6a5d310a9;
module.exports["toggleHeading2"] = $5c26c0ab55efcf4e$export$192a351cfd6ca247;
module.exports["toggleHeading3"] = $5c26c0ab55efcf4e$export$fe382f3f4c871c62;
module.exports["toggleHeading4"] = $5c26c0ab55efcf4e$export$4073e08db19e0e31;
module.exports["toggleHeading5"] = $5c26c0ab55efcf4e$export$b84e85b2035ddb39;
module.exports["toggleHeading6"] = $5c26c0ab55efcf4e$export$86b1ac99fd15509b;
module.exports["toggleSmallText"] = $5c26c0ab55efcf4e$export$16f43eb2b2380de5;
module.exports["toggleOrderedList"] = $5c26c0ab55efcf4e$export$dca848a1b50b6a31;
module.exports["toggleBulletList"] = $5c26c0ab55efcf4e$export$c0e115f47553645e;
module.exports["toggleBlockQuote"] = $5c26c0ab55efcf4e$export$34ed0cbd4f7ff88;
module.exports["insertNewLine"] = $5c26c0ab55efcf4e$export$c2d9390f63354627;
module.exports["insertRule"] = $5c26c0ab55efcf4e$export$5f13bbad564673d4;
module.exports["undo"] = $5c26c0ab55efcf4e$export$21f930c44940fd98;
module.exports["moveUp"] = $5c26c0ab55efcf4e$export$44935f8a884b57b9;
module.exports["moveDown"] = $5c26c0ab55efcf4e$export$8eba228b343b3599;
module.exports["moveLeft"] = $5c26c0ab55efcf4e$export$108f27160c89e515;
module.exports["moveRight"] = $5c26c0ab55efcf4e$export$e2c874fbfec7201;
module.exports["indentList"] = $5c26c0ab55efcf4e$export$8066a906978eedb2;
module.exports["outdentList"] = $5c26c0ab55efcf4e$export$959569198ddbbe17;
module.exports["redoAlt"] = $5c26c0ab55efcf4e$export$c0e41ad67d77f6bb;
module.exports["redo"] = $5c26c0ab55efcf4e$export$1688e416fee0a49e;
module.exports["makeKeymap"] = $5c26c0ab55efcf4e$export$d8a7f422d8d42038;
module.exports["openHelp"] = $5c26c0ab55efcf4e$export$1e2fd7795238a2d3;
module.exports["addLink"] = $5c26c0ab55efcf4e$export$56b88caa6d8a3bff;
module.exports["addInlineComment"] = $5c26c0ab55efcf4e$export$fd78ad47ea0892f4;
module.exports["copyLinkToBlock"] = $5c26c0ab55efcf4e$export$278533b7b7607665;
module.exports["submit"] = $5c26c0ab55efcf4e$export$853c27de4ce0f746;
module.exports["enter"] = $5c26c0ab55efcf4e$export$e668df1bcd81e4d2;
module.exports["tab"] = $5c26c0ab55efcf4e$export$62d58b1c91e8e902;
module.exports["indent"] = $5c26c0ab55efcf4e$export$79ebfa808dffa5c6;
module.exports["outdent"] = $5c26c0ab55efcf4e$export$25755c0352544598;
module.exports["backspace"] = $5c26c0ab55efcf4e$export$1ea584ca7009bcc1;
module.exports["deleteKey"] = $5c26c0ab55efcf4e$export$9603e93cdf38d7;
module.exports["forwardDelete"] = $5c26c0ab55efcf4e$export$9e41eded5cb7e706;
module.exports["space"] = $5c26c0ab55efcf4e$export$a941ed4b947d12f8;
module.exports["escape"] = $5c26c0ab55efcf4e$export$4e7f196112fea3c5;
module.exports["nextCell"] = $5c26c0ab55efcf4e$export$172699367bb25225;
module.exports["previousCell"] = $5c26c0ab55efcf4e$export$69838570e03d7193;
module.exports["shiftArrowUp"] = $5c26c0ab55efcf4e$export$776c0cd47234205a;
module.exports["shiftTab"] = $5c26c0ab55efcf4e$export$9ad63694f5781e16;
module.exports["toggleTable"] = $5c26c0ab55efcf4e$export$33b9473b3f67763f;
module.exports["focusTableResizer"] = $5c26c0ab55efcf4e$export$a57fbe0d9c764ae0;
module.exports["addRowBefore"] = $5c26c0ab55efcf4e$export$2e3087448cf87857;
module.exports["addRowAfter"] = $5c26c0ab55efcf4e$export$fbcf51cabbe4a007;
module.exports["addColumnAfter"] = $5c26c0ab55efcf4e$export$bf95f7b7d259c19f;
module.exports["addColumnBefore"] = $5c26c0ab55efcf4e$export$717d5ccb817cdecc;
module.exports["addRowBeforeVO"] = $5c26c0ab55efcf4e$export$5851c701392d3bfd;
module.exports["addRowAfterVO"] = $5c26c0ab55efcf4e$export$73fa63faf0fd6077;
module.exports["addColumnAfterVO"] = $5c26c0ab55efcf4e$export$875b853996fced8d;
module.exports["addColumnBeforeVO"] = $5c26c0ab55efcf4e$export$414418ca306c22bd;
module.exports["moveColumnLeftOld"] = $5c26c0ab55efcf4e$export$a055d05df46abae5;
module.exports["moveColumnLeft"] = $5c26c0ab55efcf4e$export$f092689a35ce978d;
module.exports["moveColumnRightOld"] = $5c26c0ab55efcf4e$export$7ff94d9a4edfc7f;
module.exports["moveColumnRight"] = $5c26c0ab55efcf4e$export$863ee96d9e15383b;
module.exports["moveRowDownOld"] = $5c26c0ab55efcf4e$export$180b7d3240961d01;
module.exports["moveRowDown"] = $5c26c0ab55efcf4e$export$13c2dd2d968ada2a;
module.exports["moveRowUpOld"] = $5c26c0ab55efcf4e$export$88de3148cc9ddd81;
module.exports["moveRowUp"] = $5c26c0ab55efcf4e$export$e6749a6fc243b921;
module.exports["deleteColumn"] = $5c26c0ab55efcf4e$export$f4f2d7d33085c714;
module.exports["deleteRow"] = $5c26c0ab55efcf4e$export$2ef39e5ffdaff9ed;
module.exports["startColumnResizing"] = $5c26c0ab55efcf4e$export$8f58457f1327dd26;
module.exports["find"] = $5c26c0ab55efcf4e$export$71aa6c912b956294;
module.exports["alignLeft"] = $5c26c0ab55efcf4e$export$ca42dd9a1a0eb501;
module.exports["alignCenter"] = $5c26c0ab55efcf4e$export$f4a51ff076cc9a09;
module.exports["alignRight"] = $5c26c0ab55efcf4e$export$faf8793e4a37a5a2;
module.exports["toggleTaskItemCheckbox"] = $5c26c0ab55efcf4e$export$6f041e7a1d88fa51;
module.exports["toggleTaskList"] = $5c26c0ab55efcf4e$export$2e48e3ea1c210731;
module.exports["selectRow"] = $5c26c0ab55efcf4e$export$e247ed8cec4832f4;
module.exports["selectColumn"] = $5c26c0ab55efcf4e$export$c2e8772deb1607ea;
module.exports["selectTable"] = $5c26c0ab55efcf4e$export$625c5b9bf13f01a8;
module.exports["increaseMediaSize"] = $5c26c0ab55efcf4e$export$fdeca4160ac263c5;
module.exports["decreaseMediaSize"] = $5c26c0ab55efcf4e$export$5ec5f857fec297eb;
module.exports["activateVideoControls"] = $5c26c0ab55efcf4e$export$36141559a83247ee;
module.exports["toggleHighlightPalette"] = $5c26c0ab55efcf4e$export$ec123199f2fe4770;
module.exports["applyYellowHighlight"] = $5c26c0ab55efcf4e$export$62f87f0ca411e518;
module.exports["focusToContextMenuTrigger"] = $5c26c0ab55efcf4e$export$6b05735f625d1c82;
module.exports["dragToMoveUp"] = $5c26c0ab55efcf4e$export$a1bdda43619f945f;
module.exports["dragToMoveDown"] = $5c26c0ab55efcf4e$export$9bf312985dc8137e;
module.exports["dragToMoveLeft"] = $5c26c0ab55efcf4e$export$c4f661b85fc92fd1;
module.exports["dragToMoveRight"] = $5c26c0ab55efcf4e$export$61c867f4a21787f6;
module.exports["showElementDragHandle"] = $5c26c0ab55efcf4e$export$ba34d2a4e6aa10e4;
module.exports["toggleCodeBlock"] = $5c26c0ab55efcf4e$export$e9c6aab026be9523;
module.exports["insertEmoji"] = $5c26c0ab55efcf4e$export$8d5c072327044b6f;
module.exports["insertMention"] = $5c26c0ab55efcf4e$export$8c4314a90d4c5fc1;
module.exports["insertTaskList"] = $5c26c0ab55efcf4e$export$cf3c284f81e5d477;
module.exports["insertElements"] = $5c26c0ab55efcf4e$export$edd9d3cec5b0a9b6;
module.exports["continueInRovoChat"] = $5c26c0ab55efcf4e$export$54f122e0d55178a9;
module.exports["formatShortcut"] = $5c26c0ab55efcf4e$export$384a290f8c265cc5;
module.exports["tooltip"] = $5c26c0ab55efcf4e$export$4e6f96734dfe12f4;
module.exports["ToolTipContent"] = $5c26c0ab55efcf4e$export$4096cb8ab9668358;
module.exports["TooltipContentWithMultipleShortcuts"] = $5c26c0ab55efcf4e$export$9f7e5fe6d45c5f7;
module.exports["findKeymapByDescription"] = $5c26c0ab55efcf4e$export$c4e6735ce96cc7b3;
module.exports["findShortcutByKeymap"] = $5c26c0ab55efcf4e$export$d69faf3b7bc3451;
module.exports["getAriaKeyshortcuts"] = $5c26c0ab55efcf4e$export$6db28e5c399297b0;
module.exports["bindKeymapWithCommand"] = $5c26c0ab55efcf4e$export$4bced0ac29aaf950;
module.exports["bindKeymapArrayWithCommand"] = $5c26c0ab55efcf4e$export$e40cfdbcfa26f180;
module.exports["bindKeymapWithEditorCommand"] = $5c26c0ab55efcf4e$export$b87d3e1cb85f0ba1;
module.exports["findKeyMapForBrowser"] = $5c26c0ab55efcf4e$export$b2dbe47650bcfa54;
module.exports["isCapsLockOnAndModifyKeyboardEvent"] = $5c26c0ab55efcf4e$export$f2da701c7659a26c;

});

parcelRegister("aC6bW", function(module, exports) {

var $3Wkl8 = parcelRequire("3Wkl8");

function $9b83b5c59a6de1de$export$bd352a83a17b2af8(command) {
    return ({ tr: tr }, dispatch)=>{
        const newTr = command?.({
            tr: tr
        });
        if (!newTr) return false;
        if (newTr instanceof (0, $3Wkl8.PassiveTransaction)) return true;
        dispatch?.(newTr);
        return true;
    };
}
module.exports["editorCommandToPMCommand"] = $9b83b5c59a6de1de$export$bd352a83a17b2af8;

});

parcelRegister("3Wkl8", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

class $47a2cfff816b86ec$export$95069e054e554fa9 extends (0, $kCECX.Transaction) {
    // This is very cheeky but this should never be used outside its intended
    // purpose - it will likely crash the editor so we should get an early warning
    // signal
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        super({});
    }
}
module.exports["PassiveTransaction"] = $47a2cfff816b86ec$export$95069e054e554fa9;

});

parcelRegister("eBSR7", function(module, exports) {

var $iqS60 = parcelRequire("iqS60");


var $44cyU = parcelRequire("44cyU");


var $kpCD8 = parcelRequire("kpCD8");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8b3c49dd5b4622e1$var$NON_LATIN_KEY_REGEX = /[^\u0000-\u007f]/;
function $8b3c49dd5b4622e1$export$5043418e2ef368d5(bindings) {
    return new (0, $kpCD8.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const name = (0, $iqS60.keyName)(event);
                let keyboardEvent = event;
                // We will try to bypass the keycode only if any of mod keys are pressed,
                // to allow users to use non-latin and Dead characters.
                const isModKeyPressed = event.ctrlKey || event.metaKey;
                // Check the unicode of the character to assert that it's not an ASCII character.
                // These are characters outside latin's range.
                const isNonLatinKey = name.length === 1 && $8b3c49dd5b4622e1$var$NON_LATIN_KEY_REGEX.test(name);
                // The `Dead` key is a key that combines with a following key to produce a combined character.
                // It will have `even.key === 'Dead'` in some browsers but the `keyCode` will be the same as in a qwerty-keyboard.
                // See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key and https://en.wikipedia.org/wiki/Dead_key
                const isDeadKey = name === 'Dead';
                if (isModKeyPressed && (isNonLatinKey || isDeadKey)) keyboardEvent = new KeyboardEvent(event.type, {
                    // Ignored via go/ees007
                    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                    // FIXME: The event.keyCode is deprecated (see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode),
                    // and could be removed in any time, but the w3c-keyname library doesn't provide a way to get
                    // a key by event.code.
                    key: (0, $iqS60.base)[event.keyCode],
                    code: event.code,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey,
                    metaKey: event.metaKey,
                    shiftKey: event.shiftKey
                });
                return (0, $44cyU.keydownHandler)(bindings)(view, keyboardEvent);
            }
        }
    });
}
module.exports["keymap"] = $8b3c49dd5b4622e1$export$5043418e2ef368d5;

});

parcelRegister("kpCD8", function(module, exports) {
// oxlint-disable-next-line import/no-duplicates

var $kCECX = parcelRequire("kCECX");


var $4o0zT = parcelRequire("4o0zT");


var $ieeJu = parcelRequire("ieeJu");


var $4iudd = parcelRequire("4iudd");


var $4RpM6 = parcelRequire("4RpM6");


var $aIbwr = parcelRequire("aIbwr");


var $2XHKU = parcelRequire("2XHKU");

const $64f124a7bf090f63$export$286bb6e3f51916b5 = ({ nodeOrMark: nodeOrMark, dom: dom, options: options })=>{
    const metadata = (0, $aIbwr.createProseMirrorMetadata)(nodeOrMark, options);
    Object.entries(metadata).forEach(([name, value])=>{
        dom.setAttribute(name, value);
        if (name === 'data-node-anchor' && ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration'))) {
            // if browser doesn't support CSS anchor, won't need the style
            // Or if it supports CSS attr() function as the value of anchor-name,
            // We won't need set the style
            if (!(0, $2XHKU.isCSSAnchorSupported)() || (0, $2XHKU.isCSSAttrAnchorSupported)()) return;
            // otherwise, we set the CSS variable for anchor-name
            dom.style.setProperty((0, $2XHKU.ANCHOR_VARIABLE_NAME), `${value}`);
            return;
        }
    });
};
/** Type guard to check if a Node is an HTMLElement in a safe way. */ const $64f124a7bf090f63$var$isHTMLElement = (element)=>{
    if (element === null || element === undefined) return false;
    // In SSR `HTMLElement` is not defined, so we need to use duck typing here
    return 'innerHTML' in element && 'style' in element && 'classList' in element;
};
// Wraper to avoid any exception during the get pos operation
// See this https://hello.atlassian.net/wiki/spaces/EDITOR/pages/2849713193/ED-19672+Extensions+Regression
// And this https://discuss.prosemirror.net/t/possible-bug-on-viewdesc-posbeforechild/5783
const $64f124a7bf090f63$var$wrapGetPosExceptions = (spec)=>{
    if (!spec?.props?.nodeViews) return spec;
    const unsafeNodeViews = spec.props.nodeViews;
    let nodeIdProvider;
    const safeNodeViews = new Proxy(unsafeNodeViews, {
        get (target, prop, receiver) {
            const safeNodeView = new Proxy(Reflect.get(target, prop, receiver), {
                apply (target, thisArg, argumentsList) {
                    const [node, view, unsafeGetPos, ...more] = argumentsList;
                    if (!nodeIdProvider && ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration'))) nodeIdProvider = (0, $4RpM6.getNodeIdProvider)(view);
                    const safeGetPos = (()=>{
                        try {
                            return unsafeGetPos();
                        } catch (e) {
                            return;
                        }
                    // eslint-disable-next-line no-extra-bind
                    }).bind(thisArg);
                    const result = Reflect.apply(target, thisArg, [
                        node,
                        view,
                        safeGetPos,
                        ...more
                    ]);
                    if (result?.dom instanceof HTMLElement || // SSR result?.dom is not an instance of HTMLElement, but we still want to attach metadata to it
                    (0, $4iudd.isSSR)() && $64f124a7bf090f63$var$isHTMLElement(result?.dom)) {
                        // we only attach metadata to the dom if its position is known
                        const pos = safeGetPos();
                        const options = pos !== undefined && ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) ? {
                            anchrorId: nodeIdProvider?.getOrGenerateId(node, pos)
                        } : undefined;
                        $64f124a7bf090f63$export$286bb6e3f51916b5({
                            nodeOrMark: node,
                            dom: result.dom,
                            options: options
                        });
                    }
                    return result;
                }
            });
            return safeNodeView;
        }
    });
    spec.props.nodeViews = safeNodeViews;
    return spec;
};
class $64f124a7bf090f63$export$1d44e2741b8f180d extends (0, $kCECX.Plugin) {
    constructor(spec){
        super($64f124a7bf090f63$var$wrapGetPosExceptions(spec));
        // This variable isn't (and shouldn't) be used anywhere. Its purpose is
        // to distinguish Plugin from SafePlugin, thus ensuring that an 'unsafe'
        // Plugin cannot be assigned as an item in EditorPlugin → pmPlugins.
        this._isATypeSafePlugin = void 0;
    }
}
module.exports["attachGenericProseMirrorMetadata"] = $64f124a7bf090f63$export$286bb6e3f51916b5;
module.exports["SafePlugin"] = $64f124a7bf090f63$export$1d44e2741b8f180d;

});

parcelRegister("4RpM6", function(module, exports) {

var $iLrhi = parcelRequire("iLrhi");

const $ae6864aa1f464e3a$var$DEFAULT_CHUNK_SIZE = 4096; // Default chunk size in bits
class $ae6864aa1f464e3a$export$fdc385e5a167108c {
    set(index, value) {
        const bitArray = this.getChunk(index);
        const byteOffset = index % this.chunkTotalBitSize;
        const byteIndex = Math.floor(byteOffset / 8); // Get the byte index
        const bitOffset = byteOffset % 8; // Get the bit offset within the byte
        if (value) bitArray[byteIndex] |= 1 << bitOffset; // set the bit
        else bitArray[byteIndex] &= ~(1 << bitOffset); // clear the bit
    }
    get(index) {
        const bitArray = this.getChunk(index);
        const byteOffset = index % this.chunkTotalBitSize;
        const byteIndex = Math.floor(byteOffset / 8); // Get the byte index
        const bitOffset = byteOffset % 8; // Get the bit offset within the byte
        return (bitArray[byteIndex] & 1 << bitOffset) !== 0; // Check if the bit is set
    }
    getChunk(index) {
        const chunkIndex = Math.floor(index / this.chunkTotalBitSize);
        if (!this.bitArrays[chunkIndex]) this.bitArrays[chunkIndex] = new Uint8Array(this.chunkSize);
        return this.bitArrays[chunkIndex];
    }
    constructor(chunkSize = $ae6864aa1f464e3a$var$DEFAULT_CHUNK_SIZE){
        this.chunkSize = void 0;
        this.chunkTotalBitSize = void 0;
        this.bitArrays = void 0;
        this.chunkSize = chunkSize;
        this.chunkTotalBitSize = this.chunkSize * 8;
        this.bitArrays = [];
    }
}


// The real key stays in `@atlaskit/editor-plugin-limited-mode`; importing it would make
// `editor-common` depend on a plugin package, so match the state property by name.
// `'limitedModePlugin$'` is what ProseMirror derives for `new PluginKey('limitedModePlugin')`,
// and editor-plugin-limited-mode-tests asserts that literal to catch it shifting to `$1`.
// Please, do not copy or use this kind of code below
// @ts-ignore
const $4dadc4ec8271b8b7$var$limitedModePluginKey = {
    key: 'limitedModePlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['limitedModePlugin$'];
    }
};
class $4dadc4ec8271b8b7$export$d6cb5c66663ecf49 {
    isEmptyDoc() {
        return this.emptyDoc;
    }
    setEmptyDoc(isEmpty) {
        this.emptyDoc = isEmpty;
    }
    isLimitedMode() {
        return this.limitedMode;
    }
    // We use pos to generate unique ids for each node at a specific position
    // This is to ensure the same ADF will always generate the same DOM initially
    getOrGenerateId(node, pos) {
        if (this.limitedMode) return undefined;
        if (this.cache.has(node)) return this.cache.get(node);
        let idSuffix = '';
        if (this.existingPos.get(pos)) idSuffix = `-${(this.count++).toString(36)}`;
        else this.existingPos.set(pos, true);
        const anchorName = `--anchor-${node.type.name}-${pos}${idSuffix}`;
        this.cache.set(node, anchorName);
        return anchorName;
    }
    getIdForNode(node) {
        if (this.limitedMode) return undefined;
        return this.cache.get(node);
    }
    setIdForNode(node, id) {
        if (this.limitedMode) return;
        this.cache.set(node, id);
    }
    // After set to limited mode, we clear the cache to free up memory
    // and prevent further ids from being generated
    // Once in limited mode, we won't exit it
    //
    // One-way by design, so this can stay latched on after the plugin flips back to
    // off: recovering would mean re-rendering every nodeview to restore its anchor.
    setLimitedMode() {
        this.limitedMode = true;
        this.cache = new WeakMap();
        this.existingPos = new (0, $ae6864aa1f464e3a$export$fdc385e5a167108c)();
        this.count = BigInt(0);
    }
    constructor(limitedMode = false, emptyDoc = false){
        this.cache = new WeakMap();
        this.count = BigInt(0);
        this.existingPos = new (0, $ae6864aa1f464e3a$export$fdc385e5a167108c)();
        this.limitedMode = false;
        this.emptyDoc = false;
        this.limitedMode = limitedMode;
        this.emptyDoc = emptyDoc;
    }
}
const $4dadc4ec8271b8b7$var$nodeIdProviderMap = new WeakMap();
/**
 * Reads the limited-mode plugin's state and nothing else, so a preset without the plugin no longer
 * gets anchor suppression (and with it, no drag handles). No plugin means limited mode is off.
 *
 * Read off the state rather than the plugin injection API because plugin `state.init` is the only
 * thing that has run by the time the `EditorView` constructor builds its first nodeview and calls
 * `getNodeIdProvider`. Plugin views and `usePluginHook` both run later.
 */ const $4dadc4ec8271b8b7$var$isLimitedModeEnabled = (editorView)=>$4dadc4ec8271b8b7$var$limitedModePluginKey.getState(editorView.state)?.documentSizeBreachesThreshold ?? false;
const $4dadc4ec8271b8b7$export$753ee9749f6df320 = (editorView)=>{
    if (!$4dadc4ec8271b8b7$var$nodeIdProviderMap.has(editorView)) {
        const limitedMode = $4dadc4ec8271b8b7$var$isLimitedModeEnabled(editorView);
        const isEmptyDoc = (0, $iLrhi.isEmptyDocument)(editorView.state.doc);
        const provider = new $4dadc4ec8271b8b7$export$d6cb5c66663ecf49(limitedMode, isEmptyDoc);
        $4dadc4ec8271b8b7$var$nodeIdProviderMap.set(editorView, provider);
        return provider;
    }
    const nodeIdProvider = $4dadc4ec8271b8b7$var$nodeIdProviderMap.get(editorView);
    // in some cases we need to re-check limited mode state
    // Confluence editor can start with an empty doc and then load content later
    // so we need to check first time from an empty doc to a non-empty doc
    if (nodeIdProvider.isEmptyDoc() && !(0, $iLrhi.isEmptyDocument)(editorView.state.doc)) {
        // set empty doc to false regardless of limited mode state
        nodeIdProvider.setEmptyDoc(false);
        if (!nodeIdProvider.isLimitedMode() && $4dadc4ec8271b8b7$var$isLimitedModeEnabled(editorView)) nodeIdProvider.setLimitedMode();
    }
    // This is based on the fact that editorView is a singleton.
    return $4dadc4ec8271b8b7$var$nodeIdProviderMap.get(editorView);
};
module.exports["getNodeIdProvider"] = $4dadc4ec8271b8b7$export$753ee9749f6df320;

});

parcelRegister("iLrhi", function(module, exports) {

var $2PBrf = parcelRequire("2PBrf");

function $d8f3d0f73b2898c4$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return (0, $2PBrf.isEmptyParagraph)(nodeChild);
}
module.exports["isEmptyDocument"] = $d8f3d0f73b2898c4$export$2da47a16c0b6bcb;

});

parcelRegister("2PBrf", function(module, exports) {
function $8dbe91591a8ef207$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
module.exports["isEmptyParagraph"] = $8dbe91591a8ef207$export$b648602b09795358;

});

parcelRegister("2XHKU", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $dOBRD = parcelRequire("dOBRD");

const $715a446252837045$export$ef134ee0b603ec88 = '--ed-pm-node-anchor';
const $715a446252837045$var$hasCssSupport = (0, $dOBRD.default)(()=>{
    if (typeof window !== 'undefined' && window.CSS && typeof window.CSS.supports === 'function') return true;
    return false;
});
const $715a446252837045$export$98ea10c5c22b6d19 = (0, $dOBRD.default)(()=>{
    if ($715a446252837045$var$hasCssSupport()) return CSS.supports('anchor-name', 'attr(data-anchor-name type(<custom-ident>))');
    return false;
});
const $715a446252837045$export$e43af301b4191f = (0, $dOBRD.default)(()=>{
    if ($715a446252837045$var$hasCssSupport()) return CSS.supports('anchor-name', '--anchor');
});
const $715a446252837045$export$abca45c45e682c01 = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-node-anchor]': {
            anchorName: `var(${$715a446252837045$export$ef134ee0b603ec88}, attr(data-node-anchor type(<custom-ident>)))`
        }
    }
});
module.exports["ANCHOR_VARIABLE_NAME"] = $715a446252837045$export$ef134ee0b603ec88;
module.exports["isCSSAttrAnchorSupported"] = $715a446252837045$export$98ea10c5c22b6d19;
module.exports["isCSSAnchorSupported"] = $715a446252837045$export$e43af301b4191f;

});

parcelRegister("llCol", function(module, exports) {

var $iTJtk = parcelRequire("iTJtk");

const $eba4854241b974d3$export$1467dbbb3bb418c6 = (0, $iTJtk.FabricChannel).editor;
module.exports["editorAnalyticsChannel"] = $eba4854241b974d3$export$1467dbbb3bb418c6;

});

parcelRegister("hBd0D", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $2sp5n = parcelRequire("2sp5n");

function $8fc5cdce60b976c1$export$30871400b97708b4(manifest, extensionModule) {
    const title = extensionModule.title || manifest.title;
    const key = `${manifest.key}:${extensionModule.key}`;
    const node = (0, $2sp5n.buildAction)(extensionModule.action, manifest);
    const preview = extensionModule.preview ?? manifest.preview;
    const category = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command') ? extensionModule.category ?? manifest.category : undefined;
    if (!node) throw new Error(`Couldn't find any action for ${title} (${key})`);
    return {
        ...(0, $4o0zT.isExperimentEnabled)('platform_editor_slash_app_category_analytics') || (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command') ? {
            app: extensionModule.app ?? manifest.app ?? {
                key: manifest.key
            }
        } : {},
        key: key,
        moduleKey: extensionModule.key,
        title: title,
        extensionType: manifest.type,
        extensionKey: manifest.key,
        keywords: extensionModule.keywords || manifest.keywords || [],
        featured: extensionModule.featured || false,
        // Keep `categories` populated for legacy Quick Insert consumers while
        // the singular category field is introduced.
        ...category?.trim() ? {
            category: category
        } : {},
        categories: category?.trim() ? [
            category
        ] : extensionModule.categories || manifest.categories || [],
        description: extensionModule.description || manifest.description,
        summary: manifest.summary,
        documentationUrl: manifest.documentationUrl,
        priority: extensionModule.priority,
        ...preview != null && {
            preview: preview
        },
        ...extensionModule.lozenge != null && {
            lozenge: extensionModule.lozenge
        },
        icon: extensionModule.icon || manifest.icons['48'],
        node: node
    };
}
module.exports["buildMenuItem"] = $8fc5cdce60b976c1$export$30871400b97708b4;

});

parcelRegister("g6wJI", function(module, exports) {
const $59b983f68af594bc$export$5ae7aa0814ef4090 = (autoConvertHandlers)=>(text)=>{
        for (const handler of autoConvertHandlers){
            const result = handler(text);
            if (result) return result;
        }
    };
module.exports["createAutoConverterRunner"] = $59b983f68af594bc$export$5ae7aa0814ef4090;

});

parcelRegister("50UK1", function(module, exports) {

var $hBd0D = parcelRequire("hBd0D");


var $g6wJI = parcelRequire("g6wJI");



const $87f539a00f9948da$export$a1d0004a197b97a3 = (extensions, transformFunction)=>{
    const items = extensions.map((manifest)=>{
        const modules = manifest.modules.quickInsert || [];
        return modules.map((extensionModule)=>(0, $hBd0D.buildMenuItem)(manifest, extensionModule));
    });
    const flatItems = [].concat(...items);
    return flatItems.map(transformFunction);
};
async function $87f539a00f9948da$export$38a3a11e6509754a(extensionProviderPromise) {
    const extensionProvider = await extensionProviderPromise;
    const extensionAutoConverters = await extensionProvider.getAutoConverter();
    return (0, $g6wJI.createAutoConverterRunner)(extensionAutoConverters);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $87f539a00f9948da$var$logError = (msg, ...args)=>{
    // eslint-disable-next-line no-console
    console.error(msg, ...args);
};
const $87f539a00f9948da$var$toolbarItemToButtonConfig = (toolbarButton, parentKey)=>{
    const { tooltip: tooltip, tooltipStyle: tooltipStyle, key: key, label: label, ariaLabel: ariaLabel, icon: icon, action: action, disabled: disabled } = toolbarButton;
    const itemKey = [
        parentKey,
        key
    ].join(':');
    if (typeof action !== 'function') $87f539a00f9948da$var$logError(`Provided action is not a function for extension toolbar button: ${label} (${itemKey})`);
    let labelAndIcon = {};
    switch(toolbarButton.display){
        case 'icon':
            if (!icon) $87f539a00f9948da$var$logError(`icon should be provided for extension toolbar button (${itemKey}), when display is set to 'icon'`);
            labelAndIcon = {
                icon: icon
            };
            break;
        case 'label':
            if (!label) $87f539a00f9948da$var$logError(`label should be provided for extension toolbar button (${itemKey}), when display is set to 'label'`);
            labelAndIcon = {
                label: label
            };
            break;
        default:
            if (!label || !icon) $87f539a00f9948da$var$logError(`label and icon should be provided for extension toolbar button (${itemKey}), when display is not set or set to 'icon-and-label'`);
            labelAndIcon = {
                icon: icon,
                label: label
            };
            break;
    }
    return {
        key: itemKey,
        ariaLabel: ariaLabel,
        tooltip: tooltip,
        tooltipStyle: tooltipStyle,
        action: action,
        disabled: disabled,
        ...labelAndIcon
    };
};
const $87f539a00f9948da$var$compareContext = (contextA, contextB)=>{
    if (contextA.type === contextB.type && contextA.nodeType === contextB.nodeType) {
        if (contextA.type === 'node') return true;
        if (contextA.type === 'extension' && contextB.type === 'extension') return contextA.extensionKey === contextB.extensionKey && contextA.extensionType === contextB.extensionType;
    }
    return false;
};
const $87f539a00f9948da$var$hasDuplicateContext = (contextualToolbars)=>{
    if (contextualToolbars.length > 1) {
        const contexts = contextualToolbars.map((contextualToolbar)=>contextualToolbar.context);
        return contexts.find((currentContext, currentIndex)=>currentIndex !== contexts.findIndex((context)=>$87f539a00f9948da$var$compareContext(currentContext, context)));
    }
};
const $87f539a00f9948da$export$9d13b95c50a2a6c9 = (extensions, node, api)=>{
    return extensions.map((extension)=>{
        if (extension.modules.contextualToolbars) {
            const duplicateContext = $87f539a00f9948da$var$hasDuplicateContext(extension.modules.contextualToolbars);
            if (duplicateContext) {
                $87f539a00f9948da$var$logError(`[contextualToolbars] Duplicate context detected - ${JSON.stringify(duplicateContext)}.`);
                return [];
            }
            return extension.modules.contextualToolbars.map((contextualToolbar)=>{
                if ($87f539a00f9948da$var$shouldAddExtensionItemForNode(contextualToolbar, node)) {
                    const { toolbarItems: toolbarItems } = contextualToolbar;
                    if (typeof toolbarItems === 'function') return toolbarItems(node, api);
                    return toolbarItems;
                }
                return [];
            }).flatMap((toolbarItems)=>toolbarItems.map((toolbarItem)=>{
                    if ($87f539a00f9948da$var$isToolbarButton(toolbarItem)) return $87f539a00f9948da$var$toolbarItemToButtonConfig(toolbarItem, extension.key);
                    return toolbarItem;
                }));
        }
        return [];
    }).flatMap((extensionToolbarButtons)=>extensionToolbarButtons);
};
const $87f539a00f9948da$var$isToolbarButton = (toolbarItem)=>{
    if ('type' in toolbarItem) return false;
    return true;
};
// defines whether to add toolbar item for the given node
function $87f539a00f9948da$var$shouldAddExtensionItemForNode(item, node) {
    // if item type is a standard node - should match the nodeType
    if (item.context.type === 'node' && item.context.nodeType === node.type) return true;
    // for other cases should be an extension and match the nodeType ("extension" | "inlineExtension" | "bodiedExtension" | "multiBodiedExtension")
    if (item.context.type !== 'extension' || node.type !== item.context.nodeType) return false;
    // in cases where we need custom exclusion depending on the node
    if (item.context.shouldExclude) {
        if (item.context.shouldExclude(node)) return false;
    }
    const { extensionType: extensionType, extensionKey: extensionKey } = item.context;
    // if extension type is given - should match extension type
    if (extensionType && extensionType !== node.attrs?.extensionType) return false;
    // if extension key is a string
    if (typeof extensionKey === 'string') return extensionKey === node.attrs?.extensionKey;
    // if extension key is an array
    if (Array.isArray(extensionKey) && extensionKey.length) return extensionKey.includes(node.attrs?.extensionKey);
    return false;
}
module.exports["getQuickInsertItemsFromModule"] = $87f539a00f9948da$export$a1d0004a197b97a3;
module.exports["getExtensionAutoConvertersFromProvider"] = $87f539a00f9948da$export$38a3a11e6509754a;
module.exports["getContextualToolbarItemsFromModule"] = $87f539a00f9948da$export$9d13b95c50a2a6c9;

});

parcelRegister("1tdlM", function(module, exports) {
$parcel$export(module.exports, "default", () => $6adaae3aeac8d933$export$2e2bcd8739ae039);

var $4A48a = parcelRequire("4A48a");

var /**
 * Allow to run methods from the `ExtensionProvider` interface across all providers seamlessly.
 * This handles optional explicit resolution, promise racing, and safely discarded rejections.
 */ $6adaae3aeac8d933$export$2e2bcd8739ae039 = (extensionProviders, { resolveExtension: resolveExtension, resolvePreloadedExtension: resolvePreloadedExtension } = {})=>{
    let providersCache = [];
    const { invokeSingle: invokeSingle, invokeList: invokeList } = (0, $4A48a.default)(extensionProviders);
    return {
        getExtensions () {
            return invokeList('getExtensions');
        },
        async preload () {
            if (providersCache.length === 0) providersCache = await Promise.all(extensionProviders.map((provider)=>Promise.resolve(provider)));
            await Promise.all(providersCache.map((provider)=>provider?.preload?.()));
        },
        getPreloadedExtension (type, key) {
            const resolvedExtension = resolvePreloadedExtension?.(type, key);
            if (resolvedExtension) return resolvedExtension;
            if (providersCache.length === 0) // preload() has not been called yet
            return;
            for (const provider of providersCache)try {
                const result = provider?.getPreloadedExtension?.(type, key);
                if (result) return result;
            } catch  {
            // Not every provider will implement this method.
            // In that case we would get error from other providers in the loop
            // and undefined from that particular provider.
            // We can safely ignore it and fallback to the async getExtension when nothing was found.
            }
        },
        async getExtension (type, key) {
            const resolvedExtension = await resolveExtension?.(type, key);
            if (resolvedExtension) return resolvedExtension;
            return invokeSingle('getExtension', [
                type,
                key
            ]);
        },
        search (keyword) {
            return invokeList('search', [
                keyword
            ]);
        },
        getAutoConverter () {
            return invokeList('getAutoConverter');
        }
    };
};

});

parcelRegister("dldpg", function(module, exports) {
class $971b76ac6a761d42$export$88da0ac32d9c271e {
    captureMessage(msg, tags) {
        if (this.handlerStorage) this.handlerStorage.captureMessage(msg, tags);
    }
    captureException(err, tags) {
        if (this.handlerStorage) this.handlerStorage.captureException(err, tags);
    }
    set handler(handler) {
        this.handlerStorage = handler;
    }
    constructor(){
        this.handlerStorage = null;
    }
}
module.exports["ErrorReporter"] = $971b76ac6a761d42$export$88da0ac32d9c271e;

});

parcelRegister("btvbC", function(module, exports) {





function $061f15f30ebc46e8$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $061f15f30ebc46e8$export$d508bcfb7f019487(node, s) {
    return $061f15f30ebc46e8$export$ff7f7c97cdce86e(node, s);
}
function $061f15f30ebc46e8$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $061f15f30ebc46e8$export$5b6ab01a6efa50e2(elem, callback) {
    return $061f15f30ebc46e8$export$b2d5d4f1aeebddf1(elem, callback);
}
module.exports["closest"] = $061f15f30ebc46e8$export$ff7f7c97cdce86e;
module.exports["closestElement"] = $061f15f30ebc46e8$export$d508bcfb7f019487;
module.exports["mapElem"] = $061f15f30ebc46e8$export$b2d5d4f1aeebddf1;
module.exports["maphElem"] = $061f15f30ebc46e8$export$5b6ab01a6efa50e2;

});

parcelRegister("2xhuI", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kSwu1 = parcelRequire("kSwu1");


var $5NB3T = parcelRequire("5NB3T");


var $83k8i = parcelRequire("83k8i");


var $lFU5S = parcelRequire("lFU5S");


var $3FYPH = parcelRequire("3FYPH");


var $5HBT9 = parcelRequire("5HBT9");


var $g7Ale = parcelRequire("g7Ale");


var $7Glgp = parcelRequire("7Glgp");


var $4KjiO = parcelRequire("4KjiO");



var $91WyP = parcelRequire("91WyP");


var $iEFx5 = parcelRequire("iEFx5");


var $bHKSU = parcelRequire("bHKSU");



var $go7uG = parcelRequire("go7uG");


var $gx3UZ = parcelRequire("gx3UZ");


var $2BvhC = parcelRequire("2BvhC");


var $bI2nS = parcelRequire("bI2nS");


var $l1ngX = parcelRequire("l1ngX");


var $bq13E = parcelRequire("bq13E");


var $fKJ7J = parcelRequire("fKJ7J");


var $h4y3S = parcelRequire("h4y3S");


var $bOjiE = parcelRequire("bOjiE");


var $4rQbz = parcelRequire("4rQbz");


var $f4Xrl = parcelRequire("f4Xrl");


var $72OpT = parcelRequire("72OpT");


var $jexwB = parcelRequire("jexwB");


var $icr1E = parcelRequire("icr1E");


var $dN8GG = parcelRequire("dN8GG");



var $8Ajok = parcelRequire("8Ajok");


var $hdn7b = parcelRequire("hdn7b");


var $WnqKg = parcelRequire("WnqKg");


var $3IBFJ = parcelRequire("3IBFJ");


var $2DRge = parcelRequire("2DRge");


var $725R2 = parcelRequire("725R2");


var $f7SX8 = parcelRequire("f7SX8");


var $hzZPp = parcelRequire("hzZPp");


var $i6cU6 = parcelRequire("i6cU6");


var $4OhxS = parcelRequire("4OhxS");


var $7BkLi = parcelRequire("7BkLi");


var $8bmf7 = parcelRequire("8bmf7");


var $7uaqq = parcelRequire("7uaqq");


var $lsQud = parcelRequire("lsQud");


var $iInrd = parcelRequire("iInrd");



var $aI2Eh = parcelRequire("aI2Eh");



var $c2kFl = parcelRequire("c2kFl");



var $2VjJa = parcelRequire("2VjJa");

const $085bead63193d059$var$_default_1 = (0, $kSwu1.defineMessages)({
    layoutFixedWidth: {
        id: "fabric.editor.layoutFixedWidth",
        defaultMessage: "Back to center"
    },
    layoutStateFixedWidth: {
        id: "fabric.editor.layoutStateFixedWidth",
        defaultMessage: "Centered"
    },
    layoutWide: {
        id: "fabric.editor.layoutWide",
        defaultMessage: "Go wide"
    },
    layoutStateWide: {
        id: "fabric.editor.layoutStateWide",
        defaultMessage: "Wide"
    },
    layoutFullWidth: {
        id: "fabric.editor.layoutFullWidth",
        defaultMessage: "Go full width"
    },
    layoutStateFullWidth: {
        id: "fabric.editor.layoutStateFullWidth",
        defaultMessage: "Full width"
    },
    alignImageRight: {
        id: "fabric.editor.alignImageRight",
        defaultMessage: "Align right"
    },
    alignImageCenter: {
        id: "fabric.editor.alignImageCenter",
        defaultMessage: "Align center"
    },
    alignImageLeft: {
        id: "fabric.editor.alignImageLeft",
        defaultMessage: "Align left"
    },
    delete: {
        id: "fabric.editor.delete",
        defaultMessage: "Delete"
    },
    remove: {
        id: "fabric.editor.remove",
        defaultMessage: "Remove"
    },
    removeEmoji: {
        id: "fabric.editor.removeEmoji",
        defaultMessage: "Remove emoji"
    },
    visit: {
        id: "fabric.editor.visit",
        defaultMessage: "Open link in a new window"
    },
    inviteToEditButtonTitle: {
        id: "fabric.editor.editMode.inviteToEditButton.title",
        defaultMessage: "Invite to edit"
    },
    saveButton: {
        id: "fabric.editor.saveButton",
        defaultMessage: "Save"
    },
    cancelButton: {
        id: "fabric.editor.cancelButton",
        defaultMessage: "Cancel"
    },
    taskList: {
        id: "fabric.editor.tooltip.taskList",
        defaultMessage: "an action item"
    },
    bulletList: {
        id: "fabric.editor.tooltip.bulletList",
        defaultMessage: "a list"
    },
    nestedExpand: {
        id: "fabric.editor.tooltip.nestedExpand",
        defaultMessage: "a nested expand"
    },
    decisionList: {
        id: "fabric.editor.tooltip.decisionList",
        defaultMessage: "a decision list"
    },
    defaultBlockNode: {
        id: "fabric.editor.tooltip.defaultBlockNode",
        defaultMessage: "a block node"
    },
    panel: {
        id: "fabric.editor.tooltip.blockPanel",
        defaultMessage: "a panel"
    },
    blockquote: {
        id: "fabric.editor.blockquote",
        defaultMessage: "a quote"
    },
    timeUpdated: {
        id: "fabric.editor.time.updated",
        defaultMessage: "Updated"
    },
    timeViewed: {
        id: "fabric.editor.time.viewed",
        defaultMessage: "Viewed"
    },
    timeAgo: {
        id: "fabric.editor.time.ago",
        defaultMessage: "ago"
    },
    copyToClipboard: {
        id: "fabric.editor.copyToClipboard",
        defaultMessage: "Copy"
    },
    copiedToClipboard: {
        id: "fabric.editor.copiedToClipboard",
        defaultMessage: "Copied!"
    },
    viewMore: {
        id: "fabric.editor.overflowMenuViewMore",
        defaultMessage: "View more"
    },
    imageEdit: {
        id: "fabric.editor.imageEdit",
        defaultMessage: "Edit image"
    },
    error: {
        id: "fabric.editor.error.message.label",
        defaultMessage: "Error"
    },
    success: {
        id: "fabric.editor.success.message.label",
        defaultMessage: "Success"
    }
});
var $085bead63193d059$export$2e2bcd8739ae039 = $085bead63193d059$var$_default_1;
module.exports["default"] = $085bead63193d059$export$2e2bcd8739ae039;

});

parcelRegister("5NB3T", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $28d3424ad2043b12$export$5229ffea355cfdf6 = (0, $kSwu1.defineMessages)({
    alignment: {
        id: "fabric.editor.alignment",
        defaultMessage: "Text alignment"
    },
    alignLeft: {
        id: "fabric.editor.alignLeft",
        defaultMessage: "Align left"
    },
    alignCenter: {
        id: "fabric.editor.alignCenter",
        defaultMessage: "Align center"
    },
    alignRight: {
        id: "fabric.editor.alignRight",
        defaultMessage: "Align right"
    }
});
module.exports["alignmentMessages"] = $28d3424ad2043b12$export$5229ffea355cfdf6;

});

parcelRegister("83k8i", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4c186334a1bb06ff$export$ff612ca71703201d = (0, $kSwu1.defineMessages)({
    createComment: {
        id: "fabric.editor.createComment",
        defaultMessage: "Comment"
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove this message when the editor_inline_comments_on_inline_nodes FF is removed
    createCommentInvalid: {
        id: "fabric.editor.createCommentInvalid",
        defaultMessage: "You can only comment on text and headings"
    },
    createCommentDisabled: {
        id: "fabric.editor.createCommentDisabled",
        defaultMessage: "You can only comment on text, headings, emojis, dates, mentions, links, and statuses."
    },
    // Duplicated by Confluence's
    // highlight-actions.inline-comments.comment.no.permission
    noPermissionToAddComment: {
        id: "fabric.editor.noPermissionToAddComment",
        defaultMessage: "{contentType, select, blogpost {You do not have permission to add comments to this blogpost} page {You do not have permission to add comments to this page} other {You do not have permission to add comments to this page}}"
    },
    toolbar: {
        id: "fabric.editor.annotationToolbar",
        defaultMessage: "Annotation toolbar"
    }
});
module.exports["annotationMessages"] = $4c186334a1bb06ff$export$ff612ca71703201d;

});

parcelRegister("lFU5S", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $25f4deabd9138dcc$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    maxWidthLabel: {
        id: "fabric.editor.breakoutMaxWidthLabel",
        defaultMessage: "Max-width"
    },
    fullWidthLabel: {
        id: "fabric.editor.breakoutFullWidthLabel",
        defaultMessage: "Full-width"
    },
    wideWidthLabel: {
        id: "fabric.editor.breakoutWideWidthLabel",
        defaultMessage: "Wide"
    },
    resizeHandle: {
        id: "fabric.editor.resizeHandle",
        defaultMessage: "Resize handle"
    },
    resizeExpand: {
        id: "fabric.editor.breakout.resizeExpand",
        defaultMessage: "Resize expand"
    },
    resizeCodeBlock: {
        id: "fabric.editor.breakout.resizeCodeBlock",
        defaultMessage: "Resize code snippet"
    },
    resizeLayout: {
        id: "fabric.editor.breakout.resizeLayout",
        defaultMessage: "Resize layout"
    },
    resizeElement: {
        id: "fabric.editor.breakout.resizeElement",
        defaultMessage: "Resize element"
    },
    resizeRule: {
        id: "fabric.editor.breakout.resizeRule",
        defaultMessage: "Resize divider"
    },
    resizePanel: {
        id: "fabric.editor.breakout.resizePanel",
        defaultMessage: "Resize panel"
    },
    resizeExtension: {
        id: "fabric.editor.breakout.resizeExtension",
        defaultMessage: "Resize extension"
    }
});
module.exports["messages"] = $25f4deabd9138dcc$export$defe85febe8b728c;

});

parcelRegister("3FYPH", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c9ae10a46107c925$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    moveUpBlock: {
        id: "fabric.editor.block.menu.move.up",
        defaultMessage: "Move up"
    },
    moveDownBlock: {
        id: "fabric.editor.block.menu.move.down",
        defaultMessage: "Move down"
    },
    copy: {
        id: "fabric.editor.block.menu.copy",
        defaultMessage: "Copy"
    },
    copyLink: {
        id: "fabric.editor.block.menu.copy.link",
        defaultMessage: "Copy link"
    },
    copyLinkToSelection: {
        id: "fabric.editor.block.menu.copy.link.to.selection",
        defaultMessage: "Copy link to selection"
    },
    linkCopiedToClipboard: {
        id: "fabric.editor.block.menu.link.copied.to.clipboard",
        defaultMessage: "Link copied to clipboard"
    },
    paragraph: {
        id: "fabric.editor.block.menu.paragraph",
        defaultMessage: "Paragraph"
    },
    normalText: {
        id: "fabric.editor.block.menu.normal.text",
        defaultMessage: "Normal text"
    },
    codeBlock: {
        id: "fabric.editor.block.menu.codeblock",
        defaultMessage: "Code block"
    },
    layout: {
        id: "fabric.editor.block.menu.layout",
        defaultMessage: "Layout"
    },
    deleteBlock: {
        id: "fabric.editor.block.menu.delete.block",
        defaultMessage: "Delete"
    },
    turnInto: {
        id: "fabric.editor.block.menu.turn.into",
        defaultMessage: "Turn into"
    },
    changeFormat: {
        id: "fabric.editor.block.menu.change.format",
        defaultMessage: "Change format"
    },
    syncBlock: {
        id: "fabric.editor.block.menu.sync.block",
        defaultMessage: "Sync block"
    },
    copySyncedBlock: {
        id: "fabric.editor.block.menu.copy.synced.block",
        defaultMessage: "Copy synced block"
    },
    newLozenge: {
        id: "fabric.editor.block.menu.new.lozenge",
        defaultMessage: "New"
    },
    decisionList: {
        id: "fabric.editor.block.menu.decision",
        defaultMessage: "Decision"
    },
    wrapIcon: {
        id: "fabric.editor.block.menu.wrap.icon",
        defaultMessage: "Wrap"
    },
    create: {
        id: "fabric.editor.block.menu.create",
        defaultMessage: "Create"
    },
    headings: {
        id: "fabric.editor.block.menu.headings",
        defaultMessage: "Headings"
    },
    textFormatting: {
        id: "fabric.editor.block.menu.text.formatting",
        defaultMessage: "Text formatting"
    },
    suggested: {
        id: "fabric.editor.block.menu.suggested",
        defaultMessage: "Suggested"
    },
    structure: {
        id: "fabric.editor.block.menu.structure",
        defaultMessage: "Structure"
    },
    fallbackNestedMenu: {
        id: "fabric.editor.block.menu.fallback.nested.menu",
        defaultMessage: "Nested Menu"
    },
    fallbackMenuItem: {
        id: "fabric.editor.block.menu.fallback.menu.item",
        defaultMessage: "Block Menu Item"
    }
});
module.exports["messages"] = $c9ae10a46107c925$export$defe85febe8b728c;

});

parcelRegister("5HBT9", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e000d8c8e2271509$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    normal: {
        id: "fabric.editor.normal",
        defaultMessage: "Normal text"
    },
    smallText: {
        id: "fabric.editor.smallText",
        defaultMessage: "Small text"
    },
    heading1: {
        id: "fabric.editor.heading1",
        defaultMessage: "Heading 1"
    },
    heading1Description: {
        id: "fabric.editor.heading1Description",
        defaultMessage: "Use this for a top level heading"
    },
    heading2: {
        id: "fabric.editor.heading2",
        defaultMessage: "Heading 2"
    },
    heading2Description: {
        id: "fabric.editor.heading2Description",
        defaultMessage: "Use this for key sections"
    },
    heading3: {
        id: "fabric.editor.heading3",
        defaultMessage: "Heading 3"
    },
    heading3Description: {
        id: "fabric.editor.heading3Description",
        defaultMessage: "Use this for sub sections and group headings"
    },
    heading4: {
        id: "fabric.editor.heading4",
        defaultMessage: "Heading 4"
    },
    heading4Description: {
        id: "fabric.editor.heading4Description",
        defaultMessage: "Use this for deep headings"
    },
    heading5: {
        id: "fabric.editor.heading5",
        defaultMessage: "Heading 5"
    },
    heading5Description: {
        id: "fabric.editor.heading5Description",
        defaultMessage: "Use this for grouping list items"
    },
    heading6: {
        id: "fabric.editor.heading6",
        defaultMessage: "Heading 6"
    },
    heading6Description: {
        id: "fabric.editor.heading6Description",
        defaultMessage: "Use this for low level headings"
    },
    blockquote: {
        id: "fabric.editor.blockquote2",
        defaultMessage: "Quote"
    },
    blockquoteDescription: {
        id: "fabric.editor.blockquote.description",
        defaultMessage: "Insert a quote or citation"
    },
    codeblock: {
        id: "fabric.editor.codeblock",
        defaultMessage: "Code snippet"
    },
    codeblockDescription: {
        id: "fabric.editor.codeblock.description",
        defaultMessage: "Display code with syntax highlighting"
    },
    infoPanel: {
        id: "fabric.editor.infoPanel",
        defaultMessage: "Info panel"
    },
    infoPanelDescription: {
        id: "fabric.editor.infoPanel.description",
        defaultMessage: "Highlight information in a colored panel"
    },
    notePanel: {
        id: "fabric.editor.notePanel",
        defaultMessage: "Note panel"
    },
    notePanelDescription: {
        id: "fabric.editor.notePanel.description",
        defaultMessage: "Add a note in a colored panel"
    },
    successPanel: {
        id: "fabric.editor.successPanel",
        defaultMessage: "Success panel"
    },
    successPanelDescription: {
        id: "fabric.editor.successPanel.description",
        defaultMessage: "Add tips in a colored panel"
    },
    warningPanel: {
        id: "fabric.editor.warningPanel",
        defaultMessage: "Warning panel"
    },
    warningPanelDescription: {
        id: "fabric.editor.warningPanel.description",
        defaultMessage: "Add a note of caution in a colored panel"
    },
    errorPanel: {
        id: "fabric.editor.errorPanel",
        defaultMessage: "Error panel"
    },
    errorPanelDescription: {
        id: "fabric.editor.errorPanel.description",
        defaultMessage: "Call out errors in a colored panel"
    },
    customPanel: {
        id: "fabric.editor.customPanel",
        defaultMessage: "Custom panel"
    },
    customPanelDescription: {
        id: "fabric.editor.customPanel.description",
        defaultMessage: "Add a note with an emoji and colored background"
    },
    syncedBlock: {
        id: "fabric.editor.syncedBlock",
        defaultMessage: "Create synced block"
    },
    syncBlock: {
        id: "fabric.editor.syncBlock",
        defaultMessage: "Sync block"
    },
    syncedBlockQuickInsertTitle: {
        id: "editor-common.messages.block-type.syncedBlockQuickInsertTitle",
        defaultMessage: "Synced block"
    },
    syncedBlockDescription: {
        id: "fabric.editor.syncedBlock.description",
        defaultMessage: "Sync content across multiple locations"
    },
    newLozenge: {
        id: "fabric.editor.quickinsert.new.lozenge",
        defaultMessage: "New"
    },
    panel: {
        id: "fabric.editor.panel",
        defaultMessage: "Panel"
    },
    other: {
        id: "fabric.editor.other",
        defaultMessage: "Others..."
    }
});
module.exports["messages"] = $e000d8c8e2271509$export$defe85febe8b728c;

});

parcelRegister("g7Ale", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a87b92da65fc80e6$export$2cfe8170446b663e = (0, $kSwu1.defineMessages)({
    blockTemplates: {
        id: "editor-plugin-snippets.snippetsPlugin.blockTemplates",
        defaultMessage: "Block templates"
    },
    browseTemplates: {
        id: "editor-plugin-snippets.snippetsPlugin.browseTemplates",
        defaultMessage: "Browse all templates"
    },
    newLozenge: {
        id: "editor-plugin-snippets.snippetsPlugin.newLozenge",
        defaultMessage: "New"
    },
    templateGalleryDescription: {
        id: "editor-plugin-snippets.snippetsPlugin.templateGalleryDescription",
        defaultMessage: "Create, discover, & insert block templates"
    },
    templateGalleryTitle: {
        id: "editor-plugin-snippets.snippetsPlugin.templateGalleryTitle",
        defaultMessage: "Block Template Gallery"
    }
});
module.exports["templateGalleryMessages"] = $a87b92da65fc80e6$export$2cfe8170446b663e;

});

parcelRegister("4KjiO", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c97b6219504bf2b4$export$df1842193ff5ba1e = (0, $kSwu1.defineMessages)({
    accessibility: {
        id: "fabric.editor.color.accessibility.accessibility",
        defaultMessage: "Accessibility"
    },
    accessibleLabel: {
        id: "fabric.editor.color.accessibility.accessibleLabel",
        defaultMessage: "Accessible"
    },
    accessibleTooltip: {
        id: "fabric.editor.color.accessibility.accessibleTooltip",
        defaultMessage: "Accessible color combination"
    },
    difficultToReadLabel: {
        id: "fabric.editor.color.accessibility.difficultToReadLabel",
        defaultMessage: "Difficult to read"
    },
    difficultToReadTooltip: {
        id: "fabric.editor.color.accessibility.difficultToReadTooltip",
        defaultMessage: "This color combination has low contrast. Select a different color to improve legibility."
    },
    inaccessibleLabel: {
        id: "fabric.editor.color.accessibility.inaccessibleLabel",
        defaultMessage: "Inaccessible"
    },
    inaccessibleTooltip: {
        id: "fabric.editor.color.accessibility.inaccessibleTooltip",
        defaultMessage: "This color combination is hard to read. Select a different color to improve legibility."
    }
});
module.exports["colorAccessibilityMessages"] = $c97b6219504bf2b4$export$df1842193ff5ba1e;

});

parcelRegister("91WyP", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $507773343f0f2d41$export$4ce3884394d6d9 = (0, $kSwu1.defineMessages)({
    openLink: {
        id: "fabric.editor.openLink",
        defaultMessage: "Open link in a new tab"
    },
    openPreviewPanel: {
        id: "fabric.editor.openPreviewPanel",
        defaultMessage: "Open preview panel"
    }
});
module.exports["linkMessages"] = $507773343f0f2d41$export$4ce3884394d6d9;

});

parcelRegister("iEFx5", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $528e2cdec0d6b4bb$export$2d7676d841c8ae9 = (0, $kSwu1.defineMessages)({
    addLink: {
        id: "fabric.editor.mediaAddLink",
        defaultMessage: "Add link"
    },
    unableToOpenLink: {
        id: "fabric.editor.unableToOpenLink",
        defaultMessage: "Unable to open this link"
    },
    unlink: {
        id: "fabric.editor.unlink",
        defaultMessage: "Unlink"
    },
    editDatasourceStandalone: {
        id: "fabric.editor.editDatasourceStandalone",
        defaultMessage: "Edit"
    },
    editDatasourceStandaloneTooltip: {
        id: "fabric.editor.editDatasourceStandaloneTooltip",
        defaultMessage: "Edit search query"
    },
    editLink: {
        id: "fabric.editor.editLink",
        defaultMessage: "Edit link"
    },
    placeholder: {
        id: "fabric.editor.hyperlinkToolbarPlaceholder",
        defaultMessage: "Paste or search for link"
    },
    linkPlaceholder: {
        id: "fabric.editor.linkPlaceholder",
        defaultMessage: "Paste link"
    },
    linkAddress: {
        id: "fabric.editor.linkAddress",
        defaultMessage: "Link address"
    },
    invalidLink: {
        id: "fabric.editor.invalidLink",
        defaultMessage: "Please enter a valid link."
    },
    emptyLink: {
        id: "fabric.editor.emptyLink",
        defaultMessage: "Please enter a link."
    },
    settingsLink: {
        id: "fabric.editor.settingsLinks",
        defaultMessage: "Go to Link Preferences"
    },
    preferencesLink: {
        id: "fabric.editor.preferencesLink",
        defaultMessage: "Link preferences"
    },
    editDatasource: {
        id: "fabric.editor.edit.datasource",
        defaultMessage: "Edit search query"
    },
    searchInput: {
        id: "fabric.editor.edit.searchInput",
        defaultMessage: "Add a link"
    }
});
module.exports["linkToolbarMessages"] = $528e2cdec0d6b4bb$export$2d7676d841c8ae9;

});

parcelRegister("gx3UZ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c361d57d0cf0d981$export$70c8a7203d95247 = (0, $kSwu1.defineMessages)({
    action: {
        id: "fabric.editor.action",
        defaultMessage: "Action item"
    },
    actionDescription: {
        id: "fabric.editor.action.description",
        defaultMessage: "Create and assign action items"
    },
    closeInsertRightRail: {
        id: "fabric.editor.insertRightRail.close",
        defaultMessage: "Close"
    },
    link: {
        id: "fabric.editor.link",
        defaultMessage: "Link"
    },
    linkDescription: {
        id: "fabric.editor.link.description",
        defaultMessage: "Insert a link"
    },
    mediaFiles: {
        id: "fabric.editor.mediaFiles",
        defaultMessage: "Image, video, or file"
    },
    addMediaFiles: {
        id: "fabric.editor.addMediaFiles",
        defaultMessage: "Add image, video, or file"
    },
    insertRightRailTitle: {
        id: "fabric.editor.insertRightRail.title",
        defaultMessage: "Insert"
    },
    mediaFilesDescription: {
        id: "fabric.editor.mediaFiles.description",
        defaultMessage: "Add images and other files to your page"
    },
    image: {
        id: "fabric.editor.image",
        defaultMessage: "Image"
    },
    aiImageGeneration: {
        id: "fabric.editor.aiImageGeneration",
        defaultMessage: "Generate image"
    },
    aiImageGenerationDescription: {
        id: "fabric.editor.aiImageGeneration.description",
        defaultMessage: "Generate an image with AI"
    },
    aiImageGenerationPopupAriaLabel: {
        id: "fabric.editor.aiImageGeneration.popupAriaLabel",
        defaultMessage: "Generate image with AI"
    },
    mention: {
        id: "fabric.editor.mention",
        defaultMessage: "Mention"
    },
    mentionDescription: {
        id: "fabric.editor.mention.description",
        defaultMessage: "Mention someone to send them a notification"
    },
    emoji: {
        id: "fabric.editor.emoji",
        defaultMessage: "Emoji"
    },
    emojiDescription: {
        id: "fabric.editor.emoji.description",
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04"
    },
    table: {
        id: "fabric.editor.table",
        defaultMessage: "Table"
    },
    tableDescription: {
        id: "fabric.editor.table.description",
        defaultMessage: "Insert a table"
    },
    tableSelector: {
        id: "fabric.editor.tableSelector",
        defaultMessage: "Table size"
    },
    tableSelectorDescription: {
        id: "fabric.editor.tableSelector.description",
        defaultMessage: "Add a table using popup to select a custom size"
    },
    tableSizeSelectorButton: {
        id: "fabric.editor.tableSizeSelectorButton",
        defaultMessage: "{numberOfColumns} by {numberOfRows}"
    },
    tableSizeSelectorPopup: {
        id: "fabric.editor.tableSizeSelectorPopup",
        defaultMessage: "Table size selector"
    },
    expand: {
        id: "fabric.editor.expand",
        defaultMessage: "Expand"
    },
    expandDescription: {
        id: "fabric.editor.expand.description",
        defaultMessage: "Insert an expand"
    },
    decision: {
        id: "fabric.editor.decision",
        defaultMessage: "Decision"
    },
    decisionDescription: {
        id: "fabric.editor.decision.description",
        defaultMessage: "Capture decisions so they're easy to track"
    },
    feedbackDialog: {
        id: "fabric.editor.feedbackDialog",
        defaultMessage: "Give feedback"
    },
    feedbackDialogDescription: {
        id: "fabric.editor.feedbackDialog.description",
        defaultMessage: "Tell us about your experience using the cloud editor"
    },
    horizontalRule: {
        id: "fabric.editor.horizontalRule",
        defaultMessage: "Divider"
    },
    horizontalRuleDescription: {
        id: "fabric.editor.horizontalRule.description",
        defaultMessage: "Separate content with a horizontal line"
    },
    date: {
        id: "fabric.editor.date",
        defaultMessage: "Date"
    },
    dateDescription: {
        id: "fabric.editor.date.description",
        defaultMessage: "Add a date using a calendar"
    },
    placeholderText: {
        id: "fabric.editor.placeholderText",
        defaultMessage: "Placeholder text"
    },
    placeholderTextDescription: {
        id: "fabric.editor.placeholderText.description",
        defaultMessage: "Insert a text placeholder into the page"
    },
    columns: {
        id: "fabric.editor.columns",
        defaultMessage: "Layouts"
    },
    columnsDescription: {
        id: "fabric.editor.columns.description",
        defaultMessage: "Structure your page using sections"
    },
    columnsDescriptionAdvancedLayout: {
        id: "fabric.editor.columns.advanced.layout.description",
        defaultMessage: "Insert {numberOfColumns} equal {numberOfColumns, plural, one {column} other {columns}}"
    },
    singleColumnsDescriptionAdvancedLayout: {
        id: "fabric.editor.columns.advanced.layout.single.description",
        defaultMessage: "Insert a single column layout"
    },
    status: {
        id: "fabric.editor.status",
        defaultMessage: "Status"
    },
    statusDescription: {
        id: "fabric.editor.status.description",
        defaultMessage: "Add a custom status label"
    },
    askRovo: {
        id: "fabric.editor.askRovo",
        defaultMessage: "Ask Rovo"
    },
    viewMore: {
        id: "fabric.editor.viewMore",
        defaultMessage: "View more"
    },
    viewMoreAriaLabel: {
        id: "fabric.editor.viewMoreAriaLabel",
        defaultMessage: "View all elements"
    },
    insertMenu: {
        id: "fabric.editor.insertMenu",
        defaultMessage: "Insert elements"
    },
    help: {
        id: "fabric.editor.help",
        defaultMessage: "Help"
    },
    helpDescription: {
        id: "fabric.editor.help.description",
        defaultMessage: "Browse all the keyboard shortcuts and markdown options"
    },
    recordVideo: {
        id: "fabric.editor.recordVideo",
        defaultMessage: "Record a Loom video"
    },
    addLoomVideo: {
        id: "fabric.editor.addLoomVideo",
        defaultMessage: "Record a Loom video"
    },
    addLoomVideoComment: {
        id: "fabric.editor.addLoomVideoComment",
        defaultMessage: "Record a Loom video comment"
    },
    recordVideoDescription: {
        id: "fabric.editor.recordVideo.description",
        defaultMessage: "Record and share your screen and thoughts"
    },
    recordLoomShortTitle: {
        id: "fabric.editor.recordLoomShortTitle",
        defaultMessage: "Record"
    },
    turnInto: {
        id: "fabric.editor.turnInto",
        defaultMessage: "Turn into"
    }
});
module.exports["toolbarInsertBlockMessages"] = $c361d57d0cf0d981$export$70c8a7203d95247;

});

parcelRegister("2BvhC", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3cc8f7c79d60af1d$export$81b075fd34c2f0bb = (0, $kSwu1.defineMessages)({
    wrapLeft: {
        id: "fabric.editor.wrapLeft",
        defaultMessage: "Wrap left"
    },
    wrapRight: {
        id: "fabric.editor.wrapRight",
        defaultMessage: "Wrap right"
    },
    changeToMediaSingle: {
        id: "fabric.editor.media_change_mediasingle",
        defaultMessage: "Original size"
    },
    changeToMediaInlineImage: {
        id: "fabric.editor.media_change_mediainline_default",
        defaultMessage: "Inline"
    },
    changeToMediaInlineImageCaptionWarning: {
        id: "fabric.editor.media_change_mediainline_caption_warn",
        defaultMessage: "Inline (caption will be removed)"
    },
    replaceMedia: {
        id: "fabric.editor.media.replace.non-final",
        defaultMessage: "Replace"
    }
});
module.exports["toolbarMessages"] = $3cc8f7c79d60af1d$export$81b075fd34c2f0bb;

});

parcelRegister("bq13E", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3c028c29e12ff5ff$export$81b075fd34c2f0bb = (0, $kSwu1.defineMessages)({
    underline: {
        id: "fabric.editor.underline",
        defaultMessage: "Underline"
    },
    strike: {
        id: "fabric.editor.strike",
        defaultMessage: "Strikethrough"
    },
    code: {
        id: "fabric.editor.code",
        defaultMessage: "Code"
    },
    codeOn: {
        id: "fabric.editor.code.on",
        defaultMessage: "{textFormattingOff}, Code On"
    },
    subscript: {
        id: "fabric.editor.subscript",
        defaultMessage: "Subscript"
    },
    subscriptOffSuperscriptOn: {
        id: "fabric.editor.subscript.off.superscript.on",
        defaultMessage: "Subscript Off, Superscript On"
    },
    superscript: {
        id: "fabric.editor.superscript",
        defaultMessage: "Superscript"
    },
    superscriptOffSubscriptOn: {
        id: "fabric.editor.superscript.off.subscript.on",
        defaultMessage: "Superscript Off, Subscript On"
    },
    clearFormatting: {
        id: "fabric.editor.clearFormatting",
        defaultMessage: "Clear formatting"
    },
    moreFormatting: {
        id: "fabric.editor.moreFormatting",
        defaultMessage: "More formatting"
    },
    textFormatting: {
        id: "fabric.editor.textFormatting",
        defaultMessage: "Text formatting"
    },
    textFormat: {
        id: "fabric.editor.textFormat",
        defaultMessage: "Format text"
    },
    bold: {
        id: "fabric.editor.bold",
        defaultMessage: "Bold"
    },
    italic: {
        id: "fabric.editor.italic",
        defaultMessage: "Italic"
    },
    on: {
        id: "fabric.editor.on",
        defaultMessage: "{formattingType} On"
    },
    off: {
        id: "fabric.editor.off",
        defaultMessage: "{formattingType} Off"
    },
    textStyles: {
        id: "fabric.editor.textStyles",
        defaultMessage: "{blockTypeName} Text styles"
    },
    textStylesTooltip: {
        id: "fabric.editor.textStylesTooltip",
        defaultMessage: "Text styles"
    },
    textFormattingOff: {
        id: "fabric.editor.text.formatting.off",
        defaultMessage: "Text formatting Off"
    },
    navigateToEditorToolbar: {
        id: "fabric.editor.navigate.toolbar.editor",
        defaultMessage: "Navigate to editor toolbar"
    },
    navigateToFloatingToolbar: {
        id: "fabric.editor.navigate.toolbar.floating",
        defaultMessage: "Navigate to floating toolbar"
    },
    askAI: {
        id: "fabric.editor.navigate.toolbar.askAI",
        defaultMessage: "Ask AI"
    },
    selectionToolbarOverflowMenuTooltip: {
        id: "fabric.editor.selectionToolbarOverflowMenuTooltip",
        defaultMessage: "More options"
    }
});
module.exports["toolbarMessages"] = $3c028c29e12ff5ff$export$81b075fd34c2f0bb;

});

parcelRegister("fKJ7J", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $65facb8c38219af1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    tableScrollRegion: {
        id: "fabric.editor.tableScrollRegion",
        defaultMessage: "Table scroll region"
    },
    tableOptions: {
        id: "fabric.editor.tableOptions",
        defaultMessage: "Table options"
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: "fabric.editor.tableResizeIncreaseScreenReaderInformation",
        defaultMessage: "Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}."
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: "fabric.editor.tableResizeDecreaseScreenReaderInformation",
        defaultMessage: "Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}."
    },
    headerRow: {
        id: "fabric.editor.headerRow",
        defaultMessage: "Header row"
    },
    headerColumn: {
        id: "fabric.editor.headerColumn",
        defaultMessage: "Header column"
    },
    numberedColumn: {
        id: "fabric.editor.numberedColumn",
        defaultMessage: "Numbered column"
    },
    collapseTable: {
        id: "fabric.editor.collapseTable",
        defaultMessage: "Collapse table"
    },
    resizeTable: {
        id: "fabric.editor.tables.resizeTable",
        defaultMessage: "Resize table"
    },
    insertColumn: {
        id: "fabric.editor.insertColumn",
        defaultMessage: "Insert column right"
    },
    addColumnLeft: {
        id: "fabric.editor.addColumnLeft",
        defaultMessage: "Add column left"
    },
    addColumnRight: {
        id: "fabric.editor.addColumnRight",
        defaultMessage: "Add column right"
    },
    insertColumnDrag: {
        id: "fabric.editor.insertColumnDrag",
        defaultMessage: "Insert column"
    },
    removeColumns: {
        id: "fabric.editor.removeColumns",
        defaultMessage: "Delete {0, plural, one {column} other {columns}}"
    },
    insertRow: {
        id: "fabric.editor.insertRow",
        defaultMessage: "Insert row below"
    },
    addRowAbove: {
        id: "fabric.editor.addRowAbove",
        defaultMessage: "Add row above"
    },
    addRowBelow: {
        id: "fabric.editor.addRowBelow",
        defaultMessage: "Add row below"
    },
    moveColumnLeft: {
        id: "fabric.editor.moveColumnLeft",
        defaultMessage: "Move {0, plural, one {column} other {columns}} left"
    },
    moveColumnLeftHelpDialogLabel: {
        id: "fabric.editor.moveColumnLeftHelpDialogLabel",
        defaultMessage: "Move column left"
    },
    moveColumnRight: {
        id: "fabric.editor.moveColumnRight",
        defaultMessage: "Move {0, plural, one {column} other {columns}} right"
    },
    moveColumnRightHelpDialogLabel: {
        id: "fabric.editor.moveColumnRightHelpDialogLabel",
        defaultMessage: "Move column right"
    },
    moveRowUp: {
        id: "fabric.editor.moveRowUp",
        defaultMessage: "Move {0, plural, one {row} other {rows}} up"
    },
    moveRowUpHelpDialogLabel: {
        id: "fabric.editor.moveRowUpHelpDialogLabel",
        defaultMessage: "Move row up"
    },
    moveRowDown: {
        id: "fabric.editor.moveDownDown",
        defaultMessage: "Move {0, plural, one {row} other {rows}} down"
    },
    moveRowDownHelpDialogLabel: {
        id: "fabric.editor.moveRowDownHelpDialogLabel",
        defaultMessage: "Move row down"
    },
    insertRowDrag: {
        id: "fabric.editor.insertRowDrag",
        defaultMessage: "Insert row"
    },
    removeRows: {
        id: "fabric.editor.removeRows",
        defaultMessage: "Delete {0, plural, one {row} other {rows}}"
    },
    rowNumbers: {
        id: "fabrid.editor.rowNumbers",
        defaultMessage: "Row numbers"
    },
    numberedRows: {
        id: "fabrid.editor.numberedRows",
        defaultMessage: "Numbered rows"
    },
    rowsAreInserted: {
        id: "fabric.editor.rowsAreInserted",
        defaultMessage: "{count, plural, one {A row has been} other {{count} rows have been}} inserted"
    },
    rowsAreRemoved: {
        id: "fabric.editor.rowsAreRemoved",
        defaultMessage: "{count, plural, one {The row has been} other {{count} rows have been}} removed"
    },
    rowSelected: {
        id: "fabric.editor.rowSelected",
        defaultMessage: "Row {index} of {total} selected"
    },
    rowMovedUp: {
        id: "fabric.editor.rowMovedUp",
        defaultMessage: "Row moved up to {index} of {total}"
    },
    rowMovedDown: {
        id: "fabric.editor.rowMovedDown",
        defaultMessage: "Row moved down to {index} of {total}"
    },
    columnsAreInserted: {
        id: "fabric.editor.columnsAreInserted",
        defaultMessage: "{count, plural, one {A column has been} other {{count} columns have been}} inserted"
    },
    columnsAreRemoved: {
        id: "fabric.editor.columnsAreRemoved",
        defaultMessage: "{count, plural, one {The column has been} other {{count} columns have been}} removed"
    },
    columnSelected: {
        id: "fabric.editor.columnSelected",
        defaultMessage: "Column {index} of {total} selected"
    },
    columnMovedLeft: {
        id: "fabric.editor.columnMovedLeft",
        defaultMessage: "Column moved left to {index} of {total}"
    },
    columnMovedRight: {
        id: "fabric.editor.columnMovedRight",
        defaultMessage: "Column moved right to {index} of {total}"
    },
    cellOptions: {
        id: "fabric.editor.cellOptions",
        defaultMessage: "Cell options"
    },
    confirmDeleteLinkedModalOKButton: {
        id: "fabric.editor.tables.confirmDeleteLinkedModalOKButton",
        defaultMessage: "Delete"
    },
    confirmDeleteLinkedModalMessage: {
        id: "fabric.editor.tables.confirmDeleteLinkedModalMessage",
        defaultMessage: "Deleting {nodeName} will break anything connected to it."
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: "fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix",
        defaultMessage: "Deleting"
    },
    confirmModalCheckboxLabel: {
        id: "fabric.editor.floatingToolbar.confirmModalCheckboxLabel",
        defaultMessage: "Also delete connected elements"
    },
    deleteElementTitle: {
        id: "fabric.editor.extension.deleteElementTitle",
        defaultMessage: "Delete element"
    },
    unnamedSource: {
        id: "fabric.editor.extension.sourceNoTitledName",
        defaultMessage: "this element"
    },
    adjustColumns: {
        id: "fabric.editor.tables.adjustColumn",
        defaultMessage: "Adjust column"
    },
    cornerControl: {
        id: "fabric.editor.cornerControl",
        defaultMessage: "Highlight table"
    },
    cellBackground: {
        id: "fabric.editor.cellBackground",
        defaultMessage: "Cell background"
    },
    cellAlignment: {
        id: "fabric.editor.table.cellAlignment",
        defaultMessage: "Alignment"
    },
    cellAlignmentTop: {
        id: "fabric.editor.table.cellAlignmentTop",
        defaultMessage: "Top"
    },
    cellAlignmentMiddle: {
        id: "fabric.editor.table.cellAlignmentMiddle",
        defaultMessage: "Middle"
    },
    cellAlignmentBottom: {
        id: "fabric.editor.table.cellAlignmentBottom",
        defaultMessage: "Bottom"
    },
    backgroundColor: {
        id: "fabric.editor.backgroundColor",
        defaultMessage: "Background color"
    },
    mergeCells: {
        id: "fabric.editor.mergeCells",
        defaultMessage: "Merge cells"
    },
    splitCell: {
        id: "fabric.editor.splitCell",
        defaultMessage: "Split cell"
    },
    clearCells: {
        id: "fabric.editor.clearCells",
        defaultMessage: "Clear {0, plural, one {cell} other {cells}}"
    },
    sortColumnASC: {
        id: "fabric.editor.sortColumnASC",
        defaultMessage: "Sort column A \u2192 Z"
    },
    sortColumnDESC: {
        id: "fabric.editor.sortColumnDESC",
        defaultMessage: "Sort column Z \u2192 A"
    },
    sortColumnIncreasing: {
        id: "fabric.editor.sortColumnIncreasing",
        defaultMessage: "Sort increasing"
    },
    sortColumnDecreasing: {
        id: "fabric.editor.sortColumnDecreasing",
        defaultMessage: "Sort decreasing"
    },
    canNotSortTable: {
        id: "fabric.editor.canNotSortTable",
        defaultMessage: "\u26A0\uFE0F You can't sort a table with merged cells"
    },
    canNotSortTableNoIcon: {
        id: "fabric.editor.canNotSortTableNoIcon",
        defaultMessage: "You can't sort a table with merged cells"
    },
    canNotMoveColumnLeftWithMergedCells: {
        id: "editor-common.messages.table.canNotMoveColumnLeftWithMergedCells",
        defaultMessage: "You can't move a column left with merged cells"
    },
    canNotMoveColumnRightWithMergedCells: {
        id: "editor-common.messages.table.canNotMoveColumnRightWithMergedCells",
        defaultMessage: "You can't move a column right with merged cells"
    },
    canNotMoveRowDownWithMergedCells: {
        id: "editor-common.messages.table.canNotMoveRowDownWithMergedCells",
        defaultMessage: "You can't move a row down with merged cells"
    },
    canNotMoveRowUpWithMergedCells: {
        id: "editor-common.messages.table.canNotMoveRowUpWithMergedCells",
        defaultMessage: "You can't move a row up with merged cells"
    },
    distributeColumns: {
        id: "fabric.editor.distributeColumns",
        defaultMessage: "Distribute columns"
    },
    fitToContent: {
        id: "fabric.editor.fitToContent",
        defaultMessage: "Fit to content"
    },
    lockColumnWidths: {
        id: "fabric.editor.lockColumns",
        defaultMessage: "Fixed column widths"
    },
    rowControl: {
        id: "fabric.editor.rowControl",
        defaultMessage: "Highlight row"
    },
    rowDragHandle: {
        id: "fabric.editor.rowDragHandle",
        defaultMessage: "Row options"
    },
    dragHandleZone: {
        id: "fabric.editor.dragHandleZone",
        defaultMessage: "Activate drag handle zone"
    },
    columnDragHandle: {
        id: "fabric.editor.columnDragHandle",
        defaultMessage: "Column options"
    },
    fullWidthLabel: {
        id: "fabric.editor.tableFullWidthLabel",
        defaultMessage: "Full-width"
    },
    startedColumnResize: {
        id: "fabric.editor.tables.startedColumnResize",
        defaultMessage: "Started column resize"
    },
    focusedOtherResize: {
        id: "fabric.editor.tables.otherResize",
        defaultMessage: "{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}"
    },
    changedColumnWidth: {
        id: "fabric.editor.tables.columnWidth",
        defaultMessage: "{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}"
    },
    columnResizeStop: {
        id: "fabric.editor.tables.resizeStop",
        defaultMessage: "Stopped resize"
    },
    columnResizeOverflow: {
        id: "fabric.editor.tables.columnResizeOverflow",
        defaultMessage: "You can only resize this column while the table has a scroll bar."
    },
    columnResizeLast: {
        id: "fabric.editor.tables.columnResizeLast",
        defaultMessage: "You can only resize this column to the left."
    },
    tableAlignmentOptions: {
        id: "fabric.editor.tableAlignmentOptions",
        defaultMessage: "Alignment options"
    },
    alignTableCenter: {
        id: "fabric.editor.alignTableCenter",
        defaultMessage: "Align center"
    },
    alignTableLeft: {
        id: "fabric.editor.alignTableLeft",
        defaultMessage: "Align left"
    }
});
module.exports["messages"] = $65facb8c38219af1$export$defe85febe8b728c;

});

parcelRegister("h4y3S", function(module, exports) {
// Common Translations will live here

var $kSwu1 = parcelRequire("kSwu1");

const $239df8587842c46f$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unorderedList: {
        id: "fabric.editor.unorderedList",
        defaultMessage: "Bullet list"
    },
    unorderedListDescription: {
        id: "fabric.editor.unorderedList.description",
        defaultMessage: "Create an unordered list"
    },
    bulletedList: {
        id: "fabric.editor.bulletedList",
        defaultMessage: "Bulleted list"
    },
    orderedList: {
        id: "fabric.editor.orderedList",
        defaultMessage: "Numbered list"
    },
    orderedListDescription: {
        id: "fabric.editor.orderedList.description",
        defaultMessage: "Create an ordered list"
    },
    lists: {
        id: "fabric.editor.lists",
        defaultMessage: "Lists"
    },
    listsFormat: {
        id: "fabric.editor.listsFormat",
        defaultMessage: "List formatting"
    }
});
module.exports["messages"] = $239df8587842c46f$export$defe85febe8b728c;

});

parcelRegister("bOjiE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $01931d5a9b239683$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    undo: {
        id: "fabric.editor.undo",
        defaultMessage: "Undo"
    },
    redo: {
        id: "fabric.editor.redo",
        defaultMessage: "Redo"
    }
});
module.exports["messages"] = $01931d5a9b239683$export$defe85febe8b728c;

});

parcelRegister("4rQbz", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3c4a23296d3a3a09$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    statusEditorLabel: {
        id: "fabric.editor.statusEditorLabel",
        defaultMessage: "Status editor"
    },
    placeholder: {
        id: "fabric.editor.statusPlaceholder",
        defaultMessage: "Set a status"
    },
    editText: {
        id: "fabric.editor.editStatusText",
        defaultMessage: "Edit Status"
    },
    editColor: {
        id: "fabric.editor.editStatusColor",
        defaultMessage: "Edit Status Color"
    },
    statusPickerOpenedAlert: {
        id: "fabric.editor.statusPickerOpenedAlert",
        defaultMessage: "Status editor popup opened, press Tab to access popup"
    }
});
module.exports["messages"] = $3c4a23296d3a3a09$export$defe85febe8b728c;

});

parcelRegister("f4Xrl", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $6de6762133157361$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    editText: {
        id: "fabric.editor.editDateText",
        defaultMessage: "Edit Date"
    },
    invalidDateError: {
        id: "fabric.editor.invalidDateError",
        defaultMessage: "Enter a valid date"
    },
    onKeyUpDownText: {
        id: "fabric.editor.upDown",
        defaultMessage: "On the use of up and down arrow keys into the following input field, the date will update below"
    },
    datePickerOpenedAlert: {
        id: "fabric.editor.datePickerOpenedAlert",
        defaultMessage: "Date editor popup opened, press Tab to access popup"
    }
});
module.exports["messages"] = $6de6762133157361$export$defe85febe8b728c;

});

parcelRegister("72OpT", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1f915849a9b2a454$export$81b075fd34c2f0bb = (0, $kSwu1.defineMessages)({
    singleColumn: {
        id: "fabric.editor.single",
        defaultMessage: "Single column layout"
    },
    twoColumns: {
        id: "fabric.editor.twoColumns",
        defaultMessage: "Two columns layout"
    },
    singleColumnAdvancedLayout: {
        id: "fabric.editor.singleColumns",
        defaultMessage: "1 Column layout"
    },
    twoColumnsAdvancedLayout: {
        id: "fabric.editor.twoColumns",
        defaultMessage: "2 Column layout"
    },
    threeColumns: {
        id: "fabric.editor.threeColumns",
        defaultMessage: "Three columns layout"
    },
    threeColumnsAdvancedLayout: {
        id: "fabric.editor.threeColumns",
        defaultMessage: "3 Column layout"
    },
    fourColumns: {
        id: "fabric.editor.fourColumns",
        defaultMessage: "4 Column layout"
    },
    fiveColumns: {
        id: "fabric.editor.fiveColumns",
        defaultMessage: "5 Column layout"
    },
    rightSidebar: {
        id: "fabric.editor.rightSidebar",
        defaultMessage: "Right sidebar layout"
    },
    leftSidebar: {
        id: "fabric.editor.leftSidebar",
        defaultMessage: "Left sidebar layout"
    },
    threeColumnsWithSidebars: {
        id: "fabric.editor.threeColumnsWithSidebars",
        defaultMessage: "Three columns with sidebars layout"
    },
    threeColumnsWithLeftSidebars: {
        id: "fabric.editor.threeColumnsWithLeftSidebars",
        defaultMessage: "Three columns with left sidebar layout"
    },
    threeColumnsWithRightSidebars: {
        id: "fabric.editor.threeColumnsWithRightSidebars",
        defaultMessage: "Three columns with right sidebar layout"
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: "fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel",
        defaultMessage: "Layout options"
    },
    layoutPlaceholder: {
        id: "fabric.editor.layout.placeholder",
        defaultMessage: "Add content"
    },
    controlslayoutPlaceholder: {
        id: "fabric.editor.layout.controls.placeholder",
        defaultMessage: "/ to insert"
    },
    columnOption: {
        id: "fabric.editor.layout.columnOption",
        defaultMessage: "{count, plural, one {{count} Column} other {{count} Columns}}"
    },
    resizeLayout: {
        id: "fabric.editor.layout.resizeLayout",
        defaultMessage: "Resize layout"
    },
    distributeColumns: {
        id: "fabric.editor.layout.distributeColumns",
        defaultMessage: "Distribute columns"
    },
    addColumnLeft: {
        id: "fabric.editor.layout.addColumnLeft",
        defaultMessage: "Add column left"
    },
    addColumnRight: {
        id: "fabric.editor.layout.addColumnRight",
        defaultMessage: "Add column right"
    },
    insertColumnLeft: {
        id: "fabric.editor.layout.insertColumnLeft",
        defaultMessage: "Insert column left"
    },
    insertColumnRight: {
        id: "fabric.editor.layout.insertColumnRight",
        defaultMessage: "Insert column right"
    },
    alignColumn: {
        id: "fabric.editor.layout.alignColumn",
        defaultMessage: "Alignment"
    },
    alignColumnTop: {
        id: "fabric.editor.layout.alignColumnTop",
        defaultMessage: "Top"
    },
    alignColumnMiddle: {
        id: "fabric.editor.layout.alignColumnMiddle",
        defaultMessage: "Center"
    },
    alignColumnBottom: {
        id: "fabric.editor.layout.alignColumnBottom",
        defaultMessage: "Bottom"
    },
    deleteColumn: {
        id: "fabric.editor.layout.deleteColumn",
        defaultMessage: "{count, plural, one {Delete column} other {Delete columns}}"
    }
});
module.exports["toolbarMessages"] = $1f915849a9b2a454$export$81b075fd34c2f0bb;

});

parcelRegister("jexwB", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4afe0b841f7d6cfa$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    indent: {
        id: "fabric.editor.indent",
        defaultMessage: "Indent"
    },
    outdent: {
        id: "fabric.editor.outdent",
        defaultMessage: "Outdent"
    }
});
module.exports["messages"] = $4afe0b841f7d6cfa$export$defe85febe8b728c;

});

parcelRegister("icr1E", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $02f4b040b262fe89$export$8a0e7c3f8f5b8868 = (0, $kSwu1.defineMessages)({
    editors: {
        id: "fabric.editor.editors",
        defaultMessage: "Editors"
    },
    anonymousCollaborator: {
        id: "fabric.editor.anonymous-collaborator",
        defaultMessage: "Anonymous collaborator"
    },
    agentWithUser: {
        id: "fabric.editor.agent-with-user",
        defaultMessage: "{agentName} with {userName}"
    }
});
module.exports["avatarGroupMessages"] = $02f4b040b262fe89$export$8a0e7c3f8f5b8868;

});

parcelRegister("dN8GG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fc2daf17fe19aeaf$export$b46a930e1a386b2e = (0, $kSwu1.defineMessages)({
    find: {
        id: "fabric.editor.find",
        defaultMessage: "Find"
    },
    matchCase: {
        id: "fabric.editor.matchCase",
        defaultMessage: "Match case"
    },
    findNext: {
        id: "fabric.editor.findNext",
        defaultMessage: "Find next"
    },
    findPrevious: {
        id: "fabric.editor.findPrevious",
        defaultMessage: "Find previous"
    },
    findReplaceDialogAriaLabel: {
        id: "fabric.editor.findReplaceDialogAriaLabel",
        defaultMessage: "Find and Replace"
    },
    findDialogAriaLabel: {
        id: "fabric.editor.findDialogAriaLabel",
        defaultMessage: "Find"
    },
    closeFindReplaceDialog: {
        id: "fabric.editor.closeFindReplaceDialog",
        defaultMessage: "Close"
    },
    noResultsFound: {
        id: "fabric.editor.noResultsFound",
        defaultMessage: "No results"
    },
    resultsCount: {
        id: "fabric.editor.resultsCount",
        defaultMessage: "{selectedMatchPosition} of {totalResultsCount}"
    },
    findReplaceToolbarButton: {
        id: "fabric.editor.findReplaceToolbarButton",
        defaultMessage: "Find and replace"
    },
    replaceWith: {
        id: "fabric.editor.replaceWith",
        defaultMessage: "Replace with"
    },
    replace: {
        id: "fabric.editor.replace",
        defaultMessage: "Replace"
    },
    replaceAll: {
        id: "fabric.editor.replaceAll",
        defaultMessage: "Replace all"
    },
    replaceSuccess: {
        id: "fabric.editor.replaceSuccess",
        defaultMessage: "{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}"
    }
});
module.exports["findReplaceMessages"] = $fc2daf17fe19aeaf$export$b46a930e1a386b2e;

});

parcelRegister("8Ajok", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $15bce6c2236dcf2a$export$effb4ee8b6f74abe = (0, $kSwu1.defineMessages)({
    textColor: {
        id: "fabric.editor.textColor",
        defaultMessage: "{selectedColorName} Text color"
    },
    textColorTooltip: {
        id: "fabric.editor.textColorTooltip",
        defaultMessage: "Text color"
    },
    textColorHighlightTooltip: {
        id: "fabric.editor.textColorHighlightTooltip",
        defaultMessage: "Text and highlight color"
    }
});
module.exports["textColorMessages"] = $15bce6c2236dcf2a$export$effb4ee8b6f74abe;

});

parcelRegister("hdn7b", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9a525ff9393f5523$export$273d864e9e6d0b1f = (0, $kSwu1.defineMessages)({
    taskPlaceholder: {
        id: "fabric.editor.taskPlaceholder",
        defaultMessage: "Type your action, use '@' to assign to someone."
    },
    decisionPlaceholder: {
        id: "fabric.editor.decisionPlaceholder",
        defaultMessage: "Add a decision\u2026"
    },
    editAccessTitle: {
        id: "fabric.editor.editAccessTitle",
        defaultMessage: "You need edit access"
    },
    requestToEditDescription: {
        id: "fabric.editor.requestToEditDescription",
        defaultMessage: "When you request access, the page owner will receive a notification."
    },
    requestToEdit: {
        id: "fabric.editor.requestToEdit",
        defaultMessage: "Request to edit"
    },
    dismiss: {
        id: "fabric.editor.requestToEditDismiss",
        defaultMessage: "Dismiss"
    },
    markTaskAsCompleted: {
        id: "fabric.editor.taskDecision.markTaskAsCompleted",
        defaultMessage: "Mark task as completed"
    },
    markTaskAsNotCompleted: {
        id: "fabric.editor.taskDecision.markTaskAsNotCompleted",
        defaultMessage: "Mark task as not completed"
    },
    taskList: {
        id: "fabric.editor.taskList",
        defaultMessage: "Task list"
    },
    decisionAriaLabel: {
        id: "fabric.editor.decisionAriaLabel",
        defaultMessage: "Decision"
    },
    undefinedDecisionAriaLabel: {
        id: "fabric.editor.undefinedDecisionAriaLabel",
        defaultMessage: "Undefined decision"
    }
});
module.exports["tasksAndDecisionsMessages"] = $9a525ff9393f5523$export$273d864e9e6d0b1f;

});

parcelRegister("WnqKg", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e1b192c8038709c3$export$ee8ab8a034b5a8bd = (0, $kSwu1.defineMessages)({
    placeholderTextPlaceholder: {
        id: "fabric.editor.placeholderTextPlaceholder",
        defaultMessage: "Add placeholder text"
    },
    shortEmptyNodePlaceholderText: {
        id: "fabric.editor.shortEmptyNodePlaceholderText",
        defaultMessage: "/ to insert"
    },
    shortEmptyNodePlaceholderADFSlashShortcut: {
        id: "fabric.editor.shortEmptyNodePlaceholderSlash",
        defaultMessage: "/"
    },
    shortEmptyNodePlaceholderADFSuffix: {
        id: "fabric.editor.shortEmptyNodePlaceholderSuffix",
        defaultMessage: " to insert"
    },
    longEmptyNodePlaceholderText: {
        id: "fabric.editor.longEmptyNodePlaceholderText",
        defaultMessage: "Type / to insert elements"
    },
    longEmptyNodePlaceholderADFPrefix: {
        id: "fabric.editor.longEmptyNodePlaceholderPrefix",
        defaultMessage: "Type "
    },
    longEmptyNodePlaceholderADFSlashShortcut: {
        id: "fabric.editor.longEmptyNodePlaceholderSlash",
        defaultMessage: "/"
    },
    longEmptyNodePlaceholderADFSuffix: {
        id: "fabric.editor.longEmptyNodePlaceholderSuffix",
        defaultMessage: " to insert elements"
    },
    sourceSyncBlockPlaceholderText: {
        id: "fabric.editor.sourceSyncBlockPlaceholderText",
        defaultMessage: "Add content you want to reuse. Copy and paste this block to sync in other locations."
    },
    multiBodiedExtensionEmptyFramePlaceholderText: {
        id: "fabric.editor.multiBodiedExtensionEmptyFramePlaceholderText",
        defaultMessage: "Type / to insert elements"
    }
});
module.exports["placeholderTextMessages"] = $e1b192c8038709c3$export$ee8ab8a034b5a8bd;

});

parcelRegister("3IBFJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $88ca7590a2f69857$export$703e803e9cb0cea4 = (0, $kSwu1.defineMessages)({
    pasteOptions: {
        id: "fabric.editor.pasteOptions",
        defaultMessage: "Paste options"
    },
    plainText: {
        id: "fabric.editor.plainText",
        defaultMessage: "Use plain text"
    },
    markdown: {
        id: "fabric.editor.useMarkdown",
        defaultMessage: "Use Markdown"
    },
    richText: {
        id: "fabric.editor.richText",
        defaultMessage: "Use rich text"
    },
    plainTextAction: {
        id: "fabric.editor.plainTextAction",
        defaultMessage: "Plain text"
    },
    markdownAction: {
        id: "fabric.editor.useMarkdownAction",
        defaultMessage: "Markdown"
    },
    richTextAction: {
        id: "fabric.editor.richTextAction",
        defaultMessage: "Rich text"
    },
    pasteMenuActionsTitle: {
        id: "fabric.editor.pasteMenuActionsTitle",
        defaultMessage: "Paste actions"
    },
    pasteMenuActionsPasteAs: {
        id: "fabric.editor.pasteMenuActionsPasteAs",
        defaultMessage: "Paste as"
    }
});
module.exports["pasteOptionsToolbarMessages"] = $88ca7590a2f69857$export$703e803e9cb0cea4;

});

parcelRegister("2DRge", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $612eb86b1f0a8150$export$7bb18eb6f9170174 = (0, $kSwu1.defineMessages)({
    info: {
        id: "fabric.editor.info",
        defaultMessage: "Info"
    },
    note: {
        id: "fabric.editor.note",
        defaultMessage: "Note"
    },
    success: {
        id: "fabric.editor.success",
        defaultMessage: "Success"
    },
    warning: {
        id: "fabric.editor.warning",
        defaultMessage: "Warning"
    },
    error: {
        id: "fabric.editor.error",
        defaultMessage: "Error"
    },
    emoji: {
        id: "fabric.editor.panel.emoji",
        defaultMessage: "Add emoji"
    },
    custom: {
        id: "fabric.editor.panel.custom",
        defaultMessage: "Custom"
    },
    backgroundColor: {
        id: "fabric.editor.panel.backgroundColor",
        defaultMessage: "Background color"
    },
    panelsGroup: {
        id: "fabric.editor.panel.panelsGroup",
        defaultMessage: "Panel Types"
    }
});
module.exports["panelMessages"] = $612eb86b1f0a8150$export$7bb18eb6f9170174;

});

parcelRegister("725R2", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c324786560137251$export$33aafd5ccbbbd00a = (0, $kSwu1.defineMessages)({
    inviteItemTitle: {
        id: "fabric.editor.inviteItem.title",
        defaultMessage: "{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}"
    },
    mentionsAddLabel: {
        id: "fabric.editor.mentionsAddLabel",
        defaultMessage: "add-icon"
    },
    mentionsIconLabel: {
        id: "fabric.editor.mentionsIconLabel",
        defaultMessage: "Mention"
    },
    mentionsNodeLabel: {
        id: "fabric.editor.mentionNode.label",
        defaultMessage: "Tagged user"
    },
    unknownLabel: {
        id: "fabric.editor.unknown.label",
        defaultMessage: "Unknown"
    },
    inviteTeammateInvalidEmail: {
        id: "fabric.editor.inviteItem.invalidEmail",
        defaultMessage: "Enter a valid email address"
    },
    sendInvite: {
        id: "fabric.editor.inviteItem.sendInvite",
        defaultMessage: "Send request to invite teammate"
    },
    typeAheadSectionPeople: {
        id: "fabric.editor.typeAhead.mentionSection.people",
        defaultMessage: "People"
    },
    typeAheadSectionAgents: {
        id: "fabric.editor.typeAhead.mentionSection.agents",
        defaultMessage: "Agents"
    },
    typeAheadSectionAgentsLabsLozengeLabel: {
        id: "editor-common.messages.mentions.typeAheadSectionAgentsLabsLozengeLabel",
        defaultMessage: "Labs"
    },
    typeAheadSectionAgentsLoadError: {
        id: "editor-common.messages.mentions.typeAheadSectionAgentsLoadError",
        defaultMessage: "Unable to load agents"
    },
    typeAheadSectionAgentsRetry: {
        id: "editor-common.messages.mentions.typeAheadSectionAgentsRetry",
        defaultMessage: "Retry"
    }
});
module.exports["mentionMessages"] = $c324786560137251$export$33aafd5ccbbbd00a;

});

parcelRegister("f7SX8", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $92b6e840097ad746$export$83c85447c71428ba = (0, $kSwu1.defineMessages)({
    editorHelp: {
        id: "fabric.editor.editorHelp",
        defaultMessage: "Editor help"
    },
    helpDialogTips: {
        id: "fabric.editor.helpDialogTips",
        defaultMessage: "Press {keyMap} to quickly open this dialog at any time"
    },
    keyboardShortcuts: {
        id: "fabric.editor.keyboardShortcuts",
        defaultMessage: "Keyboard shortcuts"
    },
    markdown: {
        id: "fabric.editor.markdown",
        defaultMessage: "Markdown"
    },
    pastePlainText: {
        id: "fabric.editor.pastePlainText",
        defaultMessage: "Paste plain text"
    },
    CheckUncheckActionItem: {
        id: "fabric.editor.checkUncheckActionItem",
        defaultMessage: "Toggle action item"
    },
    InsertTableColumn: {
        id: "fabric.editor.insertTableColumn",
        defaultMessage: "Insert table column"
    },
    InsertTableRow: {
        id: "fabric.editor.insertTableRow",
        defaultMessage: "Insert table row"
    },
    altText: {
        id: "fabric.editor.altText",
        defaultMessage: "Alt text"
    },
    selectTableRow: {
        id: "fabric.editor.selectTableRow",
        defaultMessage: "Select table row"
    },
    selectTableColumn: {
        id: "fabric.editor.selectTableColumn",
        defaultMessage: "Select table column"
    },
    selectColumnResize: {
        id: "fabric.editor.selectColumnResize",
        defaultMessage: "Select column resize"
    },
    increaseSize: {
        id: "fabric.editor.increaseSize",
        defaultMessage: "Increase table or media size"
    },
    increaseElementSize: {
        id: "fabric.editor.increaseElementSize",
        defaultMessage: "Increase element size"
    },
    decreaseSize: {
        id: "fabric.editor.decreaseSize",
        defaultMessage: "Decrease table or media size"
    },
    decreaseElementSize: {
        id: "fabric.editor.decreaseElementSize",
        defaultMessage: "Decrease element size"
    },
    openCellOptions: {
        id: "fabric.editor.openCellOptions",
        defaultMessage: "Open cell options"
    },
    focusTableResizeHandle: {
        id: "fabric.editor.focusTableResizeHandle",
        defaultMessage: "Focus table resize handle"
    },
    selectDragHandle: {
        id: "fabric.editor.selectDragHandle",
        defaultMessage: "Select drag handle"
    },
    moveSelectionUp: {
        id: "fabric.editor.moveSelectionUp",
        defaultMessage: "Move selection up"
    },
    moveSelectionDown: {
        id: "fabric.editor.moveSelectionDown",
        defaultMessage: "Move selection down"
    },
    moveSelectionLeft: {
        id: "fabric.editor.moveSelectionLeft",
        defaultMessage: "Move selection left"
    },
    moveSelectionRight: {
        id: "fabric.editor.moveSelectionRight",
        defaultMessage: "Move selection right"
    },
    closeHelpDialog: {
        id: "fabric.editor.closeHelpDialog",
        defaultMessage: "Close help dialog"
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: "fabric.editor.quickInsert",
        defaultMessage: "Quick insert"
    },
    highlightColor: {
        id: "fabric.editor.highlightColor",
        defaultMessage: "Toggle highlight color palette"
    }
});
module.exports["helpDialogMessages"] = $92b6e840097ad746$export$83c85447c71428ba;

});

parcelRegister("hzZPp", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e5b8dc2ecf5c1095$export$456100c8374b6011 = (0, $kSwu1.defineMessages)({
    clearColors: {
        id: "fabric.editor.highlight.clearColors",
        defaultMessage: "Clear all colors"
    },
    highlight: {
        id: "fabric.editor.highlight",
        defaultMessage: "Highlight color"
    },
    highlightFloatingToolbar: {
        id: "fabric.editor.highlightFloatingToolbar",
        defaultMessage: "Highlight"
    },
    removeColor: {
        id: "fabric.editor.highlight.removeColor",
        defaultMessage: "Remove color"
    },
    removeHighlight: {
        id: "fabric.editor.highlight.removeHighlight",
        defaultMessage: "Remove highlight"
    }
});
module.exports["highlightMessages"] = $e5b8dc2ecf5c1095$export$456100c8374b6011;

});

parcelRegister("i6cU6", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a4d3e6d93371f9e7$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    dragToMove: {
        id: "fabric.editor.blockControlDragHandleMove",
        defaultMessage: "Drag to move"
    },
    dragToMoveClickToOpen: {
        id: "fabric.editor.blockControlDragHandleMoveOrOpen",
        defaultMessage: "Drag to move {br} Click to open menu"
    },
    dragToRearrange: {
        id: "fabric.editor.blockControlDragHandleRearrange",
        defaultMessage: "Drag to rearrange"
    },
    insert: {
        id: "fabric.editor.blockControlInsert",
        defaultMessage: "Insert"
    },
    collapseSection: {
        id: "editor-common.messages.block-controls.collapseSection",
        defaultMessage: "Collapse section"
    },
    expandSection: {
        id: "editor-common.messages.block-controls.expandSection",
        defaultMessage: "Expand section"
    },
    moveUp: {
        id: "fabric.editor.blockControlMoveUp",
        defaultMessage: "Move up"
    },
    moveDown: {
        id: "fabric.editor.blockControlMoveDown",
        defaultMessage: "Move down"
    },
    movedup: {
        id: "fabric.editor.blockControlMovedUp",
        defaultMessage: "Content has been moved up"
    },
    movedDown: {
        id: "fabric.editor.blockControlMovedDown",
        defaultMessage: "Content has been moved down"
    },
    moveLeft: {
        id: "fabric.editor.blockControlMoveLeft",
        defaultMessage: "Move left"
    },
    moveRight: {
        id: "fabric.editor.blockControlMoveRight",
        defaultMessage: "Move right"
    },
    delete: {
        id: "fabric.editor.blockControlDelete",
        defaultMessage: "Delete"
    }
});
module.exports["messages"] = $a4d3e6d93371f9e7$export$defe85febe8b728c;

});

parcelRegister("7BkLi", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b6e3ba2975d823bc$export$423a6caa00ac48ec = (0, $kSwu1.defineMessages)({
    aspectRatioSelectionOriginal: {
        id: "editor.imageEditor.aspectRatio.original",
        defaultMessage: "Original"
    },
    aspectRatioSelectionCustom: {
        id: "editor.imageEditor.aspectRatio.custom",
        defaultMessage: "Custom"
    },
    aspectRatioSelectionSquare: {
        id: "editor.imageEditor.aspectRatio.square",
        defaultMessage: "Square"
    },
    aspectRatioSelectionCircle: {
        id: "editor.imageEditor.aspectRatio.circle",
        defaultMessage: "Circle"
    },
    aspectRatioSelectionLandscape: {
        id: "editor.imageEditor.aspectRatio.landscape",
        defaultMessage: "Landscape"
    },
    aspectRatioSelectionPortrait: {
        id: "editor.imageEditor.aspectRatio.portrait",
        defaultMessage: "Portrait"
    },
    aspectRatioSelectionWide: {
        id: "editor.imageEditor.aspectRatio.wide",
        defaultMessage: "Wide"
    },
    squareButton: {
        id: "editor.imageEditor.aspectRatio.squareButton",
        defaultMessage: "Square 1:1"
    },
    circleButton: {
        id: "editor.imageEditor.aspectRatio.circleButton",
        defaultMessage: "Circle 1:1"
    },
    landscapeButton: {
        id: "editor.imageEditor.aspectRatio.landscapeButton",
        defaultMessage: "Landscape 4:3"
    },
    portraitButton: {
        id: "editor.imageEditor.aspectRatio.portraitButton",
        defaultMessage: "Portrait 3:4"
    },
    wideButton: {
        id: "editor.imageEditor.aspectRatio.wideButton",
        defaultMessage: "Wide 16:9"
    },
    cancelButton: {
        id: "editor.imageEditor.cancel",
        defaultMessage: "Cancel"
    },
    doneButton: {
        id: "editor.imageEditor.done",
        defaultMessage: "Done"
    },
    savingButton: {
        id: "editor.imageEditor.saving",
        defaultMessage: "Saving..."
    }
});
module.exports["mediaEditingMessages"] = $b6e3ba2975d823bc$export$423a6caa00ac48ec;

});

parcelRegister("8bmf7", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fa9c9d40ca82f628$export$6bc8062c04c761fa = (0, $kSwu1.defineMessages)({
    selectionExtensionDropdownButtonLabel: {
        id: "fabric.editor.selectionExtensionDropdownButtonLabel",
        defaultMessage: "Select app"
    },
    externalExtensionsHeading: {
        id: "fabric.editor.externalExtensionsHeading",
        defaultMessage: "Apps"
    }
});
module.exports["selectionExtensionMessages"] = $fa9c9d40ca82f628$export$6bc8062c04c761fa;

});

parcelRegister("7uaqq", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $439eac1ede48b61f$export$b0226831bf5c0d3e = (0, $kSwu1.defineMessages)({
    toolbarAppears: {
        id: "fabric.editor.toolbarAppears",
        defaultMessage: "Toolbar appears"
    },
    toolbarPositionInline: {
        id: "fabric.editor.toolbarPositionInline",
        defaultMessage: "In-line with text"
    },
    toolbarPositionFixedAtTop: {
        id: "fabric.editor.toolbarPositionFixedAtTop",
        defaultMessage: "Fixed at top"
    },
    toolbarPositionUnpined: {
        id: "fabric.editor.toolbarPositionUnpined",
        defaultMessage: "Pin the toolbar at the top"
    },
    toolbarPositionPinedAtTop: {
        id: "fabric.editor.toolbarPositionPinedAtTop",
        defaultMessage: "Unpin the toolbar"
    },
    toolbarPositionUnpinnedConcise: {
        id: "fabric.editor.toolbarPositionUnpinnedConcise",
        defaultMessage: "Pin toolbar to top"
    }
});
module.exports["selectionToolbarMessages"] = $439eac1ede48b61f$export$b0226831bf5c0d3e;

});

parcelRegister("lsQud", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $66fbde4b3acc082d$export$8ea7f7e979b71fa5 = (0, $kSwu1.defineMessages)({
    panelLabel: {
        id: "fabric.editor.contextPanel.panelLabel",
        defaultMessage: "Context panel"
    },
    panelContentLabel: {
        id: "fabric.editor.contextPanel.panelContentLabel",
        defaultMessage: "Scrollable context panel content"
    }
});
module.exports["contextPanelMessages"] = $66fbde4b3acc082d$export$8ea7f7e979b71fa5;

});

parcelRegister("iInrd", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $cfc0c9a9d3bed9e5$export$8448461a71ae48a1 = (0, $kSwu1.defineMessages)({
    toolbarIconLabel: {
        id: "editor.trackChanges.toolbarIconLabel",
        defaultMessage: "View changes"
    },
    removed: {
        id: "editor.trackChanges.removed",
        defaultMessage: "Removed"
    },
    added: {
        id: "editor.trackChanges.added",
        defaultMessage: "Added"
    }
});
module.exports["trackChangesMessages"] = $cfc0c9a9d3bed9e5$export$8448461a71ae48a1;

});

parcelRegister("aI2Eh", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $ff1f8bf9c08f6a2f$export$254768729b492c8b = (0, $kSwu1.defineMessages)({
    copySyncBlockLabel: {
        id: "fabric.editor.copySyncBlock",
        defaultMessage: "Copy"
    },
    copySyncedBlockTooltip: {
        id: "fabric.editor.copySyncedBlockTooltip",
        defaultMessage: "Copy synced block"
    },
    copyToSyncLabel: {
        id: "fabric.editor.copyToSyncLabel",
        defaultMessage: "Copy to sync"
    },
    editSourceLabel: {
        id: "fabric.editor.editSourceLabel",
        defaultMessage: "Edit source"
    },
    editSourceTooltip: {
        id: "fabric.editor.editSourceTooltipEnabled",
        defaultMessage: "Edit synced content at source location"
    },
    editSourceTooltipDisabled: {
        id: "fabric.editor.editSourceTooltipDisabled",
        defaultMessage: "Source link is not currently available"
    },
    syncBlockGroup: {
        id: "fabric.editor.syncBlockGroup",
        defaultMessage: "Sync Block Types"
    },
    syncedBlockLabel: {
        id: "fabric.editor.syncedBlock.label.text",
        defaultMessage: "Synced block"
    },
    sourceSyncedBlockLabel: {
        id: "fabric.editor.sourceSyncedBlock.label.text",
        defaultMessage: "Source synced block"
    },
    unsyncedBlockLabel: {
        id: "fabric.editor.unsyncedBlock.label.text",
        defaultMessage: "Unsynced block"
    },
    permissionDeniedHeading: {
        id: "fabric.editor.syncedBlockPermissionDeniedHeading",
        defaultMessage: "Request access to view synced block"
    },
    permissionDeniedDescription: {
        id: "fabric.editor.syncedBlockPermissionDeniedDescription",
        defaultMessage: "You don't have access to view the source content of this synced block."
    },
    permissionDeniedAltText: {
        id: "fabric.editor.syncedBlockPermissionDeniedIconAltText",
        defaultMessage: "Permission denied."
    },
    requestAccessButton: {
        id: "fabric.editor.requestAccessToSyncedBlock",
        defaultMessage: "Request access"
    },
    accessRequested: {
        id: "fabric.editor.accessToSyncedBlockRequested",
        defaultMessage: "Access requested"
    },
    requestAccessError: {
        id: "fabric.editor.requestAccessToSyncedBlockError",
        defaultMessage: "Something went wrong. Click to try again"
    },
    sourceSyncBlockTooltip: {
        id: "fabric.editor.sourceSyncBlockTooltip",
        defaultMessage: "When you edit this source block it will update across synced locations."
    },
    defaultSyncBlockTooltip: {
        id: "fabric.editor.sourceSyncBlockTooltip",
        defaultMessage: "Synced block"
    },
    referenceSyncBlockTooltip: {
        id: "fabric.editor.referenceSyncBlockTooltip",
        defaultMessage: "Synced from: {title}"
    },
    unpublishedLocalReferenceAvailabilityTooltip: {
        id: "editor-common.messages.syncBlock.unpublishedLocalReferenceAvailabilityTooltip",
        defaultMessage: "{sourceType, select, page {Publish the page to make the source synced block content available in other locations.} blog {Publish the blog to make the source synced block content available in other locations.} jiraWorkItem {Publish the work item to make the source synced block content available in other locations.} other {Publish to make the source synced block content available in other locations.}}"
    },
    unpublishedSourceAvailabilityTooltip: {
        id: "editor-common.messages.syncBlock.unpublishedSourceAvailabilityTooltip",
        defaultMessage: "{sourceType, select, page {Publish the page to make the content available in other locations.} blog {Publish the blog to make the content available in other locations.} jiraWorkItem {Publish the work item to make the content available in other locations.} other {Publish to make the content available in other locations.}}"
    },
    referenceSyncBlockLastEdited: {
        id: "fabric.editor.referenceSyncBlockLastEdited",
        defaultMessage: "Last edited:"
    },
    referenceSyncBlockSyncedFrom: {
        id: "fabric.editor.referenceSyncBlockSyncedFrom",
        defaultMessage: "Synced from:"
    },
    taskInDestinationSyncedBlockTooltip: {
        id: "fabric.editor.taskInDestinationSyncedBlockTooltip",
        defaultMessage: "This content is synced. Edit it at the source."
    },
    deletionConfirmationModalTitleSingle: {
        id: "fabric.editor.deletionConfirmationModalTitleSingle",
        defaultMessage: "Delete synced content?"
    },
    deleteConfirmationModalTitleMultiple: {
        id: "fabric.editor.deleteConfirmationModalTitleMultiple",
        defaultMessage: "Delete content in {count, plural, one {1 location} other {# locations}}?"
    },
    deleteConfirmationModalCancelButton: {
        id: "fabric.editor.deleteConfirmationModalCancelButton",
        defaultMessage: "Cancel"
    },
    deleteConfirmationModalDeleteButton: {
        id: "fabric.editor.deleteConfirmationModalDeleteButton",
        defaultMessage: "Delete"
    },
    deleteRetryButton: {
        id: "fabric.editor.deleteConfirmationModalRetryButton",
        defaultMessage: "Try again"
    },
    deletionConfirmationModalDescription: {
        id: "fabric.editor.deletionConfirmationModalDescription",
        defaultMessage: "If you delete this synced block, it will become an \u201CUnsynced block\u201D in other locations. This action is permanent and cannot be undone."
    },
    deletionConfirmationModalDescriptionNew: {
        id: "fabric.editor.deletionConfirmationModalDescriptionNew",
        defaultMessage: "If you delete this synced block, it will appear as an empty \"Unsynced block\" in {syncBlockCount, plural, one {1 other synced location} other {# locations}}. This action is permanent and cannot be undone."
    },
    deletionConfirmationModalDescriptionReferenceCount: {
        id: "fabric.editor.deletionConfirmationModalDescriptionReferenceCount",
        defaultMessage: "If you delete this source synced block, it will appear as an empty \"Unsynced block\" in {syncBlockCount, plural, one {1 other synced location} other {# other synced locations}}. This action is permanent and cannot be undone."
    },
    deletionConfirmationModalDescriptionNoRef: {
        id: "fabric.editor.deletionConfirmationModalDescriptionNoRef",
        defaultMessage: "Your content will no longer appear, and the synced block will be deleted. This action is permanent and cannot be undone."
    },
    createSyncBlockLabel: {
        id: "fabric.editor.createSyncBlockLabel",
        defaultMessage: "Create synced block"
    },
    syncBlockLabel: {
        id: "fabric.editor.syncBlockLabel",
        defaultMessage: "Sync block"
    },
    newLozenge: {
        id: "fabric.editor.syncBlock.toolbar.newLozenge",
        defaultMessage: "New"
    },
    failToDeleteTitle: {
        id: "fabric.editor.error.title.failToDelete",
        defaultMessage: "Failed to delete"
    },
    failToDeleteWhenOfflineDescription: {
        id: "fabric.editor.error.description.failToDeleteWhenOffline",
        defaultMessage: "You appear to be offline. Please connect to the internet to delete synced content."
    },
    cannotDeleteTitle: {
        id: "fabric.editor.error.flag.title.cannotDelete",
        defaultMessage: "Failed to delete synced block"
    },
    cannotDeleteDescription: {
        id: "fabric.editor.error.description.cannotDelete",
        defaultMessage: "An error occurred while trying to delete this synced block. "
    },
    failToEditTitle: {
        id: "fabric.editor.error.title.failToEdit",
        defaultMessage: "Cannot edit synced content offline"
    },
    failToEditWhenOfflineDescription: {
        id: "fabric.editor.error.description.failToEditWhenOffline",
        defaultMessage: "You appear to be offline. Please connect to the internet to edit synced content."
    },
    failToCreateTitle: {
        id: "fabric.editor.error.title.failToCreate",
        defaultMessage: "Cannot create synced content offline"
    },
    failToCreateWhenOfflineDescription: {
        id: "fabric.editor.error.description.failToCreateWhenOffline",
        defaultMessage: "You appear to be offline. Please connect to the internet to create synced content."
    },
    feedbackFlagTitle: {
        id: "editor-common.messages.syncBlock.feedbackFlagTitle",
        defaultMessage: "Help us improve Synced blocks"
    },
    feedbackFlagDescription: {
        id: "editor-common.messages.syncBlock.feedbackFlagDescription",
        defaultMessage: "We\u2019d love your feedback. This quick survey should take less than a minute."
    },
    feedbackFlagGiveFeedback: {
        id: "editor-common.messages.syncBlock.feedbackFlagGiveFeedback",
        defaultMessage: "Give feedback"
    },
    feedbackFlagNoThanks: {
        id: "editor-common.messages.syncBlock.feedbackFlagNoThanks",
        defaultMessage: "No thanks"
    },
    loadingSyncedContent: {
        id: "fabric.editor.syncedBlockLoadingSyncedContent",
        defaultMessage: "Loading synced content"
    },
    generalErrorDescription: {
        id: "fabric.editor.syncedBlockGeneralErrorDescription",
        defaultMessage: "We're unable to display this content at the moment."
    },
    notFoundAltText: {
        id: "fabric.editor.syncedBlockNotFoundIconAltText",
        defaultMessage: "Synced block not found."
    },
    notFoundDescription: {
        id: "fabric.editor.syncedBlockNotFoundDescription.non-final",
        defaultMessage: "We're unable to display this content as its source has been deleted or archived."
    },
    sourceUnsyncedDescription: {
        id: "fabric.editor.syncedBlockSourceUnsyncedDescription",
        defaultMessage: "We're unable to display this content as it's been unsynced from <a>{title}</a>."
    },
    sourceDeletedDescription: {
        id: "fabric.editor.syncedBlockSourceDeletedDescription",
        defaultMessage: "We're unable to display this content as it's been deleted from <a>{title}</a>."
    },
    entityNotFoundDescription: {
        id: "fabric.editor.syncedBlockEntityNotFoundDescription",
        defaultMessage: "We're unable to display this synced block as it's not available on this site. <link>Learn more</link>"
    },
    genericNotFoundDescription: {
        id: "fabric.editor.syncedBlockGenericNotFoundDescription",
        defaultMessage: "We're unable to display this synced content as it's been deleted or unsynced."
    },
    retryButton: {
        id: "fabric.editor.retrySyncedBlock",
        defaultMessage: "Try again"
    },
    offlineError: {
        id: "fabric.editor.error.description.reference.offline",
        defaultMessage: "We're unable to display synced blocks when you're offline"
    },
    unpublishedError: {
        id: "fabric.editor.error.description.reference.unpublished",
        defaultMessage: "Synced content will display <link>when the page is published</link>"
    },
    unpublishedInParentheses: {
        id: "editor-common.messages.syncBlock.unpublishedInParentheses",
        defaultMessage: "(unpublished)"
    },
    unpublishedErrorJiraWorkItem: {
        id: "fabric.editor.error.description.reference.unpublished.jiraWorkItem",
        defaultMessage: "Synced content will display <link>when the item's description is saved</link>"
    },
    syncBlockCopiedTitle: {
        id: "fabric.editor.syncBlockCopiedTitle",
        defaultMessage: "Synced block copied to clipboard"
    },
    syncBlockCopiedDescription: {
        id: "fabric.editor.syncBlockCopiedDescription",
        defaultMessage: "Paste your synced block to keep content auto-updated. Permissions are the same."
    },
    syncBlockCopiedJiraUnsavedFieldDescription: {
        id: "editor-common.messages.syncBlock.syncBlockCopiedJiraUnsavedFieldDescription.ai-non-final",
        defaultMessage: "To reuse this content, save this field and paste this synced block in another location."
    },
    syncBlockCopiedLivePageDescription: {
        id: "editor-common.messages.syncBlock.syncBlockCopiedLivePageDescription",
        defaultMessage: "Paste this synced block content in another location to reuse its content."
    },
    syncBlockCopiedUnpublishedDescription: {
        id: "editor-common.messages.syncBlock.syncBlockCopiedUnpublishedDescription",
        defaultMessage: "To reuse this content, publish this page and paste this synced block in another location."
    },
    syncBlockCopiedAction: {
        id: "fabric.editor.syncBlockCopiedAction",
        defaultMessage: "Learn more"
    },
    syncedLocationDropdownTitle: {
        id: "fabric.editor.syncedLocationDropdownTitle",
        defaultMessage: "Synced locations"
    },
    syncedLocationDropdownTitleWithCount: {
        id: "fabric.editor.syncedLocationDropdownTitleWithCount.ai-non-final",
        defaultMessage: "Synced locations ({count})"
    },
    syncedLocationDropdownLoading: {
        id: "fabric.editor.syncedLocationDropdownLoading.ai-non-final",
        defaultMessage: "Loading synced locations"
    },
    syncedLocationDropdownNoReferencesTooltip: {
        id: "editor-common.messages.syncBlock.syncedLocationDropdownNoReferencesTooltip.ai-non-final",
        defaultMessage: "Not yet synced to any other locations"
    },
    syncedLocationDropdownHeading: {
        id: "fabric.editor.syncedLocationDropdownHeading",
        defaultMessage: "{count} locations:"
    },
    syncedLocationDropdownError: {
        id: "fabric.editor.syncedLocationDropdownError",
        defaultMessage: "We can't load locations right now. Please wait a few minutes and refresh your browser."
    },
    syncedLocationDropdownNoResults: {
        id: "fabric.editor.syncedLocationDropdownNoResults",
        defaultMessage: "Copy and paste synced blocks to reuse in other locations."
    },
    syncedLocationDropdownActivationNoResults: {
        id: "editor-common.messages.syncBlock.syncedLocationDropdownActivationNoResults",
        defaultMessage: "To reuse content, copy and paste this block to sync to other locations"
    },
    syncedLocationDropdownLearnMoreLink: {
        id: "fabric.editor.syncedLocationDropdownLearnMoreLink",
        defaultMessage: "Learn more about synced blocks"
    },
    syncedLocationDropdownSamePage: {
        id: "fabric.editor.syncedLocationDropdownSamePage",
        defaultMessage: "This page"
    },
    syncedLocationDropdownTitleBlockIndex: {
        id: "fabric.editor.syncedLocationDropdownTitleNote",
        defaultMessage: "block {index}"
    },
    syncedLocationDropdownTitleNoteForConfluencePage: {
        id: "fabric.editor.syncedLocationDropdownTitleNoteForConfluencePage",
        defaultMessage: "This page"
    },
    syncedLocationDropdownTitleNoteForJiraWorkItem: {
        id: "fabric.editor.syncedLocationDropdownTitleNoteForJiraWorkItem",
        defaultMessage: "This work item"
    },
    syncedLocationDropdownTitleNoteForJiraWorkItemField: {
        id: "fabric.editor.syncedLocationDropdownTitleNoteForJiraWorkItemField",
        defaultMessage: "This work item field"
    },
    syncedLocationDropdownTooltipFieldName: {
        id: "fabric.editor.syncedLocationDropdownTooltipFieldName",
        defaultMessage: "Field: {fieldName}"
    },
    syncedLocationDropdownSourceLozenge: {
        id: "fabric.editor.syncedLocationDropdownSourceLozenge",
        defaultMessage: "Source"
    },
    syncedLocationDropdownRequestAccess: {
        id: "fabric.editor.syncedLocationDropdownRequestAccess",
        defaultMessage: "Request access"
    },
    syncedLocationDropdownRestrictedContent: {
        id: "fabric.editor.syncedLocationDropdownRestrictedContent",
        defaultMessage: "Restricted content"
    },
    syncedLocationDropdownUntitledPage: {
        id: "fabric.editor.syncedLocationDropdownUntitledPage",
        defaultMessage: "Untitled"
    },
    // Accessible labels for the Jira issue-type icons rendered in the synced location
    // dropdown. Used as the `IconTile` `label` prop so screen readers announce the type.
    syncedLocationDropdownIssueTypeTask: {
        id: "fabric.editor.syncedLocationDropdownIssueTypeTask",
        defaultMessage: "Task"
    },
    syncedLocationDropdownIssueTypeBug: {
        id: "fabric.editor.syncedLocationDropdownIssueTypeBug",
        defaultMessage: "Bug"
    },
    syncedLocationDropdownIssueTypeStory: {
        id: "fabric.editor.syncedLocationDropdownIssueTypeStory",
        defaultMessage: "Story"
    },
    syncedLocationDropdownIssueTypeEpic: {
        id: "fabric.editor.syncedLocationDropdownIssueTypeEpic",
        defaultMessage: "Epic"
    },
    syncedLocationDropdownIssueTypeSubtask: {
        id: "fabric.editor.syncedLocationDropdownIssueTypeSubtask",
        defaultMessage: "Subtask"
    },
    syncedLocationDropdownIssueTypeGeneric: {
        id: "fabric.editor.syncedLocationDropdownIssueTypeGeneric",
        defaultMessage: "Jira work item"
    },
    unpublishedSyncBlockPastedTitle: {
        id: "fabric.editor.unpublishedSyncBlockPastedTitle",
        defaultMessage: "Pasted from unpublished page"
    },
    unpublishedSyncBlockPastedTitleJiraWorkItem: {
        id: "fabric.editor.unpublishedSyncBlockPastedTitle.jiraWorkItem",
        defaultMessage: "Pasted from unsaved item"
    },
    unpublishedSyncBlockPastedDescription: {
        id: "fabric.editor.unpublishedSyncBlockPastedDescription",
        defaultMessage: "When the page is published, the content will be displayed."
    },
    unpublishedSyncBlockPastedDescriptionJiraWorkItem: {
        id: "fabric.editor.unpublishedSyncBlockPastedDescription.jiraWorkItem",
        defaultMessage: "<link>When the item's description is saved</link>, the content will be displayed."
    },
    unsyncButton: {
        id: "fabric.editor.syncedBlock.unsync",
        defaultMessage: "Unsync"
    },
    deleteConfirmationModalUnsyncButton: {
        id: "fabric.editor.deleteConfirmationModalUnsyncButton",
        defaultMessage: "Unsync"
    },
    unsyncConfirmationModalTitle: {
        id: "fabric.editor.unsyncConfirmationModalTitle",
        defaultMessage: "Unsync this content?"
    },
    unsyncConfirmModalDescriptionSingle: {
        id: "fabric.editor.unsyncConfirmModalDescriptionSingle",
        defaultMessage: "Your content will stay here. It will no longer be a synced block. This action is permanent and cannot be undone."
    },
    unsyncConfirmModalDescriptionMultiple: {
        id: "fabric.editor.unsyncConfirmModalDescriptionMultiple",
        defaultMessage: "Your content will stay here. In {syncBlockCount, plural, one {1 other synced location} other {# other synced locations}} it will appear as an \"Unsynced block\". This action is permanent and cannot be undone."
    },
    unsyncConfirmModalDescriptionMultipleNew: {
        id: "fabric.editor.unsyncConfirmModalDescriptionMultipleNew",
        defaultMessage: "Your content will stay here. In {syncBlockCount, plural, one {1 other synced location} other {# other synced locations}} it will appear as an empty \"Unsynced block\". This action is permanent and cannot be undone."
    },
    cannotPasteSyncedBlockTitle: {
        id: "fabric.editor.cannotPasteSyncedBlockTitle",
        defaultMessage: "Unable to paste"
    },
    cannotPasteSyncedBlockDescription: {
        id: "fabric.editor.cannotPasteSyncedBlockDescription",
        defaultMessage: "We\u2019re still building this feature. Currently, you can only paste synced content once your work item has been created. "
    },
    cannotPasteSyncedBlockUnsupportedDescription: {
        id: "fabric.editor.cannotPasteSyncedBlockUnsupportedDescription",
        defaultMessage: "Sync blocks aren't supported here yet. "
    },
    cannotPasteSyncedBlockAction: {
        id: "fabric.editor.cannotPasteSyncedBlockAction",
        defaultMessage: "Learn more"
    },
    cannotCreateSyncBlockTitle: {
        id: "fabric.editor.cannotCreateSyncBlockTitle",
        defaultMessage: "Unable to create synced block"
    },
    CannotCreateSyncBlockDescription: {
        id: "fabric.editor.cannotCreateSyncBlockDescription",
        defaultMessage: "An error occurred while trying to create this synced block. "
    },
    inlineExtensionInSyncBlockTitle: {
        id: "fabric.editor.inlineExtensionInSyncBlockTitle",
        defaultMessage: "Some macros may not work when adding synced blocks to new locations"
    },
    inlineExtensionInSyncBlockDescription: {
        id: "fabric.editor.inlineExtensionInSyncBlockDescription",
        defaultMessage: "This may happen if your synced block is used in places that don't support certain macros."
    },
    extensionInSyncBlockTitle: {
        id: "fabric.editor.extensionInSyncBlockTitle",
        defaultMessage: "Some macros may not work when adding synced blocks to new locations"
    },
    extensionInSyncBlockDescription: {
        id: "fabric.editor.extensionInSyncBlockDescription",
        defaultMessage: "This may happen if your synced block is used in places that don't support certain macros."
    },
    duplicateSourceSyncBlockTitle: {
        id: "fabric.editor.duplicateSourceSyncBlockTitle",
        defaultMessage: "Duplicate synced block removed"
    },
    duplicateSourceSyncBlockDescription: {
        id: "fabric.editor.duplicateSourceSyncBlockDescription",
        defaultMessage: "Only one source synced block per source is allowed on a page. Use a reference synced block to reuse this content."
    }
});
module.exports["syncBlockMessages"] = $ff1f8bf9c08f6a2f$export$254768729b492c8b;

});

parcelRegister("c2kFl", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0e4105444fd9a55d$export$8becdf1c29fc36cd = (0, $kSwu1.defineMessages)({
    colorPickerTitle: {
        id: "company-hub-text-color.color-picker-dropdown.picker-title",
        defaultMessage: "Text Color"
    }
});
module.exports["companyHubTextColorMessages"] = $0e4105444fd9a55d$export$8becdf1c29fc36cd;

});

parcelRegister("2VjJa", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $d027c8219a3d8915$export$a0fb5df03a49c723 = (0, $kSwu1.defineMessages)({
    groupLabel: {
        id: "fabric.editor.markdownMode.viewToggle.groupLabel",
        defaultMessage: "View mode"
    },
    source: {
        id: "fabric.editor.markdownMode.viewToggle.source",
        defaultMessage: "Syntax editor"
    },
    wysiwyg: {
        id: "fabric.editor.markdownMode.viewToggle.wysiwyg",
        defaultMessage: "Preview editor"
    },
    preview: {
        id: "fabric.editor.markdownMode.viewToggle.preview",
        defaultMessage: "Split view (coming soon)"
    },
    sourceAriaLabel: {
        id: "fabric.editor.markdownMode.sourceView.ariaLabel",
        defaultMessage: "Markdown source"
    },
    confirmDialogTitleToMarkdown: {
        id: "fabric.editor.markdownMode.confirmDialog.title.toMarkdown",
        defaultMessage: "Convert to markdown"
    },
    confirmDialogTitleToMarkdownLossy: {
        id: "fabric.editor.markdownMode.confirmDialog.title.toMarkdownLossy",
        defaultMessage: "Convert to markdown"
    },
    confirmDialogTitleToRichText: {
        id: "fabric.editor.markdownMode.confirmDialog.title.toRichText",
        defaultMessage: "Convert to rich text"
    },
    confirmDialogToMarkdownToolsRemoved: {
        id: "fabric.editor.markdownMode.confirmDialog.toMarkdown.toolsRemoved",
        defaultMessage: "Use basic formatting"
    },
    confirmDialogToMarkdownToggle: {
        id: "fabric.editor.markdownMode.confirmDialog.toMarkdown.toggle",
        defaultMessage: "Toggle between the syntax and preview editor"
    },
    confirmDialogToMarkdownVersionHistory: {
        id: "fabric.editor.markdownMode.confirmDialog.toMarkdown.versionHistory",
        defaultMessage: "Restore previous drafts with version history"
    },
    confirmDialogToMarkdownLossyRichContent: {
        id: "fabric.editor.markdownMode.confirmDialog.toMarkdownLossy.richContent",
        defaultMessage: "Your content may look different as converting removes rich text formatting"
    },
    confirmDialogToMarkdownLossyVersionHistory: {
        id: "fabric.editor.markdownMode.confirmDialog.toMarkdownLossy.versionHistory",
        defaultMessage: "To restore formatting, access previous drafts from version history"
    },
    confirmDialogToMarkdownLossyCta: {
        id: "fabric.editor.markdownMode.confirmDialog.toMarkdownLossy.cta",
        defaultMessage: "Convert"
    },
    confirmDialogToRichTextStandardTools: {
        id: "fabric.editor.markdownMode.confirmDialog.toRichText.standardTools",
        defaultMessage: "Use all rich text tools"
    },
    confirmDialogToRichTextVersionHistory: {
        id: "fabric.editor.markdownMode.confirmDialog.toRichText.versionHistory",
        defaultMessage: "Restore previous drafts with version history"
    },
    confirmDialogCancel: {
        id: "fabric.editor.markdownMode.confirmDialog.cancel",
        defaultMessage: "Cancel"
    },
    confirmDialogConfirm: {
        id: "fabric.editor.markdownMode.confirmDialog.confirm",
        defaultMessage: "Confirm"
    },
    confirmDialogError: {
        id: "fabric.editor.markdownMode.confirmDialog.error",
        defaultMessage: "Something went wrong while converting this page. Please try again."
    },
    unlinkSyncedBlocksTitle: {
        id: "fabric.editor.markdownMode.unlinkSyncedBlocks.title",
        defaultMessage: "Delete synced content?"
    },
    unlinkSyncedBlocksBody: {
        id: "fabric.editor.markdownMode.unlinkSyncedBlocks.body",
        defaultMessage: "Converting will delete synced blocks and their content. This cannot be restored in version history."
    },
    labsLozenge: {
        id: "fabric.editor.markdownMode.labsLozenge",
        defaultMessage: "LABS"
    }
});
module.exports["markdownModeMessages"] = $d027c8219a3d8915$export$a0fb5df03a49c723;

});

parcelRegister("kzRKB", function(module, exports) {

var $gMweA = parcelRequire("gMweA");

function $9eca4f8e13ee5b87$export$c982229f6c12dcf() {
    if (!(0, $gMweA.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd - nav.requestStart;
    return;
}
module.exports["getRequestToResponseTime"] = $9eca4f8e13ee5b87$export$c982229f6c12dcf;

});

parcelRegister("ePEtz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $h2a7P = parcelRequire("h2a7P");


var $lNyjH = parcelRequire("lNyjH");

const $fc52ddb856b114b5$export$aedd1a2d18cbf42b = (object1, object2)=>{
    const oldKeys = object1 !== null ? (0, $h2a7P.getKeys)(object1) : [];
    const newKeys = object2 !== null ? (0, $h2a7P.getKeys)(object2) : [];
    const removed = oldKeys.filter((key)=>!newKeys.includes(key));
    const added = newKeys.filter((key)=>!oldKeys.includes(key));
    const common = oldKeys.filter((key)=>newKeys.includes(key));
    return {
        added: added,
        common: common,
        removed: removed
    };
};
const $fc52ddb856b114b5$export$d438af18e3a25d10 = (object1, object2, curDepth = 0, maxDepth = 2, keysToIgnore = [])=>{
    const { added: added, common: common, removed: removed } = $fc52ddb856b114b5$export$aedd1a2d18cbf42b(object1, object2);
    const changed = [];
    common.forEach((key)=>{
        const value1 = object1[key];
        const value2 = object2[key];
        const value1Type = typeof value1;
        const value2Type = typeof value2;
        // Do comparision only if values doesn't match (or reference to same object in memory).
        // Or if key does not exist in keys to ignore.
        if (value1 !== value2 && keysToIgnore.indexOf(key) === -1) {
            // if both key value are objects and not referencing same object in memory.
            //  then get recursive difference.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(value2)) changed.push({
                key: key,
                reactElementChanged: true
            });
            else if (value1Type === 'object' && value2Type === 'object') {
                if (curDepth <= maxDepth) {
                    const difference = $fc52ddb856b114b5$export$d438af18e3a25d10(value1, value2, curDepth + 1, maxDepth);
                    changed.push({
                        key: key,
                        difference: difference
                    });
                } else changed.push({
                    key: key,
                    maxDepthReached: true
                });
            } else changed.push({
                key: key,
                oldValue: (0, $lNyjH.serializeValue)(value1),
                newValue: (0, $lNyjH.serializeValue)(value2)
            });
        }
    });
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
const $fc52ddb856b114b5$export$418b0a935c0a0030 = (object1, object2)=>{
    const { added: added, common: common, removed: removed } = $fc52ddb856b114b5$export$aedd1a2d18cbf42b(object1, object2);
    const changed = common.filter((key)=>object1[key] !== object2[key]);
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
module.exports["getPropsDifference"] = $fc52ddb856b114b5$export$d438af18e3a25d10;
module.exports["getShallowPropsDifference"] = $fc52ddb856b114b5$export$418b0a935c0a0030;

});

parcelRegister("egfqG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $ePEtz = parcelRequire("ePEtz");

const $21460d10f983248b$export$ebce6d7d8ca67353 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useComponentRenderTracking(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { onRender: onRender, propsDiffingOptions: propsDiffingOptions, zeroBasedCount: t1 } = t0;
    const zeroBasedCount = t1 === undefined ? true : t1;
    const propsRef = (0, $cozmU.useRef)();
    const renderCountRef = (0, $cozmU.useRef)(zeroBasedCount ? 0 : 1);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $03RpJ.default)();
        $[0] = t2;
    } else t2 = $[0];
    const { current: componentId } = (0, $cozmU.useRef)(t2);
    let t3;
    if ($[1] !== onRender || $[2] !== propsDiffingOptions) {
        t3 = ()=>{
            const lastProps = propsRef.current;
            const renderCount = renderCountRef.current;
            let propsDifference;
            if (propsDiffingOptions?.enabled && lastProps) propsDifference = propsDiffingOptions?.useShallow ? (0, $ePEtz.getShallowPropsDifference)(lastProps, propsDiffingOptions.props) : (0, $ePEtz.getPropsDifference)(lastProps, propsDiffingOptions.props, 0, 2, propsDiffingOptions?.propsToIgnore);
            const result = {
                renderCount: renderCount,
                propsDifference: propsDifference,
                componentId: componentId
            };
            onRender(result);
            if (propsDiffingOptions?.enabled) propsRef.current = propsDiffingOptions.props;
            renderCountRef.current = renderCountRef.current + 1;
        };
        $[1] = onRender;
        $[2] = propsDiffingOptions;
        $[3] = t3;
    } else t3 = $[3];
    (0, $cozmU.useEffect)(t3);
} : function useComponentRenderTracking({ onRender: onRender, propsDiffingOptions: propsDiffingOptions, zeroBasedCount: zeroBasedCount = true }) {
    const propsRef = (0, $cozmU.useRef)();
    const renderCountRef = (0, $cozmU.useRef)(zeroBasedCount ? 0 : 1);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: componentId } = (0, $cozmU.useRef)((0, $03RpJ.default)());
    (0, $cozmU.useEffect)(()=>{
        const lastProps = propsRef.current;
        const renderCount = renderCountRef.current;
        let propsDifference;
        if (propsDiffingOptions?.enabled && lastProps) propsDifference = propsDiffingOptions?.useShallow ? (0, $ePEtz.getShallowPropsDifference)(lastProps, propsDiffingOptions.props) : (0, $ePEtz.getPropsDifference)(lastProps, propsDiffingOptions.props, 0, 2, propsDiffingOptions?.propsToIgnore);
        const result = {
            renderCount: renderCount,
            propsDifference: propsDifference,
            componentId: componentId
        };
        onRender(result);
        if (propsDiffingOptions?.enabled) propsRef.current = propsDiffingOptions.props;
        renderCountRef.current = renderCountRef.current + 1;
    }); // No dependencies run on each render
};
module.exports["useComponentRenderTracking"] = $21460d10f983248b$export$ebce6d7d8ca67353;

});

parcelRegister("5Qi6J", function(module, exports) {

var $rUtf9 = parcelRequire("rUtf9");

var $iEBdR = parcelRequire("iEBdR");

var $jTt8P = parcelRequire("jTt8P");

const $afee9f566c824804$export$dbdec03917c683f4 = (schema, adf)=>{
    let isTransformed = false;
    const { syncBlock: syncBlock, bodiedSyncBlock: bodiedSyncBlock, unsupportedBlock: unsupportedBlock } = schema.nodes;
    if (!unsupportedBlock) return {
        isTransformed: isTransformed,
        transformedAdf: adf
    };
    const transformedAdf = (0, $jTt8P.traverse)(adf, {
        syncBlock: (node)=>{
            if (syncBlock) return node;
            isTransformed = true;
            const unsupportedBlockNode = unsupportedBlock.createChecked({
                originalValue: node
            });
            return unsupportedBlockNode.toJSON();
        },
        bodiedSyncBlock: (node)=>{
            if (bodiedSyncBlock) return node;
            isTransformed = true;
            const unsupportedBlockNode = unsupportedBlock.createChecked({
                originalValue: node
            });
            return unsupportedBlockNode.toJSON();
        },
        unsupportedBlock: (node)=>{
            if (!node.attrs?.originalValue) return node;
            if (node.attrs.originalValue.type === 'syncBlock' && syncBlock) {
                isTransformed = true;
                return node.attrs.originalValue;
            } else if (node.attrs.originalValue.type === 'bodiedSyncBlock' && bodiedSyncBlock) {
                isTransformed = true;
                return node.attrs.originalValue;
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};


var $hD7pG = parcelRequire("hD7pG");



// This is the set of marks that we wont allow in duplicate to
// exist on a given node, regardless of their attributes. We do
// not include annotations here, because we do allow duplicate
// annotations as long as they have unique id attributes (valid scenario)
const $9dbc69afb2dd96cd$var$markDuplicatesDisallowed = new Set([
    'strong',
    'underline',
    'textColor',
    'link',
    'em',
    'subsup',
    'strike',
    'backgroundColor'
]);
const $9dbc69afb2dd96cd$var$maybeHasDisallowedDuplicateMarks = (node)=>{
    const markTypes = node.marks?.map((mark)=>mark.type)?.filter((markType)=>// For annotations, we are performing the same cheap check
        // for duplicates by type, without considering IDs, to quickly determine
        // whether there may be potential deduping targets.
        // In the actual deduping logic in maybeRemoveDisallowedDuplicateMarks,
        // we correctly/safely dedupe annotations by their unique IDs.
        $9dbc69afb2dd96cd$var$markDuplicatesDisallowed.has(markType) || markType === 'annotation');
    if (!markTypes?.length) return false;
    return new Set(markTypes).size !== markTypes.length;
};
const $9dbc69afb2dd96cd$var$maybeRemoveDisallowedDuplicateMarks = (node)=>{
    const quota = new Map();
    const annotationsQuota = new Map();
    const discardedMarks = [];
    $9dbc69afb2dd96cd$var$markDuplicatesDisallowed.forEach((mark)=>{
        quota.set(mark, false);
    });
    if (!node.marks) return {
        discardedMarks: discardedMarks
    };
    const dedupedMarks = node.marks.filter((mark)=>{
        const markType = mark.type;
        if (markType === 'annotation') {
            const id = mark.attrs?.id;
            if (annotationsQuota.has(id)) {
                discardedMarks.push(mark);
                return false;
            } else {
                annotationsQuota.set(id, true);
                return true;
            }
        }
        if (quota.has(markType)) {
            if (!quota.get(markType)) {
                quota.set(markType, true);
                return true;
            } else {
                discardedMarks.push(mark);
                return false;
            }
        }
        return true;
    });
    return {
        node: {
            ...node,
            marks: dedupedMarks
        },
        discardedMarks: discardedMarks
    };
};
const $9dbc69afb2dd96cd$export$af4e387303482581 = (adf)=>{
    let isTransformed = false;
    const discardedMarks = [];
    const transformedAdf = (0, $jTt8P.traverse)(adf, {
        text: (node)=>{
            if ($9dbc69afb2dd96cd$var$maybeHasDisallowedDuplicateMarks(node)) {
                const result = $9dbc69afb2dd96cd$var$maybeRemoveDisallowedDuplicateMarks(node);
                const resultDiscardedMarks = result.discardedMarks;
                if (resultDiscardedMarks.length) {
                    discardedMarks.push(...resultDiscardedMarks);
                    isTransformed = true;
                    return result.node;
                }
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed,
        discardedMarks: discardedMarks
    };
};




const $0b17504eed8ca13b$var$hasChildHeadingWithIndentation = (node)=>node.content?.some((childNode)=>childNode?.type === 'heading' && childNode?.marks?.some((mark)=>mark.type === 'indentation')) ?? false;
const $0b17504eed8ca13b$var$removeIndentationFromHeadings = (node)=>{
    return {
        ...node,
        content: node.content?.map((childNode)=>{
            if (childNode?.type === 'heading') return {
                ...childNode,
                marks: childNode.marks?.filter((mark)=>mark.type !== 'indentation')
            };
            return childNode;
        })
    };
};
const $0b17504eed8ca13b$export$c06e4b521519af22 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $jTt8P.traverse)(adf, {
        tableCell: (node)=>{
            if ($0b17504eed8ca13b$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $0b17504eed8ca13b$var$removeIndentationFromHeadings(node);
            }
            return;
        },
        tableHeader: (node)=>{
            if ($0b17504eed8ca13b$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $0b17504eed8ca13b$var$removeIndentationFromHeadings(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};





var $1HhPq = parcelRequire("1HhPq");

const $6d7de5d1fdebb575$var$getChildrenTypeCounts = (nodeContent, allowedTypes)=>{
    const childrenTypes = {};
    nodeContent.forEach((childNode)=>{
        if (!childNode?.type || !allowedTypes.includes(childNode.type)) return;
        if (!childrenTypes[childNode.type]) {
            childrenTypes[childNode.type] = 1;
            return;
        }
        childrenTypes[childNode.type]++;
    });
    return childrenTypes;
};
const $6d7de5d1fdebb575$var$removeDuplicatedNodes = (type, content, predicate)=>{
    let maxIterations = 10;
    let childrenTypeCounts = $6d7de5d1fdebb575$var$getChildrenTypeCounts(content, [
        type
    ])[type];
    let firstPredicateNodeIndex = content.findIndex(predicate);
    while(childrenTypeCounts > 1 && firstPredicateNodeIndex > -1 && maxIterations-- > 0){
        content.splice(firstPredicateNodeIndex, 1);
        firstPredicateNodeIndex = content.findIndex(predicate);
        childrenTypeCounts = $6d7de5d1fdebb575$var$getChildrenTypeCounts(content, [
            type
        ])[type];
    }
};
/**
 * @param  {{[type:string]:number}} allowedTypes - array types allowed to deduplicate
 */ const $6d7de5d1fdebb575$var$deduplicateMediaSingleChildren = (node, allowedTypes)=>{
    if (!node.content) return;
    const content = [
        ...node.content
    ];
    Object.keys(allowedTypes).forEach((type)=>{
        //prioritise removing empty nodes first
        $6d7de5d1fdebb575$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type && (0, $1HhPq.isEmpty)(node));
        //remove other remaining dupicates
        $6d7de5d1fdebb575$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type);
    });
    return {
        ...node,
        content: content
    };
};
const $6d7de5d1fdebb575$export$1c8c16d74c7a63bf = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $jTt8P.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node?.content?.length) return;
            const disallowedDuplicateTypes = [
                'media',
                'caption'
            ];
            const childrenTypes = $6d7de5d1fdebb575$var$getChildrenTypeCounts(node.content, disallowedDuplicateTypes);
            if (Object.values(childrenTypes).some((occurences)=>occurences > 1)) {
                isTransformed = true;
                return $6d7de5d1fdebb575$var$deduplicateMediaSingleChildren(node, childrenTypes);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};


var $ihHxk = parcelRequire("ihHxk");



const $349e5bae72668599$export$abd79dcca4cbaf32 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $jTt8P.traverse)(adf, {
        mediaSingle: (node)=>{
            const { width: width, widthType: widthType } = node.attrs || {};
            // if width is not a number or greater than 100, and widthType is not set, we set width to 100
            if (typeof width === 'number' && width > 100 && !widthType) {
                isTransformed = true;
                const newAttrs = {
                    ...node.attrs,
                    width: 100
                };
                return {
                    ...node,
                    attrs: newAttrs
                };
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};


var $bnFzS = parcelRequire("bnFzS");

var $gHMgs = parcelRequire("gHMgs");

var $c8cGy = parcelRequire("c8cGy");

var $5trrQ = parcelRequire("5trrQ");

var $kaOn9 = parcelRequire("kaOn9");







const $6a7a53e01330a8fd$var$getMaxColumnsCountForTable = (tableNode)=>{
    let colsInRow = 1;
    tableNode.content?.forEach((childNode)=>{
        if (childNode?.type === 'tableRow' && typeof childNode.content?.length === 'number' && childNode.content.length > colsInRow) colsInRow = childNode.content.length;
    });
    return colsInRow;
};
const $6a7a53e01330a8fd$var$createValidEmptyContent = (node)=>{
    switch(node.type){
        case 'tableCell':
            return [
                (0, $c8cGy.paragraph)()
            ];
        default:
            return [];
    }
};
const $6a7a53e01330a8fd$var$fixIfTableCellInvalidEmpty = (reportTransform)=>(node)=>{
        if ((0, $1HhPq.isEmpty)(node)) {
            reportTransform();
            return {
                ...node,
                content: $6a7a53e01330a8fd$var$createValidEmptyContent(node)
            };
        }
        return;
    };
const $6a7a53e01330a8fd$var$hasNonListItemChildren = (node)=>node.content?.some((node)=>node?.type !== 'listItem');
const $6a7a53e01330a8fd$var$hasEmptyListItemChildren = (node)=>node.content?.some((childNode)=>childNode?.type === 'listItem' && !childNode.content?.length);
const $6a7a53e01330a8fd$var$tryCreateValidListItemWrappedChildren = (parentListNode)=>{
    return parentListNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'listItem':
                if ((0, $1HhPq.isEmpty)(childNode)) {
                    const result = (0, $gHMgs.listItem)([
                        (0, $c8cGy.paragraph)()
                    ]);
                    return result;
                }
                return childNode;
            case 'text':
                return (0, $gHMgs.listItem)([
                    (0, $c8cGy.paragraph)(childNode)
                ]);
            default:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return (0, $gHMgs.listItem)([
                    childNode
                ]);
        }
        return childNode;
    });
};
const $6a7a53e01330a8fd$var$fixIfListParentWithInvalidListItemChildren = (reportTransform)=>(node)=>{
        if ($6a7a53e01330a8fd$var$hasNonListItemChildren(node) || $6a7a53e01330a8fd$var$hasEmptyListItemChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $6a7a53e01330a8fd$var$tryCreateValidListItemWrappedChildren(node)
            };
        }
        return;
    };
const $6a7a53e01330a8fd$var$hasNonTableRowChildren = (node)=>node.content?.some((node)=>node?.type !== 'tableRow');
const $6a7a53e01330a8fd$var$tryCreateValidTableRowWrappedChildren = (parentTableNode)=>{
    const maxColsCount = $6a7a53e01330a8fd$var$getMaxColumnsCountForTable(parentTableNode);
    return parentTableNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'text':
                return (0, $kaOn9.tableRow)([
                    (0, $5trrQ.tableCell)({})((0, $c8cGy.paragraph)(childNode)),
                    ...new Array(maxColsCount - 1).fill((0, $5trrQ.tableCell)({})((0, $c8cGy.paragraph)()))
                ]);
            case 'tableCell':
                return (0, $kaOn9.tableRow)([
                    childNode
                ]);
            case 'tableRow':
                if ((0, $1HhPq.isEmpty)(childNode)) return (0, $kaOn9.tableRow)([
                    ...new Array(maxColsCount).fill((0, $5trrQ.tableCell)({})((0, $c8cGy.paragraph)()))
                ]);
                return childNode;
            default:
                return childNode;
        }
        return childNode;
    });
};
const $6a7a53e01330a8fd$var$hasEmptyTableRowChildren = (node)=>node?.content?.some((node)=>node?.type === 'tableRow' && node?.content?.length === 0) || undefined;
const $6a7a53e01330a8fd$var$fixIfTableParentWithInvalidTableRowChildren = (reportTransform)=>(node)=>{
        if ($6a7a53e01330a8fd$var$hasEmptyTableRowChildren(node) || $6a7a53e01330a8fd$var$hasNonTableRowChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $6a7a53e01330a8fd$var$tryCreateValidTableRowWrappedChildren(node)
            };
        }
        return;
    };
const $6a7a53e01330a8fd$var$removeMediaSingleWithNoContent = (reportTransform)=>(node)=>{
        if ((0, $1HhPq.isEmpty)(node)) {
            reportTransform();
            return false;
        }
        return;
    };
const $6a7a53e01330a8fd$export$652814b83c30d251 = (adf)=>{
    let isTransformed = false;
    const reportTransform = ()=>{
        isTransformed = true;
    };
    let transformedAdf = (0, $jTt8P.traverse)(adf, {
        tableCell: $6a7a53e01330a8fd$var$fixIfTableCellInvalidEmpty(reportTransform)
    });
    // Empty mediaSingle nodes get stripped from the document and so this transform
    // will create an empty listItem if the media node is in a list. Empty listItems
    // are invalid adf, so we need to transform the mediaSingle nodes first.
    transformedAdf = (0, $jTt8P.traverse)(transformedAdf || adf, {
        mediaSingle: $6a7a53e01330a8fd$var$removeMediaSingleWithNoContent(reportTransform)
    });
    transformedAdf = (0, $jTt8P.traverse)(transformedAdf || adf, {
        bulletList: $6a7a53e01330a8fd$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        orderedList: $6a7a53e01330a8fd$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        table: $6a7a53e01330a8fd$var$fixIfTableParentWithInvalidTableRowChildren(reportTransform)
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};




const $1a7e74ed4263a0b6$var$hasLinkAndCodeMarks = (node)=>{
    const marks = node.marks?.map((mark)=>mark.type);
    return marks?.includes('link') && marks?.includes('code');
};
const $1a7e74ed4263a0b6$var$removeCodeMarks = (node)=>{
    if (node.marks) return {
        ...node,
        marks: node.marks.filter((mark)=>mark.type !== 'code')
    };
    return node;
};
const $1a7e74ed4263a0b6$export$3d531d2daf0e8a14 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $jTt8P.traverse)(adf, {
        text: (node)=>{
            if ($1a7e74ed4263a0b6$var$hasLinkAndCodeMarks(node)) {
                isTransformed = true;
                return $1a7e74ed4263a0b6$var$removeCodeMarks(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};



var $aPdNQ = parcelRequire("aPdNQ");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $krYZG = parcelRequire("krYZG");


var $hZ5o2 = parcelRequire("hZ5o2");





var $4o0zT = parcelRequire("4o0zT");

const $c79c83124d9bf7a3$export$17701af918d23092 = ()=>(0, $4o0zT.isExperimentEnabled)('platform_editor_nest_container_in_panel');


const $690f02e1a9a7d6f9$export$67a2736d73dace7c = ()=>(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) || (0, $c79c83124d9bf7a3$export$17701af918d23092)();




// The container children unlocked on panel_c1 by the consolidated
// `platform_editor_nest_container_in_panel` experiment. `table` is intentionally excluded:
// it ships independently under `platform_editor_nest_table_in_panel` and is checked by
// `isPanelNestingTableSupported`.
const $998d6b5c5f5fc646$var$PANEL_C1_CONTAINER_CHILD_TYPES = [
    'expand',
    'panel',
    'blockquote',
    'bodiedExtension'
];
const $998d6b5c5f5fc646$export$adaec6ad4f1f3448 = (schema)=>{
    const { panel_c1: panel_c1 } = schema.nodes;
    if (!panel_c1) return false;
    // Confirm the PM schema actually allows at least one container child inside panel_c1.
    const panelC1CanContainAnyContainer = $998d6b5c5f5fc646$var$PANEL_C1_CONTAINER_CHILD_TYPES.some((type)=>{
        const childType = schema.nodes[type];
        return !!childType && panel_c1.contentMatch.matchType(childType)?.validEnd === true;
    });
    return panelC1CanContainAnyContainer && (0, $c79c83124d9bf7a3$export$17701af918d23092)();
};



var $d5JQX = parcelRequire("d5JQX");


var $kMDxP = parcelRequire("kMDxP");


var $1H5A4 = parcelRequire("1H5A4");


var $2K3wo = parcelRequire("2K3wo");


var $4yKbg = parcelRequire("4yKbg");

// Gate the generalised (table + expand + panel + blockquote + bodiedExtension) panel_c1
// fallback behind the consolidated container-in-panel experiment. The in-production
// table-in-panel path keeps using the deprecated table-only transform until
// platform_editor_nest_container_in_panel is rolled out.
const $1c293eb64b22c2a9$var$runPanelC1FallbackTransform = (schema, adf)=>(0, $c79c83124d9bf7a3$export$17701af918d23092)() ? (0, $iEBdR.panelC1FallbackTransformV2)(schema, adf) : (0, $rUtf9.panelC1FallbackTransform)(schema, adf);
const $1c293eb64b22c2a9$var$transformNestedTablesWithAnalytics = (node, dispatchAnalyticsEvent)=>{
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $bnFzS.transformNestedTablesIncomingDocument)(node);
        if (isTransformed) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $krYZG.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            });
            return {
                transformedAdf: transformedAdf,
                isTransformed: isTransformed
            };
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to transform one or more nested tables in the document');
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
            }
        });
    }
    return {
        transformedAdf: node,
        isTransformed: false
    };
};
const $1c293eb64b22c2a9$var$transformContainerNodesWithAnalytics = (node, schema, dispatchAnalyticsEvent)=>{
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed, transformedNodeTypes: transformedNodeTypes } = (0, $hD7pG.transformContainerNodes)(node, schema);
        if (isTransformed && transformedAdf) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $krYZG.ACTION).CONTAINER_NODE_TRANSFORMED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    transformedNodeTypes: transformedNodeTypes
                }
            });
            return {
                transformedAdf: transformedAdf,
                isTransformed: isTransformed
            };
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to transform one or more panel container nodes');
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform panel container nodes' : undefined}`
            }
        });
    }
    return {
        transformedAdf: node,
        isTransformed: false
    };
};
function $1c293eb64b22c2a9$export$cafe23194e65f591(schema, value, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        node = JSON.parse(value);
    } catch  {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    // Convert nested-table extensions into nested tables
    let { transformedAdf: transformedAdf } = $1c293eb64b22c2a9$var$transformNestedTablesWithAnalytics(node, dispatchAnalyticsEvent);
    const result = (0, $afee9f566c824804$export$dbdec03917c683f4)(schema, transformedAdf);
    if (result.isTransformed && result.transformedAdf) transformedAdf = result.transformedAdf;
    if ((0, $iDrrr.fg)('platform_editor_panel_c1_fallback_transform')) {
        const panelC1Result = $1c293eb64b22c2a9$var$runPanelC1FallbackTransform(schema, transformedAdf);
        if (panelC1Result.isTransformed && panelC1Result.transformedAdf) transformedAdf = panelC1Result.transformedAdf;
    }
    if ((0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) ({ transformedAdf: transformedAdf } = $1c293eb64b22c2a9$var$transformContainerNodesWithAnalytics(transformedAdf, schema, dispatchAnalyticsEvent));
    return (0, $aPdNQ.Node).fromJSON(schema, transformedAdf);
}
function $1c293eb64b22c2a9$export$f1a0a61081c3ed62(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        if (contentTransformer) {
            const doc = contentTransformer.parse(value);
            node = doc.toJSON();
        } else node = JSON.parse(value);
    } catch  {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    if (Array.isArray(node)) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${node} is an array, but it must be an object.`);
        return;
    }
    try {
        // ProseMirror always require a child under doc
        if (node.type === 'doc') {
            if (Array.isArray(node.content) && node.content.length === 0) node.content.push({
                type: 'paragraph',
                content: []
            });
            // Just making sure doc is always valid
            if (!node.version) node.version = 1;
        }
        if (contentTransformer) return (0, $aPdNQ.Node).fromJSON(schema, node);
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        let { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $ihHxk.transformMediaLinkMarks)(node);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
        // Fix mediaSingle width issues
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $349e5bae72668599$export$abd79dcca4cbaf32)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).MEDIA_SINGLE_WIDTH_TRANSFORMED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
        // See: HOT-97965 https://product-fabric.atlassian.net/browse/ED-14400
        // We declared in code mark spec that links and marks should not co-exist on
        // text nodes. This util strips code marks from bad text nodes and preserves links.
        // Otherwise, prosemirror will try to repair the invalid document by stripping links
        // and preserving code marks during content changes.
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $1a7e74ed4263a0b6$export$3d531d2daf0e8a14)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).TEXT_LINK_MARK_TRANSFORMED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
        let discardedMarks = [];
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed, discardedMarks: discardedMarks } = (0, $9dbc69afb2dd96cd$export$af4e387303482581)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).DEDUPE_MARKS_TRANSFORMED_V2,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                /** UGC WARNING
           *
           * DO NOT include the `mark` attributes inside, we map here to only
           * extract the mark type as that is the only non-UGC safe information
           * that we can add to event-attributes
           *
           */ discardedMarkTypes: discardedMarks.map((mark)=>mark.type)
            }
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $6a7a53e01330a8fd$export$652814b83c30d251)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).NODES_MISSING_CONTENT_TRANSFORMED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $0b17504eed8ca13b$export$c06e4b521519af22)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).INDENTATION_MARKS_TRANSFORMED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $6d7de5d1fdebb575$export$1c8c16d74c7a63bf)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).INVALID_MEDIA_CONTENT_TRANSFORMED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
        if (dispatchAnalyticsEvent) {
            const hasSingleColumnLayout = transformedAdf.content?.some((node)=>node && node.type === 'layoutSection' && node.content?.length === 1);
            if (hasSingleColumnLayout) dispatchAnalyticsEvent({
                action: (0, $krYZG.ACTION).SINGLE_COL_LAYOUT_DETECTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            });
        }
        if ((0, $iDrrr.fg)('platform_editor_panel_c1_fallback_transform')) {
            const panelC1Result = $1c293eb64b22c2a9$var$runPanelC1FallbackTransform(schema, transformedAdf);
            if (panelC1Result.isTransformed && panelC1Result.transformedAdf) transformedAdf = panelC1Result.transformedAdf;
        }
        // Validate ADF first before converting nested-table extensions into nested tables
        // This matches the renderer's behavior in render-document.ts
        const allowNestedTables = (0, $hZ5o2.isNestedTablesSupported)(schema);
        const allowTableInPanel = (0, $d5JQX.isPanelNestingTableSupported)(schema);
        const allowContainerInPanel = (0, $998d6b5c5f5fc646$export$adaec6ad4f1f3448)(schema);
        const validateADFEntityOptions = allowNestedTables || allowTableInPanel || allowContainerInPanel ? {
            allowNestedTables: allowNestedTables || undefined,
            allowTableInPanel: allowTableInPanel || undefined,
            allowContainerInPanel: allowContainerInPanel || undefined
        } : undefined;
        let entity = (0, $2K3wo.validateADFEntity)(schema, transformedAdf || node, dispatchAnalyticsEvent, validateADFEntityOptions);
        // Convert nested-table extensions into nested tables
        ({ transformedAdf: transformedAdf } = $1c293eb64b22c2a9$var$transformNestedTablesWithAnalytics(entity, dispatchAnalyticsEvent));
        entity = transformedAdf;
        // The container-node promotion (panel -> panel_c1) is schema-driven and shared across
        // nesting scenarios, so it runs when any panel container-variant experiment is on.
        if ((0, $690f02e1a9a7d6f9$export$67a2736d73dace7c)()) {
            ({ transformedAdf: transformedAdf } = $1c293eb64b22c2a9$var$transformContainerNodesWithAnalytics(entity, schema, dispatchAnalyticsEvent));
            entity = transformedAdf;
        }
        const newEntity = $1c293eb64b22c2a9$var$maySanitizePrivateContent(entity, providerFactory, sanitizePrivateContent);
        const parsedDoc = (0, $aPdNQ.Node).fromJSON(schema, newEntity);
        // throws an error if the document is invalid
        try {
            parsedDoc.check();
        } catch (err) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $krYZG.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            });
            throw err;
        }
        if (dispatchAnalyticsEvent) (0, $1H5A4.findAndTrackUnsupportedContentNodes)(parsedDoc, schema, dispatchAnalyticsEvent);
        return parsedDoc;
    } catch (e) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
        // eslint-disable-next-line no-console
        console.error(`Error processing document:\n${e instanceof Error ? e.message : String(e)}\n\n`, JSON.stringify(node));
        if ($1c293eb64b22c2a9$var$isProseMirrorSchemaCheckError(e)) throw e;
        return;
    }
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $1c293eb64b22c2a9$var$INVALID_MARKS_REGEX = /^Invalid collection of marks for node/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $1c293eb64b22c2a9$var$INVALID_CONTENT_REGEX = /^Invalid content for node/;
function $1c293eb64b22c2a9$var$isProseMirrorSchemaCheckError(error) {
    return error instanceof RangeError && (!!error.message.match($1c293eb64b22c2a9$var$INVALID_MARKS_REGEX) || !!error.message.match($1c293eb64b22c2a9$var$INVALID_CONTENT_REGEX));
}
const $1c293eb64b22c2a9$var$maySanitizePrivateContent = (entity, providerFactory, sanitizePrivateContent)=>{
    if (sanitizePrivateContent && providerFactory) return (0, $kMDxP.sanitizeNodeForPrivacy)(entity, providerFactory);
    return entity;
};
module.exports["processRawValueWithoutValidation"] = $1c293eb64b22c2a9$export$cafe23194e65f591;
module.exports["processRawValue"] = $1c293eb64b22c2a9$export$f1a0a61081c3ed62;

});

parcelRegister("5trrQ", function(module, exports) {
const $dd348a331e5475c5$export$e1e720e5f4603e6a = (attrs)=>(...content)=>({
            type: 'tableCell',
            attrs: attrs,
            content: content
        });
module.exports["tableCell"] = $dd348a331e5475c5$export$e1e720e5f4603e6a;

});

parcelRegister("kaOn9", function(module, exports) {
const $b0599f6597963511$export$ce666bf02318c957 = (content)=>({
        type: 'tableRow',
        content: content
    });
module.exports["tableRow"] = $b0599f6597963511$export$ce666bf02318c957;

});

parcelRegister("hZ5o2", function(module, exports) {
const $7ebaeef09f48dd25$export$103fe177194b9cb8 = (schema)=>{
    const { table: table, tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    if (!table || !tableCell || !tableHeader) return false;
    // Check if table cells can contain table nodes by testing their content match
    const tableCellCanContainTable = tableCell.contentMatch.matchType(table)?.validEnd === true;
    const tableHeaderCanContainTable = tableHeader.contentMatch.matchType(table)?.validEnd === true;
    return tableCellCanContainTable || tableHeaderCanContainTable;
};
module.exports["isNestedTablesSupported"] = $7ebaeef09f48dd25$export$103fe177194b9cb8;

});

parcelRegister("kMDxP", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");


var $cRgxl = parcelRequire("cRgxl");

function $53f07bc0a1d45cae$export$8a32f625580e0a06(json, providerFactory) {
    const mentionNames = new Map();
    let hasCacheableMentions = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedJSON = (0, $jTt8P.traverse)(json, {
        mention: (node)=>{
            if (node.attrs && node.attrs.text) {
                hasCacheableMentions = true;
                // Remove @ prefix
                const text = node.attrs.text;
                const name = text.startsWith('@') ? text.slice(1) : text;
                mentionNames.set(node.attrs.id, name);
            }
            return {
                ...node,
                attrs: {
                    ...node.attrs,
                    text: ''
                }
            };
        }
    });
    if (hasCacheableMentions && providerFactory) {
        const handler = (_name, providerPromise)=>{
            if (providerPromise) providerPromise.then((provider)=>{
                if ((0, $cRgxl.isResolvingMentionProvider)(provider)) {
                    mentionNames.forEach((name, id)=>{
                        provider.cacheMentionName(id, name);
                    });
                    mentionNames.clear();
                    providerFactory.unsubscribe('mentionProvider', handler);
                }
            });
        };
        providerFactory.subscribe('mentionProvider', handler);
    }
    return sanitizedJSON;
}
module.exports["sanitizeNodeForPrivacy"] = $53f07bc0a1d45cae$export$8a32f625580e0a06;

});

parcelRegister("4yKbg", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $5Qi6J = parcelRequire("5Qi6J");

function $becd2ebdd36721c9$export$89b7989c347e6a7b(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    const adfEntities = value.map((item)=>(0, $5Qi6J.processRawValue)(schema, item, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent)).filter((item)=>Boolean(item));
    if (adfEntities.length === 0) return;
    return (0, $aPdNQ.Fragment).from(adfEntities);
}
module.exports["processRawFragmentValue"] = $becd2ebdd36721c9$export$89b7989c347e6a7b;

});

parcelRegister("4EksL", function(module, exports) {
$parcel$export(module.exports, "Side", () => (parcelRequire("eaLat")).Side);

var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $eaLat = parcelRequire("eaLat");


var $88vX6 = parcelRequire("88vX6");

const $f19fed71727f2340$export$d9f9f34e18094ffd = 'gapcursor';
class $f19fed71727f2340$export$7d98c58ca1423246 extends (0, $kCECX.Selection) {
    static valid($pos) {
        const { parent: parent, nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
        const targetNode = (0, $88vX6.isValidTargetNode)(nodeBefore) ? nodeBefore : (0, $88vX6.isValidTargetNode)(nodeAfter) ? nodeAfter : null;
        if (!targetNode || parent.isTextblock) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    static findFrom($pos, dir, mustMove = false) {
        const side = dir === 1 ? (0, $eaLat.Side).RIGHT : (0, $eaLat.Side).LEFT;
        if (!mustMove && $f19fed71727f2340$export$7d98c58ca1423246.valid($pos)) return new $f19fed71727f2340$export$7d98c58ca1423246($pos, side);
        let pos = $pos.pos;
        // TODO: ED-5048 - Fix any, potential issue.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let next = null;
        // Scan up from this position
        for(let d = $pos.depth;; d--){
            const parent = $pos.node(d);
            if (side === (0, $eaLat.Side).RIGHT ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                next = parent.maybeChild(side === (0, $eaLat.Side).RIGHT ? $pos.indexAfter(d) : $pos.index(d) - 1);
                break;
            } else if (d === 0) return null;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($f19fed71727f2340$export$7d98c58ca1423246.valid($cur)) return new $f19fed71727f2340$export$7d98c58ca1423246($cur, side);
        }
        // And then down into the next node
        for(;;){
            next = side === (0, $eaLat.Side).RIGHT ? next.firstChild : next.lastChild;
            if (next === null) break;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($f19fed71727f2340$export$7d98c58ca1423246.valid($cur)) return new $f19fed71727f2340$export$7d98c58ca1423246($cur, side);
        }
        return null;
    }
    static fromJSON(doc, json) {
        return new $f19fed71727f2340$export$7d98c58ca1423246(doc.resolve(json.pos), json.side);
    }
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.head));
        return $f19fed71727f2340$export$7d98c58ca1423246.valid($pos) ? new $f19fed71727f2340$export$7d98c58ca1423246($pos, this.side) : (0, $kCECX.Selection).near($pos);
    }
    eq(other) {
        return other instanceof $f19fed71727f2340$export$7d98c58ca1423246 && other.head === this.head;
    }
    content() {
        return (0, $aPdNQ.Slice).empty;
    }
    getBookmark() {
        return new $f19fed71727f2340$export$afd2c0d75bc9ce6c(this.anchor);
    }
    toJSON() {
        return {
            pos: this.head,
            type: $f19fed71727f2340$export$d9f9f34e18094ffd,
            side: this.side
        };
    }
    /**
   * Construct a GapCursorSelection
   * @param {ResolvedPos} $pos resolved position
   * @param {Side} side side where the gap cursor is drawn
   */ constructor($pos, side = (0, $eaLat.Side).LEFT){
        super($pos, $pos), this.side = side;
        this.visible = false;
    }
}
(0, $kCECX.Selection).jsonID($f19fed71727f2340$export$d9f9f34e18094ffd, $f19fed71727f2340$export$7d98c58ca1423246);
class $f19fed71727f2340$export$afd2c0d75bc9ce6c {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    map(mapping) {
        return new $f19fed71727f2340$export$afd2c0d75bc9ce6c(mapping.map(this.pos));
    }
    resolve(doc) {
        const $pos = doc.resolve(this.pos);
        return $f19fed71727f2340$export$7d98c58ca1423246.valid($pos) ? new $f19fed71727f2340$export$7d98c58ca1423246($pos) : (0, $kCECX.Selection).near($pos);
    }
    constructor(pos){
        this.pos = pos;
    }
}
module.exports["JSON_ID"] = $f19fed71727f2340$export$d9f9f34e18094ffd;
module.exports["GapCursorSelection"] = $f19fed71727f2340$export$7d98c58ca1423246;

});

parcelRegister("eaLat", function(module, exports) {
var $82f77c79c2c96909$export$80a00690bda7f17e = /*#__PURE__*/ function(Side) {
    Side["LEFT"] = "left";
    Side["RIGHT"] = "right";
    return Side;
}({});
module.exports["Side"] = $82f77c79c2c96909$export$80a00690bda7f17e;

});

parcelRegister("88vX6", function(module, exports) {

var $5X54F = parcelRequire("5X54F");

const $8c961580df7fbb3a$export$b485b49b5e1715ef = (node)=>{
    return !!node && !(0, $5X54F.isIgnored)(node);
};
module.exports["isValidTargetNode"] = $8c961580df7fbb3a$export$b485b49b5e1715ef;

});

parcelRegister("5X54F", function(module, exports) {
// we don't show gap cursor for those nodes
const $c5651a2c8eb33c12$var$IGNORED_NODES = [
    'paragraph',
    'bulletList',
    'orderedList',
    'listItem',
    'taskItem',
    'decisionItem',
    'heading',
    'blockquote',
    'layoutColumn',
    'caption',
    'media',
    'extensionFrame'
];
const $c5651a2c8eb33c12$export$ac3f691269cd6d9b = (node)=>{
    return !!node && $c5651a2c8eb33c12$var$IGNORED_NODES.indexOf(node.type.name) !== -1;
};
module.exports["isIgnored"] = $c5651a2c8eb33c12$export$ac3f691269cd6d9b;

});

parcelRegister("eJlpI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3k5Tv = parcelRequire("3k5Tv");


var $4o0zT = parcelRequire("4o0zT");


var $58PSv = parcelRequire("58PSv");


var $01rUB = parcelRequire("01rUB");


var $5XRFP = parcelRequire("5XRFP");


var $8m50u = parcelRequire("8m50u");


var $ieeJu = parcelRequire("ieeJu");





var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");

const $e360459019f1de6d$var$chromelessStyles = {
    scrollbar: "_3pAwtjEw7y _3J9v7g8fU6 _2vSjE5gozt _1gVfwBYbGa _0Gam4U66of _3ZpBalkTlo",
    editor: "_26BoRwSPN1 _0jFU0VIZbP _4bt5LAnQyn _2WAcuGIZbP _1EqgXlOLYo _24h04i2Njc _1T2N03wPeg _12iZqt98eZ _1oxO6FYbGa _1WW4KLT6kp _4FL2NLdnbC _2g2Wr0dnbC _0unGkCdnbC _0ArIKhdnbC _3VoV1AdnbC _46o2TmdnbC _3sxmnJdnbC _3CkF32dnbC _0upLEalpBW _35Wg0Q2ADO _2JHABoPgdg"
};
const $e360459019f1de6d$export$67dd02a0af0568d6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, containerRef: containerRef, maxHeight: maxHeight, minHeight: minHeight } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $e360459019f1de6d$var$chromelessStyles.editor,
            $e360459019f1de6d$var$chromelessStyles.scrollbar,
            "akEditor"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    const t2 = maxHeight ? `${maxHeight}px` : undefined;
    const t3 = `${minHeight}px`;
    let t4;
    if ($[1] !== t2 || $[2] !== t3) {
        t4 = {
            maxHeight: t2,
            minHeight: t3
        };
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== children || $[5] !== containerRef || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t1,
            style: t4,
            ref: containerRef,
            "data-testid": "chromeless-editor",
            id: "chromeless-editor",
            children: children
        });
        $[4] = children;
        $[5] = containerRef;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ children: children, containerRef: containerRef, maxHeight: maxHeight, minHeight: minHeight })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $e360459019f1de6d$var$chromelessStyles.editor,
            $e360459019f1de6d$var$chromelessStyles.scrollbar,
            "akEditor"
        ]),
        style: {
            maxHeight: maxHeight ? `${maxHeight}px` : undefined,
            minHeight: `${minHeight}px`
        },
        ref: containerRef,
        "data-testid": "chromeless-editor",
        id: "chromeless-editor",
        children: children
    });


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
* Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
* Used via `componentWithCondition` in `Chromeless.tsx`.
*
* Cleanup: delete this file once the experiment has shipped.
*/ 
var $lOiVq = parcelRequire("lOiVq");

function $6dea76d3058fe99d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6dea76d3058fe99d$var$scrollbarStylesNew = {
    name: "18ng4c4",
    styles: "-ms-overflow-style:-ms-autohiding-scrollbar;&::-webkit-scrollbar-corner{display:none;}&::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-subtle, #00000000);}&:hover::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-bold, #292A2E);border-radius:var(--ds-radius-large, 8px);}&::-webkit-scrollbar-thumb:hover{background-color:var(--ds-background-neutral-bold-hovered, #3B3D42);}"
};
const $6dea76d3058fe99d$var$chromelessEditorStylesNew = {
    name: "zwat44",
    styles: "line-height:20px;height:auto;overflow-x:hidden;overflow-y:auto;max-width:inherit;box-sizing:border-box;word-wrap:break-word;div > .ProseMirror{outline:none;white-space:pre-wrap;padding:0;margin:0;& > :last-child{padding-bottom:var(--ds-space-100, 8px);}}.ProseMirror{& > p:last-of-type{margin-bottom:var(--ds-space-0, 0px);}}"
};
const $6dea76d3058fe99d$export$c3fe16b5f281801b = ({ children: children, containerRef: containerRef, maxHeight: maxHeight, minHeight: minHeight, ...rest })=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $6dea76d3058fe99d$var$chromelessEditorStylesNew,
            $6dea76d3058fe99d$var$scrollbarStylesNew
        ],
        className: "akEditor",
        style: {
            maxHeight: maxHeight ? `${maxHeight}px` : undefined,
            minHeight: `${minHeight}px`
        },
        ref: containerRef,
        "data-testid": "chromeless-editor",
        id: "chromeless-editor"
    }, children);


const $4c6b7f4be382c6d6$export$5ffd32ebea3773c5 = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $e360459019f1de6d$export$67dd02a0af0568d6), (0, $6dea76d3058fe99d$export$c3fe16b5f281801b));


class $1e18578e92fa28bc$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        return /*#__PURE__*/ (0, $8aG6j.jsx)($1e18578e92fa28bc$var$RenderWithPluginState, {
            editorAPI: this.props.editorAPI,
            renderChrome: this.renderChrome
        });
    }
    constructor(...args){
        super(...args);
        this.appearance = 'chromeless';
        this.containerElement = null;
        this.setContainerElement = (ref)=>{
            this.containerElement = ref;
        };
        this.renderChrome = ({ maxContentSize: maxContentSize })=>{
            const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, maxHeight: maxHeight, minHeight: minHeight = 30, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginHooks: pluginHooks, featureFlags: featureFlags } = this.props;
            const maxContentSizeReached = Boolean(maxContentSize?.maxContentSizeReached);
            const editorViewMode = (0, $3k5Tv.useSharedPluginStateWithSelector)(this.props.editorAPI, [
                'editorViewMode'
            ], (states)=>states?.editorViewModeState?.mode);
            const containerRef = (0, $4o0zT.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? this.setContainerElement : (ref)=>this.containerElement = ref;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5XRFP.default), {
                animate: maxContentSizeReached,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4c6b7f4be382c6d6$export$5ffd32ebea3773c5), {
                    maxHeight: maxHeight,
                    minHeight: minHeight,
                    containerRef: containerRef,
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $58PSv.default), {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: "ak-editor-content-area",
                        featureFlags: featureFlags,
                        viewMode: editorViewMode,
                        appearance: this.appearance,
                        children: [
                            customContentComponents && 'before' in customContentComponents ? customContentComponents.before : customContentComponents,
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $01rUB.default), {
                                editorView: editorView,
                                editorActions: editorActions,
                                eventDispatcher: eventDispatcher,
                                providerFactory: providerFactory,
                                appearance: this.appearance,
                                items: contentComponents,
                                popupsMountPoint: popupsMountPoint,
                                popupsBoundariesElement: popupsBoundariesElement,
                                popupsScrollableElement: popupsScrollableElement,
                                containerElement: this.containerElement,
                                disabled: !!disabled,
                                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                wrapperElement: this.containerElement,
                                pluginHooks: pluginHooks
                            }),
                            editorDOMElement,
                            customContentComponents && 'after' in customContentComponents ? customContentComponents.after : null
                        ]
                    })
                })
            });
        };
    }
}
$1e18578e92fa28bc$export$2e2bcd8739ae039.displayName = 'ChromelessEditorAppearance';
function $1e18578e92fa28bc$var$RenderWithPluginState({ renderChrome: renderChrome, editorAPI: editorAPI }) {
    'use no memo';
    // renderChrome should be changed to called as a component not a function
    const maxContentSizeReached = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorAPI, [
        'maxContentSize'
    ], (states)=>states?.maxContentSizeState?.maxContentSizeReached);
    const maxContentSize = maxContentSizeReached === undefined ? undefined : {
        maxContentSizeReached: maxContentSizeReached
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Fragment), {
        children: renderChrome({
            maxContentSize: maxContentSize
        })
    });
}
module.exports["default"] = $1e18578e92fa28bc$export$2e2bcd8739ae039;

});

parcelRegister("3k5Tv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");

/**
 *
 * Directly map object values
 *
 * @private
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $a82bcb31e49bb834$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginStateWithSelector` example: `useSharedPluginStateWithSelector(api, ['width'], selector)`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $a82bcb31e49bb834$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $cozmU.useMemo)(()=>plugins, []);
}
function $a82bcb31e49bb834$export$e5d623015ec283cc(injectionApi, plugins, selector) {
    const pluginNames = $a82bcb31e49bb834$var$useStaticPlugins(plugins);
    const selectorRef = (0, $cozmU.useRef)(selector);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $cozmU.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $a82bcb31e49bb834$var$useSharedPluginStateInternal(namedExternalPlugins, selectorRef);
}
function $a82bcb31e49bb834$var$useSharedPluginStateInternal(externalPlugins, selector) {
    const refStates = (0, $cozmU.useRef)($a82bcb31e49bb834$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState()));
    const [pluginStates, setPluginState] = (0, $cozmU.useState)(()=>selector.current(refStates.current));
    const mounted = (0, $cozmU.useRef)(false);
    (0, $cozmU.useLayoutEffect)(()=>{
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            setPluginState((currentPluginStates)=>{
                const nextStates = selector.current({
                    ...refStates.current
                });
                if ($a82bcb31e49bb834$var$shallowEqual(nextStates, currentPluginStates)) return currentPluginStates;
                return nextStates;
            });
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $a82bcb31e49bb834$var$mapValues(externalPlugins, (value_0)=>value_0?.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb?.());
        };
    }, [
        externalPlugins,
        selector
    ]);
    return pluginStates;
}
function $a82bcb31e49bb834$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (objA[key] !== objB[key]) return false;
    }
    return true;
}
module.exports["useSharedPluginStateWithSelector"] = $a82bcb31e49bb834$export$e5d623015ec283cc;

});

parcelRegister("58PSv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $8dxef = parcelRequire("8dxef");


var $39Puj = parcelRequire("39Puj");


var $lqPdm = parcelRequire("lqPdm");

const $8b6953b26499ad89$var$tableCellBackgroundColorVariablePrefix = '--ak-editor-table-cell-background';
const $8b6953b26499ad89$var$getTableCellBackgroundColorVariableName = (colorName)=>`${$8b6953b26499ad89$var$tableCellBackgroundColorVariablePrefix}-${colorName.replace(/\s+/gu, '-')}`;
const $8b6953b26499ad89$export$ca835ce2a5bd6107 = Array.from((0, $39Puj.tableBackgroundColorNames).entries()).reduce((acc, [colorName, hexColor])=>{
    const paletteColorValue = (0, $lqPdm.hexToEditorBackgroundPaletteColor)(hexColor);
    if (paletteColorValue) acc[$8b6953b26499ad89$var$getTableCellBackgroundColorVariableName(colorName)] = paletteColorValue;
    return acc;
}, {});



var $7Y8M5 = parcelRequire("7Y8M5");

/**
 * Compiled CSS-compatible variant of {@link overflowShadow}. Returns a plain
 * CSS string (stack of `linear-gradient` layers) suitable for assignment to a
 * `background-image` property in a `cssMap`/`css` declaration.
 *
 * @param options.leftCoverWidth - Width of the left cover layer. Defaults to `token('space.100')`.
 * @param options.rightCoverWidth - Width of the right cover layer. Defaults to `token('space.100')`.
 */ const $82e142800f46dc29$export$bb4a61a93a1e5360 = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    return [
        /* shadow cover left */ `linear-gradient(to right, ${"var(--ds-background-neutral, #0515240F)"} ${leftCoverWidthResolved}, transparent ${leftCoverWidthResolved})`,
        /* shadow cover background left */ `linear-gradient(to right, ${"var(--ds-surface-raised, #FFFFFF)"} ${leftCoverWidthResolved}, transparent ${leftCoverWidthResolved})`,
        /* shadow cover right */ `linear-gradient(to left, ${"var(--ds-background-neutral, #0515240F)"} ${rightCoverWidthResolved}, transparent ${rightCoverWidthResolved})`,
        /* shadow cover background right */ `linear-gradient(to left, ${"var(--ds-surface-raised, #FFFFFF)"} ${rightCoverWidthResolved}, transparent ${rightCoverWidthResolved})`,
        /* overflow shadow right spread */ `linear-gradient(to left, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0, ${"var(--ds-UNSAFE-transparent, transparent)"} ${width})`,
        /* overflow shadow right perimeter */ `linear-gradient(to left, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0, ${"var(--ds-UNSAFE-transparent, transparent)"} ${width})`,
        /* overflow shadow left spread */ `linear-gradient(to right, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0, ${"var(--ds-UNSAFE-transparent, transparent)"} ${width})`,
        /* overflow shadow left perimeter */ `linear-gradient(to right, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0, ${"var(--ds-UNSAFE-transparent, transparent)"} ${width})`
    ].join(', ');
};



var $4o0zT = parcelRequire("4o0zT");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $jsa8f = parcelRequire("jsa8f");

const $f3bd510a790a1c50$var$akEditorCalculatedWideLayoutWidth = 1011; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $f3bd510a790a1c50$var$akEditorCalculatedWideLayoutWidthSmallViewport = 905;
const $f3bd510a790a1c50$var$akEditorGutterPadding = 32;
const $f3bd510a790a1c50$var$akEditorDefaultLayoutWidth = 760;
const $f3bd510a790a1c50$var$akEditorFullWidthLayoutWidth = 1800;
const $f3bd510a790a1c50$var$tableOverflowShadowWidthWide = 32; // The breakpoint for small devices is 1266px, copied from getBreakpoint in platform/packages/editor/editor-common/src/ui/WidthProvider/index.tsx
const $f3bd510a790a1c50$var$akEditorBreakpointForSmallDevice = `1266px`;
const $f3bd510a790a1c50$var$akEditorGutterPaddingReduced = 24;
const $f3bd510a790a1c50$var$akEditorFullPageNarrowBreakout = 600;
const $f3bd510a790a1c50$var$akEditorUltraWideLayoutWidth = 4000; // Layout responsiveness breakpoints — chosen to align editor layout responsiveness with the renderer.
// Applied to the editor-area container query (max-width) for layout sections.
const $f3bd510a790a1c50$var$akEditorLayoutFullWidthBreakpoint = 724;
const $f3bd510a790a1c50$var$akEditorLayoutFixedWidthBreakpoint = 788;
const $f3bd510a790a1c50$var$akEditorLayoutResizedBreakpoint = 820; // Originally copied from packages/editor/editor-core/src/ui/Appearance/Comment/Comment.tsx
const $f3bd510a790a1c50$var$CommentEditorMargin = 14;
const $f3bd510a790a1c50$var$GRID_GUTTER = 12;
const $f3bd510a790a1c50$var$blockNodesVerticalMargin = '0.75rem';
const $f3bd510a790a1c50$var$fontSize14px = `${0.875}rem`;
const $f3bd510a790a1c50$var$scaledBlockNodesVerticalMargin = '0.75em'; // Block spacing hook (gated by isExperimentEnabled('platform_editor_extension_block_spacing')).
// When the experiment is on, these variants re-declare the block margins to read from the
// `--ak-editor-extension-block-spacing` CSS custom property, falling back to the original values.
// When the experiment is off, none of these are applied and behaviour is identical to before.
const $f3bd510a790a1c50$var$blockNodesVerticalMarginVar = 'var(--ak-editor-extension-block-spacing, 0.75rem)';
const $f3bd510a790a1c50$var$scaledBlockNodesVerticalMarginVar = 'var(--ak-editor-extension-block-spacing, 0.75em)'; // emoji constants — values inlined from packages/elements/emoji/src/util/constants.ts
// If you need to update these values, please also update packages/elements/emoji/src/util/constants.ts
const $f3bd510a790a1c50$var$defaultEmojiHeight = 20;
const $f3bd510a790a1c50$var$defaultDenseEmojiHeight = 16.25;
const $f3bd510a790a1c50$var$scaledEmojiHeightH1 = 28;
const $f3bd510a790a1c50$var$scaledEmojiHeightH2 = 26;
const $f3bd510a790a1c50$var$scaledEmojiHeightH3 = 24;
const $f3bd510a790a1c50$var$scaledEmojiHeightH4 = 22;
const $f3bd510a790a1c50$var$denseEmojiHeightH1 = 24.25;
const $f3bd510a790a1c50$var$denseEmojiHeightH2 = 22.25;
const $f3bd510a790a1c50$var$denseEmojiHeightH3 = 20.25;
const $f3bd510a790a1c50$var$denseEmojiHeightH4 = 18.25; // TODO: EDITOR-6932 - inline them at the end of migration
const $f3bd510a790a1c50$var$emojiSelectionStyles = null;
const $f3bd510a790a1c50$var$gutterDangerOverlay = null;
const $f3bd510a790a1c50$var$blanketSelectionStyles = null; // copied from packages/editor/editor-shared-styles/src/consts/consts.ts
const $f3bd510a790a1c50$var$akEditorLineHeight = 1.714;
const $f3bd510a790a1c50$var$listsStylesSafariFixMultiSelector = `
	.ProseMirror:not(.blockCardView-content-wrap) > li > p:first-child,
	.ProseMirror:not(.blockCardView-content-wrap) > li > .code-block:first-child,
	.ProseMirror:not(.blockCardView-content-wrap) > li > .ProseMirror-gapcursor:first-child + .code-block`;
const $f3bd510a790a1c50$var$editorAreaNonSmallDeviceContainerQuery = `@container editor-area (width >= ${$f3bd510a790a1c50$var$akEditorBreakpointForSmallDevice})`;
const $f3bd510a790a1c50$var$editorAreaNarrowPageContainerQuery = `@container editor-area (max-width: ${$f3bd510a790a1c50$var$akEditorFullPageNarrowBreakout}px)`;
const $f3bd510a790a1c50$var$editorAreaLayoutFullWidthMaxWidthContainerQuery = `@container editor-area (max-width: ${$f3bd510a790a1c50$var$akEditorLayoutFullWidthBreakpoint}px)`;
const $f3bd510a790a1c50$var$editorAreaLayoutFixedWidthMaxWidthContainerQuery = `@container editor-area (max-width: ${$f3bd510a790a1c50$var$akEditorLayoutFixedWidthBreakpoint}px)`;
const $f3bd510a790a1c50$var$editorAreaLayoutResizedMaxWidthContainerQuery = `@container editor-area (max-width: ${$f3bd510a790a1c50$var$akEditorLayoutResizedBreakpoint}px)`;
const $f3bd510a790a1c50$var$placeholderFadeInKeyframes = null;
const $f3bd510a790a1c50$var$fadeIn = null;
const $f3bd510a790a1c50$var$tableInlineStartShadow = null;
const $f3bd510a790a1c50$var$tableInlineEndShadow = null;
const $f3bd510a790a1c50$var$hideNativeBrowserTextSelectionStyles = null;
const $f3bd510a790a1c50$var$boxShadowSelectionStyles = null; // TODO: EDITOR-6932 - inline them at the end of migration
const $f3bd510a790a1c50$var$dangerBorderStyles = null; // TODO: EDITOR-6932 - inline them at the end of migration
const $f3bd510a790a1c50$var$backgroundSelectionStyles = null; // TODO: EDITOR-6932 - inline them at the end of migration
const $f3bd510a790a1c50$var$dangerBackgroundStyles = null; // TODO: EDITOR-6932 - inline them at the end of migration
const $f3bd510a790a1c50$var$mentionsSelectedColor = null;
const $f3bd510a790a1c50$var$fixVerticalAlignmentSelector = `
	&:first-of-type + ul,
	&:first-of-type + span + ul,
	&:first-of-type + ol,
	&:first-of-type + span + ol,
	&:first-of-type + pre,
	&:first-of-type + span + pre,
	&:first-of-type + blockquote,
	&:first-of-type + span + blockquote
`;
const $f3bd510a790a1c50$var$gapCursorTwoImagesSideBySideFixSelector = `
  .ProseMirror-gapcursor[layout="wrap-left"] + span + [layout="wrap-left"],
  .ProseMirror-gapcursor[layout="wrap-right"] + span + [layout="wrap-right"],
  .ProseMirror-gapcursor + [layout="wrap-left"] + [layout="wrap-right"],
  .ProseMirror-gapcursor + [layout="wrap-left"] + span + [layout="wrap-right"],
  .ProseMirror-gapcursor + [layout="wrap-right"] + [layout="wrap-left"],
  .ProseMirror-gapcursor + [layout="wrap-right"] + span + [layout="wrap-left"],
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"],
  [layout="wrap-left"] + .ProseMirror-gapcursor + span [layout="wrap-right"],
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"],
  [layout="wrap-right"] + .ProseMirror-gapcursor + span + [layout="wrap-left"],
  [layout="wrap-left"] + .ProseMirror-gapcursor`;
const $f3bd510a790a1c50$var$gapCursorMarginFixSelector = `
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"] > div,
  [layout="wrap-left"] + .ProseMirror-gapcursor + span + [layout="wrap-right"] > div,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"] > div,
  [layout="wrap-right"] + .ProseMirror-gapcursor + span + [layout="wrap-left"] > div,
  .ProseMirror-gapcursor + [layout="wrap-right"] + [layout="wrap-left"] > div,
  .ProseMirror-gapcursor + [layout="wrap-right"] + span + [layout="wrap-left"] > div,
  .ProseMirror-gapcursor + [layout="wrap-left"] + [layout="wrap-right"] > div,
  .ProseMirror-gapcursor + [layout="wrap-left"] + span + [layout="wrap-right"] > div`;
const $f3bd510a790a1c50$var$gapCursorFloatLeftFixSelector = `
  [layout="wrap-left"] + .ProseMirror-gapcursor,
  [layout="wrap-right"] + .ProseMirror-gapcursor`;
const $f3bd510a790a1c50$var$gapCursorAfterPseudoSelector = `
  .ProseMirror-gapcursor + [layout="wrap-left"] + span + [layout="wrap-right"]::after,
  .ProseMirror-gapcursor + [layout="wrap-right"] + span + [layout="wrap-left"]::after,
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"]::after,
  [layout="wrap-left"] + .ProseMirror-gapcursor + span + [layout="wrap-right"]::after,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"]::after,
  [layout="wrap-right"] + .ProseMirror-gapcursor + span + [layout="wrap-left"]::after`;
const $f3bd510a790a1c50$var$gapCursorMarginDeepChildrenFixSelector = `
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"] + *,
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"] + span + *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"] + *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"] + span + *,
  [layout="wrap-left"] + .ProseMirror-gapcursor + span + [layout="wrap-right"] + *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + span + [layout="wrap-left"] + *,
  .ProseMirror-gapcursor + [layout="wrap-left"] + span + [layout="wrap-right"] + *,
  .ProseMirror-gapcursor + [layout="wrap-right"] + span + [layout="wrap-left"] + *,
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"] + * > *,
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"] + span + * > *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"] + * > *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"] + span + * > *,
  [layout="wrap-left"] + .ProseMirror-gapcursor + span + [layout="wrap-right"] + * > *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + span + [layout="wrap-left"] + * > *,
  .ProseMirror-gapcursor + [layout="wrap-left"] + span + [layout="wrap-right"] + * > *,
  .ProseMirror-gapcursor + [layout="wrap-right"] + span + [layout="wrap-left"] + * > *,
  .ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"]) + .ProseMirror-gapcursor + *,
  .ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"]) + .ProseMirror-gapcursor + span + *`;
const $f3bd510a790a1c50$var$gapCursorBlink = null;
const $f3bd510a790a1c50$var$pulseIn = null;
const $f3bd510a790a1c50$var$pulseOut = null;
const $f3bd510a790a1c50$var$pulseInDuringTr = null;
const $f3bd510a790a1c50$var$pulseOutDuringTr = null; // Agent edit shimmer: skeleton-loader sweep across the agent-authored range.
const $f3bd510a790a1c50$var$agentShimmer = null; // Agent edit purple "just edited" highlight: eases the background and underline in, holds, then eases
// them back out over the highlight's lifetime (duration set inline per-decoration to match removal).
const $f3bd510a790a1c50$var$agentEditHighlight = null;
const $f3bd510a790a1c50$var$syncBlockCreationLoadingKeyframes = null;
const $f3bd510a790a1c50$var$mentionRunShimmer = null; /**
                                 * aiPanelStyles
                                 * was imported from packages/editor/editor-core/src/ui/ContentStyles/ai-panels.ts
                                 */ 
const $f3bd510a790a1c50$var$rotationAnimation = null;
const $f3bd510a790a1c50$var$rotationAnimationFirefox = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $f3bd510a790a1c50$var$prismBorderBaseBackgroundFirefox = `linear-gradient(90deg, #0065FF 0%, #0469FF 12%, #BF63F3 24%, #FFA900 48%, #BF63F3 64%, #0469FF 80%, #0065FF 100%)`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $f3bd510a790a1c50$var$prismBorderBaseBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), #0065FF 0%, #0469FF 20%, #BF63F3 50%, #FFA900 56%, #0065FF 100%)`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $f3bd510a790a1c50$var$prismBorderDarkBackgroundFirefox = `linear-gradient(90deg, #0065FF80 0%, #0469FF80 12%, #BF63F380 24%, #FFA90080 48%, #BF63F380 64%, #0469FF80 80%, #0065FF80 100%)`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $f3bd510a790a1c50$var$prismBorderDarkBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), #0065FF80 0%, #0469FF80 20%, #BF63F380 50%, #FFA90080 56%, #0065FF80 100%)`; // TODO: EDITOR-6932 - inline them at the end of migration
const $f3bd510a790a1c50$var$borderSelectionStyles = null;
const $f3bd510a790a1c50$var$overflowShadowStyles = null; /**
                                    * editorContentStyles contains the Compiled CSS styles migrated from EditorContentContainer/styles.
                                    * Validate style changes with local VR and integration tests.
                                    *
                                    * If you are not sure, please contact #proj-cc-editor-full-compiled-css-migration
                                    */ 
// eslint-disable-next-line @atlaskit/design-system/no-css-map-scoped
const $f3bd510a790a1c50$var$editorContentStyles = {
    aiPanelBaseFirefoxStyles: "cc-nxozza",
    aiPanelBaseStyles: "cc-fq3ixy",
    aiPanelDarkFirefoxStyles: "cc-10cptea",
    aiPanelDarkStyles: "cc-5cpl9e",
    alignMultipleWrappedImageInLayoutStyles: "cc-dkvgen",
    annotationStyles: "cc-1flkwh",
    backgroundColorStyles: "cc-vbhsc3",
    highlightLinksUnsetStyles: "cc-kix5ii",
    baseStyles: "cc-8rtctp",
    baseStylesMaxContainerWidthFixes: "cc-9ri12x",
    blockMarksStyles: "cc-8cs5ej",
    blockSpacingVarStyles: "cc-8757yd",
    extensionWithBreakoutStyles: "cc-j1c8r0",
    blockSpacingVarScaledStyles: "cc-1xcketl",
    blockquoteDangerStyles: "cc-1sniys0",
    blockquoteSelectedNodeStyles: "cc-zchq1h",
    blocktypeStyles: "cc-fbqkq9",
    headingScrollMarginStyles: "cc-7k6n9k",
    blocktypeStylesRtlBlockquote: "cc-jo4vj",
    blocktypeStylesNestedDnd: "cc-1r1wtfx",
    blocktypeStyles_fg_platform_editor_typography_ugc: "cc-1tvgvcm",
    codeBlockStyles: "cc-1aew448",
    codeBlockStylesWithEmUnits: "cc-hl0mak",
    codeMarkStyles: "cc-1j1rcxi",
    commentEditorStyles: "cc-ht6m66",
    nonFullPageContainerTypeStyles: "cc-vvroiu",
    cursorStyles: "cc-bp4onv",
    dangerDateStyles: "cc-4fidym",
    dangerRuleStyles: "cc-12bry89",
    ruleWithAttrsStyles: "cc-jgboh",
    dateStyles: "cc-4a2sda",
    dateVanillaStyles: "cc-uwx56g",
    decisionDangerStyles: "cc-1if9r82",
    decisionIconWithVisualRefresh: "cc-11vrzqk",
    decisionStyles: "cc-8lm5yp",
    diffListStyles: "cc-5jmzeb",
    editorControlsSmartCardStyles: "cc-1ej3po4",
    editorGutterPaddingBaseStyles: "cc-1u75jr",
    editorLargeGutterPuddingReducedBaseStyles: "cc-16djhdn",
    editorUGCTokensRefreshed: "cc-axldfu",
    editorUGCSmallText: "cc-gi137o",
    embedCardStyles: "cc-rvrlre",
    emojiDangerStyles: "cc-zm2uv",
    emojiStyles: "cc-hhv5aj",
    emojiSelectionStyles: "cc-93v8xz",
    directEmojiSelectionStyles: "cc-1shdmq7",
    emojiDenseStyles: "cc-1c1i7rv",
    expandStyles: "cc-halxj4",
    expandStylesBase: "cc-17cvvyz",
    expandStylesMixin_chromeless_expand_fix: "cc-1vh2e0l",
    expandStylesMixinNestedDnd: "cc-oizn4q",
    expandStylesMixin_fg_platform_visual_refresh_icons: "cc-1wwn39y",
    expandDenseStyles: "cc-1roxt8n",
    extensionStyles: "cc-1smh8rj",
    extensionStylesDense: "cc-co74ny",
    extensionDiffStyles: "cc-17qh1x7",
    bodiedExtensionLayoutShiftFix: "cc-1iiqc8d",
    findReplaceStyles: "cc-rltwid",
    findReplaceStylesWithCodeblockColorContrastFix: "cc-fvp5l3",
    findReplaceStylesWithRefSyncBlock: "cc-1lqllhn",
    firstBlockNodeStyles: "cc-c7wvy",
    firstNodeWidgetFixStyles: "cc-2ub6w9",
    firstCodeBlockWithNoMargin: "cc-101wakz",
    firstFloatingToolbarButtonStyles: "cc-qzsa0i",
    firstWrappedMediaStyles: "cc-1932pj3",
    fontSizeStyles: "cc-1bl2asj",
    fullPageEditorStyles: "cc-u6bitr",
    gapCursorStyles: "cc-6snxi6",
    gapCursorStylesVisibilityFix: "cc-1jrnrsn",
    gridStyles: "cc-1mk7qyx",
    hideCursorWhenHideSelectionStyles: "cc-1o2iha0",
    hideSelectionStyles: "cc-1062cpx",
    hyperLinkFloatingToolbarStyles: "cc-mcw54q",
    indentationStyles: "cc-178lsg",
    InlineNodeViewSharedStyles: "cc-qmeuk0",
    layoutBaseStyles: "cc-x33nmu",
    layoutBaseStylesAdvanced: "cc-5tnpr3",
    layoutBaseStylesNestedDndExcludingBodiedSync: "cc-1aah7yo",
    layoutColumnDividerStyles: "cc-1kmb1d7",
    layoutColumnDividerStylesNestedDnD: "cc-1wu6eoc",
    layoutColumnMartinTopFixes: "cc-1ui88lk",
    layoutColumnResizeStyles: "cc-13pm7r7",
    layoutColumnResponsiveStyles: "cc-ltzpov",
    layoutColumnStylesAdvanced: "cc-b8v72t",
    layoutColumnStylesNotAdvanced: "cc-ji5n4z",
    layoutResponsiveBaseStyles: "cc-5tnn3i",
    layoutResponsiveStylesForView: "cc-19hy1zt",
    layoutDragHandleWrapperStylesLegacy: "cc-1334uzr",
    layoutSectionStylesAdvanced: "cc-jymp42",
    layoutSectionStylesNotAdvanced: "cc-bl1kpu",
    layoutSelectedStylesAdvanced: "cc-1awd7rg",
    layoutSelectedStylesAdvancedFix: "cc-dvqk9n",
    layoutSelectedStylesForViewAdvanced: "cc-1ubdzzh",
    layoutSelectedStylesForViewNotAdvanced: "cc-1s8bqns",
    layoutSelectedStylesNotAdvanced: "cc-a2byjx",
    layoutStylesForView: "cc-jybn5i",
    linkingVisualRefreshV1Styles: "cc-18lhlkw",
    linkStyles: "cc-4q7djy",
    listDangerStyles: "cc-175suwm",
    listItemHiddenMarkerStyles: "cc-5drztr",
    listSelectedNodeStyles: "cc-kjdsov",
    listsStyles: "cc-d30lm9",
    listsStylesMarginLayoutShiftFix: "cc-19q8bsv",
    listsStylesSafariFix: "cc-7zb3g7",
    listsDenseStyles: "cc-1f5b2a8",
    maxModeReizeFixStyles: "cc-yaauc5",
    mediaAlignmentStyles: "cc-1u4mef2",
    vanillaCaptionStyles: "cc-ylks8u",
    mediaCaptionStyles: "cc-jou28z",
    mediaDangerStyles: "cc-1j1fgm4",
    mediaGroupStyles: "cc-1181xy3",
    mediaStyles: "cc-1tsurnq",
    mentionDangerStyles: "cc-shgg21",
    mentionNodeStyles: "cc-3mptdv",
    agentMentionShimmerDarkMode: "cc-kpc7tm",
    mentionsSelectionStyles: "cc-pasq3f",
    mentionsStyles: "cc-1ch2mav",
    nestedPanelBorderStylesMixin: "cc-4gjktj",
    nestedPanelDangerStyles: "cc-6qmb10",
    panelStyles: "cc-1q1rsvs",
    panelStylesMixin: "cc-y1fvdb",
    panelStylesMixinNestedDnd: "cc-1l2ajh9",
    panelViewStyles: "cc-14f1i19",
    paragraphStylesUGCRefreshed: "cc-xd6k28",
    paragraphStylesWithScaledMargin: "cc-dafs11",
    placeholderOverflowStyles: "cc-1ratie0",
    placeholderStyles: "cc-1fe75wr",
    placeholderTextStyles: "cc-p2vnxp",
    pragmaticResizerStyles: "cc-xz3998",
    pragmaticResizerStylesCodeBlockSyncedBlockPatch: "cc-1ou5hn3",
    pragmaticResizerStylesForTooltip: "cc-ol8ybb",
    pragmaticResizerStylesSyncedBlock: "cc-1qubxhz",
    pragmaticResizerStylesWithReducedEditorGutter: "cc-pjep6d",
    pragmaticResizerStylesPanelAndRule: "cc-1yd6cax",
    pragmaticResizerStylesExtensions: "cc-1vlq9bw",
    pragmaticStylesLayoutFirstNodeResizeHandleFix: "cc-gvmcb8",
    resizerStyles: "cc-12vtbrw",
    resizerBottomHandleStyles: "cc-1uqurck",
    ruleStyles: "cc-1udc5a2",
    scaledEmojiStyles: "cc-33h5rh",
    scaledEmojiDenseStyles: "cc-1xoth0f",
    scrollbarStyles: "cc-19g7rsz",
    selectedNodeStyles: "cc-1rdosaw",
    selectionToolbarAnimationStyles: "cc-pwe4jy",
    shadowStyles: "cc-17lsfth",
    showDiffDeletedNodeStyles: "cc-yq0u2c",
    smartCardDiffStyles: "cc-q67isw",
    smartCardStylesWithSearchMatch: "cc-en2ljt",
    smartCardStylesWithSearchMatchAndBlockMenuDangerStyles: "cc-1xb8dtq",
    smartCardStylesWithSearchMatchAndPreviewPanelResponsiveness: "cc-1lq0ftg",
    smartLinksInLivePagesStyles: "cc-1vvkzqc",
    syncBlockFirstNodeStyles: "cc-w012lq",
    syncBlockTextSelectionStyles: "cc-1y0yw2m",
    syncBlockInteractiveCursorStyles: "cc-13vvsdg",
    syncBlockOverflowStyles: "cc-pcoc0f",
    syncBlockStyles: "cc-hcyd0h",
    syncBlockSelectedStyles: "cc-u54o3z",
    syncBlockStylesBase: "cc-15d9ojr",
    tableCellBackgroundColorOverrides: "cc-1d4nwlw",
    tableCommentEditorStyles: "cc-1rmp8zp",
    tableContainerStyles: "cc-cdl04x",
    tableScrollInlineShadowStyles: "cc-1ff9jzy",
    tableContentModeStyles: "cc-jaald7",
    tableContentModeExtensionContainmentStyles: "cc-n94ot4",
    tableContentModeNestedTableStyles: "cc-7bbx0c",
    tableEmptyRowStyles: "cc-2hcb5b",
    tableRoundedCornerStyles: "cc-40thxh",
    tableLayoutFixes: "cc-1olrv5m",
    tableLayoutFixesWithFontSize: "cc-12k1wjt",
    tableSharedStyle: "cc-191p3m",
    tableSharedStyleBackgroundClipFix: "cc-8zaofg",
    tableSharedStyle_with_platform_editor_table_q4_loveability: "cc-1yp891w",
    tableSharedStyle_without_platform_editor_table_q4_loveability: "cc-1oggp9a",
    tableSharedStyle_with_platform_editor_table_menu_updates: "cc-1umqnky",
    tableSharedStyle_with_platform_editor_bordered_panel_nested_in_table: "cc-19kg595",
    taskItemCheckboxStyles: "cc-ri327w",
    taskItemStyles: "cc-12ue49",
    taskItemStylesWithBlockTaskItem: "cc-1lrzai2",
    tasksAndDecisionsStyles: "cc-111dazk",
    tasksAndDecisionsDenseStyles: "cc-r80zg4",
    statusDangerStyles: "cc-16eit37",
    statusStyles: "cc-1n7epx6",
    statusStylesMixin_fg_platform_component_visual_refresh_with_search_match: "cc-1rkvfkn",
    statusStylesMixin_without_fg_platform_component_visual_refresh_with_search_match: "cc-asniun",
    deletedStatusStrikeStyles: "cc-l4fro4",
    statusStylesTeam26: "cc-18pwq72",
    statusStylesNamedSemantic: "cc-nxc4cw",
    statusStylesNamedAccent: "cc-1ajfo9u",
    statusStylesHexAccent: "cc-13q87kd",
    telepointerColorAndCommonStyle: "cc-18bfncu",
    telepointerColorAndCommonStyleDarkMode: "cc-vh4h1e",
    agentShimmerStyles: "cc-oxiemz",
    telepointerStyle: "cc-yly1tq",
    textColorStyles: "cc-zrepy0",
    textDangerStyles: "cc-dqcceg",
    textHighlightPaddingStyles: "cc-w1naod",
    textHighlightStyle: "cc-5bys90",
    textSelectedNodeStyles: "cc-zehtfr",
    unsupportedStyles: "cc-148bb4h",
    vanillaTooltipDefaultStyles: "cc-1nel5m",
    contributorTagStyles: "cc-1nedeqb",
    vanillaUnsupportedStyles: "cc-14ih7us",
    whitespaceStyles: "cc-3tuu0m"
};
const $f3bd510a790a1c50$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $f3bd510a790a1c50$export$b9e04e68e256861a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(26);
    const { className: className, children: children, viewMode: viewMode, isScrollable: isScrollable, appearance: appearance, contentMode: contentMode, useStandardNodeWidth: useStandardNodeWidth } = props;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const isFullPage = appearance === "full-page" || appearance === "full-width" || appearance === "max";
    const isComment = appearance === "comment";
    const isChromeless = appearance === "chromeless";
    let t0;
    if ($[0] !== appearance || $[1] !== contentMode) {
        t0 = (0, $jsa8f.getBaseFontSize)(appearance, contentMode);
        $[0] = appearance;
        $[1] = contentMode;
        $[2] = t0;
    } else t0 = $[2];
    const baseFontSize = t0;
    const isDense = !!baseFontSize && baseFontSize !== (0, $7Y8M5.akEditorFullPageDefaultFontSize);
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $82e142800f46dc29$export$bb4a61a93a1e5360)({
            leftCoverWidth: "var(--ds-space-300, 24px)"
        });
        $[3] = t1;
    } else t1 = $[3];
    const tableOverflowShadow = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            "--ak-editor--table-overflow-shadow": tableOverflowShadow,
            ...(0, $8b6953b26499ad89$export$ca835ce2a5bd6107),
            ...!(0, $jkcNT.editorExperiment)("platform_editor_preview_panel_responsiveness", true, {
                exposure: true
            }) && {
                "--ak-editor--large-gutter-padding": `${(0, $7Y8M5.akEditorGutterPaddingDynamic)()}px`
            }
        };
        $[4] = t2;
    } else t2 = $[4];
    const style = t2;
    let t3;
    if ($[5] !== className || $[6] !== colorMode || $[7] !== contentMode || $[8] !== isChromeless || $[9] !== isComment || $[10] !== isDense || $[11] !== isFullPage || $[12] !== useStandardNodeWidth || $[13] !== viewMode) {
        const browser = (0, $8dxef.getBrowserInfo)();
        const isBlockSpacingEnabled = (0, $4o0zT.isExperimentEnabled)("platform_editor_extension_block_spacing");
        const isFloatingTocEnabled = (0, $4o0zT.isExperimentEnabled)("platform_editor_floating_toc");
        const isUpdateStatusColorsEnabled = (0, $2pQiO.UNSAFE_expValNoExposure)("platform_editor_update_status_colors", "isEnabled", false) || (0, $2pQiO.UNSAFE_expValNoExposure)("platform_editor_update_status_colors_jira", "isEnabled", false);
        const isStatusStylesTeam26 = (0, $iDrrr.fg)("platform-dst-lozenge-tag-badge-visual-uplifts");
        let t4;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = !(0, $ieeJu.expValEquals)("platform_editor_lovability_text_bg_color", "isEnabled", true) && $f3bd510a790a1c50$var$editorContentStyles.highlightLinksUnsetStyles;
            $[15] = t4;
        } else t4 = $[15];
        let t5;
        if ($[16] !== contentMode || $[17] !== isDense) {
            t5 = contentMode === "compact" && isDense && !(0, $ieeJu.expValEquals)("platform_editor_lovability_emoji_scaling", "isEnabled", true) && $f3bd510a790a1c50$var$editorContentStyles.emojiDenseStyles;
            $[16] = contentMode;
            $[17] = isDense;
            $[18] = t5;
        } else t5 = $[18];
        t3 = (0, $hekY6.default)([
            $f3bd510a790a1c50$var$editorContentStyles.baseStyles,
            $f3bd510a790a1c50$var$editorContentStyles.maxModeReizeFixStyles,
            $f3bd510a790a1c50$var$editorContentStyles.baseStylesMaxContainerWidthFixes,
            $f3bd510a790a1c50$var$editorContentStyles.editorGutterPaddingBaseStyles,
            (0, $jkcNT.editorExperiment)("platform_editor_preview_panel_responsiveness", true, {
                exposure: true
            }) && $f3bd510a790a1c50$var$editorContentStyles.editorLargeGutterPuddingReducedBaseStyles,
            $f3bd510a790a1c50$var$editorContentStyles.whitespaceStyles,
            $f3bd510a790a1c50$var$editorContentStyles.indentationStyles,
            $f3bd510a790a1c50$var$editorContentStyles.fontSizeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.shadowStyles,
            $f3bd510a790a1c50$var$editorContentStyles.InlineNodeViewSharedStyles,
            $f3bd510a790a1c50$var$editorContentStyles.hideSelectionStyles,
            $f3bd510a790a1c50$var$editorContentStyles.hideCursorWhenHideSelectionStyles,
            $f3bd510a790a1c50$var$editorContentStyles.selectedNodeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.cursorStyles,
            $f3bd510a790a1c50$var$editorContentStyles.firstFloatingToolbarButtonStyles,
            $f3bd510a790a1c50$var$editorContentStyles.placeholderTextStyles,
            $f3bd510a790a1c50$var$editorContentStyles.placeholderStyles,
            (0, $jkcNT.editorExperiment)("platform_editor_controls", "variant1") && $f3bd510a790a1c50$var$editorContentStyles.placeholderOverflowStyles,
            $f3bd510a790a1c50$var$editorContentStyles.codeBlockStyles,
            contentMode === "compact" && $f3bd510a790a1c50$var$editorContentStyles.codeBlockStylesWithEmUnits,
            $f3bd510a790a1c50$var$editorContentStyles.editorUGCTokensRefreshed,
            $f3bd510a790a1c50$var$editorContentStyles.editorUGCSmallText,
            $f3bd510a790a1c50$var$editorContentStyles.blocktypeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.blocktypeStylesRtlBlockquote,
            isFloatingTocEnabled && $f3bd510a790a1c50$var$editorContentStyles.headingScrollMarginStyles,
            $f3bd510a790a1c50$var$editorContentStyles.blockquoteSelectedNodeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.listSelectedNodeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.textSelectedNodeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.blocktypeStyles_fg_platform_editor_typography_ugc,
            $f3bd510a790a1c50$var$editorContentStyles.blocktypeStylesNestedDnd,
            $f3bd510a790a1c50$var$editorContentStyles.codeMarkStyles,
            $f3bd510a790a1c50$var$editorContentStyles.textColorStyles,
            $f3bd510a790a1c50$var$editorContentStyles.backgroundColorStyles,
            t4,
            $f3bd510a790a1c50$var$editorContentStyles.textHighlightPaddingStyles,
            $f3bd510a790a1c50$var$editorContentStyles.listsStyles,
            $f3bd510a790a1c50$var$editorContentStyles.listItemHiddenMarkerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.diffListStyles,
            contentMode === "compact" && isDense && $f3bd510a790a1c50$var$editorContentStyles.listsDenseStyles,
            isFullPage && $f3bd510a790a1c50$var$editorContentStyles.listsStylesMarginLayoutShiftFix,
            $f3bd510a790a1c50$var$editorContentStyles.ruleStyles,
            (0, $4o0zT.isExperimentEnabled)("platform_editor_lovability_dividers_attributes") && $f3bd510a790a1c50$var$editorContentStyles.ruleWithAttrsStyles,
            $f3bd510a790a1c50$var$editorContentStyles.smartCardDiffStyles,
            $f3bd510a790a1c50$var$editorContentStyles.showDiffDeletedNodeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.mediaStyles,
            (0, $4o0zT.isExperimentEnabled)("platform_editor_vanilla_node_views_phase1") && $f3bd510a790a1c50$var$editorContentStyles.vanillaCaptionStyles,
            contentMode === "compact" && $f3bd510a790a1c50$var$editorContentStyles.mediaCaptionStyles,
            $f3bd510a790a1c50$var$editorContentStyles.firstWrappedMediaStyles,
            $f3bd510a790a1c50$var$editorContentStyles.telepointerStyle,
            $f3bd510a790a1c50$var$editorContentStyles.telepointerColorAndCommonStyle,
            colorMode === "dark" && $f3bd510a790a1c50$var$editorContentStyles.telepointerColorAndCommonStyleDarkMode,
            (0, $anBbz.expValEqualsNoExposure)("platform_editor_agent_be_streaming", "isEnabled", true) && $f3bd510a790a1c50$var$editorContentStyles.agentShimmerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.gapCursorStyles,
            $f3bd510a790a1c50$var$editorContentStyles.gapCursorStylesVisibilityFix,
            $f3bd510a790a1c50$var$editorContentStyles.panelStyles,
            $f3bd510a790a1c50$var$editorContentStyles.nestedPanelBorderStylesMixin,
            $f3bd510a790a1c50$var$editorContentStyles.panelStylesMixinNestedDnd,
            $f3bd510a790a1c50$var$editorContentStyles.panelStylesMixin,
            $f3bd510a790a1c50$var$editorContentStyles.mentionsStyles,
            $f3bd510a790a1c50$var$editorContentStyles.tasksAndDecisionsStyles,
            contentMode === "compact" && isDense && $f3bd510a790a1c50$var$editorContentStyles.tasksAndDecisionsDenseStyles,
            $f3bd510a790a1c50$var$editorContentStyles.gridStyles,
            $f3bd510a790a1c50$var$editorContentStyles.blockMarksStyles,
            $f3bd510a790a1c50$var$editorContentStyles.dateStyles,
            $f3bd510a790a1c50$var$editorContentStyles.extensionStyles,
            (0, $iDrrr.fg)("platform_editor_lovability_resize_exts_gracefully") && $f3bd510a790a1c50$var$editorContentStyles.extensionWithBreakoutStyles,
            contentMode === "compact" && $f3bd510a790a1c50$var$editorContentStyles.extensionStylesDense,
            $f3bd510a790a1c50$var$editorContentStyles.bodiedExtensionLayoutShiftFix,
            $f3bd510a790a1c50$var$editorContentStyles.extensionDiffStyles,
            $f3bd510a790a1c50$var$editorContentStyles.expandStylesBase,
            !useStandardNodeWidth && $f3bd510a790a1c50$var$editorContentStyles.expandStyles,
            contentMode === "compact" && isDense && $f3bd510a790a1c50$var$editorContentStyles.expandDenseStyles,
            $f3bd510a790a1c50$var$editorContentStyles.expandStylesMixinNestedDnd,
            $f3bd510a790a1c50$var$editorContentStyles.expandStylesMixin_fg_platform_visual_refresh_icons,
            isChromeless && $f3bd510a790a1c50$var$editorContentStyles.expandStylesMixin_chromeless_expand_fix,
            $f3bd510a790a1c50$var$editorContentStyles.findReplaceStyles,
            $f3bd510a790a1c50$var$editorContentStyles.findReplaceStylesWithCodeblockColorContrastFix,
            $f3bd510a790a1c50$var$editorContentStyles.findReplaceStylesWithRefSyncBlock,
            $f3bd510a790a1c50$var$editorContentStyles.textHighlightStyle,
            $f3bd510a790a1c50$var$editorContentStyles.decisionStyles,
            (0, $anBbz.expValEqualsNoExposure)("platform_editor_blocktaskitem_node_tenantid", "isEnabled", true) ? $f3bd510a790a1c50$var$editorContentStyles.taskItemStylesWithBlockTaskItem : $f3bd510a790a1c50$var$editorContentStyles.taskItemStyles,
            $f3bd510a790a1c50$var$editorContentStyles.taskItemCheckboxStyles,
            $f3bd510a790a1c50$var$editorContentStyles.decisionIconWithVisualRefresh,
            $f3bd510a790a1c50$var$editorContentStyles.statusStyles,
            isStatusStylesTeam26 ? $f3bd510a790a1c50$var$editorContentStyles.statusStylesTeam26 : (0, $iDrrr.fg)("platform-component-visual-refresh") ? $f3bd510a790a1c50$var$editorContentStyles.statusStylesMixin_fg_platform_component_visual_refresh_with_search_match : $f3bd510a790a1c50$var$editorContentStyles.statusStylesMixin_without_fg_platform_component_visual_refresh_with_search_match,
            isStatusStylesTeam26 && isUpdateStatusColorsEnabled && $f3bd510a790a1c50$var$editorContentStyles.statusStylesNamedAccent,
            isStatusStylesTeam26 && !isUpdateStatusColorsEnabled && $f3bd510a790a1c50$var$editorContentStyles.statusStylesNamedSemantic,
            ((0, $iDrrr.fg)("platform_editor_gracefully_render_status_color") || isUpdateStatusColorsEnabled) && $f3bd510a790a1c50$var$editorContentStyles.statusStylesHexAccent,
            (0, $iDrrr.fg)("platform_editor_ai_show_diff_patch_2") && $f3bd510a790a1c50$var$editorContentStyles.deletedStatusStrikeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.annotationStyles,
            $f3bd510a790a1c50$var$editorContentStyles.smartCardStylesWithSearchMatchAndBlockMenuDangerStyles,
            (0, $jkcNT.editorExperiment)("platform_editor_preview_panel_responsiveness", true) && $f3bd510a790a1c50$var$editorContentStyles.smartCardStylesWithSearchMatchAndPreviewPanelResponsiveness,
            $f3bd510a790a1c50$var$editorContentStyles.editorControlsSmartCardStyles,
            $f3bd510a790a1c50$var$editorContentStyles.embedCardStyles,
            $f3bd510a790a1c50$var$editorContentStyles.unsupportedStyles,
            $f3bd510a790a1c50$var$editorContentStyles.vanillaTooltipDefaultStyles,
            (0, $iDrrr.fg)("confluence_ncs_step_diffing_version_history") && $f3bd510a790a1c50$var$editorContentStyles.contributorTagStyles,
            (0, $4o0zT.isExperimentEnabled)("platform_editor_vanilla_node_views_phase1") && $f3bd510a790a1c50$var$editorContentStyles.vanillaUnsupportedStyles,
            $f3bd510a790a1c50$var$editorContentStyles.resizerStyles,
            (0, $anBbz.expValEqualsNoExposure)("cc-maui-experiment", "isEnabled", true) && (0, $ieeJu.expValEquals)("databases-native-embeds-v2", "isEnabled", true) && $f3bd510a790a1c50$var$editorContentStyles.resizerBottomHandleStyles,
            $f3bd510a790a1c50$var$editorContentStyles.layoutBaseStyles,
            $f3bd510a790a1c50$var$editorContentStyles.alignMultipleWrappedImageInLayoutStyles,
            $f3bd510a790a1c50$var$editorContentStyles.syncBlockStylesBase,
            (0, $iDrrr.fg)("platform-dst-tokens-finesse") && $f3bd510a790a1c50$var$editorContentStyles.syncBlockSelectedStyles,
            !useStandardNodeWidth && $f3bd510a790a1c50$var$editorContentStyles.syncBlockStyles,
            $f3bd510a790a1c50$var$editorContentStyles.syncBlockOverflowStyles,
            $f3bd510a790a1c50$var$editorContentStyles.syncBlockFirstNodeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.syncBlockTextSelectionStyles,
            $f3bd510a790a1c50$var$editorContentStyles.syncBlockInteractiveCursorStyles,
            (0, $jkcNT.editorExperiment)("advanced_layouts", true) && $f3bd510a790a1c50$var$editorContentStyles.layoutBaseStylesAdvanced,
            (0, $jkcNT.editorExperiment)("advanced_layouts", true) ? $f3bd510a790a1c50$var$editorContentStyles.layoutSectionStylesAdvanced : $f3bd510a790a1c50$var$editorContentStyles.layoutSectionStylesNotAdvanced,
            (0, $jkcNT.editorExperiment)("advanced_layouts", true) && !(0, $iDrrr.fg)("platform-dst-top-layer-tooltip") && $f3bd510a790a1c50$var$editorContentStyles.layoutDragHandleWrapperStylesLegacy,
            (0, $jkcNT.editorExperiment)("advanced_layouts", true) && $f3bd510a790a1c50$var$editorContentStyles.layoutColumnDividerStyles,
            (0, $jkcNT.editorExperiment)("advanced_layouts", true) && $f3bd510a790a1c50$var$editorContentStyles.layoutColumnDividerStylesNestedDnD,
            (0, $jkcNT.editorExperiment)("advanced_layouts", true) ? $f3bd510a790a1c50$var$editorContentStyles.layoutColumnStylesAdvanced : $f3bd510a790a1c50$var$editorContentStyles.layoutColumnStylesNotAdvanced,
            (0, $jkcNT.editorExperiment)("advanced_layouts", true) && $f3bd510a790a1c50$var$editorContentStyles.layoutColumnResizeStyles,
            (0, $jkcNT.editorExperiment)("advanced_layouts", true) ? $f3bd510a790a1c50$var$editorContentStyles.layoutSelectedStylesAdvanced : $f3bd510a790a1c50$var$editorContentStyles.layoutSelectedStylesNotAdvanced,
            $f3bd510a790a1c50$var$editorContentStyles.layoutSelectedStylesAdvancedFix,
            (0, $jkcNT.editorExperiment)("advanced_layouts", true) && $f3bd510a790a1c50$var$editorContentStyles.layoutColumnResponsiveStyles,
            (0, $jkcNT.editorExperiment)("advanced_layouts", true) && $f3bd510a790a1c50$var$editorContentStyles.layoutResponsiveBaseStyles,
            $f3bd510a790a1c50$var$editorContentStyles.layoutBaseStylesNestedDndExcludingBodiedSync,
            $f3bd510a790a1c50$var$editorContentStyles.layoutColumnMartinTopFixes,
            $f3bd510a790a1c50$var$editorContentStyles.smartLinksInLivePagesStyles,
            $f3bd510a790a1c50$var$editorContentStyles.linkingVisualRefreshV1Styles,
            $f3bd510a790a1c50$var$editorContentStyles.dateVanillaStyles,
            contentMode === "compact" ? $f3bd510a790a1c50$var$editorContentStyles.paragraphStylesWithScaledMargin : $f3bd510a790a1c50$var$editorContentStyles.paragraphStylesUGCRefreshed,
            $f3bd510a790a1c50$var$editorContentStyles.linkStyles,
            browser.safari && $f3bd510a790a1c50$var$editorContentStyles.listsStylesSafariFix,
            $f3bd510a790a1c50$var$editorContentStyles.pragmaticResizerStylesSyncedBlock,
            (0, $anBbz.expValEqualsNoExposure)("platform_editor_breakout_resizing", "isEnabled", true) && $f3bd510a790a1c50$var$editorContentStyles.pragmaticResizerStyles,
            (0, $anBbz.expValEqualsNoExposure)("platform_editor_breakout_resizing", "isEnabled", true) && (0, $anBbz.expValEqualsNoExposure)("platform_editor_lovability_resize_dividers_panels", "isEnabled", true) && $f3bd510a790a1c50$var$editorContentStyles.pragmaticResizerStylesPanelAndRule,
            (0, $anBbz.expValEqualsNoExposure)("platform_editor_breakout_resizing", "isEnabled", true) && (0, $4o0zT.isExperimentEnabled)("platform_editor_lovability_resize_extensions") && $f3bd510a790a1c50$var$editorContentStyles.pragmaticResizerStylesExtensions,
            (0, $anBbz.expValEqualsNoExposure)("platform_editor_breakout_resizing", "isEnabled", true) && $f3bd510a790a1c50$var$editorContentStyles.pragmaticResizerStylesCodeBlockSyncedBlockPatch,
            (0, $jkcNT.editorExperiment)("advanced_layouts", true) && (0, $anBbz.expValEqualsNoExposure)("platform_editor_breakout_resizing", "isEnabled", true) && $f3bd510a790a1c50$var$editorContentStyles.pragmaticStylesLayoutFirstNodeResizeHandleFix,
            (0, $anBbz.expValEqualsNoExposure)("platform_editor_breakout_resizing", "isEnabled", true) && $f3bd510a790a1c50$var$editorContentStyles.pragmaticResizerStylesForTooltip,
            (0, $jkcNT.editorExperiment)("platform_editor_preview_panel_responsiveness", true) && ((0, $jkcNT.editorExperiment)("advanced_layouts", true) || (0, $anBbz.expValEqualsNoExposure)("platform_editor_breakout_resizing", "isEnabled", true)) && $f3bd510a790a1c50$var$editorContentStyles.pragmaticResizerStylesWithReducedEditorGutter,
            $f3bd510a790a1c50$var$editorContentStyles.aiPanelBaseStyles,
            $f3bd510a790a1c50$var$isFirefox && $f3bd510a790a1c50$var$editorContentStyles.aiPanelBaseFirefoxStyles,
            colorMode === "dark" && $f3bd510a790a1c50$var$editorContentStyles.aiPanelDarkStyles,
            colorMode === "dark" && $f3bd510a790a1c50$var$isFirefox && $f3bd510a790a1c50$var$editorContentStyles.aiPanelDarkFirefoxStyles,
            viewMode === "view" && $f3bd510a790a1c50$var$editorContentStyles.layoutStylesForView,
            viewMode === "view" && (0, $jkcNT.editorExperiment)("advanced_layouts", true) && $f3bd510a790a1c50$var$editorContentStyles.layoutSelectedStylesForViewAdvanced,
            viewMode === "view" && (0, $jkcNT.editorExperiment)("advanced_layouts", false) && $f3bd510a790a1c50$var$editorContentStyles.layoutSelectedStylesForViewNotAdvanced,
            viewMode === "view" && (0, $jkcNT.editorExperiment)("advanced_layouts", true) && $f3bd510a790a1c50$var$editorContentStyles.layoutResponsiveStylesForView,
            isComment && $f3bd510a790a1c50$var$editorContentStyles.commentEditorStyles,
            isComment && $f3bd510a790a1c50$var$editorContentStyles.tableCommentEditorStyles,
            (isComment || isChromeless) && $f3bd510a790a1c50$var$editorContentStyles.nonFullPageContainerTypeStyles,
            isFullPage && $f3bd510a790a1c50$var$editorContentStyles.fullPageEditorStyles,
            isFullPage && $f3bd510a790a1c50$var$editorContentStyles.scrollbarStyles,
            $f3bd510a790a1c50$var$editorContentStyles.firstCodeBlockWithNoMargin,
            $f3bd510a790a1c50$var$editorContentStyles.firstBlockNodeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.firstNodeWidgetFixStyles,
            $f3bd510a790a1c50$var$editorContentStyles.mentionNodeStyles,
            colorMode === "dark" && $f3bd510a790a1c50$var$editorContentStyles.agentMentionShimmerDarkMode,
            $f3bd510a790a1c50$var$editorContentStyles.mentionsSelectionStyles,
            (0, $ieeJu.expValEquals)("platform_editor_lovability_emoji_scaling", "isEnabled", true) ? $f3bd510a790a1c50$var$editorContentStyles.scaledEmojiStyles : $f3bd510a790a1c50$var$editorContentStyles.emojiStyles,
            isFloatingTocEnabled ? $f3bd510a790a1c50$var$editorContentStyles.directEmojiSelectionStyles : $f3bd510a790a1c50$var$editorContentStyles.emojiSelectionStyles,
            contentMode === "compact" && isDense && (0, $ieeJu.expValEquals)("platform_editor_lovability_emoji_scaling", "isEnabled", true) && $f3bd510a790a1c50$var$editorContentStyles.scaledEmojiDenseStyles,
            t5,
            $f3bd510a790a1c50$var$editorContentStyles.panelViewStyles,
            $f3bd510a790a1c50$var$editorContentStyles.mediaGroupStyles,
            $f3bd510a790a1c50$var$editorContentStyles.mediaAlignmentStyles,
            $f3bd510a790a1c50$var$editorContentStyles.tableLayoutFixesWithFontSize,
            $f3bd510a790a1c50$var$editorContentStyles.tableContainerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.tableSharedStyle,
            (0, $4o0zT.isExperimentEnabled)("platform_editor_table_css_overflow_shadow") && $f3bd510a790a1c50$var$editorContentStyles.tableScrollInlineShadowStyles,
            (browser.gecko || browser.ie || browser.mac && browser.chrome) && $f3bd510a790a1c50$var$editorContentStyles.tableSharedStyleBackgroundClipFix,
            (0, $ieeJu.expValEquals)("platform_editor_table_q4_loveability", "isEnabled", true) ? $f3bd510a790a1c50$var$editorContentStyles.tableSharedStyle_with_platform_editor_table_q4_loveability : $f3bd510a790a1c50$var$editorContentStyles.tableSharedStyle_without_platform_editor_table_q4_loveability,
            (0, $ieeJu.expValEquals)("platform_editor_table_menu_updates", "isEnabled", true) && $f3bd510a790a1c50$var$editorContentStyles.tableSharedStyle_with_platform_editor_table_menu_updates,
            (0, $iDrrr.fg)("platform_editor_bordered_panel_nested_in_table") && $f3bd510a790a1c50$var$editorContentStyles.tableSharedStyle_with_platform_editor_bordered_panel_nested_in_table,
            $f3bd510a790a1c50$var$editorContentStyles.tableEmptyRowStyles,
            (0, $ieeJu.expValEquals)("platform_editor_table_q4_loveability", "isEnabled", true) && $f3bd510a790a1c50$var$editorContentStyles.tableRoundedCornerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.tableContentModeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.tableContentModeExtensionContainmentStyles,
            $f3bd510a790a1c50$var$editorContentStyles.tableContentModeNestedTableStyles,
            $f3bd510a790a1c50$var$editorContentStyles.tableCellBackgroundColorOverrides,
            $f3bd510a790a1c50$var$editorContentStyles.hyperLinkFloatingToolbarStyles,
            $f3bd510a790a1c50$var$editorContentStyles.selectionToolbarAnimationStyles,
            $f3bd510a790a1c50$var$editorContentStyles.blockquoteDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.textDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.listDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.dangerDateStyles,
            $f3bd510a790a1c50$var$editorContentStyles.emojiDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.mentionDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.decisionDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.statusDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.dangerRuleStyles,
            $f3bd510a790a1c50$var$editorContentStyles.mediaDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.nestedPanelDangerStyles,
            isBlockSpacingEnabled && $f3bd510a790a1c50$var$editorContentStyles.blockSpacingVarStyles,
            isBlockSpacingEnabled && isDense && $f3bd510a790a1c50$var$editorContentStyles.blockSpacingVarScaledStyles,
            className || undefined
        ]);
        $[5] = className;
        $[6] = colorMode;
        $[7] = contentMode;
        $[8] = isChromeless;
        $[9] = isComment;
        $[10] = isDense;
        $[11] = isFullPage;
        $[12] = useStandardNodeWidth;
        $[13] = viewMode;
        $[14] = t3;
    } else t3 = $[14];
    const t4 = isScrollable ? "true" : undefined;
    const t5 = isScrollable ? 0 : undefined;
    const t6 = isScrollable ? "region" : undefined;
    let t7;
    if ($[19] !== children || $[20] !== ref || $[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t3,
            ref: ref,
            "data-editor-scroll-container": t4,
            "data-testid": "editor-content-container",
            style: style,
            tabIndex: t5,
            role: t6,
            children: children
        });
        $[19] = children;
        $[20] = ref;
        $[21] = t3;
        $[22] = t4;
        $[23] = t5;
        $[24] = t6;
        $[25] = t7;
    } else t7 = $[25];
    return t7;
} : (props, ref)=>{
    const { className: className, children: children, viewMode: viewMode, isScrollable: isScrollable, appearance: appearance, contentMode: contentMode, useStandardNodeWidth: useStandardNodeWidth } = props;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const isFullPage = appearance === 'full-page' || appearance === 'full-width' || appearance === 'max';
    const isComment = appearance === 'comment';
    const isChromeless = appearance === 'chromeless';
    const baseFontSize = (0, $jsa8f.getBaseFontSize)(appearance, contentMode);
    const isDense = !!baseFontSize && baseFontSize !== (0, $7Y8M5.akEditorFullPageDefaultFontSize);
    const tableOverflowShadow = (0, $82e142800f46dc29$export$bb4a61a93a1e5360)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }); // Under the static-CSS experiment, --ak-editor-base-font-size is set earlier on the
    // root div in editor-internal.tsx and inherited via the CSS cascade — do not set it here.
    // For the legacy path, compute it from the Emotion theme as before.
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            '--ak-editor--table-overflow-shadow': tableOverflowShadow,
            ...(0, $8b6953b26499ad89$export$ca835ce2a5bd6107),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            ...!(0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) && {
                '--ak-editor--large-gutter-padding': `${(0, $7Y8M5.akEditorGutterPaddingDynamic)()}px`
            }
        }), [
        tableOverflowShadow
    ]);
    const browser = (0, $8dxef.getBrowserInfo)(); // Evaluate the block-spacing experiment once per render.
    const isBlockSpacingEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_extension_block_spacing');
    const isFloatingTocEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_floating_toc');
    const isUpdateStatusColorsEnabled = (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_update_status_colors', 'isEnabled', false) || (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_update_status_colors_jira', 'isEnabled', false);
    const isStatusStylesTeam26 = (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $f3bd510a790a1c50$var$editorContentStyles.baseStyles,
            $f3bd510a790a1c50$var$editorContentStyles.maxModeReizeFixStyles,
            $f3bd510a790a1c50$var$editorContentStyles.baseStylesMaxContainerWidthFixes,
            $f3bd510a790a1c50$var$editorContentStyles.editorGutterPaddingBaseStyles,
            (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) && $f3bd510a790a1c50$var$editorContentStyles.editorLargeGutterPuddingReducedBaseStyles,
            $f3bd510a790a1c50$var$editorContentStyles.whitespaceStyles,
            $f3bd510a790a1c50$var$editorContentStyles.indentationStyles,
            $f3bd510a790a1c50$var$editorContentStyles.fontSizeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.shadowStyles,
            $f3bd510a790a1c50$var$editorContentStyles.InlineNodeViewSharedStyles,
            $f3bd510a790a1c50$var$editorContentStyles.hideSelectionStyles,
            $f3bd510a790a1c50$var$editorContentStyles.hideCursorWhenHideSelectionStyles,
            $f3bd510a790a1c50$var$editorContentStyles.selectedNodeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.cursorStyles,
            $f3bd510a790a1c50$var$editorContentStyles.firstFloatingToolbarButtonStyles,
            $f3bd510a790a1c50$var$editorContentStyles.placeholderTextStyles,
            $f3bd510a790a1c50$var$editorContentStyles.placeholderStyles,
            (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && $f3bd510a790a1c50$var$editorContentStyles.placeholderOverflowStyles,
            $f3bd510a790a1c50$var$editorContentStyles.codeBlockStyles,
            contentMode === 'compact' && $f3bd510a790a1c50$var$editorContentStyles.codeBlockStylesWithEmUnits,
            $f3bd510a790a1c50$var$editorContentStyles.editorUGCTokensRefreshed,
            $f3bd510a790a1c50$var$editorContentStyles.editorUGCSmallText,
            $f3bd510a790a1c50$var$editorContentStyles.blocktypeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.blocktypeStylesRtlBlockquote,
            isFloatingTocEnabled && $f3bd510a790a1c50$var$editorContentStyles.headingScrollMarginStyles,
            $f3bd510a790a1c50$var$editorContentStyles.blockquoteSelectedNodeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.listSelectedNodeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.textSelectedNodeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.blocktypeStyles_fg_platform_editor_typography_ugc,
            $f3bd510a790a1c50$var$editorContentStyles.blocktypeStylesNestedDnd,
            $f3bd510a790a1c50$var$editorContentStyles.codeMarkStyles,
            $f3bd510a790a1c50$var$editorContentStyles.textColorStyles,
            $f3bd510a790a1c50$var$editorContentStyles.backgroundColorStyles,
            !(0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $f3bd510a790a1c50$var$editorContentStyles.highlightLinksUnsetStyles,
            $f3bd510a790a1c50$var$editorContentStyles.textHighlightPaddingStyles,
            $f3bd510a790a1c50$var$editorContentStyles.listsStyles,
            $f3bd510a790a1c50$var$editorContentStyles.listItemHiddenMarkerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.diffListStyles,
            contentMode === 'compact' && isDense && $f3bd510a790a1c50$var$editorContentStyles.listsDenseStyles,
            isFullPage && $f3bd510a790a1c50$var$editorContentStyles.listsStylesMarginLayoutShiftFix,
            $f3bd510a790a1c50$var$editorContentStyles.ruleStyles,
            (0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_dividers_attributes') && $f3bd510a790a1c50$var$editorContentStyles.ruleWithAttrsStyles,
            $f3bd510a790a1c50$var$editorContentStyles.smartCardDiffStyles,
            $f3bd510a790a1c50$var$editorContentStyles.showDiffDeletedNodeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.mediaStyles,
            (0, $4o0zT.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1') && $f3bd510a790a1c50$var$editorContentStyles.vanillaCaptionStyles,
            contentMode === 'compact' && $f3bd510a790a1c50$var$editorContentStyles.mediaCaptionStyles,
            $f3bd510a790a1c50$var$editorContentStyles.firstWrappedMediaStyles,
            $f3bd510a790a1c50$var$editorContentStyles.telepointerStyle,
            /* This needs to be after telepointer styles as some overlapping rules have equal specificity, and so the order is significant */ $f3bd510a790a1c50$var$editorContentStyles.telepointerColorAndCommonStyle,
            colorMode === 'dark' && $f3bd510a790a1c50$var$editorContentStyles.telepointerColorAndCommonStyleDarkMode,
            (0, $anBbz.expValEqualsNoExposure)('platform_editor_agent_be_streaming', 'isEnabled', true) && $f3bd510a790a1c50$var$editorContentStyles.agentShimmerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.gapCursorStyles,
            $f3bd510a790a1c50$var$editorContentStyles.gapCursorStylesVisibilityFix,
            $f3bd510a790a1c50$var$editorContentStyles.panelStyles,
            $f3bd510a790a1c50$var$editorContentStyles.nestedPanelBorderStylesMixin,
            $f3bd510a790a1c50$var$editorContentStyles.panelStylesMixinNestedDnd,
            $f3bd510a790a1c50$var$editorContentStyles.panelStylesMixin,
            $f3bd510a790a1c50$var$editorContentStyles.mentionsStyles,
            $f3bd510a790a1c50$var$editorContentStyles.tasksAndDecisionsStyles,
            contentMode === 'compact' && isDense && $f3bd510a790a1c50$var$editorContentStyles.tasksAndDecisionsDenseStyles,
            $f3bd510a790a1c50$var$editorContentStyles.gridStyles,
            $f3bd510a790a1c50$var$editorContentStyles.blockMarksStyles,
            $f3bd510a790a1c50$var$editorContentStyles.dateStyles,
            $f3bd510a790a1c50$var$editorContentStyles.extensionStyles,
            (0, $iDrrr.fg)('platform_editor_lovability_resize_exts_gracefully') && $f3bd510a790a1c50$var$editorContentStyles.extensionWithBreakoutStyles,
            contentMode === 'compact' && $f3bd510a790a1c50$var$editorContentStyles.extensionStylesDense,
            $f3bd510a790a1c50$var$editorContentStyles.bodiedExtensionLayoutShiftFix,
            $f3bd510a790a1c50$var$editorContentStyles.extensionDiffStyles,
            $f3bd510a790a1c50$var$editorContentStyles.expandStylesBase,
            !useStandardNodeWidth && $f3bd510a790a1c50$var$editorContentStyles.expandStyles,
            contentMode === 'compact' && isDense && $f3bd510a790a1c50$var$editorContentStyles.expandDenseStyles,
            $f3bd510a790a1c50$var$editorContentStyles.expandStylesMixinNestedDnd,
            $f3bd510a790a1c50$var$editorContentStyles.expandStylesMixin_fg_platform_visual_refresh_icons,
            isChromeless && $f3bd510a790a1c50$var$editorContentStyles.expandStylesMixin_chromeless_expand_fix,
            $f3bd510a790a1c50$var$editorContentStyles.findReplaceStyles,
            $f3bd510a790a1c50$var$editorContentStyles.findReplaceStylesWithCodeblockColorContrastFix,
            $f3bd510a790a1c50$var$editorContentStyles.findReplaceStylesWithRefSyncBlock,
            $f3bd510a790a1c50$var$editorContentStyles.textHighlightStyle,
            $f3bd510a790a1c50$var$editorContentStyles.decisionStyles,
            (0, $anBbz.expValEqualsNoExposure)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true) ? $f3bd510a790a1c50$var$editorContentStyles.taskItemStylesWithBlockTaskItem : $f3bd510a790a1c50$var$editorContentStyles.taskItemStyles,
            $f3bd510a790a1c50$var$editorContentStyles.taskItemCheckboxStyles,
            $f3bd510a790a1c50$var$editorContentStyles.decisionIconWithVisualRefresh,
            $f3bd510a790a1c50$var$editorContentStyles.statusStyles,
            isStatusStylesTeam26 ? $f3bd510a790a1c50$var$editorContentStyles.statusStylesTeam26 : (0, $iDrrr.fg)('platform-component-visual-refresh') ? $f3bd510a790a1c50$var$editorContentStyles.statusStylesMixin_fg_platform_component_visual_refresh_with_search_match : $f3bd510a790a1c50$var$editorContentStyles.statusStylesMixin_without_fg_platform_component_visual_refresh_with_search_match,
            isStatusStylesTeam26 && isUpdateStatusColorsEnabled && $f3bd510a790a1c50$var$editorContentStyles.statusStylesNamedAccent,
            isStatusStylesTeam26 && !isUpdateStatusColorsEnabled && $f3bd510a790a1c50$var$editorContentStyles.statusStylesNamedSemantic,
            ((0, $iDrrr.fg)('platform_editor_gracefully_render_status_color') || isUpdateStatusColorsEnabled) && $f3bd510a790a1c50$var$editorContentStyles.statusStylesHexAccent,
            (0, $iDrrr.fg)('platform_editor_ai_show_diff_patch_2') && $f3bd510a790a1c50$var$editorContentStyles.deletedStatusStrikeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.annotationStyles,
            $f3bd510a790a1c50$var$editorContentStyles.smartCardStylesWithSearchMatchAndBlockMenuDangerStyles,
            (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && $f3bd510a790a1c50$var$editorContentStyles.smartCardStylesWithSearchMatchAndPreviewPanelResponsiveness,
            $f3bd510a790a1c50$var$editorContentStyles.editorControlsSmartCardStyles,
            $f3bd510a790a1c50$var$editorContentStyles.embedCardStyles,
            $f3bd510a790a1c50$var$editorContentStyles.unsupportedStyles,
            $f3bd510a790a1c50$var$editorContentStyles.vanillaTooltipDefaultStyles,
            (0, $iDrrr.fg)('confluence_ncs_step_diffing_version_history') && $f3bd510a790a1c50$var$editorContentStyles.contributorTagStyles,
            (0, $4o0zT.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1') && $f3bd510a790a1c50$var$editorContentStyles.vanillaUnsupportedStyles,
            $f3bd510a790a1c50$var$editorContentStyles.resizerStyles,
            (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $ieeJu.expValEquals)('databases-native-embeds-v2', 'isEnabled', true) && $f3bd510a790a1c50$var$editorContentStyles.resizerBottomHandleStyles,
            $f3bd510a790a1c50$var$editorContentStyles.layoutBaseStyles,
            $f3bd510a790a1c50$var$editorContentStyles.alignMultipleWrappedImageInLayoutStyles,
            $f3bd510a790a1c50$var$editorContentStyles.syncBlockStylesBase,
            (0, $iDrrr.fg)('platform-dst-tokens-finesse') && $f3bd510a790a1c50$var$editorContentStyles.syncBlockSelectedStyles,
            !useStandardNodeWidth && $f3bd510a790a1c50$var$editorContentStyles.syncBlockStyles,
            $f3bd510a790a1c50$var$editorContentStyles.syncBlockOverflowStyles,
            $f3bd510a790a1c50$var$editorContentStyles.syncBlockFirstNodeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.syncBlockTextSelectionStyles,
            $f3bd510a790a1c50$var$editorContentStyles.syncBlockInteractiveCursorStyles,
            (0, $jkcNT.editorExperiment)('advanced_layouts', true) && $f3bd510a790a1c50$var$editorContentStyles.layoutBaseStylesAdvanced,
            (0, $jkcNT.editorExperiment)('advanced_layouts', true) ? $f3bd510a790a1c50$var$editorContentStyles.layoutSectionStylesAdvanced : $f3bd510a790a1c50$var$editorContentStyles.layoutSectionStylesNotAdvanced,
            (0, $jkcNT.editorExperiment)('advanced_layouts', true) && !(0, $iDrrr.fg)('platform-dst-top-layer-tooltip') && $f3bd510a790a1c50$var$editorContentStyles.layoutDragHandleWrapperStylesLegacy,
            (0, $jkcNT.editorExperiment)('advanced_layouts', true) && $f3bd510a790a1c50$var$editorContentStyles.layoutColumnDividerStyles,
            (0, $jkcNT.editorExperiment)('advanced_layouts', true) && $f3bd510a790a1c50$var$editorContentStyles.layoutColumnDividerStylesNestedDnD,
            (0, $jkcNT.editorExperiment)('advanced_layouts', true) ? $f3bd510a790a1c50$var$editorContentStyles.layoutColumnStylesAdvanced : $f3bd510a790a1c50$var$editorContentStyles.layoutColumnStylesNotAdvanced,
            (0, $jkcNT.editorExperiment)('advanced_layouts', true) && $f3bd510a790a1c50$var$editorContentStyles.layoutColumnResizeStyles,
            (0, $jkcNT.editorExperiment)('advanced_layouts', true) ? $f3bd510a790a1c50$var$editorContentStyles.layoutSelectedStylesAdvanced : $f3bd510a790a1c50$var$editorContentStyles.layoutSelectedStylesNotAdvanced,
            $f3bd510a790a1c50$var$editorContentStyles.layoutSelectedStylesAdvancedFix,
            (0, $jkcNT.editorExperiment)('advanced_layouts', true) && $f3bd510a790a1c50$var$editorContentStyles.layoutColumnResponsiveStyles,
            (0, $jkcNT.editorExperiment)('advanced_layouts', true) && $f3bd510a790a1c50$var$editorContentStyles.layoutResponsiveBaseStyles,
            $f3bd510a790a1c50$var$editorContentStyles.layoutBaseStylesNestedDndExcludingBodiedSync,
            $f3bd510a790a1c50$var$editorContentStyles.layoutColumnMartinTopFixes,
            $f3bd510a790a1c50$var$editorContentStyles.smartLinksInLivePagesStyles,
            $f3bd510a790a1c50$var$editorContentStyles.linkingVisualRefreshV1Styles,
            $f3bd510a790a1c50$var$editorContentStyles.dateVanillaStyles,
            contentMode === 'compact' ? $f3bd510a790a1c50$var$editorContentStyles.paragraphStylesWithScaledMargin : $f3bd510a790a1c50$var$editorContentStyles.paragraphStylesUGCRefreshed,
            $f3bd510a790a1c50$var$editorContentStyles.linkStyles,
            browser.safari && $f3bd510a790a1c50$var$editorContentStyles.listsStylesSafariFix,
            $f3bd510a790a1c50$var$editorContentStyles.pragmaticResizerStylesSyncedBlock,
            (0, $anBbz.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && $f3bd510a790a1c50$var$editorContentStyles.pragmaticResizerStyles,
            (0, $anBbz.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) && $f3bd510a790a1c50$var$editorContentStyles.pragmaticResizerStylesPanelAndRule,
            (0, $anBbz.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && (0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_resize_extensions') && $f3bd510a790a1c50$var$editorContentStyles.pragmaticResizerStylesExtensions,
            (0, $anBbz.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && $f3bd510a790a1c50$var$editorContentStyles.pragmaticResizerStylesCodeBlockSyncedBlockPatch,
            (0, $jkcNT.editorExperiment)('advanced_layouts', true) && (0, $anBbz.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && $f3bd510a790a1c50$var$editorContentStyles.pragmaticStylesLayoutFirstNodeResizeHandleFix,
            (0, $anBbz.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && $f3bd510a790a1c50$var$editorContentStyles.pragmaticResizerStylesForTooltip,
            (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && ((0, $jkcNT.editorExperiment)('advanced_layouts', true) || (0, $anBbz.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true)) && $f3bd510a790a1c50$var$editorContentStyles.pragmaticResizerStylesWithReducedEditorGutter,
            $f3bd510a790a1c50$var$editorContentStyles.aiPanelBaseStyles,
            $f3bd510a790a1c50$var$isFirefox && $f3bd510a790a1c50$var$editorContentStyles.aiPanelBaseFirefoxStyles,
            colorMode === 'dark' && $f3bd510a790a1c50$var$editorContentStyles.aiPanelDarkStyles,
            colorMode === 'dark' && $f3bd510a790a1c50$var$isFirefox && $f3bd510a790a1c50$var$editorContentStyles.aiPanelDarkFirefoxStyles,
            viewMode === 'view' && $f3bd510a790a1c50$var$editorContentStyles.layoutStylesForView,
            viewMode === 'view' && (0, $jkcNT.editorExperiment)('advanced_layouts', true) && $f3bd510a790a1c50$var$editorContentStyles.layoutSelectedStylesForViewAdvanced,
            viewMode === 'view' && (0, $jkcNT.editorExperiment)('advanced_layouts', false) && $f3bd510a790a1c50$var$editorContentStyles.layoutSelectedStylesForViewNotAdvanced,
            viewMode === 'view' && (0, $jkcNT.editorExperiment)('advanced_layouts', true) && $f3bd510a790a1c50$var$editorContentStyles.layoutResponsiveStylesForView,
            isComment && $f3bd510a790a1c50$var$editorContentStyles.commentEditorStyles,
            isComment && $f3bd510a790a1c50$var$editorContentStyles.tableCommentEditorStyles,
            (isComment || isChromeless) && $f3bd510a790a1c50$var$editorContentStyles.nonFullPageContainerTypeStyles,
            isFullPage && $f3bd510a790a1c50$var$editorContentStyles.fullPageEditorStyles,
            isFullPage && $f3bd510a790a1c50$var$editorContentStyles.scrollbarStyles,
            $f3bd510a790a1c50$var$editorContentStyles.firstCodeBlockWithNoMargin,
            $f3bd510a790a1c50$var$editorContentStyles.firstBlockNodeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.firstNodeWidgetFixStyles,
            $f3bd510a790a1c50$var$editorContentStyles.mentionNodeStyles,
            colorMode === 'dark' && $f3bd510a790a1c50$var$editorContentStyles.agentMentionShimmerDarkMode,
            $f3bd510a790a1c50$var$editorContentStyles.mentionsSelectionStyles,
            (0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? $f3bd510a790a1c50$var$editorContentStyles.scaledEmojiStyles : $f3bd510a790a1c50$var$editorContentStyles.emojiStyles,
            isFloatingTocEnabled ? $f3bd510a790a1c50$var$editorContentStyles.directEmojiSelectionStyles : $f3bd510a790a1c50$var$editorContentStyles.emojiSelectionStyles,
            contentMode === 'compact' && isDense && (0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) && $f3bd510a790a1c50$var$editorContentStyles.scaledEmojiDenseStyles,
            contentMode === 'compact' && isDense && !(0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) && $f3bd510a790a1c50$var$editorContentStyles.emojiDenseStyles,
            $f3bd510a790a1c50$var$editorContentStyles.panelViewStyles,
            $f3bd510a790a1c50$var$editorContentStyles.mediaGroupStyles,
            $f3bd510a790a1c50$var$editorContentStyles.mediaAlignmentStyles,
            $f3bd510a790a1c50$var$editorContentStyles.tableLayoutFixesWithFontSize,
            $f3bd510a790a1c50$var$editorContentStyles.tableContainerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.tableSharedStyle,
            (0, $4o0zT.isExperimentEnabled)('platform_editor_table_css_overflow_shadow') && $f3bd510a790a1c50$var$editorContentStyles.tableScrollInlineShadowStyles,
            (browser.gecko || browser.ie || browser.mac && browser.chrome) && $f3bd510a790a1c50$var$editorContentStyles.tableSharedStyleBackgroundClipFix,
            (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? $f3bd510a790a1c50$var$editorContentStyles.tableSharedStyle_with_platform_editor_table_q4_loveability : $f3bd510a790a1c50$var$editorContentStyles.tableSharedStyle_without_platform_editor_table_q4_loveability,
            (0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) && $f3bd510a790a1c50$var$editorContentStyles.tableSharedStyle_with_platform_editor_table_menu_updates,
            (0, $iDrrr.fg)('platform_editor_bordered_panel_nested_in_table') && $f3bd510a790a1c50$var$editorContentStyles.tableSharedStyle_with_platform_editor_bordered_panel_nested_in_table,
            $f3bd510a790a1c50$var$editorContentStyles.tableEmptyRowStyles,
            (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $f3bd510a790a1c50$var$editorContentStyles.tableRoundedCornerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.tableContentModeStyles,
            $f3bd510a790a1c50$var$editorContentStyles.tableContentModeExtensionContainmentStyles,
            $f3bd510a790a1c50$var$editorContentStyles.tableContentModeNestedTableStyles,
            $f3bd510a790a1c50$var$editorContentStyles.tableCellBackgroundColorOverrides,
            $f3bd510a790a1c50$var$editorContentStyles.hyperLinkFloatingToolbarStyles,
            $f3bd510a790a1c50$var$editorContentStyles.selectionToolbarAnimationStyles,
            $f3bd510a790a1c50$var$editorContentStyles.blockquoteDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.textDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.listDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.dangerDateStyles,
            $f3bd510a790a1c50$var$editorContentStyles.emojiDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.mentionDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.decisionDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.statusDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.dangerRuleStyles,
            $f3bd510a790a1c50$var$editorContentStyles.mediaDangerStyles,
            $f3bd510a790a1c50$var$editorContentStyles.nestedPanelDangerStyles,
            isBlockSpacingEnabled && $f3bd510a790a1c50$var$editorContentStyles.blockSpacingVarStyles,
            isBlockSpacingEnabled && isDense && $f3bd510a790a1c50$var$editorContentStyles.blockSpacingVarScaledStyles,
            className || undefined
        ]),
        ref: ref,
        "data-editor-scroll-container": isScrollable ? 'true' : undefined,
        "data-testid": "editor-content-container",
        style: style,
        tabIndex: isScrollable ? 0 : undefined,
        role: isScrollable ? 'region' : undefined,
        children: children
    });
});


/**
 * This module exposes the Compiled implementation as the entry point so consumers keep
 * importing from `./EditorContentContainer`.
 */ const $cbf583bc97d0d6bf$var$EditorContentContainer = (0, $f3bd510a790a1c50$export$b9e04e68e256861a);
var $cbf583bc97d0d6bf$export$2e2bcd8739ae039 = $cbf583bc97d0d6bf$var$EditorContentContainer;
module.exports["default"] = $cbf583bc97d0d6bf$export$2e2bcd8739ae039;

});

parcelRegister("01rUB", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $krYZG = parcelRequire("krYZG");


var $8m50u = parcelRequire("8m50u");


var $ieeJu = parcelRequire("ieeJu");








var $jv11C = parcelRequire("jv11C");

class $cca4fa57dc7b38c9$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $jv11C.logException)(error, {
            location: 'editor-core/ui'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false
        };
    }
}











parcelRequire("cozmU");

function $1848dc2225a78214$var$MountPluginHook({ usePluginHook: usePluginHook, editorView: editorView, containerElement: containerElement, wrapperElement: wrapperElement }) {
    usePluginHook({
        editorView: editorView,
        containerElement: containerElement,
        wrapperElement: wrapperElement
    });
    return null;
}
const $1848dc2225a78214$export$a9224552b63e3fe8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MountPluginHooks(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { pluginHooks: pluginHooks, editorView: editorView, containerElement: containerElement, wrapperElement: wrapperElement } = t0;
    if (!editorView) return null;
    let t1;
    if ($[0] !== containerElement || $[1] !== editorView || $[2] !== pluginHooks || $[3] !== wrapperElement) {
        t1 = pluginHooks?.map((usePluginHook, index)=>{
            const pluginName = usePluginHook.pluginName;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($1848dc2225a78214$var$MountPluginHook, {
                usePluginHook: usePluginHook,
                editorView: editorView,
                containerElement: containerElement,
                wrapperElement: wrapperElement
            }, pluginName ?? index);
        });
        $[0] = containerElement;
        $[1] = editorView;
        $[2] = pluginHooks;
        $[3] = wrapperElement;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: t1
        });
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : function MountPluginHooks({ pluginHooks: pluginHooks, editorView: editorView, containerElement: containerElement, wrapperElement: wrapperElement }) {
    if (!editorView) return null;
    // Key each fiber by the plugin name carried on the hook function (set by
    // `processPluginsList`). This keeps fibers stable across `reconfigureState`
    // calls that change the plugin set — keying by array index would let React
    // reuse the same fiber for a different `usePluginHook`, which calls a
    // different sequence of hooks (Rules of Hooks violation).
    // Falls back to the array index for any hook that wasn't annotated.
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: pluginHooks?.map((usePluginHook, index)=>{
            const pluginName = usePluginHook.pluginName;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($1848dc2225a78214$var$MountPluginHook, {
                usePluginHook: usePluginHook,
                editorView: editorView,
                containerElement: containerElement,
                wrapperElement: wrapperElement
            }, pluginName ?? index);
        })
    });
};











parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $d609c3c739a3ec14$var$pluginsComponentsWrapperCompiledStyles = {
    root: "_3iDTPbQ4SZ"
};
const $d609c3c739a3ec14$export$b02ad3407509f83f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let children;
    let rest;
    if ($[0] !== t0) {
        ({ children: children, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = rest;
    } else {
        children = $[1];
        rest = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $d609c3c739a3ec14$var$pluginsComponentsWrapperCompiledStyles.root
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== rest) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ...rest,
            className: t1,
            children: children
        });
        $[4] = children;
        $[5] = rest;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, ...rest })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ...rest,
        className: (0, $hekY6.default)([
            $d609c3c739a3ec14$var$pluginsComponentsWrapperCompiledStyles.root
        ]),
        children: children
    });


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
 * Used via `componentWithCondition` in `index.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $lOiVq = parcelRequire("lOiVq");

function $9184c6daa417eb58$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9184c6daa417eb58$var$pluginsComponentsWrapperEmotionStyles = {
    name: "zjik7",
    styles: "display:flex"
};
const $9184c6daa417eb58$export$d06288dd7d5aba1f = ({ children: children, ...rest })=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $9184c6daa417eb58$var$pluginsComponentsWrapperEmotionStyles,
        ...rest
    }, children);


const $f327eafdacac49d3$var$PluginsComponentsWrapperMigration = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $d609c3c739a3ec14$export$b02ad3407509f83f), (0, $9184c6daa417eb58$export$d06288dd7d5aba1f));
const $f327eafdacac49d3$var$PluginComponent = ({ component: component, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement })=>{
    return component({
        editorView: editorView,
        editorActions: editorActions,
        eventDispatcher: eventDispatcher,
        providerFactory: providerFactory,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        appearance: appearance,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        containerElement: containerElement,
        disabled: disabled,
        wrapperElement: wrapperElement
    });
};
const $f327eafdacac49d3$var$PluginSlot = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { items: items, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement, pluginHooks: pluginHooks } = t0;
    if (!items && !pluginHooks) return null;
    let t1;
    if ($[0] !== items?.length) {
        t1 = Boolean(items?.length) && (0, $ieeJu.expValEquals)("platform_editor_per_plugin_error_boundary", "isEnabled", true);
        $[0] = items?.length;
        $[1] = t1;
    } else t1 = $[1];
    const isolatePluginSlotFailures = t1;
    let t2;
    if ($[2] !== containerElement || $[3] !== editorView || $[4] !== pluginHooks || $[5] !== wrapperElement) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1848dc2225a78214$export$a9224552b63e3fe8), {
            editorView: editorView,
            pluginHooks: pluginHooks,
            containerElement: containerElement,
            wrapperElement: wrapperElement
        });
        $[2] = containerElement;
        $[3] = editorView;
        $[4] = pluginHooks;
        $[5] = wrapperElement;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== appearance || $[8] !== containerElement || $[9] !== disabled || $[10] !== dispatchAnalyticsEvent || $[11] !== editorActions || $[12] !== editorView || $[13] !== eventDispatcher || $[14] !== isolatePluginSlotFailures || $[15] !== items || $[16] !== popupsBoundariesElement || $[17] !== popupsMountPoint || $[18] !== popupsScrollableElement || $[19] !== providerFactory || $[20] !== wrapperElement) {
        t3 = items?.map((component, index)=>{
            if (isolatePluginSlotFailures) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cca4fa57dc7b38c9$export$e926676385687eaf), {
                component: (0, $krYZG.ACTION_SUBJECT).PLUGIN_SLOT,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                fallbackComponent: null,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($f327eafdacac49d3$var$PluginComponent, {
                    component: component,
                    editorView: editorView,
                    editorActions: editorActions,
                    eventDispatcher: eventDispatcher,
                    providerFactory: providerFactory,
                    appearance: appearance,
                    popupsMountPoint: popupsMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsScrollableElement: popupsScrollableElement,
                    containerElement: containerElement,
                    disabled: disabled,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    wrapperElement: wrapperElement
                })
            }, index);
            const props = {
                key: index
            };
            const element = component({
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                appearance: appearance,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                containerElement: containerElement,
                disabled: disabled,
                wrapperElement: wrapperElement
            });
            return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(element, props);
        });
        $[7] = appearance;
        $[8] = containerElement;
        $[9] = disabled;
        $[10] = dispatchAnalyticsEvent;
        $[11] = editorActions;
        $[12] = editorView;
        $[13] = eventDispatcher;
        $[14] = isolatePluginSlotFailures;
        $[15] = items;
        $[16] = popupsBoundariesElement;
        $[17] = popupsMountPoint;
        $[18] = popupsScrollableElement;
        $[19] = providerFactory;
        $[20] = wrapperElement;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)($f327eafdacac49d3$var$PluginsComponentsWrapperMigration, {
            "data-testid": "plugins-components-wrapper",
            children: t3
        });
        $[22] = t3;
        $[23] = t4;
    } else t4 = $[23];
    let t5;
    if ($[24] !== t2 || $[25] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cca4fa57dc7b38c9$export$e926676385687eaf), {
            component: (0, $krYZG.ACTION_SUBJECT).PLUGIN_SLOT,
            fallbackComponent: null,
            children: [
                t2,
                t4
            ]
        });
        $[24] = t2;
        $[25] = t4;
        $[26] = t5;
    } else t5 = $[26];
    return t5;
} : ({ items: items, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement, pluginHooks: pluginHooks })=>{
    if (!items && !pluginHooks) return null;
    const isolatePluginSlotFailures = Boolean(items?.length) && (0, $ieeJu.expValEquals)('platform_editor_per_plugin_error_boundary', 'isEnabled', true);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cca4fa57dc7b38c9$export$e926676385687eaf), {
        component: (0, $krYZG.ACTION_SUBJECT).PLUGIN_SLOT,
        fallbackComponent: null,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1848dc2225a78214$export$a9224552b63e3fe8), {
                editorView: editorView,
                pluginHooks: pluginHooks,
                containerElement: containerElement,
                wrapperElement: wrapperElement
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($f327eafdacac49d3$var$PluginsComponentsWrapperMigration, {
                "data-testid": "plugins-components-wrapper",
                children: items?.map((component, index)=>{
                    if (isolatePluginSlotFailures) return(// The wrapper adds a small amount of overhead, but moves the plugin factory call
                    // inside the per-plugin boundary while still invoking it as a factory.
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cca4fa57dc7b38c9$export$e926676385687eaf), {
                        component: (0, $krYZG.ACTION_SUBJECT).PLUGIN_SLOT,
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                        fallbackComponent: null,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)($f327eafdacac49d3$var$PluginComponent, {
                            component: component,
                            editorView: editorView,
                            editorActions: editorActions,
                            eventDispatcher: eventDispatcher,
                            providerFactory: providerFactory,
                            appearance: appearance,
                            popupsMountPoint: popupsMountPoint,
                            popupsBoundariesElement: popupsBoundariesElement,
                            popupsScrollableElement: popupsScrollableElement,
                            containerElement: containerElement,
                            disabled: disabled,
                            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                            wrapperElement: wrapperElement
                        })
                    }, index));
                    const props = {
                        key: index
                    };
                    const element = component({
                        editorView: editorView,
                        editorActions: editorActions,
                        eventDispatcher: eventDispatcher,
                        providerFactory: providerFactory,
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        appearance: appearance,
                        popupsMountPoint: popupsMountPoint,
                        popupsBoundariesElement: popupsBoundariesElement,
                        popupsScrollableElement: popupsScrollableElement,
                        containerElement: containerElement,
                        disabled: disabled,
                        wrapperElement: wrapperElement
                    });
                    return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(element, props);
                })
            })
        ]
    });
};
const $f327eafdacac49d3$var$PluginSlotComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($f327eafdacac49d3$var$PluginSlot, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
$f327eafdacac49d3$var$PluginSlotComponent.displayName = 'PluginSlot';
var $f327eafdacac49d3$export$2e2bcd8739ae039 = $f327eafdacac49d3$var$PluginSlotComponent;
module.exports["default"] = $f327eafdacac49d3$export$2e2bcd8739ae039;

});

parcelRegister("bGjLa", function(module, exports) {

var $8m50u = parcelRequire("8m50u");


var $ieeJu = parcelRequire("ieeJu");

/* Comment-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
* Compiled branch of the `platform_editor_core_non_ecc_static_css` experiment.
* Used via `componentWithCondition` in `Comment.tsx`.
*
* Cleanup: delete this file once the experiment has shipped.
*/ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $5X6fy = parcelRequire("5X6fy");


var $kSwu1 = parcelRequire("kSwu1");


var $7joZr = parcelRequire("7joZr");


var $ad7Ou = parcelRequire("ad7Ou");


var $4y8CY = parcelRequire("4y8CY");

var $3k5Tv = parcelRequire("3k5Tv");


var $2xhuI = parcelRequire("2xhuI");


var $dUm2W = parcelRequire("dUm2W");


var $bZDJe = parcelRequire("bZDJe");


var $7Y8M5 = parcelRequire("7Y8M5");


var $jkcNT = parcelRequire("jkcNT");


var $8eIAK = parcelRequire("8eIAK");


var $iy9Au = parcelRequire("iy9Au");


var $58PSv = parcelRequire("58PSv");


var $01rUB = parcelRequire("01rUB");


var $5JOGK = parcelRequire("5JOGK");


var $bVYsF = parcelRequire("bVYsF");


var $5XRFP = parcelRequire("5XRFP");





var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");


var $83KD5 = parcelRequire("83KD5");


var $lMyvS = parcelRequire("lMyvS");

const $45103d414e00d6bf$export$48156340a1673791 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { editorAPI: editorAPI, editorView: editorView, editorAppearance: editorAppearance, disabled: disabled, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement } = t0;
    let components;
    let t1;
    let toolbar;
    if ($[0] !== editorAPI?.toolbar?.actions) {
        components = editorAPI?.toolbar?.actions.getComponents();
        toolbar = components?.find($45103d414e00d6bf$var$_temp);
        t1 = !components || !(0, $83KD5.isToolbar)(toolbar);
        $[0] = editorAPI?.toolbar?.actions;
        $[1] = components;
        $[2] = t1;
        $[3] = toolbar;
    } else {
        components = $[1];
        t1 = $[2];
        toolbar = $[3];
    }
    if (t1) return null;
    let t2;
    if ($[4] !== components || $[5] !== disabled || $[6] !== editorAPI || $[7] !== editorAppearance || $[8] !== editorView || $[9] !== popupsBoundariesElement || $[10] !== popupsMountPoint || $[11] !== popupsScrollableElement || $[12] !== toolbar) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lMyvS.ToolbarNext), {
            toolbar: toolbar,
            components: components,
            editorView: editorView,
            editorAPI: editorAPI,
            editorAppearance: editorAppearance,
            isDisabled: disabled,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            popupsMountPoint: popupsMountPoint
        });
        $[4] = components;
        $[5] = disabled;
        $[6] = editorAPI;
        $[7] = editorAppearance;
        $[8] = editorView;
        $[9] = popupsBoundariesElement;
        $[10] = popupsMountPoint;
        $[11] = popupsScrollableElement;
        $[12] = toolbar;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
} : ({ editorAPI: editorAPI, editorView: editorView, editorAppearance: editorAppearance, disabled: disabled, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement })=>{
    const components = editorAPI?.toolbar?.actions.getComponents();
    const toolbar = components?.find((component)=>component.key === (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR);
    if (!components || !(0, $83KD5.isToolbar)(toolbar)) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lMyvS.ToolbarNext), {
        toolbar: toolbar,
        components: components,
        editorView: editorView,
        editorAPI: editorAPI,
        editorAppearance: editorAppearance,
        isDisabled: disabled,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        popupsMountPoint: popupsMountPoint
    });
};
function $45103d414e00d6bf$var$_temp(component) {
    return component.key === (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR;
}











parcelRequire("cozmU");



















parcelRequire("cozmU");

const $67ae59487b7a561b$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
const $67ae59487b7a561b$var$fixedToolbarCompiledStyles = {
    mainToolbarWrapper: "_1mT5xdRAKS _0hPCNLDIqT _0Of8r22ADO _1Znuxb2ADO _1wydGWdnbC _2Zuz6QkG2W _3iDTPbQ4SZ _0jFU0VIZbP _0KLXrulfZc _2OUyjtYbGa _3Jay95dnbC _1pLMfqdnbC _3dWw89dnbC",
    mainToolbarWithoutLeftPadding: "_0Of8r22ADO _1Znuxb2ADO _1wydGWdnbC _2Zuz6Q2ADO",
    mainToolbarTwoLine: "_4p3kRSIDxV _0PND29F05b _3gMsu0Q4SZ _2SvMAQz9WS _45XDcMz9WS _2NuSBXQ4SZ",
    mainToolbarWrapperVisualRefresh: "_0fdGNFN91d",
    mainToolbarRadius: "_0bjKvDS00P",
    editorModernisationToolbar: "_0bjKvD1Hdw _2rgTTNYbGa"
};
const $67ae59487b7a561b$export$698f02dc2a985568 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(7);
    const t0 = props.twoLineEditorToolbar && $67ae59487b7a561b$var$fixedToolbarCompiledStyles.mainToolbarTwoLine;
    const t1 = props.isNewToolbarEnabled && $67ae59487b7a561b$var$fixedToolbarCompiledStyles.mainToolbarWithoutLeftPadding;
    const t2 = props.isEditorModernisationEnabled && $67ae59487b7a561b$var$fixedToolbarCompiledStyles.editorModernisationToolbar;
    let t3;
    if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2) {
        t3 = (0, $hekY6.default)([
            $67ae59487b7a561b$var$fixedToolbarCompiledStyles.mainToolbarWrapper,
            t0,
            $67ae59487b7a561b$var$fixedToolbarCompiledStyles.mainToolbarWrapperVisualRefresh,
            t1,
            $67ae59487b7a561b$var$fixedToolbarCompiledStyles.mainToolbarRadius,
            t2
        ]);
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== props.children || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "ak-editor-main-toolbar",
            className: t3,
            children: props.children
        });
        $[4] = props.children;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": "ak-editor-main-toolbar",
        className: (0, $hekY6.default)([
            $67ae59487b7a561b$var$fixedToolbarCompiledStyles.mainToolbarWrapper,
            props.twoLineEditorToolbar && $67ae59487b7a561b$var$fixedToolbarCompiledStyles.mainToolbarTwoLine,
            $67ae59487b7a561b$var$fixedToolbarCompiledStyles.mainToolbarWrapperVisualRefresh,
            props.isNewToolbarEnabled && $67ae59487b7a561b$var$fixedToolbarCompiledStyles.mainToolbarWithoutLeftPadding,
            $67ae59487b7a561b$var$fixedToolbarCompiledStyles.mainToolbarRadius,
            props.isEditorModernisationEnabled && $67ae59487b7a561b$var$fixedToolbarCompiledStyles.editorModernisationToolbar
        ]),
        children: props.children
    });


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
* Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
* Used via `componentWithCondition` in `Toolbar.tsx`.
*
* Cleanup: delete this file once the experiment has shipped.
*/ 
var $lOiVq = parcelRequire("lOiVq");

function $fd36c0a467717c25$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fd36c0a467717c25$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
const $fd36c0a467717c25$var$mainToolbarWrapperStyleNew = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'relative',
    alignItems: 'center',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 0`,
    display: 'flex',
    height: 'auto',
    backgroundColor: "var(--ds-surface, #FFFFFF)",
    boxShadow: 'none',
    paddingLeft: "var(--ds-space-250, 20px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '> div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:first-of-type:not(style), > style:first-of-type + *': {
            marginLeft: 0
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.block-type-btn': {
        paddingLeft: 0
    }
});
/** keep default padding for entire toolbar */ const $fd36c0a467717c25$var$mainToolbarWithoutLeftPadding = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 0`
});
const $fd36c0a467717c25$var$mainToolbarTwoLineStylesNew = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& > div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media (max-width: ${$fd36c0a467717c25$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
            flexDirection: 'column-reverse',
            alignItems: 'end',
            display: 'flex',
            justifyContent: 'flex-end'
        },
        /* make this more explicit for a toolbar */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`@media (max-width: ${$fd36c0a467717c25$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '> div:nth-of-type(2)': {
                    justifyContent: 'flex-end',
                    display: 'flex'
                }
            }
        }
    }
});
const $fd36c0a467717c25$var$mainToolbarWrapperStylesVisualRefresh = {
    name: "y5dbpb",
    styles: "span svg{max-width:100%;}"
};
const $fd36c0a467717c25$var$mainToolbarRadius = /*#__PURE__*/ (0, $lOiVq.css)({
    borderRadius: `${"var(--ds-radius-medium, 6px)"} ${"var(--ds-radius-medium, 6px)"} 0 0`
});
const $fd36c0a467717c25$var$editorModernisationToolbarStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    borderRadius: `${"var(--ds-radius-xlarge, 12px)"} ${"var(--ds-radius-xlarge, 12px)"} 0 0`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.show-keyline': {
        boxShadow: "var(--ds-shadow-overflow, 0px 0px 8px #1E1F2128, 0px 0px 1px #1E1F211e)"
    }
});
const $fd36c0a467717c25$export$84f029869645bc38 = (props)=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $fd36c0a467717c25$var$mainToolbarWrapperStyleNew,
            props.twoLineEditorToolbar && $fd36c0a467717c25$var$mainToolbarTwoLineStylesNew,
            $fd36c0a467717c25$var$mainToolbarWrapperStylesVisualRefresh,
            props.isNewToolbarEnabled && $fd36c0a467717c25$var$mainToolbarWithoutLeftPadding,
            $fd36c0a467717c25$var$mainToolbarRadius,
            props.isEditorModernisationEnabled && $fd36c0a467717c25$var$editorModernisationToolbarStyle
        ],
        "data-testid": "ak-editor-main-toolbar"
    }, props.children);

















const $0f029c9679d01cce$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
const $0f029c9679d01cce$var$akEditorMenuZIndex = 500;
const $0f029c9679d01cce$var$akEditorToolbarKeylineHeight = 2;
const $0f029c9679d01cce$var$stickyToolbarCompiledStyles = {
    mainToolbarWrapper: "_1mT5xdRAKS _0hPCNLDIqT _0Of8r22ADO _1Znuxb2ADO _1wydGWdnbC _2Zuz6QkG2W _3iDTPbQ4SZ _0jFU0VIZbP _0KLXrulfZc _2OUyjtYbGa _3Jay95dnbC _1pLMfqdnbC _3dWw89dnbC",
    mainToolbarWithPadding: "_0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO",
    mainToolbarTwoLine: "_4p3kRSIDxV _0PND29F05b _3gMsu0Q4SZ _2SvMAQz9WS _45XDcMz9WS _2NuSBXQ4SZ",
    mainToolbarWrapperVisualRefresh: "_0fdGNFN91d",
    mainToolbarRadius: "_0bjKvDS00P",
    editorModernisationToolbar: "_0bjKvD1Hdw _2rgTTNYbGa",
    stickyToolbarWrapper: "_23rrnHJD2S _1mT5xdHE3j _1wydGW2ADO _42Yu6BN779 _2rgTTNf7vw"
};
const $0f029c9679d01cce$export$2005bfaa48dbb54b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(14);
    const [top, setTop] = (0, $cozmU.useState)(0);
    let t0;
    let t1;
    if ($[0] !== props.externalToolbarRef || $[1] !== props.offsetTop) {
        t0 = ()=>{
            if (props.externalToolbarRef?.current?.clientHeight) setTop(props.externalToolbarRef.current.clientHeight);
            else setTop(props.offsetTop || 0);
        };
        t1 = [
            props.externalToolbarRef,
            props.offsetTop
        ];
        $[0] = props.externalToolbarRef;
        $[1] = props.offsetTop;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    const t2 = `${top}px`;
    let t3;
    if ($[4] !== t2) {
        t3 = {
            top: t2
        };
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const wrapperStyle = t3;
    const t4 = props.twoLineEditorToolbar && $0f029c9679d01cce$var$stickyToolbarCompiledStyles.mainToolbarTwoLine;
    const t5 = props.isNewToolbarEnabled && $0f029c9679d01cce$var$stickyToolbarCompiledStyles.mainToolbarWithPadding;
    const t6 = props.isEditorModernisationEnabled && $0f029c9679d01cce$var$stickyToolbarCompiledStyles.editorModernisationToolbar;
    let t7;
    if ($[6] !== t4 || $[7] !== t5 || $[8] !== t6) {
        t7 = (0, $hekY6.default)([
            $0f029c9679d01cce$var$stickyToolbarCompiledStyles.mainToolbarWrapper,
            t4,
            $0f029c9679d01cce$var$stickyToolbarCompiledStyles.mainToolbarWrapperVisualRefresh,
            $0f029c9679d01cce$var$stickyToolbarCompiledStyles.stickyToolbarWrapper,
            t5,
            $0f029c9679d01cce$var$stickyToolbarCompiledStyles.mainToolbarRadius,
            t6,
            "show-keyline"
        ]);
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== props.children || $[11] !== t7 || $[12] !== wrapperStyle) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: wrapperStyle,
            "data-testid": "ak-editor-main-toolbar",
            className: t7,
            children: props.children
        });
        $[10] = props.children;
        $[11] = t7;
        $[12] = wrapperStyle;
        $[13] = t8;
    } else t8 = $[13];
    return t8;
} : (props)=>{
    const [top, setTop] = (0, $cozmU.useState)(0); // ED-15802: if externalToolbarRef is passed in, set top to externalToolbarRef?.current?.clientHeight
    // else if offsetTop is a number set top to offsetTop
    // otherwise top is 0 as initial state
    (0, $cozmU.useEffect)(()=>{
        if (props.externalToolbarRef?.current?.clientHeight) setTop(props.externalToolbarRef.current.clientHeight);
        else setTop(props.offsetTop || 0);
    }, [
        props.externalToolbarRef,
        props.offsetTop
    ]);
    const wrapperStyle = (0, $cozmU.useMemo)(()=>({
            top: `${top}px`
        }), [
        top
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/enforce-style-prop -- top is computed dynamically from externalToolbarRef height / offsetTop and cannot be a static css value
    , {
        style: wrapperStyle,
        "data-testid": "ak-editor-main-toolbar",
        className: (0, $hekY6.default)([
            $0f029c9679d01cce$var$stickyToolbarCompiledStyles.mainToolbarWrapper,
            props.twoLineEditorToolbar && $0f029c9679d01cce$var$stickyToolbarCompiledStyles.mainToolbarTwoLine,
            $0f029c9679d01cce$var$stickyToolbarCompiledStyles.mainToolbarWrapperVisualRefresh,
            $0f029c9679d01cce$var$stickyToolbarCompiledStyles.stickyToolbarWrapper,
            props.isNewToolbarEnabled && $0f029c9679d01cce$var$stickyToolbarCompiledStyles.mainToolbarWithPadding,
            $0f029c9679d01cce$var$stickyToolbarCompiledStyles.mainToolbarRadius,
            props.isEditorModernisationEnabled && $0f029c9679d01cce$var$stickyToolbarCompiledStyles.editorModernisationToolbar,
            'show-keyline'
        ]),
        children: props.children
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
* Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
* Used via `componentWithCondition` in `Toolbar.tsx`.
*
* Cleanup: delete this file once the experiment has shipped.
*/ 





function $25f7e0fd272ecf46$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $25f7e0fd272ecf46$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
const $25f7e0fd272ecf46$var$akEditorMenuZIndex = 500;
const $25f7e0fd272ecf46$var$akEditorToolbarKeylineHeight = 2;
const $25f7e0fd272ecf46$var$mainToolbarWrapperStyleNew = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'relative',
    alignItems: 'center',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 0`,
    display: 'flex',
    height: 'auto',
    backgroundColor: "var(--ds-surface, #FFFFFF)",
    boxShadow: 'none',
    paddingLeft: "var(--ds-space-250, 20px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '> div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:first-of-type:not(style), > style:first-of-type + *': {
            marginLeft: 0
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.block-type-btn': {
        paddingLeft: 0
    }
});
const $25f7e0fd272ecf46$var$mainToolbarWithPadding = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `${"var(--ds-space-100, 8px)"}`
});
const $25f7e0fd272ecf46$var$mainToolbarTwoLineStylesNew = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& > div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media (max-width: ${$25f7e0fd272ecf46$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
            flexDirection: 'column-reverse',
            alignItems: 'end',
            display: 'flex',
            justifyContent: 'flex-end'
        },
        /* make this more explicit for a toolbar */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`@media (max-width: ${$25f7e0fd272ecf46$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '> div:nth-of-type(2)': {
                    justifyContent: 'flex-end',
                    display: 'flex'
                }
            }
        }
    }
});
const $25f7e0fd272ecf46$var$mainToolbarWrapperStylesVisualRefresh = {
    name: "y5dbpb",
    styles: "span svg{max-width:100%;}"
};
const $25f7e0fd272ecf46$var$mainToolbarRadius = /*#__PURE__*/ (0, $lOiVq.css)({
    borderRadius: `${"var(--ds-radius-medium, 6px)"} ${"var(--ds-radius-medium, 6px)"} 0 0`
});
const $25f7e0fd272ecf46$var$editorModernisationToolbarStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    borderRadius: `${"var(--ds-radius-xlarge, 12px)"} ${"var(--ds-radius-xlarge, 12px)"} 0 0`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.show-keyline': {
        boxShadow: "var(--ds-shadow-overflow, 0px 0px 8px #1E1F2128, 0px 0px 1px #1E1F211e)"
    }
});
const $25f7e0fd272ecf46$var$stickyToolbarWrapperStyleNew = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'sticky',
    paddingBottom: "var(--ds-space-100, 8px)",
    zIndex: $25f7e0fd272ecf46$var$akEditorMenuZIndex,
    transition: 'box-shadow ease-in-out 0.2s',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.show-keyline': {
        boxShadow: `0 ${$25f7e0fd272ecf46$var$akEditorToolbarKeylineHeight}px 0 0 ${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"}`
    }
});
const $25f7e0fd272ecf46$export$614511c351cc0a13 = (props)=>{
    const [top, setTop] = (0, $cozmU.useState)(0); // ED-15802: if externalToolbarRef is passed in, set top to externalToolbarRef?.current?.clientHeight
    // else if offsetTop is a number set top to offsetTop
    // otherwise top is 0 as initial state
    (0, $cozmU.useEffect)(()=>{
        if (props.externalToolbarRef?.current?.clientHeight) setTop(props.externalToolbarRef.current.clientHeight);
        else setTop(props.offsetTop || 0);
    }, [
        props.externalToolbarRef,
        props.offsetTop
    ]);
    const wrapperStyle = {
        top: `${top}px`
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $25f7e0fd272ecf46$var$mainToolbarWrapperStyleNew,
            props.twoLineEditorToolbar && $25f7e0fd272ecf46$var$mainToolbarTwoLineStylesNew,
            $25f7e0fd272ecf46$var$mainToolbarWrapperStylesVisualRefresh,
            $25f7e0fd272ecf46$var$stickyToolbarWrapperStyleNew,
            props.isNewToolbarEnabled && $25f7e0fd272ecf46$var$mainToolbarWithPadding,
            $25f7e0fd272ecf46$var$mainToolbarRadius,
            props.isEditorModernisationEnabled && $25f7e0fd272ecf46$var$editorModernisationToolbarStyle
        ],
        style: wrapperStyle,
        "data-testid": "ak-editor-main-toolbar",
        className: 'show-keyline'
    }, props.children);
};


const $f1dd66aaa28f975c$var$StickyToolbarMigration = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $0f029c9679d01cce$export$2005bfaa48dbb54b), (0, $25f7e0fd272ecf46$export$614511c351cc0a13));
const $f1dd66aaa28f975c$var$FixedToolbarMigration = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $67ae59487b7a561b$export$698f02dc2a985568), (0, $fd36c0a467717c25$export$84f029869645bc38));
/**
 * ED-15802: Scenarios when a sticky bar is used:
 * 1. useStickyToolbar is true
 * 2. useStickyToolbar is a DOM element
 * 3. useStickyToolbar is an object and has offsetTop key;
 */ const $f1dd66aaa28f975c$var$getStickyParameters = (configuration)=>{
    // const isUsingStickyOffset, isHTMLElement is used so TS can properly infer types.
    const isHTMLElement = typeof configuration === 'object' && !('offsetTop' in configuration);
    const isUsingStickyOffset = typeof configuration === 'object' && 'offsetTop' in configuration;
    if (typeof configuration !== 'object') return {
        externalToolbarRef: undefined,
        offsetTop: undefined
    };
    if (isUsingStickyOffset) return {
        offsetTop: configuration.offsetTop
    };
    if (isHTMLElement) return {
        externalToolbarRef: configuration
    };
};
const $f1dd66aaa28f975c$export$f7e5e5a2fbd99270 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { useStickyToolbar: useStickyToolbar, twoLineEditorToolbar: twoLineEditorToolbar, children: children, isEditorModernisationEnabled: isEditorModernisationEnabled, isNewToolbarEnabled: isNewToolbarEnabled } = t0;
    if (useStickyToolbar) {
        let t1;
        if ($[0] !== useStickyToolbar) {
            t1 = $f1dd66aaa28f975c$var$getStickyParameters(useStickyToolbar);
            $[0] = useStickyToolbar;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== children || $[3] !== isEditorModernisationEnabled || $[4] !== isNewToolbarEnabled || $[5] !== t1 || $[6] !== twoLineEditorToolbar) {
            t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($f1dd66aaa28f975c$var$StickyToolbarMigration, {
                ...t1,
                isEditorModernisationEnabled: isEditorModernisationEnabled,
                twoLineEditorToolbar: twoLineEditorToolbar,
                isNewToolbarEnabled: isNewToolbarEnabled,
                children: children
            });
            $[2] = children;
            $[3] = isEditorModernisationEnabled;
            $[4] = isNewToolbarEnabled;
            $[5] = t1;
            $[6] = twoLineEditorToolbar;
            $[7] = t2;
        } else t2 = $[7];
        return t2;
    }
    let t1;
    if ($[8] !== children || $[9] !== isEditorModernisationEnabled || $[10] !== isNewToolbarEnabled || $[11] !== twoLineEditorToolbar) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($f1dd66aaa28f975c$var$FixedToolbarMigration, {
            isEditorModernisationEnabled: isEditorModernisationEnabled,
            twoLineEditorToolbar: twoLineEditorToolbar,
            isNewToolbarEnabled: isNewToolbarEnabled,
            children: children
        });
        $[8] = children;
        $[9] = isEditorModernisationEnabled;
        $[10] = isNewToolbarEnabled;
        $[11] = twoLineEditorToolbar;
        $[12] = t1;
    } else t1 = $[12];
    return t1;
} : ({ useStickyToolbar: useStickyToolbar, twoLineEditorToolbar: twoLineEditorToolbar, children: children, isEditorModernisationEnabled: isEditorModernisationEnabled, isNewToolbarEnabled: isNewToolbarEnabled })=>{
    if (useStickyToolbar) return /*#__PURE__*/ (0, $8aG6j.jsx)($f1dd66aaa28f975c$var$StickyToolbarMigration, {
        ...$f1dd66aaa28f975c$var$getStickyParameters(useStickyToolbar),
        isEditorModernisationEnabled: isEditorModernisationEnabled,
        twoLineEditorToolbar: twoLineEditorToolbar,
        isNewToolbarEnabled: isNewToolbarEnabled,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($f1dd66aaa28f975c$var$FixedToolbarMigration, {
        isEditorModernisationEnabled: isEditorModernisationEnabled,
        twoLineEditorToolbar: twoLineEditorToolbar,
        isNewToolbarEnabled: isNewToolbarEnabled,
        children: children
    });
};


const $154459da5ffbdf52$var$commentEditorCompiledStyles = {
    commentEditor: "_30huDKS6k6 _0bjKvDKTcp _3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIztyp _0jFU0VIZbP _0KLXru7Cj1 _24h04i2Njc _1EqgXlOLYo _1T2N03wPeg _2B7ft78HPE _17xm1w2ADO _15u3vI2ADO _02LbpL2ADO",
    modernisedEditor: "_0bjKvDyzSk",
    secondaryToolbar: "_24h04i2Njc _37wbyuz9WS _0hPCNLDIqT _3iDTPbQ4SZ _0Of8r28HPE _1ZnuxbFQfX _1wydGW8HPE _2Zuz6QFQfX",
    mainToolbarCustomComponentsSlotNew: "_3iDTPbQ4SZ _37wbyuz9WS _0hPCNLDIqT _2O5Vij7dHp _1ZnuxbkG2W _1Fbn34Q4SZ _1UPrH0dnbC",
    mainToolbarCustomComponentsSlotPaddingOverride: "_1ZnuxbdnbC",
    mainToolbarCustomComponentsSlotTwoLineToolbar: "_2ev37mdnbC",
    contentAreaMaxHeight: "_0NUa3r0Guy _2WAcuGIZbP"
};
const $154459da5ffbdf52$var$appearance = 'comment';
const $154459da5ffbdf52$export$705c03bd29d87476 = (props)=>{
    const { editorAPI: editorAPI } = props; // Get useStandardNodeWidth from block menu plugin shared state
    // Only access editorAPI when the experiment is enabled to avoid performance impact
    const useStandardNodeWidth = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && (editorAPI?.blockMenu?.sharedState?.currentState()?.useStandardNodeWidth ?? false);
    const { editorViewMode: editorViewMode, primaryToolbarComponentsState: primaryToolbarComponentsState, maxContentSizeReached: maxContentSizeReached } = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorAPI, [
        'maxContentSize',
        'primaryToolbar',
        'editorViewMode'
    ], (states)=>({
            maxContentSizeReached: !!states.maxContentSizeState?.maxContentSizeReached,
            primaryToolbarComponentsState: states.primaryToolbarState?.components,
            editorViewMode: states.editorViewModeState?.mode
        }));
    const primaryToolbarState = (0, $5JOGK.getPrimaryToolbarComponents)(editorAPI, primaryToolbarComponentsState);
    const { mediaState: mediaState } = (0, $4y8CY.useSharedPluginState)(editorAPI, [
        'media'
    ]);
    const intl = (0, $kSwu1.useIntl)();
    const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, customPrimaryToolbarComponents: customPrimaryToolbarComponents, primaryToolbarComponents: primaryToolbarComponentsProp, customSecondaryToolbarComponents: customSecondaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, maxHeight: maxHeight, minHeight: minHeight = 150, onSave: onSave, onCancel: onCancel, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, useStickyToolbar: useStickyToolbar, pluginHooks: pluginHooks, featureFlags: featureFlags, innerRef: innerRef, isEditorModernisationEnabled: isEditorModernisationEnabled } = props;
    const showSecondaryToolbar = !!onSave || !!onCancel || !!customSecondaryToolbarComponents;
    const containerElement = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null); // Wrapper container for toolbar and content area
    const wrapperElementRef = (0, $cozmU.useMemo)(()=>innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef(), [
        innerRef
    ]);
    const [saveButtonDisabled, setSaveButtonDisabled] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (mediaState) mediaState.subscribeToUploadInProgressState(setSaveButtonDisabled);
        return ()=>mediaState?.unsubscribeFromUploadInProgressState(setSaveButtonDisabled);
    }, [
        mediaState
    ]);
    const handleSave = (0, $cozmU.useCallback)(()=>{
        if (editorView && onSave) onSave(editorView);
    }, [
        editorView,
        onSave
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        if (editorView && onCancel) onCancel(editorView);
    }, [
        editorView,
        onCancel
    ]);
    const isShortcutToFocusToolbar = (0, $cozmU.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    }, []); // When primary toolbar components is undefined, do not show two line editor toolbar
    const isTwoLineToolbarEnabled = !!customPrimaryToolbarComponents;
    const handleEscape = (0, $cozmU.useCallback)((event_0)=>{
        if (!editorView?.hasFocus()) editorView?.focus();
        event_0.preventDefault();
        event_0.stopPropagation();
    }, [
        editorView
    ]);
    let primaryToolbarComponents = primaryToolbarComponentsProp;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    const isToolbarAIFCEnabled = Boolean(editorAPI?.toolbar);
    const wrapperStyle = (0, $cozmU.useMemo)(()=>({
            minHeight: `${minHeight}px`,
            ...maxHeight ? {
                '--comment-editor-max-height': `${maxHeight}px`
            } : {}
        }), [
        minHeight,
        maxHeight
    ]);
    const customToolbarSlot = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            $154459da5ffbdf52$var$commentEditorCompiledStyles.mainToolbarCustomComponentsSlotNew,
            isTwoLineToolbarEnabled && $154459da5ffbdf52$var$commentEditorCompiledStyles.mainToolbarCustomComponentsSlotTwoLineToolbar,
            isToolbarAIFCEnabled && $154459da5ffbdf52$var$commentEditorCompiledStyles.mainToolbarCustomComponentsSlotPaddingOverride
        ]),
        children: customPrimaryToolbarComponents
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5XRFP.default), {
        animate: maxContentSizeReached,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dUm2W.WidthProvider), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic minHeight/maxHeight from props
                , {
                    style: wrapperStyle,
                    className: (0, $hekY6.default)([
                        $154459da5ffbdf52$var$commentEditorCompiledStyles.commentEditor,
                        isEditorModernisationEnabled && $154459da5ffbdf52$var$commentEditorCompiledStyles.modernisedEditor,
                        "akEditor"
                    ]),
                    ref: wrapperElementRef,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f1dd66aaa28f975c$export$f7e5e5a2fbd99270), {
                            isEditorModernisationEnabled: isEditorModernisationEnabled,
                            useStickyToolbar: useStickyToolbar,
                            twoLineEditorToolbar: isTwoLineToolbarEnabled,
                            isNewToolbarEnabled: isToolbarAIFCEnabled,
                            children: isToolbarAIFCEnabled ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $bZDJe.ToolbarArrowKeyNavigationProvider), {
                                editorView: editorView,
                                childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
                                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                                handleEscape: handleEscape,
                                editorAppearance: $154459da5ffbdf52$var$appearance,
                                useStickyToolbar: useStickyToolbar,
                                intl: intl,
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $45103d414e00d6bf$export$48156340a1673791), {
                                        editorAPI: editorAPI,
                                        editorView: editorView,
                                        editorAppearance: $154459da5ffbdf52$var$appearance,
                                        disabled: !!disabled,
                                        popupsBoundariesElement: popupsBoundariesElement,
                                        popupsScrollableElement: popupsScrollableElement,
                                        popupsMountPoint: popupsMountPoint
                                    }),
                                    customPrimaryToolbarComponents ? customToolbarSlot : null
                                ]
                            }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $bZDJe.ToolbarArrowKeyNavigationProvider), {
                                editorView: editorView,
                                childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
                                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                                handleEscape: handleEscape,
                                editorAppearance: $154459da5ffbdf52$var$appearance,
                                useStickyToolbar: useStickyToolbar,
                                intl: intl,
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bVYsF.ToolbarWithSizeDetector // Ignored via go/ees005
                                    ), {
                                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                        editorView: editorView,
                                        editorActions: editorActions,
                                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                        eventDispatcher: eventDispatcher,
                                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                        providerFactory: providerFactory,
                                        appearance: $154459da5ffbdf52$var$appearance,
                                        items: primaryToolbarComponents,
                                        popupsMountPoint: popupsMountPoint,
                                        popupsBoundariesElement: popupsBoundariesElement,
                                        popupsScrollableElement: popupsScrollableElement,
                                        disabled: !!disabled,
                                        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                        containerElement: containerElement.current,
                                        twoLineEditorToolbar: isTwoLineToolbarEnabled
                                    }),
                                    customToolbarSlot
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8eIAK.default), {
                            editorView: editorView,
                            editorDisabled: disabled,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dUm2W.WidthConsumer), {
                                children: ({ width: width })=>{
                                    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $58PSv.default), {
                                        ref: containerElement,
                                        isScrollable: maxHeight ? true : undefined,
                                        className: (0, $hekY6.default)([
                                            maxHeight && $154459da5ffbdf52$var$commentEditorCompiledStyles.contentAreaMaxHeight,
                                            (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('ak-editor-content-area', {
                                                'less-margin': width < (0, $7Y8M5.akEditorMobileBreakoutPoint)
                                            })
                                        ]),
                                        featureFlags: featureFlags,
                                        viewMode: editorViewMode,
                                        appearance: $154459da5ffbdf52$var$appearance,
                                        useStandardNodeWidth: useStandardNodeWidth,
                                        children: [
                                            customContentComponents && 'before' in customContentComponents ? (0, $iy9Au.contentComponentClickWrapper)(customContentComponents.before) : (0, $iy9Au.contentComponentClickWrapper)(customContentComponents),
                                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $01rUB.default), {
                                                editorView: editorView,
                                                editorActions: editorActions,
                                                eventDispatcher: eventDispatcher,
                                                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                                providerFactory: providerFactory,
                                                appearance: $154459da5ffbdf52$var$appearance,
                                                items: contentComponents,
                                                popupsMountPoint: popupsMountPoint,
                                                popupsBoundariesElement: popupsBoundariesElement,
                                                popupsScrollableElement: popupsScrollableElement,
                                                containerElement: containerElement.current,
                                                disabled: !!disabled,
                                                wrapperElement: wrapperElementRef.current,
                                                pluginHooks: pluginHooks
                                            }),
                                            editorDOMElement,
                                            customContentComponents && 'after' in customContentComponents ? (0, $iy9Au.contentComponentClickWrapper)(customContentComponents.after) : null
                                        ]
                                    });
                                }
                            })
                        })
                    ]
                }),
                showSecondaryToolbar && /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                    "data-testid": "ak-editor-secondary-toolbar",
                    className: (0, $hekY6.default)([
                        $154459da5ffbdf52$var$commentEditorCompiledStyles.secondaryToolbar
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7joZr.default), {
                            children: [
                                !!onSave && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                                    appearance: "primary",
                                    onClick: handleSave,
                                    testId: "comment-save-button",
                                    isDisabled: disabled || saveButtonDisabled,
                                    interactionName: "editor-comment-save-button",
                                    children: intl.formatMessage((0, $2xhuI.default).saveButton)
                                }),
                                !!onCancel && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                                    appearance: "subtle",
                                    onClick: handleCancel,
                                    testId: "comment-cancel-button",
                                    isDisabled: disabled,
                                    interactionName: "editor-comment-cancel-button",
                                    children: intl.formatMessage((0, $2xhuI.default).cancelButton)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            style: {
                                flexGrow: 1
                            }
                        }),
                        customSecondaryToolbarComponents
                    ]
                })
            ]
        })
    });
};
$154459da5ffbdf52$export$705c03bd29d87476.displayName = 'CommentEditorAppearance';


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
* Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
* Used via `componentWithCondition` in `Comment.tsx`.
*
* Cleanup: delete this file once the experiment has shipped.
*/ 



































var $4o0zT = parcelRequire("4o0zT");



























function $5a656cf0b8c5f79e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5a656cf0b8c5f79e$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
const $5a656cf0b8c5f79e$var$commentEditorStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.less-margin > .ProseMirror': {
        margin: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    minWidth: '272px',
    height: 'auto',
    backgroundColor: "var(--ds-background-input, #FFFFFF)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-input, #8C8F97)"}`,
    boxSizing: 'border-box',
    borderRadius: "var(--ds-radius-medium, 6px)",
    maxWidth: 'inherit',
    wordWrap: 'break-word'
});
const $5a656cf0b8c5f79e$var$modernisedEditorStyles = {
    name: "4hv4al",
    styles: "border-radius:var(--ds-radius-xlarge, 12px);border-color:var(--ds-border-input, #8C8F97)"
};
const $5a656cf0b8c5f79e$var$secondaryToolbarStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-025, 2px)"}`
});
const $5a656cf0b8c5f79e$var$mainToolbarCustomComponentsSlotStyleNew = {
    name: "4cnzc6",
    styles: "display:flex;justify-content:flex-end;align-items:center;flex-grow:1;padding-right:var(--ds-space-250, 20px);> div{display:flex;flex-shrink:0;}"
};
const $5a656cf0b8c5f79e$var$mainToolbarCustomComponentsSlotStylePaddingOverride = {
    name: "jjyo93",
    styles: "padding-right:0"
};
const $5a656cf0b8c5f79e$var$mainToolbarCustomComponentsSlotStyleTwoLineToolbarNew = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    [`@media (max-width: ${$5a656cf0b8c5f79e$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
        paddingRight: 0
    }
});
const $5a656cf0b8c5f79e$var$appearance = 'comment';
const $5a656cf0b8c5f79e$export$1f4a955ce070d42d = (props)=>{
    const { editorAPI: editorAPI } = props; // Get useStandardNodeWidth from block menu plugin shared state
    // Only access editorAPI when the experiment is enabled to avoid performance impact
    const useStandardNodeWidth = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && (editorAPI?.blockMenu?.sharedState?.currentState()?.useStandardNodeWidth ?? false);
    const { editorViewMode: editorViewMode, primaryToolbarComponentsState: primaryToolbarComponentsState, maxContentSizeReached: maxContentSizeReached } = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorAPI, [
        'maxContentSize',
        'primaryToolbar',
        'editorViewMode'
    ], (states)=>({
            maxContentSizeReached: !!states.maxContentSizeState?.maxContentSizeReached,
            primaryToolbarComponentsState: states.primaryToolbarState?.components,
            editorViewMode: states.editorViewModeState?.mode
        }));
    const primaryToolbarState = (0, $5JOGK.getPrimaryToolbarComponents)(editorAPI, primaryToolbarComponentsState);
    const { mediaState: mediaState } = (0, $4y8CY.useSharedPluginState)(editorAPI, [
        'media'
    ]);
    const intl = (0, $kSwu1.useIntl)();
    const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, customPrimaryToolbarComponents: customPrimaryToolbarComponents, primaryToolbarComponents: primaryToolbarComponentsProp, customSecondaryToolbarComponents: customSecondaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, maxHeight: maxHeight, minHeight: minHeight = 150, onSave: onSave, onCancel: onCancel, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, useStickyToolbar: useStickyToolbar, pluginHooks: pluginHooks, featureFlags: featureFlags, innerRef: innerRef, isEditorModernisationEnabled: isEditorModernisationEnabled } = props;
    const showSecondaryToolbar = !!onSave || !!onCancel || !!customSecondaryToolbarComponents;
    const containerElement = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null); // Wrapper container for toolbar and content area
    const wrapperElementRef = (0, $cozmU.useMemo)(()=>innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef(), [
        innerRef
    ]);
    const [saveButtonDisabled, setSaveButtonDisabled] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (mediaState) mediaState.subscribeToUploadInProgressState(setSaveButtonDisabled);
        return ()=>mediaState?.unsubscribeFromUploadInProgressState(setSaveButtonDisabled);
    }, [
        mediaState
    ]);
    const handleSave = (0, $cozmU.useCallback)(()=>{
        if (editorView && onSave) onSave(editorView);
    }, [
        editorView,
        onSave
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        if (editorView && onCancel) onCancel(editorView);
    }, [
        editorView,
        onCancel
    ]);
    const isShortcutToFocusToolbar = (0, $cozmU.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    }, []); // When primary toolbar components is undefined, do not show two line editor toolbar
    const isTwoLineToolbarEnabled = !!customPrimaryToolbarComponents;
    const handleEscape = (0, $cozmU.useCallback)((event)=>{
        if (!editorView?.hasFocus()) editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    }, [
        editorView
    ]);
    let primaryToolbarComponents = primaryToolbarComponentsProp;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    const isToolbarAIFCEnabled = Boolean(editorAPI?.toolbar);
    const memoizedContentAreaStyles = (0, $cozmU.useMemo)(()=>[
            maxHeight ? /*#__PURE__*/ (0, $lOiVq.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                maxHeight: `${maxHeight}px`,
                // When maxHeight is set, content area should have overflow-y explicitly set as auto
                // As we have overflow-x: clip for the content area, and when maxHeight prop is set, overflow-y will be computed as visible by default.
                // This will cause the content area to have content overflowing the container
                // so need to set overflow-y as auto to make sure the content area is scrollable
                overflowY: 'auto'
            }) : null
        ], [
        maxHeight
    ]);
    const contentAreaStyles = (0, $4o0zT.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedContentAreaStyles : [
        maxHeight ? /*#__PURE__*/ (0, $lOiVq.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxHeight: `${maxHeight}px`,
            // When maxHeight is set, content area should have overflow-y explicitly set as auto
            // As we have overflow-x: clip for the content area, and when maxHeight prop is set, overflow-y will be computed as visible by default.
            // This will cause the content area to have content overflowing the container
            // so need to set overflow-y as auto to make sure the content area is scrollable
            overflowY: 'auto'
        }) : null
    ];
    const customToolbarSlot = /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $5a656cf0b8c5f79e$var$mainToolbarCustomComponentsSlotStyleNew,
            isTwoLineToolbarEnabled && $5a656cf0b8c5f79e$var$mainToolbarCustomComponentsSlotStyleTwoLineToolbarNew,
            isToolbarAIFCEnabled && $5a656cf0b8c5f79e$var$mainToolbarCustomComponentsSlotStylePaddingOverride
        ]
    }, customPrimaryToolbarComponents);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5XRFP.default), {
        animate: maxContentSizeReached
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUm2W.WidthProvider), null, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $5a656cf0b8c5f79e$var$commentEditorStyles,
            isEditorModernisationEnabled && $5a656cf0b8c5f79e$var$modernisedEditorStyles,
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $lOiVq.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                minHeight: `${minHeight}px`
            })
        ],
        className: "akEditor",
        ref: wrapperElementRef
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $f1dd66aaa28f975c$export$f7e5e5a2fbd99270), {
        isEditorModernisationEnabled: isEditorModernisationEnabled,
        useStickyToolbar: useStickyToolbar,
        twoLineEditorToolbar: isTwoLineToolbarEnabled,
        isNewToolbarEnabled: isToolbarAIFCEnabled
    }, isToolbarAIFCEnabled ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bZDJe.ToolbarArrowKeyNavigationProvider), {
        editorView: editorView,
        childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleEscape: handleEscape,
        editorAppearance: $5a656cf0b8c5f79e$var$appearance,
        useStickyToolbar: useStickyToolbar,
        intl: intl
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $45103d414e00d6bf$export$48156340a1673791), {
        editorAPI: editorAPI,
        editorView: editorView,
        editorAppearance: $5a656cf0b8c5f79e$var$appearance,
        disabled: !!disabled,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        popupsMountPoint: popupsMountPoint
    }), customPrimaryToolbarComponents ? customToolbarSlot : null) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bZDJe.ToolbarArrowKeyNavigationProvider), {
        editorView: editorView,
        childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleEscape: handleEscape,
        editorAppearance: $5a656cf0b8c5f79e$var$appearance,
        useStickyToolbar: useStickyToolbar,
        intl: intl
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bVYsF.ToolbarWithSizeDetector // Ignored via go/ees005
    ), {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: editorView,
        editorActions: editorActions,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: eventDispatcher,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        providerFactory: providerFactory,
        appearance: $5a656cf0b8c5f79e$var$appearance,
        items: primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        disabled: !!disabled,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        containerElement: containerElement.current,
        twoLineEditorToolbar: isTwoLineToolbarEnabled
    }), customToolbarSlot)), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $8eIAK.default), {
        editorView: editorView,
        editorDisabled: disabled
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUm2W.WidthConsumer), null, ({ width: width })=>{
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $58PSv.default), {
            ref: containerElement,
            css: contentAreaStyles,
            isScrollable: maxHeight ? true : undefined,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('ak-editor-content-area', {
                'less-margin': width < (0, $7Y8M5.akEditorMobileBreakoutPoint)
            }),
            featureFlags: featureFlags,
            viewMode: editorViewMode,
            appearance: $5a656cf0b8c5f79e$var$appearance,
            useStandardNodeWidth: useStandardNodeWidth
        }, customContentComponents && 'before' in customContentComponents ? (0, $iy9Au.contentComponentClickWrapper)(customContentComponents.before) : (0, $iy9Au.contentComponentClickWrapper)(customContentComponents), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $01rUB.default), {
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            providerFactory: providerFactory,
            appearance: $5a656cf0b8c5f79e$var$appearance,
            items: contentComponents,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement.current,
            disabled: !!disabled,
            wrapperElement: wrapperElementRef.current,
            pluginHooks: pluginHooks
        }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? (0, $iy9Au.contentComponentClickWrapper)(customContentComponents.after) : null);
    }))), showSecondaryToolbar && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $5a656cf0b8c5f79e$var$secondaryToolbarStyles,
        "data-testid": "ak-editor-secondary-toolbar"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7joZr.default), null, !!onSave && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleSave,
        testId: "comment-save-button",
        isDisabled: disabled || saveButtonDisabled,
        interactionName: "editor-comment-save-button"
    }, intl.formatMessage((0, $2xhuI.default).saveButton)), !!onCancel && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleCancel,
        testId: "comment-cancel-button",
        isDisabled: disabled,
        interactionName: "editor-comment-cancel-button"
    }, intl.formatMessage((0, $2xhuI.default).cancelButton))), /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        style: {
            flexGrow: 1
        }
    }), customSecondaryToolbarComponents)));
};
$5a656cf0b8c5f79e$export$1f4a955ce070d42d.displayName = 'CommentEditorAppearance';


const $3e3535e1cc0ca1ca$export$7b9f3a51cd0c1967 = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $154459da5ffbdf52$export$705c03bd29d87476), (0, $5a656cf0b8c5f79e$export$1f4a955ce070d42d));
module.exports["CommentEditorWithIntl"] = $3e3535e1cc0ca1ca$export$7b9f3a51cd0c1967;

});

parcelRegister("4y8CY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");

/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $d88b883699f74793$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $d88b883699f74793$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $cozmU.useMemo)(()=>plugins, []);
}
function $d88b883699f74793$export$a4c4fd90e2b72baa(injectionApi, plugins, options) {
    const pluginNames = $d88b883699f74793$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $cozmU.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $d88b883699f74793$var$useSharedPluginStateInternal(namedExternalPlugins, options);
}
function $d88b883699f74793$var$useSharedPluginStateInternal(externalPlugins, options = {}) {
    const [pluginStates, setPluginState] = (0, $cozmU.useState)($d88b883699f74793$var$mapValues(externalPlugins, (value)=>options.disabled ? undefined : value?.sharedState.currentState()));
    const refStates = (0, $cozmU.useRef)({});
    const mounted = (0, $cozmU.useRef)(false);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (options.disabled) return;
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            setPluginState((currentPluginStates)=>({
                    ...currentPluginStates,
                    ...refStates.current
                }));
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $d88b883699f74793$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb?.());
        };
    // Do not re-render due to state changes, we only need to check this when
    // setting up the initial subscription.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
    return pluginStates;
}
module.exports["useSharedPluginState"] = $d88b883699f74793$export$a4c4fd90e2b72baa;

});

parcelRegister("8eIAK", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $8m50u = parcelRequire("8m50u");


var $ieeJu = parcelRequire("ieeJu");


var $btvbC = parcelRequire("btvbC");

/**
 * @see ED-14699 - check if editor is inside a modal to continue to bring cursor to input when
 * any part of the editor container is clicked
 *
 * Handles two cases when a click event is fired:
 *
 * 1. if editor (e.g. comment inside of Jira ticket view) is inside modal then ensure focus and cursor is brought to the input
 * 2. if another modal is open (e.g. delete confirmation modal for confluence table) then ignore clicks as they shouldn't influence editor state
 */ const $6b891c190210b2e4$export$79ba7abfc5f47a65 = (target)=>{
    const modalDialog = target?.closest('[role=dialog]');
    if (modalDialog) // return false if not an editor inside modal, otherwise return true
    return !!modalDialog?.querySelector('.akEditor');
    // no modal present so we can return true
    return true;
};



var $iy9Au = parcelRequire("iy9Au");


var $jbOus = parcelRequire("jbOus");


var $9WBFV = parcelRequire("9WBFV");


var $Lh4Gi = parcelRequire("Lh4Gi");

const $469257f0271f2a53$export$c5a7a653c4681bfd = (view, event)=>{
    const { dispatch: dispatch, dom: dom, state: state } = view;
    const { tr: tr } = state;
    const isEditorFocused = !!view?.hasFocus?.();
    const isBottomAreaClicked = event.clientY > dom.getBoundingClientRect().bottom;
    if (isBottomAreaClicked) {
        tr.setMeta('outsideProsemirrorEditorClicked', true);
        (0, $9WBFV.addParagraphAtEnd)(tr);
    }
    (0, $Lh4Gi.setSelectionTopLevelBlocks)(tr, event, // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    dom, view.posAtCoords.bind(view), isEditorFocused);
    (0, $jbOus.tintDirtyTransaction)(tr);
    if (!tr.docChanged && !tr.selectionSet) return;
    if (dispatch) dispatch(tr);
    view.focus();
    event.preventDefault();
};


// we ignore all of the clicks made inside <div class="ak-editor-content-area" /> (but not clicks on the node itself)
const $aefe7d7ff3fc8aac$var$insideContentArea = (ref)=>{
    while(ref){
        if (ref.classList && ref.classList.contains('ak-editor-content-area')) return true;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        ref = ref.parentNode;
    }
    return false;
};
const $aefe7d7ff3fc8aac$var$insideProseMirrorEditableArea = (ref)=>{
    return Boolean(ref?.closest('.ProseMirror'));
};
const $aefe7d7ff3fc8aac$export$28b64e3e5a38e8a2 = (view, event)=>{
    const isEditorFocused = !!view?.hasFocus?.();
    if (!(event.target instanceof HTMLElement)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const isTargetContentArea = target?.classList.contains('ak-editor-content-area');
    const isTargetChildOfContentArea = $aefe7d7ff3fc8aac$var$insideContentArea(target?.parentNode instanceof HTMLElement ? target?.parentNode : null);
    const isTargetInsideEditableArea = $aefe7d7ff3fc8aac$var$insideProseMirrorEditableArea(target);
    // Any click inside ProseMirror should be managed by ProseMirror
    if (isTargetInsideEditableArea) return false;
    const isEventComingFromContentArea = Boolean(event.currentTarget.querySelector('.ak-editor-content-area'));
    // @see https://product-fabric.atlassian.net/browse/ED-4287
    // click event gets triggered twice on a checkbox (on <label> first and then on <input>)
    // by the time it gets triggered on input, PM already re-renders nodeView and detaches it from DOM
    // which doesn't pass the check !contentArea.contains(event.target)
    const isInputClicked = target?.nodeName === 'INPUT';
    // @see ED-5126
    const isPopupClicked = !!(0, $btvbC.closestElement)(target, '[data-editor-popup]');
    // Fixes issue when using a textarea for editor title in full page editor doesn't let user focus it.
    const isTextAreaClicked = target?.nodeName === 'TEXTAREA';
    const isBreadcrumbClicked = !!(0, $btvbC.closestElement)(target, 'nav[aria-label="Breadcrumbs"]');
    const selection = window.getSelection();
    const isEditorPopupTextSelected = selection?.type === 'Range' && // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    (0, $btvbC.closestElement)(selection?.anchorNode, '[data-editor-popup]');
    // For clicks directly on the content component -- they should not be ignored
    const isContentComponent = target?.parentElement?.closest(`[${(0, $iy9Au.ignoreAttribute)}]`);
    // This is a super workaround to find when events are coming from Confluence InlineComment modal
    // We don't own those components, so we can't change them
    const isEventComingFromInlineCommentPopup = Boolean((0, $btvbC.closestElement)(event.currentTarget, 'div[offset]')) || Boolean((0, $btvbC.closestElement)(target, 'div[offset]'));
    const isAnchorButtonClicked = Boolean((0, $btvbC.closestElement)(event.currentTarget, 'a')) || Boolean((0, $btvbC.closestElement)(target, 'a')) || event.currentTarget?.nodeName === 'A' || target?.nodeName === 'A';
    const isButtonClicked = Boolean((0, $btvbC.closestElement)(event.currentTarget, 'button')) || Boolean((0, $btvbC.closestElement)(target, 'button')) || event.currentTarget?.nodeName === 'BUTTON' || target?.nodeName === 'BUTTON' || isAnchorButtonClicked;
    const isTargetInsideContentArea = Boolean(isTargetChildOfContentArea);
    const isBetweenContentAreaAndEditableContent = isTargetInsideContentArea && !isTargetInsideEditableArea;
    // Column Picker dropdown in Datasources table
    const isDatasourcePopupClicked = !!target?.closest('#column-picker-popup');
    const edgeCaseScenario1 = (isBetweenContentAreaAndEditableContent || !isEventComingFromContentArea) && !isEditorFocused;
    const edgeCaseScenario2 = !isTargetInsideContentArea && isEditorFocused;
    const edgeCaseScenario3 = isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCaseScenario4 = isEventComingFromContentArea && !isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCases = edgeCaseScenario1 || edgeCaseScenario2 || edgeCaseScenario3 || edgeCaseScenario4;
    const isClickOutsideEditor = edgeCases && !isDatasourcePopupClicked && !isEventComingFromInlineCommentPopup && !isButtonClicked && !isInputClicked && !isTextAreaClicked && !isPopupClicked && !isBreadcrumbClicked && !isEditorPopupTextSelected && !isContentComponent && (0, $6b891c190210b2e4$export$79ba7abfc5f47a65)(target);
    // click was within editor container and focus should be brought to input
    if (isClickOutsideEditor && view) (0, $469257f0271f2a53$export$c5a7a653c4681bfd)(view, event);
};











parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $f9dc1aa8361db726$var$clickWrapperCompiledStyles = {
    root: "_2O5Vij7dHp _0jFU0VN91d"
};
const $f9dc1aa8361db726$export$ea84b896e6fff843 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let children;
    let rest;
    if ($[0] !== t0) {
        ({ children: children, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = rest;
    } else {
        children = $[1];
        rest = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $f9dc1aa8361db726$var$clickWrapperCompiledStyles.root
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== rest) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ...rest,
            className: t1,
            children: children
        });
        $[4] = children;
        $[5] = rest;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, ...rest })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ...rest,
        className: (0, $hekY6.default)([
            $f9dc1aa8361db726$var$clickWrapperCompiledStyles.root
        ]),
        children: children
    });


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
 * Used via `componentWithCondition` in `index.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $lOiVq = parcelRequire("lOiVq");

function $326709944ad84c0e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $326709944ad84c0e$var$clickWrapperEmotionStyles = {
    name: "sox1a6",
    styles: "flex-grow:1;height:100%"
};
const $326709944ad84c0e$export$6eeb061cc2f1987e = ({ children: children, ...rest })=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $326709944ad84c0e$var$clickWrapperEmotionStyles,
        ...rest
    }, children);


const $97d85adb77685b06$var$ClickAreaBlockContainerMigration = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $f9dc1aa8361db726$export$ea84b896e6fff843), (0, $326709944ad84c0e$export$6eeb061cc2f1987e));
const $97d85adb77685b06$export$68468c5dbde37b99 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { editorView: editorView, editorDisabled: editorDisabled, children: children } = t0;
    let t1;
    if ($[0] !== editorDisabled || $[1] !== editorView) {
        t1 = (event)=>{
            if (!editorView) return;
            if (!editorDisabled) (0, $aefe7d7ff3fc8aac$export$28b64e3e5a38e8a2)(editorView, event);
        };
        $[0] = editorDisabled;
        $[1] = editorView;
        $[2] = t1;
    } else t1 = $[2];
    const handleMouseDown = t1;
    let t2;
    if ($[3] !== children || $[4] !== handleMouseDown) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($97d85adb77685b06$var$ClickAreaBlockContainerMigration, {
            "data-editor-click-wrapper": true,
            "data-testid": "click-wrapper",
            onMouseDown: handleMouseDown,
            role: "presentation",
            children: children
        });
        $[3] = children;
        $[4] = handleMouseDown;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ editorView: editorView, editorDisabled: editorDisabled, children: children })=>{
    const handleMouseDown = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        if (!editorView) return;
        if (!editorDisabled) (0, $aefe7d7ff3fc8aac$export$28b64e3e5a38e8a2)(editorView, event);
    }, [
        editorView,
        editorDisabled
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($97d85adb77685b06$var$ClickAreaBlockContainerMigration, {
        "data-editor-click-wrapper": true,
        "data-testid": "click-wrapper",
        onMouseDown: handleMouseDown,
        // This div is a presentational container that captures mouse events
        // for programmatic editor focus management, not user interaction.
        role: "presentation",
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$97d85adb77685b06$export$2e2bcd8739ae039 = $97d85adb77685b06$export$68468c5dbde37b99;
module.exports["ClickAreaBlock"] = $97d85adb77685b06$export$68468c5dbde37b99;
module.exports["default"] = $97d85adb77685b06$export$2e2bcd8739ae039;

});

parcelRegister("iy9Au", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");

const $4ab1d3be7904b78c$export$72d101e93c081651 = 'data-editor-content-component';
const $4ab1d3be7904b78c$export$57a965c23051130d = (reactComponents)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-editor-content-component": 'true',
        children: reactComponents
    });
};
module.exports["ignoreAttribute"] = $4ab1d3be7904b78c$export$72d101e93c081651;
module.exports["contentComponentClickWrapper"] = $4ab1d3be7904b78c$export$57a965c23051130d;

});

parcelRegister("9WBFV", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $kCECX = parcelRequire("kCECX");


var $8HW7o = parcelRequire("8HW7o");


var $56doO = parcelRequire("56doO");

function $262d6a8e1debd5ac$export$fc18809329b5ff08(tr) {
    const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } }, doc: doc } = tr;
    if (doc.lastChild && !(doc.lastChild.type === paragraph && doc.lastChild.content.size === 0)) {
        if (paragraph) tr.insert(doc.content.size, paragraph.createAndFill());
    }
    tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, tr.doc.content.size - 1));
    tr.scrollIntoView();
}
function $262d6a8e1debd5ac$export$2864da03fd603a92() {
    return function(state, dispatch) {
        const { tr: tr } = state;
        $262d6a8e1debd5ac$export$fc18809329b5ff08(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $262d6a8e1debd5ac$export$774cc08dd90b6a6a = (align)=>(state, dispatch)=>{
        const { from: from, to: to } = state.selection;
        const tr = state.tr;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === state.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        if (tr.docChanged && dispatch) {
            dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $262d6a8e1debd5ac$export$b637dda807357427 = (align)=>(tr)=>{
        const { from: from, to: to } = tr.selection;
        const initialDoc = tr.doc;
        tr.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === tr.doc.type.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        // compare tr.doc with initialDoc instead of tr.docChanged
        // because tr passed in might have been modified prior this function
        // e.g. see changeAlignmentTr platform/packages/editor/editor-plugin-alignment/src/editor-commands/index.ts:L197
        if (!tr.doc.eq(initialDoc)) {
            tr.scrollIntoView();
            return true;
        }
        return false;
    };
const $262d6a8e1debd5ac$export$1115c4cf51ae1924 = (markType, getAttrs, allowedBlocks)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.type.isBlock) return false;
            const parentAllowsMark = state?.schema?.nodes?.blockTaskItem && parent?.type === state?.schema?.nodes?.blockTaskItem && markType === state?.schema?.marks?.indentation ? false : parent?.type.allowsMarkType(markType);
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(state.schema, node, parent))) && parentAllowsMark) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $262d6a8e1debd5ac$export$8614a16deba8906f = (markType, getAttrs, allowedBlocks)=>(from, to, tr)=>{
        let markApplied = false;
        tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.type.isBlock) return false;
            const schema = tr.doc.type.schema;
            const parentAllowsMark = schema?.nodes?.blockTaskItem && parent?.type === schema?.nodes?.blockTaskItem && markType === schema?.marks?.indentation ? false : parent?.type.allowsMarkType(markType);
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(tr.doc.type.schema, node, parent))) && parentAllowsMark) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $262d6a8e1debd5ac$export$a10bb5a1a10022f6 = (markType, getAttrs)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (parent?.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, state.selection.from));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $262d6a8e1debd5ac$export$72d6145976985e8c = (markType, getAttrs, allowedBlocks)=>(state, dispatch)=>{
        let markApplied = false;
        const tr = state.tr;
        const toggleBlockMarkOnRange = $262d6a8e1debd5ac$export$1115c4cf51ae1924(markType, getAttrs, allowedBlocks);
        if (state.selection instanceof (0, $8HW7o.CellSelection)) state.selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr, state);
        });
        else {
            const { from: from, to: to } = state.selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr, state);
        }
        if (markApplied && tr.docChanged) {
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $262d6a8e1debd5ac$export$23f118e134ed2228 = (markType, getAttrs, allowedBlocks)=>(tr)=>{
        let markApplied = false;
        const toggleBlockMarkOnRange = $262d6a8e1debd5ac$export$8614a16deba8906f(markType, getAttrs, allowedBlocks);
        const initialDoc = tr.doc;
        const { selection: selection } = tr;
        if (selection instanceof (0, $8HW7o.CellSelection)) selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr);
        });
        else {
            const { from: from, to: to } = selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr);
        }
        // compare tr.doc with initialDoc instead of tr.docChanged
        // because tr passed in might have been modified prior this function
        // e.g. see changeAlignmentTr platform/packages/editor/editor-plugin-alignment/src/editor-commands/index.ts:L197
        if (markApplied && !initialDoc.eq(tr.doc)) {
            tr.scrollIntoView();
            return true;
        }
        return false;
    };
const $262d6a8e1debd5ac$export$59c0bf8874edecc7 = (state, dispatch)=>{
    const tr = state.tr;
    tr.replace(0, state.doc.nodeSize - 2);
    tr.setSelection((0, $kCECX.Selection).atStart(tr.doc));
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
function $262d6a8e1debd5ac$export$ad1078cb3917e860($pos) {
    // parent is non-isolating, so we can look across this boundary
    if (!$pos.parent.type.spec.isolating) // search up the tree from the pos's *parent*
    for(let i = $pos.depth - 1; i >= 0; i--){
        // starting from the inner most node's parent, find out
        // if we're not its first child
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $262d6a8e1debd5ac$export$c6a04dca1ed03a3c(level) {
    return function(state, dispatch) {
        const { selection: selection, schema: schema, tr: tr } = state;
        const ranges = selection instanceof (0, $8HW7o.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}
module.exports["addParagraphAtEnd"] = $262d6a8e1debd5ac$export$fc18809329b5ff08;
module.exports["changeImageAlignment"] = $262d6a8e1debd5ac$export$774cc08dd90b6a6a;
module.exports["changeImageAlignmentNext"] = $262d6a8e1debd5ac$export$b637dda807357427;
module.exports["createToggleBlockMarkOnRange"] = $262d6a8e1debd5ac$export$1115c4cf51ae1924;
module.exports["createToggleBlockMarkOnRangeNext"] = $262d6a8e1debd5ac$export$8614a16deba8906f;
module.exports["createToggleInlineMarkOnRange"] = $262d6a8e1debd5ac$export$a10bb5a1a10022f6;
module.exports["toggleBlockMark"] = $262d6a8e1debd5ac$export$72d6145976985e8c;
module.exports["toggleBlockMarkNext"] = $262d6a8e1debd5ac$export$23f118e134ed2228;
module.exports["findCutBefore"] = $262d6a8e1debd5ac$export$ad1078cb3917e860;

});

parcelRegister("56doO", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");

const $e7168d4c0cc4976f$export$f51280337625031 = (state, nodeType, start, end, attrs)=>{
    // To ensure that match is done after HardBreak.
    const { hardBreak: hardBreak, codeBlock: codeBlock, listItem: listItem } = state.schema.nodes;
    const $pos = state.doc.resolve(start);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if ($pos.nodeAfter.type !== hardBreak) return null;
    // To ensure no nesting is done. (unless we're inserting a codeBlock inside lists)
    if ($pos.depth > 1 && !(nodeType === codeBlock && (0, $bjg0G.hasParentNodeOfType)(listItem)(state.selection))) return null;
    // Split at the start of autoformatting and delete formatting characters.
    let tr = state.tr.delete(start, end).split(start);
    let currentNode = tr.doc.nodeAt(start + 1);
    // If node has more content split at the end of autoformatting.
    let nodeHasMoreContent = false;
    tr.doc.nodesBetween(start, start + currentNode.nodeSize, (node, pos)=>{
        if (!nodeHasMoreContent && node.type === hardBreak) {
            nodeHasMoreContent = true;
            tr = tr.split(pos + 1).delete(pos, pos + 1);
        }
    });
    if (nodeHasMoreContent) currentNode = tr.doc.nodeAt(start + 1);
    // Create new node and fill with content of current node.
    const { blockquote: blockquote, paragraph: paragraph } = state.schema.nodes;
    let content;
    let depth;
    if (nodeType === blockquote) {
        depth = 3;
        content = [
            paragraph.create({}, currentNode.content)
        ];
    } else {
        depth = 2;
        content = currentNode.content;
    }
    const newNode = nodeType.create(attrs, content);
    // Add new node.
    tr = tr.setSelection(new (0, $kCECX.NodeSelection)(tr.doc.resolve(start + 1)))// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .replaceSelectionWith(newNode).setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(start + depth)));
    return tr;
};
module.exports["insertBlock"] = $e7168d4c0cc4976f$export$f51280337625031;

});

parcelRegister("Lh4Gi", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $4EksL = parcelRequire("4EksL");


var $eaLat = parcelRequire("eaLat");


var $88vX6 = parcelRequire("88vX6");

// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $341921c7ba7f3030$var$captureCursorCoords = (event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $eaLat.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $eaLat.Side).LEFT : (0, $eaLat.Side).RIGHT;
            let position;
            if (side === (0, $eaLat.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $341921c7ba7f3030$export$1b305efb24649ca5 = (tr, event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $341921c7ba7f3030$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $eaLat.Side).LEFT ? (0, $88vX6.isValidTargetNode)($pos.nodeAfter) : (0, $88vX6.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $4EksL.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $4EksL.GapCursorSelection)) tr.setSelection((0, $kCECX.Selection).near($pos));
        else tr.setSelection(new (0, $4EksL.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $kCECX.Selection).findFrom($pos, cursorCoords.side === (0, $eaLat.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $341921c7ba7f3030$export$44fdd7840a0a11f2 = (position, side = (0, $eaLat.Side).LEFT)=>(state, dispatch)=>{
        // @see ED-6231
        if (position > state.doc.content.size) return false;
        const $pos = state.doc.resolve(position);
        if ((0, $4EksL.GapCursorSelection).valid($pos)) {
            if (dispatch) dispatch(state.tr.setSelection(new (0, $4EksL.GapCursorSelection)($pos, side)));
            return true;
        }
        return false;
    };
module.exports["setSelectionTopLevelBlocks"] = $341921c7ba7f3030$export$1b305efb24649ca5;
module.exports["setGapCursorAtPos"] = $341921c7ba7f3030$export$44fdd7840a0a11f2;

});

parcelRegister("5JOGK", function(module, exports) {
const $a49396703bac2f6d$export$f454e86f6cef71f4 = (editorAPI, components)=>{
    return {
        components: components ?? editorAPI?.primaryToolbar?.sharedState.currentState()?.components
    };
};
module.exports["getPrimaryToolbarComponents"] = $a49396703bac2f6d$export$f454e86f6cef71f4;

});

parcelRegister("bVYsF", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");


var $6OREF = parcelRequire("6OREF");


var $8m50u = parcelRequire("8m50u");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");


var $1LXnB = parcelRequire("1LXnB");


var $loGKD = parcelRequire("loGKD");











var $iDrrr = parcelRequire("iDrrr");

const $11f4e3b8ded81812$export$1217913212f99c7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (ref, t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { skip: skip } = t0;
    const [elementWidth, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(undefined);
    let t1;
    let t2;
    if ($[0] !== ref || $[1] !== skip) {
        t1 = ()=>{
            if (!skip && ref.current && !(0, $iDrrr.fg)("platform_editor_prevent_toolbar_width_reflow")) setWidth(Math.round(ref.current.getBoundingClientRect().width));
        };
        t2 = [
            skip,
            setWidth,
            ref
        ];
        $[0] = ref;
        $[1] = skip;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t1, t2);
    return elementWidth;
} : (ref, { skip: skip })=>{
    const [elementWidth, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!skip && ref.current && !(0, $iDrrr.fg)('platform_editor_prevent_toolbar_width_reflow')) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        setWidth(Math.round(ref.current.getBoundingClientRect().width));
    }, [
        skip,
        setWidth,
        ref
    ]);
    return elementWidth;
};



var $lMyvS = parcelRequire("lMyvS");




var $50ogq = parcelRequire("50ogq");

var $v0kiU = parcelRequire("v0kiU");

var $8QpVb = parcelRequire("8QpVb");

var $hvcLS = parcelRequire("hvcLS");







// Toolbar sizes for full page editor a little bit different, because it has more buttons e.g. actions button...
const $106b90ea370d11fb$var$toolbarSizesFullPageNext = [
    {
        width: (0, $8QpVb.ToolbarWidthsFullPageNext).XXL,
        size: (0, $6OREF.ToolbarSize).XXL
    },
    {
        width: (0, $8QpVb.ToolbarWidthsFullPageNext).XL,
        size: (0, $6OREF.ToolbarSize).XL
    },
    {
        width: (0, $8QpVb.ToolbarWidthsFullPageNext).L,
        size: (0, $6OREF.ToolbarSize).L
    },
    {
        width: (0, $8QpVb.ToolbarWidthsFullPageNext).M,
        size: (0, $6OREF.ToolbarSize).M
    },
    {
        width: (0, $8QpVb.ToolbarWidthsFullPageNext).S,
        size: (0, $6OREF.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesFullPageNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $106b90ea370d11fb$var$toolbarSizesFullPage = [
    {
        width: (0, $v0kiU.ToolbarWidthsFullPage).XXL,
        size: (0, $6OREF.ToolbarSize).XXL
    },
    {
        width: (0, $v0kiU.ToolbarWidthsFullPage).XL,
        size: (0, $6OREF.ToolbarSize).XL
    },
    {
        width: (0, $v0kiU.ToolbarWidthsFullPage).L,
        size: (0, $6OREF.ToolbarSize).L
    },
    {
        width: (0, $v0kiU.ToolbarWidthsFullPage).M,
        size: (0, $6OREF.ToolbarSize).M
    },
    {
        width: (0, $v0kiU.ToolbarWidthsFullPage).S,
        size: (0, $6OREF.ToolbarSize).S
    }
];
const $106b90ea370d11fb$var$toolbarSizesNext = [
    {
        width: (0, $hvcLS.ToolbarWidthsNext).XXL,
        size: (0, $6OREF.ToolbarSize).XXL
    },
    {
        width: (0, $hvcLS.ToolbarWidthsNext).XL,
        size: (0, $6OREF.ToolbarSize).XL
    },
    {
        width: (0, $hvcLS.ToolbarWidthsNext).L,
        size: (0, $6OREF.ToolbarSize).L
    },
    {
        width: (0, $hvcLS.ToolbarWidthsNext).M,
        size: (0, $6OREF.ToolbarSize).M
    },
    {
        width: (0, $hvcLS.ToolbarWidthsNext).S,
        size: (0, $6OREF.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $106b90ea370d11fb$var$toolbarSizes = [
    {
        width: (0, $50ogq.ToolbarWidths).XXL,
        size: (0, $6OREF.ToolbarSize).XXL
    },
    {
        width: (0, $50ogq.ToolbarWidths).XL,
        size: (0, $6OREF.ToolbarSize).XL
    },
    {
        width: (0, $50ogq.ToolbarWidths).L,
        size: (0, $6OREF.ToolbarSize).L
    },
    {
        width: (0, $50ogq.ToolbarWidths).M,
        size: (0, $6OREF.ToolbarSize).M
    },
    {
        width: (0, $50ogq.ToolbarWidths).S,
        size: (0, $6OREF.ToolbarSize).S
    }
];
const $106b90ea370d11fb$var$toolbarSizesForAppearance = (appearance)=>(0, $loGKD.isFullPage)(appearance) ? (0, $iDrrr.fg)('platform_editor_toolbar_responsive_fixes') ? $106b90ea370d11fb$var$toolbarSizesFullPageNext : $106b90ea370d11fb$var$toolbarSizesFullPage : (0, $iDrrr.fg)('platform_editor_toolbar_responsive_fixes') ? $106b90ea370d11fb$var$toolbarSizesNext : $106b90ea370d11fb$var$toolbarSizes;
const $106b90ea370d11fb$export$df8e48f984163082 = (toolbarSize, appearance)=>{
    return ($106b90ea370d11fb$var$toolbarSizesForAppearance(appearance).find(({ size: size })=>toolbarSize === size) || {
        width: (0, $50ogq.ToolbarWidths).S
    }).width;
};
const $106b90ea370d11fb$export$886398ab6922a80f = (toolbarWidth, appearance)=>{
    return ($106b90ea370d11fb$var$toolbarSizesForAppearance(appearance).find(({ width: width })=>toolbarWidth > width) || {
        size: (0, $6OREF.ToolbarSize).XXXS
    }).size;
};











parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $f2c5353ecc381c18$var$toolbarSizeDetectorWrapperCompiledStyles = {
    root: "_39xV02N91d _1mT5xdRAKS"
};
const $f2c5353ecc381c18$export$390f44f5b097927e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, style: style } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $f2c5353ecc381c18$var$toolbarSizeDetectorWrapperCompiledStyles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== style) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: style,
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = style;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, style: style })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: style,
        className: (0, $hekY6.default)([
            $f2c5353ecc381c18$var$toolbarSizeDetectorWrapperCompiledStyles.root
        ]),
        children: children
    });


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
 * Used via `componentWithCondition` in `ToolbarWithSizeDetector.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $lOiVq = parcelRequire("lOiVq");

function $51dcad6643910e7c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $51dcad6643910e7c$var$toolbarSizeDetectorWrapperEmotionStyles = {
    name: "n48rgu",
    styles: "width:100%;position:relative"
};
const $51dcad6643910e7c$export$4f6c55d99b915855 = ({ children: children, style: style })=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $51dcad6643910e7c$var$toolbarSizeDetectorWrapperEmotionStyles,
        style: style
    }, children);


const $6d4f135f9f95b6fe$var$ToolbarSizeDetectorWrapperMigration = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $f2c5353ecc381c18$export$390f44f5b097927e), (0, $51dcad6643910e7c$export$4f6c55d99b915855));
const $6d4f135f9f95b6fe$export$6bb21858343ac39d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(35);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(undefined);
    const t0 = typeof width !== "undefined";
    let t1;
    if ($[0] !== t0) {
        t1 = {
            skip: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const elementWidth = (0, $11f4e3b8ded81812$export$1217913212f99c7)(ref, t1);
    const defaultToolbarSize = (0, $4iudd.isSSR)() && (0, $loGKD.isFullPage)(props.appearance) ? (0, $6OREF.ToolbarSize).XXL : undefined;
    let t2;
    if ($[2] !== defaultToolbarSize || $[3] !== elementWidth || $[4] !== props.appearance || $[5] !== width) {
        t2 = typeof width === "undefined" && typeof elementWidth === "undefined" ? defaultToolbarSize : (0, $106b90ea370d11fb$export$886398ab6922a80f)(width || elementWidth, props.appearance);
        $[2] = defaultToolbarSize;
        $[3] = elementWidth;
        $[4] = props.appearance;
        $[5] = width;
        $[6] = t2;
    } else t2 = $[6];
    const toolbarSize = t2;
    let t3;
    if (props.hasMinWidth) {
        const toolbarWidth = (0, $loGKD.isFullPage)(props.appearance) && props.twoLineEditorToolbar ? (0, $6OREF.ToolbarSize).S : (0, $6OREF.ToolbarSize).M;
        let t4;
        if ($[7] !== props.appearance || $[8] !== toolbarWidth) {
            t4 = (0, $106b90ea370d11fb$export$df8e48f984163082)(toolbarWidth, props.appearance);
            $[7] = props.appearance;
            $[8] = toolbarWidth;
            $[9] = t4;
        } else t4 = $[9];
        t3 = `${t4}px`;
    } else {
        const isPreviewPanelResponsivenessEnabled = (0, $jkcNT.editorExperiment)("platform_editor_preview_panel_responsiveness", true, {
            exposure: true
        });
        t3 = isPreviewPanelResponsivenessEnabled ? "fit-content" : "254px";
    }
    const minWidthValue = t3;
    let t4;
    if ($[10] !== minWidthValue) {
        t4 = {
            minWidth: minWidthValue
        };
        $[10] = minWidthValue;
        $[11] = t4;
    } else t4 = $[11];
    const memoizedWrapperStyle = t4;
    let t5;
    if ($[12] !== memoizedWrapperStyle || $[13] !== minWidthValue) {
        t5 = (0, $ieeJu.expValEquals)("platform_editor_core_non_ecc_static_css", "isEnabled", true) ? memoizedWrapperStyle : {
            minWidth: minWidthValue
        };
        $[12] = memoizedWrapperStyle;
        $[13] = minWidthValue;
        $[14] = t5;
    } else t5 = $[14];
    const wrapperStyle = t5;
    let t6;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1LXnB.WidthObserver), {
            setWidth: setWidth
        });
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== props.appearance || $[17] !== props.containerElement || $[18] !== props.disabled || $[19] !== props.dispatchAnalyticsEvent || $[20] !== props.editorActions || $[21] !== props.editorView || $[22] !== props.eventDispatcher || $[23] !== props.hasMinWidth || $[24] !== props.items || $[25] !== props.popupsBoundariesElement || $[26] !== props.popupsMountPoint || $[27] !== props.popupsScrollableElement || $[28] !== props.providerFactory || $[29] !== props.twoLineEditorToolbar || $[30] !== toolbarSize) {
        t7 = props.editorView && toolbarSize ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lMyvS.Toolbar), {
            toolbarSize: toolbarSize,
            items: props.items,
            editorView: props.editorView,
            editorActions: props.editorActions,
            eventDispatcher: props.eventDispatcher,
            providerFactory: props.providerFactory,
            appearance: props.appearance,
            popupsMountPoint: props.popupsMountPoint,
            popupsBoundariesElement: props.popupsBoundariesElement,
            popupsScrollableElement: props.popupsScrollableElement,
            disabled: props.disabled,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
            containerElement: props.containerElement,
            hasMinWidth: props.hasMinWidth,
            twoLineEditorToolbar: props.twoLineEditorToolbar
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: ref
        });
        $[16] = props.appearance;
        $[17] = props.containerElement;
        $[18] = props.disabled;
        $[19] = props.dispatchAnalyticsEvent;
        $[20] = props.editorActions;
        $[21] = props.editorView;
        $[22] = props.eventDispatcher;
        $[23] = props.hasMinWidth;
        $[24] = props.items;
        $[25] = props.popupsBoundariesElement;
        $[26] = props.popupsMountPoint;
        $[27] = props.popupsScrollableElement;
        $[28] = props.providerFactory;
        $[29] = props.twoLineEditorToolbar;
        $[30] = toolbarSize;
        $[31] = t7;
    } else t7 = $[31];
    let t8;
    if ($[32] !== t7 || $[33] !== wrapperStyle) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)($6d4f135f9f95b6fe$var$ToolbarSizeDetectorWrapperMigration, {
            style: wrapperStyle,
            children: [
                t6,
                t7
            ]
        });
        $[32] = t7;
        $[33] = wrapperStyle;
        $[34] = t8;
    } else t8 = $[34];
    return t8;
} : (props)=>{
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(undefined);
    const elementWidth = (0, $11f4e3b8ded81812$export$1217913212f99c7)(ref, {
        skip: typeof width !== 'undefined'
    });
    const defaultToolbarSize = (0, $4iudd.isSSR)() && (0, $loGKD.isFullPage)(props.appearance) ? (0, $6OREF.ToolbarSize).XXL : undefined;
    const toolbarSize = typeof width === 'undefined' && typeof elementWidth === 'undefined' ? defaultToolbarSize : // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $106b90ea370d11fb$export$886398ab6922a80f)(width || elementWidth, props.appearance);
    const minWidthValue = (0, $cozmU.useMemo)(()=>{
        if (props.hasMinWidth) {
            const toolbarWidth = (0, $loGKD.isFullPage)(props.appearance) && props.twoLineEditorToolbar ? (0, $6OREF.ToolbarSize).S : (0, $6OREF.ToolbarSize).M;
            return `${(0, $106b90ea370d11fb$export$df8e48f984163082)(toolbarWidth, props.appearance)}px`;
        } else {
            const isPreviewPanelResponsivenessEnabled = (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            });
            return isPreviewPanelResponsivenessEnabled ? 'fit-content' : '254px';
        }
    }, [
        props.appearance,
        props.hasMinWidth,
        props.twoLineEditorToolbar
    ]);
    const memoizedWrapperStyle = (0, $cozmU.useMemo)(()=>({
            minWidth: minWidthValue
        }), [
        minWidthValue
    ]);
    const wrapperStyle = (0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true) ? memoizedWrapperStyle : {
        minWidth: minWidthValue
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)($6d4f135f9f95b6fe$var$ToolbarSizeDetectorWrapperMigration, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- minWidth is computed dynamically from props.hasMinWidth, props.appearance, props.twoLineEditorToolbar, and the platform_editor_preview_panel_responsiveness experiment, so it cannot be expressed as a static css value.
        style: wrapperStyle,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1LXnB.WidthObserver), {
                setWidth: setWidth
            }),
            props.editorView && toolbarSize ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lMyvS.Toolbar), {
                toolbarSize: toolbarSize,
                items: props.items,
                editorView: props.editorView,
                editorActions: props.editorActions,
                eventDispatcher: props.eventDispatcher,
                providerFactory: props.providerFactory,
                appearance: props.appearance,
                popupsMountPoint: props.popupsMountPoint,
                popupsBoundariesElement: props.popupsBoundariesElement,
                popupsScrollableElement: props.popupsScrollableElement,
                disabled: props.disabled,
                dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
                containerElement: props.containerElement,
                hasMinWidth: props.hasMinWidth,
                twoLineEditorToolbar: props.twoLineEditorToolbar
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                ref: ref
            })
        ]
    });
};
module.exports["ToolbarWithSizeDetector"] = $6d4f135f9f95b6fe$export$6bb21858343ac39d;

});

parcelRegister("loGKD", function(module, exports) {
function $7f1394985b339b8c$export$2800a15841f40ad7(appearance) {
    return appearance === 'full-page' || appearance === 'full-width';
}
module.exports["isFullPage"] = $7f1394985b339b8c$export$2800a15841f40ad7;

});

parcelRegister("lMyvS", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3k5Tv = parcelRequire("3k5Tv");


var $bFSJa = parcelRequire("bFSJa");

var $gnAkm = parcelRequire("gnAkm");


var $6OREF = parcelRequire("6OREF");


var $jaFVy = parcelRequire("jaFVy");


var $5AKbu = parcelRequire("5AKbu");

var $jgJIe = parcelRequire("jgJIe");

var $cE5a1 = parcelRequire("cE5a1");


var $7CFSN = parcelRequire("7CFSN");


var $4o0zT = parcelRequire("4o0zT");








var $3u5lg = parcelRequire("3u5lg");


var $4iudd = parcelRequire("4iudd");


var $8m50u = parcelRequire("8m50u");


var $ieeJu = parcelRequire("ieeJu");










parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $a0bd3fba9559743c$var$toolbarComponentsWrapperCompiledStyles = {
    root: "_3iDTPbQ4SZ _3xo5UHI7V3"
};
const $a0bd3fba9559743c$export$526eaae4f7757167 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, "data-vc": dataVc } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $a0bd3fba9559743c$var$toolbarComponentsWrapperCompiledStyles.root
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataVc) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-vc": dataVc,
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = dataVc;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, 'data-vc': dataVc })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-vc": dataVc,
        className: (0, $hekY6.default)([
            $a0bd3fba9559743c$var$toolbarComponentsWrapperCompiledStyles.root
        ]),
        children: children
    });


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
 * Used via `componentWithCondition` in `ToolbarInner.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");

const $aace4448963e2592$var$toolbarComponentsWrapperEmotionStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $7Y8M5.akEditorMobileMaxWidth}px)`]: {
        justifyContent: 'space-between'
    }
});
const $aace4448963e2592$export$729d2c4dd4193a59 = ({ children: children, 'data-vc': dataVc })=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $aace4448963e2592$var$toolbarComponentsWrapperEmotionStyles,
        "data-vc": dataVc
    }, children);


const $b21f7b547d7783a6$var$ToolbarComponentsWrapperMigration = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $a0bd3fba9559743c$export$526eaae4f7757167), (0, $aace4448963e2592$export$729d2c4dd4193a59));
class $b21f7b547d7783a6$export$7c77e89663c6a665 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(nextProps, this.props);
    }
    render() {
        const { appearance: appearance, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, items: items, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, containerElement: containerElement } = this.props;
        if (!items || !items.length) return null;
        if ((0, $4iudd.isSSR)()) // Toolbar in SSR environment is showing collapsed state, which caused layout shift after hydrating to SPA.
        // Hiding toolbar in SSR until the dependency of screen width is resolved in SSR environment.
        return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)($b21f7b547d7783a6$var$ToolbarComponentsWrapperMigration, {
            "data-vc": "toolbar-inner",
            children: items.map((component, key)=>{
                const element = component({
                    editorView: editorView,
                    editorActions: editorActions,
                    eventDispatcher: eventDispatcher,
                    providerFactory: providerFactory,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    appearance: appearance,
                    popupsMountPoint: popupsMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsScrollableElement: popupsScrollableElement,
                    disabled: disabled,
                    toolbarSize: toolbarSize,
                    isToolbarReducedSpacing: isToolbarReducedSpacing,
                    containerElement: containerElement,
                    isLastItem: key === items.length - 1,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    wrapperElement: null
                });
                // oxlint-disable-next-line react/no-array-index-key
                return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(element, {
                    key: key
                });
            })
        });
    }
}


const $2566f6d874d6fff7$var$TOOLBAR_FALLBACKS = {
    group: (0, $5AKbu.ToolbarButtonGroup),
    section: (0, $cE5a1.ToolbarSection),
    menuSection: (0, $jgJIe.ToolbarDropdownItemSection)
};
const $2566f6d874d6fff7$export$4c260019440d418f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(15);
    const t0 = props.toolbarSize < (0, $6OREF.ToolbarSize).XXL;
    let t1;
    if ($[0] !== props.appearance || $[1] !== props.containerElement || $[2] !== props.disabled || $[3] !== props.dispatchAnalyticsEvent || $[4] !== props.editorActions || $[5] !== props.editorView || $[6] !== props.eventDispatcher || $[7] !== props.items || $[8] !== props.popupsBoundariesElement || $[9] !== props.popupsMountPoint || $[10] !== props.popupsScrollableElement || $[11] !== props.providerFactory || $[12] !== props.toolbarSize || $[13] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b21f7b547d7783a6$export$7c77e89663c6a665), {
            items: props.items,
            editorView: props.editorView,
            editorActions: props.editorActions,
            eventDispatcher: props.eventDispatcher,
            providerFactory: props.providerFactory,
            appearance: props.appearance,
            popupsMountPoint: props.popupsMountPoint,
            popupsBoundariesElement: props.popupsBoundariesElement,
            popupsScrollableElement: props.popupsScrollableElement,
            disabled: props.disabled,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
            toolbarSize: props.toolbarSize,
            isToolbarReducedSpacing: t0,
            containerElement: props.containerElement
        });
        $[0] = props.appearance;
        $[1] = props.containerElement;
        $[2] = props.disabled;
        $[3] = props.dispatchAnalyticsEvent;
        $[4] = props.editorActions;
        $[5] = props.editorView;
        $[6] = props.eventDispatcher;
        $[7] = props.items;
        $[8] = props.popupsBoundariesElement;
        $[9] = props.popupsMountPoint;
        $[10] = props.popupsScrollableElement;
        $[11] = props.providerFactory;
        $[12] = props.toolbarSize;
        $[13] = t0;
        $[14] = t1;
    } else t1 = $[14];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b21f7b547d7783a6$export$7c77e89663c6a665), {
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        toolbarSize: props.toolbarSize,
        isToolbarReducedSpacing: props.toolbarSize < (0, $6OREF.ToolbarSize).XXL,
        containerElement: props.containerElement
    });
};
const $2566f6d874d6fff7$var$usePluginState = (0, $gtMdU.isReactCompilerActivePlatform)() ? (api)=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "connectivity",
            "editorViewMode",
            "userPreferences"
        ];
        $[0] = t0;
    } else t0 = $[0];
    return (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t0, $2566f6d874d6fff7$var$_temp);
} : (api)=>{
    return (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'editorViewMode',
        'userPreferences'
    ], (state)=>{
        return {
            connectivityStateMode: state.connectivityState?.mode,
            editorViewMode: state.editorViewModeState?.mode,
            editorToolbarDockingPreference: state.userPreferencesState?.preferences?.toolbarDockingPosition
        };
    });
};
const $2566f6d874d6fff7$export$1606f8c5fd0ac145 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { toolbar: toolbar, components: components, editorView: editorView, editorAPI: editorAPI, popupsMountPoint: popupsMountPoint, editorAppearance: editorAppearance, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isDisabled: isDisabled, disabledWithoutInteractionLogic: disabledWithoutInteractionLogic } = t0;
    const { connectivityStateMode: connectivityStateMode, editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference } = $2566f6d874d6fff7$var$usePluginState(editorAPI);
    let t1;
    if ($[0] !== connectivityStateMode) {
        t1 = (0, $jaFVy.isOfflineMode)(connectivityStateMode);
        $[0] = connectivityStateMode;
        $[1] = t1;
    } else t1 = $[1];
    const isOffline = t1;
    let t2;
    if ($[2] !== editorAPI?.analytics?.actions) {
        t2 = (payload)=>{
            editorAPI?.analytics?.actions.fireAnalyticsEvent(payload);
        };
        $[2] = editorAPI?.analytics?.actions;
        $[3] = t2;
    } else t2 = $[3];
    const memoizedFireAnalyticsEvent = t2;
    let t3;
    if ($[4] !== memoizedFireAnalyticsEvent) {
        t3 = (0, $4o0zT.isExperimentEnabled)("platform_editor_perf_lint_cleanup") ? memoizedFireAnalyticsEvent : (payload_0)=>memoizedFireAnalyticsEvent(payload_0);
        $[4] = memoizedFireAnalyticsEvent;
        $[5] = t3;
    } else t3 = $[5];
    const fireAnalyticsEvent = t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $4o0zT.isExperimentEnabled)("platform_editor_perf_lint_cleanup") ? $2566f6d874d6fff7$var$TOOLBAR_FALLBACKS : {
            group: (0, $5AKbu.ToolbarButtonGroup),
            section: (0, $cE5a1.ToolbarSection),
            menuSection: (0, $jgJIe.ToolbarDropdownItemSection)
        };
        $[6] = t4;
    } else t4 = $[6];
    const fallbacks = t4;
    const t5 = editorView ?? null;
    const t6 = editorViewMode ?? "edit";
    let t7;
    if ($[7] !== components || $[8] !== toolbar) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7CFSN.ToolbarModelRenderer), {
            toolbar: toolbar,
            components: components,
            fallbacks: fallbacks
        });
        $[7] = components;
        $[8] = toolbar;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== disabledWithoutInteractionLogic || $[11] !== editorAPI || $[12] !== fireAnalyticsEvent || $[13] !== isDisabled || $[14] !== popupsBoundariesElement || $[15] !== popupsMountPoint || $[16] !== popupsScrollableElement || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gnAkm.EditorToolbarUIProvider), {
            api: editorAPI,
            isDisabled: isDisabled,
            disabledWithoutInteractionLogic: disabledWithoutInteractionLogic,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            fireAnalyticsEvent: fireAnalyticsEvent,
            children: t7
        });
        $[10] = disabledWithoutInteractionLogic;
        $[11] = editorAPI;
        $[12] = fireAnalyticsEvent;
        $[13] = isDisabled;
        $[14] = popupsBoundariesElement;
        $[15] = popupsMountPoint;
        $[16] = popupsScrollableElement;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== editorAppearance || $[20] !== editorToolbarDockingPreference || $[21] !== isOffline || $[22] !== t5 || $[23] !== t6 || $[24] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bFSJa.EditorToolbarProvider), {
            editorView: t5,
            editorAppearance: editorAppearance,
            editorViewMode: t6,
            editorToolbarDockingPreference: editorToolbarDockingPreference,
            isOffline: isOffline,
            children: t8
        });
        $[19] = editorAppearance;
        $[20] = editorToolbarDockingPreference;
        $[21] = isOffline;
        $[22] = t5;
        $[23] = t6;
        $[24] = t8;
        $[25] = t9;
    } else t9 = $[25];
    return t9;
} : ({ toolbar: toolbar, components: components, editorView: editorView, editorAPI: editorAPI, popupsMountPoint: popupsMountPoint, editorAppearance: editorAppearance, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isDisabled: isDisabled, disabledWithoutInteractionLogic: disabledWithoutInteractionLogic })=>{
    const { connectivityStateMode: connectivityStateMode, editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference } = $2566f6d874d6fff7$var$usePluginState(editorAPI);
    // remove offline check when patch6Enabled is cleaned up
    const isOffline = (0, $jaFVy.isOfflineMode)(connectivityStateMode);
    const memoizedFireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        editorAPI?.analytics?.actions.fireAnalyticsEvent(payload);
    }, [
        editorAPI
    ]);
    const fireAnalyticsEvent = (0, $4o0zT.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedFireAnalyticsEvent : (payload_0)=>memoizedFireAnalyticsEvent(payload_0);
    const fallbacks = (0, $4o0zT.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? $2566f6d874d6fff7$var$TOOLBAR_FALLBACKS : {
        group: (0, $5AKbu.ToolbarButtonGroup),
        section: (0, $cE5a1.ToolbarSection),
        menuSection: (0, $jgJIe.ToolbarDropdownItemSection)
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bFSJa.EditorToolbarProvider), {
        editorView: editorView ?? null,
        editorAppearance: editorAppearance,
        editorViewMode: editorViewMode ?? 'edit',
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        isOffline: isOffline,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gnAkm.EditorToolbarUIProvider), {
            api: editorAPI,
            isDisabled: isDisabled,
            disabledWithoutInteractionLogic: disabledWithoutInteractionLogic,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            fireAnalyticsEvent: fireAnalyticsEvent,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7CFSN.ToolbarModelRenderer), {
                toolbar: toolbar,
                components: components,
                fallbacks: fallbacks
            })
        })
    });
};
function $2566f6d874d6fff7$var$_temp(state) {
    return {
        connectivityStateMode: state.connectivityState?.mode,
        editorViewMode: state.editorViewModeState?.mode,
        editorToolbarDockingPreference: state.userPreferencesState?.preferences?.toolbarDockingPosition
    };
}
module.exports["Toolbar"] = $2566f6d874d6fff7$export$4c260019440d418f;
module.exports["ToolbarNext"] = $2566f6d874d6fff7$export$1606f8c5fd0ac145;

});

parcelRegister("bFSJa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4o0zT = parcelRequire("4o0zT");

const $d883b46926e8973c$var$EditorToolbarContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    editorView: null,
    editorAppearance: undefined,
    editorViewMode: undefined,
    editorToolbarDockingPreference: undefined
});
const $d883b46926e8973c$export$d463571cb9040a24 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($d883b46926e8973c$var$EditorToolbarContext);
    if (!context) throw new Error("useEditorToolbar must be used within EditorToolbarContext");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($d883b46926e8973c$var$EditorToolbarContext);
    if (!context) throw new Error('useEditorToolbar must be used within EditorToolbarContext');
    return context;
};
const $d883b46926e8973c$export$847624ff5ecdfe6d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { children: children, editorView: editorView, editorAppearance: editorAppearance, editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, isOffline: isOffline } = t0;
    let t1;
    if ($[0] !== editorAppearance || $[1] !== editorToolbarDockingPreference || $[2] !== editorView || $[3] !== editorViewMode || $[4] !== isOffline) {
        t1 = {
            editorView: editorView,
            editorAppearance: editorAppearance,
            editorViewMode: editorViewMode,
            editorToolbarDockingPreference: editorToolbarDockingPreference,
            isOffline: isOffline
        };
        $[0] = editorAppearance;
        $[1] = editorToolbarDockingPreference;
        $[2] = editorView;
        $[3] = editorViewMode;
        $[4] = isOffline;
        $[5] = t1;
    } else t1 = $[5];
    const memoizedValue = t1;
    let t2;
    if ($[6] !== editorAppearance || $[7] !== editorToolbarDockingPreference || $[8] !== editorView || $[9] !== editorViewMode || $[10] !== isOffline || $[11] !== memoizedValue) {
        t2 = (0, $4o0zT.isExperimentEnabled)("platform_editor_perf_lint_cleanup") ? memoizedValue : {
            editorView: editorView,
            editorAppearance: editorAppearance,
            editorViewMode: editorViewMode,
            editorToolbarDockingPreference: editorToolbarDockingPreference,
            isOffline: isOffline
        };
        $[6] = editorAppearance;
        $[7] = editorToolbarDockingPreference;
        $[8] = editorView;
        $[9] = editorViewMode;
        $[10] = isOffline;
        $[11] = memoizedValue;
        $[12] = t2;
    } else t2 = $[12];
    const contextValue = t2;
    let t3;
    if ($[13] !== children || $[14] !== contextValue) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)($d883b46926e8973c$var$EditorToolbarContext.Provider, {
            value: contextValue,
            children: children
        });
        $[13] = children;
        $[14] = contextValue;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
} : ({ children: children, editorView: editorView, editorAppearance: editorAppearance, editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, isOffline: isOffline })=>{
    const memoizedValue = (0, $cozmU.useMemo)(()=>({
            editorView: editorView,
            editorAppearance: editorAppearance,
            editorViewMode: editorViewMode,
            editorToolbarDockingPreference: editorToolbarDockingPreference,
            isOffline: isOffline
        }), [
        editorView,
        editorAppearance,
        editorViewMode,
        editorToolbarDockingPreference,
        isOffline
    ]);
    const contextValue = (0, $4o0zT.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedValue : {
        editorView: editorView,
        editorAppearance: editorAppearance,
        editorViewMode: editorViewMode,
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        isOffline: isOffline
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)($d883b46926e8973c$var$EditorToolbarContext.Provider, {
        value: contextValue,
        children: children
    });
};
module.exports["useEditorToolbar"] = $d883b46926e8973c$export$d463571cb9040a24;
module.exports["EditorToolbarProvider"] = $d883b46926e8973c$export$847624ff5ecdfe6d;

});

parcelRegister("gnAkm", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b2jdX = parcelRequire("b2jdX");


var $4o0zT = parcelRequire("4o0zT");

const $bdcbdb1f4bbb48e4$export$54b6b74e939729c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children, api: api, isDisabled: isDisabled, disabledWithoutInteractionLogic: disabledWithoutInteractionLogic, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, fireAnalyticsEvent: fireAnalyticsEvent, keyboardNavigation: keyboardNavigation } = t0;
    let t1;
    if ($[0] !== api?.core) {
        t1 = (t2)=>{
            const { isOpen: isOpen, event: event } = t2;
            if (!isOpen) {
                const isKeyboardEscape = event instanceof KeyboardEvent && event.key === "Escape";
                const shouldFocusEditor = !isKeyboardEscape;
                if ((0, $4o0zT.isExperimentEnabled)("platform_editor_toolbar_multi_editor_fix") && event instanceof MouseEvent && event.target instanceof Element && !event.target.closest("[role=\"menu\"]")) return;
                if (shouldFocusEditor) setTimeout(()=>requestAnimationFrame(()=>{
                        api?.core.actions.focus({
                            scrollIntoView: false
                        });
                    }), 1);
            }
        };
        $[0] = api?.core;
        $[1] = t1;
    } else t1 = $[1];
    const onDropdownOpenChanged = t1;
    let t2;
    if ($[2] !== children || $[3] !== disabledWithoutInteractionLogic || $[4] !== fireAnalyticsEvent || $[5] !== isDisabled || $[6] !== keyboardNavigation || $[7] !== onDropdownOpenChanged || $[8] !== popupsBoundariesElement || $[9] !== popupsMountPoint || $[10] !== popupsScrollableElement) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b2jdX.ToolbarUIProvider), {
            onDropdownOpenChanged: onDropdownOpenChanged,
            preventDefaultOnMouseDown: true,
            isDisabled: isDisabled,
            disabledWithoutInteractionLogic: disabledWithoutInteractionLogic,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            fireAnalyticsEvent: fireAnalyticsEvent,
            keyboardNavigation: keyboardNavigation,
            children: children
        });
        $[2] = children;
        $[3] = disabledWithoutInteractionLogic;
        $[4] = fireAnalyticsEvent;
        $[5] = isDisabled;
        $[6] = keyboardNavigation;
        $[7] = onDropdownOpenChanged;
        $[8] = popupsBoundariesElement;
        $[9] = popupsMountPoint;
        $[10] = popupsScrollableElement;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
} : ({ children: children, api: api, isDisabled: isDisabled, disabledWithoutInteractionLogic: disabledWithoutInteractionLogic, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, fireAnalyticsEvent: fireAnalyticsEvent, keyboardNavigation: keyboardNavigation })=>{
    const onDropdownOpenChanged = (0, $cozmU.useCallback)(({ isOpen: isOpen, event: event })=>{
        if (!isOpen) {
            // Only refocus the editor when the dropdown closes via mouse or programmatic close.
            // When closed via keyboard Escape, keep focus on the trigger for better keyboard UX.
            const isKeyboardEscape = event instanceof KeyboardEvent && event.key === 'Escape';
            const shouldFocusEditor = !isKeyboardEscape;
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_toolbar_multi_editor_fix') && event instanceof MouseEvent && event.target instanceof Element && !event.target.closest('[role="menu"]')) return;
            if (shouldFocusEditor) // On Dropdown closed, focus is returned to trigger button by default in requestAnimationFrame
            // Hence, `.focus()` should also be called in requestAnimationFrame
            setTimeout(()=>requestAnimationFrame(()=>{
                    api?.core.actions.focus({
                        scrollIntoView: false
                    });
                }), 1);
        }
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b2jdX.ToolbarUIProvider), {
        onDropdownOpenChanged: onDropdownOpenChanged,
        preventDefaultOnMouseDown: true,
        isDisabled: isDisabled,
        disabledWithoutInteractionLogic: disabledWithoutInteractionLogic,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        fireAnalyticsEvent: fireAnalyticsEvent,
        keyboardNavigation: keyboardNavigation,
        children: children
    });
};
module.exports["EditorToolbarUIProvider"] = $bdcbdb1f4bbb48e4$export$54b6b74e939729c;

});

parcelRegister("jaFVy", function(module, exports) {
const $8c9ff4e069cde4e8$export$a73e10b357da8876 = (mode)=>{
    return mode === 'offline' || mode === 'collab-offline' || mode === 'internet-offline';
};
module.exports["isOfflineMode"] = $8c9ff4e069cde4e8$export$a73e10b357da8876;

});

parcelRegister("7CFSN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");

const $9cc40c72d93227c2$export$671f8dfe06a9af10 = (components, parentKey)=>components.filter((component)=>component.parents.some((parent)=>parent.key === parentKey)).sort((a, b)=>(a.parents.find((p)=>p.key === parentKey)?.rank || 0) - (b.parents.find((p)=>p.key === parentKey)?.rank || 0));
const $9cc40c72d93227c2$export$7fc4381d95dc76c8 = (props)=>null;
const $9cc40c72d93227c2$export$fc1acc9190910d14 = (component)=>{
    return component.type === 'section';
};


const $9f809a1d9d5b659a$var$hasParents = (component)=>{
    return component.type !== 'toolbar';
};
const $9f809a1d9d5b659a$var$getChildTypesForParent = (parentType)=>{
    switch(parentType){
        case 'toolbar':
            return [
                'section'
            ];
        case 'section':
            return [
                'group'
            ];
        case 'group':
            return [
                'button',
                'menu'
            ];
        case 'menu':
        case 'nested-menu':
            return [
                'menu-section'
            ];
        case 'menu-section':
            return [
                'menu-item',
                'nested-menu'
            ];
        default:
            return [];
    }
};
const $9f809a1d9d5b659a$var$getFallbackComponent = (type, fallbacks)=>{
    switch(type){
        case 'group':
            return fallbacks.group;
        case 'menu-section':
            return fallbacks.menuSection;
        case 'section':
            return fallbacks.section;
        default:
            return 0, $9cc40c72d93227c2$export$7fc4381d95dc76c8;
    }
};
const $9f809a1d9d5b659a$var$hasMenuItems = (menuSections, allComponents)=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_toolbar_hide_overflow_menu', 'isEnabled', true)) return menuSections.some((menuSection)=>{
        return allComponents.some((component)=>{
            return component.type === 'menu-item' && component.parents.some((parent)=>parent.key === menuSection.key) && (!('isHidden' in component) || !component.isHidden?.());
        });
    });
    return menuSections.some((menuSection)=>{
        return allComponents.some((component)=>component.type === 'menu-item' && component.parents.some((parent)=>parent.key === menuSection.key));
    });
};
const $9f809a1d9d5b659a$var$shouldHideEmptyComponent = (component, children, allComponents)=>{
    if (component.type === 'menu') {
        const menuSections = children.filter((child)=>child.type === 'menu-section');
        return menuSections.length === 0 || !$9f809a1d9d5b659a$var$hasMenuItems(menuSections, allComponents);
    }
    if (component.type === 'group' || component.type === 'nested-menu' || component.type === 'menu-section') return children.length === 0;
    return false;
};
const $9f809a1d9d5b659a$var$ComponentRenderer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { component: component, parents: parents, allComponents: allComponents, fallbacks: fallbacks } = t0;
    let T0;
    let t1;
    let t2;
    let t3;
    if ($[0] !== allComponents || $[1] !== component || $[2] !== fallbacks || $[3] !== parents) {
        t3 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const childTypes = $9f809a1d9d5b659a$var$getChildTypesForParent(component.type);
            const children = (0, $9cc40c72d93227c2$export$671f8dfe06a9af10)(allComponents.filter((comp)=>childTypes.includes(comp.type)), component.key);
            if ($9f809a1d9d5b659a$var$shouldHideEmptyComponent(component, children, allComponents)) {
                t3 = null;
                break bb0;
            }
            let t4;
            if ($[8] !== component.component || $[9] !== component.type || $[10] !== fallbacks) {
                t4 = component.component || $9f809a1d9d5b659a$var$getFallbackComponent(component.type, fallbacks);
                $[8] = component.component;
                $[9] = component.type;
                $[10] = fallbacks;
                $[11] = t4;
            } else t4 = $[11];
            const Component = t4;
            let t5;
            if ($[12] !== component.key || $[13] !== component.type) {
                t5 = {
                    key: component.key,
                    type: component.type
                };
                $[12] = component.key;
                $[13] = component.type;
                $[14] = t5;
            } else t5 = $[14];
            let t6;
            if ($[15] !== parents || $[16] !== t5) {
                t6 = [
                    ...parents,
                    t5
                ];
                $[15] = parents;
                $[16] = t5;
                $[17] = t6;
            } else t6 = $[17];
            const newParents = t6;
            if (children.length === 0) {
                let t7;
                if ($[18] !== Component || $[19] !== parents) {
                    t7 = /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                        parents: parents,
                        children: null
                    });
                    $[18] = Component;
                    $[19] = parents;
                    $[20] = t7;
                } else t7 = $[20];
                t3 = t7;
                break bb0;
            }
            T0 = Component;
            t1 = parents;
            let t7;
            if ($[21] !== allComponents || $[22] !== fallbacks || $[23] !== newParents) {
                t7 = (child)=>/*#__PURE__*/ (0, $8aG6j.jsx)($9f809a1d9d5b659a$var$ComponentRenderer, {
                        component: child,
                        parents: newParents,
                        allComponents: allComponents,
                        fallbacks: fallbacks
                    }, child.key);
                $[21] = allComponents;
                $[22] = fallbacks;
                $[23] = newParents;
                $[24] = t7;
            } else t7 = $[24];
            t2 = children.map(t7);
        }
        $[0] = allComponents;
        $[1] = component;
        $[2] = fallbacks;
        $[3] = parents;
        $[4] = T0;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else {
        T0 = $[4];
        t1 = $[5];
        t2 = $[6];
        t3 = $[7];
    }
    if (t3 !== Symbol.for("react.early_return_sentinel")) return t3;
    let t4;
    if ($[25] !== T0 || $[26] !== t1 || $[27] !== t2) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)(T0, {
            parents: t1,
            children: t2
        });
        $[25] = T0;
        $[26] = t1;
        $[27] = t2;
        $[28] = t4;
    } else t4 = $[28];
    return t4;
} : ({ component: component, parents: parents, allComponents: allComponents, fallbacks: fallbacks })=>{
    const childTypes = $9f809a1d9d5b659a$var$getChildTypesForParent(component.type);
    const children = (0, $9cc40c72d93227c2$export$671f8dfe06a9af10)(// eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    allComponents.filter((comp)=>childTypes.includes(comp.type)), component.key);
    if ($9f809a1d9d5b659a$var$shouldHideEmptyComponent(component, children, allComponents)) return null;
    const Component = component.component || $9f809a1d9d5b659a$var$getFallbackComponent(component.type, fallbacks);
    const newParents = [
        ...parents,
        {
            key: component.key,
            type: component.type
        }
    ];
    if (children.length === 0) return /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
        parents: parents,
        children: null
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
        parents: parents,
        children: children.map((child)=>/*#__PURE__*/ (0, $8aG6j.jsx)($9f809a1d9d5b659a$var$ComponentRenderer, {
                component: child,
                parents: newParents,
                allComponents: allComponents,
                fallbacks: fallbacks
            }, child.key))
    });
};
const $9f809a1d9d5b659a$export$9ceb2742df82af54 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { toolbar: toolbar, components: components, fallbacks: fallbacks } = t0;
    const ToolbarComponent = toolbar.component || (0, $9cc40c72d93227c2$export$7fc4381d95dc76c8);
    let T0;
    let t1;
    if ($[0] !== ToolbarComponent || $[1] !== components || $[2] !== fallbacks || $[3] !== toolbar.key || $[4] !== toolbar.type) {
        const sections = (0, $9cc40c72d93227c2$export$671f8dfe06a9af10)(components.filter((0, $9cc40c72d93227c2$export$fc1acc9190910d14)), toolbar.key);
        T0 = ToolbarComponent;
        let t2;
        if ($[7] !== components || $[8] !== fallbacks || $[9] !== toolbar.key || $[10] !== toolbar.type) {
            t2 = (section)=>/*#__PURE__*/ (0, $8aG6j.jsx)($9f809a1d9d5b659a$var$ComponentRenderer, {
                    component: section,
                    parents: [
                        {
                            key: toolbar.key,
                            type: toolbar.type
                        }
                    ],
                    allComponents: components.filter($9f809a1d9d5b659a$var$hasParents),
                    fallbacks: fallbacks
                }, section.key);
            $[7] = components;
            $[8] = fallbacks;
            $[9] = toolbar.key;
            $[10] = toolbar.type;
            $[11] = t2;
        } else t2 = $[11];
        t1 = sections.map(t2);
        $[0] = ToolbarComponent;
        $[1] = components;
        $[2] = fallbacks;
        $[3] = toolbar.key;
        $[4] = toolbar.type;
        $[5] = T0;
        $[6] = t1;
    } else {
        T0 = $[5];
        t1 = $[6];
    }
    let t2;
    if ($[12] !== T0 || $[13] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)(T0, {
            children: t1
        });
        $[12] = T0;
        $[13] = t1;
        $[14] = t2;
    } else t2 = $[14];
    return t2;
} : ({ toolbar: toolbar, components: components, fallbacks: fallbacks })=>{
    const ToolbarComponent = toolbar.component || (0, $9cc40c72d93227c2$export$7fc4381d95dc76c8);
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    const sections = (0, $9cc40c72d93227c2$export$671f8dfe06a9af10)(components.filter((0, $9cc40c72d93227c2$export$fc1acc9190910d14)), toolbar.key);
    return /*#__PURE__*/ (0, $8aG6j.jsx)(ToolbarComponent, {
        children: sections.map((section)=>/*#__PURE__*/ (0, $8aG6j.jsx)($9f809a1d9d5b659a$var$ComponentRenderer, {
                component: section,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                parents: [
                    {
                        key: toolbar.key,
                        type: toolbar.type
                    }
                ],
                // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
                allComponents: components.filter($9f809a1d9d5b659a$var$hasParents),
                fallbacks: fallbacks
            }, section.key))
    });
};
module.exports["ToolbarModelRenderer"] = $9f809a1d9d5b659a$export$9ceb2742df82af54;

});

parcelRegister("3nacY", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $34f45584b76b3dfc$export$cc1c18c6e6b6ecaf = {
    INLINE_TEXT_TOOLBAR: 'inline-text-toolbar',
    PRIMARY_TOOLBAR: 'primary-toolbar'
};
const $34f45584b76b3dfc$export$78ec0124ca63fa02 = {
    key: 'ai-section',
    type: 'section'
};
const $34f45584b76b3dfc$export$124d2ee606ccdfdc = {
    key: 'ai-view-section',
    type: 'section'
};
const $34f45584b76b3dfc$export$6d5407fbb0bc912e = {
    key: 'ai-section-primary-toolbar',
    type: 'section'
};
const $34f45584b76b3dfc$export$ea53d97c37cdede3 = {
    key: 'ai-section-full-page-primary-toolbar',
    type: 'section'
};
const $34f45584b76b3dfc$export$dcbeb7730f347566 = {
    key: 'ai-section-comment-primary-toolbar',
    type: 'section'
};
const $34f45584b76b3dfc$export$ab61657fb37116be = {
    key: 'rovo-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$b0e50b17917e2523 = {
    key: 'rovo-group-view',
    type: 'group'
};
const $34f45584b76b3dfc$export$67ae7e5d398cd98 = {
    key: 'rovo-group-primary-toolbar',
    type: 'group'
};
const $34f45584b76b3dfc$export$393a27a1587c4748 = {
    key: 'rovo-group-display-small',
    type: 'group'
};
const $34f45584b76b3dfc$export$164a0130b2b649c6 = {
    key: 'improve-writing-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$e7c291289ee98d9 = {
    key: 'improve-writing-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$50fb6fd780a8da5a = {
    key: 'hero-prompt-button-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$6ea8ae73b826b63e = {
    key: 'hero-prompt-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$3d823cd1493e8383 = {
    key: 'rovo-hero-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$bc3c6b8bbdf543d6 = {
    key: 'rovo-write-button-primary-toolbar',
    type: 'button'
};
const $34f45584b76b3dfc$export$4532eefb6fdb660c = {
    key: 'rovo-menu',
    type: 'menu'
};
const $34f45584b76b3dfc$export$245b51779748026d = {
    key: 'rovo-menu-display-small',
    type: 'menu'
};
const $34f45584b76b3dfc$export$f157764a2d8d74e6 = {
    key: 'rovo-prompt-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$8be015e65f184637 = {
    key: 'rovo-prompt-menu-section-display-small',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$c9c5b3ece9aa9724 = {
    key: 'improve-writing-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$1ede5932cecaa59 = {
    key: 'hero-prompt-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$4799f439258ea378 = {
    key: 'make-shorter-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$b82c17edba0c6a9e = {
    key: 'make-longer-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$1356bd5d76f7fc4 = {
    key: 'change-tone-nested-menu',
    type: 'nested-menu'
};
const $34f45584b76b3dfc$export$ba297ac76e077190 = {
    key: 'spelling-and-grammar-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$86a7882cf39bf1df = {
    key: 'change-tone-default-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$d868febccc6870c7 = {
    key: 'more-professional-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$4a7c57dd33fc4a14 = {
    key: 'more-casual-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$3758b89123aa4456 = {
    key: 'more-empathetic-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$76118e0d25ac1fef = {
    key: 'translate-nested-menu',
    type: 'nested-menu'
};
const $34f45584b76b3dfc$export$a526b8293dafd11c = {
    key: 'translate-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$5836877aa3028c9d = {
    key: 'define-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$92f779590a87713f = {
    key: 'define-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$8bfe594eeaed8635 = {
    key: 'define-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$8d0a77a358b8b557 = {
    key: 'add-polish-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$b60b22005cb1946b = {
    key: 'ai-suggestions-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$3c6ba64af5b24c36 = {
    key: 'ai-suggestions-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$46f6ca06869869c = {
    key: 'text-section',
    type: 'section'
};
const $34f45584b76b3dfc$export$9821adc8accbec40 = {
    key: 'text-section-primary-toolbar',
    type: 'section'
};
const $34f45584b76b3dfc$export$65db33ca2d38a784 = {
    key: 'text-section-collapsed',
    type: 'section'
};
const $34f45584b76b3dfc$export$dbb8e55d66b9ce7c = {
    key: 'text-collapsed-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$50e256f5fa0723b1 = {
    key: 'text-collapsed-menu',
    type: 'menu'
};
const $34f45584b76b3dfc$export$17de14a70389be62 = {
    key: 'text-styles-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$e3c7868e9e7f30f = {
    key: 'text-styles-menu',
    type: 'menu'
};
const $34f45584b76b3dfc$export$61c471f0e406c6cd = {
    key: 'text-styles-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$a0d395bab4f77bed = {
    key: 'normal-text-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$e01e7ae5367e3f41 = {
    key: 'small-text-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$2469e8506da598d3 = {
    key: 'heading-1-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$a065aede28a4fa60 = {
    key: 'heading-2-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$85070b7c6d42e3bb = {
    key: 'heading-3-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$e78c2531f67b545f = {
    key: 'heading-4-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$a92294de346392be = {
    key: 'heading-5-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$9c3cdc8e6d51ce82 = {
    key: 'heading-6-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$f4b89f87980eb537 = {
    key: 'block-quote-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$acdcd8bfebadff8e = {
    key: 'text-formatting-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$3efe78988280adb3 = {
    key: 'text-formatting-group-collapsed',
    type: 'group'
};
const $34f45584b76b3dfc$export$d709b777a6a93241 = {
    key: 'text-formatting-group-inline',
    type: 'group'
};
const $34f45584b76b3dfc$export$e54b89ebe974229a = {
    key: 'bold-button-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$eb8680bccd13ec29 = {
    key: 'underline-button-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$b1308631b6ed4b3 = {
    key: 'text-formatting-hero-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$1f2df85e05c78a28 = {
    key: 'text-formatting-hero-button-collapsed',
    type: 'button'
};
const $34f45584b76b3dfc$export$512cce888b603a21 = {
    key: 'bold-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$8ba429f81350a9a5 = {
    key: 'underline-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$6ed8e5719ec9c8ca = {
    key: 'text-formatting-menu',
    type: 'menu'
};
const $34f45584b76b3dfc$export$8bc14fdbfc88e3d = {
    key: 'bold-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$55cababf49d70434 = {
    key: 'italic-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$74aa4c917d0fb179 = {
    key: 'underline-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$9caef6162846aa5f = {
    key: 'strike-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$33821ea6eceb9d13 = {
    key: 'code-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$ee8cb7d7ef764bfe = {
    key: 'subscript-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$85ead1ec02f87839 = {
    key: 'superscript-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$6f16936b77c05f44 = {
    key: 'text-formatting-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$2d7a9246359565f = {
    key: 'clear-formatting-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$2577e452f5468087 = {
    key: 'clear-formatting-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$eb99509879c4d1a6 = {
    key: 'text-color-highlight-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$126ef012ef4d8c5f = {
    key: 'text-color-highlight-menu',
    type: 'menu'
};
const $34f45584b76b3dfc$export$70638f1e77085913 = {
    key: 'text-color-highlight-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$ebd1271b08f151b0 = {
    key: 'text-color-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$bae2fe42c2b86102 = {
    key: 'highlight-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$267f9526bd36c2c = {
    key: 'clear-color-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$97870c389b03ef61 = {
    key: 'color-accessibility-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$36cf1d476157a47d = {
    key: 'alignment-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$b9d75d8ec913c411 = {
    key: 'alignment-menu',
    type: 'menu'
};
const $34f45584b76b3dfc$export$a7d30f7c1c00dd6e = {
    key: 'alignment-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$fb5e83c02abc1116 = {
    key: 'align-left-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$920b9c1f02074883 = {
    key: 'align-center-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$77c582b2c8fa437c = {
    key: 'align-right-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$cfa2bcff371b7719 = {
    key: 'lists-indentation-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$e24e846ad969dbb4 = {
    key: 'lists-indentation-group-collapsed',
    type: 'group'
};
const $34f45584b76b3dfc$export$18e3c58ea662f7ad = {
    key: 'lists-indentation-group-inline',
    type: 'group'
};
const $34f45584b76b3dfc$export$93963c53c29fc835 = {
    key: 'bullet-list-button-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$6c8387a14e0128fe = {
    key: 'bullet-list-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$f625e29dbd38e447 = {
    key: 'lists-indentation-hero-button-collapsed',
    type: 'button'
};
const $34f45584b76b3dfc$export$8709d937e93456c5 = {
    key: 'lists-indentation-hero-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$77b7fc28d250a53f = {
    key: 'lists-indentation-menu',
    type: 'menu'
};
const $34f45584b76b3dfc$export$21a99ac537934e71 = {
    key: 'lists-indendation-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$fc39a5dc74747fed = {
    key: 'bullet-list-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$9d64032e4ea1097c = {
    key: 'numbered-list-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$d6bac99c24b8cdfd = {
    key: 'task-list-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$87678574248a0249 = {
    key: 'indent-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$8fc4080aa2f8adc2 = {
    key: 'outdent-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$8be58f85d6f2b208 = {
    key: 'insert-block-section',
    type: 'section'
};
const $34f45584b76b3dfc$export$a55d93db15cde50c = {
    key: 'code-block-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$22d0f50f2ec2f1a8 = {
    key: 'code-block-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$6265c903e79c43eb = {
    key: 'task-list-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$9634f504f88ede38 = {
    key: 'task-list-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$ce4671f9066f5c48 = {
    key: 'media-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$37025ad4bfe1d2aa = {
    key: 'media-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$f4c921ea7ce3d48a = {
    key: 'mention-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$450b9a588cdf3949 = {
    key: 'mention-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$6ca7976638436c6 = {
    key: 'emoji-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$a4310034b096a4ad = {
    key: 'emoji-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$f746b10bd135ebe5 = {
    key: 'layout-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$bc099bce567fd020 = {
    key: 'layout-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$19b0175d8da45496 = {
    key: 'table-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$c37ae5d099679682 = {
    key: 'table-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$c796ec87818935d5 = {
    key: 'table-size-picker',
    type: 'button'
};
const $34f45584b76b3dfc$export$2db6abe323bf312e = {
    key: 'insert-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$2b79c1387bf4ea1b = {
    key: 'insert-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$1fc1401e9e5d8a = {
    key: 'linking-section',
    type: 'section'
};
const $34f45584b76b3dfc$export$87f2f2ff3eb62f79 = {
    key: 'linking-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$3d214445dcf942f2 = {
    key: 'linking-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$8d13eb2ec1e19466 = {
    key: 'synced-block-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$f7a124e17ae9698f = {
    key: 'synced-block-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$796e931612f154e7 = {
    key: 'synced-block-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$457818231baddd40 = {
    key: 'collab-section',
    type: 'section'
};
const $34f45584b76b3dfc$export$8978fe8e689744cc = {
    key: 'comment-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$f97beb46382b3388 = {
    key: 'comment-hero-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$d757fc54a1831d82 = {
    key: 'apps-section',
    type: 'section'
};
const $34f45584b76b3dfc$export$c3f44bc1025dceb2 = {
    key: 'track-changes-section',
    type: 'section'
};
const $34f45584b76b3dfc$export$b3d4f2cdc057cba1 = {
    key: 'undo-changes-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$f13c32a4c68c0806 = {
    key: 'undo-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$e149a5154bb9b44 = {
    key: 'redo-changes-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$1fb249ec6ca34dd0 = {
    key: 'redo-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$8e3cd3ec14c6efc = {
    key: 'track-changes-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$9cfd2622f07061e0 = {
    key: 'track-changes-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$cb18e5ae740a3f22 = {
    key: 'overflow-section',
    type: 'section'
};
const $34f45584b76b3dfc$export$932f82408ad2af53 = {
    key: 'overflow-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$6583eb3a2765795b = {
    key: 'overflow-menu',
    type: 'menu'
};
const $34f45584b76b3dfc$export$cefae60670d357d0 = {
    key: 'pin-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$76d22fa71bc28346 = {
    key: 'pin-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$1b5ea0d5074f7d18 = {
    key: 'overflow-section-primary-toolbar',
    type: 'section'
};
const $34f45584b76b3dfc$export$a481b12c04259be8 = {
    key: 'overflow-group-primary-toolbar',
    type: 'group'
};
const $34f45584b76b3dfc$export$b0bb124d5687709e = {
    key: 'overflow-menu-primary-toolbar',
    type: 'menu'
};
const $34f45584b76b3dfc$export$6d497f3df1049a22 = {
    key: 'pin-section',
    type: 'section'
};
const $34f45584b76b3dfc$export$762436e7516a2365 = {
    key: 'pin-group',
    type: 'group'
};
const $34f45584b76b3dfc$export$cfefbb6355b14379 = {
    key: 'pin-button',
    type: 'button'
};
const $34f45584b76b3dfc$export$68f7a2de17e9e39d = {
    key: 'view-mode-toggle-section',
    type: 'section'
};
const $34f45584b76b3dfc$export$dd76f40d6548a654 = {
    key: 'loom-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$4ac3fd1884a40118 = {
    key: 'loom-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$debff7788300c3ff = {
    key: 'selection-extension-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$3752412f1cf2bc0e = {
    key: 'overflow-extensions-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$41bea16b66da911 = {
    key: 'first-party-extensions-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$4b664282d7b95d2c = {
    key: 'external-extensions-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$b4e8aaf730259f83 = {
    key: 'paste-menu',
    type: 'menu'
};
const $34f45584b76b3dfc$export$76da35b5d1c35bbe = {
    key: 'paste-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$5646e8ff118a2c3f = {
    key: 'paste-nested-menu',
    type: 'nested-menu'
};
const $34f45584b76b3dfc$export$4a6eb83eeeb712a = {
    key: 'paste-menu-nested-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$7528e3cffa17b456 = {
    key: 'rich-text-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$d10c0f4ac46a1253 = {
    key: 'markdown-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$ef2727de8c063819 = {
    key: 'plain-text-menu-item',
    type: 'menu-item'
};
const $34f45584b76b3dfc$export$4d6ba29b72804f46 = {
    key: 'ai-paste-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$fe45b268a1e660de = {
    key: 'smart-link-display-as-paste-menu-section',
    type: 'menu-section'
};
const $34f45584b76b3dfc$export$7897566b2299aaf5 = {
    INSERT: 'editor-toolbar-insert-button',
    EMOJI: 'editor-toolbar-emoji-button',
    IMAGE: 'editor-toolbar-image-button',
    MEDIA: 'editor-toolbar-media-button',
    TABLE: 'Table',
    // Keep original value to avoid breaking existing tests
    TABLE_SELECTOR: 'editor-toolbar-table-selector-button',
    MENTION: 'editor-toolbar-mention-button',
    LAYOUT: 'editor-toolbar-layout-button',
    TASK_LIST: 'editor-toolbar-task-list-button'
};
module.exports["TOOLBARS"] = $34f45584b76b3dfc$export$cc1c18c6e6b6ecaf;
module.exports["AI_SECTION"] = $34f45584b76b3dfc$export$78ec0124ca63fa02;
module.exports["AI_VIEW_SECTION"] = $34f45584b76b3dfc$export$124d2ee606ccdfdc;
module.exports["AI_SECTION_PRIMARY_TOOLBAR"] = $34f45584b76b3dfc$export$6d5407fbb0bc912e;
module.exports["AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR"] = $34f45584b76b3dfc$export$ea53d97c37cdede3;
module.exports["AI_SECTION_COMMENT_PRIMARY_TOOLBAR"] = $34f45584b76b3dfc$export$dcbeb7730f347566;
module.exports["ROVO_GROUP"] = $34f45584b76b3dfc$export$ab61657fb37116be;
module.exports["ROVO_GROUP_VIEW"] = $34f45584b76b3dfc$export$b0e50b17917e2523;
module.exports["ROVO_GROUP_PRIMARY_TOOLBAR"] = $34f45584b76b3dfc$export$67ae7e5d398cd98;
module.exports["ROVO_GROUP_DISPLAY_SMALL"] = $34f45584b76b3dfc$export$393a27a1587c4748;
module.exports["IMPROVE_WRITING_GROUP"] = $34f45584b76b3dfc$export$164a0130b2b649c6;
module.exports["IMPROVE_WRITING_BUTTON"] = $34f45584b76b3dfc$export$e7c291289ee98d9;
module.exports["HERO_PROMPT_BUTTON_GROUP"] = $34f45584b76b3dfc$export$50fb6fd780a8da5a;
module.exports["HERO_PROMPT_BUTTON"] = $34f45584b76b3dfc$export$6ea8ae73b826b63e;
module.exports["ROVO_HERO_BUTTON"] = $34f45584b76b3dfc$export$3d823cd1493e8383;
module.exports["ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR"] = $34f45584b76b3dfc$export$bc3c6b8bbdf543d6;
module.exports["ROVO_MENU"] = $34f45584b76b3dfc$export$4532eefb6fdb660c;
module.exports["ROVO_MENU_DISPLAY_SMALL"] = $34f45584b76b3dfc$export$245b51779748026d;
module.exports["ROVO_PROMPT_MENU_SECTION"] = $34f45584b76b3dfc$export$f157764a2d8d74e6;
module.exports["ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL"] = $34f45584b76b3dfc$export$8be015e65f184637;
module.exports["IMPROVE_WRITING_MENU_ITEM"] = $34f45584b76b3dfc$export$c9c5b3ece9aa9724;
module.exports["HERO_PROMPT_MENU_ITEM"] = $34f45584b76b3dfc$export$1ede5932cecaa59;
module.exports["MAKE_SHORTER_MENU_ITEM"] = $34f45584b76b3dfc$export$4799f439258ea378;
module.exports["MAKE_LONGER_MENU_ITEM"] = $34f45584b76b3dfc$export$b82c17edba0c6a9e;
module.exports["CHANGE_TONE_NESTED_MENU"] = $34f45584b76b3dfc$export$1356bd5d76f7fc4;
module.exports["SPELLING_AND_GRAMMAR_MENU_ITEM"] = $34f45584b76b3dfc$export$ba297ac76e077190;
module.exports["CHANGE_TONE_MENU_SECTION"] = $34f45584b76b3dfc$export$86a7882cf39bf1df;
module.exports["MORE_PROFESSIONAL_MENU_ITEM"] = $34f45584b76b3dfc$export$d868febccc6870c7;
module.exports["MORE_CASUAL_MENU_ITEM"] = $34f45584b76b3dfc$export$4a7c57dd33fc4a14;
module.exports["MORE_EMPATHETIC_MENU_ITEM"] = $34f45584b76b3dfc$export$3758b89123aa4456;
module.exports["TRANSLATE_NESTED_MENU"] = $34f45584b76b3dfc$export$76118e0d25ac1fef;
module.exports["TRANSLATE_MENU_SECTION"] = $34f45584b76b3dfc$export$a526b8293dafd11c;
module.exports["DEFINE_MENU_ITEM"] = $34f45584b76b3dfc$export$5836877aa3028c9d;
module.exports["DEFINE_GROUP"] = $34f45584b76b3dfc$export$92f779590a87713f;
module.exports["DEFINE_BUTTON"] = $34f45584b76b3dfc$export$8bfe594eeaed8635;
module.exports["ADD_POLISH_MENU_ITEM"] = $34f45584b76b3dfc$export$8d0a77a358b8b557;
module.exports["AI_SUGGESTIONS_GROUP"] = $34f45584b76b3dfc$export$b60b22005cb1946b;
module.exports["AI_SUGGESTIONS_BUTTON"] = $34f45584b76b3dfc$export$3c6ba64af5b24c36;
module.exports["TEXT_SECTION"] = $34f45584b76b3dfc$export$46f6ca06869869c;
module.exports["TEXT_SECTION_PRIMARY_TOOLBAR"] = $34f45584b76b3dfc$export$9821adc8accbec40;
module.exports["TEXT_SECTION_COLLAPSED"] = $34f45584b76b3dfc$export$65db33ca2d38a784;
module.exports["TEXT_COLLAPSED_GROUP"] = $34f45584b76b3dfc$export$dbb8e55d66b9ce7c;
module.exports["TEXT_COLLAPSED_MENU"] = $34f45584b76b3dfc$export$50e256f5fa0723b1;
module.exports["TEXT_STYLES_GROUP"] = $34f45584b76b3dfc$export$17de14a70389be62;
module.exports["TEXT_STYLES_MENU"] = $34f45584b76b3dfc$export$e3c7868e9e7f30f;
module.exports["TEXT_STYLES_MENU_SECTION"] = $34f45584b76b3dfc$export$61c471f0e406c6cd;
module.exports["NORMAL_TEXT_MENU_ITEM"] = $34f45584b76b3dfc$export$a0d395bab4f77bed;
module.exports["SMALL_TEXT_MENU_ITEM"] = $34f45584b76b3dfc$export$e01e7ae5367e3f41;
module.exports["HEADING_1_MENU_ITEM"] = $34f45584b76b3dfc$export$2469e8506da598d3;
module.exports["HEADING_2_MENU_ITEM"] = $34f45584b76b3dfc$export$a065aede28a4fa60;
module.exports["HEADING_3_MENU_ITEM"] = $34f45584b76b3dfc$export$85070b7c6d42e3bb;
module.exports["HEADING_4_MENU_ITEM"] = $34f45584b76b3dfc$export$e78c2531f67b545f;
module.exports["HEADING_5_MENU_ITEM"] = $34f45584b76b3dfc$export$a92294de346392be;
module.exports["HEADING_6_MENU_ITEM"] = $34f45584b76b3dfc$export$9c3cdc8e6d51ce82;
module.exports["BLOCK_QUOTE_MENU_ITEM"] = $34f45584b76b3dfc$export$f4b89f87980eb537;
module.exports["TEXT_FORMATTING_GROUP"] = $34f45584b76b3dfc$export$acdcd8bfebadff8e;
module.exports["TEXT_FORMATTING_GROUP_COLLAPSED"] = $34f45584b76b3dfc$export$3efe78988280adb3;
module.exports["TEXT_FORMATTING_GROUP_INLINE"] = $34f45584b76b3dfc$export$d709b777a6a93241;
module.exports["BOLD_BUTTON_GROUP"] = $34f45584b76b3dfc$export$e54b89ebe974229a;
module.exports["UNDERLINE_BUTTON_GROUP"] = $34f45584b76b3dfc$export$eb8680bccd13ec29;
module.exports["TEXT_FORMATTING_HERO_BUTTON"] = $34f45584b76b3dfc$export$b1308631b6ed4b3;
module.exports["TEXT_FORMATTING_HERO_BUTTON_COLLAPSED"] = $34f45584b76b3dfc$export$1f2df85e05c78a28;
module.exports["BOLD_BUTTON"] = $34f45584b76b3dfc$export$512cce888b603a21;
module.exports["UNDERLINE_BUTTON"] = $34f45584b76b3dfc$export$8ba429f81350a9a5;
module.exports["TEXT_FORMATTING_MENU"] = $34f45584b76b3dfc$export$6ed8e5719ec9c8ca;
module.exports["BOLD_MENU_ITEM"] = $34f45584b76b3dfc$export$8bc14fdbfc88e3d;
module.exports["ITALIC_MENU_ITEM"] = $34f45584b76b3dfc$export$55cababf49d70434;
module.exports["UNDERLINE_MENU_ITEM"] = $34f45584b76b3dfc$export$74aa4c917d0fb179;
module.exports["STRIKE_MENU_ITEM"] = $34f45584b76b3dfc$export$9caef6162846aa5f;
module.exports["CODE_MENU_ITEM"] = $34f45584b76b3dfc$export$33821ea6eceb9d13;
module.exports["SUBSCRIPT_MENU_ITEM"] = $34f45584b76b3dfc$export$ee8cb7d7ef764bfe;
module.exports["SUPERSCRIPT_MENU_ITEM"] = $34f45584b76b3dfc$export$85ead1ec02f87839;
module.exports["TEXT_FORMATTING_MENU_SECTION"] = $34f45584b76b3dfc$export$6f16936b77c05f44;
module.exports["CLEAR_FORMARTTING_MENU_SECTION"] = $34f45584b76b3dfc$export$2d7a9246359565f;
module.exports["CLEAR_FORMATTING_MENU_ITEM"] = $34f45584b76b3dfc$export$2577e452f5468087;
module.exports["TEXT_COLOR_HIGHLIGHT_GROUP"] = $34f45584b76b3dfc$export$eb99509879c4d1a6;
module.exports["TEXT_COLOR_HIGHLIGHT_MENU"] = $34f45584b76b3dfc$export$126ef012ef4d8c5f;
module.exports["TEXT_COLOR_HIGHLIGHT_MENU_SECTION"] = $34f45584b76b3dfc$export$70638f1e77085913;
module.exports["TEXT_COLOR_MENU_ITEM"] = $34f45584b76b3dfc$export$ebd1271b08f151b0;
module.exports["HIGHLIGHT_MENU_ITEM"] = $34f45584b76b3dfc$export$bae2fe42c2b86102;
module.exports["CLEAR_COLOR_MENU_ITEM"] = $34f45584b76b3dfc$export$267f9526bd36c2c;
module.exports["COLOR_ACCESSIBILITY_MENU_ITEM"] = $34f45584b76b3dfc$export$97870c389b03ef61;
module.exports["ALIGNMENT_GROUP"] = $34f45584b76b3dfc$export$36cf1d476157a47d;
module.exports["ALIGNMENT_MENU"] = $34f45584b76b3dfc$export$b9d75d8ec913c411;
module.exports["ALIGNMENT_MENU_SECTION"] = $34f45584b76b3dfc$export$a7d30f7c1c00dd6e;
module.exports["ALIGN_LEFT_MENU_ITEM"] = $34f45584b76b3dfc$export$fb5e83c02abc1116;
module.exports["ALIGN_CENTER_MENU_ITEM"] = $34f45584b76b3dfc$export$920b9c1f02074883;
module.exports["ALIGN_RIGHT_MENU_ITEM"] = $34f45584b76b3dfc$export$77c582b2c8fa437c;
module.exports["LISTS_INDENTATION_GROUP"] = $34f45584b76b3dfc$export$cfa2bcff371b7719;
module.exports["LISTS_INDENTATION_GROUP_COLLAPSED"] = $34f45584b76b3dfc$export$e24e846ad969dbb4;
module.exports["LISTS_INDENTATION_GROUP_INLINE"] = $34f45584b76b3dfc$export$18e3c58ea662f7ad;
module.exports["BULLETED_LIST_BUTTON_GROUP"] = $34f45584b76b3dfc$export$93963c53c29fc835;
module.exports["BULLETED_LIST_BUTTON"] = $34f45584b76b3dfc$export$6c8387a14e0128fe;
module.exports["LISTS_INDENTATION_HERO_BUTTON_COLLAPSED"] = $34f45584b76b3dfc$export$f625e29dbd38e447;
module.exports["LISTS_INDENTATION_HERO_BUTTON"] = $34f45584b76b3dfc$export$8709d937e93456c5;
module.exports["LISTS_INDENTATION_MENU"] = $34f45584b76b3dfc$export$77b7fc28d250a53f;
module.exports["LISTS_INDENTATION_MENU_SECTION"] = $34f45584b76b3dfc$export$21a99ac537934e71;
module.exports["BULLETED_LIST_MENU_ITEM"] = $34f45584b76b3dfc$export$fc39a5dc74747fed;
module.exports["NUMBERED_LIST_MENU_ITEM"] = $34f45584b76b3dfc$export$9d64032e4ea1097c;
module.exports["TASK_LIST_MENU_ITEM"] = $34f45584b76b3dfc$export$d6bac99c24b8cdfd;
module.exports["INDENT_MENU_ITEM"] = $34f45584b76b3dfc$export$87678574248a0249;
module.exports["OUTDENT_MENU_ITEM"] = $34f45584b76b3dfc$export$8fc4080aa2f8adc2;
module.exports["INSERT_BLOCK_SECTION"] = $34f45584b76b3dfc$export$8be58f85d6f2b208;
module.exports["CODE_BLOCK_GROUP"] = $34f45584b76b3dfc$export$a55d93db15cde50c;
module.exports["CODE_BLOCK_BUTTON"] = $34f45584b76b3dfc$export$22d0f50f2ec2f1a8;
module.exports["TASK_LIST_GROUP"] = $34f45584b76b3dfc$export$6265c903e79c43eb;
module.exports["TASK_LIST_BUTTON"] = $34f45584b76b3dfc$export$9634f504f88ede38;
module.exports["MEDIA_GROUP"] = $34f45584b76b3dfc$export$ce4671f9066f5c48;
module.exports["MEDIA_BUTTON"] = $34f45584b76b3dfc$export$37025ad4bfe1d2aa;
module.exports["MENTION_GROUP"] = $34f45584b76b3dfc$export$f4c921ea7ce3d48a;
module.exports["MENTION_BUTTON"] = $34f45584b76b3dfc$export$450b9a588cdf3949;
module.exports["EMOJI_GROUP"] = $34f45584b76b3dfc$export$6ca7976638436c6;
module.exports["EMOJI_BUTTON"] = $34f45584b76b3dfc$export$a4310034b096a4ad;
module.exports["LAYOUT_GROUP"] = $34f45584b76b3dfc$export$f746b10bd135ebe5;
module.exports["LAYOUT_BUTTON"] = $34f45584b76b3dfc$export$bc099bce567fd020;
module.exports["TABLE_GROUP"] = $34f45584b76b3dfc$export$19b0175d8da45496;
module.exports["TABLE_BUTTON"] = $34f45584b76b3dfc$export$c37ae5d099679682;
module.exports["TABLE_SIZE_PICKER"] = $34f45584b76b3dfc$export$c796ec87818935d5;
module.exports["INSERT_GROUP"] = $34f45584b76b3dfc$export$2db6abe323bf312e;
module.exports["INSERT_BUTTON"] = $34f45584b76b3dfc$export$2b79c1387bf4ea1b;
module.exports["LINKING_SECTION"] = $34f45584b76b3dfc$export$1fc1401e9e5d8a;
module.exports["LINKING_GROUP"] = $34f45584b76b3dfc$export$87f2f2ff3eb62f79;
module.exports["LINKING_BUTTON"] = $34f45584b76b3dfc$export$3d214445dcf942f2;
module.exports["SYNCED_BLOCK_GROUP"] = $34f45584b76b3dfc$export$8d13eb2ec1e19466;
module.exports["SYNCED_BLOCK_BUTTON"] = $34f45584b76b3dfc$export$f7a124e17ae9698f;
module.exports["SYNCED_BLOCK_SECTION"] = $34f45584b76b3dfc$export$796e931612f154e7;
module.exports["COLLAB_SECTION"] = $34f45584b76b3dfc$export$457818231baddd40;
module.exports["COMMENT_GROUP"] = $34f45584b76b3dfc$export$8978fe8e689744cc;
module.exports["COMMENT_HERO_BUTTON"] = $34f45584b76b3dfc$export$f97beb46382b3388;
module.exports["APPS_SECTION"] = $34f45584b76b3dfc$export$d757fc54a1831d82;
module.exports["TRACK_CHANGES_SECTION"] = $34f45584b76b3dfc$export$c3f44bc1025dceb2;
module.exports["UNDO_CHANGES_GROUP"] = $34f45584b76b3dfc$export$b3d4f2cdc057cba1;
module.exports["UNDO_BUTTON"] = $34f45584b76b3dfc$export$f13c32a4c68c0806;
module.exports["REDO_CHANGES_GROUP"] = $34f45584b76b3dfc$export$e149a5154bb9b44;
module.exports["REDO_BUTTON"] = $34f45584b76b3dfc$export$1fb249ec6ca34dd0;
module.exports["TRACK_CHANGES_GROUP"] = $34f45584b76b3dfc$export$8e3cd3ec14c6efc;
module.exports["TRACK_CHANGES_BUTTON"] = $34f45584b76b3dfc$export$9cfd2622f07061e0;
module.exports["OVERFLOW_SECTION"] = $34f45584b76b3dfc$export$cb18e5ae740a3f22;
module.exports["OVERFLOW_GROUP"] = $34f45584b76b3dfc$export$932f82408ad2af53;
module.exports["OVERFLOW_MENU"] = $34f45584b76b3dfc$export$6583eb3a2765795b;
module.exports["PIN_MENU_SECTION"] = $34f45584b76b3dfc$export$cefae60670d357d0;
module.exports["PIN_MENU_ITEM"] = $34f45584b76b3dfc$export$76d22fa71bc28346;
module.exports["OVERFLOW_SECTION_PRIMARY_TOOLBAR"] = $34f45584b76b3dfc$export$1b5ea0d5074f7d18;
module.exports["OVERFLOW_GROUP_PRIMARY_TOOLBAR"] = $34f45584b76b3dfc$export$a481b12c04259be8;
module.exports["OVERFLOW_MENU_PRIMARY_TOOLBAR"] = $34f45584b76b3dfc$export$b0bb124d5687709e;
module.exports["PIN_SECTION"] = $34f45584b76b3dfc$export$6d497f3df1049a22;
module.exports["PIN_GROUP"] = $34f45584b76b3dfc$export$762436e7516a2365;
module.exports["PIN_BUTTON"] = $34f45584b76b3dfc$export$cfefbb6355b14379;
module.exports["VIEW_MODE_TOGGLE_SECTION"] = $34f45584b76b3dfc$export$68f7a2de17e9e39d;
module.exports["LOOM_MENU_SECTION"] = $34f45584b76b3dfc$export$dd76f40d6548a654;
module.exports["LOOM_MENU_ITEM"] = $34f45584b76b3dfc$export$4ac3fd1884a40118;
module.exports["SELECTION_EXTENSION_MENU_SECTION"] = $34f45584b76b3dfc$export$debff7788300c3ff;
module.exports["OVERFLOW_EXTENSIONS_MENU_SECTION"] = $34f45584b76b3dfc$export$3752412f1cf2bc0e;
module.exports["FIRST_PARTY_EXTENSIONS_MENU_ITEM"] = $34f45584b76b3dfc$export$41bea16b66da911;
module.exports["EXTERNAL_EXTENSIONS_MENU_ITEM"] = $34f45584b76b3dfc$export$4b664282d7b95d2c;
module.exports["PASTE_MENU"] = $34f45584b76b3dfc$export$b4e8aaf730259f83;
module.exports["PASTE_MENU_SECTION"] = $34f45584b76b3dfc$export$76da35b5d1c35bbe;
module.exports["PASTE_NESTED_MENU"] = $34f45584b76b3dfc$export$5646e8ff118a2c3f;
module.exports["PASTE_MENU_NESTED_SECTION"] = $34f45584b76b3dfc$export$4a6eb83eeeb712a;
module.exports["PASTE_RICH_TEXT_MENU_ITEM"] = $34f45584b76b3dfc$export$7528e3cffa17b456;
module.exports["PASTE_MARKDOWN_MENU_ITEM"] = $34f45584b76b3dfc$export$d10c0f4ac46a1253;
module.exports["PASTE_PLAIN_TEXT_MENU_ITEM"] = $34f45584b76b3dfc$export$ef2727de8c063819;
module.exports["AI_PASTE_MENU_SECTION"] = $34f45584b76b3dfc$export$4d6ba29b72804f46;
module.exports["SMART_LINK_DISPLAY_AS_PASTE_MENU_SECTION"] = $34f45584b76b3dfc$export$fe45b268a1e660de;
module.exports["TOOLBAR_BUTTON_TEST_ID"] = $34f45584b76b3dfc$export$7897566b2299aaf5;

});

parcelRegister("83KD5", function(module, exports) {
const $0c75186bd7c0d6c2$export$75279ffd74fef67b = (component)=>{
    return component?.type === 'toolbar';
};
module.exports["isToolbar"] = $0c75186bd7c0d6c2$export$75279ffd74fef67b;

});

parcelRegister("jZ0wT", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");










const $f41cdd85d6e00006$export$8742d3f42739b0ac = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RenderMarker(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { onRender: onRender } = t0;
    let t1;
    if ($[0] !== onRender) {
        t1 = ()=>{
            if (onRender) onRender();
        };
        $[0] = onRender;
        $[1] = t1;
    } else t1 = $[1];
    (0, $cozmU.useLayoutEffect)(t1);
    return null;
} : function RenderMarker({ onRender: onRender }) {
    (0, $cozmU.useLayoutEffect)(()=>{
        if (onRender) onRender();
    });
    return null;
};


const $f3887a34ef360a4a$var$SSRRenderMeasureImpl = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SSRRenderMeasureImpl(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { onSSRMeasure: onSSRMeasure, segmentName: segmentName, startTimestampRef: startTimestampRef, children: children } = t0;
    const wasMeasured = (0, $cozmU.useRef)(false);
    let t1;
    if ($[0] !== onSSRMeasure || $[1] !== segmentName || $[2] !== startTimestampRef) {
        t1 = ()=>{
            if (wasMeasured.current) return;
            onSSRMeasure?.({
                segmentName: segmentName,
                startTimestamp: startTimestampRef.current,
                endTimestamp: performance.now()
            });
            wasMeasured.current = true;
        };
        $[0] = onSSRMeasure;
        $[1] = segmentName;
        $[2] = startTimestampRef;
        $[3] = t1;
    } else t1 = $[3];
    const handleOnRender = t1;
    let t2;
    if ($[4] !== handleOnRender) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f41cdd85d6e00006$export$8742d3f42739b0ac), {
            onRender: handleOnRender
        });
        $[4] = handleOnRender;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== children || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                children,
                t2
            ]
        });
        $[6] = children;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : function SSRRenderMeasureImpl({ onSSRMeasure: onSSRMeasure, segmentName: segmentName, startTimestampRef: startTimestampRef, children: children }) {
    const wasMeasured = (0, $cozmU.useRef)(false);
    const handleOnRender = (0, $cozmU.useCallback)(()=>{
        if (wasMeasured.current) return;
        onSSRMeasure?.({
            segmentName: segmentName,
            startTimestamp: startTimestampRef.current,
            endTimestamp: performance.now()
        });
        wasMeasured.current = true;
    }, [
        onSSRMeasure,
        segmentName,
        startTimestampRef
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f41cdd85d6e00006$export$8742d3f42739b0ac), {
                onRender: handleOnRender
            })
        ]
    });
};
const $f3887a34ef360a4a$var$SSRRenderMeasureNoOp = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children })=>{
    return children;
});
const $f3887a34ef360a4a$export$9f2784dd4053b8a7 = (0, $4iudd.isSSR)() ? $f3887a34ef360a4a$var$SSRRenderMeasureImpl : $f3887a34ef360a4a$var$SSRRenderMeasureNoOp;
module.exports["SSRRenderMeasure"] = $f3887a34ef360a4a$export$9f2784dd4053b8a7;

});

parcelRegister("6ohxN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $03RpJ = parcelRequire("03RpJ");


var $kLVNa = parcelRequire("kLVNa");


var $9DHhW = parcelRequire("9DHhW");


var $krYZG = parcelRequire("krYZG");

var $fdQKX = parcelRequire("fdQKX");


var $hiQdW = parcelRequire("hiQdW");


var $6pnwK = parcelRequire("6pnwK");


var $bMenv = parcelRequire("bMenv");


var $d7j1D = parcelRequire("d7j1D");


var $cfjQo = parcelRequire("cfjQo");


var $l5aTW = parcelRequire("l5aTW");


var $kLi51 = parcelRequire("kLi51");





var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");























var $9kbTQ = parcelRequire("9kbTQ");


var $4iudd = parcelRequire("4iudd");


var $8lRRs = parcelRequire("8lRRs");


const $f9b7b55711a9504e$var$PortalRenderWrapper = /*#__PURE__*/ (0, $cozmU.memo)((0, $8lRRs.PortalRenderWrapperInner));
$f9b7b55711a9504e$var$PortalRenderWrapper.displayName = 'PortalRenderWrapper';
// Tree-shakable renderToStaticMarkup that should work only in SSR
function $f9b7b55711a9504e$var$getRenderToStaticMarkup() {
    return ()=>'';
}
const $f9b7b55711a9504e$export$3a6b5f5c5bba4bde = (portalManager)=>{
    const portalsMap = new Map();
    return {
        render: (children, container, key, onBeforeReactDomRender, immediate = false)=>{
            if ((0, $4iudd.isSSR)()) {
                let html = '';
                try {
                    const renderToStaticMarkup = $f9b7b55711a9504e$var$getRenderToStaticMarkup();
                    const Children = children;
                    html = renderToStaticMarkup(/*#__PURE__*/ (0, $8aG6j.jsx)(Children, {}));
                } catch (error) {}
                container.innerHTML = html;
            } else if (typeof onBeforeReactDomRender === 'function') {
                const portal = /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, $8aG6j.jsx)($f9b7b55711a9504e$var$PortalRenderWrapper, {
                    getChildren: children,
                    onBeforeRender: onBeforeReactDomRender
                }), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal, immediate));
            } else {
                const portal = /*#__PURE__*/ (0, $9kbTQ.createPortal)(children(), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal, immediate));
            }
        },
        remove: (key)=>{
            if ((0, $4iudd.isSSR)()) return;
            portalsMap.get(key)?.();
            portalsMap.delete(key);
        },
        destroy: ()=>{
            portalsMap.clear();
            portalManager.destroy();
        }
    };
};




















const $fd62aa0909e3331c$export$828f0f29e8293a07 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PortalBucket(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { id: id, portalManager: portalManager } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const [portals, setPortals] = (0, $cozmU.useState)(t1);
    let t2;
    let t3;
    if ($[1] !== id || $[2] !== portalManager) {
        t2 = ()=>{
            portalManager.registerBucket(id, setPortals);
            return ()=>{
                portalManager.unregisterBucket(id);
            };
        };
        t3 = [
            id,
            portalManager
        ];
        $[1] = id;
        $[2] = portalManager;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useLayoutEffect)(t2, t3);
    let t4;
    if ($[5] !== portals) {
        t4 = Object.values(portals);
        $[5] = portals;
        $[6] = t4;
    } else t4 = $[6];
    const portalElements = t4;
    let t5;
    if ($[7] !== portalElements) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: portalElements
        });
        $[7] = portalElements;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : function PortalBucket({ id: id, portalManager: portalManager }) {
    // State to hold the current portals for this bucket
    const [portals, setPortals] = (0, $cozmU.useState)({});
    // Effect to register/unregister this bucket with the portal manager on mount/unmount
    (0, $cozmU.useLayoutEffect)(()=>{
        portalManager.registerBucket(id, setPortals);
        return ()=>{
            portalManager.unregisterBucket(id);
        };
    }, [
        id,
        portalManager
    ]);
    // Memoize the portal elements to avoid unnecessary re-renders
    const portalElements = (0, $cozmU.useMemo)(()=>Object.values(portals), [
        portals
    ]);
    // Render the current portal elements
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: portalElements
    });
};


function $81f8551071119f2c$export$adfaaa25a1ea6e69(portalManager) {
    return function PortalRenderer() {
        const [buckets, setBuckets] = (0, $cozmU.useState)(portalManager.getBuckets());
        (0, $cozmU.useLayoutEffect)(()=>{
            portalManager.registerPortalRenderer(setBuckets);
            return ()=>{
                portalManager.unregisterPortalRenderer();
            };
        }, []);
        const portalsElements = (0, $cozmU.useMemo)(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        ()=>buckets.map((_, i)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fd62aa0909e3331c$export$828f0f29e8293a07), {
                    id: i,
                    portalManager: portalManager
                }, i)), [
            buckets
        ]);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: portalsElements
        });
    };
}



var $kmQhR = parcelRequire("kmQhR");


var $ieeJu = parcelRequire("ieeJu");

const $e7dc842d632fc85b$var$DEFAULT_INITIAL_BUCKETS = 50;
const $e7dc842d632fc85b$var$DEFAULT_MAX_BUCKET_CAPACITY = 50;
const $e7dc842d632fc85b$var$DEFAULT_SCALE_RATIO = 0.5;
const $e7dc842d632fc85b$var$DEFAULT_THROTTLE_DELAY = 16; // ~60fps for smooth updates
/**
 * Creates an empty bucket object with a specified capacity. Each bucket is designed
 * to hold a certain number of React portals and has an associated updater function
 * which can be null initially.
 *
 * @function createEmptyBucket
 * @param {number} capacity - The maximum capacity of the bucket.
 * @returns {PortalBucketType} An object representing an empty bucket with the specified capacity.
 */ function $e7dc842d632fc85b$var$createEmptyBucket(capacity) {
    return {
        portals: {},
        capacity: capacity,
        updater: null
    };
}
class $e7dc842d632fc85b$export$52c7ef79917c2f38 {
    getCurrentBucket() {
        return this.availableBuckets.values().next().value;
    }
    createBucket() {
        const currentBucket = this.getCurrentBucket();
        //If the current bucket has capacity, skip this logic
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        if (this.buckets[currentBucket].capacity > 0) return;
        else // The current bucket is full, delete the bucket from the list of available buckets
        // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
        this.availableBuckets.delete(currentBucket);
        // Skip creating new bucket if there are buckets still available
        if (this.availableBuckets.size > 0) return;
        // Scale the buckets up only if there are no available buckets left
        // Calculate how many new buckets need to be added
        const numBucketsToAdd = Math.floor(this.buckets.length * this.scaleRatio);
        this.buckets = [
            ...this.buckets
        ];
        for(let i = 0; i < numBucketsToAdd; i++){
            this.buckets.push($e7dc842d632fc85b$var$createEmptyBucket(this.maxBucketCapacity));
            this.availableBuckets.add(this.buckets.length - 1);
        }
        this.portalRendererUpdater?.(this.buckets);
    }
    getOrCreateThrottledUpdater(id) {
        if (!this.throttledBucketUpdaters.has(id)) {
            const throttledUpdater = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(()=>{
                this.buckets[id]?.updater?.(()=>({
                        ...this.buckets[id].portals
                    }));
            }, this.throttleDelay);
            this.throttledBucketUpdaters.set(id, throttledUpdater);
        }
        return this.throttledBucketUpdaters.get(id);
    }
    getBuckets() {
        return this.buckets;
    }
    registerBucket(id, updater) {
        this.buckets[id].updater = updater;
        this.buckets[id].updater?.(()=>({
                ...this.buckets[id].portals
            }));
    }
    unregisterBucket(id) {
        this.buckets[id].updater = null;
        // Clean up throttled updater when bucket is unregistered
        if (this.throttledBucketUpdaters.has(id)) {
            this.throttledBucketUpdaters.get(id)?.cancel();
            this.throttledBucketUpdaters.delete(id);
        }
    }
    updateBuckets(id, immediate = false) {
        if (!this.throttleActivationRAFId && (0, $ieeJu.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true)) this.throttleActivationRAFId = requestAnimationFrame(()=>{
            this.shouldUseThrottledUpdates = true;
        });
        if (immediate || !this.shouldUseThrottledUpdates || !(0, $ieeJu.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true)) {
            // Cancel any pending throttled update and update immediately
            if (this.throttledBucketUpdaters.has(id)) this.throttledBucketUpdaters.get(id)?.cancel();
            this.buckets[id].updater?.(()=>({
                    ...this.buckets[id].portals
                }));
        } else // Use throttled update for smooth, regular updates
        this.getOrCreateThrottledUpdater(id)?.();
    }
    registerPortal(key, portal, immediate = false) {
        this.createBucket();
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        this.buckets[this.getCurrentBucket()].capacity -= 1;
        const id = this.portalToBucketMap.get(key) ?? this.getCurrentBucket();
        // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
        this.portalToBucketMap.set(key, id);
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        if (this.buckets[id].portals[key] !== portal) {
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            this.buckets[id].portals[key] = portal;
            // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.updateBuckets(id, immediate);
        }
        //returns a function to unregister the portal
        return ()=>{
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            delete this.buckets[id].portals[key];
            this.portalToBucketMap.delete(key);
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            this.buckets[id].capacity += 1;
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            if (this.buckets[id].capacity > this.scaleCapacityThreshold) // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.availableBuckets.add(id);
            // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.updateBuckets(id, immediate);
        };
    }
    registerPortalRenderer(updater) {
        if (!this.portalRendererUpdater) updater(()=>this.buckets);
        this.portalRendererUpdater = updater;
    }
    unregisterPortalRenderer() {
        this.portalRendererUpdater = null;
    }
    /**
   * Cleans up resources used by the PortalManager. This includes clearing all portals,
   * unregistering all buckets, and resetting internal state.
   */ destroy() {
        // Cancel all pending throttled updates
        this.throttledBucketUpdaters.forEach((updater)=>{
            updater.cancel();
        });
        this.throttledBucketUpdaters.clear();
        // Iterate through each bucket and clear its portals and unset the updater function
        this.buckets.forEach((bucket, id)=>{
            bucket.portals = {}; // Clearing all portals from the bucket
            bucket.updater = null; // Unsetting the bucket's updater function
            this.availableBuckets.add(id); // Mark all buckets as available
        });
        this.portalToBucketMap.clear();
        this.portalRendererUpdater = null;
        this.availableBuckets = new Set(this.buckets.map((_, index)=>index));
    }
    constructor(initialBuckets = $e7dc842d632fc85b$var$DEFAULT_INITIAL_BUCKETS, maxBucketCapacity = $e7dc842d632fc85b$var$DEFAULT_MAX_BUCKET_CAPACITY, scaleRatio = $e7dc842d632fc85b$var$DEFAULT_SCALE_RATIO, throttleDelay = $e7dc842d632fc85b$var$DEFAULT_THROTTLE_DELAY){
        this.maxBucketCapacity = void 0;
        this.scaleRatio = void 0;
        this.buckets = void 0;
        this.availableBuckets = void 0;
        this.portalToBucketMap = void 0;
        this.portalRendererUpdater = void 0;
        this.scaleCapacityThreshold = void 0;
        this.throttledBucketUpdaters = void 0;
        this.throttleDelay = void 0;
        /**
     * Controls whether to use throttled updates or immediate synchronous updates.
     * During initial load, we use synchronous updates to avoid delays and ensure immediate responsiveness.
     * After the initial load period (one RAF cycle), we switch to throttled updates for better performance.
     */ this.shouldUseThrottledUpdates = false;
        /**
     * RequestAnimationFrame callback ID used to transition from synchronous to throttled update mode.
     * This ensures we switch to throttled mode after the initial render cycle completes.
     */ this.throttleActivationRAFId = void 0;
        this.maxBucketCapacity = maxBucketCapacity;
        this.scaleRatio = scaleRatio;
        this.throttleDelay = throttleDelay;
        // Initialise buckets array by creating an array of length `initialBuckets` containing empty buckets
        this.buckets = Array.from({
            length: initialBuckets
        }, ()=>$e7dc842d632fc85b$var$createEmptyBucket(maxBucketCapacity));
        this.portalToBucketMap = new Map();
        this.availableBuckets = new Set(Array.from({
            length: initialBuckets
        }, (_, i)=>i));
        this.portalRendererUpdater = null;
        this.scaleCapacityThreshold = maxBucketCapacity / 2;
        this.throttledBucketUpdaters = new Map();
    }
}


const $c1bb1b78f2430357$export$9b00782c24eb3d6b = (0, $gtMdU.isReactCompilerActivePlatform)() ? function usePortalProvider() {
    const $ = (0, $bDgLe.c)(6);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = new (0, $e7dc842d632fc85b$export$52c7ef79917c2f38)();
        $[0] = t0;
    } else t0 = $[0];
    const portalManager = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $81f8551071119f2c$export$adfaaa25a1ea6e69)(portalManager);
        $[1] = t1;
    } else t1 = $[1];
    const PortalRenderer = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $f9b7b55711a9504e$export$3a6b5f5c5bba4bde)(portalManager);
        $[2] = t2;
    } else t2 = $[2];
    const portalProviderAPI = t2;
    let t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>()=>{
                portalProviderAPI.destroy();
            };
        t4 = [
            portalManager,
            portalProviderAPI
        ];
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [
            portalProviderAPI,
            PortalRenderer
        ];
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : function usePortalProvider() {
    const portalManager = (0, $cozmU.useMemo)(()=>new (0, $e7dc842d632fc85b$export$52c7ef79917c2f38)(), []);
    const PortalRenderer = (0, $cozmU.useMemo)(()=>(0, $81f8551071119f2c$export$adfaaa25a1ea6e69)(portalManager), [
        portalManager
    ]);
    const portalProviderAPI = (0, $cozmU.useMemo)(()=>(0, $f9b7b55711a9504e$export$3a6b5f5c5bba4bde)(portalManager), [
        portalManager
    ]);
    // Cleanup on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            portalProviderAPI.destroy();
        };
    }, [
        portalManager,
        portalProviderAPI
    ]);
    return [
        portalProviderAPI,
        PortalRenderer
    ];
};



var $7Y8M5 = parcelRequire("7Y8M5");


var $4o0zT = parcelRequire("4o0zT");


var $8m50u = parcelRequire("8m50u");














var $3ge84 = parcelRequire("3ge84");




var $llCol = parcelRequire("llCol");


var $8ROsu = parcelRequire("8ROsu");


var $fghmm = parcelRequire("fghmm");


var $jv11C = parcelRequire("jv11C");

/* eslint-disable require-unicode-regexp */ const $37f4a1cfa5ba42f9$var$CHROME_REGEX = /Chrome\//;
const $37f4a1cfa5ba42f9$var$OPR_REGEX = /OPR\//;
const $37f4a1cfa5ba42f9$var$CHROME_VERSION_REGEX = /Chrome\/(\d+)/;
const $37f4a1cfa5ba42f9$var$GECKO_REGEX = /gecko\/\d/i;
const $37f4a1cfa5ba42f9$var$FIREFOX_VERSION_REGEX = /Firefox\/(\d+)/;
const $37f4a1cfa5ba42f9$var$EDGE_REGEX = /Edge\/(\d+)/;
const $37f4a1cfa5ba42f9$var$SAFARI_REGEX = /Version\/([0-9._]+).*Safari/;
const $37f4a1cfa5ba42f9$export$12d09524e028927 = (userAgent)=>{
    // Take browsers in both Desktop and Mobile (includes Chrome, Firefox, Edge and Safari) within last 2 years
    const chrome = $37f4a1cfa5ba42f9$var$CHROME_REGEX.test(userAgent) && !$37f4a1cfa5ba42f9$var$OPR_REGEX.test(userAgent);
    const chromeVersion = chrome ? parseInt((userAgent.match($37f4a1cfa5ba42f9$var$CHROME_VERSION_REGEX) || [])[1], 10) : 0;
    if (chromeVersion >= 123) return false;
    const gecko = $37f4a1cfa5ba42f9$var$GECKO_REGEX.test(userAgent);
    const geckoVersion = gecko ? parseInt((userAgent.match($37f4a1cfa5ba42f9$var$FIREFOX_VERSION_REGEX) || [])[1], 10) : 0;
    if (geckoVersion >= 124) return false;
    const edge = $37f4a1cfa5ba42f9$var$EDGE_REGEX.exec(userAgent);
    const edgeVersion = edge ? +edge[1] : 0;
    if (edgeVersion >= 123) return false;
    const safari = !chrome && !gecko && $37f4a1cfa5ba42f9$var$SAFARI_REGEX.test(userAgent);
    const safariVersion = safari ? parseInt((userAgent.match($37f4a1cfa5ba42f9$var$SAFARI_REGEX) || [])[1], 10) : 0;
    if (safariVersion >= 17) return false;
    return true;
};





parcelRequire("cozmU");




const $181bbe803453d27a$export$cf381084b490bd31 = (WrappedComponent)=>{
    const _WithFeatureFlags = (props)=>{
        const { editorActions: editorActions } = (0, $d7j1D.useEditorContext)();
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $8aG6j.jsx)(WrappedComponent, {
            ...props,
            editorView: editorActions?._privateGetEditorView()
        }));
    };
    return _WithFeatureFlags;
};


class $08d101760b2f202f$export$d6d3bedcc5fc09c8 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch(error, errorInfo) {
        // Only report and re-render once, to avoid over-reporting errors and infinite rerendering
        if (this.state.error) return;
        if (this.props.errorTracking) this.sendErrorData({
            error: error,
            errorInfo: errorInfo,
            errorStack: error.stack
        });
        // Update state to allow a re-render to attempt graceful recovery (in the event that
        // the error was caused by a race condition or is intermittent)
        this.setState({
            error: error
        }, ()=>{
            if (this.props.rethrow) // Now that a re-render has occurred, we re-throw to allow product error boundaries
            // to catch and handle the error too.
            //
            // Note that when rethrowing inside a error boundary, the stack trace
            // from a higher error boundary's componentDidCatch.info param will reset
            // to this component, instead of the original component which threw it.
            throw error;
        });
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // FIXME: This is causing more problems then it's solving. The async check to sniff the browser extensions is block some
    // react unit tests. Essentially jest never completes and just hangs. This was code was added 3yrs ago so that errors
    // would detail if the browser had grammarly extension installed or not. I'm not sure if anyone has every inspecting this
    // as it doesn't look like any dashboards exist for it.
    // You can see the open handles that are block tests if you run unit tests with --detectOpenHandles
    // async componentDidMount() {
    // 	this.browserExtensions = await sniffUserBrowserExtensions({
    // 		extensions: ['grammarly'],
    // 		async: true,
    // 		asyncTimeoutMs: 20000,
    // 	});
    // }
    render() {
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fghmm.IntlErrorBoundary), {
            children: this.props.children
        });
    }
    constructor(props){
        super(props);
        this.featureFlags = void 0;
        this.browserExtensions = undefined;
        this.state = {
            error: undefined
        };
        this.sendErrorData = async (analyticsErrorPayload)=>{
            const product = await this.getProductName();
            const { error: error, errorInfo: errorInfo } = analyticsErrorPayload;
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const sharedId = (0, $03RpJ.default)();
            const browserInfo = window?.navigator?.userAgent || 'unknown';
            const attributes = {
                product: product,
                browserInfo: browserInfo,
                error: error.toString(),
                errorInfo: errorInfo,
                errorId: sharedId,
                browserExtensions: this.browserExtensions,
                docStructure: this.featureFlags.errorBoundaryDocStructure && this.props.editorView ? (0, $8ROsu.getDocStructure)(this.props.editorView.state.doc, {
                    compact: true
                }) : undefined,
                outdatedBrowser: (0, $37f4a1cfa5ba42f9$export$12d09524e028927)(browserInfo)
            };
            this.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).EDITOR_CRASHED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: attributes
            });
            this.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).EDITOR_CRASHED_ADDITIONAL_INFORMATION,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorId: sharedId
                }
            });
            this.logException(error, {
                location: 'editor-core/create-editor',
                product: product
            });
        };
        this.getProductName = async ()=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
            if (contextIdentifierProvider) {
                const context = await contextIdentifierProvider;
                if (context.product) return context.product;
            }
            return 'atlaskit';
        };
        this.fireAnalyticsEvent = (event)=>{
            this.props.createAnalyticsEvent?.(event).fire((0, $llCol.editorAnalyticsChannel));
        };
        this.logException = (error, tags)=>{
            (0, $jv11C.logException)(error, tags);
        };
        this.featureFlags = props.featureFlags;
    }
}
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$08d101760b2f202f$export$d6d3bedcc5fc09c8.defaultProps = {
    rethrow: true,
    errorTracking: true
};
class $08d101760b2f202f$export$e34b68cf8622e9fd extends $08d101760b2f202f$export$d6d3bedcc5fc09c8 {
    constructor(props){
        super(props);
        this.context = void 0;
        this.logException = (error, tags)=>{
            const extraTags = {};
            extraTags.editorSessionId = this.context?.getAtlaskitAnalyticsContext()?.[0]?.fabricEditorCtx?.editorSessionId;
            (0, $jv11C.logException)(error, {
                ...tags,
                ...extraTags
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
$08d101760b2f202f$export$e34b68cf8622e9fd.contextType = (0, $3ge84.default);
const $08d101760b2f202f$var$_default_1 = (0, $181bbe803453d27a$export$cf381084b490bd31)($08d101760b2f202f$export$e34b68cf8622e9fd);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$08d101760b2f202f$export$2e2bcd8739ae039 = $08d101760b2f202f$var$_default_1;



var $eVvEf = parcelRequire("eVvEf");





var $iBeRE = parcelRequire("iBeRE");





var $kTcv5 = parcelRequire("kTcv5");














var $7D1yr = parcelRequire("7D1yr");










// Default value from: `import { fontSize } from '@atlaskit/theme/constants';`
const $0731276cbee611b2$var$defaultFontSize = 14;
// No-op variant used when the static-css experiment is enabled. Editor consumers
// no longer read theme.baseFontSize / theme.layoutMaxWidth via Emotion's useTheme(),
// so no <ThemeProvider> is required in the React tree.
const $0731276cbee611b2$var$BaseThemeWrapperNoop = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
// Legacy variant keeping the original Emotion <ThemeProvider> behaviour for
// callers that still rely on theme.baseFontSize / theme.layoutMaxWidth.
const $0731276cbee611b2$var$BaseThemeWrapperLegacy = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { baseFontSize: baseFontSize, children: children } = t0;
    const t1 = baseFontSize || $0731276cbee611b2$var$defaultFontSize;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            baseFontSize: t1,
            layoutMaxWidth: (0, $7Y8M5.akEditorDefaultLayoutWidth)
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const memoizedTheme = t2;
    let t3;
    if ($[2] !== children || $[3] !== memoizedTheme) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7D1yr.a), {
            theme: memoizedTheme,
            children: children
        });
        $[2] = children;
        $[3] = memoizedTheme;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ baseFontSize: baseFontSize, children: children })=>{
    const memoizedTheme = (0, $cozmU.useMemo)(()=>({
            baseFontSize: baseFontSize || $0731276cbee611b2$var$defaultFontSize,
            layoutMaxWidth: (0, $7Y8M5.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7D1yr.a), {
        theme: memoizedTheme,
        children: children
    });
};
const $0731276cbee611b2$export$3de34996b814f0f0 = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), $0731276cbee611b2$var$BaseThemeWrapperNoop, $0731276cbee611b2$var$BaseThemeWrapperLegacy);











parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $2cf38fb21eb39a48$var$editorContainerCompiledStyles = {
    root: "_1mT5xdRAKS _39xV02N91d _0jFU0VN91d"
};
const $2cf38fb21eb39a48$export$f01d938f9288b4e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, fontSize: fontSize } = t0;
    const t1 = `${fontSize}px`;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            "--ak-editor-base-font-size": t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = t2;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $2cf38fb21eb39a48$var$editorContainerCompiledStyles.root
        ]);
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== children || $[4] !== t3) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t3,
            className: t4,
            children: children
        });
        $[3] = children;
        $[4] = t3;
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : ({ children: children, fontSize: fontSize })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            '--ak-editor-base-font-size': `${fontSize}px`
        },
        className: (0, $hekY6.default)([
            $2cf38fb21eb39a48$var$editorContainerCompiledStyles.root
        ]),
        children: children
    });


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
 * Used via `componentWithCondition` in `editor-internal.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $lOiVq = parcelRequire("lOiVq");

function $2a8ffb7d32b5a49d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2a8ffb7d32b5a49d$var$editorContainerEmotionStyles = {
    name: "zxsb69",
    styles: "position:relative;width:100%;height:100%"
};
const $2a8ffb7d32b5a49d$export$566369593ab67567 = ({ children: children, fontSize: fontSize })=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $2a8ffb7d32b5a49d$var$editorContainerEmotionStyles,
        style: {
            '--ak-editor-base-font-size': `${fontSize}px`
        }
    }, children);



var $jsa8f = parcelRequire("jsa8f");

const $dbf08bc9eeed0fa4$var$EditorInternalContainerMigration = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $2cf38fb21eb39a48$export$f01d938f9288b4e1), (0, $2a8ffb7d32b5a49d$export$566369593ab67567));
const $dbf08bc9eeed0fa4$var$DEFAULT_VALUE_PROP_TO_IGNORE = [
    'defaultValue'
];
const $dbf08bc9eeed0fa4$export$2617c0dabe49c335 = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(81);
    const { props: props, handleAnalyticsEvent: handleAnalyticsEvent, createAnalyticsEvent: createAnalyticsEvent, handleSave: handleSave, editorActions: editorActions, providerFactory: providerFactory, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed, preset: preset, AppearanceComponent: AppearanceComponent } = t0;
    const t1 = props.onSave ? handleSave : undefined;
    let t2;
    if ($[0] !== props || $[1] !== t1) {
        t2 = {
            ...props,
            onSave: t1,
            analyticsHandler: undefined
        };
        $[0] = props;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const overriddenEditorProps = t2;
    let t3;
    if ($[3] !== props.featureFlags) {
        t3 = (0, $cfjQo.createFeatureFlagsFromProps)(props.featureFlags);
        $[3] = props.featureFlags;
        $[4] = t3;
    } else t3 = $[4];
    const featureFlags = t3;
    let t4;
    if ($[5] !== featureFlags) {
        t4 = (0, $4o0zT.isExperimentEnabled)("platform_editor_enable_rerender_tracking") && !featureFlags.lcmPreventRenderTracking;
        $[5] = featureFlags;
        $[6] = t4;
    } else t4 = $[6];
    const renderTrackingEnabled = t4;
    const [portalProviderAPI, PortalRenderer] = (0, $c1bb1b78f2430357$export$9b00782c24eb3d6b)();
    const [nodeViewPortalProviderAPI, NodeViewPortalRenderer] = (0, $c1bb1b78f2430357$export$9b00782c24eb3d6b)();
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $4o0zT.isExperimentEnabled)("platform_editor_perf_lint_cleanup") ? $dbf08bc9eeed0fa4$var$DEFAULT_VALUE_PROP_TO_IGNORE : [
            "defaultValue"
        ];
        $[7] = t5;
    } else t5 = $[7];
    const propsToIgnore = t5;
    let baseFontSize;
    let t6;
    if ($[8] !== props.appearance || $[9] !== props.contentMode) {
        baseFontSize = (0, $jsa8f.getBaseFontSize)(props.appearance, props.contentMode);
        t6 = (0, $7Y8M5.editorFontSize)({
            theme: {
                baseFontSize: baseFontSize
            }
        });
        $[8] = props.appearance;
        $[9] = props.contentMode;
        $[10] = baseFontSize;
        $[11] = t6;
    } else {
        baseFontSize = $[10];
        t6 = $[11];
    }
    const fontSize = t6;
    let t7;
    if ($[12] !== handleAnalyticsEvent || $[13] !== props || $[14] !== renderTrackingEnabled) {
        t7 = renderTrackingEnabled && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kTcv5.RenderTracking), {
            componentProps: props,
            action: (0, $krYZG.ACTION).RE_RENDERED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            handleAnalyticsEvent: handleAnalyticsEvent,
            propsToIgnore: propsToIgnore,
            useShallow: false
        });
        $[12] = handleAnalyticsEvent;
        $[13] = props;
        $[14] = renderTrackingEnabled;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== AppearanceComponent || $[17] !== baseFontSize || $[18] !== editorActions || $[19] !== featureFlags || $[20] !== handleSave || $[21] !== preset || $[22] !== props.UNSAFE_containLayout || $[23] !== props.__livePage || $[24] !== props.allowUndoRedoButtons || $[25] !== props.appearance || $[26] !== props.collabEdit || $[27] !== props.contentComponents || $[28] !== props.contentMode || $[29] !== props.contextPanel || $[30] !== props.disabled || $[31] !== props.featureFlags?.toolbarMinWidthOverflow || $[32] !== props.isEditorModernisationEnabled || $[33] !== props.maxHeight || $[34] !== props.minHeight || $[35] !== props.onCancel || $[36] !== props.onSSRMeasure || $[37] !== props.onSave || $[38] !== props.persistScrollGutter || $[39] !== props.popupsBoundariesElement || $[40] !== props.popupsMountPoint || $[41] !== props.popupsScrollableElement || $[42] !== props.primaryToolbarComponents || $[43] !== props.primaryToolbarIconBefore || $[44] !== props.secondaryToolbarComponents || $[45] !== props.useStickyToolbar || $[46] !== providerFactory) {
        t8 = (t9)=>{
            const { editor: editor, view: view, eventDispatcher: eventDispatcher, config: config, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorRef: editorRef, editorAPI: editorAPI } = t9;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0731276cbee611b2$export$3de34996b814f0f0), {
                baseFontSize: baseFontSize,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)(AppearanceComponent, {
                    innerRef: editorRef,
                    editorAPI: editorAPI,
                    appearance: props.appearance,
                    disabled: props.disabled,
                    editorActions: editorActions,
                    editorDOMElement: editor,
                    editorView: view,
                    providerFactory: providerFactory,
                    eventDispatcher: eventDispatcher,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    maxHeight: props.maxHeight,
                    minHeight: props.minHeight,
                    onSave: props.onSave ? handleSave : undefined,
                    onCancel: props.onCancel,
                    onSSRMeasure: props.onSSRMeasure,
                    popupsMountPoint: props.popupsMountPoint,
                    popupsBoundariesElement: props.popupsBoundariesElement,
                    popupsScrollableElement: props.popupsScrollableElement,
                    contentComponents: config.contentComponents,
                    contentMode: props.contentMode,
                    primaryToolbarComponents: config.primaryToolbarComponents,
                    primaryToolbarIconBefore: props.primaryToolbarIconBefore,
                    secondaryToolbarComponents: config.secondaryToolbarComponents,
                    customContentComponents: props.contentComponents,
                    customPrimaryToolbarComponents: props.primaryToolbarComponents,
                    customSecondaryToolbarComponents: props.secondaryToolbarComponents,
                    contextPanel: props.contextPanel,
                    collabEdit: props.collabEdit,
                    persistScrollGutter: props.persistScrollGutter,
                    enableToolbarMinWidth: props.featureFlags?.toolbarMinWidthOverflow != null ? !!props.featureFlags?.toolbarMinWidthOverflow : props.allowUndoRedoButtons,
                    isEditorModernisationEnabled: props.isEditorModernisationEnabled,
                    useStickyToolbar: props.useStickyToolbar,
                    featureFlags: featureFlags,
                    pluginHooks: config.pluginHooks,
                    __livePage: props.__livePage,
                    preset: preset,
                    UNSAFE_containLayout: props.UNSAFE_containLayout
                })
            });
        };
        $[16] = AppearanceComponent;
        $[17] = baseFontSize;
        $[18] = editorActions;
        $[19] = featureFlags;
        $[20] = handleSave;
        $[21] = preset;
        $[22] = props.UNSAFE_containLayout;
        $[23] = props.__livePage;
        $[24] = props.allowUndoRedoButtons;
        $[25] = props.appearance;
        $[26] = props.collabEdit;
        $[27] = props.contentComponents;
        $[28] = props.contentMode;
        $[29] = props.contextPanel;
        $[30] = props.disabled;
        $[31] = props.featureFlags?.toolbarMinWidthOverflow;
        $[32] = props.isEditorModernisationEnabled;
        $[33] = props.maxHeight;
        $[34] = props.minHeight;
        $[35] = props.onCancel;
        $[36] = props.onSSRMeasure;
        $[37] = props.onSave;
        $[38] = props.persistScrollGutter;
        $[39] = props.popupsBoundariesElement;
        $[40] = props.popupsMountPoint;
        $[41] = props.popupsScrollableElement;
        $[42] = props.primaryToolbarComponents;
        $[43] = props.primaryToolbarIconBefore;
        $[44] = props.secondaryToolbarComponents;
        $[45] = props.useStickyToolbar;
        $[46] = providerFactory;
        $[47] = t8;
    } else t8 = $[47];
    let t9;
    if ($[48] !== createAnalyticsEvent || $[49] !== nodeViewPortalProviderAPI || $[50] !== onEditorCreated || $[51] !== onEditorDestroyed || $[52] !== overriddenEditorProps || $[53] !== portalProviderAPI || $[54] !== preset || $[55] !== props.disabled || $[56] !== providerFactory || $[57] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eVvEf.default), {
            editorProps: overriddenEditorProps,
            createAnalyticsEvent: createAnalyticsEvent,
            portalProviderAPI: portalProviderAPI,
            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
            providerFactory: providerFactory,
            onEditorCreated: onEditorCreated,
            onEditorDestroyed: onEditorDestroyed,
            disabled: props.disabled,
            preset: preset,
            render: t8
        });
        $[48] = createAnalyticsEvent;
        $[49] = nodeViewPortalProviderAPI;
        $[50] = onEditorCreated;
        $[51] = onEditorDestroyed;
        $[52] = overriddenEditorProps;
        $[53] = portalProviderAPI;
        $[54] = preset;
        $[55] = props.disabled;
        $[56] = providerFactory;
        $[57] = t8;
        $[58] = t9;
    } else t9 = $[58];
    let t10;
    if ($[59] !== PortalRenderer) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)(PortalRenderer, {});
        $[59] = PortalRenderer;
        $[60] = t10;
    } else t10 = $[60];
    let t11;
    if ($[61] !== NodeViewPortalRenderer) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsx)(NodeViewPortalRenderer, {});
        $[61] = NodeViewPortalRenderer;
        $[62] = t11;
    } else t11 = $[62];
    let t12;
    if ($[63] !== t10 || $[64] !== t11 || $[65] !== t9) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iBeRE.IntlProviderIfMissingWrapper), {
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
                children: [
                    t9,
                    t10,
                    t11
                ]
            })
        });
        $[63] = t10;
        $[64] = t11;
        $[65] = t9;
        $[66] = t12;
    } else t12 = $[66];
    let t13;
    if ($[67] !== editorActions || $[68] !== t12) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d7j1D.default), {
            editorActions: editorActions,
            children: t12
        });
        $[67] = editorActions;
        $[68] = t12;
        $[69] = t13;
    } else t13 = $[69];
    let t14;
    if ($[70] !== fontSize || $[71] !== t13) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)($dbf08bc9eeed0fa4$var$EditorInternalContainerMigration, {
            fontSize: fontSize,
            children: t13
        });
        $[70] = fontSize;
        $[71] = t13;
        $[72] = t14;
    } else t14 = $[72];
    let t15;
    if ($[73] !== createAnalyticsEvent || $[74] !== featureFlags || $[75] !== props.contextIdentifierProvider || $[76] !== t14) {
        t15 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $08d101760b2f202f$export$2e2bcd8739ae039), {
            errorTracking: true,
            createAnalyticsEvent: createAnalyticsEvent,
            contextIdentifierProvider: props.contextIdentifierProvider,
            featureFlags: featureFlags,
            children: t14
        });
        $[73] = createAnalyticsEvent;
        $[74] = featureFlags;
        $[75] = props.contextIdentifierProvider;
        $[76] = t14;
        $[77] = t15;
    } else t15 = $[77];
    let t16;
    if ($[78] !== t15 || $[79] !== t7) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
            children: [
                t7,
                t15
            ]
        });
        $[78] = t15;
        $[79] = t7;
        $[80] = t16;
    } else t16 = $[80];
    return t16;
} : ({ props: props, handleAnalyticsEvent: handleAnalyticsEvent, createAnalyticsEvent: createAnalyticsEvent, handleSave: handleSave, editorActions: editorActions, providerFactory: providerFactory, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed, preset: preset, AppearanceComponent: AppearanceComponent })=>{
    const overriddenEditorProps = {
        ...props,
        onSave: props.onSave ? handleSave : undefined,
        // noop all analytic events, even if a handler is still passed.
        analyticsHandler: undefined
    };
    const featureFlags = (0, $cfjQo.createFeatureFlagsFromProps)(props.featureFlags);
    const renderTrackingEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_enable_rerender_tracking') && !featureFlags.lcmPreventRenderTracking;
    const [portalProviderAPI, PortalRenderer] = (0, $c1bb1b78f2430357$export$9b00782c24eb3d6b)();
    const [nodeViewPortalProviderAPI, NodeViewPortalRenderer] = (0, $c1bb1b78f2430357$export$9b00782c24eb3d6b)();
    const propsToIgnore = (0, $4o0zT.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? $dbf08bc9eeed0fa4$var$DEFAULT_VALUE_PROP_TO_IGNORE : [
        'defaultValue'
    ];
    const baseFontSize = (0, $jsa8f.getBaseFontSize)(props.appearance, props.contentMode);
    const fontSize = (0, $7Y8M5.editorFontSize)({
        theme: {
            baseFontSize: baseFontSize
        }
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
        children: [
            renderTrackingEnabled && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kTcv5.RenderTracking), {
                componentProps: props,
                action: (0, $krYZG.ACTION).RE_RENDERED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                handleAnalyticsEvent: handleAnalyticsEvent,
                propsToIgnore: propsToIgnore,
                useShallow: false
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $08d101760b2f202f$export$2e2bcd8739ae039), {
                errorTracking: true,
                createAnalyticsEvent: createAnalyticsEvent,
                contextIdentifierProvider: props.contextIdentifierProvider,
                featureFlags: featureFlags,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($dbf08bc9eeed0fa4$var$EditorInternalContainerMigration, {
                    fontSize: fontSize,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d7j1D.default), {
                        editorActions: editorActions,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iBeRE.IntlProviderIfMissingWrapper), {
                            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eVvEf.default), {
                                        editorProps: overriddenEditorProps,
                                        createAnalyticsEvent: createAnalyticsEvent,
                                        portalProviderAPI: portalProviderAPI,
                                        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                                        providerFactory: providerFactory,
                                        onEditorCreated: onEditorCreated,
                                        onEditorDestroyed: onEditorDestroyed,
                                        disabled: props.disabled,
                                        preset: preset,
                                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017: this callback closes over the full props object and derived featureFlags; memoization is ineffective because ReactEditorViewNext is not memo()'d and deps (props, featureFlags) change every render
                                        render: ({ editor: editor, view: view, eventDispatcher: eventDispatcher, config: config, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorRef: editorRef, editorAPI: editorAPI })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $0731276cbee611b2$export$3de34996b814f0f0), {
                                                baseFontSize: baseFontSize,
                                                children: /*#__PURE__*/ (0, $8aG6j.jsx)(AppearanceComponent, {
                                                    innerRef: editorRef,
                                                    editorAPI: editorAPI,
                                                    // Ignored via go/ees005
                                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                                    appearance: props.appearance,
                                                    disabled: props.disabled,
                                                    editorActions: editorActions,
                                                    editorDOMElement: editor,
                                                    editorView: view,
                                                    providerFactory: providerFactory,
                                                    eventDispatcher: eventDispatcher,
                                                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                                    maxHeight: props.maxHeight,
                                                    minHeight: props.minHeight,
                                                    onSave: props.onSave ? handleSave : undefined,
                                                    onCancel: props.onCancel,
                                                    onSSRMeasure: props.onSSRMeasure,
                                                    popupsMountPoint: props.popupsMountPoint,
                                                    popupsBoundariesElement: props.popupsBoundariesElement,
                                                    popupsScrollableElement: props.popupsScrollableElement,
                                                    contentComponents: config.contentComponents,
                                                    contentMode: props.contentMode,
                                                    primaryToolbarComponents: config.primaryToolbarComponents,
                                                    primaryToolbarIconBefore: props.primaryToolbarIconBefore,
                                                    secondaryToolbarComponents: config.secondaryToolbarComponents,
                                                    customContentComponents: props.contentComponents,
                                                    customPrimaryToolbarComponents: props.primaryToolbarComponents,
                                                    customSecondaryToolbarComponents: props.secondaryToolbarComponents,
                                                    contextPanel: props.contextPanel,
                                                    collabEdit: props.collabEdit,
                                                    persistScrollGutter: props.persistScrollGutter,
                                                    enableToolbarMinWidth: props.featureFlags?.toolbarMinWidthOverflow != null ? !!props.featureFlags?.toolbarMinWidthOverflow : props.allowUndoRedoButtons,
                                                    isEditorModernisationEnabled: props.isEditorModernisationEnabled,
                                                    useStickyToolbar: props.useStickyToolbar,
                                                    featureFlags: featureFlags,
                                                    pluginHooks: config.pluginHooks,
                                                    __livePage: props.__livePage,
                                                    preset: preset,
                                                    UNSAFE_containLayout: props.UNSAFE_containLayout
                                                })
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $8aG6j.jsx)(PortalRenderer, {}),
                                    /*#__PURE__*/ (0, $8aG6j.jsx)(NodeViewPortalRenderer, {})
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
















function $daf2a725862e8da8$export$2e2bcd8739ae039(action, props, createAnalyticsEvent) {
    return async (duration, startTime)=>{
        const contextIdentifier = await props.contextIdentifierProvider;
        const objectId = contextIdentifier?.objectId;
        if (createAnalyticsEvent) (0, $fdQKX.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: action,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                attributes: {
                    duration: duration,
                    startTime: startTime,
                    objectId: objectId
                },
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            }
        });
    };
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4o5MH = parcelRequire("4o5MH");







function $541b71afa6816c31$export$2e2bcd8739ae039() {
    (0, $4o5MH.default)(()=>{
        (0, $hiQdW.startMeasure)((0, $l5aTW.default).EDITOR_MOUNTED);
    });
}


function $7312ea02580709f6$export$2e2bcd8739ae039(props, createAnalyticsEvent) {
    (0, $541b71afa6816c31$export$2e2bcd8739ae039)();
    (0, $cozmU.useEffect)(()=>{
        (0, $hiQdW.stopMeasure)((0, $l5aTW.default).EDITOR_MOUNTED, (0, $daf2a725862e8da8$export$2e2bcd8739ae039)((0, $krYZG.ACTION).EDITOR_MOUNTED, props, createAnalyticsEvent));
        return ()=>{
            (0, $hiQdW.clearMeasure)((0, $l5aTW.default).EDITOR_MOUNTED);
            (0, $hiQdW.clearMeasure)((0, $l5aTW.default).ON_EDITOR_READY_CALLBACK);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
// Disable Exhaustive Deps here since we only want to stop the measure on mount.
}











const $4576bd37d6bd92fc$export$d9d7e48a5f16fb4d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (passedProps)=>{
    const $ = (0, $bDgLe.c)(104);
    let t0;
    if ($[0] !== passedProps.AppearanceComponent || $[1] !== passedProps.UNSAFE_cards || $[2] !== passedProps.UNSAFE_containLayout || $[3] !== passedProps.UNSAFE_useAnalyticsContext || $[4] !== passedProps.__livePage || $[5] !== passedProps.activityProvider || $[6] !== passedProps.allowAnalyticsGASV3 || $[7] !== passedProps.allowBlockType || $[8] !== passedProps.allowBorderMark || $[9] !== passedProps.allowBreakout || $[10] !== passedProps.allowConfluenceInlineComment || $[11] !== passedProps.allowDate || $[12] !== passedProps.allowExpand || $[13] !== passedProps.allowExtension || $[14] !== passedProps.allowFindReplace || $[15] !== passedProps.allowFragmentMark || $[16] !== passedProps.allowHelpDialog || $[17] !== passedProps.allowIndentation || $[18] !== passedProps.allowLayouts || $[19] !== passedProps.allowNestedTasks || $[20] !== passedProps.allowPanel || $[21] !== passedProps.allowRule || $[22] !== passedProps.allowStatus || $[23] !== passedProps.allowTables || $[24] !== passedProps.allowTasksAndDecisions || $[25] !== passedProps.allowTemplatePlaceholders || $[26] !== passedProps.allowTextAlignment || $[27] !== passedProps.allowTextColor || $[28] !== passedProps.allowUndoRedoButtons || $[29] !== passedProps.annotationProviders || $[30] !== passedProps.appearance || $[31] !== passedProps.assistiveDescribedBy || $[32] !== passedProps.assistiveLabel || $[33] !== passedProps.autoScrollIntoView || $[34] !== passedProps.autoformattingProvider || $[35] !== passedProps.codeBlock || $[36] !== passedProps.collabEdit || $[37] !== passedProps.collabEditProvider || $[38] !== passedProps.contentComponents || $[39] !== passedProps.contentMode || $[40] !== passedProps.contentTransformerProvider || $[41] !== passedProps.contextIdentifierProvider || $[42] !== passedProps.contextPanel || $[43] !== passedProps.defaultValue || $[44] !== passedProps.disabled || $[45] !== passedProps.editorActions || $[46] !== passedProps.elementBrowser || $[47] !== passedProps.emojiProvider || $[48] !== passedProps.errorReporterHandler || $[49] !== passedProps.extensionHandlers || $[50] !== passedProps.extensionProviders || $[51] !== passedProps.featureFlags || $[52] !== passedProps.feedbackInfo || $[53] !== passedProps.inputSamplingLimit || $[54] !== passedProps.insertMenuItems || $[55] !== passedProps.isEditorModernisationEnabled || $[56] !== passedProps.legacyImageUploadProvider || $[57] !== passedProps.linking || $[58] !== passedProps.macroProvider || $[59] !== passedProps.maxContentSize || $[60] !== passedProps.maxHeight || $[61] !== passedProps.media || $[62] !== passedProps.mention || $[63] !== passedProps.mentionInsertDisplayName || $[64] !== passedProps.mentionProvider || $[65] !== passedProps.minHeight || $[66] !== passedProps.onCancel || $[67] !== passedProps.onChange || $[68] !== passedProps.onDestroy || $[69] !== passedProps.onEditorReady || $[70] !== passedProps.onSSRMeasure || $[71] !== passedProps.onSave || $[72] !== passedProps.pasteWarningOptions || $[73] !== passedProps.performanceTracking || $[74] !== passedProps.persistScrollGutter || $[75] !== passedProps.placeholder || $[76] !== passedProps.placeholderBracketHint || $[77] !== passedProps.popupsBoundariesElement || $[78] !== passedProps.popupsMountPoint || $[79] !== passedProps.popupsScrollableElement || $[80] !== passedProps.presenceProvider || $[81] !== passedProps.preset || $[82] !== passedProps.primaryToolbarComponents || $[83] !== passedProps.primaryToolbarIconBefore || $[84] !== passedProps.quickInsert || $[85] !== passedProps.sanitizePrivateContent || $[86] !== passedProps.saveOnEnter || $[87] !== passedProps.searchProvider || $[88] !== passedProps.secondaryToolbarComponents || $[89] !== passedProps.shouldFocus || $[90] !== passedProps.showIndentationButtons || $[91] !== passedProps.skipValidation || $[92] !== passedProps.smartLinks || $[93] !== passedProps.syncBlock || $[94] !== passedProps.syncedBlockProvider || $[95] !== passedProps.taskDecisionProvider || $[96] !== passedProps.textFormatting || $[97] !== passedProps.uploadErrorHandler || $[98] !== passedProps.useStickyToolbar || $[99] !== passedProps.waitForMediaUpload) {
        t0 = {
            preset: passedProps.preset,
            appearance: passedProps.appearance,
            contentMode: passedProps.contentMode,
            contentComponents: passedProps.contentComponents,
            primaryToolbarIconBefore: passedProps.primaryToolbarIconBefore,
            secondaryToolbarComponents: passedProps.secondaryToolbarComponents,
            persistScrollGutter: passedProps.persistScrollGutter,
            quickInsert: passedProps.quickInsert,
            shouldFocus: passedProps.shouldFocus,
            disabled: passedProps.disabled,
            contextPanel: passedProps.contextPanel,
            errorReporterHandler: passedProps.errorReporterHandler,
            contentTransformerProvider: passedProps.contentTransformerProvider,
            maxHeight: passedProps.maxHeight,
            minHeight: passedProps.minHeight,
            placeholder: passedProps.placeholder,
            placeholderBracketHint: passedProps.placeholderBracketHint,
            defaultValue: passedProps.defaultValue,
            assistiveLabel: passedProps.assistiveLabel,
            assistiveDescribedBy: passedProps.assistiveDescribedBy,
            popupsMountPoint: passedProps.popupsMountPoint,
            popupsBoundariesElement: passedProps.popupsBoundariesElement,
            popupsScrollableElement: passedProps.popupsScrollableElement,
            editorActions: passedProps.editorActions,
            onEditorReady: passedProps.onEditorReady,
            onDestroy: passedProps.onDestroy,
            onChange: passedProps.onChange,
            onCancel: passedProps.onCancel,
            extensionProviders: passedProps.extensionProviders,
            UNSAFE_useAnalyticsContext: passedProps.UNSAFE_useAnalyticsContext,
            useStickyToolbar: passedProps.useStickyToolbar,
            isEditorModernisationEnabled: passedProps.isEditorModernisationEnabled,
            featureFlags: passedProps.featureFlags,
            onSave: passedProps.onSave,
            sanitizePrivateContent: passedProps.sanitizePrivateContent,
            media: passedProps.media,
            collabEdit: passedProps.collabEdit,
            primaryToolbarComponents: passedProps.primaryToolbarComponents,
            performanceTracking: passedProps.performanceTracking,
            inputSamplingLimit: passedProps.inputSamplingLimit,
            allowUndoRedoButtons: passedProps.allowUndoRedoButtons,
            linking: passedProps.linking,
            activityProvider: passedProps.activityProvider,
            searchProvider: passedProps.searchProvider,
            annotationProviders: passedProps.annotationProviders,
            collabEditProvider: passedProps.collabEditProvider,
            presenceProvider: passedProps.presenceProvider,
            emojiProvider: passedProps.emojiProvider,
            taskDecisionProvider: passedProps.taskDecisionProvider,
            legacyImageUploadProvider: passedProps.legacyImageUploadProvider,
            mentionProvider: passedProps.mentionProvider,
            autoformattingProvider: passedProps.autoformattingProvider,
            macroProvider: passedProps.macroProvider,
            contextIdentifierProvider: passedProps.contextIdentifierProvider,
            allowExpand: passedProps.allowExpand,
            allowNestedTasks: passedProps.allowNestedTasks,
            allowBlockType: passedProps.allowBlockType,
            allowTasksAndDecisions: passedProps.allowTasksAndDecisions,
            allowBreakout: passedProps.allowBreakout,
            allowRule: passedProps.allowRule,
            allowHelpDialog: passedProps.allowHelpDialog,
            allowPanel: passedProps.allowPanel,
            allowExtension: passedProps.allowExtension,
            allowConfluenceInlineComment: passedProps.allowConfluenceInlineComment,
            allowTemplatePlaceholders: passedProps.allowTemplatePlaceholders,
            allowDate: passedProps.allowDate,
            allowLayouts: passedProps.allowLayouts,
            allowStatus: passedProps.allowStatus,
            allowTextAlignment: passedProps.allowTextAlignment,
            allowIndentation: passedProps.allowIndentation,
            showIndentationButtons: passedProps.showIndentationButtons,
            allowFindReplace: passedProps.allowFindReplace,
            allowBorderMark: passedProps.allowBorderMark,
            allowFragmentMark: passedProps.allowFragmentMark,
            autoScrollIntoView: passedProps.autoScrollIntoView,
            elementBrowser: passedProps.elementBrowser,
            maxContentSize: passedProps.maxContentSize,
            saveOnEnter: passedProps.saveOnEnter,
            feedbackInfo: passedProps.feedbackInfo,
            mention: passedProps.mention,
            mentionInsertDisplayName: passedProps.mentionInsertDisplayName,
            uploadErrorHandler: passedProps.uploadErrorHandler,
            onSSRMeasure: passedProps.onSSRMeasure,
            waitForMediaUpload: passedProps.waitForMediaUpload,
            extensionHandlers: passedProps.extensionHandlers,
            allowTextColor: passedProps.allowTextColor,
            allowTables: passedProps.allowTables,
            insertMenuItems: passedProps.insertMenuItems,
            UNSAFE_cards: passedProps.UNSAFE_cards,
            smartLinks: passedProps.smartLinks,
            allowAnalyticsGASV3: passedProps.allowAnalyticsGASV3,
            codeBlock: passedProps.codeBlock,
            textFormatting: passedProps.textFormatting,
            __livePage: passedProps.__livePage,
            AppearanceComponent: passedProps.AppearanceComponent,
            skipValidation: passedProps.skipValidation,
            syncBlock: passedProps.syncBlock,
            syncedBlockProvider: passedProps.syncedBlockProvider,
            pasteWarningOptions: passedProps.pasteWarningOptions,
            UNSAFE_containLayout: passedProps.UNSAFE_containLayout
        };
        $[0] = passedProps.AppearanceComponent;
        $[1] = passedProps.UNSAFE_cards;
        $[2] = passedProps.UNSAFE_containLayout;
        $[3] = passedProps.UNSAFE_useAnalyticsContext;
        $[4] = passedProps.__livePage;
        $[5] = passedProps.activityProvider;
        $[6] = passedProps.allowAnalyticsGASV3;
        $[7] = passedProps.allowBlockType;
        $[8] = passedProps.allowBorderMark;
        $[9] = passedProps.allowBreakout;
        $[10] = passedProps.allowConfluenceInlineComment;
        $[11] = passedProps.allowDate;
        $[12] = passedProps.allowExpand;
        $[13] = passedProps.allowExtension;
        $[14] = passedProps.allowFindReplace;
        $[15] = passedProps.allowFragmentMark;
        $[16] = passedProps.allowHelpDialog;
        $[17] = passedProps.allowIndentation;
        $[18] = passedProps.allowLayouts;
        $[19] = passedProps.allowNestedTasks;
        $[20] = passedProps.allowPanel;
        $[21] = passedProps.allowRule;
        $[22] = passedProps.allowStatus;
        $[23] = passedProps.allowTables;
        $[24] = passedProps.allowTasksAndDecisions;
        $[25] = passedProps.allowTemplatePlaceholders;
        $[26] = passedProps.allowTextAlignment;
        $[27] = passedProps.allowTextColor;
        $[28] = passedProps.allowUndoRedoButtons;
        $[29] = passedProps.annotationProviders;
        $[30] = passedProps.appearance;
        $[31] = passedProps.assistiveDescribedBy;
        $[32] = passedProps.assistiveLabel;
        $[33] = passedProps.autoScrollIntoView;
        $[34] = passedProps.autoformattingProvider;
        $[35] = passedProps.codeBlock;
        $[36] = passedProps.collabEdit;
        $[37] = passedProps.collabEditProvider;
        $[38] = passedProps.contentComponents;
        $[39] = passedProps.contentMode;
        $[40] = passedProps.contentTransformerProvider;
        $[41] = passedProps.contextIdentifierProvider;
        $[42] = passedProps.contextPanel;
        $[43] = passedProps.defaultValue;
        $[44] = passedProps.disabled;
        $[45] = passedProps.editorActions;
        $[46] = passedProps.elementBrowser;
        $[47] = passedProps.emojiProvider;
        $[48] = passedProps.errorReporterHandler;
        $[49] = passedProps.extensionHandlers;
        $[50] = passedProps.extensionProviders;
        $[51] = passedProps.featureFlags;
        $[52] = passedProps.feedbackInfo;
        $[53] = passedProps.inputSamplingLimit;
        $[54] = passedProps.insertMenuItems;
        $[55] = passedProps.isEditorModernisationEnabled;
        $[56] = passedProps.legacyImageUploadProvider;
        $[57] = passedProps.linking;
        $[58] = passedProps.macroProvider;
        $[59] = passedProps.maxContentSize;
        $[60] = passedProps.maxHeight;
        $[61] = passedProps.media;
        $[62] = passedProps.mention;
        $[63] = passedProps.mentionInsertDisplayName;
        $[64] = passedProps.mentionProvider;
        $[65] = passedProps.minHeight;
        $[66] = passedProps.onCancel;
        $[67] = passedProps.onChange;
        $[68] = passedProps.onDestroy;
        $[69] = passedProps.onEditorReady;
        $[70] = passedProps.onSSRMeasure;
        $[71] = passedProps.onSave;
        $[72] = passedProps.pasteWarningOptions;
        $[73] = passedProps.performanceTracking;
        $[74] = passedProps.persistScrollGutter;
        $[75] = passedProps.placeholder;
        $[76] = passedProps.placeholderBracketHint;
        $[77] = passedProps.popupsBoundariesElement;
        $[78] = passedProps.popupsMountPoint;
        $[79] = passedProps.popupsScrollableElement;
        $[80] = passedProps.presenceProvider;
        $[81] = passedProps.preset;
        $[82] = passedProps.primaryToolbarComponents;
        $[83] = passedProps.primaryToolbarIconBefore;
        $[84] = passedProps.quickInsert;
        $[85] = passedProps.sanitizePrivateContent;
        $[86] = passedProps.saveOnEnter;
        $[87] = passedProps.searchProvider;
        $[88] = passedProps.secondaryToolbarComponents;
        $[89] = passedProps.shouldFocus;
        $[90] = passedProps.showIndentationButtons;
        $[91] = passedProps.skipValidation;
        $[92] = passedProps.smartLinks;
        $[93] = passedProps.syncBlock;
        $[94] = passedProps.syncedBlockProvider;
        $[95] = passedProps.taskDecisionProvider;
        $[96] = passedProps.textFormatting;
        $[97] = passedProps.uploadErrorHandler;
        $[98] = passedProps.useStickyToolbar;
        $[99] = passedProps.waitForMediaUpload;
        $[100] = t0;
    } else t0 = $[100];
    const allProps = t0;
    let t1;
    if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            appearance: "comment",
            disabled: false,
            quickInsert: true
        };
        $[101] = t1;
    } else t1 = $[101];
    const defaultProps = t1;
    let t2;
    if ($[102] !== allProps) {
        t2 = {
            ...defaultProps,
            ...allProps
        };
        $[102] = allProps;
        $[103] = t2;
    } else t2 = $[103];
    const nextProps = t2;
    const memodProps = nextProps;
    return memodProps;
} : (passedProps)=>{
    const memodProps = (0, $cozmU.useMemo)(()=>{
        // That sounds awful but this is the only way to make sure we didn't missed any EditorProps
        const allProps = {
            preset: passedProps.preset,
            appearance: passedProps.appearance,
            contentMode: passedProps.contentMode,
            contentComponents: passedProps.contentComponents,
            primaryToolbarIconBefore: passedProps.primaryToolbarIconBefore,
            secondaryToolbarComponents: passedProps.secondaryToolbarComponents,
            persistScrollGutter: passedProps.persistScrollGutter,
            quickInsert: passedProps.quickInsert,
            shouldFocus: passedProps.shouldFocus,
            disabled: passedProps.disabled,
            contextPanel: passedProps.contextPanel,
            errorReporterHandler: passedProps.errorReporterHandler,
            contentTransformerProvider: passedProps.contentTransformerProvider,
            maxHeight: passedProps.maxHeight,
            minHeight: passedProps.minHeight,
            placeholder: passedProps.placeholder,
            placeholderBracketHint: passedProps.placeholderBracketHint,
            defaultValue: passedProps.defaultValue,
            assistiveLabel: passedProps.assistiveLabel,
            assistiveDescribedBy: passedProps.assistiveDescribedBy,
            popupsMountPoint: passedProps.popupsMountPoint,
            popupsBoundariesElement: passedProps.popupsBoundariesElement,
            popupsScrollableElement: passedProps.popupsScrollableElement,
            editorActions: passedProps.editorActions,
            onEditorReady: passedProps.onEditorReady,
            onDestroy: passedProps.onDestroy,
            onChange: passedProps.onChange,
            onCancel: passedProps.onCancel,
            extensionProviders: passedProps.extensionProviders,
            UNSAFE_useAnalyticsContext: passedProps.UNSAFE_useAnalyticsContext,
            useStickyToolbar: passedProps.useStickyToolbar,
            isEditorModernisationEnabled: passedProps.isEditorModernisationEnabled,
            featureFlags: passedProps.featureFlags,
            onSave: passedProps.onSave,
            sanitizePrivateContent: passedProps.sanitizePrivateContent,
            media: passedProps.media,
            collabEdit: passedProps.collabEdit,
            primaryToolbarComponents: passedProps.primaryToolbarComponents,
            performanceTracking: passedProps.performanceTracking,
            inputSamplingLimit: passedProps.inputSamplingLimit,
            allowUndoRedoButtons: passedProps.allowUndoRedoButtons,
            linking: passedProps.linking,
            activityProvider: passedProps.activityProvider,
            searchProvider: passedProps.searchProvider,
            annotationProviders: passedProps.annotationProviders,
            collabEditProvider: passedProps.collabEditProvider,
            presenceProvider: passedProps.presenceProvider,
            emojiProvider: passedProps.emojiProvider,
            taskDecisionProvider: passedProps.taskDecisionProvider,
            legacyImageUploadProvider: passedProps.legacyImageUploadProvider,
            mentionProvider: passedProps.mentionProvider,
            autoformattingProvider: passedProps.autoformattingProvider,
            macroProvider: passedProps.macroProvider,
            contextIdentifierProvider: passedProps.contextIdentifierProvider,
            allowExpand: passedProps.allowExpand,
            allowNestedTasks: passedProps.allowNestedTasks,
            allowBlockType: passedProps.allowBlockType,
            allowTasksAndDecisions: passedProps.allowTasksAndDecisions,
            allowBreakout: passedProps.allowBreakout,
            allowRule: passedProps.allowRule,
            allowHelpDialog: passedProps.allowHelpDialog,
            allowPanel: passedProps.allowPanel,
            allowExtension: passedProps.allowExtension,
            allowConfluenceInlineComment: passedProps.allowConfluenceInlineComment,
            allowTemplatePlaceholders: passedProps.allowTemplatePlaceholders,
            allowDate: passedProps.allowDate,
            allowLayouts: passedProps.allowLayouts,
            allowStatus: passedProps.allowStatus,
            allowTextAlignment: passedProps.allowTextAlignment,
            allowIndentation: passedProps.allowIndentation,
            showIndentationButtons: passedProps.showIndentationButtons,
            allowFindReplace: passedProps.allowFindReplace,
            allowBorderMark: passedProps.allowBorderMark,
            allowFragmentMark: passedProps.allowFragmentMark,
            autoScrollIntoView: passedProps.autoScrollIntoView,
            elementBrowser: passedProps.elementBrowser,
            maxContentSize: passedProps.maxContentSize,
            saveOnEnter: passedProps.saveOnEnter,
            feedbackInfo: passedProps.feedbackInfo,
            mention: passedProps.mention,
            mentionInsertDisplayName: passedProps.mentionInsertDisplayName,
            uploadErrorHandler: passedProps.uploadErrorHandler,
            onSSRMeasure: passedProps.onSSRMeasure,
            waitForMediaUpload: passedProps.waitForMediaUpload,
            extensionHandlers: passedProps.extensionHandlers,
            allowTextColor: passedProps.allowTextColor,
            allowTables: passedProps.allowTables,
            insertMenuItems: passedProps.insertMenuItems,
            UNSAFE_cards: passedProps.UNSAFE_cards,
            smartLinks: passedProps.smartLinks,
            allowAnalyticsGASV3: passedProps.allowAnalyticsGASV3,
            codeBlock: passedProps.codeBlock,
            textFormatting: passedProps.textFormatting,
            __livePage: passedProps.__livePage,
            AppearanceComponent: passedProps.AppearanceComponent,
            skipValidation: passedProps.skipValidation,
            syncBlock: passedProps.syncBlock,
            syncedBlockProvider: passedProps.syncedBlockProvider,
            pasteWarningOptions: passedProps.pasteWarningOptions,
            UNSAFE_containLayout: passedProps.UNSAFE_containLayout
        };
        const defaultProps = {
            appearance: 'comment',
            disabled: false,
            quickInsert: true
        };
        const nextProps = {
            ...defaultProps,
            ...allProps
        };
        return nextProps;
    }, [
        passedProps.preset,
        passedProps.appearance,
        passedProps.contentMode,
        passedProps.contentComponents,
        passedProps.primaryToolbarIconBefore,
        passedProps.secondaryToolbarComponents,
        passedProps.persistScrollGutter,
        passedProps.quickInsert,
        passedProps.shouldFocus,
        passedProps.disabled,
        passedProps.contextPanel,
        passedProps.errorReporterHandler,
        passedProps.contentTransformerProvider,
        passedProps.maxHeight,
        passedProps.minHeight,
        passedProps.placeholder,
        passedProps.placeholderBracketHint,
        passedProps.performanceTracking,
        passedProps.inputSamplingLimit,
        passedProps.defaultValue,
        passedProps.assistiveLabel,
        passedProps.assistiveDescribedBy,
        passedProps.popupsMountPoint,
        passedProps.popupsBoundariesElement,
        passedProps.popupsScrollableElement,
        passedProps.editorActions,
        passedProps.onEditorReady,
        passedProps.onDestroy,
        passedProps.onChange,
        passedProps.onCancel,
        passedProps.onSSRMeasure,
        passedProps.extensionProviders,
        passedProps.UNSAFE_useAnalyticsContext,
        passedProps.useStickyToolbar,
        passedProps.isEditorModernisationEnabled,
        passedProps.featureFlags,
        passedProps.onSave,
        passedProps.sanitizePrivateContent,
        passedProps.media,
        passedProps.collabEdit,
        passedProps.primaryToolbarComponents,
        passedProps.allowUndoRedoButtons,
        passedProps.linking,
        passedProps.activityProvider,
        passedProps.searchProvider,
        passedProps.annotationProviders,
        passedProps.collabEditProvider,
        passedProps.presenceProvider,
        passedProps.emojiProvider,
        passedProps.taskDecisionProvider,
        passedProps.legacyImageUploadProvider,
        passedProps.mentionProvider,
        passedProps.autoformattingProvider,
        passedProps.macroProvider,
        passedProps.contextIdentifierProvider,
        passedProps.allowExpand,
        passedProps.allowNestedTasks,
        passedProps.allowBlockType,
        passedProps.allowTasksAndDecisions,
        passedProps.allowBreakout,
        passedProps.allowRule,
        passedProps.allowHelpDialog,
        passedProps.allowPanel,
        passedProps.allowExtension,
        passedProps.allowConfluenceInlineComment,
        passedProps.allowTemplatePlaceholders,
        passedProps.allowDate,
        passedProps.allowLayouts,
        passedProps.allowStatus,
        passedProps.allowTextAlignment,
        passedProps.allowIndentation,
        passedProps.showIndentationButtons,
        passedProps.allowFindReplace,
        passedProps.allowBorderMark,
        passedProps.allowFragmentMark,
        passedProps.autoScrollIntoView,
        passedProps.elementBrowser,
        passedProps.maxContentSize,
        passedProps.saveOnEnter,
        passedProps.feedbackInfo,
        passedProps.mention,
        passedProps.mentionInsertDisplayName,
        passedProps.uploadErrorHandler,
        passedProps.waitForMediaUpload,
        passedProps.extensionHandlers,
        passedProps.allowTextColor,
        passedProps.allowTables,
        passedProps.insertMenuItems,
        passedProps.UNSAFE_cards,
        passedProps.smartLinks,
        passedProps.allowAnalyticsGASV3,
        passedProps.codeBlock,
        passedProps.textFormatting,
        passedProps.__livePage,
        passedProps.AppearanceComponent,
        passedProps.skipValidation,
        passedProps.syncBlock,
        passedProps.syncedBlockProvider,
        passedProps.pasteWarningOptions,
        passedProps.UNSAFE_containLayout
    ]);
    return memodProps;
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$4576bd37d6bd92fc$export$2e2bcd8739ae039 = $4576bd37d6bd92fc$export$d9d7e48a5f16fb4d;












var $eNbr2 = parcelRequire("eNbr2");


var $dOBRD = parcelRequire("dOBRD");


var $1tdlM = parcelRequire("1tdlM");

function $2f21ee47948a0a2a$var$prepareExtensionProvidersInternal(editorActions, extensionProviders) {
    if (!extensionProviders) return;
    if (typeof extensionProviders === 'function') return (0, $1tdlM.default)(extensionProviders(editorActions));
    return (0, $1tdlM.default)(extensionProviders);
}
const $2f21ee47948a0a2a$var$prepareExtensionProvider = (getEditorActions)=>(0, $dOBRD.default)((extensionProviders)=>$2f21ee47948a0a2a$var$prepareExtensionProvidersInternal(getEditorActions(), extensionProviders));
var $2f21ee47948a0a2a$export$2e2bcd8739ae039 = $2f21ee47948a0a2a$var$prepareExtensionProvider;



var $4A48a = parcelRequire("4A48a");

function $6e2a446e851426a9$export$e3759a254d73dcb7(quickInsertProviders) {
    const { invokeList: invokeList, invokeOptionalList: invokeOptionalList } = (0, $4A48a.default)(quickInsertProviders);
    return {
        getComponents () {
            return invokeOptionalList('getComponents');
        },
        getItems () {
            return invokeList('getItems');
        }
    };
}











parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $eRn3r = parcelRequire("eRn3r");







var $50UK1 = parcelRequire("50UK1");

var $2sp5n = parcelRequire("2sp5n");


var $24ZxJ = parcelRequire("24ZxJ");







parcelRequire("cozmU");


var $7SMXM = parcelRequire("7SMXM");


var $79UEV = parcelRequire("79UEV");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");














var $I2MTF = parcelRequire("I2MTF");


var $9wgTc = parcelRequire("9wgTc");













var $4yKbg = parcelRequire("4yKbg");

var $5Qi6J = parcelRequire("5Qi6J");





var $bjg0G = parcelRequire("bjg0G");

const $8f196e56ef17ed5e$var$sendAnalytics = (item, selection, createAnalyticsEvent, source)=>{
    if (createAnalyticsEvent) {
        const insertLocation = (0, $24ZxJ.findInsertLocation)(selection);
        (0, $fdQKX.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION,
                attributes: {
                    extensionType: item.extensionType,
                    extensionKey: item.extensionKey,
                    key: item.key,
                    inputMethod: source || (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                    ...insertLocation ? {
                        insertLocation: insertLocation
                    } : {}
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            }
        });
    }
};
const $8f196e56ef17ed5e$var$warnDummyAPI = (location)=>{};
const $8f196e56ef17ed5e$var$dummyExtensionAPI = {
    editInContextPanel: ()=>$8f196e56ef17ed5e$var$warnDummyAPI('editInContextPanel'),
    _editInLegacyMacroBrowser: ()=>$8f196e56ef17ed5e$var$warnDummyAPI('_editInLegacyMacroBrowser'),
    getNodeWithPosByLocalId: ()=>({
            node: null,
            pos: null
        }),
    doc: {
        insertAfter: ()=>$8f196e56ef17ed5e$var$warnDummyAPI('doc:insertAfter'),
        scrollTo: ()=>$8f196e56ef17ed5e$var$warnDummyAPI('doc:scrollTo'),
        update: ()=>$8f196e56ef17ed5e$var$warnDummyAPI('doc:update')
    }
};
const $8f196e56ef17ed5e$export$70dcc8733cd2c05e = ({ apiRef: apiRef, createAnalyticsEvent: createAnalyticsEvent, editorActions: editorActions, insert: insert, item: item, source: source, state: state })=>{
    if (typeof item.node === 'function') {
        const extensionAPI = apiRef.current?.extension?.actions?.api() ?? $8f196e56ef17ed5e$var$dummyExtensionAPI;
        (0, $2sp5n.resolveImport)(item.node(extensionAPI)).then((node)=>{
            $8f196e56ef17ed5e$var$sendAnalytics(item, state.selection, createAnalyticsEvent, source);
            if (node) {
                const api = apiRef.current;
                if (!api) {
                    editorActions.replaceSelection(node);
                    return;
                }
                api.core.actions.execute(({ tr: tr })=>{
                    const content = Array.isArray(node) ? (0, $4yKbg.processRawFragmentValue)(tr.doc.type.schema, node) : (0, $5Qi6J.processRawValue)(tr.doc.type.schema, node);
                    return content ? (0, $bjg0G.safeInsert)(content)(tr).scrollIntoView() : null;
                });
            }
        }).catch((error)=>(0, $jv11C.logException)(error, {
                location: 'editor-core/quick-insert'
            }));
        return insert('');
    }
    $8f196e56ef17ed5e$var$sendAnalytics(item, state.selection, createAnalyticsEvent, source);
    return insert(item.node);
};















var $hw4ew = parcelRequire("hw4ew");


var $clm0n = parcelRequire("clm0n");


var $ivert = parcelRequire("ivert");


var $jmUhx = parcelRequire("jmUhx");


var $745kV = parcelRequire("745kV");


var $bDjVc = parcelRequire("bDjVc");

const $f09e868e0c8efa32$var$lazyExtensionIconCache = new WeakMap();
const $f09e868e0c8efa32$var$whiteboardQuickInsertItemKeys = new Set([
    'whiteboard-extension:create-whiteboard',
    'whiteboard-extension:create-diagram',
    'whiteboard-extension:create-flowchart',
    'whiteboard-extension:create-brainstorming',
    'whiteboard-extension:create-retrospective',
    'whiteboard-extension:create-roadmap'
]);
const $f09e868e0c8efa32$var$quickInsertItemIcons = {
    'toc:toc': (0, (/*@__PURE__*/$parcel$interopDefault($clm0n))),
    'cards:quick-insert': (0, (/*@__PURE__*/$parcel$interopDefault($745kV))),
    'carousel:quick-insert': (0, (/*@__PURE__*/$parcel$interopDefault($hw4ew))),
    'create-from-template:create-from-template': (0, (/*@__PURE__*/$parcel$interopDefault($ivert)))
};
const $f09e868e0c8efa32$var$resolveExtensionIcon = async (getIcon)=>{
    try {
        const maybeIcon = await getIcon?.();
        if (!maybeIcon) return 0, (/*@__PURE__*/$parcel$interopDefault($jmUhx));
        if (Object.prototype.hasOwnProperty.call(maybeIcon, 'default')) return maybeIcon.default ?? (0, (/*@__PURE__*/$parcel$interopDefault($jmUhx)));
        return maybeIcon;
    } catch  {
        return 0, (/*@__PURE__*/$parcel$interopDefault($jmUhx));
    }
};
const $f09e868e0c8efa32$var$createLazyExtensionIcon = (getIcon)=>{
    const cachedIcon = $f09e868e0c8efa32$var$lazyExtensionIconCache.get(getIcon);
    if (cachedIcon) return cachedIcon;
    const LazyIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>$f09e868e0c8efa32$var$resolveExtensionIcon(getIcon).then((Icon)=>({
                default: Icon
            })));
    LazyIcon.displayName = 'lazy(ExtensionIcon)';
    const Icon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
        const $ = (0, $bDgLe.c)(3);
        const { label: label, size: size } = t0;
        let t1;
        if ($[0] !== label || $[1] !== size) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
                    label: label,
                    size: size
                }),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)(LazyIcon, {
                    label: label,
                    size: size
                })
            });
            $[0] = label;
            $[1] = size;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    } : ({ label: label, size: size })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
                label: label,
                size: size
            }),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(LazyIcon, {
                label: label,
                size: size
            })
        });
    $f09e868e0c8efa32$var$lazyExtensionIconCache.set(getIcon, Icon);
    return Icon;
};
const $f09e868e0c8efa32$export$fa4d06fd361b5e56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { getIcon: getIcon, itemKey: itemKey, label: label, size: size } = t0;
    let t1;
    bb0: {
        const quickInsertItemIcon = $f09e868e0c8efa32$var$quickInsertItemIcons[itemKey];
        if (quickInsertItemIcon) {
            t1 = quickInsertItemIcon;
            break bb0;
        }
        if ($f09e868e0c8efa32$var$whiteboardQuickInsertItemKeys.has(itemKey)) {
            t1 = (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc)));
            break bb0;
        }
        let t2;
        if ($[0] !== getIcon) {
            t2 = getIcon ? $f09e868e0c8efa32$var$createLazyExtensionIcon(getIcon) : (0, (/*@__PURE__*/$parcel$interopDefault($jmUhx)));
            $[0] = getIcon;
            $[1] = t2;
        } else t2 = $[1];
        t1 = t2;
    }
    const Icon = t1;
    let t2;
    if ($[2] !== Icon || $[3] !== label || $[4] !== size) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            size: size
        });
        $[2] = Icon;
        $[3] = label;
        $[4] = size;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ getIcon: getIcon, itemKey: itemKey, label: label, size: size })=>{
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const quickInsertItemIcon = $f09e868e0c8efa32$var$quickInsertItemIcons[itemKey];
        if (quickInsertItemIcon) return quickInsertItemIcon;
        if ($f09e868e0c8efa32$var$whiteboardQuickInsertItemKeys.has(itemKey)) return 0, (/*@__PURE__*/$parcel$interopDefault($bDjVc));
        return getIcon ? $f09e868e0c8efa32$var$createLazyExtensionIcon(getIcon) : (0, (/*@__PURE__*/$parcel$interopDefault($jmUhx)));
    }, [
        getIcon,
        itemKey
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
        label: label,
        size: size
    });
};


const $da493d6d3f5861ba$export$c56df9875b147e5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { apiRef: apiRef, createAnalyticsEvent: createAnalyticsEvent, editorActions: editorActions, item: item, onInsert: onInsert } = t0;
    const { editorView: editorView, isOffline: isOffline } = (0, $9wgTc.useQuickInsertContext)();
    let t1;
    if ($[0] !== apiRef || $[1] !== createAnalyticsEvent || $[2] !== editorActions || $[3] !== editorView.state || $[4] !== item || $[5] !== onInsert) {
        t1 = (t2)=>{
            const { insert: insert, source: source } = t2;
            const result = (0, $8f196e56ef17ed5e$export$70dcc8733cd2c05e)({
                apiRef: apiRef,
                createAnalyticsEvent: createAnalyticsEvent,
                editorActions: editorActions,
                insert: insert,
                item: item,
                source: source,
                state: editorView.state
            });
            if (result) onInsert?.();
            return result;
        };
        $[0] = apiRef;
        $[1] = createAnalyticsEvent;
        $[2] = editorActions;
        $[3] = editorView.state;
        $[4] = item;
        $[5] = onInsert;
        $[6] = t1;
    } else t1 = $[6];
    const onSelect = t1;
    let t2;
    if ($[7] !== item.icon || $[8] !== item.key) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f09e868e0c8efa32$export$fa4d06fd361b5e56), {
            getIcon: item.icon,
            itemKey: item.key,
            label: ""
        });
        $[7] = item.icon;
        $[8] = item.key;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== isOffline || $[11] !== item.description || $[12] !== item.preview || $[13] !== item.title || $[14] !== onSelect || $[15] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
            iconBefore: t2,
            isDisabled: isOffline,
            onSelect: onSelect,
            preview: item.preview,
            description: item.description,
            title: item.title
        });
        $[10] = isOffline;
        $[11] = item.description;
        $[12] = item.preview;
        $[13] = item.title;
        $[14] = onSelect;
        $[15] = t2;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
} : ({ apiRef: apiRef, createAnalyticsEvent: createAnalyticsEvent, editorActions: editorActions, item: item, onInsert: onInsert })=>{
    const { editorView: editorView, isOffline: isOffline } = (0, $9wgTc.useQuickInsertContext)();
    const onSelect = (0, $cozmU.useCallback)(({ insert: insert, source: source })=>{
        const result = (0, $8f196e56ef17ed5e$export$70dcc8733cd2c05e)({
            apiRef: apiRef,
            createAnalyticsEvent: createAnalyticsEvent,
            editorActions: editorActions,
            insert: insert,
            item: item,
            source: source,
            state: editorView.state
        });
        if (result) onInsert?.();
        return result;
    }, [
        apiRef,
        createAnalyticsEvent,
        editorActions,
        editorView.state,
        item,
        onInsert
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f09e868e0c8efa32$export$fa4d06fd361b5e56), {
            getIcon: item.icon,
            itemKey: item.key,
            label: ""
        }),
        isDisabled: isOffline,
        onSelect: onSelect,
        preview: item.preview,
        description: item.description,
        title: item.title
    });
};


























parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");

const $9737812674bae357$var$styles = {
    highlight: "_0KLXruDMqu _2NnhnEXpc7 _3iDTPbS8kF",
    start: "_0LQT5E1Y8M _03SyCP1Y8M _1uo2ZfsiTF",
    end: "_03SyCP1Y8M _1uo2ZfkCDT",
    wrapping: "_3zvHkHdC7N _1ANEUSzUZr",
    text: "_3zvHkHdC7N"
};
const $9737812674bae357$export$55feb0e4f341a6f6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { slug: slug, isDisabled: t1 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const t2 = isDisabled ? "color.text.disabled" : "color.text";
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $w6R6I.cx)($9737812674bae357$var$styles.highlight, $9737812674bae357$var$styles.start);
        $[0] = t3;
    } else t3 = $[0];
    const t4 = isDisabled ? "color.text.disabled" : "color.text.subtle";
    let t5;
    if ($[1] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            xcss: t3,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                color: t4,
                children: "/"
            })
        });
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    if ($[3] !== slug) {
        t6 = slug.slice(0, -1);
        $[3] = slug;
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            xcss: $9737812674bae357$var$styles.highlight,
            children: t6
        });
        $[5] = t6;
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== slug) {
        t8 = slug && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            xcss: (0, $w6R6I.cx)($9737812674bae357$var$styles.highlight, $9737812674bae357$var$styles.end),
            children: slug.slice(-1)
        });
        $[7] = slug;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t2 || $[10] !== t5 || $[11] !== t7 || $[12] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            xcss: $9737812674bae357$var$styles.wrapping,
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4aRua.Text), {
                color: t2,
                xcss: $9737812674bae357$var$styles.text,
                children: [
                    t5,
                    t7,
                    t8
                ]
            })
        });
        $[9] = t2;
        $[10] = t5;
        $[11] = t7;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    return t9;
} : ({ slug: slug, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "span",
        xcss: $9737812674bae357$var$styles.wrapping,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4aRua.Text), {
            color: isDisabled ? 'color.text.disabled' : 'color.text',
            xcss: $9737812674bae357$var$styles.text,
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    as: "span",
                    xcss: (0, $w6R6I.cx)($9737812674bae357$var$styles.highlight, $9737812674bae357$var$styles.start),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: isDisabled ? 'color.text.disabled' : 'color.text.subtle',
                        children: "/"
                    })
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    as: "span",
                    xcss: $9737812674bae357$var$styles.highlight,
                    children: slug.slice(0, -1)
                }),
                slug && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    as: "span",
                    xcss: (0, $w6R6I.cx)($9737812674bae357$var$styles.highlight, $9737812674bae357$var$styles.end),
                    children: slug.slice(-1)
                })
            ]
        })
    });






var $1l0kj = parcelRequire("1l0kj");






const $27de7c06c8b209e0$export$605ca0190b93d615 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { apiRef: apiRef, createAnalyticsEvent: createAnalyticsEvent, editorActions: editorActions, item: item, onInsert: onInsert } = t0;
    const { editorView: editorView, isOffline: isOffline } = (0, $9wgTc.useQuickInsertContext)();
    let t1;
    if ($[0] !== apiRef || $[1] !== createAnalyticsEvent || $[2] !== editorActions || $[3] !== editorView.state || $[4] !== item || $[5] !== onInsert) {
        t1 = (t2)=>{
            const { insert: insert, source: source } = t2;
            const result = (0, $8f196e56ef17ed5e$export$70dcc8733cd2c05e)({
                apiRef: apiRef,
                createAnalyticsEvent: createAnalyticsEvent,
                editorActions: editorActions,
                insert: insert,
                item: item,
                source: source,
                state: editorView.state
            });
            if (result) onInsert?.();
            return result;
        };
        $[0] = apiRef;
        $[1] = createAnalyticsEvent;
        $[2] = editorActions;
        $[3] = editorView.state;
        $[4] = item;
        $[5] = onInsert;
        $[6] = t1;
    } else t1 = $[6];
    const onSelect = t1;
    let t2;
    if ($[7] !== item.icon || $[8] !== item.key) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f09e868e0c8efa32$export$fa4d06fd361b5e56), {
            getIcon: item.icon,
            itemKey: item.key,
            label: ""
        });
        $[7] = item.icon;
        $[8] = item.key;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== item.icon || $[11] !== item.key) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f09e868e0c8efa32$export$fa4d06fd361b5e56), {
            getIcon: item.icon,
            itemKey: item.key,
            label: "",
            size: "small"
        });
        $[10] = item.icon;
        $[11] = item.key;
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== isOffline || $[14] !== item.moduleKey || $[15] !== item.title) {
        t4 = item.moduleKey ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9737812674bae357$export$55feb0e4f341a6f6), {
            isDisabled: isOffline,
            slug: item.moduleKey
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: isOffline ? "color.text.disabled" : "color.text",
            children: item.title
        });
        $[13] = isOffline;
        $[14] = item.moduleKey;
        $[15] = item.title;
        $[16] = t4;
    } else t4 = $[16];
    let t5;
    if ($[17] !== item.lozenge || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100",
            children: [
                t4,
                item.lozenge
            ]
        });
        $[17] = item.lozenge;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    let t6;
    if ($[20] !== isOffline || $[21] !== item.description || $[22] !== item.preview || $[23] !== item.title || $[24] !== onSelect || $[25] !== t2 || $[26] !== t3 || $[27] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
            ariaLabel: item.title,
            description: item.description,
            iconBefore: t2,
            isDisabled: isOffline,
            onSelect: onSelect,
            preview: item.preview,
            previewIcon: t3,
            shouldClampPreview: false,
            title: item.title,
            titleContent: t5
        });
        $[20] = isOffline;
        $[21] = item.description;
        $[22] = item.preview;
        $[23] = item.title;
        $[24] = onSelect;
        $[25] = t2;
        $[26] = t3;
        $[27] = t5;
        $[28] = t6;
    } else t6 = $[28];
    return t6;
} : ({ apiRef: apiRef, createAnalyticsEvent: createAnalyticsEvent, editorActions: editorActions, item: item, onInsert: onInsert })=>{
    const { editorView: editorView, isOffline: isOffline } = (0, $9wgTc.useQuickInsertContext)();
    const onSelect = (0, $cozmU.useCallback)(({ insert: insert, source: source })=>{
        const result = (0, $8f196e56ef17ed5e$export$70dcc8733cd2c05e)({
            apiRef: apiRef,
            createAnalyticsEvent: createAnalyticsEvent,
            editorActions: editorActions,
            insert: insert,
            item: item,
            source: source,
            state: editorView.state
        });
        if (result) onInsert?.();
        return result;
    }, [
        apiRef,
        createAnalyticsEvent,
        editorActions,
        editorView.state,
        item,
        onInsert
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        ariaLabel: item.title,
        description: item.description,
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f09e868e0c8efa32$export$fa4d06fd361b5e56), {
            getIcon: item.icon,
            itemKey: item.key,
            label: ""
        }),
        isDisabled: isOffline,
        onSelect: onSelect,
        preview: item.preview,
        previewIcon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f09e868e0c8efa32$export$fa4d06fd361b5e56), {
            getIcon: item.icon,
            itemKey: item.key,
            label: "",
            size: "small"
        }),
        shouldClampPreview: false,
        title: item.title,
        titleContent: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100",
            children: [
                item.moduleKey ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9737812674bae357$export$55feb0e4f341a6f6), {
                    isDisabled: isOffline,
                    slug: item.moduleKey
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    color: isOffline ? 'color.text.disabled' : 'color.text',
                    children: item.title
                }),
                item.lozenge
            ]
        })
    });
};


const $0c2fe7a4f6e05df3$var$structureExtensionItemKeyRanks = {
    'toc:toc': 600,
    [(0, $dCkbP.TABS_MENU_ITEM).key]: 1900,
    'cards:quick-insert': 2000,
    'carousel:quick-insert': 2100,
    'spotlight:quick-insert': 2200,
    'create-from-template:create-from-template': 2700,
    'anchor:anchor': 2900,
    'smart-button:quick-insert': 3000
};
const $0c2fe7a4f6e05df3$var$UNRECOGNIZED_STRUCTURE_EXTENSION_ITEM_RANK = 3100;
const $0c2fe7a4f6e05df3$var$APP_DATA_AND_CHARTS_ITEM_RANK = 2700;
const $0c2fe7a4f6e05df3$var$APP_EMBED_ITEM_RANK = (0, $dXqu3.EXTENSION_ITEM_RANK);
const $0c2fe7a4f6e05df3$var$APP_MEDIA_ITEM_RANK = Math.max(...Object.values((0, $dXqu3.MEDIA_SECTION_RANK))) + 100;
const $0c2fe7a4f6e05df3$var$APP_OTHER_ITEM_RANK = (0, $dXqu3.EXTENSION_ITEM_RANK);
const $0c2fe7a4f6e05df3$var$getStructureExtensionItemRank = (item)=>$0c2fe7a4f6e05df3$var$structureExtensionItemKeyRanks[item.key];
const $0c2fe7a4f6e05df3$var$isExtensionItemInSection = (item, sectionKey)=>(0, $79UEV.getQuickInsertMenuItemParents)({
        category: item.category,
        legacyCategories: item.categories,
        rank: 0
    }).some((parent)=>parent.key === sectionKey);
const $0c2fe7a4f6e05df3$var$compareMenuItemsByTitleAndKey = (firstItem, secondItem)=>firstItem.title.localeCompare(secondItem.title) || firstItem.key.localeCompare(secondItem.key);
const $0c2fe7a4f6e05df3$var$getAlphabeticalItemRanks = (items, isRankedItem, firstRank)=>new Map(items.filter(isRankedItem).sort($0c2fe7a4f6e05df3$var$compareMenuItemsByTitleAndKey).map((item, index)=>[
            item,
            firstRank + index
        ]));
const $0c2fe7a4f6e05df3$var$hasNoNegativePriority = (item)=>item.priority === undefined || item.priority >= 0;
const $0c2fe7a4f6e05df3$var$getSectionAlphabeticalItemRanks = (items, sectionKey, firstRank, isRankedItem = $0c2fe7a4f6e05df3$var$hasNoNegativePriority)=>$0c2fe7a4f6e05df3$var$getAlphabeticalItemRanks(items, (item)=>$0c2fe7a4f6e05df3$var$isExtensionItemInSection(item, sectionKey) && isRankedItem(item), firstRank);
// Rank each parent section separately so a macro in multiple categories gets the right order in each.
const $0c2fe7a4f6e05df3$var$createExtensionItemRanker = (items)=>{
    const sections = [
        [
            (0, $dCkbP.EMBED_SECTION).key,
            $0c2fe7a4f6e05df3$var$APP_EMBED_ITEM_RANK
        ],
        [
            (0, $dCkbP.MEDIA_SECTION).key,
            $0c2fe7a4f6e05df3$var$APP_MEDIA_ITEM_RANK
        ],
        [
            (0, $dCkbP.OTHER_SECTION).key,
            $0c2fe7a4f6e05df3$var$APP_OTHER_ITEM_RANK
        ],
        [
            (0, $dCkbP.STRUCTURE_SECTION).key,
            $0c2fe7a4f6e05df3$var$UNRECOGNIZED_STRUCTURE_EXTENSION_ITEM_RANK,
            (item)=>$0c2fe7a4f6e05df3$var$getStructureExtensionItemRank(item) === undefined
        ],
        [
            (0, $dCkbP.DATA_AND_CHARTS_SECTION).key,
            $0c2fe7a4f6e05df3$var$APP_DATA_AND_CHARTS_ITEM_RANK,
            (item)=>item.priority === undefined
        ]
    ];
    const ranksBySection = new Map(sections.map(([sectionKey, firstRank, isRankedItem])=>[
            sectionKey,
            $0c2fe7a4f6e05df3$var$getSectionAlphabeticalItemRanks(items, sectionKey, firstRank, isRankedItem)
        ]));
    return ({ index: index, knownRank: knownRank, item: item, sectionKey: sectionKey })=>{
        if (knownRank !== undefined) return knownRank;
        const sectionRank = ranksBySection.get(sectionKey)?.get(item);
        return sectionRank ?? (0, $dXqu3.EXTENSION_ITEM_RANK) + (item.priority ?? index);
    };
};
const $0c2fe7a4f6e05df3$export$52cb7b7c93bddc96 = ({ apiRef: apiRef, createAnalyticsEvent: createAnalyticsEvent, editorActions: editorActions, items: items })=>{
    const getExtensionItemRank = $0c2fe7a4f6e05df3$var$createExtensionItemRanker(items);
    return items.map((item, index)=>{
        const structureRank = $0c2fe7a4f6e05df3$var$getStructureExtensionItemRank(item);
        const isStructureItem = structureRank !== undefined;
        const categories = isStructureItem ? [
            'structure'
        ] : item.categories;
        const parents = (0, $79UEV.getQuickInsertMenuItemParents)({
            category: item.category,
            legacyCategories: categories,
            rank: 0
        });
        return {
            type: 'menu-item',
            key: item.key,
            parents: parents.map((parent)=>({
                    ...parent,
                    rank: getExtensionItemRank({
                        index: index,
                        knownRank: (0, $dXqu3.CREATE_SECTION_RANK)[item.key] ?? structureRank,
                        item: item,
                        sectionKey: parent.key
                    })
                })),
            match: (0, $7SMXM.createQuickInsertMatcher)(()=>({
                    description: item.description,
                    keywords: item.keywords,
                    title: item.title
                })),
            component: (props)=>{
                const Component = item.extensionType === 'com.atlassian.rovo.skill' ? (0, $27de7c06c8b209e0$export$605ca0190b93d615) : (0, $da493d6d3f5861ba$export$c56df9875b147e5d);
                return /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                    apiRef: apiRef,
                    createAnalyticsEvent: createAnalyticsEvent,
                    editorActions: editorActions,
                    item: item,
                    onInsert: props.onInsert
                });
            }
        };
    });
};


/**
 * Utils to send analytics event when an extension is inserted using quickInsert
 */ function $602531f9bab3fe89$var$sendExtensionQuickInsertAnalytics(item, selection, createAnalyticsEvent, source) {
    if (createAnalyticsEvent) {
        const insertLocation = (0, $24ZxJ.findInsertLocation)(selection);
        (0, $fdQKX.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION,
                attributes: {
                    extensionType: item.extensionType,
                    extensionKey: item.extensionKey,
                    key: item.key,
                    inputMethod: source || (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                    ...insertLocation ? {
                        insertLocation: insertLocation
                    } : {}
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            }
        });
    }
}
const $602531f9bab3fe89$var$showDummyAPIWarning = (location)=>{};
const $602531f9bab3fe89$var$dummyExtensionAPI = {
    editInContextPanel: ()=>$602531f9bab3fe89$var$showDummyAPIWarning('editInContextPanel'),
    _editInLegacyMacroBrowser: ()=>$602531f9bab3fe89$var$showDummyAPIWarning('_editInLegacyMacroBrowser'),
    getNodeWithPosByLocalId: ()=>({
            node: null,
            pos: null
        }),
    doc: {
        insertAfter: ()=>$602531f9bab3fe89$var$showDummyAPIWarning('doc:insertAfter'),
        scrollTo: ()=>$602531f9bab3fe89$var$showDummyAPIWarning('doc:scrollTo'),
        update: ()=>$602531f9bab3fe89$var$showDummyAPIWarning('doc:update')
    }
};
// Keep lazy icon component identities stable across menu unmounts and remounts.
const $602531f9bab3fe89$var$lazyExtensionIconCache = new WeakMap();
const $602531f9bab3fe89$var$LazyExtensionIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { iconLoader: iconLoader } = t0;
    let t1;
    if ($[0] !== iconLoader) {
        t1 = $602531f9bab3fe89$var$lazyExtensionIconCache.get(iconLoader);
        $[0] = iconLoader;
        $[1] = t1;
    } else t1 = $[1];
    let Icon = t1;
    if (!Icon) {
        if ($[2] !== iconLoader) {
            Icon = (0, $eRn3r.lazy)(()=>iconLoader());
            $602531f9bab3fe89$var$lazyExtensionIconCache.set(iconLoader, Icon);
            $[2] = iconLoader;
            $[3] = Icon;
        } else Icon = $[3];
    }
    let t2;
    if ($[4] !== Icon) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eRn3r.LazySuspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                label: ""
            })
        });
        $[4] = Icon;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ iconLoader: iconLoader })=>{
    let Icon = $602531f9bab3fe89$var$lazyExtensionIconCache.get(iconLoader);
    if (!Icon) {
        Icon = (0, $eRn3r.lazy)(()=>iconLoader());
        $602531f9bab3fe89$var$lazyExtensionIconCache.set(iconLoader, Icon);
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eRn3r.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: ""
        })
    });
};
async function $602531f9bab3fe89$export$6b0bb34c2583056f(extensionProvider, editorActions, apiRef, createAnalyticsEvent) {
    const extensions = await extensionProvider.getExtensions();
    const getMenuItems = ()=>(0, $50UK1.getQuickInsertItemsFromModule)(extensions, (item)=>item);
    return {
        getComponents: ()=>{
            const isMarkdownMode = apiRef.current?.markdownMode?.sharedState.currentState()?.isMarkdownMode;
            if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command') || isMarkdownMode) return Promise.resolve([]);
            return Promise.resolve((0, $0c2fe7a4f6e05df3$export$52cb7b7c93bddc96)({
                apiRef: apiRef,
                createAnalyticsEvent: createAnalyticsEvent,
                editorActions: editorActions,
                items: getMenuItems()
            }));
        },
        getItems: ()=>{
            // `extensionProvider` is supplied independently of the preset, so
            // suppress its items in markdown mode where rich-only content cannot
            // be inserted. See `MarkdownModeReader` above for why this is read
            // via a structural cast rather than the typed plugin API.
            const isMarkdownMode = apiRef.current?.markdownMode?.sharedState.currentState()?.isMarkdownMode;
            if (isMarkdownMode) return Promise.resolve([]);
            const quickInsertItems = (0, $50UK1.getQuickInsertItemsFromModule)(extensions, (item)=>{
                return {
                    ...((0, $4o0zT.isExperimentEnabled)('platform_editor_slash_app_category_analytics') || (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command')) && item.app ? {
                        app: item.app
                    } : {},
                    // Add module key so typeahead/quick-insert can identify items
                    // **locale-agnostically**! nb: we _already_ send key in analytics
                    // events, this standardises and makes our items more predictable.
                    key: item.key,
                    title: item.title,
                    description: item.description,
                    ...item.preview ? {
                        preview: item.preview
                    } : {},
                    icon: ()=>{
                        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_loosely_lazy_migration')) return /*#__PURE__*/ (0, $8aG6j.jsx)($602531f9bab3fe89$var$LazyExtensionIcon, {
                            iconLoader: item.icon
                        });
                        const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
                            __loadable_id__: "N8xjw",
                            name: "Icon",
                            loader: item.icon,
                            loading: ()=>null
                        });
                        return /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                            label: ""
                        });
                    },
                    keywords: item.keywords,
                    featured: item.featured,
                    priority: item.priority,
                    ...item.category ? {
                        category: item.category
                    } : {},
                    categories: item.categories,
                    ...item.lozenge != null && {
                        lozenge: item.lozenge
                    },
                    isDisabledOffline: true,
                    // This legacy action intentionally mirrors executeExtensionQuickInsertItem,
                    // which serves the registered representation of the same item.
                    action: (insert, state, source)=>{
                        if (typeof item.node === 'function') {
                            const extensionAPI = apiRef?.current?.extension?.actions?.api();
                            // While this should only run when the extension some setups of editor
                            // may not have the extension API
                            if (extensionAPI) (0, $2sp5n.resolveImport)(item.node(extensionAPI)).then((node)=>{
                                $602531f9bab3fe89$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            else // Originally it was understood we could only use this if we were using the extension plugin
                            // However there are some edge cases where this is not true (ie. in jira)
                            // Since making it optional now would be a breaking change - instead we can just pass a dummy extension API to consumers that warns them of using the methods.
                            (0, $2sp5n.resolveImport)(item.node($602531f9bab3fe89$var$dummyExtensionAPI)).then((node)=>{
                                $602531f9bab3fe89$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            return insert('');
                        } else {
                            $602531f9bab3fe89$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                            return insert(item.node);
                        }
                    }
                };
            });
            return Promise.all(quickInsertItems);
        }
    };
}


function $baa17283ad47b684$export$2e2bcd8739ae039(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent) {
    const quickInsertProvider = quickInsert && typeof quickInsert !== 'boolean' && quickInsert.provider;
    const extensionQuickInsertProvider = extensionProvider && (0, $602531f9bab3fe89$export$6b0bb34c2583056f)(extensionProvider, editorActions, apiRef, createAnalyticsEvent);
    return quickInsertProvider && extensionQuickInsertProvider ? Promise.resolve((0, $6e2a446e851426a9$export$e3759a254d73dcb7)([
        quickInsertProvider,
        extensionQuickInsertProvider
    ])) : quickInsertProvider || extensionQuickInsertProvider;
}


function $6662f6d4ac13a85c$export$2e2bcd8739ae039({ autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider }) {
    return {
        emojiProvider: emojiProvider,
        mentionProvider: mentionProvider,
        autoformattingProvider: autoformattingProvider,
        activityProvider: activityProvider,
        imageUploadProvider: legacyImageUploadProvider,
        taskDecisionProvider: taskDecisionProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        searchProvider: searchProvider,
        presenceProvider: presenceProvider,
        macroProvider: macroProvider,
        collabEditProvider: collabEdit?.provider ? collabEdit.provider : collabEditProvider
    };
}


function $84a340670f6be41c$export$2e2bcd8739ae039(providerFactory, { mentionProvider: mentionProvider, contextIdentifierProvider: contextIdentifierProvider, collabEditProvider: collabEditProvider, activityProvider: activityProvider, presenceProvider: presenceProvider, macroProvider: macroProvider, imageUploadProvider: imageUploadProvider, searchProvider: searchProvider }, extensionProvider, quickInsertProvider) {
    providerFactory.setProvider('mentionProvider', mentionProvider);
    providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider);
    providerFactory.setProvider('imageUploadProvider', imageUploadProvider);
    providerFactory.setProvider('collabEditProvider', collabEditProvider);
    providerFactory.setProvider('activityProvider', activityProvider);
    providerFactory.setProvider('searchProvider', searchProvider);
    providerFactory.setProvider('presenceProvider', presenceProvider);
    providerFactory.setProvider('macroProvider', macroProvider);
    if (extensionProvider) providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
    if (quickInsertProvider) providerFactory.setProvider('quickInsertProvider', quickInsertProvider);
}


const $e6311569e6ca82c1$var$useEditorRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useEditorRef(preset) {
    const $ = (0, $bDgLe.c)(4);
    const apiRef = (0, $cozmU.useRef)();
    let t0;
    if ($[0] !== preset?.apiResolver) {
        t0 = ()=>preset?.apiResolver.on((api)=>{
                apiRef.current = api;
            });
        $[0] = preset?.apiResolver;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = preset?.apiResolver;
    let t2;
    if ($[2] !== t1) {
        t2 = [
            t1
        ];
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    (0, $cozmU.useEffect)(t0, t2);
    return apiRef;
} : function useEditorRef(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset) {
    const apiRef = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        return preset?.apiResolver.on((api)=>{
            apiRef.current = api;
        });
    }, [
        preset?.apiResolver
    ]);
    return apiRef;
};
function $e6311569e6ca82c1$var$prepareProviders(editorActions, apiRef, quickInsert, extensionProviders, createAnalyticsEvent) {
    const extensionProvider = (0, $2f21ee47948a0a2a$export$2e2bcd8739ae039)(()=>editorActions)(extensionProviders);
    const quickInsertProvider = (0, $baa17283ad47b684$export$2e2bcd8739ae039)(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent);
    return {
        extensionProvider: extensionProvider,
        quickInsertProvider: quickInsertProvider
    };
}
function $e6311569e6ca82c1$export$2e2bcd8739ae039(props, editorActions, createAnalyticsEvent) {
    const { autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider, quickInsert: quickInsert, extensionProviders: extensionProviders } = props;
    const providers = (0, $cozmU.useMemo)(()=>(0, $6662f6d4ac13a85c$export$2e2bcd8739ae039)({
            autoformattingProvider: autoformattingProvider,
            emojiProvider: emojiProvider,
            mentionProvider: mentionProvider,
            legacyImageUploadProvider: legacyImageUploadProvider,
            taskDecisionProvider: taskDecisionProvider,
            contextIdentifierProvider: contextIdentifierProvider,
            searchProvider: searchProvider,
            macroProvider: macroProvider,
            activityProvider: activityProvider,
            collabEdit: collabEdit,
            collabEditProvider: collabEditProvider,
            presenceProvider: presenceProvider
        }), [
        autoformattingProvider,
        emojiProvider,
        mentionProvider,
        legacyImageUploadProvider,
        taskDecisionProvider,
        contextIdentifierProvider,
        searchProvider,
        macroProvider,
        activityProvider,
        collabEdit,
        collabEditProvider,
        presenceProvider
    ]);
    const providerFactory = (0, $cozmU.useRef)(new (0, $eNbr2.default)());
    const editorRef = $e6311569e6ca82c1$var$useEditorRef(props.preset);
    const preparedProviders = (0, $cozmU.useMemo)(()=>// Though this will introduce some performance regression related to quick insert
        // loading but we can remove it soon when Forge will move to new API.
        // quickInsert={Promise.resolve(consumerQuickInsert)} is one of the main reason behind this performance issue.
        $e6311569e6ca82c1$var$prepareProviders(editorActions, editorRef, quickInsert, extensionProviders, createAnalyticsEvent), [
        extensionProviders,
        quickInsert,
        editorActions,
        createAnalyticsEvent,
        editorRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        (0, $84a340670f6be41c$export$2e2bcd8739ae039)(providerFactory.current, providers, preparedProviders.extensionProvider, preparedProviders.quickInsertProvider);
    }, [
        providers,
        preparedProviders
    ]);
    // componentWillUnmount equivalent
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // Disable this next line because it is not a React node
            // so we can safely call destroy on the ref.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            providerFactory.current.destroy();
        };
    }, []);
    return providerFactory.current;
}



/**
 * Editor wrapper that deals with the lifecycle logic of the editor
 * @param passedProps
 * @example
 */ function $5d26494cc0b5561d$var$Editor(passedProps) {
    const propsRef = (0, $cozmU.useRef)(passedProps);
    const props = (0, $4576bd37d6bd92fc$export$2e2bcd8739ae039)(passedProps);
    (0, $cozmU.useMemo)(()=>{
        propsRef.current = props;
    }, [
        props
    ]);
    const editorContext = (0, $d7j1D.useEditorContext)();
    const editorActionsPlaceholderInstance = (0, $cozmU.useMemo)(()=>new (0, $bMenv.default)(), []);
    const editorActions = editorContext.editorActions || editorActionsPlaceholderInstance;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleAnalyticsEvent = (0, $cozmU.useCallback)((data)=>{
        (0, $fdQKX.fireAnalyticsEvent)(createAnalyticsEvent)(data);
    }, [
        createAnalyticsEvent
    ]);
    const getFeatureFlagsFromRef = (0, $cozmU.useCallback)(()=>{
        return {
            ...(0, $cfjQo.createFeatureFlagsFromProps)(propsRef.current.featureFlags),
            useNativeCollabPlugin: Boolean(typeof propsRef.current.collabEdit?.useNativePlugin === 'boolean' ? !!propsRef.current.collabEdit?.useNativePlugin : false)
        };
    }, []);
    const onEditorCreated = (0, $cozmU.useCallback)((instance)=>{
        const { contextIdentifierProvider: contextIdentifierProvider, onEditorReady: onEditorReady, featureFlags: featureFlags } = propsRef.current;
        editorActions._privateRegisterEditor(instance.view, instance.eventDispatcher, instance.transformer, getFeatureFlagsFromRef);
        if (onEditorReady) {
            (0, $hiQdW.startMeasure)((0, $l5aTW.default).ON_EDITOR_READY_CALLBACK);
            onEditorReady(editorActions);
            (0, $hiQdW.stopMeasure)((0, $l5aTW.default).ON_EDITOR_READY_CALLBACK, (0, $daf2a725862e8da8$export$2e2bcd8739ae039)((0, $krYZG.ACTION).ON_EDITOR_READY_CALLBACK, {
                contextIdentifierProvider: contextIdentifierProvider,
                featureFlags: featureFlags
            }, createAnalyticsEvent));
        }
    }, [
        editorActions,
        createAnalyticsEvent,
        getFeatureFlagsFromRef,
        propsRef
    ]);
    const onEditorDestroyed = (0, $cozmU.useCallback)((_instance)=>{
        const { onDestroy: onDestroy } = propsRef.current;
        editorActions._privateUnregisterEditor();
        if (onDestroy) onDestroy();
    }, [
        editorActions,
        propsRef
    ]);
    (0, $7312ea02580709f6$export$2e2bcd8739ae039)(props, createAnalyticsEvent);
    const providerFactory = (0, $e6311569e6ca82c1$export$2e2bcd8739ae039)(props, editorActions, createAnalyticsEvent);
    const { onSave: onSaveFromProps } = props;
    const handleSave = (0, $cozmU.useCallback)((view)=>{
        if (onSaveFromProps) onSaveFromProps(view);
    }, [
        onSaveFromProps
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dbf08bc9eeed0fa4$export$2617c0dabe49c335), {
        props: props,
        handleAnalyticsEvent: handleAnalyticsEvent,
        createAnalyticsEvent: createAnalyticsEvent,
        preset: props.preset,
        handleSave: handleSave,
        editorActions: editorActions,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        providerFactory: providerFactory,
        AppearanceComponent: props.AppearanceComponent
    });
}
const $5d26494cc0b5561d$var$useMemoEditorFeatureFlags = (featureFlags)=>{
    const ffRef = (0, $cozmU.useRef)(featureFlags);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(ffRef.current, featureFlags)) ffRef.current = featureFlags;
    return ffRef.current;
};
function $5d26494cc0b5561d$export$be7eaacc86ce4514(props) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const editorSessionId = (0, $cozmU.useRef)((0, $03RpJ.default)());
    const data = (0, $cozmU.useMemo)(()=>{
        return {
            packageName: (0, $kLi51.name),
            packageVersion: (0, $kLi51.version),
            componentName: 'editorCore',
            appearance: (0, $6pnwK.getAnalyticsAppearance)(props.appearance),
            editorSessionId: editorSessionId.current
        };
    }, [
        props.appearance
    ]);
    const memodEditorFeatureFlags = $5d26494cc0b5561d$var$useMemoEditorFeatureFlags(props.featureFlags);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kLVNa.FabricEditorAnalyticsContext), {
        // @ts-expect-error Type 'string' is not assignable to type '"editorCore" | "renderer"'.
        data: data,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($5d26494cc0b5561d$var$Editor, {
            ...props,
            featureFlags: memodEditorFeatureFlags
        })
    });
}
$5d26494cc0b5561d$export$be7eaacc86ce4514.propTypes = {
    minHeight: ({ appearance: appearance, minHeight: minHeight })=>{
        if (minHeight && appearance && ![
            'comment',
            'chromeless'
        ].includes(appearance)) return new Error('minHeight only supports editor appearance chromeless and comment for Editor');
        return null;
    }
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$5d26494cc0b5561d$export$2e2bcd8739ae039 = $5d26494cc0b5561d$export$be7eaacc86ce4514;
module.exports["CoreEditor"] = $5d26494cc0b5561d$export$be7eaacc86ce4514;

});

parcelRegister("fdQKX", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

var $38527dcddae4233e$var$_AnalyticsQueue;
class $38527dcddae4233e$export$b44c4ba8fe19bbc7 {
    request(fn) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.requestIdleCallback) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(fn);
        else {
            const start = performance.now();
            setTimeout(()=>{
                fn({
                    didTimeout: false,
                    timeRemaining: ()=>Math.max(0, 50 - (performance.now() - start))
                });
            }, 0);
        }
    }
    pending() {
        // Defensive coding as navigator.scheduling.isInputPending is an experimental API
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof window.navigator?.scheduling?.isInputPending === 'function') // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return window.navigator?.scheduling?.isInputPending() === true;
        return false;
    }
    process() {
        if (this.running) return;
        this.running = true;
        this.request((deadline)=>{
            while(deadline.timeRemaining() > 0 && this.tasks.length > 0 && !this.pending()){
                const task = this.tasks.shift();
                if (task) task();
            }
            this.running = false;
            if (this.tasks.length > 0) this.process();
        });
    }
    schedule(task) {
        this.tasks.push(task);
        this.process();
    }
    constructor(){
        this.tasks = [];
        this.running = false;
    }
}
$38527dcddae4233e$var$_AnalyticsQueue = $38527dcddae4233e$export$b44c4ba8fe19bbc7;
$38527dcddae4233e$export$b44c4ba8fe19bbc7.get = (0, $dOBRD.default)(()=>new $38527dcddae4233e$var$_AnalyticsQueue());



var $llCol = parcelRequire("llCol");

const $32028436c2965b29$export$c7d191551feb734 = (createAnalyticsEvent, options)=>({ payload: payload, channel: channel = (0, $llCol.editorAnalyticsChannel) })=>{
        if (!createAnalyticsEvent) return;
        if (options?.immediate) {
            createAnalyticsEvent(payload)?.fire(channel);
            return;
        }
        const queue = (0, $38527dcddae4233e$export$b44c4ba8fe19bbc7).get();
        queue.schedule(()=>createAnalyticsEvent(payload)?.fire(channel));
    };
module.exports["fireAnalyticsEvent"] = $32028436c2965b29$export$c7d191551feb734;

});

parcelRegister("bMenv", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $fGIRV = parcelRequire("fGIRV");


var $4yKbg = parcelRequire("4yKbg");

var $5Qi6J = parcelRequire("5Qi6J");


var $6pnwK = parcelRequire("6pnwK");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");

// Please, do not copy or use this kind of code below
// @ts-ignore
const $bdd76a172a46a443$var$mediaPluginKey = {
    key: 'mediaPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['mediaPlugin$'];
    }
};
async function $bdd76a172a46a443$export$99c45752ffdaa598(editorView) {
    const mediaPluginState = editorView.state && $bdd76a172a46a443$var$mediaPluginKey.getState(editorView.state);
    if (mediaPluginState && mediaPluginState.waitForMediaUpload) await mediaPluginState.waitForPendingTasks();
    return editorView.state.doc;
}


function $e0b321aad7f99a44$var$deprecationWarnings(className, props, deprecations) {
    return;
}
var $e0b321aad7f99a44$export$2e2bcd8739ae039 = $e0b321aad7f99a44$var$deprecationWarnings;


const $d4f6dff3dc6ba901$export$1dc8bea8646ac811 = (state, ids)=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    state.doc.descendants((node, pos)=>{
        const fragmentLocalIdList = node.marks?.filter((m)=>m.type.name === 'fragment').map((m)=>m.attrs?.localId).filter((id)=>id && localIdSet.has(id));
        if (fragmentLocalIdList.length > 0) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};


/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ function $369a0c252ad09608$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}


function $8e6a292c4eeeb45a$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return (0, $369a0c252ad09608$export$b648602b09795358)(nodeChild);
}


/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ const $9277c5385f5e04e7$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};


/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ 
var $2lPWP = parcelRequire("2lPWP");

const $a5488b88d6117635$var$transformer = new (0, $2lPWP.JSONTransformer)();
function $a5488b88d6117635$export$54fd2c36b5cc6731(node) {
    return $a5488b88d6117635$var$transformer.encode(node);
}


// Please, do not copy or use this kind of code below
// @ts-ignore
const $70857b72fb9f79c6$var$fakePluginKey = {
    key: 'nativeCollabProviderPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['nativeCollabProviderPlugin$'];
    }
};
class $70857b72fb9f79c6$export$2e2bcd8739ae039 {
    static from(view, eventDispatcher, transformer) {
        const editorActions = new $70857b72fb9f79c6$export$2e2bcd8739ae039();
        editorActions._privateRegisterEditor(view, eventDispatcher, transformer);
        return editorActions;
    }
    //#region private
    // This method needs to be public for context based helper components.
    _privateGetEditorView() {
        return this.editorView;
    }
    _privateGetEventDispatcher() {
        return this.eventDispatcher;
    }
    getFeatureFlags() {
        return {};
    }
    // This method needs to be public for EditorContext component.
    _privateRegisterEditor(editorView, eventDispatcher, contentTransformer, getFeatureFlags = ()=>({})) {
        this.contentTransformer = contentTransformer;
        this.eventDispatcher = eventDispatcher;
        this.getFeatureFlags = getFeatureFlags;
        if (!this.editorView && editorView) {
            this.editorView = editorView;
            this.listeners.forEach((cb)=>cb(editorView, eventDispatcher));
        } else if (this.editorView !== editorView) throw new Error("Editor has already been registered! It's not allowed to re-register editor with the new Editor instance.");
        if (this.contentTransformer) this.contentEncode = this.contentTransformer.encode.bind(this.contentTransformer);
    }
    // This method needs to be public for EditorContext component.
    _privateUnregisterEditor() {
        this.editorView = undefined;
        this.contentTransformer = undefined;
        this.contentEncode = undefined;
        this.eventDispatcher = undefined;
        this.getFeatureFlags = ()=>({});
    }
    _privateSubscribe(cb) {
        // If editor is registered and somebody is trying to add a listener,
        // just call it first.
        if (this.editorView && this.eventDispatcher) cb(this.editorView, this.eventDispatcher);
        this.listeners.push(cb);
    }
    _privateUnsubscribe(cb) {
        this.listeners = this.listeners.filter((c)=>c !== cb);
    }
    //#endregion
    focus({ scrollIntoView: scrollIntoView } = {
        scrollIntoView: true
    }) {
        if (!this.editorView || this.editorView.hasFocus()) return false;
        this.editorView.focus();
        if (scrollIntoView ?? true) this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        return true;
    }
    blur() {
        if (!this.editorView || !this.editorView.hasFocus()) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorView.dom.blur();
        return true;
    }
    clear() {
        if (!this.editorView) return false;
        const editorView = this.editorView;
        const { state: state } = editorView;
        const tr = editorView.state.tr.setSelection((0, $kCECX.TextSelection).create(state.doc, 0, state.doc.nodeSize - 2)).deleteSelection();
        editorView.dispatch(tr);
        return true;
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated This is deprecated and is no longer maintained.
   *
   * Use the `requestDocument` API from `editorAPI` (ie. `editorApi?.core?.actions.requestDocument( ... ))
   * it has inbuilt throttling and is designed for use with `ComposableEditor`.
   *
   * Docs on its usage are available from: https://atlaskit.atlassian.com/packages/editor/editor-core
   *
   * WARNING: this may be called repeatedly, async with care
   */ async getValue() {
        const { editorView: editorView } = this;
        if (!editorView) return;
        const doc = await (0, $bdd76a172a46a443$export$99c45752ffdaa598)(editorView);
        const json = (0, $a5488b88d6117635$export$54fd2c36b5cc6731)(doc);
        if (!this.contentEncode) return json;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nodeSanitized = (0, $aPdNQ.Node).fromJSON(this.editorView.state.schema, json);
        try {
            return this.contentEncode(nodeSanitized);
        } catch (e) {
            this.dispatchAnalyticsEvent({
                action: (0, $krYZG.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
                }
            });
            throw e;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated - please use `getNodeWithPosByLocalId` found in the core plugin actions instead
   * @example
    	const { editorApi, preset } = usePreset(...);
  	const extensionAPI = editorAPI?.extension?.actions?.api();
  	// Use nodeWithPos as desired
  	const nodeWithPos = extensionAPI.getNodeWithPosByLocalId(localId);
  	const node = nodeWithPos.node;
  	const nodePos = nodeWithPos.pos;
   */ getNodeByLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $9277c5385f5e04e7$export$947fc26275418e36)(this.editorView?.state, [
                id
            ]);
            const node = nodes.length >= 1 ? nodes[0] : undefined;
            return node?.node;
        }
    }
    getNodeByFragmentLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $d4f6dff3dc6ba901$export$1dc8bea8646ac811)(this.editorView?.state, [
                id
            ]);
            return nodes.length > 0 ? nodes[0].node : undefined;
        }
    }
    /**
   * This method will return the currently selected `Node` if the selection is a `Node`.
   * Otherwise, if the selection is textual or a non-selectable `Node` within another selectable `Node`, the closest selectable parent `Node` will be returned.
   */ getSelectedNode() {
        if (this.editorView?.state?.selection) {
            const { selection: selection } = this.editorView.state;
            if (selection instanceof (0, $kCECX.NodeSelection)) return selection.node;
            return (0, $bjg0G.findParentNode)((node)=>Boolean(node.type.spec.selectable))(selection)?.node;
        }
    }
    isDocumentEmpty() {
        // Unlikely case when editorView has been destroyed before calling isDocumentEmpty,
        // we treat this case as if document was empty.
        if (!this.editorView) return true;
        return (0, $8e6a292c4eeeb45a$export$2da47a16c0b6bcb)(this.editorView.state.doc);
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated - please use `replaceDocument` found in the core plugin actions instead
   * using this will reset your Editor State which could cause some things to break (like emojis)
   * @example - use the `replaceDocument` from the core plugin actions instead
   * ```ts
   * const { editorApi, preset } = usePreset(...);
  	// where you need it
  	editorApi?.core.actions.replaceDocument(value);
  	return <ComposableEditor preset={preset} ... />
   */ replaceDocument(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    rawValue, shouldScrollToBottom = true, // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /** @deprecated [ED-14158] shouldAddToHistory is not being used in this function */ shouldAddToHistory = true) {
        (0, $e0b321aad7f99a44$export$2e2bcd8739ae039)('EditorActions.replaceDocument', {
            shouldAddToHistory: shouldAddToHistory
        }, [
            {
                property: 'shouldAddToHistory',
                description: '[ED-14158] EditorActions.replaceDocument does not use the shouldAddToHistory arg',
                type: 'removed'
            }
        ]);
        if (!this.editorView || rawValue === undefined || rawValue === null) return false;
        if (this.eventDispatcher) this.eventDispatcher.emit('resetEditorState', {
            doc: rawValue,
            shouldScrollToBottom: shouldScrollToBottom
        });
        return true;
    }
    replaceSelection(rawValue, tryToReplace, position) {
        if (!this.editorView) return false;
        const { state: state } = this.editorView;
        if (!rawValue) {
            const tr = state.tr.deleteSelection().scrollIntoView();
            this.editorView.dispatch(tr);
            return true;
        }
        const { schema: schema } = state;
        const content = Array.isArray(rawValue) ? (0, $4yKbg.processRawFragmentValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent) : (0, $5Qi6J.processRawValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent);
        if (!content) return false;
        // try to find a place in the document where to insert a node if its not allowed at the cursor position by schema
        this.editorView.dispatch((0, $bjg0G.safeInsert)(content, position, tryToReplace)(state.tr).scrollIntoView());
        return true;
    }
    appendText(text) {
        if (!this.editorView || !text) return false;
        const { state: state } = this.editorView;
        const lastChild = state.doc.lastChild;
        if (lastChild && lastChild.type !== state.schema.nodes.paragraph) return false;
        const tr = state.tr.insertText(text).scrollIntoView();
        this.editorView.dispatch(tr);
        return true;
    }
    constructor(){
        this.editorView = void 0;
        this.contentTransformer = void 0;
        this.contentEncode = void 0;
        this.eventDispatcher = void 0;
        this.listeners = [];
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $fGIRV.createDispatch)(this.eventDispatcher);
                dispatch((0, $6pnwK.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        /**
     * If editor is using new collab service,
     * we want editor to call the collab provider to
     * retrieve the final acknowledged state of the
     * editor. The final acknowledged editor state
     * refers to the latest state of editor with confirmed
     * steps.
     */ this.getResolvedEditorState = async (reason)=>{
            const { useNativeCollabPlugin: useNativeCollabPlugin } = this.getFeatureFlags();
            if (!this.editorView) throw new Error('Called getResolvedEditorState before editorView is ready');
            if (!useNativeCollabPlugin) {
                const editorValue = await this.getValue();
                if (!editorValue) throw new Error('editorValue is undefined');
                return {
                    content: editorValue,
                    title: null,
                    stepVersion: -1
                };
            }
            const editorView = this.editorView;
            await (0, $bdd76a172a46a443$export$99c45752ffdaa598)(editorView);
            const collabEditState = $70857b72fb9f79c6$var$fakePluginKey.getState(editorView.state);
            return collabEditState?.getFinalAcknowledgedState(reason);
        };
    }
}
module.exports["default"] = $70857b72fb9f79c6$export$2e2bcd8739ae039;

});

parcelRegister("fGIRV", function(module, exports) {
class $c53354d582568dcf$export$ec8b666c5fe2c75a {
    on(event, cb) {
        if (!this.listeners[event]) this.listeners[event] = new Set();
        this.listeners[event].add(cb);
    }
    has(event, cb) {
        if (!this.listeners[event]) return false;
        return this.listeners[event].has(cb);
    }
    off(event, cb) {
        if (!this.listeners[event]) return;
        if (this.listeners[event].has(cb)) this.listeners[event].delete(cb);
    }
    emit(event, data) {
        if (!this.listeners[event]) return;
        this.listeners[event].forEach((cb)=>cb(data));
    }
    destroy() {
        this.listeners = {};
    }
    constructor(){
        this.listeners = {};
    }
}
function $c53354d582568dcf$var$getEventFromEventName(eventName) {
    return typeof eventName === 'string' ? eventName : eventName.key;
}
function $c53354d582568dcf$export$f57f9cc7ce57b7d0(eventDispatcher) {
    return (eventName, data)=>{
        if (!eventName) throw new Error('event name is required!');
        eventDispatcher.emit($c53354d582568dcf$var$getEventFromEventName(eventName), data);
    };
}
module.exports["EventDispatcher"] = $c53354d582568dcf$export$ec8b666c5fe2c75a;
module.exports["createDispatch"] = $c53354d582568dcf$export$f57f9cc7ce57b7d0;

});

parcelRegister("d7j1D", function(module, exports) {
$parcel$export(module.exports, "default", () => $727a3aade04b357e$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $54Cdh = parcelRequire("54Cdh");


var $bMenv = parcelRequire("bMenv");

const $727a3aade04b357e$export$b119c82498f162a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $54Cdh.EditorContext));
} : ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $54Cdh.EditorContext));
class $727a3aade04b357e$export$797df872f5526664 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $54Cdh.EditorContext).Provider, {
            value: this.contextValue,
            children: this.props.children
        });
    }
    constructor(props){
        super(props);
        this.editorActions = void 0;
        this.contextValue = void 0;
        this.editorActions = props.editorActions || new (0, $bMenv.default)();
        this.contextValue = {
            editorActions: this.editorActions
        };
    }
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$727a3aade04b357e$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)($727a3aade04b357e$export$797df872f5526664, {
        editorActions: props.editorActions,
        children: props.children
    });
module.exports["useEditorContext"] = $727a3aade04b357e$export$b119c82498f162a5;

});

parcelRegister("54Cdh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $b222e785b7cdab12$export$27b8dd149e32f6c7 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({});
module.exports["EditorContext"] = $b222e785b7cdab12$export$27b8dd149e32f6c7;

});

parcelRegister("cfjQo", function(module, exports) {

var $3ppaK = parcelRequire("3ppaK");

function $501aac92770cc41c$var$verifyJSON(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return undefined;
    }
}
function $501aac92770cc41c$var$getSpellCheck(featureFlags) {
    if (!!featureFlags?.['disableSpellcheckByBrowser']) return typeof featureFlags?.['disableSpellcheckByBrowser'] === 'object' ? featureFlags?.['disableSpellcheckByBrowser'] : typeof featureFlags?.['disableSpellcheckByBrowser'] === 'string' ? $501aac92770cc41c$var$verifyJSON(featureFlags?.['disableSpellcheckByBrowser']) : undefined;
    if (!!featureFlags?.['disable-spellcheck-by-browser']) return typeof featureFlags?.['disable-spellcheck-by-browser'] === 'object' ? featureFlags?.['disable-spellcheck-by-browser'] : typeof featureFlags?.['disable-spellcheck-by-browser'] === 'string' ? $501aac92770cc41c$var$verifyJSON(featureFlags?.['disable-spellcheck-by-browser']) : undefined;
    return undefined;
}
function $501aac92770cc41c$export$63102b0cbe181144(featureFlags) {
    const normalizedFeatureFlags = (0, $3ppaK.normalizeFeatureFlags)(featureFlags);
    return {
        ...normalizedFeatureFlags,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: Boolean(typeof featureFlags?.showAvatarGroupAsPlugin === 'boolean' ? !!featureFlags?.showAvatarGroupAsPlugin : false),
        errorBoundaryDocStructure: Boolean(typeof featureFlags?.useErrorBoundaryDocStructure === 'boolean' ? !!featureFlags?.useErrorBoundaryDocStructure : false),
        synchronyErrorDocStructure: Boolean(typeof featureFlags?.synchronyErrorDocStructure === 'boolean' ? !!featureFlags?.synchronyErrorDocStructure : false),
        enableViewUpdateSubscription: Boolean(typeof featureFlags?.enableViewUpdateSubscription === 'boolean' ? !!featureFlags?.enableViewUpdateSubscription : false),
        collabAvatarScroll: Boolean(typeof featureFlags?.collabAvatarScroll === 'boolean' ? !!featureFlags?.collabAvatarScroll : false),
        twoLineEditorToolbar: Boolean(typeof featureFlags?.twoLineEditorToolbar === 'boolean' ? !!featureFlags?.twoLineEditorToolbar : false),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        disableSpellcheckByBrowser: $501aac92770cc41c$var$getSpellCheck(featureFlags)
    };
}
module.exports["createFeatureFlagsFromProps"] = $501aac92770cc41c$export$63102b0cbe181144;

});

parcelRegister("l5aTW", function(module, exports) {
$parcel$export(module.exports, "default", () => $54c8a23d08d7c650$export$2e2bcd8739ae039);
var $54c8a23d08d7c650$export$2e2bcd8739ae039 = {
    EDITOR_MOUNTED: 'Editor Component Mount Time',
    PROSEMIRROR_RENDERED: 'ProseMirror Render Time',
    PROSEMIRROR_CONTENT_RENDERED: 'ProseMirror Content Render Time',
    ON_EDITOR_READY_CALLBACK: 'onEditorReady Callback Duration'
};

});

parcelRegister("kLi51", function(module, exports) {
const $91fd91bb9a8be6c3$export$a8ff84c12d48cfa6 = "platform-pkg";
const $91fd91bb9a8be6c3$export$83d89fbfd8236492 = "0.0.0-use.local";
module.exports["name"] = $91fd91bb9a8be6c3$export$a8ff84c12d48cfa6;
module.exports["version"] = $91fd91bb9a8be6c3$export$83d89fbfd8236492;

});

parcelRegister("8ROsu", function(module, exports) {
const $066ee88f128786d6$var$hash = {
    nodes: {
        doc: 'doc',
        paragraph: 'p',
        text: 't',
        bulletList: 'ul',
        orderedList: 'ol',
        listItem: 'li',
        heading: 'h',
        blockquote: 'blockq',
        codeBlock: 'codebl',
        panel: 'pnl',
        rule: 'rl',
        hardBreak: 'br',
        mention: 'ment',
        emoji: 'emj',
        image: 'img',
        caption: 'cap',
        media: 'media',
        mediaGroup: 'mediag',
        mediaSingle: 'medias',
        plain: 'pln',
        table: 'table',
        tableCell: 'td',
        tableHeader: 'th',
        tableRow: 'tr',
        decisionList: 'dl',
        decisionItem: 'di',
        taskList: 'tl',
        taskItem: 'ti',
        extension: 'ext',
        inlineExtension: 'exti',
        bodiedExtension: 'extb',
        multiBodiedExtension: 'extmbe',
        extensionFrame: 'extfrm',
        status: 'sts',
        placeholder: 'plh',
        inlineCard: 'cardi',
        blockCard: 'cardb',
        embedCard: 'carde',
        expand: 'exp',
        nestedExpand: 'expn',
        unsupportedBlock: 'unsupb',
        unsupportedInline: 'unsupi',
        unknownBlock: 'unkb',
        date: 'date'
    },
    marks: {
        em: 'em',
        strong: 'strong',
        code: 'code',
        strike: 'strike',
        underline: 'undline',
        link: 'lnk',
        subsup: 'subsup',
        textColor: 'txtclr',
        unsupportedMark: 'unsupmrk',
        unsupportedNodeAttribute: 'unsupnattr',
        annotation: 'anno'
    }
};
function $066ee88f128786d6$var$shortHash(type, isMark) {
    const code = $066ee88f128786d6$var$hash[isMark ? 'marks' : 'nodes'][type];
    return code ? code : type;
}
function $066ee88f128786d6$var$compactStringifier(node) {
    const isContentEmpty = !node.content;
    const isTextNode = node?.type === 'text';
    const hasMarks = node.marks?.length;
    const isContentArray = Array.isArray(node.content);
    const marks = (child)=>{
        if (hasMarks) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return node.marks.reduce((str, mark)=>`${$066ee88f128786d6$var$shortHash(mark, true)}(${str})`, child);
        return child;
    };
    let content;
    if (isTextNode) content = String(node.nodeSize);
    else if (isContentEmpty) content = '';
    else if (isContentArray) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    content = node.content.map((node)=>$066ee88f128786d6$var$compactStringifier(node)).join(',');
    return marks(`${$066ee88f128786d6$var$shortHash(node.type, false)}(${content})`);
}
const $066ee88f128786d6$export$6451b72139862cbd = (doc, options)=>{
    try {
        const result = $066ee88f128786d6$var$getBlockNode(doc, 0);
        if (options?.compact) return $066ee88f128786d6$var$compactStringifier(result);
        return result;
    } catch (error) {
        return `Error logging document structure: ${error}`;
    }
};
const $066ee88f128786d6$var$getBlockNode = (node, pos)=>{
    const blockNode = {
        type: node.type.name,
        pos: pos,
        nodeSize: node.nodeSize
    };
    const content = $066ee88f128786d6$var$getBlockNodeContent(node.content, pos);
    if (content.length > 0) blockNode.content = content;
    const marks = $066ee88f128786d6$var$getMarks(node);
    if (marks.length > 0) blockNode.marks = marks;
    return blockNode;
};
const $066ee88f128786d6$var$getBlockNodeContent = (node, pos)=>{
    if (!node || !node.content || !node.content.length) return [];
    let blockNodeContent = [];
    const { content: content } = node;
    if (content[0].isBlock) {
        // children are block nodes
        let prevNode;
        blockNodeContent = content.map((node)=>{
            pos += prevNode ? prevNode.nodeSize : 1;
            prevNode = node;
            return $066ee88f128786d6$var$getBlockNode(node, pos);
        });
    } else {
        // children are inline nodes .
        const result = $066ee88f128786d6$var$getInlineNodes(content, pos);
        blockNodeContent = result.inlineNodes;
        pos = result.pos;
    }
    return blockNodeContent;
};
const $066ee88f128786d6$var$getInlineNodes = (nodes, pos)=>{
    const inlineNodes = nodes.map((node)=>{
        const { nodeSize: nodeSize } = node;
        const inlineNode = {
            type: node.type.name,
            pos: pos,
            nodeSize: nodeSize
        };
        const marks = $066ee88f128786d6$var$getMarks(node);
        if (marks.length > 0) inlineNode.marks = marks;
        pos += nodeSize;
        return inlineNode;
    });
    return {
        inlineNodes: inlineNodes,
        pos: pos
    };
};
const $066ee88f128786d6$var$getMarks = (node)=>node.marks.map((mark)=>mark.type.name);
module.exports["getDocStructure"] = $066ee88f128786d6$export$6451b72139862cbd;

});

parcelRegister("eVvEf", function(module, exports) {
$parcel$export(module.exports, "default", () => $218674f197ea575e$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $03RpJ = parcelRequire("03RpJ");


var $krYZG = parcelRequire("krYZG");

var $fdQKX = parcelRequire("fdQKX");

var $iLcY8 = parcelRequire("iLcY8");


var $4iudd = parcelRequire("4iudd");


var $fGIRV = parcelRequire("fGIRV");


var $4o5MH = parcelRequire("4o5MH");

var $2InGJ = parcelRequire("2InGJ");


var $gMweA = parcelRequire("gMweA");


var $fvMxa = parcelRequire("fvMxa");


var $dnhfp = parcelRequire("dnhfp");


var $5vSgR = parcelRequire("5vSgR");


var $kzRKB = parcelRequire("kzRKB");

var $fS38i = parcelRequire("fS38i");




const $970d799a06d520c1$var$profileSSROperationImpl = (segmentName, fn, onSSRMeasure)=>{
    if (!onSSRMeasure) return fn();
    const startTimestamp = performance.now();
    try {
        return fn();
    } finally{
        onSSRMeasure({
            segmentName: segmentName,
            startTimestamp: startTimestamp,
            endTimestamp: performance.now()
        });
    }
};
const $970d799a06d520c1$var$profileSSROperationNoOp = (_segmentName, fn, _onSSRMeasure)=>{
    return fn();
};
const $970d799a06d520c1$export$69bfe89b2a668d26 = (0, $4iudd.isSSR)() ? $970d799a06d520c1$var$profileSSROperationImpl : $970d799a06d520c1$var$profileSSROperationNoOp;


var $jZ0wT = parcelRequire("jZ0wT");


var $3u5lg = parcelRequire("3u5lg");


var $kmQhR = parcelRequire("kmQhR");


var $aPdNQ = parcelRequire("aPdNQ");


var $iDrrr = parcelRequire("iDrrr");


var $4RpM6 = parcelRequire("4RpM6");


var $4yKbg = parcelRequire("4yKbg");


var $5Qi6J = parcelRequire("5Qi6J");


var $aC6bW = parcelRequire("aC6bW");


var $kCECX = parcelRequire("kCECX");


var $kpCD8 = parcelRequire("kpCD8");

const $7af9f0379bfecafb$export$c701b355a31b2a13 = new (0, $kCECX.PluginKey)('appearancePlugin');
const $7af9f0379bfecafb$var$DEFAULT_APPEARANCE = 'comment';
function $7af9f0379bfecafb$export$8eb39c7592eeb788(initialAppearance) {
    return new (0, $kpCD8.SafePlugin)({
        key: $7af9f0379bfecafb$export$c701b355a31b2a13,
        state: {
            init: ()=>({
                    appearance: initialAppearance ?? $7af9f0379bfecafb$var$DEFAULT_APPEARANCE
                }),
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($7af9f0379bfecafb$export$c701b355a31b2a13);
                if (meta?.appearance !== undefined) return {
                    ...pluginState,
                    appearance: meta.appearance
                };
                return pluginState;
            }
        }
    });
}



var $2lPWP = parcelRequire("2lPWP");







const $d73a376b77b62e7c$var$transformer = new (0, $2lPWP.JSONTransformer)();
function $d73a376b77b62e7c$export$54fd2c36b5cc6731(node) {
    return $d73a376b77b62e7c$var$transformer.encode(node);
}
function $d73a376b77b62e7c$export$6a1dd68d75badcc7(callback) {
    let frameId;
    let lastArgs;
    const delayedCallbacks = [];
    const wrapperFn = (...args)=>{
        const lastArgsBefore = lastArgs;
        lastArgs = args;
        if (frameId) {
            if (lastArgsBefore) {
                const [_v, _c, _t, _f, alwaysFire] = lastArgsBefore;
                if (alwaysFire) delayedCallbacks.push(lastArgsBefore);
            }
            return;
        }
        // If `requestIdleCallback` doesn't exist - fallback to `requestAnimationFrame`
        const delayFunction = globalThis.requestIdleCallback ?? globalThis.requestAnimationFrame;
        frameId = delayFunction(()=>{
            frameId = undefined;
            if (lastArgs) {
                delayedCallbacks.forEach((savedArgs)=>{
                    callback(...savedArgs);
                });
                callback(...lastArgs);
            }
        }, {
            timeout: 100
        });
    };
    return wrapperFn;
}
function $d73a376b77b62e7c$export$dce79649e5264171(editorView, callback, transformer, fireAnalyticsEvent, _alwaysFire) {
    const { doc: doc, schema: schema } = editorView?.state ?? {};
    if (!doc || !schema) return undefined;
    try {
        const json = $d73a376b77b62e7c$export$54fd2c36b5cc6731(doc);
        if (typeof transformer === 'undefined') callback(json);
        else {
            const nodeSanitized = (0, $aPdNQ.Node).fromJSON(schema, json);
            callback(transformer.encode(nodeSanitized));
        }
    } catch (e) {
        fireAnalyticsEvent?.({
            payload: {
                action: (0, $krYZG.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
                }
            }
        });
        throw e;
    }
}
function $d73a376b77b62e7c$export$840661c1d4051b37(editorView, callback, transformer, fireAnalyticsEvent, _alwaysFire) {
    try {
        return $d73a376b77b62e7c$export$dce79649e5264171(editorView, callback, transformer, fireAnalyticsEvent, _alwaysFire);
    } catch  {
        callback(undefined);
    }
}


const $1a9bb85c4fc1efe7$export$71ab138dd170c35 = ({ config: config })=>{
    // Create the document request throttler per editor (rather than at a module level)
    const scheduleDocumentRequest = (0, $d73a376b77b62e7c$export$6a1dd68d75badcc7)((0, $d73a376b77b62e7c$export$dce79649e5264171));
    const scheduleDocumentRequestNoThrowError = (0, $d73a376b77b62e7c$export$6a1dd68d75badcc7)((0, $d73a376b77b62e7c$export$840661c1d4051b37));
    return {
        name: 'core',
        getSharedState (state) {
            const pluginState = state && (0, $7af9f0379bfecafb$export$c701b355a31b2a13).getState(state);
            return {
                schema: state?.schema,
                appearance: pluginState?.appearance
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'appearancePlugin',
                    plugin: ()=>(0, $7af9f0379bfecafb$export$8eb39c7592eeb788)(config?.appearance)
                }
            ];
        },
        actions: {
            execute: (command)=>{
                const editorView = config?.getEditorView();
                if (!editorView || !command) return false;
                const { state: state, dispatch: dispatch } = editorView;
                return (0, $aC6bW.editorCommandToPMCommand)(command)(state, dispatch);
            },
            // Code copied from `EditorActions.focus()`
            focus: (options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || editorView.hasFocus()) return false;
                editorView.focus();
                if (options?.scrollIntoView ?? true) editorView.dispatch(editorView.state.tr.scrollIntoView());
                return true;
            },
            // Code copied from `EditorActions.blur()`
            blur: ()=>{
                const editorView = config?.getEditorView();
                if (!editorView || !editorView.hasFocus()) return false;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorView.dom.blur();
                return true;
            },
            scrollToPos (pos, scrollOptions) {
                const editorView = config?.getEditorView();
                if (!editorView) return false;
                const tr = editorView.state.tr;
                const isValidPos = typeof pos === 'number' && pos >= 0 && pos <= tr.doc.content.size;
                if (!isValidPos) return false;
                if ((0, $iDrrr.fg)('platform_editor_fix_scroll_to_pos')) {
                    // nodeDOM can return a Text node for inline positions
                    const nodeDom = editorView.nodeDOM(pos);
                    const dom = (nodeDom instanceof Element ? nodeDom : null) ?? editorView.domAtPos(pos)?.node;
                    if (!(dom instanceof Element)) return false;
                    dom.scrollIntoView(scrollOptions);
                    return true;
                }
                // Legacy path — domAtPos interprets block boundaries as the parent container
                const dom = editorView.domAtPos(pos).node;
                if (!(dom instanceof Element)) {
                    // If it's not an element (e.g. #text node), we'll try the parent.
                    // This is expected to cover most of the scenarios, if not, window.scrollTo is an alternative
                    if (dom.parentNode instanceof Element) {
                        dom.parentNode.scrollIntoView(scrollOptions);
                        return true;
                    }
                    return false;
                }
                dom.scrollIntoView(scrollOptions);
                return true;
            },
            updateAppearance: (newAppearance)=>{
                const editorView = config?.getEditorView();
                if (!editorView) return false;
                // Avoid dispatching a redundant transaction if appearance hasn't changed
                const currentAppearance = (0, $7af9f0379bfecafb$export$c701b355a31b2a13).getState(editorView.state)?.appearance;
                if (currentAppearance === newAppearance) return false;
                const tr = editorView.state.tr.setMeta((0, $7af9f0379bfecafb$export$c701b355a31b2a13), {
                    appearance: newAppearance
                });
                tr.setMeta('addToHistory', false);
                editorView.dispatch(tr);
                return true;
            },
            replaceDocument: (replaceValue, options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || replaceValue === undefined || replaceValue === null) return false;
                const { state: state } = editorView;
                const { schema: schema } = state;
                const content = options?.skipValidation ? (0, $5Qi6J.processRawValueWithoutValidation)(schema, replaceValue) : Array.isArray(replaceValue) ? (0, $4yKbg.processRawFragmentValue)(schema, replaceValue, undefined, undefined, options?.transformer) : (0, $5Qi6J.processRawValue)(schema, replaceValue, undefined, undefined, options?.transformer);
                // Don't replace the document if it's the same document, as full size
                // replace transactions cause issues for collaborative editing and
                // content reconciliation (eg. inline comments getting dropped)
                if (content instanceof (0, $aPdNQ.Node) && state.doc.eq(content)) return false;
                if (content) {
                    const tr = state.tr.replaceWith(0, state.doc.nodeSize - 2, content);
                    tr.setMeta('replaceDocument', true);
                    if (options?.addToHistory === false) tr.setMeta('addToHistory', false);
                    if (options?.scrollIntoView ?? true) editorView.dispatch(tr.scrollIntoView());
                    else editorView.dispatch(tr.setMeta('scrollIntoView', false));
                    return true;
                }
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            requestDocument (onReceive, options) {
                const view = config?.getEditorView() ?? null;
                scheduleDocumentRequest(view, onReceive, options?.transformer, config?.fireAnalyticsEvent, options?.alwaysFire);
            },
            requestDocumentAsync: (options)=>{
                return new Promise((resolve)=>{
                    const view = config?.getEditorView() ?? null;
                    scheduleDocumentRequestNoThrowError(view, (doc)=>{
                        resolve(doc);
                    }, options?.transformer, config?.fireAnalyticsEvent, true);
                });
            },
            createTransformer (cb) {
                const view = config?.getEditorView() ?? null;
                if (!view?.state.schema) return undefined;
                return cb(view?.state.schema);
            },
            getAnchorIdForNode (node, pos) {
                const view = config?.getEditorView() ?? null;
                if (!view) return undefined;
                const nodeIdProvider = (0, $4RpM6.getNodeIdProvider)(view);
                const cachedId = nodeIdProvider.getIdForNode(node);
                if (cachedId) return cachedId;
                if (pos < 0) return undefined;
                // Check DOM first to avoid generating a new ID with a collision suffix
                // when the DOM already has a valid anchor. This prevents misalignment
                // of drag handles on first focus after clicking from the title.
                const nodeDOM = view.nodeDOM(pos);
                if (nodeDOM instanceof HTMLElement) {
                    const domAnchor = nodeDOM.getAttribute('data-node-anchor');
                    if (domAnchor) {
                        // Cache the DOM anchor for this node to maintain consistency
                        // This ensures subsequent calls return the same anchor
                        nodeIdProvider.setIdForNode(node, domAnchor);
                        return domAnchor;
                    }
                }
                // Only generate a new ID if DOM doesn't have one
                const generatedId = nodeIdProvider.getOrGenerateId(node, pos);
                if (generatedId) return generatedId;
                return undefined;
            }
        }
    };
};



function $909b6449b6611a81$var$hasGetSharedState(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.getSharedState === 'function';
}
function $909b6449b6611a81$var$hasActions(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.actions === 'object';
}
function $909b6449b6611a81$var$hasCommands(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.commands === 'object';
}
const $909b6449b6611a81$var$filterPluginsWithListeners = ({ listeners: listeners, plugins: plugins })=>Array.from(listeners.keys()).map((pluginName)=>plugins.get(pluginName)).filter((plugin)=>plugin !== undefined && $909b6449b6611a81$var$hasGetSharedState(plugin));
const $909b6449b6611a81$var$extractSharedStateFromPlugins = ({ oldEditorState: oldEditorState, newEditorState: newEditorState, plugins: plugins })=>{
    const isInitialization = !oldEditorState && newEditorState;
    const result = new Map();
    for (const plugin of plugins){
        if (!plugin || !$909b6449b6611a81$var$hasGetSharedState(plugin)) continue;
        const nextSharedState = plugin.getSharedState(newEditorState);
        const prevSharedState = !isInitialization && oldEditorState ? plugin.getSharedState(oldEditorState) : undefined;
        const isSamePluginState = (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(prevSharedState, nextSharedState);
        if (isInitialization || !isSamePluginState) result.set(plugin.name, {
            nextSharedState: nextSharedState,
            prevSharedState: prevSharedState
        });
    }
    return result;
};
const $909b6449b6611a81$var$THROTTLE_CALLS_FOR_MILLISECONDS = 0;
const $909b6449b6611a81$var$notifyListenersThrottled = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(({ listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue })=>{
    const callbacks = [];
    for (const [pluginName, diffs] of updatesToNotifyQueue.entries()){
        const pluginListeners = listeners.get(pluginName) || [];
        pluginListeners.forEach((callback)=>{
            diffs.forEach((diff)=>{
                callbacks.push(callback.bind(callback, diff));
            });
        });
    }
    updatesToNotifyQueue.clear();
    if (callbacks.length === 0) return;
    callbacks.reverse().forEach((cb)=>{
        cb();
    });
}, $909b6449b6611a81$var$THROTTLE_CALLS_FOR_MILLISECONDS);
class $909b6449b6611a81$var$ActionsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$909b6449b6611a81$var$hasActions(plugin)) return {};
        return new Proxy(plugin.actions || {}, {
            get: function(target, prop, _receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $909b6449b6611a81$var$EditorCommandsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$909b6449b6611a81$var$hasCommands(plugin)) return {};
        return new Proxy(plugin.commands || {}, {
            get: function(target, prop, _receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $909b6449b6611a81$export$da7528f3fb233b4a {
    createAPI(plugin) {
        if (!plugin) return {
            currentState: ()=>undefined,
            onChange: (_sub)=>{
                return ()=>{};
            }
        };
        const pluginName = plugin.name;
        return {
            currentState: ()=>{
                if (!$909b6449b6611a81$var$hasGetSharedState(plugin)) return undefined;
                const state = this.getEditorState();
                return plugin.getSharedState(state);
            },
            onChange: (sub)=>{
                const pluginListeners = this.listeners.get(pluginName) || new Set();
                pluginListeners.add(sub);
                this.listeners.set(pluginName, pluginListeners);
                return ()=>this.cleanupSubscription(pluginName, sub);
            }
        };
    }
    cleanupSubscription(pluginName, sub) {
        (this.listeners.get(pluginName) || new Set()).delete(sub);
    }
    // Drop every listener and pending update for a plugin that is no longer
    // registered. Without this, callbacks (and their captured closures) for
    // evicted plugins would linger in `listeners` until destroy(), and every
    // transaction would still walk their keys via filterPluginsWithListeners.
    removePluginListeners(pluginName) {
        this.listeners.delete(pluginName);
        this.updatesToNotifyQueue.delete(pluginName);
    }
    notifyListeners({ newEditorState: newEditorState, oldEditorState: oldEditorState, plugins: plugins }) {
        const { listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue } = this;
        const pluginsFiltered = $909b6449b6611a81$var$filterPluginsWithListeners({
            plugins: plugins,
            listeners: listeners
        });
        const sharedStateDiffs = $909b6449b6611a81$var$extractSharedStateFromPlugins({
            oldEditorState: oldEditorState,
            newEditorState: newEditorState,
            plugins: pluginsFiltered
        });
        if (sharedStateDiffs.size === 0) return;
        for (const [pluginName, nextDiff] of sharedStateDiffs){
            const currentDiffQueue = updatesToNotifyQueue.get(pluginName) || [];
            updatesToNotifyQueue.set(pluginName, [
                ...currentDiffQueue,
                nextDiff
            ]);
        }
        $909b6449b6611a81$var$notifyListenersThrottled({
            updatesToNotifyQueue: updatesToNotifyQueue,
            listeners: listeners
        });
    }
    destroy() {
        this.listeners.clear();
        this.updatesToNotifyQueue.clear();
    }
    constructor({ getEditorState: getEditorState }){
        this.getEditorState = void 0;
        this.listeners = void 0;
        this.updatesToNotifyQueue = new Map();
        this.getEditorState = getEditorState;
        this.listeners = new Map();
    }
}
const $909b6449b6611a81$var$editorAPICache = new WeakMap();
class $909b6449b6611a81$export$50ccbedb1c6559a0 {
    /**
   * Returns PM plugins from internally-registered plugins (e.g. the core plugin)
   * that are not processed through the normal preset builder flow.
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getInternalPMPlugins() {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = [];
        const corePlugin = this.plugins.get('core');
        if (corePlugin && typeof corePlugin.pmPlugins === 'function') {
            const pmPlugins = corePlugin.pmPlugins();
            if (pmPlugins) result.push(...pmPlugins);
        }
        return result;
    }
    createAPI() {
        const { sharedStateAPI: sharedStateAPI, actionsAPI: actionsAPI, commandsAPI: commandsAPI, getPluginByName: getPluginByName } = this;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new Proxy({}, {
            get: function(target, prop, _receiver) {
                // If we pass this as a prop React hates us
                // Let's just reflect the result and ignore these
                if (prop === 'toJSON') return Reflect.get(target, prop);
                const plugin = getPluginByName(prop);
                if (!plugin) return undefined;
                const sharedState = sharedStateAPI.createAPI(plugin);
                const actions = actionsAPI.createAPI(plugin);
                const commands = commandsAPI.createAPI(plugin);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const proxyCoreAPI = {
                    sharedState: sharedState,
                    actions: actions,
                    commands: commands
                };
                return proxyCoreAPI;
            }
        });
    }
    api() {
        if (!$909b6449b6611a81$var$editorAPICache.get(this)) $909b6449b6611a81$var$editorAPICache.set(this, this.createAPI());
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $909b6449b6611a81$var$editorAPICache.get(this);
    }
    constructor({ getEditorState: getEditorState, getEditorView: getEditorView, fireAnalyticsEvent: fireAnalyticsEvent, appearance: appearance }){
        this.sharedStateAPI = void 0;
        this.actionsAPI = void 0;
        this.commandsAPI = void 0;
        this.plugins = void 0;
        this.onEditorViewUpdated = ({ newEditorState: newEditorState, oldEditorState: oldEditorState })=>{
            this.sharedStateAPI.notifyListeners({
                newEditorState: newEditorState,
                oldEditorState: oldEditorState,
                plugins: this.plugins
            });
        };
        this.onEditorPluginInitialized = (plugin)=>{
            this.addPlugin(plugin);
        };
        // Internal cleanup helper used by ReactEditorView's reconfigureState to
        // reconcile the registered plugin set with the current preset. Removes
        // every registered plugin not in `keptPluginNames`; `core` is always
        // preserved. Returns the names that were removed. Intentionally not on
        // PluginInjectionAPIDefinition: this is an editor-internal control, not
        // part of the injection-API contract that plugins or external consumers
        // depend on.
        this.retainPlugins = (keptPluginNames)=>{
            const evicted = [];
            for (const name of this.plugins.keys())if (name !== 'core' && !keptPluginNames.has(name)) evicted.push(name);
            for (const name of evicted){
                this.plugins.delete(name);
                this.sharedStateAPI.removePluginListeners(name);
            }
            return evicted;
        };
        // Internal: snapshot the names of currently-registered plugins. Used by
        // reconfigureState to capture the previous plugin set before the new
        // preset registers its own plugins via onEditorPluginInitialized.
        this.getRegisteredPluginNames = ()=>Array.from(this.plugins.keys());
        this.addPlugin = (plugin)=>{
            // Plugins other than `core` are checked by the preset itself
            // For some reason in some tests we have duplicates that are missed.
            // To follow-up in ED-19611
            if (plugin.name === 'core' && this.plugins.has(plugin.name)) throw new Error(`Plugin ${plugin.name} has already been initialised in the Editor API!
        There cannot be duplicate plugins or you will have unexpected behaviour`);
            this.plugins.set(plugin.name, plugin);
        };
        this.getPluginByName = (pluginName)=>{
            const plugin = this.plugins.get(pluginName);
            return plugin;
        };
        this.sharedStateAPI = new $909b6449b6611a81$export$da7528f3fb233b4a({
            getEditorState: getEditorState
        });
        this.plugins = new Map();
        this.actionsAPI = new $909b6449b6611a81$var$ActionsAPI();
        this.commandsAPI = new $909b6449b6611a81$var$EditorCommandsAPI();
        // Special core plugin that is always added
        this.addPlugin((0, $1a9bb85c4fc1efe7$export$71ab138dd170c35)({
            config: {
                getEditorView: getEditorView,
                fireAnalyticsEvent: fireAnalyticsEvent,
                appearance: appearance
            }
        }));
    }
}






var $2iHw5 = parcelRequire("2iHw5");


var $6pnwK = parcelRequire("6pnwK");


var $iLrhi = parcelRequire("iLrhi");








var $8nvEM = parcelRequire("8nvEM");



















function $08319ffb5b98e637$export$d5371f6840b6acde({ pmPlugins: pmPlugins, schema: schema, doc: doc }) {
    return (0, $kCECX.EditorState).create({
        doc: doc,
        schema: schema,
        plugins: pmPlugins
    });
}






var $eNbr2 = parcelRequire("eNbr2");

class $c99fa13805cd5152$var$SSREventDispatcher extends (0, $fGIRV.EventDispatcher) {
    emit() {
    // Don't notify about events in SSR
    }
}
function $c99fa13805cd5152$export$5dd8b2dbd9647c38({ plugins: plugins, schema: schema, portalProviderAPI: portalProviderAPI, getIntl: getIntl }) {
    const eventDispatcher = new $c99fa13805cd5152$var$SSREventDispatcher();
    const providerFactory = new (0, $eNbr2.default)();
    const pmPluginFactoryParams = {
        dispatch: (0, $fGIRV.createDispatch)(eventDispatcher),
        dispatchAnalyticsEvent: ()=>{},
        eventDispatcher: eventDispatcher,
        featureFlags: {},
        getIntl: getIntl,
        portalProviderAPI: portalProviderAPI,
        nodeViewPortalProviderAPI: portalProviderAPI,
        providerFactory: providerFactory,
        schema: schema
    };
    return plugins.reduce((acc, editorPlugin)=>{
        editorPlugin.pmPlugins?.().forEach(({ plugin: plugin })=>{
            try {
                const pmPlugin = plugin(pmPluginFactoryParams);
                if (pmPlugin) acc.push(pmPlugin);
            } catch (error) {
                if ("production" !== 'production') // eslint-disable-next-line no-console
                console.warn(`[EditorSSR] Failed to create PM plugin (${plugin?.name}) during SSR. This plugin will be skipped.`, error);
            }
        });
        return acc;
    }, []);
}


const $07e46fd8091c3d79$var$SSR_TRACE_SEGMENT_NAME = 'reactEditorView/editorSSRRenderer';
/**
 * A lightweight EditorView implementation for SSR environments.
 *
 * It's kind of aggressive right now, we need to test and see how it works.
 * Probably, we will need to implement more methods/properties in the future.
 *
 * If it doesn't work, we can extend `EditorView` directly instead of implementing `Partial<EditorView>`,
 * but it will perform some DOM operation during the construction.
 */ class $07e46fd8091c3d79$var$SSREditorView {
    update() {
    // No-op in SSR
    }
    setProps() {
    // No-op in SSR
    }
    dispatchEvent() {
    // No-op in SSR
    }
    dispatch() {
    // No-op in SSR
    }
    hasFocus() {
        return false;
    }
    focus() {
    // No-op in SSR
    }
    updateRoot() {
    // No-op in SSR
    }
    posAtCoords() {
        return null;
    }
    coordsAtPos() {
        return {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
    }
    domAtPos() {
        return {
            node: this.root,
            offset: 0
        };
    }
    nodeDOM() {
        return null;
    }
    posAtDOM() {
        return 0;
    }
    endOfTextblock() {
        return false;
    }
    pasteHTML() {
        return false;
    }
    pasteText() {
        return false;
    }
    destroy() {
    // No-op in SSR
    }
    updateState() {
    // No-op in SSR
    }
    someProp() {
        return undefined;
    }
    serializeForClipboard(slice) {
        // No-op in SSR - clipboard operations are not supported
        return {
            dom: document.createElement('div'),
            text: '',
            slice: slice
        };
    }
    constructor(place, props){
        this.state = void 0;
        this.dom = void 0;
        this.editable = void 0;
        this.dragging = void 0;
        this.composing = void 0;
        this.props = void 0;
        this.root = void 0;
        this.isDestroyed = void 0;
        this.state = props.state;
        this.dom = document.createElement('div');
        this.editable = true;
        this.dragging = null;
        this.composing = false;
        this.props = props;
        this.root = document;
        this.isDestroyed = false;
    }
}
function $07e46fd8091c3d79$export$8d417ec112d5c31c({ plugins: plugins, schema: schema, doc: doc, portalProviderAPI: portalProviderAPI, intl: intl, onSSRMeasure: onSSRMeasure, onEditorStateChanged: onEditorStateChanged, prebuiltPMPlugins: prebuiltPMPlugins, prebuiltEditorState: prebuiltEditorState, ...divProps }) {
    // Should be always the first statement in the component
    const firstRenderStartTimestampRef = (0, $cozmU.useRef)(performance.now());
    // PMPluginFactoryParams use `getIntl` function to get current intl instance,
    // so we don't need to add `intl` as a dependency to `useMemo`.
    // We will store intl in ref and access to it dynamically in `getIntl` function call.
    const intlRef = (0, $cozmU.useRef)(intl);
    intlRef.current = intl;
    const pmPlugins = (0, $cozmU.useMemo)(()=>{
        if (prebuiltPMPlugins) return prebuiltPMPlugins;
        return (0, $970d799a06d520c1$export$69bfe89b2a668d26)(`${$07e46fd8091c3d79$var$SSR_TRACE_SEGMENT_NAME}/createPMPlugins`, ()=>(0, $c99fa13805cd5152$export$5dd8b2dbd9647c38)({
                plugins: plugins,
                schema: schema,
                portalProviderAPI: portalProviderAPI,
                getIntl: ()=>intlRef.current
            }), onSSRMeasure);
    }, [
        plugins,
        portalProviderAPI,
        schema,
        onSSRMeasure,
        prebuiltPMPlugins
    ]);
    const nodeViews = (0, $cozmU.useMemo)(()=>{
        return pmPlugins.reduce((acc, plugin)=>{
            return Object.assign(acc, plugin.props.nodeViews);
        }, {});
    }, [
        pmPlugins
    ]);
    const markViews = (0, $cozmU.useMemo)(()=>{
        return pmPlugins.reduce((acc_0, plugin_0)=>{
            return Object.assign(acc_0, plugin_0.props.markViews);
        }, {});
    }, [
        pmPlugins
    ]);
    const editorState = (0, $cozmU.useMemo)(()=>{
        if (prebuiltEditorState) return prebuiltEditorState;
        return (0, $970d799a06d520c1$export$69bfe89b2a668d26)(`${$07e46fd8091c3d79$var$SSR_TRACE_SEGMENT_NAME}/createSSREditorState`, ()=>(0, $08319ffb5b98e637$export$d5371f6840b6acde)({
                doc: doc,
                schema: schema,
                pmPlugins: pmPlugins
            }), onSSRMeasure);
    }, [
        doc,
        pmPlugins,
        schema,
        onSSRMeasure,
        prebuiltEditorState
    ]);
    // In React 19 could be replaced by `useEffectEvent` hook.
    const onEditorStateChangedRef = (0, $cozmU.useRef)(onEditorStateChanged);
    onEditorStateChangedRef.current = onEditorStateChanged;
    (0, $cozmU.useLayoutEffect)(()=>{
        onEditorStateChangedRef.current?.(editorState);
    }, [
        editorState
    ]);
    const editorView = (0, $cozmU.useMemo)(()=>{
        return new $07e46fd8091c3d79$var$SSREditorView(null, {
            state: editorState
        });
    }, [
        editorState
    ]);
    const { serializer: serializer_0, nodePositions: nodePositions_0 } = (0, $cozmU.useMemo)(()=>{
        const createSerializerAndNodePositions = ()=>{
            const nodePositions = new WeakMap();
            // ProseMirror View adds <br class="ProseMirror-trailingBreak" /> to empty nodes. Because we are using
            // DOMSerializer, we should simulate the same behaviour to get the same HTML document.
            //
            // There are a lot of conditions that check for adding `<br />` but we could implement only the case when we
            // are adding `<br />` to empty texblock, because if we add `<br />` in other cases it will change order of DOM nodes inside
            // this node (`<br />`) will be the first, after will be other nodes. It's because we are adding `<br />` to root node before
            // we are rendering child node.
            //
            // See: https://discuss.prosemirror.net/t/where-can-i-read-about-prosemirror-trailingbreak/6665
            // See: https://github.com/ProseMirror/prosemirror-view/blob/76c7c47f03730b18397b94bd269ece8a9cb7f486/src/viewdesc.ts#L803
            // See: https://github.com/ProseMirror/prosemirror-view/blob/76c7c47f03730b18397b94bd269ece8a9cb7f486/src/viewdesc.ts#L1365
            const addTrailingBreakIfNeeded = (node, contentDOM)=>{
                if (contentDOM && node.isTextblock && !node.lastChild) {
                    const br = document.createElement('br');
                    br.classList.add('ProseMirror-trailingBreak');
                    contentDOM.appendChild(br);
                }
            };
            const toDomNodeRenderers = Object.fromEntries(Object.entries(schema.nodes).map(([nodeName, nodeType])=>{
                return [
                    nodeName,
                    nodeType.spec.toDOM
                ];
            }).filter(([, toDOM])=>!!toDOM));
            const toDomMarkRenderers = Object.fromEntries(Object.entries(schema.marks).map(([markName, markType])=>{
                return [
                    markName,
                    markType.spec.toDOM
                ];
            }).filter(([, toDOM_0])=>!!toDOM_0));
            const nodeViewRenderers = Object.fromEntries(Object.entries(nodeViews).map(([nodeName_0, nodeViewFactory])=>{
                return [
                    nodeName_0,
                    (node_0)=>{
                        try {
                            const nodeViewInstance = nodeViewFactory(node_0, editorView, ()=>nodePositions.get(node_0) ?? 0, [], (0, $8nvEM.DecorationSet).create(node_0, []));
                            addTrailingBreakIfNeeded(node_0, nodeViewInstance.contentDOM);
                            return {
                                dom: nodeViewInstance.dom,
                                // Leaf nodes have no content, ProseMirror will throw an error if we pass contentDOM
                                contentDOM: node_0.isLeaf ? undefined : nodeViewInstance.contentDOM
                            };
                        } catch (error) {
                            // Fall back to schema-level toDOM for this node
                            const toDOM_1 = schema.nodes[nodeName_0]?.spec.toDOM;
                            if (toDOM_1) return (0, $aPdNQ.DOMSerializer).renderSpec(document, toDOM_1(node_0));
                            // Last resort: empty div
                            return {
                                dom: document.createElement('div')
                            };
                        }
                    }
                ];
            }));
            // Create renderers for textblock nodes that don't have custom NodeViews (e.g. paragraph, heading)
            const textblockRenderers = Object.fromEntries(Object.entries(schema.nodes).filter(([nodeName_1, nodeType_0])=>{
                // Only handle textblock nodes
                return nodeType_0.spec.toDOM && nodeType_0.isTextblock && !nodeViews[nodeName_1];
            }).map(([nodeName_2, nodeType_1])=>{
                const toDOM_2 = nodeType_1.spec.toDOM;
                if (!toDOM_2) return [
                    nodeName_2,
                    undefined
                ];
                return [
                    nodeName_2,
                    (node_1)=>{
                        if (!node_1.lastChild) {
                            const result = (0, $aPdNQ.DOMSerializer).renderSpec(document, toDOM_2(node_1));
                            addTrailingBreakIfNeeded(node_1, result.contentDOM);
                            return result;
                        }
                        return toDOM_2(node_1);
                    }
                ];
            }).filter(([, renderer])=>!!renderer));
            const markViewRenderers = Object.fromEntries(Object.entries(markViews).map(([markName_0, markViewFactory])=>{
                return [
                    markName_0,
                    (mark)=>{
                        const markViewInstance = markViewFactory(mark, editorView, false);
                        return {
                            dom: markViewInstance.dom,
                            contentDOM: markViewInstance.contentDOM
                        };
                    }
                ];
            }));
            const serializer = new (0, $aPdNQ.DOMSerializer)({
                ...toDomNodeRenderers,
                ...textblockRenderers,
                ...nodeViewRenderers,
                text: $07e46fd8091c3d79$var$renderText
            }, {
                ...toDomMarkRenderers,
                ...markViewRenderers
            });
            return {
                serializer: serializer,
                nodePositions: nodePositions
            };
        };
        return (0, $970d799a06d520c1$export$69bfe89b2a668d26)(`${$07e46fd8091c3d79$var$SSR_TRACE_SEGMENT_NAME}/createSerializerAndNodePositions`, createSerializerAndNodePositions, onSSRMeasure);
    }, [
        editorView,
        markViews,
        nodeViews,
        schema.marks,
        schema.nodes,
        onSSRMeasure
    ]);
    const editorHTML = (0, $cozmU.useMemo)(()=>{
        const serializeFragment = ()=>{
            if (!doc) return undefined;
            doc.descendants((node_2, pos)=>{
                nodePositions_0.set(node_2, pos);
            });
            const fragment = serializer_0.serializeFragment(doc.content);
            const wrapper = document.createElement('div');
            wrapper.appendChild(fragment);
            return wrapper.innerHTML;
        };
        try {
            return (0, $970d799a06d520c1$export$69bfe89b2a668d26)(`${$07e46fd8091c3d79$var$SSR_TRACE_SEGMENT_NAME}/serializeFragment`, serializeFragment, onSSRMeasure);
        } catch (error_0) {
            return undefined;
        }
    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-usememo-deps -- Ignored via go/ees017 (to be fixed)
    }, [
        doc,
        serializer_0,
        nodePositions_0,
        onSSRMeasure
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jZ0wT.SSRRenderMeasure), {
        segmentName: $07e46fd8091c3d79$var$SSR_TRACE_SEGMENT_NAME,
        startTimestampRef: firstRenderStartTimestampRef,
        onSSRMeasure: onSSRMeasure,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            id: divProps.id,
            // eslint-disable-next-line react/no-danger -- It's intentional by design
            dangerouslySetInnerHTML: typeof editorHTML === 'string' ? {
                __html: editorHTML
            } : undefined,
            // For some reason on SSR, the result `class` has a trailing space, that broke UFO,
            // because ReactEditorView produces a div with `class` without space.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: divProps.className.trim(),
            "aria-label": divProps['aria-label'],
            "aria-describedby": divProps['aria-describedby'],
            ...divProps['aria-readonly'] === 'true' ? {
                'aria-readonly': 'true'
            } : {},
            "data-editor-id": divProps['data-editor-id'],
            "data-vc-ignore-if-no-layout-shift": true,
            "data-ssr-placeholder": "editor-view",
            "data-ssr-placeholder-replace": "editor-view",
            "aria-multiline": true,
            role: "textbox",
            // @ts-expect-error - contenteditable is not exist in div attributes
            contenteditable: "true",
            "data-gramm": "false",
            translate: "no"
        })
    });
}
function $07e46fd8091c3d79$var$renderText(node) {
    return node.text || '';
}





var $4o0zT = parcelRequire("4o0zT");


var $gXfti = parcelRequire("gXfti");


var $E1QOf = parcelRequire("E1QOf");


var $a33Aa = parcelRequire("a33Aa");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");




const $fdff5ad7448b8b55$export$e4c19534640d7866 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    const { editorApi: editorApi, contextIdentifierProvider: contextIdentifierProvider, mediaProvider: mediaProvider, mentionProvider: mentionProvider, cardProvider: cardProvider, emojiProvider: emojiProvider, autoformattingProvider: autoformattingProvider, taskDecisionProvider: taskDecisionProvider } = t0;
    let t1;
    if ($[0] !== contextIdentifierProvider || $[1] !== editorApi?.contextIdentifier?.commands || $[2] !== editorApi?.core?.actions) {
        t1 = ()=>{
            const setProvider = async function setProvider() {
                if (!contextIdentifierProvider) return;
                const provider = await contextIdentifierProvider;
                editorApi?.core?.actions.execute(editorApi?.contextIdentifier?.commands.setProvider({
                    contextIdentifierProvider: provider
                }));
            };
            setProvider();
        };
        $[0] = contextIdentifierProvider;
        $[1] = editorApi?.contextIdentifier?.commands;
        $[2] = editorApi?.core?.actions;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== contextIdentifierProvider || $[5] !== editorApi) {
        t2 = [
            contextIdentifierProvider,
            editorApi
        ];
        $[4] = contextIdentifierProvider;
        $[5] = editorApi;
        $[6] = t2;
    } else t2 = $[6];
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== editorApi?.media?.actions || $[8] !== mediaProvider) {
        t3 = ()=>{
            if (mediaProvider) editorApi?.media?.actions.setProvider(mediaProvider);
        };
        $[7] = editorApi?.media?.actions;
        $[8] = mediaProvider;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== editorApi || $[11] !== mediaProvider) {
        t4 = [
            mediaProvider,
            editorApi
        ];
        $[10] = editorApi;
        $[11] = mediaProvider;
        $[12] = t4;
    } else t4 = $[12];
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[13] !== editorApi?.mention?.actions || $[14] !== mentionProvider) {
        t5 = ()=>{
            if (mentionProvider) editorApi?.mention?.actions.setProvider(mentionProvider);
        };
        $[13] = editorApi?.mention?.actions;
        $[14] = mentionProvider;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== editorApi || $[17] !== mentionProvider) {
        t6 = [
            mentionProvider,
            editorApi
        ];
        $[16] = editorApi;
        $[17] = mentionProvider;
        $[18] = t6;
    } else t6 = $[18];
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[19] !== cardProvider || $[20] !== editorApi?.card?.actions) {
        t7 = ()=>{
            if (cardProvider) editorApi?.card?.actions.setProvider(cardProvider);
        };
        $[19] = cardProvider;
        $[20] = editorApi?.card?.actions;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== cardProvider || $[23] !== editorApi) {
        t8 = [
            cardProvider,
            editorApi
        ];
        $[22] = cardProvider;
        $[23] = editorApi;
        $[24] = t8;
    } else t8 = $[24];
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[25] !== editorApi?.emoji?.actions || $[26] !== emojiProvider) {
        t9 = ()=>{
            if (emojiProvider) editorApi?.emoji?.actions.setProvider(emojiProvider);
        };
        $[25] = editorApi?.emoji?.actions;
        $[26] = emojiProvider;
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== editorApi || $[29] !== emojiProvider) {
        t10 = [
            emojiProvider,
            editorApi
        ];
        $[28] = editorApi;
        $[29] = emojiProvider;
        $[30] = t10;
    } else t10 = $[30];
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[31] !== autoformattingProvider || $[32] !== editorApi?.customAutoformat?.actions) {
        t11 = ()=>{
            if (autoformattingProvider) editorApi?.customAutoformat?.actions.setProvider(autoformattingProvider);
        };
        $[31] = autoformattingProvider;
        $[32] = editorApi?.customAutoformat?.actions;
        $[33] = t11;
    } else t11 = $[33];
    let t12;
    if ($[34] !== autoformattingProvider || $[35] !== editorApi) {
        t12 = [
            autoformattingProvider,
            editorApi
        ];
        $[34] = autoformattingProvider;
        $[35] = editorApi;
        $[36] = t12;
    } else t12 = $[36];
    (0, $cozmU.useEffect)(t11, t12);
    let t13;
    if ($[37] !== editorApi?.taskDecision?.actions || $[38] !== taskDecisionProvider) {
        t13 = ()=>{
            if (taskDecisionProvider) editorApi?.taskDecision?.actions.setProvider(taskDecisionProvider);
        };
        $[37] = editorApi?.taskDecision?.actions;
        $[38] = taskDecisionProvider;
        $[39] = t13;
    } else t13 = $[39];
    let t14;
    if ($[40] !== editorApi || $[41] !== taskDecisionProvider) {
        t14 = [
            taskDecisionProvider,
            editorApi
        ];
        $[40] = editorApi;
        $[41] = taskDecisionProvider;
        $[42] = t14;
    } else t14 = $[42];
    (0, $cozmU.useEffect)(t13, t14);
} : ({ editorApi: editorApi, contextIdentifierProvider: contextIdentifierProvider, mediaProvider: mediaProvider, mentionProvider: mentionProvider, cardProvider: cardProvider, emojiProvider: emojiProvider, autoformattingProvider: autoformattingProvider, taskDecisionProvider: taskDecisionProvider })=>{
    (0, $cozmU.useEffect)(()=>{
        async function setProvider() {
            if (!contextIdentifierProvider) return;
            const provider = await contextIdentifierProvider;
            editorApi?.core?.actions.execute(editorApi?.contextIdentifier?.commands.setProvider({
                contextIdentifierProvider: provider
            }));
        }
        setProvider();
    }, [
        contextIdentifierProvider,
        editorApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (mediaProvider) editorApi?.media?.actions.setProvider(mediaProvider);
    }, [
        mediaProvider,
        editorApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (mentionProvider) editorApi?.mention?.actions.setProvider(mentionProvider);
    }, [
        mentionProvider,
        editorApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (cardProvider) editorApi?.card?.actions.setProvider(cardProvider);
    }, [
        cardProvider,
        editorApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (emojiProvider) editorApi?.emoji?.actions.setProvider(emojiProvider);
    }, [
        emojiProvider,
        editorApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (autoformattingProvider) editorApi?.customAutoformat?.actions.setProvider(autoformattingProvider);
    }, [
        autoformattingProvider,
        editorApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (taskDecisionProvider) editorApi?.taskDecision?.actions.setProvider(taskDecisionProvider);
    }, [
        taskDecisionProvider,
        editorApi
    ]);
};



var $cfjQo = parcelRequire("cfjQo");

function $bfdc563d0e4e6c6b$export$2b8873b73f502810(view) {
    return view.dom.getElementsByTagName('*').length;
}


function $fa2e45474333705a$export$af7be2186992199(node) {
    const nodes = {};
    const extensionKeys = {};
    const extensionNodeNames = [
        'extension',
        'bodiedExtension',
        'inlineExtension',
        'multiBodiedExtension'
    ];
    node.nodesBetween(0, node.nodeSize - 2, (currentNode)=>{
        nodes[currentNode.type.name] = (nodes[currentNode.type.name] || 0) + 1;
        if (!extensionNodeNames.includes(currentNode.type.name)) return;
        const extensionKey = currentNode.attrs?.extensionKey;
        if (!extensionKey) return;
        extensionKeys[extensionKey] = (extensionKeys[extensionKey] || 0) + 1;
    });
    return {
        nodes: nodes,
        extensionKeys: extensionKeys
    };
}


/**
 * Check if a DOM element is visible within the viewport. We deem a node visible if the top left corner coordinate is within the viewport.
 * This may not look visible, and may include a node that looks below the fold – but it's more than 0 pixels within the viewport.
 */ const $00fcfbaae55f623b$export$9c8a351faafa8fbb = (node)=>{
    const rect = node.getBoundingClientRect();
    const isVisible = rect.x >= 0 && rect.x < window.innerWidth && rect.y >= 0 && rect.y < window.innerHeight;
    return isVisible;
};


const $73258c031e4e3af0$export$f20e3cf045904cb = (editorDom)=>{
    const MAX_NODES_TO_COUNT = 200;
    const pmNodesList = editorDom.querySelectorAll('[data-prosemirror-node-name]');
    const nodesTypeCounter = {};
    for(let i = 0; i < Math.min(MAX_NODES_TO_COUNT, pmNodesList.length); i++){
        const node = pmNodesList[i];
        const type = node.getAttribute('data-prosemirror-node-name');
        // No valid prosemirrornode type, skip.
        if (!type) continue;
        const isVisible = (0, $00fcfbaae55f623b$export$9c8a351faafa8fbb)(node);
        // Not a visible node, end counting.
        if (!isVisible) break;
        nodesTypeCounter[type] = (nodesTypeCounter[type] || 0) + 1;
    }
    return nodesTypeCounter;
};


function $ba16f1fc98d339f3$export$73ae01d857526945(appearance) {
    return appearance === 'chromeless';
}



var $loGKD = parcelRequire("loGKD");


var $kTcv5 = parcelRequire("kTcv5");


var $l5aTW = parcelRequire("l5aTW");

const $e7d2c0e957b38411$export$646a6982857f2cd5 = 2000;
const $e7d2c0e957b38411$export$79d7eac6cbb6352d = 3000;
const $e7d2c0e957b38411$export$7d7bd496a5206996 = 100;


function $5c368fea92f7e1ac$export$7265233e78178a4(plugins) {
    /**
   * First pass to collect pluginsOptions
   */ const pluginsOptions = plugins.reduce((acc, plugin)=>{
        if (plugin.pluginsOptions) Object.keys(plugin.pluginsOptions).forEach((pluginName)=>{
            if (!acc[pluginName]) acc[pluginName] = [];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            acc[pluginName].push(plugin.pluginsOptions[pluginName]);
        });
        return acc;
    }, {});
    /**
   * Process plugins
   */ return plugins.reduce((acc, plugin)=>{
        if (plugin.pmPlugins) acc.pmPlugins.push(...plugin.pmPlugins(plugin.name ? pluginsOptions[plugin.name] : undefined));
        if (plugin.nodes) acc.nodes.push(...plugin.nodes());
        if (plugin.marks) acc.marks.push(...plugin.marks());
        if (plugin.contentComponent) acc.contentComponents.push(plugin.contentComponent);
        if (plugin.usePluginHook) {
            // Wrap with .bind(null) so we can annotate the function with the
            // plugin name without mutating the plugin's original hook reference.
            // MountPluginHooks reads `pluginName` to derive a stable React key.
            const named = plugin.usePluginHook.bind(null);
            named.pluginName = plugin.name;
            acc.pluginHooks.push(named);
        }
        if (plugin.primaryToolbarComponent) acc.primaryToolbarComponents.push(plugin.primaryToolbarComponent);
        if (plugin.secondaryToolbarComponent) acc.secondaryToolbarComponents.push(plugin.secondaryToolbarComponent);
        if (plugin.onEditorViewStateUpdated) acc.onEditorViewStateUpdatedCallbacks.push({
            pluginName: plugin.name,
            callback: plugin.onEditorViewStateUpdated
        });
        return acc;
    }, {
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
}



var $ceZg8 = parcelRequire("ceZg8");


var $22m0b = parcelRequire("22m0b");


var $kAvGB = parcelRequire("kAvGB");





var $aIbwr = parcelRequire("aIbwr");

const $dde499d04a1b04a8$export$29c1e593063b23a7 = ({ nodeOrMark: nodeOrMark, domSpec: domSpec })=>{
    if (!Array.isArray(domSpec)) return domSpec;
    const maybeDefinedAttributes = domSpec[1];
    const metadata = (0, $aIbwr.createProseMirrorMetadata)(nodeOrMark);
    const hasDefinedAttributes = typeof maybeDefinedAttributes === 'object' && !Array.isArray(maybeDefinedAttributes);
    if (hasDefinedAttributes) domSpec[1] = Object.assign(maybeDefinedAttributes, metadata);
    else domSpec.splice(1, 0, metadata);
    return domSpec;
};


function $0c05775ab915e589$export$ef6c09ff452189fa(marks) {
    const markKeys = Object.keys(marks);
    const markGroups = new Set(markKeys.map((mark)=>marks[mark].group));
    markKeys.forEach((markKey)=>{
        const mark = marks[markKey];
        if (mark.excludes) // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        mark.excludes = mark.excludes.split(' ').filter((group)=>markGroups.has(group)).join(' ');
    });
    return marks;
}


const $97fb23b0b573a2d0$export$48404bb361c0cbc1 = (toDOM)=>{
    return new Proxy(toDOM, {
        apply (target, thisArg, argumentsList) {
            const domSpec = Reflect.apply(target, thisArg, argumentsList);
            if (!Array.isArray(domSpec)) return domSpec;
            const nodeOrMark = argumentsList[0];
            return (0, $dde499d04a1b04a8$export$29c1e593063b23a7)({
                nodeOrMark: nodeOrMark,
                domSpec: domSpec
            });
        }
    });
};
const $97fb23b0b573a2d0$export$83e999ea28e263f4 = (spec)=>{
    return new Proxy(spec, {
        get (target, prop, receiver) {
            const result = Reflect.get(target, prop, receiver);
            if (prop === 'toDOM' && typeof result === 'function') return $97fb23b0b573a2d0$export$48404bb361c0cbc1(result);
            return result;
        }
    });
};
function $97fb23b0b573a2d0$export$5f4ce795563f4211(editorConfig) {
    const marks = (0, $0c05775ab915e589$export$ef6c09ff452189fa)(editorConfig.marks.sort((0, $kAvGB.sortByOrder)('marks')).reduce((acc, mark)=>{
        acc[mark.name] = $97fb23b0b573a2d0$export$83e999ea28e263f4(mark.mark);
        return acc;
    }, {}));
    const nodes = (0, $22m0b.sanitizeNodes)(editorConfig.nodes.sort((0, $kAvGB.sortByOrder)('nodes')).reduce((acc, node)=>{
        acc[node.name] = $97fb23b0b573a2d0$export$83e999ea28e263f4(node.node);
        return acc;
    }, {}), marks);
    return new (0, $aPdNQ.Schema)({
        nodes: nodes,
        marks: marks
    });
}



var $dldpg = parcelRequire("dldpg");

function $214e7a10e86ba265$export$e98521bb0cea2db1(errorReporterHandler) {
    const errorReporter = new (0, $dldpg.ErrorReporter)();
    if (errorReporterHandler) errorReporter.handler = errorReporterHandler;
    return errorReporter;
}























const $13b25707b207bfbe$var$injectNodeViewNodeTypeList = [
    'paragraph',
    'heading',
    'bulletList',
    'orderedList',
    'blockquote',
    'rule',
    'decisionList',
    'taskList',
    'layoutColumn',
    'hardBreak'
];
const $13b25707b207bfbe$var$injectNodeViewNodeTypeConditionalList = [
    ...$13b25707b207bfbe$var$injectNodeViewNodeTypeList,
    // nodes that have custom nodeView behind experiment/FG
    'layoutSection'
];
const $13b25707b207bfbe$var$key = new (0, $kCECX.PluginKey)('editorNativeAnchorSupportPlugin');
const $13b25707b207bfbe$export$dc8df63091e87b7a = (schema)=>{
    const nodeViewEntries = [];
    const injectList = (0, $ieeJu.expValEquals)('advanced_layouts', 'isEnabled', true) && !(0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true) ? $13b25707b207bfbe$var$injectNodeViewNodeTypeList : $13b25707b207bfbe$var$injectNodeViewNodeTypeConditionalList;
    schema.spec.nodes.forEach((nodeName, nodeSpec)=>{
        if (injectList.includes(nodeName)) {
            if (nodeSpec.toDOM && typeof nodeSpec.toDOM === 'function') {
                const toDOM = nodeSpec.toDOM.bind(nodeSpec);
                nodeViewEntries.push([
                    nodeName,
                    (node)=>(0, $aPdNQ.DOMSerializer).renderSpec(document, toDOM(node))
                ]);
            }
        }
    });
    return new (0, $kpCD8.SafePlugin)({
        key: $13b25707b207bfbe$var$key,
        props: {
            nodeViews: Object.fromEntries(nodeViewEntries)
        }
    });
};








const $3f17d8d3e9e5b562$var$key = new (0, $kCECX.PluginKey)('editorStateNotificationPlugin');
const $3f17d8d3e9e5b562$export$e0355cecc74597d = (onEditorStateUpdated, onEditorViewStateUpdatedCallbacks)=>{
    const transactions = [];
    return new (0, $kpCD8.SafePlugin)({
        key: $3f17d8d3e9e5b562$var$key,
        state: {
            init () {
                return {
                    latestTransaction: undefined
                };
            },
            apply (tr) {
                transactions.push(tr);
                return {
                    latestTransaction: tr
                };
            }
        },
        view: ()=>{
            return {
                update: (view, oldEditorState)=>{
                    onEditorStateUpdated({
                        oldEditorState: oldEditorState,
                        newEditorState: view.state
                    });
                }
            };
        }
    });
};


function $13ce1df8d27a505a$export$169329cb2979ef81(config) {
    const { editorConfig: editorConfig } = config;
    const pmPlugins = editorConfig.pmPlugins.sort((0, $kAvGB.sortByOrder)('plugins')).map(({ plugin: plugin })=>plugin({
            schema: config.schema,
            dispatch: config.dispatch,
            eventDispatcher: config.eventDispatcher,
            providerFactory: config.providerFactory,
            errorReporter: config.errorReporter,
            portalProviderAPI: config.portalProviderAPI,
            nodeViewPortalProviderAPI: config.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: config.dispatchAnalyticsEvent,
            featureFlags: config.featureFlags || {},
            getIntl: config.getIntl
        })).filter((plugin)=>typeof plugin !== 'undefined');
    if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) pmPlugins.push((0, $13b25707b207bfbe$export$dc8df63091e87b7a)(config.schema));
    if (config.onEditorStateUpdated !== undefined) return [
        (0, $3f17d8d3e9e5b562$export$e0355cecc74597d)(config.onEditorStateUpdated, config.editorConfig.onEditorViewStateUpdatedCallbacks),
        ...pmPlugins
    ];
    return pmPlugins;
}


function $c54d3f6fb8206a7b$export$1a7fe7567929e9de(editorPlugins, schema, previousPluginNames) {
    const availableNodeNames = new Set(Object.keys(schema.nodes));
    const availableMarkNames = new Set(Object.keys(schema.marks));
    const dropped = [];
    const kept = editorPlugins.filter((plugin)=>{
        if (!plugin) return false;
        if (previousPluginNames.has(plugin.name)) return true;
        const missingNodes = plugin.nodes ? plugin.nodes().map((n)=>n.name).filter((n)=>!availableNodeNames.has(n)) : [];
        const missingMarks = plugin.marks ? plugin.marks().map((m)=>m.name).filter((m)=>!availableMarkNames.has(m)) : [];
        if (missingNodes.length > 0 || missingMarks.length > 0) {
            dropped.push({
                name: plugin.name,
                missingNodes: missingNodes,
                missingMarks: missingMarks
            });
            return false;
        }
        return true;
    });
    return {
        kept: kept,
        dropped: dropped
    };
}





const $16e1705ef52a6e23$export$3b488057bfc1868f = (0, $kSwu1.defineMessages)({
    editorAssistiveLabel: {
        id: "fabric.editor.editorAssistiveLabel",
        defaultMessage: "Main content area, start typing to enter text."
    },
    fullPageEditorAssistiveLabel: {
        id: "fabric.editor.fullPageEditorAssistiveLabel",
        defaultMessage: "Page editing area, start typing to enter text."
    }
});



var $8dxef = parcelRequire("8dxef");

function $3cec430ca7025f27$export$11a24c7b1b4aab81() {
    const browser = (0, $8dxef.getBrowserInfo)();
    if (browser.chrome) return 'ua-chrome';
    else if (browser.ie) return 'ua-ie';
    else if (browser.gecko) return 'ua-firefox';
    else if (browser.safari) return 'ua-safari';
    return '';
}








function $0b5857bdb6352d46$export$ebebb7f5b9271fd7(view) {
    if (view?.hasFocus()) return;
    // Due to race conditions during editor lifecycle transitions (e.g. SPA route changes during opening or closing)
    // where the view (and its internal docView) may have been destroyed, the timeout callback may fire on a stale view.
    // Bail out in that scenario to prevent operating on an unmounted view.
    if (view?.isDestroyed) return;
    if (!window.getSelection) {
        view?.focus();
        return;
    }
    const domSelection = window.getSelection();
    if (!domSelection || domSelection.rangeCount === 0) {
        view?.focus();
        return;
    }
    // If not mocked properly in tests, getRangeAt may not exist.
    const range = domSelection.getRangeAt?.(0);
    if (!range) return;
    // if selection is outside editor focus and exit
    try {
        if (view && range?.startContainer.contains(view.dom)) {
            view.focus();
            return;
        }
    } catch (error) {
        // If we get a SecurityError-type DOMException here, then we probably just tried to
        // access a cross-origin iframe's contents. In that case, we can ignore the error and
        // just reasonably assume the selection is outside the editor, since we can't access it.
        if (error instanceof DOMException && error.name === 'SecurityError' && (0, $ieeJu.expValEquals)('platform_editor_fix_cross_origin_editor_focus', 'isEnabled', true)) {
            if (view) {
                view.focus();
                return;
            }
        } else // re-throw other unexpected errors
        throw error;
    }
    // set cursor/selection and focus
    const anchor = view?.posAtDOM(range.startContainer, range.startOffset);
    const head = view?.posAtDOM(range.endContainer, range.endOffset);
    // if anchor or head < 0 focus and exit
    if (anchor && anchor < 0 || head && head < 0) {
        view?.focus();
        return;
    }
    if (view && anchor) {
        const selection = (0, $kCECX.TextSelection).create(view.state.doc, anchor, head);
        const tr = view.state.tr.setSelection(selection);
        view.dispatch(tr);
        view.focus();
    }
}














var $gkq2M = parcelRequire("gkq2M");


var $jbOus = parcelRequire("jbOus");


var $8ROsu = parcelRequire("8ROsu");


var $hiQdW = parcelRequire("hiQdW");

const $0ec43cb630598322$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((_oldStart, _oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};





const $c16ee807d71ffd9e$export$9f24e92219b6e945 = 'Setting an unsafe property on transaction after dispatch!';
// since selection uses curSelection under the hood, we guard setSelection instead
const $c16ee807d71ffd9e$var$isUnsafeMethod = (prop)=>[
        'setSelection'
    ].includes(prop.toString());
const $c16ee807d71ffd9e$var$isReadOnlyProperty = (prop)=>[
        'doc',
        'docs',
        'steps',
        'selection'
    ].includes(prop.toString());
const $c16ee807d71ffd9e$export$668aa008bdae439f = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginKey: pluginKey })=>{
    const isUnsafe = ()=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).TRANSACTION_MUTATED_AFTER_DISPATCH,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                pluginKey: pluginKey || 'unknown'
            }
        });
        throw new Error($c16ee807d71ffd9e$export$9f24e92219b6e945);
    };
    return {
        get: function(target, prop, receiver) {
            if ($c16ee807d71ffd9e$var$isUnsafeMethod(prop)) isUnsafe();
            return Reflect.get(target, prop, receiver);
        },
        set: function(target, prop, receiver) {
            if ($c16ee807d71ffd9e$var$isReadOnlyProperty(prop)) isUnsafe();
            return Reflect.set(target, prop, receiver);
        }
    };
};








/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $222639a17f5efda5$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;


const $f09857ac1790b989$export$5e38f3b295505ec8 = `\u{1F989} EditorView::state::apply`;
const $f09857ac1790b989$export$646ca0d076c98ad5 = `\u{1F989} EditorView::updateState`;
const $f09857ac1790b989$export$2f488cec9729a7d6 = `\u{1F989} EditorView::onEditorViewStateUpdated`;
const $f09857ac1790b989$export$bb82e7cfb8987f35 = `\u{1F989} ReactEditorView::onChange`;
const $f09857ac1790b989$export$373baa16b824d295 = `\u{1F989} ReactEditorView::dispatchTransaction`;
const $f09857ac1790b989$export$735da5ee20c885d5 = false;
const $f09857ac1790b989$var$DEFAULT_SAMPLING_RATE = 100;
const $f09857ac1790b989$var$noop = ()=>{};
class $f09857ac1790b989$export$7a054319813aafa {
    addMeasureListener(listener) {
        this.measureListeners.push(listener);
    }
    removeMeasureListener(listener) {
        const index = this.measureListeners.indexOf(listener);
        if (index > -1) this.measureListeners.splice(index, 1);
    }
    shouldTrackTransaction(options) {
        const { enabled: trackingEnabled, samplingRate: samplingRate = $f09857ac1790b989$var$DEFAULT_SAMPLING_RATE } = options;
        return trackingEnabled && this.dispatchCallCounter === samplingRate;
    }
    constructor(){
        // Counter so we can rate limit the transaction performance tracking
        this.dispatchCallCounter = 0;
        // A map containing the time which measurement starts
        this.measureMap = new Map();
        this.measureListeners = [];
        this.bumpDispatchCounter = (options)=>{
            const { enabled: trackingEnabled, samplingRate: samplingRate = $f09857ac1790b989$var$DEFAULT_SAMPLING_RATE } = options;
            if (trackingEnabled) {
                if (this.dispatchCallCounter >= samplingRate) this.dispatchCallCounter = 0;
                this.dispatchCallCounter++;
            }
            return this.dispatchCallCounter;
        };
        this.getMeasureHelpers = (options)=>{
            const { usePerformanceMarks: usePerformanceMarks = $f09857ac1790b989$export$735da5ee20c885d5 } = options;
            if (!this.shouldTrackTransaction(options)) return {
                startMeasure: $f09857ac1790b989$var$noop,
                stopMeasure: $f09857ac1790b989$var$noop
            };
            return {
                startMeasure: usePerformanceMarks ? (0, $hiQdW.startMeasure) : this.startMeasureSimple,
                stopMeasure: usePerformanceMarks ? (0, $hiQdW.stopMeasure) : this.stopMeasureSimple
            };
        };
        this.startMeasureSimple = (measureName)=>{
            if (!(0, $gMweA.isPerformanceAPIAvailable)()) return;
            this.measureMap.set(measureName, performance.now());
        };
        this.stopMeasureSimple = (measureName, onMeasureComplete)=>{
            if (!(0, $gMweA.isPerformanceAPIAvailable)()) return;
            const startTime = this.measureMap.get(measureName);
            if (startTime) {
                const duration = (0, $222639a17f5efda5$export$a26b90db2c8f1b97)(startTime);
                this.measureMap.delete(measureName);
                if (onMeasureComplete) onMeasureComplete(duration, startTime);
                // Call each subscribed listener
                this.measureListeners.forEach((listener)=>listener({
                        name: measureName,
                        duration: duration,
                        startTime: startTime
                    }));
            }
        };
    }
}


const $1df669123c71c9c7$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check();
    } catch (error) {
        return false;
    }
    return true;
};


const $965beaf2cc445b32$export$996213f7c272fc6f = (nodes)=>nodes.every((0, $1df669123c71c9c7$export$4c39e41e39b3c449));



const $a5c701676bfcc1ce$export$b582387940572fe7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { onChange: onChange, dispatchAnalyticsEvent: dispatchAnalyticsEvent, onEditorViewUpdated: onEditorViewUpdated, isRemoteReplaceDocumentTransaction: isRemoteReplaceDocumentTransaction } = t0;
    const onChangeRef = (0, $cozmU.useRef)(onChange);
    let t1;
    let t2;
    if ($[0] !== onChange) {
        t1 = ()=>{
            onChangeRef.current = onChange;
        };
        t2 = [
            onChange
        ];
        $[0] = onChange;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== dispatchAnalyticsEvent || $[4] !== isRemoteReplaceDocumentTransaction || $[5] !== onEditorViewUpdated) {
        t3 = (view, unsafeTransaction)=>{
            if (!view) return;
            const nodes = (0, $0ec43cb630598322$export$cdc577fd3f583194)(unsafeTransaction);
            const changedNodesValid = (0, $965beaf2cc445b32$export$996213f7c272fc6f)(nodes);
            const transaction = new Proxy(unsafeTransaction, (0, $c16ee807d71ffd9e$export$668aa008bdae439f)({
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                pluginKey: "unknown-reacteditorview"
            }));
            const isRemoteReplace = isRemoteReplaceDocumentTransaction ? isRemoteReplaceDocumentTransaction(transaction) : false;
            if (changedNodesValid || isRemoteReplace) {
                const oldEditorState = view.state;
                const { state: newEditorState, transactions: transactions } = view.state.applyTransaction(transaction);
                if (newEditorState === oldEditorState) return;
                view.updateState(newEditorState);
                onEditorViewUpdated({
                    originalTransaction: transaction,
                    transactions: transactions,
                    oldEditorState: oldEditorState,
                    newEditorState: newEditorState
                });
                if (onChangeRef.current && transaction.docChanged) {
                    const source = transaction.getMeta("isRemote") ? "remote" : "local";
                    const isDirtyChange = (0, $jbOus.isDirtyTransaction)(transaction);
                    (0, $hiQdW.startMeasure)((0, $f09857ac1790b989$export$bb82e7cfb8987f35));
                    onChangeRef.current(view, {
                        source: source,
                        isDirtyChange: isDirtyChange
                    });
                    (0, $hiQdW.stopMeasure)((0, $f09857ac1790b989$export$bb82e7cfb8987f35));
                }
            }
            if (!changedNodesValid) {
                const invalidNodes = nodes.filter($a5c701676bfcc1ce$var$_temp).map($a5c701676bfcc1ce$var$_temp2);
                dispatchAnalyticsEvent({
                    action: (0, $krYZG.ACTION).DISPATCHED_INVALID_TRANSACTION,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        analyticsEventPayloads: (0, $gkq2M.getAnalyticsEventsFromTransaction)(transaction),
                        invalidNodes: invalidNodes,
                        isRemoteReplaceDocumentTransaction: isRemoteReplace
                    }
                });
            }
        };
        $[3] = dispatchAnalyticsEvent;
        $[4] = isRemoteReplaceDocumentTransaction;
        $[5] = onEditorViewUpdated;
        $[6] = t3;
    } else t3 = $[6];
    const dispatchTransaction = t3;
    return dispatchTransaction;
} : ({ onChange: onChange, dispatchAnalyticsEvent: dispatchAnalyticsEvent, onEditorViewUpdated: onEditorViewUpdated, isRemoteReplaceDocumentTransaction: isRemoteReplaceDocumentTransaction })=>{
    // We need to have a ref to the latest `onChange` since the `dispatchTransaction` gets captured
    const onChangeRef = (0, $cozmU.useRef)(onChange);
    (0, $cozmU.useEffect)(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    const dispatchTransaction = (0, $cozmU.useCallback)((view, unsafeTransaction)=>{
        if (!view) return;
        const nodes = (0, $0ec43cb630598322$export$cdc577fd3f583194)(unsafeTransaction);
        const changedNodesValid = (0, $965beaf2cc445b32$export$996213f7c272fc6f)(nodes);
        const transaction = new Proxy(unsafeTransaction, (0, $c16ee807d71ffd9e$export$668aa008bdae439f)({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginKey: 'unknown-reacteditorview'
        }));
        // If the transaction is a remote replaceDocument transaction, we should skip validation.
        // Remote replaceDocument transactions are fired when the document is replaced by initialization of editor-plugin-collab-edit
        // If there is a discrepancy in the ProseMirror schema at initialization, it results in the editor being loaded with no content,
        // giving the user the impression that content has been lost
        const isRemoteReplace = isRemoteReplaceDocumentTransaction ? isRemoteReplaceDocumentTransaction(transaction) : false;
        if (changedNodesValid || isRemoteReplace) {
            const oldEditorState = view.state;
            // go ahead and update the state now we know the transaction is good
            const { state: newEditorState, transactions: transactions } = view.state.applyTransaction(transaction);
            if (newEditorState === oldEditorState) return;
            view.updateState(newEditorState);
            onEditorViewUpdated({
                originalTransaction: transaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
            if (onChangeRef.current && transaction.docChanged) {
                const source = transaction.getMeta('isRemote') ? 'remote' : 'local';
                const isDirtyChange = (0, $jbOus.isDirtyTransaction)(transaction);
                (0, $hiQdW.startMeasure)((0, $f09857ac1790b989$export$bb82e7cfb8987f35));
                onChangeRef.current(view, {
                    source: source,
                    isDirtyChange: isDirtyChange
                });
                (0, $hiQdW.stopMeasure)((0, $f09857ac1790b989$export$bb82e7cfb8987f35));
            }
        }
        if (!changedNodesValid) {
            const invalidNodes = nodes.filter((node)=>!(0, $1df669123c71c9c7$export$4c39e41e39b3c449)(node)).map((node_0)=>(0, $8ROsu.getDocStructure)(node_0, {
                    compact: true
                }));
            dispatchAnalyticsEvent({
                action: (0, $krYZG.ACTION).DISPATCHED_INVALID_TRANSACTION,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    analyticsEventPayloads: (0, $gkq2M.getAnalyticsEventsFromTransaction)(transaction),
                    invalidNodes: invalidNodes,
                    isRemoteReplaceDocumentTransaction: isRemoteReplace
                }
            });
        }
    }, [
        dispatchAnalyticsEvent,
        onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction
    ]);
    return dispatchTransaction;
};
function $a5c701676bfcc1ce$var$_temp(node) {
    return !(0, $1df669123c71c9c7$export$4c39e41e39b3c449)(node);
}
function $a5c701676bfcc1ce$var$_temp2(node_0) {
    return (0, $8ROsu.getDocStructure)(node_0, {
        compact: true
    });
}




















const $9a35c14aafbf2032$export$47d5b79f3ddf0b92 = (appearance)=>{
    if (appearance === 'full-width') return (0, $iLcY8.FULL_WIDTH_MODE).FULL_WIDTH;
    return (0, $iLcY8.FULL_WIDTH_MODE).FIXED_WIDTH;
};


const $613adc729f63e077$export$4998b7b36606f9c3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (appearance, dispatchAnalyticsEvent)=>{
    const $ = (0, $bDgLe.c)(5);
    const previousAppearance = (0, $2InGJ.default)(appearance);
    let t0;
    let t1;
    if ($[0] !== appearance || $[1] !== dispatchAnalyticsEvent || $[2] !== previousAppearance) {
        t0 = ()=>{
            if (appearance !== previousAppearance) {
                if (appearance === "full-width" || previousAppearance === "full-width") dispatchAnalyticsEvent({
                    action: (0, $krYZG.ACTION).CHANGED_FULL_WIDTH_MODE,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        previousMode: (0, $9a35c14aafbf2032$export$47d5b79f3ddf0b92)(previousAppearance),
                        newMode: (0, $9a35c14aafbf2032$export$47d5b79f3ddf0b92)(appearance)
                    }
                });
            }
        };
        t1 = [
            appearance,
            previousAppearance,
            dispatchAnalyticsEvent
        ];
        $[0] = appearance;
        $[1] = dispatchAnalyticsEvent;
        $[2] = previousAppearance;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : (appearance, dispatchAnalyticsEvent)=>{
    const previousAppearance = (0, $2InGJ.default)(appearance);
    (0, $cozmU.useEffect)(()=>{
        if (appearance !== previousAppearance) {
            if (appearance === 'full-width' || previousAppearance === 'full-width') dispatchAnalyticsEvent({
                action: (0, $krYZG.ACTION).CHANGED_FULL_WIDTH_MODE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    previousMode: (0, $9a35c14aafbf2032$export$47d5b79f3ddf0b92)(previousAppearance),
                    newMode: (0, $9a35c14aafbf2032$export$47d5b79f3ddf0b92)(appearance)
                }
            });
        }
    }, [
        appearance,
        previousAppearance,
        dispatchAnalyticsEvent
    ]);
};


const $218674f197ea575e$var$EDIT_AREA_ID = 'ak-editor-textarea';
const $218674f197ea575e$var$SSR_TRACE_SEGMENT_NAME = 'reactEditorView';
const $218674f197ea575e$var$bootStartTime = (0, $gMweA.isPerformanceAPIAvailable)() ? performance.now() : undefined;
// `markdown↔rich` toggles drop different node/mark sets, so the unique
// name set is enough to detect when a destructive rebuild is needed.
function $218674f197ea575e$var$sameNames(a, b) {
    const setA = new Set(a);
    const setB = new Set(b);
    if (setA.size !== setB.size) return false;
    for (const name of setA){
        if (!setB.has(name)) return false;
    }
    return true;
}
function $218674f197ea575e$var$schemaShapeChanged(current, next) {
    return !$218674f197ea575e$var$sameNames(Object.keys(current.nodes), next.nodes.map((n)=>n.name)) || !$218674f197ea575e$var$sameNames(Object.keys(current.marks), next.marks.map((m)=>m.name));
}
function $218674f197ea575e$export$e7d1b1cbca007e16(props) {
    // Should be always the first statement in the component
    const firstRenderStartTimestampRef = (0, $cozmU.useRef)(performance.now());
    const { preset: preset, editorProps: { onSSRMeasure: onSSRMeasure, appearance: nextAppearance, disabled: disabled, featureFlags: editorPropFeatureFlags, errorReporterHandler: errorReporterHandler, defaultValue: defaultValue, shouldFocus: shouldFocus }, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed } = props;
    // Holds the best available EditorState before the ProseMirror EditorView has mounted.
    // On SSR: set to the SSR-rendered state so toolbar plugins can read it via getEditorState().
    // On client first render: set to initialEditorState for the same reason.
    // Cleared to undefined once createEditorView runs and viewRef.current becomes available.
    const preMountEditorStateRef = (0, $cozmU.useRef)(undefined);
    const editorRef = (0, $cozmU.useRef)(null);
    const viewRef = (0, $cozmU.useRef)();
    const focusTimeoutId = (0, $cozmU.useRef)();
    // ProseMirror is instantiated prior to the initial React render cycle,
    // so we allow transactions by default, to avoid discarding the initial one.
    const canDispatchTransactions = (0, $cozmU.useRef)(true);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const editorId = (0, $cozmU.useRef)((0, $03RpJ.default)());
    const eventDispatcher = (0, $cozmU.useMemo)(()=>new (0, $fGIRV.EventDispatcher)(), []);
    const config = (0, $cozmU.useRef)({
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
    const contentTransformer = (0, $cozmU.useRef)(undefined);
    const featureFlags = (0, $cozmU.useMemo)(()=>(0, $cfjQo.createFeatureFlagsFromProps)(editorPropFeatureFlags), [
        editorPropFeatureFlags
    ]);
    const getEditorState = (0, $cozmU.useCallback)(()=>preMountEditorStateRef.current ?? viewRef.current?.state, []);
    const getEditorView = (0, $cozmU.useCallback)(()=>viewRef.current, []);
    const dispatch = (0, $cozmU.useMemo)(()=>(0, $fGIRV.createDispatch)(eventDispatcher), [
        eventDispatcher
    ]);
    const errorReporter = (0, $cozmU.useMemo)(()=>(0, $214e7a10e86ba265$export$e98521bb0cea2db1)(errorReporterHandler), [
        errorReporterHandler
    ]);
    const handleAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        (0, $fdQKX.fireAnalyticsEvent)(props.createAnalyticsEvent)(payload);
    }, [
        props.createAnalyticsEvent
    ]);
    const dispatchAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        const dispatch = (0, $fGIRV.createDispatch)(eventDispatcher);
        dispatch((0, $6pnwK.analyticsEventKey), {
            payload: payload
        });
    }, [
        eventDispatcher
    ]);
    const pluginInjectionAPI = (0, $cozmU.useRef)(new (0, $909b6449b6611a81$export$50ccbedb1c6559a0)({
        getEditorState: getEditorState,
        getEditorView: getEditorView,
        fireAnalyticsEvent: handleAnalyticsEvent,
        appearance: nextAppearance
    }));
    const parseDoc = (0, $cozmU.useCallback)((schema, api, options)=>{
        if (!options.doc) return undefined;
        // if the collabEdit API is set, skip this validation due to potential pm validation errors
        // from docs that end up with invalid marks after processing (See #hot-111702 for more details)
        if ((0, $4iudd.isSSR)() || api?.collabEdit !== undefined || options.props.editorProps.skipValidation) return (0, $5Qi6J.processRawValueWithoutValidation)(schema, options.doc, dispatchAnalyticsEvent);
        else return (0, $5Qi6J.processRawValue)(schema, options.doc, options.props.providerFactory, options.props.editorProps.sanitizePrivateContent, contentTransformer.current, dispatchAnalyticsEvent);
    }, [
        dispatchAnalyticsEvent
    ]);
    const createEditorState = (0, $cozmU.useCallback)((options)=>{
        let schema;
        if (viewRef.current) {
            if (options.resetting) /**
         * ReactEditorView currently does NOT handle dynamic schema,
         * We are reusing the existing schema, and rely on #reconfigureState
         * to update `this.config`
         */ schema = viewRef.current.state.schema;
            else {
                /**
         * There's presently a number of issues with changing the schema of a
         * editor inflight. A significant issue is that we lose the ability
         * to keep track of a user's history as the internal plugin state
         * keeps a list of Steps to undo/redo (which are tied to the schema).
         * Without a good way to do work around this, we prevent this for now.
         */ // eslint-disable-next-line no-console
                console.warn('The editor does not support changing the schema dynamically.');
                return viewRef.current.state;
            }
        } else {
            config.current = (0, $5c368fea92f7e1ac$export$7265233e78178a4)((0, $ceZg8.default)(options.props.preset, 'allowBlockType' in props.editorProps ? props.editorProps : {}, pluginInjectionAPI.current));
            config.current.pmPlugins.push(...pluginInjectionAPI.current.getInternalPMPlugins());
            schema = (0, $97fb23b0b573a2d0$export$5f4ce795563f4211)(config.current);
        }
        const { contentTransformerProvider: contentTransformerProvider } = options.props.editorProps;
        const plugins = (0, $13ce1df8d27a505a$export$169329cb2979ef81)({
            schema: schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: options.props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: pluginInjectionAPI.current.onEditorViewUpdated
        });
        contentTransformer.current = contentTransformerProvider ? contentTransformerProvider(schema) : undefined;
        const api = pluginInjectionAPI.current.api();
        // If we have a doc prop, we need to process it into a PMNode
        const doc = parseDoc(schema, api, options);
        const isViewMode = api?.editorViewMode?.sharedState.currentState().mode === 'view';
        let selection;
        if (doc) {
            if (isViewMode) {
                const emptySelection = new (0, $kCECX.TextSelection)(doc.resolve(0));
                return (0, $kCECX.EditorState).create({
                    schema: schema,
                    plugins: plugins,
                    doc: doc,
                    selection: emptySelection
                });
            } else selection = options.selectionAtStart ? (0, $kCECX.Selection).atStart(doc) : (0, $kCECX.Selection).atEnd(doc);
        }
        // Workaround for ED-3507: When media node is the last element, scrollIntoView throws an error
        const patchedSelection = selection ? (0, $kCECX.Selection).findFrom(selection.$head, -1, true) || undefined : undefined;
        return (0, $kCECX.EditorState).create({
            schema: schema,
            plugins: plugins,
            doc: doc,
            selection: patchedSelection
        });
    }, [
        errorReporter,
        featureFlags,
        parseDoc,
        props.intl,
        props.portalProviderAPI,
        props.nodeViewPortalProviderAPI,
        props.editorProps,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch
    ]);
    const initialEditorState = (0, $cozmU.useMemo)(()=>{
        if ((0, $4iudd.isSSR)()) // We don't need to create initial state in SSR, it would be done by EditorSSRRenderer,
        // so we can save some CPU time here.
        return undefined;
        const state = createEditorState({
            props: props,
            doc: defaultValue,
            // ED-4759: Don't set selection at end for full-page editor - should be at start.
            selectionAtStart: (0, $loGKD.isFullPage)(nextAppearance)
        });
        if ((0, $ieeJu.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true)) // CSR only, synchronously set preMountEditorStateRef so it's ready to be consumed by children including toolbar
        preMountEditorStateRef.current = state;
        return state;
    }, // This is only used for the initial state - afterwards we will have `viewRef` available for use
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const getCurrentEditorState = (0, $cozmU.useCallback)(()=>{
        return viewRef.current?.state ?? initialEditorState;
    }, [
        initialEditorState
    ]);
    const blur = (0, $cozmU.useCallback)(()=>{
        if (!viewRef.current) return;
        if (viewRef.current.dom instanceof HTMLElement && viewRef.current.hasFocus()) viewRef.current.dom.blur();
        // The selectionToDOM method uses the document selection to determine currently selected node
        // We need to mimic blurring this as it seems doing the above is not enough.
        // Guard against clearing selections that belong outside this editor instance.
        // @ts-expect-error
        const sel = viewRef.current.root.getSelection();
        if (sel) {
            if (!(0, $4o0zT.isExperimentEnabled)('fix_editor_blur_issue_exp')) {
                sel.removeAllRanges();
                return;
            }
            if ((!sel.anchorNode || viewRef.current.dom.contains(sel.anchorNode)) && (!sel.focusNode || viewRef.current.dom.contains(sel.focusNode))) sel.removeAllRanges();
        }
    }, []);
    const resetEditorState = (0, $cozmU.useCallback)(({ doc: doc, shouldScrollToBottom: shouldScrollToBottom })=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const newEditorState = createEditorState({
            props: props,
            doc: doc,
            resetting: true,
            selectionAtStart: !shouldScrollToBottom
        });
        viewRef.current.updateState(newEditorState);
        props.editorProps.onChange?.(viewRef.current, {
            source: 'local',
            isDirtyChange: false
        });
    }, [
        blur,
        createEditorState,
        props
    ]);
    // Initialise phase
    // Using constructor hook so we setup and dispatch analytics before anything else
    (0, $4o5MH.default)(()=>{
        // This needs to be before initialising editorState because
        // we dispatch analytics events in plugin initialisation
        eventDispatcher.on((0, $6pnwK.analyticsEventKey), handleAnalyticsEvent);
        eventDispatcher.on('resetEditorState', resetEditorState);
        dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).STARTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            attributes: {
                platform: (0, $iLcY8.PLATFORMS).WEB,
                featureFlags: featureFlags ? (0, $dnhfp.getEnabledFeatureFlagKeys)(featureFlags) : [],
                accountLocale: props.intl?.locale,
                browserLocale: window.navigator.language
            },
            eventType: (0, $krYZG.EVENT_TYPE).UI
        });
    });
    (0, $cozmU.useLayoutEffect)(()=>{
        if ((0, $4iudd.isSSR)()) return;
        // Transaction dispatching is already enabled by default prior to
        // mounting, but we reset it here, just in case the editor view
        // instance is ever recycled (mounted again after unmounting) with
        // the same key.
        // AND since React 18 effects may run multiple times so we need to ensure
        // this is reset so that transactions are still allowed.
        // Although storing mounted state is an anti-pattern in React,
        // we do so here so that we can intercept and abort asynchronous
        // ProseMirror transactions when a dismount is imminent.
        canDispatchTransactions.current = true;
        return ()=>{
            // We can ignore any transactions from this point onwards.
            // This serves to avoid potential runtime exceptions which could arise
            // from an async dispatched transaction after it's unmounted.
            canDispatchTransactions.current = false;
        };
    }, []);
    // Cleanup
    (0, $cozmU.useLayoutEffect)(()=>{
        if ((0, $4iudd.isSSR)()) // No cleanup in SSR should happened because SSR doesn't render a real editor.
        return;
        return ()=>{
            const focusTimeoutIdCurrent = focusTimeoutId.current;
            if (focusTimeoutIdCurrent) clearTimeout(focusTimeoutIdCurrent);
            if (viewRef.current) {
                // Destroy the state if the Editor is being unmounted
                const editorState = viewRef.current.state;
                editorState.plugins.forEach((plugin)=>{
                    const state = plugin.getState(editorState);
                    if (state && state.destroy) state.destroy();
                });
            }
            eventDispatcher.destroy();
        // this.view will be destroyed when React unmounts in handleEditorViewRef
        };
    }, [
        eventDispatcher
    ]);
    // Bumped after `reconfigureState` so the render prop re-reads the
    // in-place-mutated `config.current` (contentComponents / toolbar
    // components from the rebuilt preset).
    const [, bumpConfigVersion] = (0, $cozmU.useState)(0);
    // Preset reference last processed by reconfigureState. Used to skip the
    // destructive work (plugin filter, schema rebuild) when reconfigure is
    // called with the same preset.
    const lastProcessedPresetRef = (0, $cozmU.useRef)(null);
    const reconfigureState = (0, $cozmU.useCallback)((props)=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        // Snapshot plugin names registered before createPluginsList runs, so
        // we can tell which plugins are newly added by the new preset vs.
        // which ones already coexisted with the current schema.
        const previousPluginNames = new Set(pluginInjectionAPI.current.getRegisteredPluginNames());
        let editorPlugins = (0, $ceZg8.default)(props.preset, 'allowBlockType' in props.editorProps ? props.editorProps : {}, pluginInjectionAPI.current);
        // Capture once, before either downstream block updates the ref —
        // both the filter and the schema rebuild are destructive and only
        // want to run when the preset has actually changed.
        const presetChanged = lastProcessedPresetRef.current !== props.preset;
        // Build a candidate config from the *unfiltered* plugin list so we can
        // decide whether the schema rebuild path will run. Both the rebuild
        // decision and the drop-filter decision below depend on this answer,
        // so it has to be computed up-front.
        const buildConfig = (plugins)=>{
            const c = (0, $5c368fea92f7e1ac$export$7265233e78178a4)(plugins);
            c.pmPlugins.push(...pluginInjectionAPI.current.getInternalPMPlugins());
            return c;
        };
        let nextConfig = buildConfig(editorPlugins);
        // `state.reconfigure` preserves the original schema, so a preset
        // toggle that should change schema (markdown↔rich) needs a fresh
        // `EditorState`. Resets all plugin state including undo history.
        //
        // Compare schema *shape* (node + mark name sets) rather than preset
        // identity: consumers commonly recreate the preset object on every
        // parent re-render, and a destructive rebuild on a no-op identity
        // change tears down all plugin state (e.g. unmounts the AI palette).
        const shouldRebuildSchema = presetChanged && $218674f197ea575e$var$schemaShapeChanged(viewRef.current.state.schema, nextConfig) && (0, $anBbz.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true);
        // `state.reconfigure` keeps the original schema, so switching presets
        // can leave the editor inconsistent in two ways:
        //   1. The new preset may add plugins that reference schema nodes or
        //      marks the original schema doesn't have.
        //   2. Plugins registered by a previous preset can linger in the
        //      injection API even when the new preset doesn't re-register
        //      them, so listeners still fire against a state that no longer
        //      has their pmPlugin.
        //
        // When the schema is being rebuilt below, the new schema is built
        // from the *unfiltered* plugin list — so dropping plugins whose
        // nodes/marks the OLD schema lacks would wrongly remove the very
        // plugins the rebuild is meant to admit. Skip the drop step in that
        // case (purpose 1) but always reconcile the injection API
        // (purpose 2). When NOT rebuilding, run both — even under the
        // `cc-markdown-mode` experiment, otherwise no-op preset identity
        // changes would silently leave a broken plugin/schema mismatch.
        if (presetChanged) {
            let dropped = [];
            if (!shouldRebuildSchema) {
                const result = (0, $c54d3f6fb8206a7b$export$1a7fe7567929e9de)(editorPlugins, viewRef.current.state.schema, previousPluginNames);
                if (result.dropped.length > 0) {
                    editorPlugins = result.kept;
                    // Plugin list changed — rebuild candidate config to match.
                    nextConfig = buildConfig(editorPlugins);
                }
                dropped = result.dropped;
            }
            const keptPluginNames = new Set(editorPlugins.map((p)=>p?.name).filter((n)=>Boolean(n)));
            const evictedFromApi = pluginInjectionAPI.current.retainPlugins(keptPluginNames);
            if (dropped.length > 0 || evictedFromApi.length > 0) // eslint-disable-next-line no-console
            console.warn('[reconfigureState] Cleanup summary:', {
                dropped: dropped,
                evictedFromApi: evictedFromApi
            });
        }
        config.current = nextConfig;
        const state = viewRef.current.state;
        let newState;
        if (shouldRebuildSchema) {
            const newSchema = (0, $97fb23b0b573a2d0$export$5f4ce795563f4211)(config.current);
            let newDoc;
            try {
                newDoc = (0, $aPdNQ.Node).fromJSON(newSchema, state.doc.toJSON());
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('[reconfigureState] Failed to migrate doc to new schema; resetting to empty doc', e);
                const empty = newSchema.topNodeType.createAndFill();
                if (!empty) throw new Error('reconfigureState: doc migration failed and new schema cannot create an empty top node');
                newDoc = empty;
            }
            let newSelection;
            try {
                newSelection = (0, $kCECX.Selection).fromJSON(newDoc, state.selection.toJSON());
            } catch  {
                // Old selection's positions / node types may not map onto the new schema.
                newSelection = (0, $kCECX.Selection).atStart(newDoc);
            }
            const plugins = (0, $13ce1df8d27a505a$export$169329cb2979ef81)({
                schema: newSchema,
                dispatch: dispatch,
                errorReporter: errorReporter,
                editorConfig: config.current,
                eventDispatcher: eventDispatcher,
                providerFactory: props.providerFactory,
                portalProviderAPI: props.portalProviderAPI,
                nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                featureFlags: featureFlags,
                getIntl: ()=>props.intl,
                onEditorStateUpdated: pluginInjectionAPI.current.onEditorViewUpdated
            });
            newState = (0, $kCECX.EditorState).create({
                schema: newSchema,
                doc: newDoc,
                selection: newSelection,
                plugins: plugins
            });
        } else {
            const plugins = (0, $13ce1df8d27a505a$export$169329cb2979ef81)({
                schema: state.schema,
                dispatch: dispatch,
                errorReporter: errorReporter,
                editorConfig: config.current,
                eventDispatcher: eventDispatcher,
                providerFactory: props.providerFactory,
                portalProviderAPI: props.portalProviderAPI,
                nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                featureFlags: featureFlags,
                getIntl: ()=>props.intl,
                onEditorStateUpdated: pluginInjectionAPI.current.onEditorViewUpdated
            });
            newState = state.reconfigure({
                plugins: plugins
            });
        }
        if (presetChanged) lastProcessedPresetRef.current = props.preset;
        // need to update the state first so when the view builds the nodeviews it is
        // using the latest plugins
        viewRef.current.updateState(newState);
        const result = viewRef.current.update({
            ...viewRef.current.props,
            state: newState
        });
        // The new collab-edit plugin instance starts with `isReady=false`.
        // The rebind path in editor-plugin-collab-edit's initialize.ts is
        // gated on `provider.getInitPayload`, which the Confluence NCS
        // provider does not implement, so the placeholder spinner would
        // never clear. Re-seeding here is safe: the prior state must have
        // had `isReady=true` for the user to have triggered the toggle.
        //
        // Must run AFTER `view.update({ state: newState })`: that call resets
        // the view's state to the captured `newState` reference, so a
        // dispatch placed before it would advance `view.state` to a value
        // that `update` then silently overwrites — discarding the meta and
        // leaving `isReady=false`.
        if (shouldRebuildSchema) {
            // `state.collabEditPlugin$` is the property PM derives from the
            // collab plugin's PluginKey; cast through `unknown` to read it.
            const collabState = viewRef.current.state.collabEditPlugin$;
            if (collabState && collabState.isReady !== true) viewRef.current.dispatch(viewRef.current.state.tr.setMeta('collabInitialised', true));
        }
        // EDITOR-6702: gated until we have a broader gate; reconfigure is a
        // low-level path so use NoExposure.
        if ((0, $anBbz.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true)) // Force a render so PluginSlot picks up the new preset's content
        // components against the new state.
        bumpConfigVersion((v)=>v + 1);
        return result;
    }, [
        blur,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch,
        errorReporter,
        featureFlags
    ]);
    const onEditorViewUpdated = (0, $cozmU.useCallback)(({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState })=>{
        config.current?.onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
            entry.callback({
                originalTransaction: originalTransaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
        });
    }, []);
    const dispatchTransaction = (0, $a5c701676bfcc1ce$export$b582387940572fe7)({
        onChange: props.editorProps.onChange,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onEditorViewUpdated: onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction: pluginInjectionAPI.current.api()?.collabEdit?.actions?.isRemoteReplaceDocumentTransaction
    });
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove these when we deprecate these props from editor-props - smartLinks is unfortunately still used in some places, we can sidestep this problem if we move everyone across to ComposableEditor and deprecate Editor
    const UNSAFE_cards = props.editorProps.UNSAFE_cards;
    const smartLinks = props.editorProps.smartLinks;
    // Temporary to replace provider factory while migration to `ComposableEditor` occurs
    (0, $fdff5ad7448b8b55$export$e4c19534640d7866)({
        editorApi: pluginInjectionAPI.current.api(),
        contextIdentifierProvider: props.editorProps.contextIdentifierProvider,
        mediaProvider: props.editorProps.media?.provider,
        mentionProvider: props.editorProps.mentionProvider,
        cardProvider: props.editorProps.linking?.smartLinks?.provider || smartLinks && smartLinks.provider || UNSAFE_cards && UNSAFE_cards.provider,
        emojiProvider: props.editorProps.emojiProvider,
        autoformattingProvider: props.editorProps.autoformattingProvider,
        taskDecisionProvider: props.editorProps.taskDecisionProvider
    });
    const getDirectEditorProps = (0, $cozmU.useCallback)((state)=>{
        const stateToUse = state ?? getCurrentEditorState();
        if (!stateToUse) // This should not be happened, because initialState is only inavailable in SSR,
        // but in SSR this function should never be called.
        // In SSR we should use EditorSSRRenderer instead usual ProseMirror editor.
        throw new Error('No editor state found');
        return {
            state: stateToUse,
            dispatchTransaction: (tr)=>{
                // Block stale transactions:
                // Prevent runtime exceptions from async transactions that would attempt to
                // update the DOM after React has unmounted the Editor.
                if (canDispatchTransactions.current) dispatchTransaction(viewRef.current, tr);
            },
            // Disables the contentEditable attribute of the editor if the editor is disabled
            editable: (_state)=>!disabled,
            attributes: {
                'data-gramm': 'false'
            }
        };
    }, [
        dispatchTransaction,
        disabled,
        getCurrentEditorState
    ]);
    const createEditorView = (0, $cozmU.useCallback)((node)=>{
        // Creates the editor-view from this.editorState. If an editor has been mounted
        // previously, this will contain the previous state of the editor.
        const view = new (0, $8nvEM.EditorView)({
            mount: node
        }, getDirectEditorProps());
        viewRef.current = view;
        if ((0, $ieeJu.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true)) // clears pre-mount state as soon as the final view is mounted
        preMountEditorStateRef.current = undefined;
        (0, $5vSgR.measureRender)((0, $l5aTW.default).PROSEMIRROR_RENDERED, ({ duration: duration, startTime: startTime, distortedDuration: distortedDuration })=>{
            const proseMirrorRenderedSeverity = (0, $6pnwK.getAnalyticsEventSeverity)(duration, (0, $e7d2c0e957b38411$export$646a6982857f2cd5), (0, $e7d2c0e957b38411$export$79d7eac6cbb6352d));
            if (viewRef.current) {
                const { nodes: nodes, extensionKeys: extensionKeys } = (0, $fa2e45474333705a$export$af7be2186992199)(viewRef.current.state.doc);
                const ttfb = (0, $fS38i.getResponseEndTime)();
                const requestToResponseTime = (0, $kzRKB.getRequestToResponseTime)();
                const contextIdentifier = pluginInjectionAPI.current.api().base?.sharedState.currentState();
                const nodesInViewport = (0, $73258c031e4e3af0$export$f20e3cf045904cb)(viewRef.current.dom);
                const nodeSize = viewRef.current.state.doc.nodeSize;
                const { totalNodes: totalNodes, nodeSizeBucket: nodeSizeBucket } = (0, $ieeJu.expValEquals)('cc_editor_insm_doc_size_stats', 'isEnabled', true) ? {
                    totalNodes: Object.values(nodes).reduce((acc, curr)=>acc + curr, 0),
                    // Computed on client for dimension bucketing in Statsig
                    nodeSizeBucket: (()=>{
                        switch(true){
                            case nodeSize < 10000:
                                return '<10000';
                            case nodeSize < 20000:
                                return '<20000';
                            case nodeSize < 30000:
                                return '<30000';
                            case nodeSize < 40000:
                                return '<40000';
                            case nodeSize < 50000:
                                return '<50000';
                            default:
                                return '50000+';
                        }
                    })()
                } : {};
                const editorDomSize = (0, $bfdc563d0e4e6c6b$export$2b8873b73f502810)(viewRef.current);
                const interaction = (0, $a33Aa.getActiveInteraction)();
                const pageLoadType = interaction?.type;
                const pageType = interaction?.routeName;
                const timings = (()=>{
                    if (requestToResponseTime === undefined && $218674f197ea575e$var$bootStartTime === undefined) return undefined;
                    const timingValues = {};
                    if (requestToResponseTime !== undefined) timingValues['requestStart->responseEnd'] = Math.round(requestToResponseTime);
                    if ($218674f197ea575e$var$bootStartTime !== undefined) timingValues.bootToRender = Math.round(startTime - $218674f197ea575e$var$bootStartTime);
                    return timingValues;
                })();
                const attributes = {
                    duration: duration,
                    startTime: startTime,
                    nodes: nodes,
                    nodesInViewport: nodesInViewport,
                    nodeSize: nodeSize,
                    nodeSizeBucket: nodeSizeBucket,
                    totalNodes: totalNodes,
                    editorDomSize: editorDomSize,
                    ttfb: ttfb,
                    severity: proseMirrorRenderedSeverity,
                    objectId: contextIdentifier?.objectId,
                    distortedDuration: distortedDuration,
                    pageLoadType: pageLoadType,
                    pageType: pageType,
                    timings: timings,
                    extensionKeys: extensionKeys,
                    ufoInteractionId: (0, $E1QOf.getInteractionId)().current
                };
                (0, $gXfti.addUFOCustomData)({
                    editorDomSize: editorDomSize
                });
                dispatchAnalyticsEvent({
                    action: (0, $krYZG.ACTION).PROSEMIRROR_RENDERED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                    attributes: attributes,
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                });
            }
        });
        pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: viewRef.current.state,
            oldEditorState: undefined
        });
        return view;
    }, [
        getDirectEditorProps,
        dispatchAnalyticsEvent
    ]);
    const [editorView, setEditorView] = (0, $cozmU.useState)(undefined);
    // Detects if the editor is nested inside an extension - ie. it is a Legacy Content Extension (LCE)
    const isNestedEditor = (0, $cozmU.useRef)(null);
    const isNestedEditorCalculated = (0, $cozmU.useRef)(false);
    if (editorRef.current !== null && !isNestedEditorCalculated.current) {
        isNestedEditor.current = !!editorRef.current?.closest('.extension-editable-area');
        isNestedEditorCalculated.current = true;
    }
    // Preconditioned on the affected population - full page, non nested editors - so that experiment
    // exposure is not diluted by editors which never run the scroll restoration code below.
    const scrollRestorePerfEnabled = !isNestedEditor.current && (0, $loGKD.isFullPage)(props.editorProps.appearance) && (0, $4o0zT.isExperimentEnabled)('cc_editor_scroll_restore_perf_improvements');
    const originalScrollToRestore = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(// Reading scrollTop forces a synchronous layout, and this expression is re-evaluated on every
    // render. Products restore scroll themselves after the document has rendered.
    !isNestedEditor.current && (0, $loGKD.isFullPage)(props.editorProps.appearance) && !scrollRestorePerfEnabled ? document.querySelector('[data-editor-scroll-container]')?.scrollTop : undefined);
    const mitigateScrollJump = // The feature gate here is being used to avoid potential bugs with the scroll restoration code
    // moving it to the end of the expression negates the point of the feature gate
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $loGKD.isFullPage)(props.editorProps.appearance) && originalScrollToRestore.current && originalScrollToRestore.current !== 0;
    (0, $cozmU.useLayoutEffect)(()=>{
        if ((0, $4iudd.isSSR)()) // We don't need to focus anything in SSR.
        return;
        if (shouldFocus && editorView?.props.editable?.(editorView.state)) {
            if (!mitigateScrollJump) {
                const focusesImmediately = (0, $ba16f1fc98d339f3$export$73ae01d857526945)(props.editorProps.appearance) || (0, $iLrhi.isEmptyDocument)(editorView.state.doc) || pluginInjectionAPI.current.api()?.interaction === undefined;
                if (focusesImmediately) focusTimeoutId.current = (0, $0b5857bdb6352d46$export$ebebb7f5b9271fd7)(editorView);
            }
        }
    }, [
        editorView,
        shouldFocus,
        mitigateScrollJump,
        disabled,
        props.editorProps.appearance
    ]);
    const scrollElement = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const possibleListeners = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef([]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $4iudd.isSSR)()) // No event listeners should be attached to scroll element in SSR.
        return;
        return ()=>{
            if (scrollElement.current) // eslint-disable-next-line react-hooks/exhaustive-deps
            for (const possibleListener of possibleListeners.current)// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollElement.current?.removeEventListener(...possibleListener);
            scrollElement.current = null;
        };
    }, []);
    const handleEditorViewRef = (0, $cozmU.useCallback)((node)=>{
        if (node) {
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            scrollElement.current = document.querySelector('[data-editor-scroll-container]');
            const cleanupListeners = ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                for (const possibleListener of possibleListeners.current)// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current?.removeEventListener(...possibleListener);
            };
            if (scrollElement.current) {
                const wheelAbortHandler = (event)=>{
                    // Programmatic scrolls are not user interactions and must not abort the load metric.
                    if (scrollRestorePerfEnabled && !event.isTrusted) return;
                    const activeInteraction = (0, $a33Aa.getActiveInteraction)();
                    if (activeInteraction && [
                        'edit-page',
                        'live-edit'
                    ].includes(activeInteraction.ufoName)) (0, $a33Aa.abortAll)('new_interaction', `wheel-on-editor-element`);
                    cleanupListeners();
                };
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current.addEventListener('wheel', wheelAbortHandler);
                possibleListeners.current.push([
                    'wheel',
                    wheelAbortHandler
                ]);
                const scrollAbortHandler = (event)=>{
                    // Programmatic scrolls are not user interactions and must not abort the load metric.
                    if (scrollRestorePerfEnabled && !event.isTrusted) return;
                    const activeInteraction = (0, $a33Aa.getActiveInteraction)();
                    if (activeInteraction && [
                        'edit-page',
                        'live-edit'
                    ].includes(activeInteraction.ufoName)) (0, $a33Aa.abortAll)('new_interaction', `scroll-on-editor-element`);
                    cleanupListeners();
                };
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current.addEventListener('scroll', scrollAbortHandler);
                possibleListeners.current.push([
                    'scroll',
                    scrollAbortHandler
                ]);
            }
        }
        if (!viewRef.current && node) {
            (0, $fvMxa.nodeVisibilityManager)(node).initialiseNodeObserver();
            const view = createEditorView(node);
            if (mitigateScrollJump) {
                const scrollElement = document.querySelector('[data-editor-scroll-container]');
                scrollElement?.scrollTo({
                    top: originalScrollToRestore.current,
                    behavior: 'instant'
                });
            }
            onEditorCreated({
                view: view,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).startTransition(()=>{
                // Force React to re-render so consumers get a reference to the editor view
                setEditorView(view);
            });
        } else if (viewRef.current && !node) {
            // When the appearance is changed, React will call handleEditorViewRef with node === null
            // to destroy the old EditorView, before calling this method again with node === div to
            // create the new EditorView
            onEditorDestroyed({
                view: viewRef.current,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            const wasAnalyticsDisconnected = !eventDispatcher.has((0, $6pnwK.analyticsEventKey), handleAnalyticsEvent);
            // If we disabled event listening for some reason we should re-enable it temporarily while we destroy
            // the view for any analytics that occur there.
            if (wasAnalyticsDisconnected) {
                eventDispatcher.on((0, $6pnwK.analyticsEventKey), handleAnalyticsEvent);
                viewRef.current.destroy(); // Destroys the dom node & all node views
                eventDispatcher.off((0, $6pnwK.analyticsEventKey), handleAnalyticsEvent);
            } else viewRef.current.destroy(); // Destroys the dom node & all node views
            (0, $fvMxa.nodeVisibilityManager)(viewRef.current.dom).disconnect();
            viewRef.current = undefined;
        }
    }, [
        createEditorView,
        onEditorCreated,
        eventDispatcher,
        onEditorDestroyed,
        handleAnalyticsEvent,
        mitigateScrollJump,
        scrollRestorePerfEnabled
    ]);
    const isPageAppearance = (0, $loGKD.isFullPage)(nextAppearance) || nextAppearance === 'max';
    const createEditor = (0, $cozmU.useCallback)((assistiveLabel, assistiveDescribedBy)=>{
        return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `ProseMirror ${(0, $3cec430ca7025f27$export$11a24c7b1b4aab81)()}`,
            ref: handleEditorViewRef,
            "aria-label": assistiveLabel || (isPageAppearance ? props.intl.formatMessage((0, $16e1705ef52a6e23$export$3b488057bfc1868f).fullPageEditorAssistiveLabel) : props.intl.formatMessage((0, $16e1705ef52a6e23$export$3b488057bfc1868f).editorAssistiveLabel)),
            // setting aria-multiline to true when not mobile appearance.
            //  because somehow mobile tests are failing when it set.
            //  don't know why that is happening.
            // Created https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-1675
            //  to investigate further.
            "aria-multiline": true,
            role: "textbox",
            id: $218674f197ea575e$var$EDIT_AREA_ID,
            "aria-describedby": assistiveDescribedBy,
            "data-editor-id": editorId.current,
            "data-vc-ignore-if-no-layout-shift": true,
            "data-ssr-placeholder": "editor-view",
            "data-ssr-placeholder-replace": "editor-view",
            "data-gramm": (0, $4o0zT.isExperimentEnabled)('platform_editor_reduce_forced_layout') ? 'false' : undefined,
            translate: (0, $4o0zT.isExperimentEnabled)('platform_editor_reduce_forced_layout') ? 'no' : undefined,
            // eslint-disable-next-line react/no-danger -- needed for SSR and hydration so react keeps the HTML untouched
            dangerouslySetInnerHTML: {
                __html: ''
            }
        }, "ProseMirror");
    }, [
        handleEditorViewRef,
        isPageAppearance,
        props.intl
    ]);
    const previousPreset = (0, $2InGJ.default)(preset);
    (0, $cozmU.useLayoutEffect)(()=>{
        if ((0, $4iudd.isSSR)()) // No state reconfiguration is supported in SSR.
        return;
        if (previousPreset && previousPreset !== preset) reconfigureState(props);
    }, [
        reconfigureState,
        previousPreset,
        preset,
        props
    ]);
    const previousDisabledState = (0, $2InGJ.default)(disabled);
    (0, $cozmU.useLayoutEffect)(()=>{
        if ((0, $4iudd.isSSR)()) // We don't need to focus anything in SSR.
        return;
        if (viewRef.current && previousDisabledState !== disabled) {
            // Disables the contentEditable attribute of the editor if the editor is disabled
            viewRef.current.setProps({
                editable: (_state)=>!disabled
            });
            const focusesImmediately = (0, $iLrhi.isEmptyDocument)(viewRef.current.state.doc) || pluginInjectionAPI.current.api()?.interaction === undefined;
            if (!disabled && shouldFocus && focusesImmediately) focusTimeoutId.current = (0, $0b5857bdb6352d46$export$ebebb7f5b9271fd7)(viewRef.current);
        }
    }, [
        disabled,
        shouldFocus,
        previousDisabledState
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        pluginInjectionAPI.current.api()?.core?.actions?.updateAppearance(nextAppearance);
    }, [
        nextAppearance
    ]);
    (0, $613adc729f63e077$export$4998b7b36606f9c3)(nextAppearance, dispatchAnalyticsEvent);
    // This function uses as prop as `<EditorSSRRenderer>` so, that should be memoized,
    // to avoid extra rerenders.
    const buildDoc = (0, $cozmU.useCallback)((schema)=>{
        return parseDoc(schema, undefined, {
            // Don't pass all props here, use only what you need to keep hook dependencies more stable.
            // Check what `parseDoc` consumes and pass only needed data.
            props: {
                providerFactory: props.providerFactory,
                editorProps: {
                    sanitizePrivateContent: props.editorProps.sanitizePrivateContent
                }
            },
            doc: defaultValue
        });
    }, [
        defaultValue,
        parseDoc,
        props.editorProps.sanitizePrivateContent,
        props.providerFactory
    ]);
    // We need to check `allowBlockType` in props, because it is now exist in EditorNextProps type.
    const { allowBlockType: allowBlockType } = 'allowBlockType' in props.editorProps ? props.editorProps : {
        allowBlockType: undefined
    };
    // In separate memo, because some props like `props.intl` that need only for rendering
    // changes many times, but we don't want to process plugins and ADF document for each unnecessary changes.
    const ssrDeps = (0, $cozmU.useMemo)(()=>{
        if (!(0, $4iudd.isSSR)()) return null;
        const doCreatePluginList = ()=>(0, $ceZg8.default)(props.preset, // Don't pass props.editorProps directly, because editoProps in the dependency will lead to
            // multiple repaints, because props.editorPros is not stable object.
            {
                allowBlockType: allowBlockType
            }, pluginInjectionAPI.current);
        const plugins = (0, $970d799a06d520c1$export$69bfe89b2a668d26)(`${$218674f197ea575e$var$SSR_TRACE_SEGMENT_NAME}/createPluginsList`, doCreatePluginList, onSSRMeasure);
        const doCreateSchema = ()=>(0, $97fb23b0b573a2d0$export$5f4ce795563f4211)((0, $5c368fea92f7e1ac$export$7265233e78178a4)(plugins));
        const schema = (0, $970d799a06d520c1$export$69bfe89b2a668d26)(`${$218674f197ea575e$var$SSR_TRACE_SEGMENT_NAME}/createSchema`, doCreateSchema, onSSRMeasure);
        const doBuildDoc = ()=>buildDoc(schema);
        const doc = (0, $970d799a06d520c1$export$69bfe89b2a668d26)(`${$218674f197ea575e$var$SSR_TRACE_SEGMENT_NAME}/buildDoc`, doBuildDoc, onSSRMeasure);
        const isViewMode = pluginInjectionAPI.current.api()?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        const ariaReadonly = isViewMode && (0, $4o0zT.isExperimentEnabled)('platform_editor_viewmode_aria_readonly_a11y') ? 'true' : undefined;
        // When the platform_editor_ssr_toolbar_optimistic is on, we create SSR-safe PM plugins and EditorState
        // HERE in ssrDeps — before any children render — so that FullPageToolbarNext can read correct
        // plugin state via useSharedPluginStateWithSelector → currentState() → getEditorState().
        //
        // We also pass these pre-built pmPlugins and editorState to EditorSSRRenderer so it can
        // skip redundant creation (avoids double createPluginsList + EditorState.create).
        if ((0, $ieeJu.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true)) {
            const ssrPMPlugins = (0, $970d799a06d520c1$export$69bfe89b2a668d26)(`${$218674f197ea575e$var$SSR_TRACE_SEGMENT_NAME}/createSSRPMPlugins`, ()=>(0, $c99fa13805cd5152$export$5dd8b2dbd9647c38)({
                    plugins: plugins,
                    schema: schema,
                    portalProviderAPI: props.portalProviderAPI,
                    getIntl: ()=>props.intl
                }), onSSRMeasure);
            const ssrState = (0, $970d799a06d520c1$export$69bfe89b2a668d26)(`${$218674f197ea575e$var$SSR_TRACE_SEGMENT_NAME}/createSSREditorState`, ()=>(0, $08319ffb5b98e637$export$d5371f6840b6acde)({
                    doc: doc,
                    schema: schema,
                    pmPlugins: ssrPMPlugins
                }), onSSRMeasure);
            return {
                plugins: plugins,
                schema: schema,
                doc: doc,
                ariaReadonly: ariaReadonly,
                ssrPMPlugins: ssrPMPlugins,
                ssrEditorState: ssrState
            };
        }
        return {
            plugins: plugins,
            schema: schema,
            doc: doc,
            ariaReadonly: ariaReadonly,
            ssrPMPlugins: undefined,
            ssrEditorState: undefined
        };
    }, [
        allowBlockType,
        buildDoc,
        props.preset,
        onSSRMeasure,
        props.portalProviderAPI,
        props.intl
    ]);
    // SSR only, synchronously set preMountEditorStateRef so it's ready to be consumed by children including toolbar
    if (ssrDeps?.ssrEditorState) preMountEditorStateRef.current = ssrDeps.ssrEditorState;
    const { assistiveLabel: assistiveLabel, assistiveDescribedBy: assistiveDescribedBy } = props.editorProps;
    const handleSsrEditorStateChanged = (0, $cozmU.useCallback)((state)=>{
        preMountEditorStateRef.current = state;
        // Notify listeners about the initial SSR state
        pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: state,
            oldEditorState: undefined
        });
    }, [
        pluginInjectionAPI
    ]);
    const memoizedReactEditorViewContext = (0, $cozmU.useMemo)(()=>({
            editorRef: editorRef,
            // Use a getter so that consumers always read the live viewRef.current at access
            // time, not a stale snapshot captured when this memo was created.
            get editorView () {
                return viewRef.current;
            },
            popupsMountPoint: props.editorProps.popupsMountPoint
        }), // viewRef is intentionally omitted from the deps array — it's a stable ref object; the getter reads
    // .current lazily so there's no stale-closure risk.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        editorRef,
        props.editorProps.popupsMountPoint
    ]);
    // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017
    const reactEditorViewContext = (0, $4o0zT.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedReactEditorViewContext : {
        editorRef: editorRef,
        editorView: viewRef.current,
        popupsMountPoint: props.editorProps.popupsMountPoint
    };
    const ssrEditor = (0, $cozmU.useMemo)(()=>{
        if (!ssrDeps) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $07e46fd8091c3d79$export$8d417ec112d5c31c), {
            intl: props.intl,
            doc: ssrDeps.doc,
            schema: ssrDeps.schema,
            plugins: ssrDeps.plugins,
            portalProviderAPI: props.portalProviderAPI,
            // IMPORTANT: Keep next props in sync with div that renders a real ProseMirror editor.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `ProseMirror ${(0, $3cec430ca7025f27$export$11a24c7b1b4aab81)()}`,
            "aria-label": assistiveLabel || (isPageAppearance ? props.intl.formatMessage((0, $16e1705ef52a6e23$export$3b488057bfc1868f).fullPageEditorAssistiveLabel) : props.intl.formatMessage((0, $16e1705ef52a6e23$export$3b488057bfc1868f).editorAssistiveLabel)),
            id: $218674f197ea575e$var$EDIT_AREA_ID,
            "aria-describedby": assistiveDescribedBy,
            ...ssrDeps.ariaReadonly === 'true' ? {
                'aria-readonly': 'true'
            } : {},
            "data-editor-id": editorId.current,
            onSSRMeasure: onSSRMeasure,
            prebuiltPMPlugins: ssrDeps.ssrPMPlugins,
            prebuiltEditorState: ssrDeps.ssrEditorState,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onEditorStateChanged: (0, $4o0zT.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? handleSsrEditorStateChanged : (state)=>{
                preMountEditorStateRef.current = state;
                // Notify listeners about the initial SSR state
                pluginInjectionAPI.current.onEditorViewUpdated({
                    newEditorState: state,
                    oldEditorState: undefined
                });
            }
        }, "ProseMirror");
    }, [
        ssrDeps,
        props.intl,
        props.portalProviderAPI,
        assistiveLabel,
        isPageAppearance,
        assistiveDescribedBy,
        onSSRMeasure,
        handleSsrEditorStateChanged
    ]);
    const editor = (0, $cozmU.useMemo)(()=>{
        // SSR editor will be available only in SSR environment,
        // in a browser `ssrEditor` will be `null`, and we will render a normal one ProseMirror.
        if (ssrEditor) return ssrEditor;
        return createEditor(props.editorProps.assistiveLabel, props.editorProps.assistiveDescribedBy);
    }, // `createEditor` changes a little too frequently - we don't want to recreate the editor view in this case
    // We should follow-up
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.editorProps.assistiveLabel,
        props.editorProps.assistiveDescribedBy,
        ssrEditor
    ]);
    const renderTrackingEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_enable_rerender_tracking') && !featureFlags.lcmPreventRenderTracking;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jZ0wT.SSRRenderMeasure), {
        segmentName: $218674f197ea575e$var$SSR_TRACE_SEGMENT_NAME,
        startTimestampRef: firstRenderStartTimestampRef,
        onSSRMeasure: onSSRMeasure,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2iHw5.default).Provider, {
            value: reactEditorViewContext,
            children: [
                renderTrackingEnabled && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kTcv5.RenderTracking), {
                    componentProps: props,
                    action: (0, $krYZG.ACTION).RE_RENDERED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).REACT_EDITOR_VIEW,
                    handleAnalyticsEvent: handleAnalyticsEvent,
                    useShallow: true
                }),
                props.render ? props.render?.({
                    editor: editor,
                    view: viewRef.current,
                    config: config.current,
                    eventDispatcher: eventDispatcher,
                    transformer: contentTransformer.current,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    editorRef: editorRef,
                    editorAPI: pluginInjectionAPI.current.api()
                }) ?? editor : editor
            ]
        })
    });
}
var // Preserving exact type generated by TypeScript
// eslint-disable-next-line @typescript-eslint/no-restricted-types, @atlaskit/volt-strict-mode/no-multiple-exports
$218674f197ea575e$export$2e2bcd8739ae039 = (0, $kSwu1.injectIntl)($218674f197ea575e$export$e7d1b1cbca007e16);
module.exports["ReactEditorView"] = $218674f197ea575e$export$e7d1b1cbca007e16;

});

parcelRegister("fvMxa", function(module, exports) {
// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $72cee3798f06615e$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $72cee3798f06615e$var$editorObservers = new WeakMap();
const $72cee3798f06615e$var$callbackMap = new WeakMap();
const $72cee3798f06615e$export$565ab8668cdfbb7c = (editorElement)=>{
    // Warning! do not reference editorElement outside of internal functions.
    // editorElement is passed to allow support for multiple editors,
    const unObserveInternal = (nodeElement)=>{
        $72cee3798f06615e$var$editorObservers.get(editorElement)?.unobserve(nodeElement);
        $72cee3798f06615e$var$callbackMap.delete(nodeElement);
    };
    const observe = (observerConfig)=>{
        $72cee3798f06615e$var$callbackMap.set(observerConfig.element, observerConfig);
        $72cee3798f06615e$var$editorObservers.get(editorElement)?.observe(observerConfig.element);
        // return clean up
        return ()=>{
            // consumer needs to unobserve on destroy if their element
            // was observed but never scrolled into view
            unObserveInternal(observerConfig.element);
        };
    };
    const initialiseNodeObserver = ()=>{
        if ($72cee3798f06615e$var$editorObservers.has(editorElement)) return;
        const intersectionObserverOptions = {
            root: editorElement.closest($72cee3798f06615e$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
            rootMargin: '0px 0px 100px 0px',
            threshold: 0
        };
        const editorObserver = new IntersectionObserver((entries)=>entries.map((entry)=>({
                    entry: entry,
                    callback: $72cee3798f06615e$var$callbackMap.get(entry.target)
                }))// Invoke callbacks together to group browser rendering
            // Avoiding requestAnimationFrame to reduce visual flickering
            .forEach(({ entry: entry, callback: callback })=>{
                if (entry.isIntersecting) {
                    callback?.onFirstVisible();
                    if (entry.target instanceof HTMLElement) // immediately unobserve the element after it is visible
                    unObserveInternal(entry.target);
                }
            }), intersectionObserverOptions);
        $72cee3798f06615e$var$editorObservers.set(editorElement, editorObserver);
    };
    const disconnect = ()=>{
        $72cee3798f06615e$var$editorObservers.get(editorElement)?.disconnect();
        $72cee3798f06615e$var$editorObservers.delete(editorElement);
    };
    return {
        initialiseNodeObserver: initialiseNodeObserver,
        observe: observe,
        disconnect: disconnect
    };
};
module.exports["nodeVisibilityManager"] = $72cee3798f06615e$export$565ab8668cdfbb7c;

});

parcelRegister("ceZg8", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1df0ad5232fad37$export$2e2bcd8739ae039);

var $cfjQo = parcelRequire("cfjQo");


var $loGKD = parcelRequire("loGKD");

function $b4bc3c4828a6a93e$export$f94443780f769f8(props) {
    const { appearance: appearance } = props;
    if ((0, $loGKD.isFullPage)(appearance)) // Full Page appearance uses a scrollable div wrapper.
    return {
        getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
    };
    return undefined;
}


const $d1df0ad5232fad37$var$isCodeBlockAllowed = (options)=>{
    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
    return exclude.indexOf('codeBlock') === -1;
};
function $d1df0ad5232fad37$export$fdea1e40b8747a5b(props, createAnalyticsEvent) {
    const appearance = props.appearance;
    const cardOptions = props.linking?.smartLinks || props.smartLinks || props.UNSAFE_cards;
    return {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        typeAhead: {
            isMobile: false
        },
        featureFlags: (0, $cfjQo.createFeatureFlagsFromProps)(props.featureFlags),
        paste: {
            cardOptions: cardOptions,
            sanitizePrivateContent: props.sanitizePrivateContent,
            pasteWarningOptions: props.pasteWarningOptions
        },
        base: {
            allowInlineCursorTarget: true,
            allowScrollGutter: (0, $b4bc3c4828a6a93e$export$f94443780f769f8)(props)
        },
        blockType: {
            lastNodeMustBeParagraph: appearance === 'comment' || appearance === 'chromeless',
            allowBlockType: props.allowBlockType,
            isUndoRedoButtonsEnabled: props.allowUndoRedoButtons
        },
        placeholder: {
            placeholder: props.placeholder,
            placeholderBracketHint: props.placeholderBracketHint
        },
        textFormatting: {
            ...props.textFormatting || {},
            responsiveToolbarMenu: props.textFormatting?.responsiveToolbarMenu != null ? props.textFormatting.responsiveToolbarMenu : props.allowUndoRedoButtons
        },
        submitEditor: props.onSave,
        quickInsert: {
            enableElementBrowser: props.elementBrowser && props.elementBrowser.showModal,
            elementBrowserHelpUrl: props.elementBrowser && props.elementBrowser.helpUrl,
            disableDefaultItems: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.disableDefaultItems || false,
            headless: false,
            emptyStateHandler: props.elementBrowser && props.elementBrowser.emptyStateHandler,
            prioritySortingFn: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.prioritySortingFn || undefined,
            onInsert: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.onInsert || undefined
        },
        selection: {
            useLongPressSelection: false
        },
        hyperlinkOptions: {
            editorAppearance: props.appearance,
            linkPicker: props.linking?.linkPicker,
            onClickCallback: cardOptions?.onClickCallback,
            platform: 'web',
            autoLinkOnBlur: props.linking?.autoLinkOnBlur
        },
        codeBlock: {
            ...props.codeBlock,
            useLongPressSelection: false,
            allowCompositionInputOverride: false
        }
    };
}
function $d1df0ad5232fad37$export$2e2bcd8739ae039(// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset, props, pluginInjectionAPI) {
    const excludes = new Set();
    if (!$d1df0ad5232fad37$var$isCodeBlockAllowed({
        allowBlockType: props.allowBlockType
    })) excludes.add('codeBlock');
    return preset.build({
        pluginInjectionAPI: pluginInjectionAPI,
        excludePlugins: excludes
    });
}
module.exports["getDefaultPresetOptionsFromEditorProps"] = $d1df0ad5232fad37$export$fdea1e40b8747a5b;

});

parcelRegister("kAvGB", function(module, exports) {

var $kKNSN = parcelRequire("kKNSN");

function $b9029ed4e926b413$export$49afdc3354d5c84e(item) {
    return function(a, b) {
        return (0, $kKNSN.rankEditorPlugins)[item].indexOf(a.name) - (0, $kKNSN.rankEditorPlugins)[item].indexOf(b.name);
    };
}
function $b9029ed4e926b413$export$b4ae7ad1c009d0a1(item) {
    return function(a, b) {
        return (0, $kKNSN.rankEditorPlugins)[item].indexOf(a.type.name) - (0, $kKNSN.rankEditorPlugins)[item].indexOf(b.type.name);
    };
}
module.exports["sortByOrder"] = $b9029ed4e926b413$export$49afdc3354d5c84e;
module.exports["sortByOrderWithTypeName"] = $b9029ed4e926b413$export$b4ae7ad1c009d0a1;

});

parcelRegister("gkq2M", function(module, exports) {

var $l5rX3 = parcelRequire("l5rX3");

function $800932a4446bb70d$export$d9985be1ece4b7ee(tr) {
    return tr.steps.filter((step)=>step instanceof (0, $l5rX3.AnalyticsStep)).reduce((acc, step)=>[
            ...acc,
            ...step.analyticsEvents
        ], []);
}
module.exports["getAnalyticsEventsFromTransaction"] = $800932a4446bb70d$export$d9985be1ece4b7ee;

});

parcelRegister("iBeRE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $4c7c1a656626859c$var$useCheckIntlContext = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $kSwu1.IntlContext)) === null;
} : ()=>(0, $cozmU.useContext)((0, $kSwu1.IntlContext)) === null;
const $4c7c1a656626859c$export$742fe272b8921eea = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IntlProviderIfMissingWrapper(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    const missingIntlContext = $4c7c1a656626859c$var$useCheckIntlContext();
    if (missingIntlContext) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.IntlProvider), {
                locale: "en",
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    return children;
} : function IntlProviderIfMissingWrapper({ children: children }) {
    const missingIntlContext = $4c7c1a656626859c$var$useCheckIntlContext();
    if (missingIntlContext) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.IntlProvider), {
        locale: "en",
        children: children
    });
    return children;
};
module.exports["IntlProviderIfMissingWrapper"] = $4c7c1a656626859c$export$742fe272b8921eea;

});

parcelRegister("7SMXM", function(module, exports) {

var $8hfTK = parcelRequire("8hfTK");


var $4o0zT = parcelRequire("4o0zT");

const $7d56dc92b1dee111$var$options = {
    includeScore: true,
    keys: [
        {
            name: 'title',
            weight: 0.57
        },
        {
            name: 'keywords',
            weight: 0.08
        },
        {
            name: 'description',
            weight: 0.04
        },
        {
            name: 'shortcut',
            weight: 0.01
        }
    ],
    threshold: 0.3
};
const $7d56dc92b1dee111$var$normalizeScore = (score)=>Math.min(1, Math.max(0, score ?? 1));
const $7d56dc92b1dee111$var$getDescription = (matcher, formatMessage)=>matcher?.getSearchData?.({
        formatMessage: formatMessage
    }).description;
const $7d56dc92b1dee111$export$70e88a6d504b41d8 = (getSearchData)=>{
    let cachedFormatMessage;
    let fuse;
    const matcher = ({ formatMessage: formatMessage, query: query })=>{
        const normalizedQuery = query.trim();
        if (!normalizedQuery) return {
            score: 0
        };
        if (!fuse || cachedFormatMessage !== formatMessage) {
            fuse = new (0, $8hfTK.default)([
                getSearchData({
                    formatMessage: formatMessage
                })
            ], $7d56dc92b1dee111$var$options);
            cachedFormatMessage = formatMessage;
        }
        const result = fuse.search(normalizedQuery)[0];
        return result ? {
            score: $7d56dc92b1dee111$var$normalizeScore(result.score)
        } : null;
    };
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command')) {
        matcher.getSearchData = getSearchData;
        $7d56dc92b1dee111$export$70e88a6d504b41d8.getDescription = $7d56dc92b1dee111$var$getDescription;
    }
    return matcher;
};
module.exports["createQuickInsertMatcher"] = $7d56dc92b1dee111$export$70e88a6d504b41d8;

});

parcelRegister("79UEV", function(module, exports) {

var $TU3ul = parcelRequire("TU3ul");


var $dCkbP = parcelRequire("dCkbP");

const $3d479d8d792f80e4$var$categorySections = {
    admin: (0, $dCkbP.STRUCTURE_SECTION),
    ai: (0, $dCkbP.ROVO_SECTION),
    'block-templates': (0, $dCkbP.BLOCK_TEMPLATES_SECTION),
    communication: (0, $dCkbP.MEDIA_SECTION),
    'confluence-content': (0, $dCkbP.STRUCTURE_SECTION),
    create: (0, $dCkbP.CREATE_SECTION),
    'data-and-charts': (0, $dCkbP.DATA_AND_CHARTS_SECTION),
    development: (0, $dCkbP.DATA_AND_CHARTS_SECTION),
    embed: (0, $dCkbP.EMBED_SECTION),
    'external-content': (0, $dCkbP.EMBED_SECTION),
    formatting: (0, $dCkbP.STRUCTURE_SECTION),
    media: (0, $dCkbP.MEDIA_SECTION),
    navigation: (0, $dCkbP.STRUCTURE_SECTION),
    other: (0, $dCkbP.OTHER_SECTION),
    reporting: (0, $dCkbP.DATA_AND_CHARTS_SECTION),
    skills: (0, $dCkbP.ROVO_SECTION),
    structure: (0, $dCkbP.STRUCTURE_SECTION),
    'text-formatting': (0, $dCkbP.TEXT_FORMATTING_SECTION),
    visuals: (0, $dCkbP.MEDIA_SECTION)
};
const $3d479d8d792f80e4$export$4d73fce96a3946b3 = ({ category: category, legacyCategories: legacyCategories, rank: rank })=>{
    const sections = new Map();
    for (const itemCategory of (0, $TU3ul.getActiveQuickInsertCategories)(category, legacyCategories)){
        const section = $3d479d8d792f80e4$var$categorySections[itemCategory.trim().toLowerCase()];
        if (section) sections.set(section.key, section);
    }
    if (sections.size === 0) sections.set((0, $dCkbP.OTHER_SECTION).key, (0, $dCkbP.OTHER_SECTION));
    return Array.from(sections.values(), (section)=>({
            ...section,
            rank: rank
        }));
};
module.exports["getQuickInsertMenuItemParents"] = $3d479d8d792f80e4$export$4d73fce96a3946b3;

});

parcelRegister("TU3ul", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");

const $8bd79760f8f9a436$export$aacf51666602968b = (category, legacyCategories)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command') && category?.trim() ? [
        category
    ] : legacyCategories ?? [];
module.exports["getActiveQuickInsertCategories"] = $8bd79760f8f9a436$export$aacf51666602968b;

});

parcelRegister("dCkbP", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $84b56a8f52c25be9$export$4f072ecaef317163 = {
    key: 'quick-insert-menu',
    type: 'menu'
};
const $84b56a8f52c25be9$export$12f7d9cc46f85973 = {
    key: 'quick-insert-recommended-section',
    type: 'menu-section'
};
const $84b56a8f52c25be9$export$41f49f07caa65d63 = {
    key: 'quick-insert-structure-section',
    type: 'menu-section'
};
const $84b56a8f52c25be9$export$6521aedf84b8b3bf = {
    key: 'quick-insert-media-section',
    type: 'menu-section'
};
const $84b56a8f52c25be9$export$1f997d459e75316e = {
    key: 'quick-insert-create-section',
    type: 'menu-section'
};
const $84b56a8f52c25be9$export$988ed94425cfd0b = {
    key: 'quick-insert-embed-section',
    type: 'menu-section'
};
const $84b56a8f52c25be9$export$b9615e67024cae79 = {
    key: 'quick-insert-text-formatting-section',
    type: 'menu-section'
};
const $84b56a8f52c25be9$export$4d3917764bce77f3 = {
    key: 'quick-insert-rovo-section',
    type: 'menu-section'
};
const $84b56a8f52c25be9$export$a450ef18bc9a77fc = {
    key: 'quick-insert-data-and-charts-section',
    type: 'menu-section'
};
const $84b56a8f52c25be9$export$9b7c7169ab55ead9 = {
    key: 'quick-insert-block-templates-section',
    type: 'menu-section'
};
const $84b56a8f52c25be9$export$90dd0db03c1b30a2 = {
    key: 'quick-insert-other-section',
    type: 'menu-section'
};
const $84b56a8f52c25be9$export$fb73f92f07d07ccc = {
    key: 'quick-insert-view-all-elements-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$79188ae36be9c645 = {
    key: 'quick-insert-action-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$328b64d203821c99 = {
    key: 'quick-insert-table-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$3e6c1978b43719ef = {
    key: 'quick-insert-status-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$2c9678b90187641a = {
    key: 'quick-insert-date-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$56991b572eda72a5 = {
    key: 'quick-insert-synced-block-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$aadca0eda4e34e44 = {
    key: 'quick-insert-expand-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$ace0c9d2823bcdf3 = {
    key: 'quick-insert-decision-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$43670f72e3d0d426 = {
    key: 'quick-insert-info-panel-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$5c5a802e2beca5e6 = {
    key: 'quick-insert-note-panel-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$dc17447a7754878c = {
    key: 'quick-insert-success-panel-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$5016ca24764bca67 = {
    key: 'quick-insert-warning-panel-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$2ccc07729da0e1f6 = {
    key: 'quick-insert-error-panel-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$1e42ac55e66427a3 = {
    key: 'quick-insert-custom-panel-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$b83dd909cbd80b37 = {
    key: 'quick-insert-two-columns-layout-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$879afacac85e1350 = {
    key: 'quick-insert-three-columns-layout-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$11cb660affb9cc3e = {
    key: 'quick-insert-four-columns-layout-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$d3001594711c32af = {
    key: 'quick-insert-five-columns-layout-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$edc8911e49093d88 = {
    key: 'quick-insert-media-insert-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$4d3261dcd0a641ce = {
    key: 'quick-insert-hyperlink-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$61aba1c1fbb4d4d5 = {
    key: 'quick-insert-emoji-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$4ac3fd1884a40118 = {
    key: 'quick-insert-loom-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$7f8dbb610dfebda2 = {
    key: 'com.atlassian.linking-platform.create:linking-platform-create-jira-issue',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$9df29af67675a123 = {
    key: 'com.atlassian.linking-platform.create:linking-platform-create-confluence-page',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$7ed85d77b9460692 = {
    key: 'whiteboard-extension:create-whiteboard',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$ef8c8f918b423983 = {
    key: 'whiteboard-extension:create-diagram',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$95f461aeae2e4a35 = {
    key: 'whiteboard-extension:create-flowchart',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$8862466ef67bab6b = {
    key: 'whiteboard-extension:create-brainstorming',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$4df8c4dbbbfb30ad = {
    key: 'whiteboard-extension:create-retrospective',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$c082d5d300851bfd = {
    key: 'whiteboard-extension:create-roadmap',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$4a7a11c8e00b21e9 = {
    key: 'database-extension:create-database',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$6efdc85fa9d62055 = {
    key: 'native-tabs:native-tabs',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$8b2d76d0bf6ffa67 = {
    key: 'skill:add-suggestions-to-content',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$e4db028613c854f5 = {
    key: 'quick-insert-mention-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$cda433de81e33e4f = {
    key: 'quick-insert-ai-image-generation-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$2469e8506da598d3 = {
    key: 'quick-insert-heading-1-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$a065aede28a4fa60 = {
    key: 'quick-insert-heading-2-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$85070b7c6d42e3bb = {
    key: 'quick-insert-heading-3-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$e78c2531f67b545f = {
    key: 'quick-insert-heading-4-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$a92294de346392be = {
    key: 'quick-insert-heading-5-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$9c3cdc8e6d51ce82 = {
    key: 'quick-insert-heading-6-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$7414b1347762a017 = {
    key: 'quick-insert-blockquote-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$1defd18ee2c88dcf = {
    key: 'quick-insert-code-block-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$bc00157d6d81cff9 = {
    key: 'quick-insert-rule-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$982479fd333b2f72 = {
    key: 'quick-insert-placeholder-text-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$b704a063314308a1 = {
    key: 'quick-insert-unordered-list-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$c95c058d1846bc54 = {
    key: 'quick-insert-ordered-list-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$93a4bc45160383ab = {
    key: 'quick-insert-ask-rovo-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$106f3f08183d9dab = {
    key: 'quick-insert-jira-work-items-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$2a7c2762dfc65a41 = {
    key: 'quick-insert-assets-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$975e8c95a552486e = {
    key: 'quick-insert-confluence-list-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$238627b0efbd611c = {
    key: 'quick-insert-help-dialog-menu-item',
    type: 'menu-item'
};
const $84b56a8f52c25be9$export$e92f59b111ab0aef = (id)=>({
        key: `quick-insert-block-template-${id}`,
        type: 'menu-item'
    });
module.exports["MENU"] = $84b56a8f52c25be9$export$4f072ecaef317163;
module.exports["RECOMMENDED_SECTION"] = $84b56a8f52c25be9$export$12f7d9cc46f85973;
module.exports["STRUCTURE_SECTION"] = $84b56a8f52c25be9$export$41f49f07caa65d63;
module.exports["MEDIA_SECTION"] = $84b56a8f52c25be9$export$6521aedf84b8b3bf;
module.exports["CREATE_SECTION"] = $84b56a8f52c25be9$export$1f997d459e75316e;
module.exports["EMBED_SECTION"] = $84b56a8f52c25be9$export$988ed94425cfd0b;
module.exports["TEXT_FORMATTING_SECTION"] = $84b56a8f52c25be9$export$b9615e67024cae79;
module.exports["ROVO_SECTION"] = $84b56a8f52c25be9$export$4d3917764bce77f3;
module.exports["DATA_AND_CHARTS_SECTION"] = $84b56a8f52c25be9$export$a450ef18bc9a77fc;
module.exports["BLOCK_TEMPLATES_SECTION"] = $84b56a8f52c25be9$export$9b7c7169ab55ead9;
module.exports["OTHER_SECTION"] = $84b56a8f52c25be9$export$90dd0db03c1b30a2;
module.exports["VIEW_ALL_ELEMENTS_MENU_ITEM"] = $84b56a8f52c25be9$export$fb73f92f07d07ccc;
module.exports["ACTION_MENU_ITEM"] = $84b56a8f52c25be9$export$79188ae36be9c645;
module.exports["TABLE_MENU_ITEM"] = $84b56a8f52c25be9$export$328b64d203821c99;
module.exports["STATUS_MENU_ITEM"] = $84b56a8f52c25be9$export$3e6c1978b43719ef;
module.exports["DATE_MENU_ITEM"] = $84b56a8f52c25be9$export$2c9678b90187641a;
module.exports["SYNCED_BLOCK_MENU_ITEM"] = $84b56a8f52c25be9$export$56991b572eda72a5;
module.exports["EXPAND_MENU_ITEM"] = $84b56a8f52c25be9$export$aadca0eda4e34e44;
module.exports["DECISION_MENU_ITEM"] = $84b56a8f52c25be9$export$ace0c9d2823bcdf3;
module.exports["INFO_PANEL_MENU_ITEM"] = $84b56a8f52c25be9$export$43670f72e3d0d426;
module.exports["NOTE_PANEL_MENU_ITEM"] = $84b56a8f52c25be9$export$5c5a802e2beca5e6;
module.exports["SUCCESS_PANEL_MENU_ITEM"] = $84b56a8f52c25be9$export$dc17447a7754878c;
module.exports["WARNING_PANEL_MENU_ITEM"] = $84b56a8f52c25be9$export$5016ca24764bca67;
module.exports["ERROR_PANEL_MENU_ITEM"] = $84b56a8f52c25be9$export$2ccc07729da0e1f6;
module.exports["CUSTOM_PANEL_MENU_ITEM"] = $84b56a8f52c25be9$export$1e42ac55e66427a3;
module.exports["TWO_COLUMNS_LAYOUT_MENU_ITEM"] = $84b56a8f52c25be9$export$b83dd909cbd80b37;
module.exports["THREE_COLUMNS_LAYOUT_MENU_ITEM"] = $84b56a8f52c25be9$export$879afacac85e1350;
module.exports["FOUR_COLUMNS_LAYOUT_MENU_ITEM"] = $84b56a8f52c25be9$export$11cb660affb9cc3e;
module.exports["FIVE_COLUMNS_LAYOUT_MENU_ITEM"] = $84b56a8f52c25be9$export$d3001594711c32af;
module.exports["MEDIA_INSERT_MENU_ITEM"] = $84b56a8f52c25be9$export$edc8911e49093d88;
module.exports["HYPERLINK_MENU_ITEM"] = $84b56a8f52c25be9$export$4d3261dcd0a641ce;
module.exports["EMOJI_MENU_ITEM"] = $84b56a8f52c25be9$export$61aba1c1fbb4d4d5;
module.exports["LOOM_MENU_ITEM"] = $84b56a8f52c25be9$export$4ac3fd1884a40118;
module.exports["JIRA_ISSUE_MENU_ITEM"] = $84b56a8f52c25be9$export$7f8dbb610dfebda2;
module.exports["CONFLUENCE_PAGE_MENU_ITEM"] = $84b56a8f52c25be9$export$9df29af67675a123;
module.exports["WHITEBOARD_MENU_ITEM"] = $84b56a8f52c25be9$export$7ed85d77b9460692;
module.exports["DIAGRAM_MENU_ITEM"] = $84b56a8f52c25be9$export$ef8c8f918b423983;
module.exports["FLOWCHART_MENU_ITEM"] = $84b56a8f52c25be9$export$95f461aeae2e4a35;
module.exports["BRAINSTORMING_MENU_ITEM"] = $84b56a8f52c25be9$export$8862466ef67bab6b;
module.exports["RETROSPECTIVE_MENU_ITEM"] = $84b56a8f52c25be9$export$4df8c4dbbbfb30ad;
module.exports["ROADMAP_MENU_ITEM"] = $84b56a8f52c25be9$export$c082d5d300851bfd;
module.exports["DATABASE_MENU_ITEM"] = $84b56a8f52c25be9$export$4a7a11c8e00b21e9;
module.exports["TABS_MENU_ITEM"] = $84b56a8f52c25be9$export$6efdc85fa9d62055;
module.exports["ADD_SUGGESTIONS_TO_CONTENT_SKILL_MENU_ITEM"] = $84b56a8f52c25be9$export$8b2d76d0bf6ffa67;
module.exports["MENTION_MENU_ITEM"] = $84b56a8f52c25be9$export$e4db028613c854f5;
module.exports["AI_IMAGE_GENERATION_MENU_ITEM"] = $84b56a8f52c25be9$export$cda433de81e33e4f;
module.exports["HEADING_1_MENU_ITEM"] = $84b56a8f52c25be9$export$2469e8506da598d3;
module.exports["HEADING_2_MENU_ITEM"] = $84b56a8f52c25be9$export$a065aede28a4fa60;
module.exports["HEADING_3_MENU_ITEM"] = $84b56a8f52c25be9$export$85070b7c6d42e3bb;
module.exports["HEADING_4_MENU_ITEM"] = $84b56a8f52c25be9$export$e78c2531f67b545f;
module.exports["HEADING_5_MENU_ITEM"] = $84b56a8f52c25be9$export$a92294de346392be;
module.exports["HEADING_6_MENU_ITEM"] = $84b56a8f52c25be9$export$9c3cdc8e6d51ce82;
module.exports["BLOCKQUOTE_MENU_ITEM"] = $84b56a8f52c25be9$export$7414b1347762a017;
module.exports["CODE_BLOCK_MENU_ITEM"] = $84b56a8f52c25be9$export$1defd18ee2c88dcf;
module.exports["RULE_MENU_ITEM"] = $84b56a8f52c25be9$export$bc00157d6d81cff9;
module.exports["PLACEHOLDER_TEXT_MENU_ITEM"] = $84b56a8f52c25be9$export$982479fd333b2f72;
module.exports["UNORDERED_LIST_MENU_ITEM"] = $84b56a8f52c25be9$export$b704a063314308a1;
module.exports["ORDERED_LIST_MENU_ITEM"] = $84b56a8f52c25be9$export$c95c058d1846bc54;
module.exports["ASK_ROVO_MENU_ITEM"] = $84b56a8f52c25be9$export$93a4bc45160383ab;
module.exports["JIRA_WORK_ITEMS_MENU_ITEM"] = $84b56a8f52c25be9$export$106f3f08183d9dab;
module.exports["ASSETS_MENU_ITEM"] = $84b56a8f52c25be9$export$2a7c2762dfc65a41;
module.exports["CONFLUENCE_LIST_MENU_ITEM"] = $84b56a8f52c25be9$export$975e8c95a552486e;
module.exports["HELP_DIALOG_MENU_ITEM"] = $84b56a8f52c25be9$export$238627b0efbd611c;
module.exports["getBlockTemplateMenuItem"] = $84b56a8f52c25be9$export$e92f59b111ab0aef;

});

parcelRegister("dXqu3", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $dCkbP = parcelRequire("dCkbP");

const $ae1be0aad1329cbf$export$6f0b97a44c333c02 = {
    [(0, $dCkbP.RECOMMENDED_SECTION).key]: 0,
    [(0, $dCkbP.STRUCTURE_SECTION).key]: 1,
    [(0, $dCkbP.MEDIA_SECTION).key]: 2,
    [(0, $dCkbP.CREATE_SECTION).key]: 3,
    [(0, $dCkbP.EMBED_SECTION).key]: 4,
    [(0, $dCkbP.TEXT_FORMATTING_SECTION).key]: 5,
    [(0, $dCkbP.ROVO_SECTION).key]: 6,
    [(0, $dCkbP.DATA_AND_CHARTS_SECTION).key]: 7,
    [(0, $dCkbP.BLOCK_TEMPLATES_SECTION).key]: 8,
    [(0, $dCkbP.OTHER_SECTION).key]: 9
};
const $ae1be0aad1329cbf$export$4b636ca6c5524d2 = {
    [(0, $dCkbP.ACTION_MENU_ITEM).key]: 100,
    [(0, $dCkbP.TABLE_MENU_ITEM).key]: 200,
    [(0, $dCkbP.STATUS_MENU_ITEM).key]: 300,
    [(0, $dCkbP.DATE_MENU_ITEM).key]: 400,
    [(0, $dCkbP.MENTION_MENU_ITEM).key]: 500,
    [(0, $dCkbP.EXPAND_MENU_ITEM).key]: 700,
    [(0, $dCkbP.CODE_BLOCK_MENU_ITEM).key]: 800,
    [(0, $dCkbP.INFO_PANEL_MENU_ITEM).key]: 900,
    [(0, $dCkbP.NOTE_PANEL_MENU_ITEM).key]: 1000,
    [(0, $dCkbP.SUCCESS_PANEL_MENU_ITEM).key]: 1100,
    [(0, $dCkbP.WARNING_PANEL_MENU_ITEM).key]: 1200,
    [(0, $dCkbP.ERROR_PANEL_MENU_ITEM).key]: 1300,
    [(0, $dCkbP.CUSTOM_PANEL_MENU_ITEM).key]: 1400,
    [(0, $dCkbP.TWO_COLUMNS_LAYOUT_MENU_ITEM).key]: 1500,
    [(0, $dCkbP.THREE_COLUMNS_LAYOUT_MENU_ITEM).key]: 1600,
    [(0, $dCkbP.FOUR_COLUMNS_LAYOUT_MENU_ITEM).key]: 1700,
    [(0, $dCkbP.FIVE_COLUMNS_LAYOUT_MENU_ITEM).key]: 1800,
    [(0, $dCkbP.SYNCED_BLOCK_MENU_ITEM).key]: 2300,
    [(0, $dCkbP.RULE_MENU_ITEM).key]: 2400,
    [(0, $dCkbP.DECISION_MENU_ITEM).key]: 2800
};
const $ae1be0aad1329cbf$export$d55d14a4c5066acf = {
    [(0, $dCkbP.MEDIA_INSERT_MENU_ITEM).key]: 100,
    [(0, $dCkbP.HYPERLINK_MENU_ITEM).key]: 200,
    [(0, $dCkbP.EMOJI_MENU_ITEM).key]: 300,
    [(0, $dCkbP.AI_IMAGE_GENERATION_MENU_ITEM).key]: 1600
};
const $ae1be0aad1329cbf$export$6fbfc97c4b6bda0c = {
    [(0, $dCkbP.JIRA_ISSUE_MENU_ITEM).key]: 100,
    [(0, $dCkbP.LOOM_MENU_ITEM).key]: 200,
    [(0, $dCkbP.CONFLUENCE_PAGE_MENU_ITEM).key]: 300,
    [(0, $dCkbP.DATABASE_MENU_ITEM).key]: 400,
    [(0, $dCkbP.WHITEBOARD_MENU_ITEM).key]: 500,
    [(0, $dCkbP.DIAGRAM_MENU_ITEM).key]: 600,
    [(0, $dCkbP.FLOWCHART_MENU_ITEM).key]: 700,
    [(0, $dCkbP.BRAINSTORMING_MENU_ITEM).key]: 800,
    [(0, $dCkbP.RETROSPECTIVE_MENU_ITEM).key]: 900,
    [(0, $dCkbP.ROADMAP_MENU_ITEM).key]: 1000
};
const $ae1be0aad1329cbf$export$80d05dd98646a9d2 = {
    [(0, $dCkbP.UNORDERED_LIST_MENU_ITEM).key]: 100,
    [(0, $dCkbP.ORDERED_LIST_MENU_ITEM).key]: 200,
    [(0, $dCkbP.HEADING_1_MENU_ITEM).key]: 300,
    [(0, $dCkbP.HEADING_2_MENU_ITEM).key]: 400,
    [(0, $dCkbP.HEADING_3_MENU_ITEM).key]: 500,
    [(0, $dCkbP.HEADING_4_MENU_ITEM).key]: 600,
    [(0, $dCkbP.HEADING_5_MENU_ITEM).key]: 700,
    [(0, $dCkbP.HEADING_6_MENU_ITEM).key]: 800,
    [(0, $dCkbP.BLOCKQUOTE_MENU_ITEM).key]: 900,
    [(0, $dCkbP.PLACEHOLDER_TEXT_MENU_ITEM).key]: 1000
};
const $ae1be0aad1329cbf$export$c9a42cd46f7a81c6 = {
    [(0, $dCkbP.ASK_ROVO_MENU_ITEM).key]: 100
};
const $ae1be0aad1329cbf$export$c93d592e1d5bcf63 = {
    [(0, $dCkbP.JIRA_WORK_ITEMS_MENU_ITEM).key]: 300,
    [(0, $dCkbP.CONFLUENCE_LIST_MENU_ITEM).key]: 400,
    [(0, $dCkbP.ASSETS_MENU_ITEM).key]: 500
};
const $ae1be0aad1329cbf$export$f3c53099acc8e95f = {
    [(0, $dCkbP.HELP_DIALOG_MENU_ITEM).key]: 100
};
const $ae1be0aad1329cbf$export$7a7912903a77addf = 1500;
const $ae1be0aad1329cbf$export$8fe8500e35b378be = Number.MAX_SAFE_INTEGER;
module.exports["QUICK_INSERT_MENU_RANK"] = $ae1be0aad1329cbf$export$6f0b97a44c333c02;
module.exports["STRUCTURE_SECTION_RANK"] = $ae1be0aad1329cbf$export$4b636ca6c5524d2;
module.exports["MEDIA_SECTION_RANK"] = $ae1be0aad1329cbf$export$d55d14a4c5066acf;
module.exports["CREATE_SECTION_RANK"] = $ae1be0aad1329cbf$export$6fbfc97c4b6bda0c;
module.exports["TEXT_FORMATTING_SECTION_RANK"] = $ae1be0aad1329cbf$export$80d05dd98646a9d2;
module.exports["ROVO_SECTION_RANK"] = $ae1be0aad1329cbf$export$c9a42cd46f7a81c6;
module.exports["DATA_AND_CHARTS_SECTION_RANK"] = $ae1be0aad1329cbf$export$c93d592e1d5bcf63;
module.exports["EXTENSION_ITEM_RANK"] = $ae1be0aad1329cbf$export$7a7912903a77addf;
module.exports["CATEGORY_VIEW_MORE_RANK"] = $ae1be0aad1329cbf$export$8fe8500e35b378be;

});

parcelRegister("I2MTF", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");











var $cozmU = parcelRequire("cozmU");


var $kh0hi = parcelRequire("kh0hi");

var $buxP3 = parcelRequire("buxP3");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");











var $hekY6 = parcelRequire("hekY6");





var $9kbTQ = parcelRequire("9kbTQ");


var $cbY7C = parcelRequire("cbY7C");


var $kSwu1 = parcelRequire("kSwu1");


var $dMmly = parcelRequire("dMmly");











var $IQ4Dz = parcelRequire("IQ4Dz");


var $lPJNC = parcelRequire("lPJNC");

const $d1bc46a6b783a090$var$PREVIEW_MODIFIERS = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                4
            ]
        }
    },
    {
        name: 'flip',
        options: {
            fallbackPlacements: [
                'left-start'
            ],
            // Choose the side by horizontal space; vertical overflow is shifted into view.
            altAxis: false,
            padding: 8,
            rootBoundary: 'viewport'
        }
    },
    {
        name: 'preventOverflow',
        options: {
            mainAxis: true,
            altAxis: true,
            tether: false,
            padding: 8,
            rootBoundary: 'viewport'
        }
    }
];
const $d1bc46a6b783a090$var$layoutStyles = {
    titleRow: "_4ouGXIdnbC",
    titleIcon: "_0hPCNLDIqT _3iDTPbQ4SZ _3YEZNOdnbC _37wbyuDIqT",
    attributionText: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4ouGXIdnbC _3zvHkHdC7N"
};
const $d1bc46a6b783a090$var$styles = {
    positioner: "_0NUa3rAabG _1EqgXl9DjQ _42Yu6BFIQA",
    panel: "_0bjKvDKTcp _4bt5LAnQyn _2WAcuGnQyn _4c065U8HPE _2Y7lL48HPE _24h04i2Njc _0KLXruoI2d _2OUyjtGk8v _0NUa3rOLYo _1EqgXlN91d _39xV02ArIa",
    content: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vbt8w",
    title: "_2sNsIgEqul _2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _1UtDYzZpcK _4ouGXIdnbC _3zvHkHdC7N _3iDTPbgJ9S _1U1ZhbbI28 _4Gn54RiZR3",
    unclampedTitle: "_2sNsIgmnOE _2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _1UtDYzy7kJ _1kk5Tkmb2E _4ouGXIdnbC _3zvHkHdC7N",
    description: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _3iDTPbgJ9S _3zvHkHdC7N _1U1ZhbbI28 _4Gn54R8OLE",
    unclampedDescription: "_2sNsIgmnOE _1UtDYzy7kJ _3zvHkHdC7N",
    imageArea: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _0KLXrunmFW _0jFU0Vv6H3 _0rIjyk2ADO _1EqgXlN91d _39xV02GVdc",
    image: "_3iDTPbvLZJ _0jFU0VN91d _00EA0egIor _39xV02N91d",
    imageHidden: "_0fKRyPnQyn",
    attribution: "_2mHwu81Y8M _0hPCNLDIqT _1UtDYzZpcK _3iDTPbQ4SZ _3zvHkHdC7N",
    compactAttribution: "_2sNsIg7NXe",
    attributionIcon: "_2O5VijdnbC _3YEZNOdnbC _1bHrqE50T1 _0hPCNLDIqT _3iDTPbQ4SZ _0jFU0Vey7F _37wbyuDIqT _39xV02ey7F"
};
const $d1bc46a6b783a090$export$ff7b0dfb01a1c1fe = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { description: description, icon: icon, id: id, preview: preview, popupsMountPoint: popupsMountPoint, referenceElement: referenceElement, shouldClampText: t1, title: title } = t0;
    const shouldClampText = t1 === undefined ? true : t1;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const imageUrl = preview.image ? colorMode === "dark" && preview.image.dark ? preview.image.dark : preview.image.light : undefined;
    const hasAccessibleContent = Boolean(description || preview.attribution);
    const portalTarget = popupsMountPoint ?? referenceElement.ownerDocument.body;
    const t2 = popupsMountPoint ? "absolute" : "fixed";
    let t3;
    if ($[0] !== description || $[1] !== hasAccessibleContent || $[2] !== icon || $[3] !== id || $[4] !== imageUrl || $[5] !== popupsMountPoint || $[6] !== preview || $[7] !== referenceElement || $[8] !== shouldClampText || $[9] !== title) {
        t3 = (t4)=>{
            const { ref: ref, style: style, update: update } = t4;
            return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                ref: ref,
                style: style,
                className: (0, $hekY6.default)([
                    $d1bc46a6b783a090$var$styles.positioner
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($d1bc46a6b783a090$var$QuickInsertPreviewPanel, {
                    description: description,
                    icon: icon,
                    id: hasAccessibleContent ? id : undefined,
                    imageUrl: imageUrl,
                    preview: preview,
                    popupsMountPoint: popupsMountPoint,
                    referenceElement: referenceElement,
                    shouldClampText: shouldClampText,
                    title: title,
                    update: update
                })
            });
        };
        $[0] = description;
        $[1] = hasAccessibleContent;
        $[2] = icon;
        $[3] = id;
        $[4] = imageUrl;
        $[5] = popupsMountPoint;
        $[6] = preview;
        $[7] = referenceElement;
        $[8] = shouldClampText;
        $[9] = title;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== referenceElement || $[12] !== t2 || $[13] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dMmly.Popper), {
            placement: "right-start",
            referenceElement: referenceElement,
            strategy: t2,
            modifiers: $d1bc46a6b783a090$var$PREVIEW_MODIFIERS,
            children: t3
        });
        $[11] = referenceElement;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== portalTarget || $[16] !== t4) {
        t5 = /*#__PURE__*/ (0, $9kbTQ.createPortal)(t4, portalTarget);
        $[15] = portalTarget;
        $[16] = t4;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : ({ description: description, icon: icon, id: id, preview: preview, popupsMountPoint: popupsMountPoint, referenceElement: referenceElement, shouldClampText: shouldClampText = true, title: title })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const imageUrl = preview.image ? colorMode === 'dark' && preview.image.dark ? preview.image.dark : preview.image.light : undefined;
    const hasAccessibleContent = Boolean(description || preview.attribution);
    const portalTarget = popupsMountPoint ?? referenceElement.ownerDocument.body;
    return /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $dMmly.Popper), {
        placement: "right-start",
        referenceElement: referenceElement,
        strategy: popupsMountPoint ? 'absolute' : 'fixed',
        modifiers: $d1bc46a6b783a090$var$PREVIEW_MODIFIERS,
        children: ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                ref: ref,
                style: style,
                className: (0, $hekY6.default)([
                    $d1bc46a6b783a090$var$styles.positioner
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($d1bc46a6b783a090$var$QuickInsertPreviewPanel, {
                    description: description,
                    icon: icon,
                    id: hasAccessibleContent ? id : undefined,
                    imageUrl: imageUrl,
                    preview: preview,
                    popupsMountPoint: popupsMountPoint,
                    referenceElement: referenceElement,
                    shouldClampText: shouldClampText,
                    title: title,
                    update: update
                })
            })
    }), portalTarget);
};
const $d1bc46a6b783a090$var$QuickInsertPreviewPanel = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { description: description, icon: icon, id: id, imageUrl: imageUrl, preview: preview, popupsMountPoint: popupsMountPoint, referenceElement: referenceElement, shouldClampText: shouldClampText, title: title, update: update } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [panelElement, setPanelElement] = (0, $cozmU.useState)(null);
    const AttributionIcon = preview.attribution?.icon;
    const attributionName = preview.attribution?.name;
    const formattedAttributionName = typeof attributionName === "string" ? attributionName : attributionName ? formatMessage(attributionName) : "";
    let t1;
    let t2;
    if ($[0] !== panelElement || $[1] !== popupsMountPoint || $[2] !== referenceElement || $[3] !== update) {
        t1 = ()=>{
            update();
            const { ownerDocument: ownerDocument } = referenceElement;
            const onScroll = ()=>void update();
            const unbindScrollListener = (0, $cbY7C.bind)(ownerDocument, {
                type: "scroll",
                listener: onScroll,
                options: true
            });
            const ResizeObserverConstructor = ownerDocument.defaultView?.ResizeObserver;
            if (!panelElement || !ResizeObserverConstructor) return unbindScrollListener;
            const observer = new ResizeObserverConstructor(()=>void update());
            observer.observe(panelElement);
            observer.observe(referenceElement);
            if (popupsMountPoint) observer.observe(popupsMountPoint);
            return ()=>{
                unbindScrollListener();
                observer.disconnect();
            };
        };
        t2 = [
            panelElement,
            popupsMountPoint,
            referenceElement,
            update
        ];
        $[0] = panelElement;
        $[1] = popupsMountPoint;
        $[2] = referenceElement;
        $[3] = update;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    const t3 = id ? "tooltip" : undefined;
    const t4 = "quick-insert-preview-panel";
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            $d1bc46a6b783a090$var$styles.panel
        ]);
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== imageUrl) {
        t6 = imageUrl && /*#__PURE__*/ (0, $8aG6j.jsx)($d1bc46a6b783a090$var$PreviewImage, {
            imageUrl: imageUrl
        }, imageUrl);
        $[7] = imageUrl;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            $d1bc46a6b783a090$var$styles.content
        ]);
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== icon) {
        t8 = icon && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            "aria-hidden": "true",
            xcss: $d1bc46a6b783a090$var$layoutStyles.titleIcon,
            children: icon
        });
        $[10] = icon;
        $[11] = t8;
    } else t8 = $[11];
    const t9 = shouldClampText && $d1bc46a6b783a090$var$styles.title;
    const t10 = !shouldClampText && $d1bc46a6b783a090$var$styles.unclampedTitle;
    let t11;
    if ($[12] !== t10 || $[13] !== t9) {
        t11 = (0, $hekY6.default)([
            t9,
            t10
        ]);
        $[12] = t10;
        $[13] = t9;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== t11 || $[16] !== title) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t11,
            children: title
        });
        $[15] = t11;
        $[16] = title;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== t12 || $[19] !== t8) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100",
            xcss: $d1bc46a6b783a090$var$layoutStyles.titleRow,
            "aria-hidden": "true",
            children: [
                t8,
                t12
            ]
        });
        $[18] = t12;
        $[19] = t8;
        $[20] = t13;
    } else t13 = $[20];
    let t14;
    if ($[21] !== description || $[22] !== shouldClampText) {
        t14 = description && /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                shouldClampText && $d1bc46a6b783a090$var$styles.description,
                !shouldClampText && $d1bc46a6b783a090$var$styles.unclampedDescription
            ]),
            children: description
        });
        $[21] = description;
        $[22] = shouldClampText;
        $[23] = t14;
    } else t14 = $[23];
    const t15 = preview.attribution && /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        className: (0, $hekY6.default)([
            $d1bc46a6b783a090$var$styles.attribution,
            shouldClampText && $d1bc46a6b783a090$var$styles.compactAttribution
        ]),
        children: [
            AttributionIcon && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "aria-hidden": "true",
                className: (0, $hekY6.default)([
                    $d1bc46a6b783a090$var$styles.attributionIcon
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)(AttributionIcon, {})
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    $d1bc46a6b783a090$var$layoutStyles.attributionText
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    size: "small",
                    color: "color.text.subtle",
                    children: AttributionIcon ? formattedAttributionName : formatMessage((0, $lPJNC.messages).previewAttributionBy, {
                        name: formattedAttributionName
                    })
                })
            })
        ]
    });
    let t16;
    if ($[24] !== t13 || $[25] !== t14 || $[26] !== t15 || $[27] !== t7) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            className: t7,
            children: [
                t13,
                t14,
                t15
            ]
        });
        $[24] = t13;
        $[25] = t14;
        $[26] = t15;
        $[27] = t7;
        $[28] = t16;
    } else t16 = $[28];
    let t17;
    if ($[29] !== t16 || $[30] !== t6) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t6,
                t16
            ]
        });
        $[29] = t16;
        $[30] = t6;
        $[31] = t17;
    } else t17 = $[31];
    let t18;
    if ($[32] !== id || $[33] !== t17 || $[34] !== t3 || $[35] !== t5) {
        t18 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: setPanelElement,
            id: id,
            role: t3,
            "data-testid": t4,
            className: t5,
            children: t17
        });
        $[32] = id;
        $[33] = t17;
        $[34] = t3;
        $[35] = t5;
        $[36] = t18;
    } else t18 = $[36];
    return t18;
} : ({ description: description, icon: icon, id: id, imageUrl: imageUrl, preview: preview, popupsMountPoint: popupsMountPoint, referenceElement: referenceElement, shouldClampText: shouldClampText, title: title, update: update })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [panelElement, setPanelElement] = (0, $cozmU.useState)(null);
    const AttributionIcon = preview.attribution?.icon;
    const attributionName = preview.attribution?.name;
    const formattedAttributionName = typeof attributionName === 'string' ? attributionName : attributionName ? formatMessage(attributionName) : '';
    (0, $cozmU.useLayoutEffect)(()=>{
        update();
        const { ownerDocument: ownerDocument } = referenceElement;
        const onScroll = ()=>void update();
        const unbindScrollListener = (0, $cbY7C.bind)(ownerDocument, {
            type: 'scroll',
            listener: onScroll,
            options: true
        });
        const ResizeObserverConstructor = ownerDocument.defaultView?.ResizeObserver;
        if (!panelElement || !ResizeObserverConstructor) return unbindScrollListener;
        const observer = new ResizeObserverConstructor(()=>void update());
        observer.observe(panelElement);
        observer.observe(referenceElement);
        if (popupsMountPoint) observer.observe(popupsMountPoint);
        return ()=>{
            unbindScrollListener();
            observer.disconnect();
        };
    }, [
        panelElement,
        popupsMountPoint,
        referenceElement,
        update
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: setPanelElement,
        id: id,
        role: id ? 'tooltip' : undefined,
        "data-testid": "quick-insert-preview-panel",
        className: (0, $hekY6.default)([
            $d1bc46a6b783a090$var$styles.panel
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                imageUrl && /*#__PURE__*/ (0, $8aG6j.jsx)($d1bc46a6b783a090$var$PreviewImage, {
                    imageUrl: imageUrl
                }, imageUrl),
                /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                    className: (0, $hekY6.default)([
                        $d1bc46a6b783a090$var$styles.content
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                            alignBlock: "center",
                            space: "space.100",
                            xcss: $d1bc46a6b783a090$var$layoutStyles.titleRow,
                            "aria-hidden": "true",
                            children: [
                                icon && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                    as: "span",
                                    "aria-hidden": "true",
                                    xcss: $d1bc46a6b783a090$var$layoutStyles.titleIcon,
                                    children: icon
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                    className: (0, $hekY6.default)([
                                        shouldClampText && $d1bc46a6b783a090$var$styles.title,
                                        !shouldClampText && $d1bc46a6b783a090$var$styles.unclampedTitle
                                    ]),
                                    children: title
                                })
                            ]
                        }),
                        description && /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                            className: (0, $hekY6.default)([
                                shouldClampText && $d1bc46a6b783a090$var$styles.description,
                                !shouldClampText && $d1bc46a6b783a090$var$styles.unclampedDescription
                            ]),
                            children: description
                        }),
                        preview.attribution && /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                            className: (0, $hekY6.default)([
                                $d1bc46a6b783a090$var$styles.attribution,
                                shouldClampText && $d1bc46a6b783a090$var$styles.compactAttribution
                            ]),
                            children: [
                                AttributionIcon && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                    "aria-hidden": "true",
                                    className: (0, $hekY6.default)([
                                        $d1bc46a6b783a090$var$styles.attributionIcon
                                    ]),
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(AttributionIcon, {})
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                    className: (0, $hekY6.default)([
                                        $d1bc46a6b783a090$var$layoutStyles.attributionText
                                    ]),
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                        size: "small",
                                        color: "color.text.subtle",
                                        children: AttributionIcon ? formattedAttributionName : formatMessage((0, $lPJNC.messages).previewAttributionBy, {
                                            name: formattedAttributionName
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $d1bc46a6b783a090$var$PreviewImage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { imageUrl: imageUrl } = t0;
    const [hasFailed, setHasFailed] = (0, $cozmU.useState)(false);
    const [hasLoaded, setHasLoaded] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $d1bc46a6b783a090$var$styles.imageArea
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== hasFailed || $[2] !== hasLoaded || $[3] !== imageUrl) {
        t2 = !hasFailed && /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            "aria-hidden": "true",
            "data-testid": "quick-insert-hover-preview",
            src: imageUrl,
            alt: "",
            onLoad: ()=>setHasLoaded(true),
            onError: ()=>setHasFailed(true),
            className: (0, $hekY6.default)([
                $d1bc46a6b783a090$var$styles.image,
                !hasLoaded && $d1bc46a6b783a090$var$styles.imageHidden
            ])
        });
        $[1] = hasFailed;
        $[2] = hasLoaded;
        $[3] = imageUrl;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "aria-hidden": "true",
            "data-testid": "quick-insert-preview-image-area",
            className: t1,
            children: t2
        });
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ imageUrl: imageUrl })=>{
    const [hasFailed, setHasFailed] = (0, $cozmU.useState)(false);
    const [hasLoaded, setHasLoaded] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "aria-hidden": "true",
        "data-testid": "quick-insert-preview-image-area",
        className: (0, $hekY6.default)([
            $d1bc46a6b783a090$var$styles.imageArea
        ]),
        children: !hasFailed && /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            "aria-hidden": "true",
            "data-testid": "quick-insert-hover-preview",
            src: imageUrl,
            alt: "",
            onLoad: ()=>setHasLoaded(true),
            onError: ()=>setHasFailed(true),
            className: (0, $hekY6.default)([
                $d1bc46a6b783a090$var$styles.image,
                !hasLoaded && $d1bc46a6b783a090$var$styles.imageHidden
            ])
        })
    });
};












var $9wgTc = parcelRequire("9wgTc");

const $5828925af3a08e67$export$79f8e24b7ec7c1d9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (onSelect)=>{
    const $ = (0, $bDgLe.c)(4);
    const { editorView: editorView, select: select } = (0, $9wgTc.useQuickInsertContext)();
    let t0;
    if ($[0] !== editorView || $[1] !== onSelect || $[2] !== select) {
        t0 = ()=>select((selectionContext)=>onSelect({
                    editorView: editorView,
                    insert: selectionContext.insert,
                    source: selectionContext.source
                }));
        $[0] = editorView;
        $[1] = onSelect;
        $[2] = select;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (onSelect)=>{
    const { editorView: editorView, select: select } = (0, $9wgTc.useQuickInsertContext)();
    return (0, $cozmU.useCallback)(()=>select((selectionContext)=>onSelect({
                editorView: editorView,
                insert: selectionContext.insert,
                source: selectionContext.source
            })), [
        editorView,
        onSelect,
        select
    ]);
};





const $e3cb4697b595dbf5$var$styles = {
    iconContainer: "_0hPCNLDIqT _3iDTPbQ4SZ _3YEZNOdnbC _37wbyuDIqT _4kiQYAoWWg _4ouGXIoWWg",
    content: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEdnbC _4ouGXIdnbC",
    iconLarge: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _0hPCNLDIqT _0KLXruoI2d _3iDTPbQ4SZ _0jFU0VUofl _37wbyuDIqT _39xV02Uofl",
    shortcut: "_0bjKvDKxmn _2sNsIg7NXe _4c065UFQfX _2Y7lL41Y8M _0KLXruDMqu _1UtDYzZpcK"
};
const $e3cb4697b595dbf5$var$itemStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    backgroundColor: 'elevation.surface.overlay',
    color: 'color.text',
    display: 'flex',
    gap: 'space.150',
    minHeight: '40px',
    paddingBlock: 'space.100',
    paddingInline: 'space.200',
    textAlign: 'start',
    width: '100%',
    ':hover': {
        backgroundColor: 'elevation.surface.overlay.hovered'
    }
});
const $e3cb4697b595dbf5$var$selectedItemStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    backgroundColor: 'elevation.surface.overlay.hovered',
    color: 'color.text',
    display: 'flex',
    gap: 'space.150',
    minHeight: '40px',
    paddingBlock: 'space.100',
    paddingInline: 'space.200',
    position: 'relative',
    textAlign: 'start',
    width: '100%',
    ':hover': {
        backgroundColor: 'elevation.surface.overlay.hovered'
    },
    '::before': {
        borderInlineStartColor: 'color.border.selected',
        borderInlineStartStyle: 'solid',
        borderInlineStartWidth: 'border.width.selected',
        content: "''",
        insetBlock: 'space.0',
        insetInlineStart: 'space.0',
        pointerEvents: 'none',
        position: 'absolute'
    }
});
const $e3cb4697b595dbf5$var$disabledItemStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    backgroundColor: 'elevation.surface.overlay',
    color: 'color.text.disabled',
    display: 'flex',
    gap: 'space.150',
    minHeight: '40px',
    paddingBlock: 'space.100',
    paddingInline: 'space.200',
    textAlign: 'start',
    width: '100%'
});
const $e3cb4697b595dbf5$export$46fa03f3f74132e0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(42);
    const { ariaLabel: ariaLabel, description: description, iconBefore: iconBefore, isDisabled: isDisabled, onSelect: onSelect, preview: preview, previewIcon: previewIcon, previewImageUrls: previewImageUrls, shortcut: shortcut, titleContent: titleContent, shouldShowPreview: t1, shouldClampPreview: shouldClampPreview, shouldWrapIcon: t2, title: title } = t0;
    const shouldShowPreview = t1 === undefined ? true : t1;
    const shouldWrapIcon = t2 === undefined ? true : t2;
    const { item: item, popupsMountPoint: popupsMountPoint } = (0, $9wgTc.useQuickInsertContext)();
    let t3;
    if ($[0] !== item) {
        t3 = item ?? {
            id: undefined,
            isPreviewActive: undefined,
            isSelected: false
        };
        $[0] = item;
        $[1] = t3;
    } else t3 = $[1];
    const { id: id, isPreviewActive: isPreviewActive, isSelected: isSelected } = t3;
    const resolvedDescription = description ?? item?.description;
    const previewId = (0, $cozmU.useId)();
    const handleClick = (0, $5828925af3a08e67$export$79f8e24b7ec7c1d9)(onSelect);
    const [referenceElement, setReferenceElement] = (0, $cozmU.useState)(null);
    let t4;
    if ($[2] !== preview || $[3] !== previewImageUrls) {
        t4 = preview ?? (previewImageUrls ? {
            image: previewImageUrls
        } : {});
        $[2] = preview;
        $[3] = previewImageUrls;
        $[4] = t4;
    } else t4 = $[4];
    const resolvedPreview = t4;
    const shouldRenderPreview = shouldShowPreview && (isPreviewActive ?? isSelected) && !isDisabled;
    const hasAccessiblePreview = Boolean(resolvedDescription || resolvedPreview?.attribution);
    const previewAttributionName = resolvedPreview.attribution?.name;
    const previewAttributionKey = typeof previewAttributionName === "string" ? previewAttributionName : previewAttributionName?.id;
    let t5;
    if ($[5] !== iconBefore || $[6] !== shouldWrapIcon) {
        t5 = iconBefore && shouldWrapIcon ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $e3cb4697b595dbf5$var$styles.iconLarge,
            children: iconBefore
        }) : iconBefore;
        $[5] = iconBefore;
        $[6] = shouldWrapIcon;
        $[7] = t5;
    } else t5 = $[7];
    const wrappedIcon = t5;
    const t6 = shouldRenderPreview && hasAccessiblePreview ? previewId : undefined;
    const t7 = isDisabled ? $e3cb4697b595dbf5$var$disabledItemStyles : isSelected ? $e3cb4697b595dbf5$var$selectedItemStyles : $e3cb4697b595dbf5$var$itemStyles;
    let t8;
    if ($[8] !== wrappedIcon) {
        t8 = wrappedIcon && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $e3cb4697b595dbf5$var$styles.iconContainer,
            children: wrappedIcon
        });
        $[8] = wrappedIcon;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== title || $[11] !== titleContent) {
        t9 = titleContent ?? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            children: title
        });
        $[10] = title;
        $[11] = titleContent;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== shortcut) {
        t10 = shortcut && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            xcss: $e3cb4697b595dbf5$var$styles.shortcut,
            children: shortcut
        });
        $[13] = shortcut;
        $[14] = t10;
    } else t10 = $[14];
    let t11;
    if ($[15] !== t10 || $[16] !== t9) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between",
            xcss: $e3cb4697b595dbf5$var$styles.content,
            children: [
                t9,
                t10
            ]
        });
        $[15] = t10;
        $[16] = t9;
        $[17] = t11;
    } else t11 = $[17];
    let t12;
    if ($[18] !== ariaLabel || $[19] !== handleClick || $[20] !== id || $[21] !== isDisabled || $[22] !== isSelected || $[23] !== t11 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kh0hi.Pressable), {
            ref: setReferenceElement,
            "aria-label": ariaLabel,
            "aria-describedby": t6,
            "aria-selected": isSelected,
            id: id,
            isDisabled: isDisabled,
            onClick: handleClick,
            role: "option",
            xcss: t7,
            children: [
                t8,
                t11
            ]
        });
        $[18] = ariaLabel;
        $[19] = handleClick;
        $[20] = id;
        $[21] = isDisabled;
        $[22] = isSelected;
        $[23] = t11;
        $[24] = t6;
        $[25] = t7;
        $[26] = t8;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== popupsMountPoint || $[29] !== previewAttributionKey || $[30] !== previewIcon || $[31] !== previewId || $[32] !== referenceElement || $[33] !== resolvedDescription || $[34] !== resolvedPreview || $[35] !== shouldClampPreview || $[36] !== shouldRenderPreview || $[37] !== title) {
        t13 = shouldRenderPreview && referenceElement && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d1bc46a6b783a090$export$ff7b0dfb01a1c1fe), {
            id: previewId,
            description: resolvedDescription,
            preview: resolvedPreview,
            popupsMountPoint: popupsMountPoint,
            referenceElement: referenceElement,
            title: title,
            icon: previewIcon,
            shouldClampText: shouldClampPreview
        }, resolvedPreview.image?.light ?? previewAttributionKey ?? title);
        $[28] = popupsMountPoint;
        $[29] = previewAttributionKey;
        $[30] = previewIcon;
        $[31] = previewId;
        $[32] = referenceElement;
        $[33] = resolvedDescription;
        $[34] = resolvedPreview;
        $[35] = shouldClampPreview;
        $[36] = shouldRenderPreview;
        $[37] = title;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] !== t12 || $[40] !== t13) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t12,
                t13
            ]
        });
        $[39] = t12;
        $[40] = t13;
        $[41] = t14;
    } else t14 = $[41];
    return t14;
} : ({ ariaLabel: ariaLabel, description: description, iconBefore: iconBefore, isDisabled: isDisabled, onSelect: onSelect, preview: preview, previewIcon: previewIcon, previewImageUrls: previewImageUrls, shortcut: shortcut, titleContent: titleContent, shouldShowPreview: shouldShowPreview = true, shouldClampPreview: shouldClampPreview, shouldWrapIcon: shouldWrapIcon = true, title: title })=>{
    const { item: item, popupsMountPoint: popupsMountPoint } = (0, $9wgTc.useQuickInsertContext)();
    const { id: id, isPreviewActive: isPreviewActive, isSelected: isSelected } = item ?? {
        id: undefined,
        isPreviewActive: undefined,
        isSelected: false
    };
    const resolvedDescription = description ?? item?.description;
    const previewId = (0, $cozmU.useId)();
    const handleClick = (0, $5828925af3a08e67$export$79f8e24b7ec7c1d9)(onSelect);
    const [referenceElement, setReferenceElement] = (0, $cozmU.useState)(null);
    const resolvedPreview = (0, $cozmU.useMemo)(()=>preview ?? (previewImageUrls ? {
            image: previewImageUrls
        } : {}), [
        preview,
        previewImageUrls
    ]);
    const shouldRenderPreview = shouldShowPreview && (isPreviewActive ?? isSelected) && !isDisabled;
    const hasAccessiblePreview = Boolean(resolvedDescription || resolvedPreview?.attribution);
    const previewAttributionName = resolvedPreview.attribution?.name;
    const previewAttributionKey = typeof previewAttributionName === 'string' ? previewAttributionName : previewAttributionName?.id;
    const wrappedIcon = iconBefore && shouldWrapIcon ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $e3cb4697b595dbf5$var$styles.iconLarge,
        children: iconBefore
    }) : iconBefore;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kh0hi.Pressable), {
                ref: setReferenceElement,
                "aria-label": ariaLabel,
                "aria-describedby": shouldRenderPreview && hasAccessiblePreview ? previewId : undefined,
                "aria-selected": isSelected,
                id: id,
                isDisabled: isDisabled,
                onClick: handleClick,
                role: "option",
                xcss: isDisabled ? $e3cb4697b595dbf5$var$disabledItemStyles : isSelected ? $e3cb4697b595dbf5$var$selectedItemStyles : $e3cb4697b595dbf5$var$itemStyles,
                children: [
                    wrappedIcon && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $e3cb4697b595dbf5$var$styles.iconContainer,
                        children: wrappedIcon
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        alignBlock: "center",
                        spread: "space-between",
                        xcss: $e3cb4697b595dbf5$var$styles.content,
                        children: [
                            titleContent ?? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                children: title
                            }),
                            shortcut && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                as: "span",
                                xcss: $e3cb4697b595dbf5$var$styles.shortcut,
                                children: shortcut
                            })
                        ]
                    })
                ]
            }),
            shouldRenderPreview && referenceElement && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d1bc46a6b783a090$export$ff7b0dfb01a1c1fe), {
                id: previewId,
                description: resolvedDescription,
                preview: resolvedPreview,
                popupsMountPoint: popupsMountPoint,
                referenceElement: referenceElement,
                title: title,
                icon: previewIcon,
                shouldClampText: shouldClampPreview
            }, resolvedPreview.image?.light ?? previewAttributionKey ?? title)
        ]
    });
};


















var $4o0zT = parcelRequire("4o0zT");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");



var $2wCqQ = parcelRequire("2wCqQ");

var $6Pqow = parcelRequire("6Pqow");







const $82a567ba05e90db2$var$borderlessItemStyles = (0, $buxP3.xcss)({
    alignItems: 'start',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.medium',
    color: 'color.text',
    cursor: 'pointer',
    display: 'flex',
    gap: 'space.150',
    height: '88px',
    padding: 'space.150',
    textAlign: 'start',
    width: '100%'
});
const $82a567ba05e90db2$var$borderlessSelectedItemStyles = (0, $buxP3.xcss)({
    alignItems: 'start',
    backgroundColor: 'color.background.selected',
    borderRadius: 'radius.medium',
    color: 'color.text',
    cursor: 'pointer',
    display: 'flex',
    gap: 'space.150',
    height: '88px',
    padding: 'space.150',
    position: 'relative',
    textAlign: 'start',
    width: '100%',
    '::before': {
        borderInlineStartColor: 'color.border.selected',
        borderInlineStartStyle: 'solid',
        borderInlineStartWidth: 'border.width.selected',
        content: "''",
        insetBlock: 'space.0',
        insetInlineStart: 'space.0',
        pointerEvents: 'none',
        position: 'absolute'
    }
});
const $82a567ba05e90db2$var$borderlessDisabledItemStyles = (0, $buxP3.xcss)({
    alignItems: 'start',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.medium',
    color: 'color.text.disabled',
    cursor: 'not-allowed',
    display: 'flex',
    gap: 'space.150',
    height: '88px',
    padding: 'space.150',
    textAlign: 'start',
    width: '100%'
});
const $82a567ba05e90db2$var$hoveredItemStyles = (0, $buxP3.xcss)({
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        borderRadius: 'radius.medium'
    }
});
const $82a567ba05e90db2$var$iconStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    backgroundColor: 'elevation.surface.overlay',
    borderColor: 'color.border',
    borderRadius: 'radius.medium',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    display: 'flex',
    flexShrink: 0,
    height: '40px',
    justifyContent: 'center',
    overflow: 'hidden',
    width: '40px'
});
const $82a567ba05e90db2$var$iconLargeStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    backgroundColor: 'elevation.surface.overlay',
    borderColor: 'color.border',
    borderRadius: 'radius.large',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    display: 'flex',
    flexShrink: 0,
    height: '40px',
    justifyContent: 'center',
    overflow: 'hidden',
    width: '40px'
});
const $82a567ba05e90db2$var$iconColorStyles = null;
const $82a567ba05e90db2$var$shortcutStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.small',
    color: 'color.text.subtle',
    font: 'font.body.small',
    paddingBlock: 'space.025',
    paddingInline: 'space.050'
});
const $82a567ba05e90db2$export$6bc6abb4df11dffb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { ariaLabel: ariaLabel, description: description, iconBefore: iconBefore, isDisabled: isDisabled, onSelect: onSelect, shortcut: shortcut, titleContent: titleContent, shouldWrapIcon: t1, title: title } = t0;
    const shouldWrapIcon = t1 === undefined ? true : t1;
    const { item: item } = (0, $9wgTc.useQuickInsertContext)();
    let t2;
    if ($[0] !== item) {
        t2 = item ?? {
            id: undefined,
            isSelected: false
        };
        $[0] = item;
        $[1] = t2;
    } else t2 = $[1];
    const { id: id, isSelected: isSelected } = t2;
    const itemDescription = description ?? item?.description;
    const handleClick = (0, $5828925af3a08e67$export$79f8e24b7ec7c1d9)(onSelect);
    const t3 = isDisabled ? $82a567ba05e90db2$var$borderlessDisabledItemStyles : isSelected ? $82a567ba05e90db2$var$borderlessSelectedItemStyles : $82a567ba05e90db2$var$borderlessItemStyles;
    let t4;
    if ($[2] !== isDisabled || $[3] !== isSelected) {
        t4 = (0, $4o0zT.isExperimentEnabled)("platform_editor_slash_command") && !isDisabled && !isSelected && $82a567ba05e90db2$var$hoveredItemStyles;
        $[2] = isDisabled;
        $[3] = isSelected;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t3 || $[6] !== t4) {
        t5 = [
            t3,
            t4
        ];
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const itemStyles = t5;
    const t6 = isSelected ? 0 : -1;
    let t7;
    if ($[8] !== iconBefore || $[9] !== shouldWrapIcon) {
        t7 = iconBefore && shouldWrapIcon ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
            xcss: (0, $4o0zT.isExperimentEnabled)("platform_editor_slash_command") ? $82a567ba05e90db2$var$iconLargeStyles : $82a567ba05e90db2$var$iconStyles,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    "_1UtDYz4YkS"
                ]),
                children: iconBefore
            })
        }) : iconBefore ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_1UtDYz4YkS"
            ]),
            children: iconBefore
        }) : null;
        $[8] = iconBefore;
        $[9] = shouldWrapIcon;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== title || $[12] !== titleContent) {
        t8 = titleContent ?? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6Pqow.Text), {
            color: "color.text",
            maxLines: 1,
            size: "medium",
            weight: "medium",
            children: title
        });
        $[11] = title;
        $[12] = titleContent;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== shortcut) {
        t9 = shortcut && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
            as: "span",
            xcss: $82a567ba05e90db2$var$shortcutStyles,
            children: shortcut
        });
        $[14] = shortcut;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== t8 || $[17] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kz1Yj.Inline), {
            alignBlock: "center",
            spread: "space-between",
            space: "space.100",
            children: [
                t8,
                t9
            ]
        });
        $[16] = t8;
        $[17] = t9;
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== itemDescription) {
        t11 = itemDescription && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6Pqow.Text), {
            color: "color.text.subtlest",
            maxLines: 2,
            size: "small",
            weight: "regular",
            children: itemDescription
        });
        $[19] = itemDescription;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== t10 || $[22] !== t11) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2wCqQ.Stack), {
            space: "space.050",
            grow: "fill",
            children: [
                t10,
                t11
            ]
        });
        $[21] = t10;
        $[22] = t11;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== ariaLabel || $[25] !== handleClick || $[26] !== id || $[27] !== isDisabled || $[28] !== isSelected || $[29] !== itemStyles || $[30] !== t12 || $[31] !== t6 || $[32] !== t7) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kh0hi.Pressable), {
            "aria-label": ariaLabel,
            "aria-selected": isSelected,
            id: id,
            isDisabled: isDisabled,
            onClick: handleClick,
            role: "option",
            tabIndex: t6,
            xcss: itemStyles,
            children: [
                t7,
                t12
            ]
        });
        $[24] = ariaLabel;
        $[25] = handleClick;
        $[26] = id;
        $[27] = isDisabled;
        $[28] = isSelected;
        $[29] = itemStyles;
        $[30] = t12;
        $[31] = t6;
        $[32] = t7;
        $[33] = t13;
    } else t13 = $[33];
    return t13;
} : ({ ariaLabel: ariaLabel, description: description, iconBefore: iconBefore, isDisabled: isDisabled, onSelect: onSelect, shortcut: shortcut, titleContent: titleContent, shouldWrapIcon: shouldWrapIcon = true, title: title })=>{
    const { item: item } = (0, $9wgTc.useQuickInsertContext)();
    const { id: id, isSelected: isSelected } = item ?? {
        id: undefined,
        isSelected: false
    };
    const itemDescription = description ?? item?.description;
    const handleClick = (0, $5828925af3a08e67$export$79f8e24b7ec7c1d9)(onSelect);
    const itemStyles = (0, $cozmU.useMemo)(()=>[
            isDisabled ? $82a567ba05e90db2$var$borderlessDisabledItemStyles : isSelected ? $82a567ba05e90db2$var$borderlessSelectedItemStyles : $82a567ba05e90db2$var$borderlessItemStyles,
            (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command') && !isDisabled && !isSelected && $82a567ba05e90db2$var$hoveredItemStyles
        ], [
        isDisabled,
        isSelected
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kh0hi.Pressable), {
        "aria-label": ariaLabel,
        "aria-selected": isSelected,
        id: id,
        isDisabled: isDisabled,
        onClick: handleClick,
        role: "option",
        tabIndex: isSelected ? 0 : -1,
        xcss: itemStyles,
        children: [
            iconBefore && shouldWrapIcon ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
                xcss: (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command') ? $82a567ba05e90db2$var$iconLargeStyles : $82a567ba05e90db2$var$iconStyles,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_1UtDYz4YkS"
                    ]),
                    children: iconBefore
                })
            }) : iconBefore ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    "_1UtDYz4YkS"
                ]),
                children: iconBefore
            }) : null,
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2wCqQ.Stack), {
                space: "space.050",
                grow: "fill",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kz1Yj.Inline), {
                        alignBlock: "center",
                        spread: "space-between",
                        space: "space.100",
                        children: [
                            titleContent ?? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6Pqow.Text), {
                                color: "color.text",
                                maxLines: 1,
                                size: "medium",
                                weight: "medium",
                                children: title
                            }),
                            shortcut && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
                                as: "span",
                                xcss: $82a567ba05e90db2$var$shortcutStyles,
                                children: shortcut
                            })
                        ]
                    }),
                    itemDescription && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6Pqow.Text), {
                        color: "color.text.subtlest",
                        maxLines: 2,
                        size: "small",
                        weight: "regular",
                        children: itemDescription
                    })
                ]
            })
        ]
    });
};





const $8e55547fcae45f15$export$d0d3cb02f0dbbd98 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { ariaLabel: ariaLabel, description: description, iconBefore: iconBefore, isDisabled: isDisabled, onSelect: onSelect, preview: preview, previewIcon: previewIcon, previewImageUrls: previewImageUrls, shortcut: shortcut, titleContent: titleContent, shouldShowPreview: shouldShowPreview, shouldClampPreview: shouldClampPreview, shouldWrapIcon: shouldWrapIcon, title: title } = t0;
    const { surface: surface } = (0, $9wgTc.useQuickInsertContext)();
    let t1;
    if ($[0] !== ariaLabel || $[1] !== description || $[2] !== iconBefore || $[3] !== isDisabled || $[4] !== onSelect || $[5] !== preview || $[6] !== previewIcon || $[7] !== previewImageUrls || $[8] !== shortcut || $[9] !== shouldClampPreview || $[10] !== shouldShowPreview || $[11] !== shouldWrapIcon || $[12] !== surface || $[13] !== title || $[14] !== titleContent) {
        t1 = surface === "element-browser" ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $82a567ba05e90db2$export$6bc6abb4df11dffb), {
            ariaLabel: ariaLabel,
            description: description,
            iconBefore: iconBefore,
            isDisabled: isDisabled,
            onSelect: onSelect,
            shortcut: shortcut,
            titleContent: titleContent,
            shouldWrapIcon: shouldWrapIcon,
            title: title
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e3cb4697b595dbf5$export$46fa03f3f74132e0), {
            ariaLabel: ariaLabel,
            description: description,
            iconBefore: iconBefore,
            isDisabled: isDisabled,
            onSelect: onSelect,
            preview: preview,
            previewIcon: previewIcon,
            previewImageUrls: previewImageUrls,
            shortcut: shortcut,
            titleContent: titleContent,
            shouldShowPreview: shouldShowPreview,
            shouldClampPreview: shouldClampPreview,
            shouldWrapIcon: shouldWrapIcon,
            title: title
        });
        $[0] = ariaLabel;
        $[1] = description;
        $[2] = iconBefore;
        $[3] = isDisabled;
        $[4] = onSelect;
        $[5] = preview;
        $[6] = previewIcon;
        $[7] = previewImageUrls;
        $[8] = shortcut;
        $[9] = shouldClampPreview;
        $[10] = shouldShowPreview;
        $[11] = shouldWrapIcon;
        $[12] = surface;
        $[13] = title;
        $[14] = titleContent;
        $[15] = t1;
    } else t1 = $[15];
    return t1;
} : ({ ariaLabel: ariaLabel, description: description, iconBefore: iconBefore, isDisabled: isDisabled, onSelect: onSelect, preview: preview, previewIcon: previewIcon, previewImageUrls: previewImageUrls, shortcut: shortcut, titleContent: titleContent, shouldShowPreview: shouldShowPreview, shouldClampPreview: shouldClampPreview, shouldWrapIcon: shouldWrapIcon, title: title })=>{
    const { surface: surface } = (0, $9wgTc.useQuickInsertContext)();
    return surface === 'element-browser' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $82a567ba05e90db2$export$6bc6abb4df11dffb), {
        ariaLabel: ariaLabel,
        description: description,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        onSelect: onSelect,
        shortcut: shortcut,
        titleContent: titleContent,
        shouldWrapIcon: shouldWrapIcon,
        title: title
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e3cb4697b595dbf5$export$46fa03f3f74132e0), {
        ariaLabel: ariaLabel,
        description: description,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        onSelect: onSelect,
        preview: preview,
        previewIcon: previewIcon,
        previewImageUrls: previewImageUrls,
        shortcut: shortcut,
        titleContent: titleContent,
        shouldShowPreview: shouldShowPreview,
        shouldClampPreview: shouldClampPreview,
        shouldWrapIcon: shouldWrapIcon,
        title: title
    });
};
module.exports["QuickInsertMenuItem"] = $8e55547fcae45f15$export$d0d3cb02f0dbbd98;

});

parcelRegister("9wgTc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $h7AEq = parcelRequire("h7AEq");

const $1c29d3aa1917b02f$export$2c0ceb75d6ddbe1f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const value = (0, $cozmU.useContext)((0, $h7AEq.QuickInsertContext));
    if (!value) throw new Error("useQuickInsertContext must be used within QuickInsertProvider");
    return value;
} : ()=>{
    const value = (0, $cozmU.useContext)((0, $h7AEq.QuickInsertContext));
    if (!value) throw new Error('useQuickInsertContext must be used within QuickInsertProvider');
    return value;
};
module.exports["useQuickInsertContext"] = $1c29d3aa1917b02f$export$2c0ceb75d6ddbe1f;

});

parcelRegister("h7AEq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $cfb0d54151ade253$export$dbec038872997d65 = (0, $cozmU.createContext)(null);
module.exports["QuickInsertContext"] = $cfb0d54151ade253$export$dbec038872997d65;

});

parcelRegister("clm0n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba8e3178d04dd5e3d53ab4dd399b430d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fc883ee5256b196$var$_react = $8fc883ee5256b196$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8fc883ee5256b196$var$_iconNew = $8fc883ee5256b196$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $8fc883ee5256b196$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableOfContent".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/table-of-content
 * Usage guidance:
 * Reserved for representing table of contents.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8fc883ee5256b196$var$TableOfContentIcon = (props)=>/*#__PURE__*/ $8fc883ee5256b196$var$_react.default.createElement($8fc883ee5256b196$var$_iconNew.default, Object.assign({
        name: "TableOfContentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14 3.75v-1.5H4v1.5zm0 10v-1.5H4v1.5zm2-6.5v1.5H8v-1.5zM6 9H4V7h2zM2 4H0V2h2zm0 10H0v-2h2z"/>`
    }, props));
$8fc883ee5256b196$var$TableOfContentIcon.displayName = 'TableOfContentIcon';
var $8fc883ee5256b196$var$_default = module.exports.default = $8fc883ee5256b196$var$TableOfContentIcon;

});

parcelRegister("dp5Fv", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $ezEf7 = parcelRequire("ezEf7");

const $0d3a40daaf8732a3$export$180fe852598a23ab = {
    pending: [
        'started'
    ],
    started: [
        'aborted',
        'failed',
        'succeeded'
    ],
    aborted: [
        'started'
    ],
    failed: [
        'started'
    ],
    succeeded: [
        'started'
    ]
};


const $07c1b232957a8c9e$export$178881f329fdb81f = (fromState, toState)=>{
    return (0, $0d3a40daaf8732a3$export$180fe852598a23ab)[fromState]?.includes(toState) ?? false;
};


class $d8d54ef8094908fe$export$fa331fd384051f6a {
    start(callback) {
        this.checks.forEach((check)=>check.start(callback));
    }
    stop() {
        this.checks.forEach((check)=>check.stop());
    }
    constructor(checks){
        this.checks = void 0;
        this.checks = checks;
    }
}


class $6ef5e2aae4260b78$export$c90b54e658fc4d7c {
    startCheck() {
        this.stopCheck();
        this.check.start(({ status: status, reason: reason, metadata: metadata })=>{
            if (status === 'success') this.success({
                reason: reason,
                metadata: metadata
            });
            else if (status === 'abort') this.abort({
                reason: reason,
                metadata: metadata
            });
            else if (status === 'failure') this.failure({
                reason: reason,
                metadata: metadata
            });
        });
    }
    stopCheck() {
        this.check.stop();
    }
    getEndStateMetadata(options = {}) {
        const metadata = {
            ...options.metadata
        };
        if (options.reason) metadata.experienceEndReason = options.reason;
        return metadata;
    }
    /**
   * Transitions to a new experience state and tracks analytics events.
   *
   * Upon transition to each state, two events are tracked:
   * - experienceMeasured: tracked on every successful transition, used for data analysis
   * - experienceSampled: tracked only on 1 out of every N transitions based on sample rate
   *
   * @param toState - The target state to transition to
   * @param metadata - Optional metadata to attach to the analytics events
   * @returns true if transition was successful, false if invalid transition
   */ transitionTo(toState, metadata) {
        if (!(0, $07c1b232957a8c9e$export$178881f329fdb81f)(this.currentState, toState)) return false;
        this.currentState = toState;
        if (toState === 'started') {
            this.isSampledTrackingEnabled = Math.random() < this.sampleRate;
            this.startTimeMs = Date.now();
            this.startMetadata = metadata;
        }
        this.trackTransition(toState, metadata);
        if (toState === 'started') this.startCheck();
        else {
            this.stopCheck();
            this.startMetadata = undefined;
        }
        this.statesSeen.add(toState);
        return true;
    }
    /**
   * Tracks analytics events for a state transition.
   *
   * Fires both experienceMeasured (always) and experienceSampled (sampled) events.
   *
   * @param toState - The state that was transitioned to
   * @param metadata - Metadata to include in the event, including firstInSession flag
   */ trackTransition(toState, metadata) {
        const attributes = {
            experienceKey: this.id,
            experienceStatus: toState,
            experienceStatusFirstSeen: !this.statesSeen.has(toState),
            experienceStartTime: this.startTimeMs || 0,
            experienceDuration: this.startTimeMs ? Date.now() - this.startTimeMs : 0,
            ...this.globalMetadata,
            ...this.startMetadata,
            ...metadata
        };
        const experienceMeasuredEvent = {
            action: (0, $krYZG.ACTION).EXPERIENCE_MEASURED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            actionSubjectId: this.actionSubjectId,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: attributes
        };
        this.dispatchAnalyticsEvent(experienceMeasuredEvent);
        if (this.isSampledTrackingEnabled) {
            const experienceSampledEvent = {
                action: (0, $krYZG.ACTION).EXPERIENCE_SAMPLED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                actionSubjectId: this.actionSubjectId,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: attributes
            };
            this.dispatchAnalyticsEvent(experienceSampledEvent);
        }
    }
    /**
   * Starts tracking the experience and all checks which monitor for completion.
   *
   * Metadata from options will be merged with metadata provided in subsequent events.
   *
   * @param options - Configuration for starting the experience
   * @param options.metadata - Optional custom metadata attached to all subsequent events for this started experience
   * @param options.forceRestart - If true and experience already in progress will abort and restart
   * @param options.method - Optional method for experience start, e.g., how the experience was initiated
   */ start(options = {}) {
        if (options.forceRestart && this.currentState === 'started') this.abort({
            reason: (0, $ezEf7.EXPERIENCE_ABORT_REASON).RESTARTED
        });
        return this.transitionTo('started', {
            experienceStartMethod: options.method,
            ...options.metadata
        });
    }
    /**
   * Marks the experience as successful and stops any ongoing checks.
   *
   * @param options - Configuration for the success event
   * @param options.metadata - Optional custom metadata attached to the success event
   * @param options.reason - Optional reason for success
   * @returns false if transition to success state was not valid
   */ success(options = {}) {
        const metadata = this.getEndStateMetadata(options);
        return this.transitionTo('succeeded', metadata);
    }
    /**
   * Aborts the experience and stops any ongoing checks.
   *
   * Use this when a started experience terminates early due to user action or context change
   * (e.g., component unmount, navigation). This is neither success nor failure.
   *
   * @param options - Configuration for the abort event
   * @param options.metadata - Optional custom metadata attached to the abort event
   * @param options.reason - Optional reason for abort
   *
   * @example
   * // Abort on component unmount
   * useEffect(() => {
   *   return () => experience.abort({ reason: 'unmount', metadata: { someKey: 'someValue' } });
   * }, []);
   *
   * @returns false if transition to aborted state was not valid
   */ abort(options = {}) {
        const metadata = this.getEndStateMetadata(options);
        return this.transitionTo('aborted', metadata);
    }
    /**
   * Manually marks the experience as failed and stops any ongoing checks.
   *
   * Use this for actual failures in the experience flow (e.g., timeout, error conditions).
   *
   * @param options - Configuration for the failure event
   * @param options.metadata - Optional custom metadata attached to the failure event
   * @param options.reason - Optional reason for failure
   * @returns false if transition to failed state was not valid
   */ failure(options = {}) {
        const metadata = this.getEndStateMetadata(options);
        return this.transitionTo('failed', metadata);
    }
    /**
   * Creates a new Experience instance for tracking user experiences.
   *
   * @param id - Unique identifier for the experience e.g. 'toolbarOpen' 'menuAction'
   * @param options - Configuration options for the experience
   * @param options.checks - Experience checks to monitor for completion
   * @param options.dispatchAnalyticsEvent - Function to dispatch analytics events
   * @param options.sampleRate - Sample rate for experienceSampled events
   * @param options.metadata - Global metadata to attach to all events
   * @param options.action - Optional sub identifier for the specific experience action e.g. 'bold' 'insertTable'
   * @param options.actionSubjectId - Optional sub identifier for the experience action subject e.g. 'selectionToolbar' 'quickInsert'
   */ constructor(id, options){
        this.id = void 0;
        this.actionSubjectId = void 0;
        this.dispatchAnalyticsEvent = void 0;
        this.sampleRate = void 0;
        this.globalMetadata = void 0;
        this.check = void 0;
        this.currentState = 'pending';
        /**
     * Set of experience states that have been seen in the current session.
     *
     * Used to determine if experienceStatusFirstSeen flag should be set in events.
     */ this.statesSeen = new Set();
        /**
     * Indicates whether sampled tracking is enabled for this current experience session.
     *
     * Set to true | false upon transitioning to 'started' state.
     * When true, on subsequent transitions we fire experienceSampled events.
     * Ensures that every tracked start has corresponding abort/fail/success tracked.
     */ this.isSampledTrackingEnabled = void 0;
        /**
     * Timestamp (in milliseconds) when the experience transitioned to 'started' state.
     *
     * Used to calculate experience duration. Set via Date.now() when experience starts.
     */ this.startTimeMs = void 0;
        /**
     * Metadata provided at experience start time to merge into subsequent events.
     *
     * Used to retain experienceStartMethod and other start-specific metadata.
     */ this.startMetadata = void 0;
        this.id = id;
        this.actionSubjectId = options.actionSubjectId;
        this.dispatchAnalyticsEvent = options.dispatchAnalyticsEvent;
        this.sampleRate = options.sampleRate ?? (0, $ezEf7.DEFAULT_EXPERIENCE_SAMPLE_RATE);
        this.globalMetadata = {
            ...options.metadata,
            experienceAction: options.action
        };
        this.check = new (0, $d8d54ef8094908fe$export$fa331fd384051f6a)(options.checks || []);
    }
}
module.exports["Experience"] = $6ef5e2aae4260b78$export$c90b54e658fc4d7c;

});

parcelRegister("ezEf7", function(module, exports) {
/**
 * Built-in failure reasons for experience checks
 *
 * These are used by the various ExperienceCheck implementations to
 * provide consistent, well-known failure reasons for analytics and debugging.
 */ const $09ae74b963a5a13b$export$21dde0ac9b2abe83 = {
    /**
   * Experience timed out before completion
   */ TIMEOUT: 'timeout',
    /**
   * Target element could not be found when starting DOM mutation observation
   */ DOM_MUTATION_TARGET_NOT_FOUND: 'domMutationTargetNotFound',
    /**
   * Error occurred during DOM mutation check execution
   */ DOM_MUTATION_CHECK_ERROR: 'domMutationCheckError'
};
const $09ae74b963a5a13b$export$e6589edd1f8a04af = {
    /**
   * Experience was aborted because it was restarted while already in progress
   */ RESTARTED: 'restarted'
};
const $09ae74b963a5a13b$export$8e85905c8b6efc67 = 0.001;
const $09ae74b963a5a13b$export$b110169935468339 = {
    ASYNC_OPERATION: 'asyncOperation',
    MENU_ACTION: 'menuAction',
    MENU_OPEN: 'menuOpen',
    TOOLBAR_ACTION: 'toolbarAction',
    TOOLBAR_OPEN: 'toolbarOpen'
};
module.exports["EXPERIENCE_FAILURE_REASON"] = $09ae74b963a5a13b$export$21dde0ac9b2abe83;
module.exports["EXPERIENCE_ABORT_REASON"] = $09ae74b963a5a13b$export$e6589edd1f8a04af;
module.exports["DEFAULT_EXPERIENCE_SAMPLE_RATE"] = $09ae74b963a5a13b$export$8e85905c8b6efc67;
module.exports["EXPERIENCE_ID"] = $09ae74b963a5a13b$export$b110169935468339;

});

parcelRegister("6NW7h", function(module, exports) {

var $ezEf7 = parcelRequire("ezEf7");

const $7574082137ffb0bb$var$DEFAULT_FAILURE_RESULT = {
    status: 'failure',
    reason: (0, $ezEf7.EXPERIENCE_FAILURE_REASON).TIMEOUT
};
class $7574082137ffb0bb$export$1a6fa509d14ac50 {
    start(callback) {
        this.stop();
        this.timeoutId = setTimeout(()=>{
            const result = this.onTimeout() || $7574082137ffb0bb$var$DEFAULT_FAILURE_RESULT;
            callback(result);
        }, this.durationMs);
    }
    stop() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
    }
    constructor({ durationMs: durationMs, onTimeout: onTimeout = ()=>$7574082137ffb0bb$var$DEFAULT_FAILURE_RESULT }){
        this.timeoutId = void 0;
        this.durationMs = 0;
        this.onTimeout = void 0;
        this.durationMs = durationMs;
        this.onTimeout = onTimeout;
    }
}
module.exports["ExperienceCheckTimeout"] = $7574082137ffb0bb$export$1a6fa509d14ac50;

});

parcelRegister("h75sz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $jv11C = parcelRequire("jv11C");

class $c86f157407aa34d6$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $jv11C.logException)(error, {
            location: 'editor-common'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false
        };
    }
}
module.exports["ErrorBoundary"] = $c86f157407aa34d6$export$e926676385687eaf;

});

parcelRegister("8VCvx", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $jIX6h = parcelRequire("jIX6h");


var $72AfS = parcelRequire("72AfS");


var $cUMTy = parcelRequire("cUMTy");

const $a411c83676d4a1af$var$darkModeTextPaletteOverrides = (0, $kSwu1.defineMessages)({
    '#FFFFFF': {
        id: "fabric.theme.dark-gray",
        defaultMessage: "Dark gray"
    }
});
const $a411c83676d4a1af$export$cca9f3b863b77c82 = {
    ...(0, $cUMTy.lightTextPaletteTooltipMessages),
    ...$a411c83676d4a1af$var$darkModeTextPaletteOverrides
};
const $a411c83676d4a1af$export$d8fe76863446580e = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    light: (0, $cUMTy.lightTextPaletteTooltipMessages),
    dark: $a411c83676d4a1af$export$cca9f3b863b77c82
};
const $a411c83676d4a1af$var$darkModeBackgroundPaletteOverrides = (0, $kSwu1.defineMessages)({
    '#FFFFFF': {
        id: "fabric.theme.subtle-gray",
        defaultMessage: "Subtle gray"
    },
    '#B3BAC5': {
        id: "fabric.theme.bold-gray",
        defaultMessage: "Bold gray"
    }
});
const $a411c83676d4a1af$export$d1327856929fda16 = {
    ...(0, $jIX6h.lightBackgroundPaletteTooltipMessages),
    ...$a411c83676d4a1af$var$darkModeBackgroundPaletteOverrides
};
const $a411c83676d4a1af$export$c671ecebb9c48677 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    light: (0, $jIX6h.lightBackgroundPaletteTooltipMessages),
    dark: $a411c83676d4a1af$export$d1327856929fda16
};
const $a411c83676d4a1af$var$darkChartsColorPaletteTooltipMessages = {
    ...(0, $72AfS.lightChartsColorPaletteTooltipMessages)
};
const $a411c83676d4a1af$export$f8b88c9f6c817aff = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    light: (0, $72AfS.lightChartsColorPaletteTooltipMessages),
    dark: $a411c83676d4a1af$var$darkChartsColorPaletteTooltipMessages
};
const $a411c83676d4a1af$var$lightBorderPaletteTooltipMessages = (0, $kSwu1.defineMessages)({
    '#091E4224': {
        id: "fabric.theme.subtle-gray",
        defaultMessage: "Subtle gray"
    },
    '#758195': {
        id: "fabric.theme.gray",
        defaultMessage: "Gray"
    },
    '#172B4D': {
        id: "fabric.theme.bold-gray",
        defaultMessage: "Bold gray"
    }
});
const $a411c83676d4a1af$var$darkBorderPaletteTooltipMessages = {
    ...$a411c83676d4a1af$var$lightBorderPaletteTooltipMessages
};
const $a411c83676d4a1af$export$515e8edd15e08de7 = {
    light: $a411c83676d4a1af$var$lightBorderPaletteTooltipMessages,
    dark: $a411c83676d4a1af$var$darkBorderPaletteTooltipMessages
};
module.exports["textPaletteTooltipMessages"] = $a411c83676d4a1af$export$d8fe76863446580e;
module.exports["backgroundPaletteTooltipMessages"] = $a411c83676d4a1af$export$c671ecebb9c48677;
module.exports["chartsColorPaletteTooltipMessages"] = $a411c83676d4a1af$export$f8b88c9f6c817aff;
module.exports["borderPaletteTooltipMessages"] = $a411c83676d4a1af$export$515e8edd15e08de7;

});

parcelRegister("kgt0V", function(module, exports) {

var $dAhdV = parcelRequire("dAhdV");


var $b63P7 = parcelRequire("b63P7");


var $2Ryc1 = parcelRequire("2Ryc1");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $ec0bced2b3071295$var$nativeCeil = Math.ceil, $ec0bced2b3071295$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $ec0bced2b3071295$var$chunk(array, size, guard) {
    if (guard ? $b63P7(array, size, guard) : size === undefined) size = 1;
    else size = $ec0bced2b3071295$var$nativeMax($2Ryc1(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($ec0bced2b3071295$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $dAhdV(array, index, index += size);
    return result;
}
module.exports = $ec0bced2b3071295$var$chunk;

});

parcelRegister("3y9WX", function(module, exports) {
const $979c42675ce79c25$var$DAM_CDN_LINK = 'https://dam-cdn.atl.orangelogic.com/CDNLink';
const $979c42675ce79c25$var$snippetPreviewImageUrlsByKey = {
    // Action items
    '019e5cd9-5ca1-7258-befd-4f50d491bb42': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVLE.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVJI.png`
    },
    // Bug report
    '019e5cd9-5ca1-7258-befd-1c3c59b0aa00': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVMN.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVJ6.png`
    },
    // Campaign brief
    '019e5cd9-5ca1-7258-befd-398bb4e40f15': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVMY.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVJE.png`
    },
    // Colorful layout
    '019e5cd9-5ca1-7258-befd-53b6eec19427': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVN6.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVIG.png`
    },
    // Colorful numbered table
    '019e5cd9-5ca1-7258-befd-70a282facf16': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVN7.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVJL.png`
    },
    // Colorful summary
    '019e5cd9-5ca1-7258-befd-7e200502de8e': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVN4.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVIE.png`
    },
    // Colorful table
    '019e5cd9-5ca1-7258-befd-5524d394ba0a': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVMJ.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVJM.png`
    },
    // Competitive snapshot
    '019e5cd9-5ca1-7258-befd-40d1947b7b84': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVMR.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVJC.png`
    },
    // Criteria rubric
    '019e5cd9-5ca1-7258-befd-84723a493931': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVMA.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVJ1.png`
    },
    // Customer quote
    '019e5cd9-5ca1-7258-befd-5fcf6165870f': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVLF.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVJK.png`
    },
    // Decision log
    '019e5cd9-5ca1-7258-befd-30c6e8712ba4': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVMT.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVJ9.png`
    },
    // Launch checklist
    '019e5cd9-5ca1-7258-befd-3ce1c551015e': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVKW.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVHN.png`
    },
    // Meeting agenda
    '019e5cd9-5ca1-7258-befd-47559a8d7cfc': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVMU.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVJD.png`
    },
    // Project status snapshot
    '019e5cd9-5ca1-7258-befd-2943939d1b79': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVMO.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVJU.png`
    },
    // Pros and cons
    '019e5cd9-5ca1-7258-befd-6db9658d75f4': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVN5.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVHY.png`
    },
    // Quick project update
    '019e5cd9-5ca1-7258-befd-820ce1acd7a0': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVNA.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVI5.png`
    },
    // Risks and assumptions
    '019e5cd9-5ca1-7258-befd-2da95ce98772': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVMQ.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVJ7.png`
    },
    // Roles and responsibilities matrix
    '019e5cd9-5ca1-7258-befd-37cd3a06776d': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVM8.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVHG.png`
    },
    // Run sheet
    '019e5cd9-5ca1-7258-befd-4a9979f87235': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVMZ.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVJB.png`
    },
    // Started → Now
    '019e5cd9-5ca1-7258-befd-74fb1585da6f': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVN8.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVJQ.png`
    },
    // Weekly calendar
    '019e5cd9-5ca1-7258-befd-580c2c95a0a0': {
        light: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVN2.png`,
        dark: `${$979c42675ce79c25$var$DAM_CDN_LINK}/AT12OVIJ.png`
    }
};
const $979c42675ce79c25$export$c1192172c58f5622 = (snippetKey)=>Object.prototype.hasOwnProperty.call($979c42675ce79c25$var$snippetPreviewImageUrlsByKey, snippetKey) ? $979c42675ce79c25$var$snippetPreviewImageUrlsByKey[snippetKey] : undefined;
module.exports["getSnippetPreviewImageUrls"] = $979c42675ce79c25$export$c1192172c58f5622;

});

parcelRegister("jA0E3", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $a579bb9ddad96162$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $a579bb9ddad96162$var$PanelInfoGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
            fill: "currentColor"
        })
    });
};
const $a579bb9ddad96162$export$2187dc2d495c3efc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($a579bb9ddad96162$var$PanelInfoGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($a579bb9ddad96162$var$PanelInfoGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelInfoIcon"] = $a579bb9ddad96162$export$2187dc2d495c3efc;

});

parcelRegister("6MmtN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $532129d0e2b29baf$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $532129d0e2b29baf$var$PanelWarningGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
            fill: "currentColor"
        })
    });
};
const $532129d0e2b29baf$export$246c5468186717b7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($532129d0e2b29baf$var$PanelWarningGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($532129d0e2b29baf$var$PanelWarningGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelWarningIcon"] = $532129d0e2b29baf$export$246c5468186717b7;

});

parcelRegister("dDpOM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $1aedaca47fa21d78$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $1aedaca47fa21d78$var$PanelErrorGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
            fill: "currentColor"
        })
    });
};
const $1aedaca47fa21d78$export$76fa6c311f4e2871 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($1aedaca47fa21d78$var$PanelErrorGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($1aedaca47fa21d78$var$PanelErrorGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelErrorIcon"] = $1aedaca47fa21d78$export$76fa6c311f4e2871;

});

parcelRegister("30pGv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $5ac0d457a06bc975$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $5ac0d457a06bc975$var$PanelSuccessGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
            fill: "currentColor"
        })
    });
};
const $5ac0d457a06bc975$export$a5a5162e21242c3c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($5ac0d457a06bc975$var$PanelSuccessGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($5ac0d457a06bc975$var$PanelSuccessGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelSuccessIcon"] = $5ac0d457a06bc975$export$a5a5162e21242c3c;

});

parcelRegister("564fr", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $276a71e22fa0e942$var$iconStyles = null;
const $276a71e22fa0e942$var$PanelNoteGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
            fill: "currentColor"
        })
    });
};
const $276a71e22fa0e942$export$d4f894f0c3f0db6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    const t0 = props.label ? "img" : undefined;
    const t1 = props.label ? props.label : undefined;
    const t2 = props.label ? undefined : true;
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)($276a71e22fa0e942$var$PanelNoteGlyph, {
            role: "presentation"
        });
        $[0] = t3;
        $[1] = t4;
    } else {
        t3 = $[0];
        t4 = $[1];
    }
    let t5;
    if ($[2] !== t0 || $[3] !== t1 || $[4] !== t2) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t0,
            "aria-label": t1,
            "aria-hidden": t2,
            className: t3,
            children: t4
        });
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($276a71e22fa0e942$var$PanelNoteGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelNoteIcon"] = $276a71e22fa0e942$export$d4f894f0c3f0db6;

});

parcelRegister("btkFO", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic

var $lOiVq = parcelRequire("lOiVq");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

function $dbb7bdedbfb2deb9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dbb7bdedbfb2deb9$var$barStyles = {
    name: "k9tay8",
    styles: "position:absolute;left:0;right:0;top:18px;margin:auto;width:var(--ds-space-200, 16px);height:3px"
};
const $dbb7bdedbfb2deb9$var$textColorIconWrapper = (0, $buxP3.xcss)({
    position: 'relative'
});
const $dbb7bdedbfb2deb9$var$getBackground = (selectedColor, disabled)=>{
    if (selectedColor) return selectedColor;
    return disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon, #292A2E)";
};
const $dbb7bdedbfb2deb9$export$76b0278e018f8601 = ({ selectedColor: selectedColor, disabled: disabled, icon: icon })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
        xcss: $dbb7bdedbfb2deb9$var$textColorIconWrapper
    }, icon, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "toolbar-icon-dynamic-stroke",
        style: {
            background: $dbb7bdedbfb2deb9$var$getBackground(selectedColor, disabled)
        },
        css: $dbb7bdedbfb2deb9$var$barStyles
    }));
};
module.exports["DynamicStrokeIconDecoration"] = $dbb7bdedbfb2deb9$export$76b0278e018f8601;

});

parcelRegister("ab7NC", function(module, exports) {

var $aH8vj = parcelRequire("aH8vj");

function $f9cd24a0b8c556ae$export$3cddda3829daa1af(steps, tr) {
    if (steps === undefined) return undefined;
    return steps.map((step)=>{
        const newStep = step.step.map(tr.mapping);
        const newInvertedStep = step.inverted.map(tr.mapping);
        if (newStep && newInvertedStep) return new (0, $aH8vj.InvertableStep)(newStep, newInvertedStep);
        return undefined;
    }).filter((s)=>!!s);
}
module.exports["mapInvertableSteps"] = $f9cd24a0b8c556ae$export$3cddda3829daa1af;

});

parcelRegister("l8S1J", function(module, exports) {
let $e00d3a76fadced4a$var$cachedPreserveItems = false, $e00d3a76fadced4a$var$cachedPreserveItemsPlugins = null;
function $e00d3a76fadced4a$export$107f10aa87a66306(state) {
    const plugins = state.plugins;
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    if ($e00d3a76fadced4a$var$cachedPreserveItemsPlugins != plugins) {
        $e00d3a76fadced4a$var$cachedPreserveItems = false;
        $e00d3a76fadced4a$var$cachedPreserveItemsPlugins = plugins;
        for(let i = 0; i < plugins.length; i++)// To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (plugins[i].spec.historyPreserveItems) {
            $e00d3a76fadced4a$var$cachedPreserveItems = true;
            break;
        }
    }
    return $e00d3a76fadced4a$var$cachedPreserveItems;
}
module.exports["mustPreserveItems"] = $e00d3a76fadced4a$export$107f10aa87a66306;

});

parcelRegister("8p30m", function(module, exports) {
// oxlint-disable-next-line import/no-duplicates

var $iIsKs = parcelRequire("iIsKs");


var $7hXFI = parcelRequire("7hXFI");


var $ab7NC = parcelRequire("ab7NC");


var $l8S1J = parcelRequire("l8S1J");

// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function $2428cece3e320e18$var$histTransaction(history, state, redo) {
    const preserveItems = (0, $l8S1J.mustPreserveItems)(state);
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
    const histOptions = (0, $iIsKs.historyKey).get(state).spec.config;
    const pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop) return null;
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const selection = pop.selection.resolve(pop.transform.doc);
    const added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    /**
	 * ===
	 * FORK ADDITION START
	 * If history slicing is active when we undo/redo, when we perform an undo/redo we want to
	 * map and keep the relevant steps in the new history state
	 */ const newHist = history.historySliceActive ? new (0, $7hXFI.HistoryState)(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1, history.historySliceActive, (0, $ab7NC.mapInvertableSteps)(history.trackedSteps, pop.transform), history.selectionBookmark?.map(pop.transform.mapping)) : new (0, $7hXFI.HistoryState)(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    /**
	 * FORK ADDITION END
	 * ===
	 */ return pop.transform.setSelection(selection).setMeta((0, $iIsKs.historyKey), {
        redo: redo,
        historyState: newHist
    });
}
function $2428cece3e320e18$export$b31cc894333c4bfb(redo, scroll) {
    return (state, dispatch)=>{
        const hist = (0, $iIsKs.historyKey).getState(state);
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
        if (dispatch) {
            const tr = $2428cece3e320e18$var$histTransaction(hist, state, redo);
            if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
module.exports["buildCommand"] = $2428cece3e320e18$export$b31cc894333c4bfb;

});

parcelRegister("h2a7P", function(module, exports) {
const $170637ba3b1816eb$export$74743eda5dda3ccf = Object.keys;
module.exports["getKeys"] = $170637ba3b1816eb$export$74743eda5dda3ccf;

});

parcelRegister("lNyjH", function(module, exports) {
const $1047c994f57cb237$export$f4c1dafc9df1f03 = (value)=>{
    const valueType = typeof value;
    if (value === null) return 'null';
    else if (value === undefined) return 'undefined';
    else if (valueType === 'string' || valueType === 'number') return value;
    else if (valueType === 'symbol') return value.toString();
    else if (valueType === 'function') return `function:${value.name}`;
    else if (valueType === 'object') return {
        type: 'object',
        keys: Object.keys(value)
    };
};
module.exports["serializeValue"] = $1047c994f57cb237$export$f4c1dafc9df1f03;

});

parcelRegister("5XRFP", function(module, exports) {
parcelRequire("cozmU");


var $8m50u = parcelRequire("8m50u");


var $ieeJu = parcelRequire("ieeJu");


var $aDzmZ = parcelRequire("aDzmZ");


var $6Sijv = parcelRequire("6Sijv");

const $c06f892ed382e0cf$var$WithFlash = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true), (0, $aDzmZ.WithFlashCompiled), (0, $6Sijv.WithFlashEmotion));
var $c06f892ed382e0cf$export$2e2bcd8739ae039 = $c06f892ed382e0cf$var$WithFlash;
module.exports["default"] = $c06f892ed382e0cf$export$2e2bcd8739ae039;

});

parcelRegister("8lRRs", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $84e4119ec7001135$export$eab0ea19ad3bed77 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { getChildren: getChildren, onBeforeRender: onBeforeRender } = t0;
    let t1;
    let t2;
    if ($[0] !== onBeforeRender) {
        t1 = ()=>{
            if (onBeforeRender) onBeforeRender();
        };
        t2 = [
            onBeforeRender
        ];
        $[0] = onBeforeRender;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] !== getChildren) {
        t3 = getChildren();
        $[3] = getChildren;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: t3
        });
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ getChildren: getChildren, onBeforeRender: onBeforeRender })=>{
    (0, $cozmU.useLayoutEffect)(()=>{
        if (onBeforeRender) onBeforeRender();
    }, [
        onBeforeRender
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: getChildren()
    });
};
module.exports["PortalRenderWrapperInner"] = $84e4119ec7001135$export$eab0ea19ad3bed77;

});

parcelRegister("jsa8f", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");

function $0e137581b87dc137$export$8e2864079bc476bd(appearance, contentMode) {
    if (contentMode === 'compact') return 0, $7Y8M5.akEditorFullPageDenseFontSize;
    if (appearance === undefined) return 0, $7Y8M5.akEditorFullPageDefaultFontSize;
    return ![
        'comment',
        'chromeless'
    ].includes(appearance) ? (0, $7Y8M5.akEditorFullPageDefaultFontSize) : undefined;
}
module.exports["getBaseFontSize"] = $0e137581b87dc137$export$8e2864079bc476bd;

});

parcelRegister("4A48a", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f5fdac9d948e61c$export$2e2bcd8739ae039);

var $kOR8Z = parcelRequire("kOR8Z");


var $1E0Cj = parcelRequire("1E0Cj");

const $9f5fdac9d948e61c$var$flatten = (arr)=>[].concat(...arr);
var /**
 * Allow to run methods from the given provider interface across all providers seamlessly.
 * Handles promise racing and discards rejected promises safely.
 */ $9f5fdac9d948e61c$export$2e2bcd8739ae039 = (providers)=>{
    if (providers.length === 0) throw new Error('At least one provider must be provided');
    const getFulfilledProviders = async ()=>{
        const results = await (0, $kOR8Z.waitForAllPromises)(providers.map((result)=>Promise.resolve(result)));
        // Filter out null/undefined providers to prevent errors when calling methods on them
        return (0, $kOR8Z.getOnlyFulfilled)(results).filter((provider)=>provider != null);
    };
    const runInAllProviders = async (mapFunction)=>{
        return (await getFulfilledProviders()).map((provider)=>mapFunction(provider));
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createCallback = (methodName, args)=>(provider)=>{
            const method = provider[methodName];
            if (typeof method === 'function') return method.apply(provider, args);
            throw new Error(`"${String(methodName)}" isn't a function of the provider`);
        };
    /**
   * Run a method from the provider which expects to return a single item
   * @param methodName
   * @param args
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeSingle = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        return (0, $1E0Cj.waitForFirstFulfilledPromise)(await runInAllProviders(callback));
    };
    /**
   * Run a method in the provider which expectes to return a list of items
   * @param methodName
   * @param args
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeList = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        const results = await (0, $kOR8Z.waitForAllPromises)(await runInAllProviders(callback));
        const fulfilledResults = (0, $kOR8Z.getOnlyFulfilled)(results);
        return $9f5fdac9d948e61c$var$flatten(fulfilledResults).filter((result)=>result);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeOptionalList = async (methodName, args)=>{
        const providersWithMethod = (await getFulfilledProviders()).filter((provider)=>typeof provider[methodName] === 'function');
        const results = await (0, $kOR8Z.waitForAllPromises)(providersWithMethod.map(createCallback(methodName, args)));
        const fulfilledResults = (0, $kOR8Z.getOnlyFulfilled)(results);
        return $9f5fdac9d948e61c$var$flatten(fulfilledResults).filter((result)=>result);
    };
    return {
        invokeSingle: invokeSingle,
        invokeList: invokeList,
        invokeOptionalList: invokeOptionalList
    };
};

});

parcelRegister("hw4ew", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::435baa6d24c46bfcc411e1a21e3f5a79>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc08b56f049a8bee$var$_react = $cc08b56f049a8bee$var$_interopRequireDefault((parcelRequire("cozmU")));

var $cc08b56f049a8bee$var$_iconNew = $cc08b56f049a8bee$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $cc08b56f049a8bee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Carousel".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/carousel
 * Usage guidance:
 * Reserved for representing carousel macro in editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc08b56f049a8bee$var$CarouselIcon = (props)=>/*#__PURE__*/ $cc08b56f049a8bee$var$_react.default.createElement($cc08b56f049a8bee$var$_iconNew.default, Object.assign({
        name: "CarouselIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.25 3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5zm1.5 10a2 2 0 0 1-2 2h-5.5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h5.5a2 2 0 0 1 2 2zM14.5 2.75H16v10.5h-1.5zM0 2.75h1.5v10.5H0z"/><path fill="currentcolor" d="M9.44 6.5a.75.75 0 0 1 .64.3l2.52 3.38-1.2.9-1.84-2.47-3.41 5.78-1.29-.76 3.98-6.75a.75.75 0 0 1 .61-.37M7 4a1.25 1.25 0 1 1 0 2.5A1.25 1.25 0 0 1 7 4"/>`
    }, props));
$cc08b56f049a8bee$var$CarouselIcon.displayName = 'CarouselIcon';
var $cc08b56f049a8bee$var$_default = module.exports.default = $cc08b56f049a8bee$var$CarouselIcon;

});

parcelRegister("4o5MH", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e5a228a70af6625$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $4e5a228a70af6625$export$2e2bcd8739ae039(callback) {
    const hasRun = (0, $cozmU.useRef)(false);
    if (!hasRun.current) {
        callback();
        hasRun.current = true;
    }
}

});

parcelRegister("kTcv5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");


var $krYZG = parcelRequire("krYZG");


var $egfqG = parcelRequire("egfqG");

const $8d46d547d7f1660c$export$fe16de086fea1f5f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RenderTracking(props) {
    const $ = (0, $bDgLe.c)(13);
    let t0;
    if ($[0] !== props.handleAnalyticsEvent) {
        t0 = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(props.handleAnalyticsEvent, 500);
        $[0] = props.handleAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const debouncedHandleAnalyticsEvent = t0;
    let t1;
    if ($[2] !== debouncedHandleAnalyticsEvent || $[3] !== props.action || $[4] !== props.actionSubject) {
        t1 = (t2)=>{
            const { renderCount: renderCount, propsDifference: propsDifference } = t2;
            if (!renderCount) return;
            debouncedHandleAnalyticsEvent({
                payload: {
                    action: props.action,
                    actionSubject: props.actionSubject,
                    attributes: {
                        count: renderCount,
                        propsDifference: propsDifference
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                }
            });
        };
        $[2] = debouncedHandleAnalyticsEvent;
        $[3] = props.action;
        $[4] = props.actionSubject;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== props.componentProps || $[7] !== props.propsToIgnore || $[8] !== props.useShallow) {
        t2 = {
            enabled: true,
            props: props.componentProps,
            propsToIgnore: props.propsToIgnore,
            useShallow: props.useShallow
        };
        $[6] = props.componentProps;
        $[7] = props.propsToIgnore;
        $[8] = props.useShallow;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== t1 || $[11] !== t2) {
        t3 = {
            onRender: t1,
            propsDiffingOptions: t2,
            zeroBasedCount: true
        };
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    (0, $egfqG.useComponentRenderTracking)(t3);
    return null;
} : function RenderTracking(props) {
    const debouncedHandleAnalyticsEvent = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(props.handleAnalyticsEvent, 500), [
        props.handleAnalyticsEvent
    ]);
    (0, $egfqG.useComponentRenderTracking)({
        onRender: ({ renderCount: renderCount, propsDifference: propsDifference })=>{
            if (!renderCount) return;
            debouncedHandleAnalyticsEvent({
                payload: {
                    action: props.action,
                    actionSubject: props.actionSubject,
                    attributes: {
                        count: renderCount,
                        propsDifference: propsDifference
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                }
            });
        },
        propsDiffingOptions: {
            enabled: true,
            props: props.componentProps,
            propsToIgnore: props.propsToIgnore,
            useShallow: props.useShallow
        },
        zeroBasedCount: true
    });
    return null;
};
module.exports["RenderTracking"] = $8d46d547d7f1660c$export$fe16de086fea1f5f;

});

parcelRegister("aIbwr", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $aPdNQ = parcelRequire("aPdNQ");


var $4o0zT = parcelRequire("4o0zT");


var $ieeJu = parcelRequire("ieeJu");

const $173bd921bf93803b$var$isPMNode = (nodeOrMark)=>{
    return nodeOrMark instanceof (0, $aPdNQ.Node) || Array.isArray(nodeOrMark.marks);
};
const $173bd921bf93803b$export$3d8be158d19aadd1 = (nodeOrMark, options)=>{
    const name = nodeOrMark.type.name;
    const isNode = $173bd921bf93803b$var$isPMNode(nodeOrMark);
    const commonAttributes = {
        'data-prosemirror-content-type': isNode ? 'node' : 'mark'
    };
    if (!isNode) return {
        ...commonAttributes,
        ['data-prosemirror-mark-name']: name
    };
    commonAttributes['data-prosemirror-node-name'] = name;
    if (nodeOrMark.type.isBlock) commonAttributes['data-prosemirror-node-block'] = 'true';
    if (nodeOrMark.type.isInline) commonAttributes['data-prosemirror-node-inline'] = 'true';
    if (options?.anchrorId !== undefined && ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration'))) commonAttributes['data-node-anchor'] = options.anchrorId;
    return commonAttributes;
};
module.exports["createProseMirrorMetadata"] = $173bd921bf93803b$export$3d8be158d19aadd1;

});

parcelRegister("kKNSN", function(module, exports) {
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
// @deprecated
// @private This rank is not stable and should not be trusted. If you need to change this file, please let the Editor lego team know about it
const $0a45eb09e79586c5$export$d4a08ec0aa6e0cef = {
    plugins: [
        'featureFlagsContextPlugin',
        'compositionPlugin',
        'inlineCursorTargetPlugin',
        'typeAhead',
        'typeAheadInsertItem',
        'focusHandlerPlugin',
        'frozenEditor',
        'submitEditor',
        'saveOnEnter',
        'customAutoformatting',
        'newlinePreserveMarksPlugin',
        'imageUpload',
        'imageUploadInputRule',
        'clipboard',
        'paste',
        'pasteKeymap',
        'mention',
        'mentionInputRule',
        'mentionKeymap',
        'emoji',
        'placeholderText',
        'emojiInputRule',
        'emojiKeymap',
        'emojiAsciiInputRule',
        'blockType',
        'quickInsert',
        'tasksAndDecisions',
        'blockTypeInputRule',
        'tasksAndDecisionsInputRule',
        'list',
        'typeAheadKeymap',
        'typeAheadInputRule',
        'date',
        // Needs to be before indentation to handle tab into input field
        'dateKeymap',
        // This should be always after `typeAheadKeymap` & `emojiKeymap`
        'indentationKeymap',
        'textColor',
        'highlight',
        'highlightKeymap',
        'alignmentPlugin',
        'listInputRule',
        'listKeymap',
        'codeBlock',
        'codeBlockIDEKeyBindings',
        'codeBlockKeyMap',
        'textFormatting',
        'textFormattingCursor',
        'textFormattingInputRule',
        'textFormattingSmartRule',
        'textFormattingClear',
        'textFormattingKeymap',
        // task/decisions keymap needs to be above table keymap so can indent actions in a table
        'tasksAndDecisionsKeyMap',
        // expand and table keymaps need to be above selection keymap to add their custom selection behaviour:
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/1113098008/Selection+Guide#Special-Cases
        'expandKeymap',
        'tableSelectionKeymap',
        'tableKeymap',
        'captionKeymap',
        // media keymap above selection keymap to allow navigating past the mediaSingle node
        'mediaKeymap',
        // selection keymap needs to be above gap cursor keymap so it can set node selections from
        // left/right arrows
        'selectionKeymap',
        'gapCursorKeymap',
        'gapCursor',
        'syncUrlText',
        'fakeCursorToolbarPlugin',
        'hyperLink',
        'table',
        'tableDecorations',
        'hyperlinkInputRule',
        'tablePMColResizing',
        'hyperlinkKeymap',
        'tableColResizing',
        'undoRedoKeyMap',
        'blockTypeKeyMap',
        'tableEditing',
        'filterStepsPlugin',
        'pmCollab',
        'collab',
        'ruleInputRule',
        'ruleKeymap',
        'panel',
        'media',
        'mediaSingleKeymap',
        'mediaEditor',
        'unsupportedContent',
        'jiraIssue',
        'helpDialog',
        'helpDialogKeymap',
        'macro',
        'expand',
        'extension',
        'layout',
        'contextPanel',
        'selectionToolbar',
        'floatingToolbar',
        'clearMarksOnChange',
        'reactNodeView',
        'history',
        'undoRedoPlugin',
        'codeBlockIndent',
        'placeholder',
        'width',
        'maxContentSize',
        'multilineContent',
        'grid',
        'mobileDimensions',
        'scrollGutterPlugin',
        'analytics',
        'findReplace',
        'selection',
        'avatarGroup',
        'viewUpdateSubscription',
        'beforePrimaryToolbar',
        'inlineCode'
    ],
    nodes: [
        'doc',
        'paragraph',
        'text',
        'bulletList',
        'orderedList',
        'listItem',
        'heading',
        'blockquote',
        'codeBlock',
        'rule',
        'panel',
        'panel_c1',
        'mention',
        'confluenceUnsupportedBlock',
        'confluenceUnsupportedInline',
        'unsupportedBlock',
        'unsupportedInline',
        'confluenceJiraIssue',
        'hardBreak',
        'emoji',
        'placeholder',
        'mediaSingle',
        'mediaGroup',
        'table',
        'expand',
        'nestedExpand',
        'media',
        'tableHeader',
        'decisionList',
        'tableRow',
        'decisionItem',
        'tableCell',
        'taskList',
        'taskItem',
        'extension',
        'bodiedExtension',
        'multiBodiedExtension',
        'inlineExtension',
        'layoutSection',
        'layoutColumn',
        'inlineCard',
        'blockCard',
        'embedCard'
    ],
    marks: [
        // Fragment mark is both for inline and block elements
        'fragment',
        // Inline marks
        'link',
        'em',
        'strong',
        'textColor',
        'backgroundColor',
        'strike',
        'subsup',
        'underline',
        'code',
        'typeAheadQuery',
        // Block marks
        'alignment',
        'breakout',
        'indentation',
        'annotation',
        'dataConsumer',
        'border',
        // Unsupported mark
        'unsupportedMark',
        'unsupportedNodeAttribute'
    ]
};
module.exports["rankEditorPlugins"] = $0a45eb09e79586c5$export$d4a08ec0aa6e0cef;

});

parcelRegister("jIX6h", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4b09be0139b5e5f4$export$12d66ae3e5b38d26 = (0, $kSwu1.defineMessages)({
    '#DEEBFF': {
        id: "fabric.theme.subtle-blue",
        defaultMessage: "Subtle blue"
    },
    '#B3D4FF': {
        id: "fabric.theme.blue",
        defaultMessage: "Blue"
    },
    '#4C9AFF': {
        id: "fabric.theme.bold-blue",
        defaultMessage: "Bold blue"
    },
    '#ADCBFB': {
        id: "fabric.theme.bold-blue-new",
        defaultMessage: "Bold blue"
    },
    '#E6FCFF': {
        id: "fabric.theme.subtle-teal",
        defaultMessage: "Subtle teal"
    },
    '#B3F5FF': {
        id: "fabric.theme.teal",
        defaultMessage: "Teal"
    },
    '#79E2F2': {
        id: "fabric.theme.bold-teal",
        defaultMessage: "Bold teal"
    },
    '#B1E4F7': {
        id: "fabric.theme.bold-teal-new",
        defaultMessage: "Bold teal"
    },
    '#E3FCEF': {
        id: "fabric.theme.subtle-green",
        defaultMessage: "Subtle green"
    },
    '#ABF5D1': {
        id: "fabric.theme.green",
        defaultMessage: "Green"
    },
    '#57D9A3': {
        id: "fabric.theme.bold-green",
        defaultMessage: "Bold green"
    },
    '#97EDC9': {
        id: "fabric.theme.bold-green-new",
        defaultMessage: "Bold green"
    },
    '#FFFAE6': {
        id: "fabric.theme.subtle-yellow",
        defaultMessage: "Subtle yellow"
    },
    '#FFF0B3': {
        id: "fabric.theme.yellow",
        defaultMessage: "Yellow"
    },
    '#FFC400': {
        id: "fabric.theme.bold-yellow",
        defaultMessage: "Bold yellow"
    },
    '#EFDD4E': {
        id: "fabric.theme.bold-yellow-new",
        defaultMessage: "Bold yellow"
    },
    '#FFEBE6': {
        id: "fabric.theme.subtle-red",
        defaultMessage: "Subtle red"
    },
    '#FFBDAD': {
        id: "fabric.theme.red",
        defaultMessage: "Red"
    },
    '#FF8F73': {
        id: "fabric.theme.bold-red",
        defaultMessage: "Bold red"
    },
    '#FFB8B2': {
        id: "fabric.theme.bold-red-new",
        defaultMessage: "Bold red"
    },
    '#EAE6FF': {
        id: "fabric.theme.subtle-purple",
        defaultMessage: "Subtle purple"
    },
    '#C0B6F2': {
        id: "fabric.theme.purple",
        defaultMessage: "Purple"
    },
    '#998DD9': {
        id: "fabric.theme.bold-purple",
        defaultMessage: "Bold purple"
    },
    '#E3BDFA': {
        id: "fabric.theme.bold-purple-new",
        defaultMessage: "Bold purple"
    },
    '#FFFFFF': {
        id: "fabric.theme.white",
        defaultMessage: "White"
    },
    '#F4F5F7': {
        id: "fabric.theme.gray",
        defaultMessage: "Gray"
    },
    '#B3BAC5': {
        id: "fabric.theme.bold-gray",
        defaultMessage: "Bold gray"
    },
    '#B7B9BE': {
        id: "fabric.theme.bold-gray-new",
        defaultMessage: "Bold gray"
    },
    '#EFFFD6': {
        id: "fabric.theme.subtle-lime",
        defaultMessage: "Subtle lime"
    },
    '#D3F1A7': {
        id: "fabric.theme.lime",
        defaultMessage: "Lime"
    },
    '#BDE97C': {
        id: "fabric.theme.bold-lime",
        defaultMessage: "Bold lime"
    },
    '#FFF5DB': {
        id: "fabric.theme.subtle-orange",
        defaultMessage: "Subtle orange"
    },
    '#FCE4A6': {
        id: "fabric.theme.orange",
        defaultMessage: "Orange"
    },
    '#FBD779': {
        id: "fabric.theme.bold-orange",
        defaultMessage: "Bold orange"
    },
    '#FFECF8': {
        id: "fabric.theme.subtle-magenta",
        defaultMessage: "Subtle magenta"
    },
    '#FDD0EC': {
        id: "fabric.theme.magenta",
        defaultMessage: "Magenta"
    },
    '#FCB6E1': {
        id: "fabric.theme.bold-magenta",
        defaultMessage: "Bold magenta"
    }
});
module.exports["lightBackgroundPaletteTooltipMessages"] = $4b09be0139b5e5f4$export$12d66ae3e5b38d26;

});

parcelRegister("72AfS", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0d29ca9c301aefa8$export$3db7ab7dd64ad21a = (0, $kSwu1.defineMessages)({
    // Blue color
    '#7AB2FF': {
        id: "fabric.theme.subtle-blue",
        defaultMessage: "Subtle blue"
    },
    '#247FFF': {
        id: "fabric.theme.blue",
        defaultMessage: "Blue"
    },
    '#0055CC': {
        id: "fabric.theme.bold-blue",
        defaultMessage: "Bold blue"
    },
    '#003884': {
        id: "fabric.theme.bolder-blue",
        defaultMessage: "Bolder blue"
    },
    // Teal color
    '#60C6D2': {
        id: "fabric.theme.subtle-teal",
        defaultMessage: "Subtle teal"
    },
    '#1D9AAA': {
        id: "fabric.theme.teal",
        defaultMessage: "Teal"
    },
    '#1D7F8C': {
        id: "fabric.theme.bold-teal",
        defaultMessage: "Bold teal"
    },
    '#206B74': {
        id: "fabric.theme.bolder-teal",
        defaultMessage: "Bolder teal"
    },
    // Green color
    '#6BE1B0': {
        id: "fabric.theme.subtle-green",
        defaultMessage: "Subtle green"
    },
    '#23A971': {
        id: "fabric.theme.green",
        defaultMessage: "Green"
    },
    '#177D52': {
        id: "fabric.theme.bold-green",
        defaultMessage: "Bold green"
    },
    '#055C3F': {
        id: "fabric.theme.bolder-green",
        defaultMessage: "Bolder green"
    },
    // Yellow color
    '#FFDB57': {
        id: "fabric.theme.subtle-yellow",
        defaultMessage: "Subtle yellow"
    },
    '#FFBE33': {
        id: "fabric.theme.yellow",
        defaultMessage: "Yellow"
    },
    '#FF9D00': {
        id: "fabric.theme.bold-yellow",
        defaultMessage: "Bold yellow"
    },
    '#946104': {
        id: "fabric.theme.bolder-yellow",
        defaultMessage: "Bolder yellow"
    },
    // Red color
    '#FF8F73': {
        id: "fabric.theme.subtle-red",
        defaultMessage: "Subtle red"
    },
    '#FC552C': {
        id: "fabric.theme.red",
        defaultMessage: "Red"
    },
    '#D32D03': {
        id: "fabric.theme.bold-red",
        defaultMessage: "Bold red"
    },
    '#A32000': {
        id: "fabric.theme.bolder-red",
        defaultMessage: "Bolder red"
    },
    // Orange color
    '#FAA53D': {
        id: "fabric.theme.subtle-orange",
        defaultMessage: "Subtle orange"
    },
    '#D97008': {
        id: "fabric.theme.orange",
        defaultMessage: "Orange"
    },
    '#B65C02': {
        id: "fabric.theme.bold-orange",
        defaultMessage: "Bold orange"
    },
    '#974F0C': {
        id: "fabric.theme.bolder-orange",
        defaultMessage: "Bolder orange"
    },
    // Magenta color
    '#E774BB': {
        id: "fabric.theme.subtle-magenta",
        defaultMessage: "Subtle magenta"
    },
    '#DA62AC': {
        id: "fabric.theme.magenta",
        defaultMessage: "Magenta"
    },
    '#CD519D': {
        id: "fabric.theme.bold-magenta",
        defaultMessage: "Bold magenta"
    },
    '#943D73': {
        id: "fabric.theme.bolder-magenta",
        defaultMessage: "Bolder magenta"
    },
    // Purple color
    '#B5A7FB': {
        id: "fabric.theme.subtle-purple",
        defaultMessage: "Subtle purple"
    },
    '#8B77EE': {
        id: "fabric.theme.purple",
        defaultMessage: "Purple"
    },
    '#5A43D0': {
        id: "fabric.theme.bold-purple",
        defaultMessage: "Bold purple"
    },
    '#44368B': {
        id: "fabric.theme.bolder-purple",
        defaultMessage: "Bolder purple"
    },
    // Gray color
    '#8993A5': {
        id: "fabric.theme.subtle-gray",
        defaultMessage: "Subtle gray"
    },
    '#8590A2': {
        id: "fabric.theme.gray",
        defaultMessage: "Gray"
    },
    '#758195': {
        id: "fabric.theme.bold-gray",
        defaultMessage: "Bold gray"
    },
    '#44546F': {
        id: "fabric.theme.bolder-gray",
        defaultMessage: "Bolder gray"
    }
});
module.exports["lightChartsColorPaletteTooltipMessages"] = $0d29ca9c301aefa8$export$3db7ab7dd64ad21a;

});

parcelRegister("cUMTy", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $baaece4e6374c35b$export$788a656fb7fb7897 = (0, $kSwu1.defineMessages)({
    '#FFFFFF': {
        id: "fabric.theme.white",
        defaultMessage: "White"
    },
    '#B3D4FF': {
        id: "fabric.theme.subtle-blue",
        defaultMessage: "Subtle blue"
    },
    '#B3F5FF': {
        id: "fabric.theme.subtle-teal",
        defaultMessage: "Subtle teal"
    },
    '#ABF5D1': {
        id: "fabric.theme.subtle-green",
        defaultMessage: "Subtle green"
    },
    '#FFF0B3': {
        id: "fabric.theme.subtle-yellow",
        defaultMessage: "Subtle yellow"
    },
    '#FFBDAD': {
        id: "fabric.theme.subtle-red",
        defaultMessage: "Subtle red"
    },
    '#EAE6FF': {
        id: "fabric.theme.subtle-purple",
        defaultMessage: "Subtle purple"
    },
    '#97A0AF': {
        id: "fabric.theme.gray",
        defaultMessage: "Gray"
    },
    '#4C9AFF': {
        id: "fabric.theme.blue",
        defaultMessage: "Blue"
    },
    '#00B8D9': {
        id: "fabric.theme.teal",
        defaultMessage: "Teal"
    },
    '#36B37E': {
        id: "fabric.theme.green",
        defaultMessage: "Green"
    },
    '#FFC400': {
        id: "fabric.theme.yellow",
        defaultMessage: "Yellow"
    },
    '#FF5630': {
        id: "fabric.theme.red",
        defaultMessage: "Red"
    },
    '#FF991F': {
        id: "fabric.theme.bold-orange",
        defaultMessage: "Bold orange"
    },
    '#6554C0': {
        id: "fabric.theme.purple",
        defaultMessage: "Purple"
    },
    '#0747A6': {
        id: "fabric.theme.bold-blue",
        defaultMessage: "Bold blue"
    },
    '#008DA6': {
        id: "fabric.theme.bold-teal",
        defaultMessage: "Bold teal"
    },
    '#006644': {
        id: "fabric.theme.bold-green",
        defaultMessage: "Bold green"
    },
    '#BF2600': {
        id: "fabric.theme.bold-red",
        defaultMessage: "Bold red"
    },
    '#403294': {
        id: "fabric.theme.bold-purple",
        defaultMessage: "Bold purple"
    },
    '#172B4D': {
        id: "fabric.theme.default",
        defaultMessage: "Default"
    },
    '#D3F1A7': {
        id: "fabric.theme.subtle-lime",
        defaultMessage: "Subtle lime"
    },
    '#FDD0EC': {
        id: "fabric.theme.subtle-magenta",
        defaultMessage: "Subtle magenta"
    },
    '#6A9A23': {
        id: "fabric.theme.lime",
        defaultMessage: "Lime"
    },
    '#CD519D': {
        id: "fabric.theme.magenta",
        defaultMessage: "Magenta"
    },
    '#4C6B1F': {
        id: "fabric.theme.bold-lime",
        defaultMessage: "Bold lime"
    },
    '#943D73': {
        id: "fabric.theme.bold-magenta",
        defaultMessage: "Bold magenta"
    },
    '#B38600': {
        id: "fabric.theme.yellow",
        defaultMessage: "Yellow"
    },
    '#7F5F01': {
        id: "fabric.theme.bold-yellow",
        defaultMessage: "Bold yellow"
    },
    '#FCE4A6': {
        id: "fabric.theme.subtle-orange",
        defaultMessage: "Subtle orange"
    },
    '#E06C00': {
        id: "fabric.theme.orange",
        defaultMessage: "Orange"
    },
    '#9E4C00': {
        id: "fabric.theme.bold-orange",
        defaultMessage: "Bold orange"
    }
});
module.exports["lightTextPaletteTooltipMessages"] = $baaece4e6374c35b$export$788a656fb7fb7897;

});

parcelRegister("aH8vj", function(module, exports) {
class $81a338ad2cb5b3e2$export$ebdc1f934f4dd665 {
    constructor(step, inverted){
        this.step = step;
        this.inverted = inverted;
    }
}
module.exports["InvertableStep"] = $81a338ad2cb5b3e2$export$ebdc1f934f4dd665;

});

parcelRegister("aDzmZ", function(module, exports) {
/* withFlash-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

function $3fd19c9bc84a04bb$var$_defineProperty(e, r, t) {
    return (r = $3fd19c9bc84a04bb$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3fd19c9bc84a04bb$var$_toPropertyKey(t) {
    var i = $3fd19c9bc84a04bb$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3fd19c9bc84a04bb$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $3fd19c9bc84a04bb$var$pulseBackground = null;
const $3fd19c9bc84a04bb$var$pulseBackgroundReverse = null;
const $3fd19c9bc84a04bb$var$compiledStyles = {
    flashWrapper: "_2OzkJjYbGa _46dFXZ5qPj _0i0QEvlNGu _1nYDU7N8t6",
    flashWrapperAnimated: "_46dFXZYSKr _0i0QEvlNGu _1nYDU7N8t6"
};
class $3fd19c9bc84a04bb$export$ce622d3514f749db extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { animate: animate, children: children } = this.props;
        this.toggle = animate && !this.toggle;
        return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $hekY6.default)([
                animate ? $3fd19c9bc84a04bb$var$compiledStyles.flashWrapperAnimated : $3fd19c9bc84a04bb$var$compiledStyles.flashWrapper,
                this.toggle ? '-flash' : ''
            ]),
            children: children
        });
    }
    constructor(...args){
        super(...args);
        $3fd19c9bc84a04bb$var$_defineProperty(this, "toggle", false);
    }
}
module.exports["WithFlashCompiled"] = $3fd19c9bc84a04bb$export$ce622d3514f749db;

});

parcelRegister("6Sijv", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
    * Emotion fallback branch of the `platform_editor_core_non_ecc_static_css` experiment.
    * Used via `componentWithCondition` in `index.tsx`.
    *
    * Cleanup: delete this file once the experiment has shipped.
    */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");

const $057354574fd26e09$var$pulseBackground = (0, $lOiVq.keyframes)({
    '50%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $057354574fd26e09$var$pulseBackgroundReverse = (0, $lOiVq.keyframes)({
    '0%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    },
    '50%': {
        backgroundColor: 'auto'
    },
    '100%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $057354574fd26e09$var$flashWrapper = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.-flash > div': {
        animationName: $057354574fd26e09$var$pulseBackgroundReverse,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > div': {
        animation: 'none'
    }
});
const $057354574fd26e09$var$flashWrapperAnimated = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`&.-flash > div`]: {
        animationName: $057354574fd26e09$var$pulseBackground,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    }
});
class $057354574fd26e09$export$d0550458201d717a extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { animate: animate, children: children } = this.props;
        this.toggle = animate && !this.toggle;
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: animate ? $057354574fd26e09$var$flashWrapperAnimated : $057354574fd26e09$var$flashWrapper,
            className: this.toggle ? '-flash' : ''
        }, children);
    }
    constructor(...args){
        super(...args);
        this.toggle = false;
    }
}
module.exports["WithFlashEmotion"] = $057354574fd26e09$export$d0550458201d717a;

});

parcelRegister("kOR8Z", function(module, exports) {

var $4LcqF = parcelRequire("4LcqF");

const $d7fdc105cb192230$var$isFullfilled = (result)=>result.status === (0, $4LcqF.ResultStatus).FULFILLED;
const $d7fdc105cb192230$var$markFullfilled = (value)=>({
        status: (0, $4LcqF.ResultStatus).FULFILLED,
        value: value
    });
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d7fdc105cb192230$var$markRejected = (error)=>({
        status: (0, $4LcqF.ResultStatus).FAILED,
        reason: error
    });
const $d7fdc105cb192230$export$b43fdcffd84b7b0f = (promises)=>{
    return Promise.all(promises.map((result)=>result.then($d7fdc105cb192230$var$markFullfilled).catch($d7fdc105cb192230$var$markRejected)));
};
const $d7fdc105cb192230$export$b7581cbf0e22e36b = (results)=>results.filter($d7fdc105cb192230$var$isFullfilled).map((result)=>result.value); // eslint-disable-next-line @atlaskit/editor/no-re-export
 // eslint-disable-next-line @atlaskit/editor/no-re-export
module.exports["waitForAllPromises"] = $d7fdc105cb192230$export$b43fdcffd84b7b0f;
module.exports["getOnlyFulfilled"] = $d7fdc105cb192230$export$b7581cbf0e22e36b;

});

parcelRegister("1E0Cj", function(module, exports) {
/**
 * Will resolve on the first fulfilled promise and disregard the remaining ones. Similar to `Promise.race` but won't
 * care about rejected promises.
 * @param promises
 */ const $b1277f9397727020$export$cb8861b0e3f3dd6f = (promises)=>{
    const rejectReasons = [];
    return new Promise((resolve, reject)=>{
        promises.forEach((promise)=>promise.then((value)=>{
                if (typeof value === 'undefined' || value === null) throw new Error(`Result was not found but the method didn't reject/throw. Please ensure that it doesn't return null or undefined.`);
                resolve(value);
            }).catch((reason)=>{
                rejectReasons.push(reason);
                if (rejectReasons.length === promises.length) reject(reason);
            }));
    });
};
module.exports["waitForFirstFulfilledPromise"] = $b1277f9397727020$export$cb8861b0e3f3dd6f;

});

parcelRegister("4LcqF", function(module, exports) {
var $16088212b787f029$export$7103a54af3e45080 = /*#__PURE__*/ function(ResultStatus) {
    ResultStatus["FULFILLED"] = "fulfilled";
    ResultStatus["FAILED"] = "failed";
    return ResultStatus;
}({});
module.exports["ResultStatus"] = $16088212b787f029$export$7103a54af3e45080;

});


$parcel$global.rlb("b8BFA")
//# sourceMappingURL=panel.43bddc6b.js.map
